!function webpackUniversalModuleDefinition(e, i) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = i(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/tide-icons"), require("@driftt/web-auth"), require("react-dom"), require("@driftt/tide-file-upload"), require("@driftt/tide-selects"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "ramda", "@driftt/tide-icons", "@driftt/web-auth", "react-dom", "@driftt/tide-file-upload", "@driftt/tide-selects"], i);else {
    var a = "object" === typeof exports ? i(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/tide-icons"), require("@driftt/web-auth"), require("react-dom"), require("@driftt/tide-file-upload"), require("@driftt/tide-selects")) : i(e.react, e["@driftt/tide-core"], e.ramda, e["@driftt/tide-icons"], e["@driftt/web-auth"], e["react-dom"], e["@driftt/tide-file-upload"], e["@driftt/tide-selects"]);

    for (var n in a) {
      ("object" === typeof exports ? exports : e)[n] = a[n];
    }
  }
}(window, function (e, i, a, n, t, o, s, r) {
  return function (e) {
    var i = {};

    function __webpack_require__(a) {
      if (i[a]) return i[a].exports;
      var n = i[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return e[a].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = i, __webpack_require__.d = function (e, i, a) {
      __webpack_require__.o(e, i) || Object.defineProperty(e, i, {
        enumerable: !0,
        get: a
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, i) {
      if (1 & i && (e = __webpack_require__(e)), 8 & i) return e;
      if (4 & i && "object" === typeof e && e && e.__esModule) return e;
      var a = Object.create(null);
      if (__webpack_require__.r(a), Object.defineProperty(a, "default", {
        enumerable: !0,
        value: e
      }), 2 & i && "string" != typeof e) for (var n in e) {
        __webpack_require__.d(a, n, function (i) {
          return e[i];
        }.bind(null, n));
      }
      return a;
    }, __webpack_require__.n = function (e) {
      var i = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(i, "a", i), i;
    }, __webpack_require__.o = function (e, i) {
      return Object.prototype.hasOwnProperty.call(e, i);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 112);
  }([function (i, a) {
    i.exports = e;
  }, function (e, i, a) {
    e.exports = a(254)();
  }, function (e, a) {
    e.exports = i;
  }, function (e, i, a) {
    e.exports = a(113);
  }, function (e, i) {
    e.exports = a;
  }, function (e, i, a) {
    var n;
    !function () {
      "use strict";

      var a = {}.hasOwnProperty;

      function classNames() {
        for (var e = [], i = 0; i < arguments.length; i++) {
          var n = arguments[i];

          if (n) {
            var t = typeof n;
            if ("string" === t || "number" === t) e.push(n);else if (Array.isArray(n)) {
              if (n.length) {
                var o = classNames.apply(null, n);
                o && e.push(o);
              }
            } else if ("object" === t) if (n.toString === Object.prototype.toString) for (var s in n) {
              a.call(n, s) && n[s] && e.push(s);
            } else e.push(n.toString());
          }
        }

        return e.join(" ");
      }

      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (n = function () {
        return classNames;
      }.apply(i, [])) || (e.exports = n);
    }();
  }, function (e, i, a) {
    var n = a(68),
        t = "object" == typeof self && self && self.Object === Object && self,
        o = n || t || Function("return this")();
    e.exports = o;
  }, function (e, i) {
    e.exports = n;
  }, function (e, i, a) {
    "use strict";

    Object.defineProperty(i, "__esModule", {
      value: !0
    });

    var n = function () {
      function defineProperties(e, i) {
        for (var a = 0; a < i.length; a++) {
          var n = i[a];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (e, i, a) {
        return i && defineProperties(e.prototype, i), a && defineProperties(e, a), e;
      };
    }(),
        t = function get(e, i, a) {
      for (var n = !0; n;) {
        var t = e,
            o = i,
            s = a;
        n = !1, null === t && (t = Function.prototype);
        var r = Object.getOwnPropertyDescriptor(t, o);

        if (void 0 !== r) {
          if ("value" in r) return r.value;
          var g = r.get;
          if (void 0 === g) return;
          return g.call(s);
        }

        var l = Object.getPrototypeOf(t);
        if (null === l) return;
        e = l, i = o, a = s, n = !0, r = l = void 0;
      }
    };

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var o = _interopRequireDefault(a(0)),
        s = _interopRequireDefault(a(61));

    i.default = function onClickOutside(e) {
      var i = [],
          a = [];
      return function (r) {
        function OnClickOutside() {
          !function _classCallCheck(e, i) {
            if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
          }(this, OnClickOutside), t(Object.getPrototypeOf(OnClickOutside.prototype), "constructor", this).apply(this, arguments);
        }

        return function _inherits(e, i) {
          if ("function" !== typeof i && null !== i) throw new TypeError("Super expression must either be null or a function, not " + typeof i);
          e.prototype = Object.create(i && i.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), i && (Object.setPrototypeOf ? Object.setPrototypeOf(e, i) : e.__proto__ = i);
        }(OnClickOutside, o.default.Component), n(OnClickOutside, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var e,
                n,
                t = this.__outsideClickHandler = (e = s.default.findDOMNode(this), n = this.props.onClickOutside || function () {}, function (i) {
              for (var a = i.target; a.parentNode;) {
                if (a === e || a.classList.contains("ignore-react-onclickoutside")) return;
                a = a.parentNode;
              }

              n(i);
            }),
                o = i.length;
            i.push(this), a[o] = t, this.props.disableOnClickOutside || this.enableOnClickOutside();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.disableOnClickOutside(), this.__outsideClickHandler = !1;
            var e = i.indexOf(this);
            e > -1 && a[e] && (a.splice(e, 1), i.splice(e, 1));
          }
        }, {
          key: "componentWillReceiveProps",
          value: function componentWillReceiveProps(e) {
            !e.disableOnClickOutside && this.props.disableOnClickOutside ? this.enableOnClickOutside() : e.disableOnClickOutside && !this.props.disableOnClickOutside && this.disableOnClickOutside();
          }
        }, {
          key: "render",
          value: function render() {
            return o.default.createElement(e, this.props);
          }
        }, {
          key: "enableOnClickOutside",
          value: function enableOnClickOutside() {
            var e = this.__outsideClickHandler;
            document.addEventListener("mousedown", e), document.addEventListener("touchstart", e);
          }
        }, {
          key: "disableOnClickOutside",
          value: function disableOnClickOutside(e) {
            e = this.__outsideClickHandler, document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", e);
          }
        }]), OnClickOutside;
      }();
    }, e.exports = i.default;
  }, function (e, i, a) {
    "use strict";

    e.exports = function (e) {
      var i = [];
      return i.toString = function toString() {
        return this.map(function (i) {
          var a = function cssWithMappingToString(e, i) {
            var a = e[1] || "",
                n = e[3];
            if (!n) return a;

            if (i && "function" === typeof btoa) {
              var t = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(n),
                  o = n.sources.map(function (e) {
                return "/*# sourceURL=" + n.sourceRoot + e + " */";
              });

              return [a].concat(o).concat([t]).join("\n");
            }

            return [a].join("\n");
          }(i, e);

          return i[2] ? "@media " + i[2] + "{" + a + "}" : a;
        }).join("");
      }, i.i = function (e, a) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var n = {}, t = 0; t < this.length; t++) {
          var o = this[t][0];
          null != o && (n[o] = !0);
        }

        for (t = 0; t < e.length; t++) {
          var s = e[t];
          null != s[0] && n[s[0]] || (a && !s[2] ? s[2] = a : a && (s[2] = "(" + s[2] + ") and (" + a + ")"), i.push(s));
        }
      }, i;
    };
  }, function (e, i, a) {
    "use strict";

    var n = {},
        t = function isOldIE() {
      var e;
      return function memorize() {
        return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
      };
    }(),
        o = function getTarget() {
      var e = {};
      return function memorize(i) {
        if ("undefined" === typeof e[i]) {
          var a = document.querySelector(i);
          if (window.HTMLIFrameElement && a instanceof window.HTMLIFrameElement) try {
            a = a.contentDocument.head;
          } catch (n) {
            a = null;
          }
          e[i] = a;
        }

        return e[i];
      };
    }();

    function listToStyles(e, i) {
      for (var a = [], n = {}, t = 0; t < e.length; t++) {
        var o = e[t],
            s = i.base ? o[0] + i.base : o[0],
            r = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        n[s] ? n[s].parts.push(r) : a.push(n[s] = {
          id: s,
          parts: [r]
        });
      }

      return a;
    }

    function addStylesToDom(e, i) {
      for (var a = 0; a < e.length; a++) {
        var t = e[a],
            o = n[t.id],
            s = 0;

        if (o) {
          for (o.refs++; s < o.parts.length; s++) {
            o.parts[s](t.parts[s]);
          }

          for (; s < t.parts.length; s++) {
            o.parts.push(addStyle(t.parts[s], i));
          }
        } else {
          for (var r = []; s < t.parts.length; s++) {
            r.push(addStyle(t.parts[s], i));
          }

          n[t.id] = {
            id: t.id,
            refs: 1,
            parts: r
          };
        }
      }
    }

    function insertStyleElement(e) {
      var i = document.createElement("style");

      if ("undefined" === typeof e.attributes.nonce) {
        var n = a.nc;
        n && (e.attributes.nonce = n);
      }

      if (Object.keys(e.attributes).forEach(function (a) {
        i.setAttribute(a, e.attributes[a]);
      }), "function" === typeof e.insert) e.insert(i);else {
        var t = o(e.insert || "head");
        if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        t.appendChild(i);
      }
      return i;
    }

    var s = function replaceText() {
      var e = [];
      return function replace(i, a) {
        return e[i] = a, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, i, a, n) {
      var t = a ? "" : n.css;
      if (e.styleSheet) e.styleSheet.cssText = s(i, t);else {
        var o = document.createTextNode(t),
            r = e.childNodes;
        r[i] && e.removeChild(r[i]), r.length ? e.insertBefore(o, r[i]) : e.appendChild(o);
      }
    }

    var r = null,
        g = 0;

    function addStyle(e, i) {
      var a, n, t;

      if (i.singleton) {
        var o = g++;
        a = r || (r = insertStyleElement(i)), n = applyToSingletonTag.bind(null, a, o, !1), t = applyToSingletonTag.bind(null, a, o, !0);
      } else a = insertStyleElement(i), n = function applyToTag(e, i, a) {
        var n = a.css,
            t = a.media,
            o = a.sourceMap;
        if (t && e.setAttribute("media", t), o && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, a, i), t = function remove() {
        !function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(a);
      };

      return n(e), function updateStyle(i) {
        if (i) {
          if (i.css === e.css && i.media === e.media && i.sourceMap === e.sourceMap) return;
          n(e = i);
        } else t();
      };
    }

    e.exports = function (e, i) {
      (i = i || {}).attributes = "object" === typeof i.attributes ? i.attributes : {}, i.singleton || "boolean" === typeof i.singleton || (i.singleton = t());
      var a = listToStyles(e, i);
      return addStylesToDom(a, i), function update(e) {
        for (var t = [], o = 0; o < a.length; o++) {
          var s = a[o],
              r = n[s.id];
          r && (r.refs--, t.push(r));
        }

        e && addStylesToDom(listToStyles(e, i), i);

        for (var g = 0; g < t.length; g++) {
          var l = t[g];

          if (0 === l.refs) {
            for (var f = 0; f < l.parts.length; f++) {
              l.parts[f]();
            }

            delete n[l.id];
          }
        }
      };
    };
  }, function (e, i) {
    e.exports = function isObject(e) {
      var i = typeof e;
      return null != e && ("object" == i || "function" == i);
    };
  }, function (e, i) {
    e.exports = function isObjectLike(e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, i) {
    var a = Array.isArray;
    e.exports = a;
  }, function (e, i, a) {
    var n = a(139),
        t = a(142);

    e.exports = function getNative(e, i) {
      var a = t(e, i);
      return n(a) ? a : void 0;
    };
  }, function (e, i, a) {
    var n = a(97)("wks"),
        t = a(99),
        o = a(23).Symbol,
        s = "function" == typeof o;
    (e.exports = function (e) {
      return n[e] || (n[e] = s && o[e] || (s ? o : t)("Symbol." + e));
    }).store = n;
  }, function (e, i) {
    e.exports = t;
  }, function (e, i, a) {
    var n = a(18),
        t = a(125),
        o = a(126),
        s = "[object Null]",
        r = "[object Undefined]",
        g = n ? n.toStringTag : void 0;

    e.exports = function baseGetTag(e) {
      return null == e ? void 0 === e ? r : s : g && g in Object(e) ? t(e) : o(e);
    };
  }, function (e, i, a) {
    var n = a(6).Symbol;
    e.exports = n;
  }, function (e, i) {
    var a = e.exports = {
      version: "2.6.12"
    };
    "number" == typeof __e && (__e = a);
  }, function (e) {
    e.exports = {
      compressed: !0,
      categories: [{
        id: "people",
        name: "Smileys & People",
        emojis: ["grinning", "grin", "joy", "rolling_on_the_floor_laughing", "smiley", "smile", "sweat_smile", "laughing", "wink", "blush", "yum", "sunglasses", "heart_eyes", "kissing_heart", "kissing", "kissing_smiling_eyes", "kissing_closed_eyes", "relaxed", "slightly_smiling_face", "hugging_face", "star-struck", "thinking_face", "face_with_raised_eyebrow", "neutral_face", "expressionless", "no_mouth", "face_with_rolling_eyes", "smirk", "persevere", "disappointed_relieved", "open_mouth", "zipper_mouth_face", "hushed", "sleepy", "tired_face", "sleeping", "relieved", "stuck_out_tongue", "stuck_out_tongue_winking_eye", "stuck_out_tongue_closed_eyes", "drooling_face", "unamused", "sweat", "pensive", "confused", "upside_down_face", "money_mouth_face", "astonished", "white_frowning_face", "slightly_frowning_face", "confounded", "disappointed", "worried", "triumph", "cry", "sob", "frowning", "anguished", "fearful", "weary", "exploding_head", "grimacing", "cold_sweat", "scream", "flushed", "zany_face", "dizzy_face", "rage", "angry", "face_with_symbols_on_mouth", "mask", "face_with_thermometer", "face_with_head_bandage", "nauseated_face", "face_vomiting", "sneezing_face", "innocent", "face_with_cowboy_hat", "clown_face", "lying_face", "shushing_face", "face_with_hand_over_mouth", "face_with_monocle", "nerd_face", "smiling_imp", "imp", "japanese_ogre", "japanese_goblin", "skull", "skull_and_crossbones", "ghost", "alien", "space_invader", "robot_face", "hankey", "smiley_cat", "smile_cat", "joy_cat", "heart_eyes_cat", "smirk_cat", "kissing_cat", "scream_cat", "crying_cat_face", "pouting_cat", "see_no_evil", "hear_no_evil", "speak_no_evil", "baby", "child", "boy", "girl", "adult", "man", "woman", "older_adult", "older_man", "older_woman", "male-doctor", "female-doctor", "male-student", "female-student", "male-teacher", "female-teacher", "male-judge", "female-judge", "male-farmer", "female-farmer", "male-cook", "female-cook", "male-mechanic", "female-mechanic", "male-factory-worker", "female-factory-worker", "male-office-worker", "female-office-worker", "male-scientist", "female-scientist", "male-technologist", "female-technologist", "male-singer", "female-singer", "male-artist", "female-artist", "male-pilot", "female-pilot", "male-astronaut", "female-astronaut", "male-firefighter", "female-firefighter", "cop", "male-police-officer", "female-police-officer", "sleuth_or_spy", "male-detective", "female-detective", "guardsman", "male-guard", "female-guard", "construction_worker", "male-construction-worker", "female-construction-worker", "prince", "princess", "man_with_turban", "man-wearing-turban", "woman-wearing-turban", "man_with_gua_pi_mao", "person_with_headscarf", "bearded_person", "person_with_blond_hair", "blond-haired-man", "blond-haired-woman", "man_in_tuxedo", "bride_with_veil", "pregnant_woman", "breast-feeding", "angel", "santa", "mrs_claus", "mage", "female_mage", "male_mage", "fairy", "female_fairy", "male_fairy", "vampire", "female_vampire", "male_vampire", "merperson", "mermaid", "merman", "elf", "female_elf", "male_elf", "genie", "female_genie", "male_genie", "zombie", "female_zombie", "male_zombie", "person_frowning", "man-frowning", "woman-frowning", "person_with_pouting_face", "man-pouting", "woman-pouting", "no_good", "man-gesturing-no", "woman-gesturing-no", "ok_woman", "man-gesturing-ok", "woman-gesturing-ok", "information_desk_person", "man-tipping-hand", "woman-tipping-hand", "raising_hand", "man-raising-hand", "woman-raising-hand", "bow", "man-bowing", "woman-bowing", "face_palm", "man-facepalming", "woman-facepalming", "shrug", "man-shrugging", "woman-shrugging", "massage", "man-getting-massage", "woman-getting-massage", "haircut", "man-getting-haircut", "woman-getting-haircut", "walking", "man-walking", "woman-walking", "runner", "man-running", "woman-running", "dancer", "man_dancing", "dancers", "man-with-bunny-ears-partying", "woman-with-bunny-ears-partying", "person_in_steamy_room", "woman_in_steamy_room", "man_in_steamy_room", "person_climbing", "woman_climbing", "man_climbing", "person_in_lotus_position", "woman_in_lotus_position", "man_in_lotus_position", "bath", "sleeping_accommodation", "man_in_business_suit_levitating", "speaking_head_in_silhouette", "bust_in_silhouette", "busts_in_silhouette", "fencer", "horse_racing", "skier", "snowboarder", "golfer", "man-golfing", "woman-golfing", "surfer", "man-surfing", "woman-surfing", "rowboat", "man-rowing-boat", "woman-rowing-boat", "swimmer", "man-swimming", "woman-swimming", "person_with_ball", "man-bouncing-ball", "woman-bouncing-ball", "weight_lifter", "man-lifting-weights", "woman-lifting-weights", "bicyclist", "man-biking", "woman-biking", "mountain_bicyclist", "man-mountain-biking", "woman-mountain-biking", "racing_car", "racing_motorcycle", "person_doing_cartwheel", "man-cartwheeling", "woman-cartwheeling", "wrestlers", "man-wrestling", "woman-wrestling", "water_polo", "man-playing-water-polo", "woman-playing-water-polo", "handball", "man-playing-handball", "woman-playing-handball", "juggling", "man-juggling", "woman-juggling", "couple", "two_men_holding_hands", "two_women_holding_hands", "couplekiss", "woman-kiss-man", "man-kiss-man", "woman-kiss-woman", "couple_with_heart", "woman-heart-man", "man-heart-man", "woman-heart-woman", "family", "man-woman-boy", "man-woman-girl", "man-woman-girl-boy", "man-woman-boy-boy", "man-woman-girl-girl", "man-man-boy", "man-man-girl", "man-man-girl-boy", "man-man-boy-boy", "man-man-girl-girl", "woman-woman-boy", "woman-woman-girl", "woman-woman-girl-boy", "woman-woman-boy-boy", "woman-woman-girl-girl", "man-boy", "man-boy-boy", "man-girl", "man-girl-boy", "man-girl-girl", "woman-boy", "woman-boy-boy", "woman-girl", "woman-girl-boy", "woman-girl-girl", "selfie", "muscle", "point_left", "point_right", "point_up", "point_up_2", "middle_finger", "point_down", "v", "crossed_fingers", "spock-hand", "the_horns", "call_me_hand", "raised_hand_with_fingers_splayed", "hand", "ok_hand", "+1", "-1", "fist", "facepunch", "left-facing_fist", "right-facing_fist", "raised_back_of_hand", "wave", "i_love_you_hand_sign", "writing_hand", "clap", "open_hands", "raised_hands", "palms_up_together", "pray", "handshake", "nail_care", "ear", "nose", "footprints", "eyes", "eye", "eye-in-speech-bubble", "brain", "tongue", "lips", "kiss", "cupid", "heart", "heartbeat", "broken_heart", "two_hearts", "sparkling_heart", "heartpulse", "blue_heart", "green_heart", "yellow_heart", "orange_heart", "purple_heart", "black_heart", "gift_heart", "revolving_hearts", "heart_decoration", "heavy_heart_exclamation_mark_ornament", "love_letter", "zzz", "anger", "bomb", "boom", "sweat_drops", "dash", "dizzy", "speech_balloon", "left_speech_bubble", "right_anger_bubble", "thought_balloon", "hole", "eyeglasses", "dark_sunglasses", "necktie", "shirt", "jeans", "scarf", "gloves", "coat", "socks", "dress", "kimono", "bikini", "womans_clothes", "purse", "handbag", "pouch", "shopping_bags", "school_satchel", "mans_shoe", "athletic_shoe", "high_heel", "sandal", "boot", "crown", "womans_hat", "tophat", "mortar_board", "billed_cap", "helmet_with_white_cross", "prayer_beads", "lipstick", "ring", "gem"]
      }, {
        id: "nature",
        name: "Animals & Nature",
        emojis: ["monkey_face", "monkey", "gorilla", "dog", "dog2", "poodle", "wolf", "fox_face", "cat", "cat2", "lion_face", "tiger", "tiger2", "leopard", "horse", "racehorse", "unicorn_face", "zebra_face", "deer", "cow", "ox", "water_buffalo", "cow2", "pig", "pig2", "boar", "pig_nose", "ram", "sheep", "goat", "dromedary_camel", "camel", "giraffe_face", "elephant", "rhinoceros", "mouse", "mouse2", "rat", "hamster", "rabbit", "rabbit2", "chipmunk", "hedgehog", "bat", "bear", "koala", "panda_face", "feet", "turkey", "chicken", "rooster", "hatching_chick", "baby_chick", "hatched_chick", "bird", "penguin", "dove_of_peace", "eagle", "duck", "owl", "frog", "crocodile", "turtle", "lizard", "snake", "dragon_face", "dragon", "sauropod", "t-rex", "whale", "whale2", "dolphin", "fish", "tropical_fish", "blowfish", "shark", "octopus", "shell", "crab", "shrimp", "squid", "snail", "butterfly", "bug", "ant", "bee", "beetle", "cricket", "spider", "spider_web", "scorpion", "bouquet", "cherry_blossom", "white_flower", "rosette", "rose", "wilted_flower", "hibiscus", "sunflower", "blossom", "tulip", "seedling", "evergreen_tree", "deciduous_tree", "palm_tree", "cactus", "ear_of_rice", "herb", "shamrock", "four_leaf_clover", "maple_leaf", "fallen_leaf", "leaves"]
      }, {
        id: "foods",
        name: "Food & Drink",
        emojis: ["grapes", "melon", "watermelon", "tangerine", "lemon", "banana", "pineapple", "apple", "green_apple", "pear", "peach", "cherries", "strawberry", "kiwifruit", "tomato", "coconut", "avocado", "eggplant", "potato", "carrot", "corn", "hot_pepper", "cucumber", "broccoli", "mushroom", "peanuts", "chestnut", "bread", "croissant", "baguette_bread", "pretzel", "pancakes", "cheese_wedge", "meat_on_bone", "poultry_leg", "cut_of_meat", "bacon", "hamburger", "fries", "pizza", "hotdog", "sandwich", "taco", "burrito", "stuffed_flatbread", "egg", "fried_egg", "shallow_pan_of_food", "stew", "bowl_with_spoon", "green_salad", "popcorn", "canned_food", "bento", "rice_cracker", "rice_ball", "rice", "curry", "ramen", "spaghetti", "sweet_potato", "oden", "sushi", "fried_shrimp", "fish_cake", "dango", "dumpling", "fortune_cookie", "takeout_box", "icecream", "shaved_ice", "ice_cream", "doughnut", "cookie", "birthday", "cake", "pie", "chocolate_bar", "candy", "lollipop", "custard", "honey_pot", "baby_bottle", "glass_of_milk", "coffee", "tea", "sake", "champagne", "wine_glass", "cocktail", "tropical_drink", "beer", "beers", "clinking_glasses", "tumbler_glass", "cup_with_straw", "chopsticks", "knife_fork_plate", "fork_and_knife", "spoon", "hocho", "amphora"]
      }, {
        id: "activity",
        name: "Activities",
        emojis: ["jack_o_lantern", "christmas_tree", "fireworks", "sparkler", "sparkles", "balloon", "tada", "confetti_ball", "tanabata_tree", "bamboo", "dolls", "flags", "wind_chime", "rice_scene", "ribbon", "gift", "reminder_ribbon", "admission_tickets", "ticket", "medal", "trophy", "sports_medal", "first_place_medal", "second_place_medal", "third_place_medal", "soccer", "baseball", "basketball", "volleyball", "football", "rugby_football", "tennis", "8ball", "bowling", "cricket_bat_and_ball", "field_hockey_stick_and_ball", "ice_hockey_stick_and_puck", "table_tennis_paddle_and_ball", "badminton_racquet_and_shuttlecock", "boxing_glove", "martial_arts_uniform", "goal_net", "dart", "golf", "ice_skate", "fishing_pole_and_fish", "running_shirt_with_sash", "ski", "sled", "curling_stone", "video_game", "joystick", "game_die", "spades", "hearts", "diamonds", "clubs", "black_joker", "mahjong", "flower_playing_cards"]
      }, {
        id: "places",
        name: "Travel & Places",
        emojis: ["earth_africa", "earth_americas", "earth_asia", "globe_with_meridians", "world_map", "japan", "snow_capped_mountain", "mountain", "volcano", "mount_fuji", "camping", "beach_with_umbrella", "desert", "desert_island", "national_park", "stadium", "classical_building", "building_construction", "house_buildings", "cityscape", "derelict_house_building", "house", "house_with_garden", "office", "post_office", "european_post_office", "hospital", "bank", "hotel", "love_hotel", "convenience_store", "school", "department_store", "factory", "japanese_castle", "european_castle", "wedding", "tokyo_tower", "statue_of_liberty", "church", "mosque", "synagogue", "shinto_shrine", "kaaba", "fountain", "tent", "foggy", "night_with_stars", "sunrise_over_mountains", "sunrise", "city_sunset", "city_sunrise", "bridge_at_night", "hotsprings", "milky_way", "carousel_horse", "ferris_wheel", "roller_coaster", "barber", "circus_tent", "performing_arts", "frame_with_picture", "art", "slot_machine", "steam_locomotive", "railway_car", "bullettrain_side", "bullettrain_front", "train2", "metro", "light_rail", "station", "tram", "monorail", "mountain_railway", "train", "bus", "oncoming_bus", "trolleybus", "minibus", "ambulance", "fire_engine", "police_car", "oncoming_police_car", "taxi", "oncoming_taxi", "car", "oncoming_automobile", "blue_car", "truck", "articulated_lorry", "tractor", "bike", "scooter", "motor_scooter", "busstop", "motorway", "railway_track", "fuelpump", "rotating_light", "traffic_light", "vertical_traffic_light", "construction", "octagonal_sign", "anchor", "boat", "canoe", "speedboat", "passenger_ship", "ferry", "motor_boat", "ship", "airplane", "small_airplane", "airplane_departure", "airplane_arriving", "seat", "helicopter", "suspension_railway", "mountain_cableway", "aerial_tramway", "satellite", "rocket", "flying_saucer", "bellhop_bell", "door", "bed", "couch_and_lamp", "toilet", "shower", "bathtub", "hourglass", "hourglass_flowing_sand", "watch", "alarm_clock", "stopwatch", "timer_clock", "mantelpiece_clock", "clock12", "clock1230", "clock1", "clock130", "clock2", "clock230", "clock3", "clock330", "clock4", "clock430", "clock5", "clock530", "clock6", "clock630", "clock7", "clock730", "clock8", "clock830", "clock9", "clock930", "clock10", "clock1030", "clock11", "clock1130", "new_moon", "waxing_crescent_moon", "first_quarter_moon", "moon", "full_moon", "waning_gibbous_moon", "last_quarter_moon", "waning_crescent_moon", "crescent_moon", "new_moon_with_face", "first_quarter_moon_with_face", "last_quarter_moon_with_face", "thermometer", "sunny", "full_moon_with_face", "sun_with_face", "star", "star2", "stars", "cloud", "partly_sunny", "thunder_cloud_and_rain", "mostly_sunny", "barely_sunny", "partly_sunny_rain", "rain_cloud", "snow_cloud", "lightning", "tornado", "fog", "wind_blowing_face", "cyclone", "rainbow", "closed_umbrella", "umbrella", "umbrella_with_rain_drops", "umbrella_on_ground", "zap", "snowflake", "snowman", "snowman_without_snow", "comet", "fire", "droplet", "ocean"]
      }, {
        id: "objects",
        name: "Objects",
        emojis: ["mute", "speaker", "sound", "loud_sound", "loudspeaker", "mega", "postal_horn", "bell", "no_bell", "musical_score", "musical_note", "notes", "studio_microphone", "level_slider", "control_knobs", "microphone", "headphones", "radio", "saxophone", "guitar", "musical_keyboard", "trumpet", "violin", "drum_with_drumsticks", "iphone", "calling", "phone", "telephone_receiver", "pager", "fax", "battery", "electric_plug", "computer", "desktop_computer", "printer", "keyboard", "three_button_mouse", "trackball", "minidisc", "floppy_disk", "cd", "dvd", "movie_camera", "film_frames", "film_projector", "clapper", "tv", "camera", "camera_with_flash", "video_camera", "vhs", "mag", "mag_right", "microscope", "telescope", "satellite_antenna", "candle", "bulb", "flashlight", "izakaya_lantern", "notebook_with_decorative_cover", "closed_book", "book", "green_book", "blue_book", "orange_book", "books", "notebook", "ledger", "page_with_curl", "scroll", "page_facing_up", "newspaper", "rolled_up_newspaper", "bookmark_tabs", "bookmark", "label", "moneybag", "yen", "dollar", "euro", "pound", "money_with_wings", "credit_card", "chart", "currency_exchange", "heavy_dollar_sign", "email", "e-mail", "incoming_envelope", "envelope_with_arrow", "outbox_tray", "inbox_tray", "package", "mailbox", "mailbox_closed", "mailbox_with_mail", "mailbox_with_no_mail", "postbox", "ballot_box_with_ballot", "pencil2", "black_nib", "lower_left_fountain_pen", "lower_left_ballpoint_pen", "lower_left_paintbrush", "lower_left_crayon", "memo", "briefcase", "file_folder", "open_file_folder", "card_index_dividers", "date", "calendar", "spiral_note_pad", "spiral_calendar_pad", "card_index", "chart_with_upwards_trend", "chart_with_downwards_trend", "bar_chart", "clipboard", "pushpin", "round_pushpin", "paperclip", "linked_paperclips", "straight_ruler", "triangular_ruler", "scissors", "card_file_box", "file_cabinet", "wastebasket", "lock", "unlock", "lock_with_ink_pen", "closed_lock_with_key", "key", "old_key", "hammer", "pick", "hammer_and_pick", "hammer_and_wrench", "dagger_knife", "crossed_swords", "gun", "bow_and_arrow", "shield", "wrench", "nut_and_bolt", "gear", "compression", "alembic", "scales", "link", "chains", "syringe", "pill", "smoking", "coffin", "funeral_urn", "moyai", "oil_drum", "crystal_ball", "shopping_trolley"]
      }, {
        id: "symbols",
        name: "Symbols",
        emojis: ["atm", "put_litter_in_its_place", "potable_water", "wheelchair", "mens", "womens", "restroom", "baby_symbol", "wc", "passport_control", "customs", "baggage_claim", "left_luggage", "warning", "children_crossing", "no_entry", "no_entry_sign", "no_bicycles", "no_smoking", "do_not_litter", "non-potable_water", "no_pedestrians", "no_mobile_phones", "underage", "radioactive_sign", "biohazard_sign", "arrow_up", "arrow_upper_right", "arrow_right", "arrow_lower_right", "arrow_down", "arrow_lower_left", "arrow_left", "arrow_upper_left", "arrow_up_down", "left_right_arrow", "leftwards_arrow_with_hook", "arrow_right_hook", "arrow_heading_up", "arrow_heading_down", "arrows_clockwise", "arrows_counterclockwise", "back", "end", "on", "soon", "top", "place_of_worship", "atom_symbol", "om_symbol", "star_of_david", "wheel_of_dharma", "yin_yang", "latin_cross", "orthodox_cross", "star_and_crescent", "peace_symbol", "menorah_with_nine_branches", "six_pointed_star", "aries", "taurus", "gemini", "cancer", "leo", "virgo", "libra", "scorpius", "sagittarius", "capricorn", "aquarius", "pisces", "ophiuchus", "twisted_rightwards_arrows", "repeat", "repeat_one", "arrow_forward", "fast_forward", "black_right_pointing_double_triangle_with_vertical_bar", "black_right_pointing_triangle_with_double_vertical_bar", "arrow_backward", "rewind", "black_left_pointing_double_triangle_with_vertical_bar", "arrow_up_small", "arrow_double_up", "arrow_down_small", "arrow_double_down", "double_vertical_bar", "black_square_for_stop", "black_circle_for_record", "eject", "cinema", "low_brightness", "high_brightness", "signal_strength", "vibration_mode", "mobile_phone_off", "female_sign", "male_sign", "medical_symbol", "recycle", "fleur_de_lis", "trident", "name_badge", "beginner", "o", "white_check_mark", "ballot_box_with_check", "heavy_check_mark", "heavy_multiplication_x", "x", "negative_squared_cross_mark", "heavy_plus_sign", "heavy_minus_sign", "heavy_division_sign", "curly_loop", "loop", "part_alternation_mark", "eight_spoked_asterisk", "eight_pointed_black_star", "sparkle", "bangbang", "interrobang", "question", "grey_question", "grey_exclamation", "exclamation", "wavy_dash", "copyright", "registered", "tm", "hash", "keycap_star", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "keycap_ten", "100", "capital_abcd", "abcd", "1234", "symbols", "abc", "a", "ab", "b", "cl", "cool", "free", "information_source", "id", "m", "new", "ng", "o2", "ok", "parking", "sos", "up", "vs", "koko", "sa", "u6708", "u6709", "u6307", "ideograph_advantage", "u5272", "u7121", "u7981", "accept", "u7533", "u5408", "u7a7a", "congratulations", "secret", "u55b6", "u6e80", "black_small_square", "white_small_square", "white_medium_square", "black_medium_square", "white_medium_small_square", "black_medium_small_square", "black_large_square", "white_large_square", "large_orange_diamond", "large_blue_diamond", "small_orange_diamond", "small_blue_diamond", "small_red_triangle", "small_red_triangle_down", "diamond_shape_with_a_dot_inside", "radio_button", "black_square_button", "white_square_button", "white_circle", "black_circle", "red_circle", "large_blue_circle"]
      }, {
        id: "flags",
        name: "Flags",
        emojis: ["checkered_flag", "cn", "crossed_flags", "de", "es", "flag-ac", "flag-ad", "flag-ae", "flag-af", "flag-ag", "flag-ai", "flag-al", "flag-am", "flag-ao", "flag-aq", "flag-ar", "flag-as", "flag-at", "flag-au", "flag-aw", "flag-ax", "flag-az", "flag-ba", "flag-bb", "flag-bd", "flag-be", "flag-bf", "flag-bg", "flag-bh", "flag-bi", "flag-bj", "flag-bl", "flag-bm", "flag-bn", "flag-bo", "flag-bq", "flag-br", "flag-bs", "flag-bt", "flag-bv", "flag-bw", "flag-by", "flag-bz", "flag-ca", "flag-cc", "flag-cd", "flag-cf", "flag-cg", "flag-ch", "flag-ci", "flag-ck", "flag-cl", "flag-cm", "flag-co", "flag-cp", "flag-cr", "flag-cu", "flag-cv", "flag-cw", "flag-cx", "flag-cy", "flag-cz", "flag-dg", "flag-dj", "flag-dk", "flag-dm", "flag-do", "flag-dz", "flag-ea", "flag-ec", "flag-ee", "flag-eg", "flag-eh", "flag-england", "flag-er", "flag-et", "flag-eu", "flag-fi", "flag-fj", "flag-fk", "flag-fm", "flag-fo", "flag-ga", "flag-gd", "flag-ge", "flag-gf", "flag-gg", "flag-gh", "flag-gi", "flag-gl", "flag-gm", "flag-gn", "flag-gp", "flag-gq", "flag-gr", "flag-gs", "flag-gt", "flag-gu", "flag-gw", "flag-gy", "flag-hk", "flag-hm", "flag-hn", "flag-hr", "flag-ht", "flag-hu", "flag-ic", "flag-id", "flag-ie", "flag-il", "flag-im", "flag-in", "flag-io", "flag-iq", "flag-ir", "flag-is", "flag-je", "flag-jm", "flag-jo", "flag-ke", "flag-kg", "flag-kh", "flag-ki", "flag-km", "flag-kn", "flag-kp", "flag-kw", "flag-ky", "flag-kz", "flag-la", "flag-lb", "flag-lc", "flag-li", "flag-lk", "flag-lr", "flag-ls", "flag-lt", "flag-lu", "flag-lv", "flag-ly", "flag-ma", "flag-mc", "flag-md", "flag-me", "flag-mf", "flag-mg", "flag-mh", "flag-mk", "flag-ml", "flag-mm", "flag-mn", "flag-mo", "flag-mp", "flag-mq", "flag-mr", "flag-ms", "flag-mt", "flag-mu", "flag-mv", "flag-mw", "flag-mx", "flag-my", "flag-mz", "flag-na", "flag-nc", "flag-ne", "flag-nf", "flag-ng", "flag-ni", "flag-nl", "flag-no", "flag-np", "flag-nr", "flag-nu", "flag-nz", "flag-om", "flag-pa", "flag-pe", "flag-pf", "flag-pg", "flag-ph", "flag-pk", "flag-pl", "flag-pm", "flag-pn", "flag-pr", "flag-ps", "flag-pt", "flag-pw", "flag-py", "flag-qa", "flag-re", "flag-ro", "flag-rs", "flag-rw", "flag-sa", "flag-sb", "flag-sc", "flag-scotland", "flag-sd", "flag-se", "flag-sg", "flag-sh", "flag-si", "flag-sj", "flag-sk", "flag-sl", "flag-sm", "flag-sn", "flag-so", "flag-sr", "flag-ss", "flag-st", "flag-sv", "flag-sx", "flag-sy", "flag-sz", "flag-ta", "flag-tc", "flag-td", "flag-tf", "flag-tg", "flag-th", "flag-tj", "flag-tk", "flag-tl", "flag-tm", "flag-tn", "flag-to", "flag-tr", "flag-tt", "flag-tv", "flag-tw", "flag-tz", "flag-ua", "flag-ug", "flag-um", "flag-uy", "flag-uz", "flag-va", "flag-vc", "flag-ve", "flag-vg", "flag-vi", "flag-vn", "flag-vu", "flag-wales", "flag-wf", "flag-ws", "flag-xk", "flag-ye", "flag-yt", "flag-za", "flag-zm", "flag-zw", "fr", "gb", "it", "jp", "kr", "rainbow-flag", "ru", "triangular_flag_on_post", "us", "waving_black_flag", "waving_white_flag"]
      }],
      emojis: {
        100: {
          a: "Hundred Points Symbol",
          b: "1F4AF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["score", "perfect", "numbers", "century", "exam", "quiz", "test", "pass", "hundred"],
          k: [25, 26]
        },
        1234: {
          a: "Input Symbol for Numbers",
          b: "1F522",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["numbers", "blue-square"],
          k: [27, 36]
        },
        monkey_face: {
          a: "Monkey Face",
          b: "1F435",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "circus"],
          k: [13, 31],
          l: [":o)"]
        },
        grinning: {
          a: "Grinning Face",
          b: "1F600",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "smile", "happy", "joy", ":D", "grin"],
          k: [30, 24],
          m: ":D"
        },
        earth_africa: {
          a: "Earth Globe Europe-Africa",
          b: "1F30D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["globe", "world", "international"],
          k: [6, 5]
        },
        checkered_flag: {
          a: "Chequered Flag",
          b: "1F3C1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["contest", "finishline", "race", "gokart"],
          k: [9, 27]
        },
        mute: {
          a: "Speaker with Cancellation Stroke",
          b: "1F507",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "volume", "silence", "quiet"],
          k: [27, 9]
        },
        jack_o_lantern: {
          a: "Jack-O-Lantern",
          b: "1F383",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["halloween", "light", "pumpkin", "creepy", "fall"],
          k: [8, 17]
        },
        atm: {
          a: "Automated Teller Machine",
          b: "1F3E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "cash", "blue-square", "payment", "bank"],
          k: [12, 4]
        },
        grapes: {
          a: "Grapes",
          b: "1F347",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "food", "wine"],
          k: [7, 9]
        },
        earth_americas: {
          a: "Earth Globe Americas",
          b: "1F30E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["globe", "world", "USA", "international"],
          k: [6, 6]
        },
        grin: {
          a: "Grinning Face with Smiling Eyes",
          b: "1F601",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "happy", "smile", "joy", "kawaii"],
          k: [30, 25]
        },
        melon: {
          a: "Melon",
          b: "1F348",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature", "food"],
          k: [7, 10]
        },
        triangular_flag_on_post: {
          a: "Triangular Flag on Post",
          b: "1F6A9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mark", "milestone", "place"],
          k: [35, 14]
        },
        monkey: {
          a: "Monkey",
          b: "1F412",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "banana", "circus"],
          k: [12, 48]
        },
        christmas_tree: {
          a: "Christmas Tree",
          b: "1F384",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["festival", "vacation", "december", "xmas", "celebration"],
          k: [8, 18]
        },
        put_litter_in_its_place: {
          a: "Put Litter in Its Place Symbol",
          b: "1F6AE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "sign", "human", "info"],
          k: [35, 19]
        },
        speaker: {
          a: "Speaker",
          b: "1F508",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "volume", "silence", "broadcast"],
          k: [27, 10]
        },
        earth_asia: {
          a: "Earth Globe Asia-Australia",
          b: "1F30F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["globe", "world", "east", "international"],
          k: [6, 7]
        },
        crossed_flags: {
          a: "Crossed Flags",
          b: "1F38C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "nation", "country", "border"],
          k: [8, 31]
        },
        joy: {
          a: "Face with Tears of Joy",
          b: "1F602",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "cry", "tears", "weep", "happy", "happytears", "haha"],
          k: [30, 26]
        },
        sound: {
          a: "Speaker with One Sound Wave",
          b: "1F509",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["volume", "speaker", "broadcast"],
          k: [27, 11]
        },
        watermelon: {
          a: "Watermelon",
          b: "1F349",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "food", "picnic", "summer"],
          k: [7, 11]
        },
        gorilla: {
          a: "Gorilla",
          b: "1F98D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "circus"],
          k: [42, 37],
          o: 9
        },
        fireworks: {
          a: "Fireworks",
          b: "1F386",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "festival", "carnival", "congratulations"],
          k: [8, 25]
        },
        potable_water: {
          a: "Potable Water Symbol",
          b: "1F6B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "liquid", "restroom", "cleaning", "faucet"],
          k: [35, 21]
        },
        wheelchair: {
          a: "Wheelchair Symbol",
          b: "267F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "disabled", "a11y", "accessibility"],
          k: [48, 10],
          o: 4
        },
        rolling_on_the_floor_laughing: {
          a: "Rolling on the Floor Laughing",
          b: "1F923",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 26],
          o: 9
        },
        loud_sound: {
          a: "Speaker with Three Sound Waves",
          b: "1F50A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["volume", "noise", "noisy", "speaker", "broadcast"],
          k: [27, 12]
        },
        waving_black_flag: {
          a: "Waving Black Flag",
          b: "1F3F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 19],
          o: 7
        },
        tangerine: {
          a: "Tangerine",
          b: "1F34A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "fruit", "nature", "orange"],
          k: [7, 12]
        },
        dog: {
          a: "Dog Face",
          b: "1F436",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "friend", "nature", "woof", "puppy", "pet", "faithful"],
          k: [13, 32]
        },
        sparkler: {
          a: "Firework Sparkler",
          b: "1F387",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stars", "night", "shine"],
          k: [8, 26]
        },
        globe_with_meridians: {
          a: "Globe with Meridians",
          b: "1F310",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["earth", "international", "world", "internet", "interweb", "i18n"],
          k: [6, 8]
        },
        smiley: {
          a: "Smiling Face with Open Mouth",
          b: "1F603",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "happy", "joy", "haha", ":D", ":)", "smile", "funny"],
          k: [30, 27],
          l: ["=)", "=-)"],
          m: ":)"
        },
        loudspeaker: {
          a: "Public Address Loudspeaker",
          b: "1F4E2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["volume", "sound"],
          k: [26, 25]
        },
        sparkles: {
          a: "Sparkles",
          b: "2728",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stars", "shine", "shiny", "cool", "awesome", "good", "magic"],
          k: [49, 48]
        },
        dog2: {
          a: "Dog",
          b: "1F415",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "friend", "doge", "pet", "faithful"],
          k: [12, 51]
        },
        waving_white_flag: {
          a: "Waving White Flag",
          b: "1F3F3-FE0F",
          c: "1F3F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 15],
          o: 7
        },
        world_map: {
          a: "World Map",
          b: "1F5FA-FE0F",
          c: "1F5FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["location", "direction"],
          k: [30, 18],
          o: 7
        },
        lemon: {
          a: "Lemon",
          b: "1F34B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature"],
          k: [7, 13]
        },
        mens: {
          a: "Mens Symbol",
          b: "1F6B9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["toilet", "restroom", "wc", "blue-square", "gender", "male"],
          k: [36, 29]
        },
        womens: {
          a: "Womens Symbol",
          b: "1F6BA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "woman", "female", "toilet", "loo", "restroom", "gender"],
          k: [36, 30]
        },
        "rainbow-flag": {
          a: "Rainbow Flag",
          b: "1F3F3-FE0F-200D-1F308",
          c: "1F3F3-200D-1F308",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [12, 14],
          o: 7
        },
        smile: {
          a: "Smiling Face with Open Mouth and Smiling Eyes",
          b: "1F604",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "happy", "joy", "funny", "haha", "laugh", "like", ":D", ":)"],
          k: [30, 28],
          l: ["C:", "c:", ":D", ":-D"],
          m: ":)"
        },
        banana: {
          a: "Banana",
          b: "1F34C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "food", "monkey"],
          k: [7, 14]
        },
        mega: {
          a: "Cheering Megaphone",
          b: "1F4E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "speaker", "volume"],
          k: [26, 26]
        },
        japan: {
          a: "Silhouette of Japan",
          b: "1F5FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nation", "country", "japanese", "asia"],
          k: [30, 22]
        },
        poodle: {
          a: "Poodle",
          b: "1F429",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dog", "animal", "101", "nature", "pet"],
          k: [13, 19]
        },
        balloon: {
          a: "Balloon",
          b: "1F388",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["party", "celebration", "birthday", "circus"],
          k: [8, 27]
        },
        "flag-ac": {
          a: "Ascension Island Flag",
          b: "1F1E6-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 31]
        },
        sweat_smile: {
          a: "Smiling Face with Open Mouth and Cold Sweat",
          b: "1F605",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "hot", "happy", "laugh", "sweat", "smile", "relief"],
          k: [30, 29]
        },
        pineapple: {
          a: "Pineapple",
          b: "1F34D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature", "food"],
          k: [7, 15]
        },
        restroom: {
          a: "Restroom",
          b: "1F6BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "toilet", "refresh", "wc", "gender"],
          k: [36, 31]
        },
        postal_horn: {
          a: "Postal Horn",
          b: "1F4EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["instrument", "music"],
          k: [26, 38]
        },
        wolf: {
          a: "Wolf Face",
          b: "1F43A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "wild"],
          k: [13, 36]
        },
        tada: {
          a: "Party Popper",
          b: "1F389",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["party", "congratulations", "birthday", "magic", "circus", "celebration"],
          k: [8, 28]
        },
        snow_capped_mountain: {
          a: "Snow Capped Mountain",
          b: "1F3D4-FE0F",
          c: "1F3D4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 37],
          o: 7
        },
        laughing: {
          a: "Smiling Face with Open Mouth and Tightly-Closed Eyes",
          b: "1F606",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["happy", "joy", "lol", "satisfied", "haha", "face", "glad", "XD", "laugh"],
          k: [30, 30],
          l: [":>", ":->"],
          n: ["satisfied"]
        },
        apple: {
          a: "Red Apple",
          b: "1F34E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "mac", "school"],
          k: [7, 16]
        },
        "flag-ad": {
          a: "Andorra Flag",
          b: "1F1E6-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 32]
        },
        fox_face: {
          a: "Fox Face",
          b: "1F98A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "face"],
          k: [42, 34],
          o: 9
        },
        confetti_ball: {
          a: "Confetti Ball",
          b: "1F38A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["festival", "party", "birthday", "circus"],
          k: [8, 29]
        },
        bell: {
          a: "Bell",
          b: "1F514",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "notification", "christmas", "xmas", "chime"],
          k: [27, 22]
        },
        mountain: {
          a: "Mountain",
          b: "26F0-FE0F",
          c: "26F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "nature", "environment"],
          k: [48, 38],
          o: 5
        },
        baby_symbol: {
          a: "Baby Symbol",
          b: "1F6BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["orange-square", "child"],
          k: [36, 32]
        },
        wc: {
          a: "Water Closet",
          b: "1F6BE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["toilet", "restroom", "blue-square"],
          k: [36, 34]
        },
        wink: {
          a: "Winking Face",
          b: "1F609",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "happy", "mischievous", "secret", ";)", "smile", "eye"],
          k: [30, 33],
          l: [";)", ";-)"],
          m: ";)"
        },
        no_bell: {
          a: "Bell with Cancellation Stroke",
          b: "1F515",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "volume", "mute", "quiet", "silent"],
          k: [27, 23]
        },
        green_apple: {
          a: "Green Apple",
          b: "1F34F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature"],
          k: [7, 17]
        },
        tanabata_tree: {
          a: "Tanabata Tree",
          b: "1F38B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature", "branch", "summer"],
          k: [8, 30]
        },
        "flag-ae": {
          a: "United Arab Emirates Flag",
          b: "1F1E6-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 33]
        },
        volcano: {
          a: "Volcano",
          b: "1F30B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "nature", "disaster"],
          k: [6, 3]
        },
        cat: {
          a: "Cat Face",
          b: "1F431",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "meow", "nature", "pet", "kitten"],
          k: [13, 27]
        },
        "flag-af": {
          a: "Afghanistan Flag",
          b: "1F1E6-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 34]
        },
        musical_score: {
          a: "Musical Score",
          b: "1F3BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["treble", "clef", "compose"],
          k: [9, 22]
        },
        blush: {
          a: "Smiling Face with Smiling Eyes",
          b: "1F60A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "smile", "happy", "flushed", "crush", "embarrassed", "shy", "joy"],
          k: [30, 34],
          m: ":)"
        },
        pear: {
          a: "Pear",
          b: "1F350",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature", "food"],
          k: [7, 18]
        },
        bamboo: {
          a: "Pine Decoration",
          b: "1F38D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature", "vegetable", "panda", "pine_decoration"],
          k: [8, 32]
        },
        passport_control: {
          a: "Passport Control",
          b: "1F6C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["custom", "blue-square"],
          k: [36, 43]
        },
        mount_fuji: {
          a: "Mount Fuji",
          b: "1F5FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "mountain", "nature", "japanese"],
          k: [30, 19]
        },
        cat2: {
          a: "Cat",
          b: "1F408",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "meow", "pet", "cats"],
          k: [12, 38]
        },
        musical_note: {
          a: "Musical Note",
          b: "1F3B5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["score", "tone", "sound"],
          k: [9, 15]
        },
        dolls: {
          a: "Japanese Dolls",
          b: "1F38E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "toy", "kimono"],
          k: [8, 33]
        },
        lion_face: {
          a: "Lion Face",
          b: "1F981",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 25],
          o: 8
        },
        camping: {
          a: "Camping",
          b: "1F3D5-FE0F",
          c: "1F3D5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "outdoors", "tent"],
          k: [11, 38],
          o: 7
        },
        "flag-ag": {
          a: "Antigua & Barbuda Flag",
          b: "1F1E6-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 35]
        },
        customs: {
          a: "Customs",
          b: "1F6C3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["passport", "border", "blue-square"],
          k: [36, 44]
        },
        yum: {
          a: "Face Savouring Delicious Food",
          b: "1F60B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["happy", "joy", "tongue", "smile", "face", "silly", "yummy", "nom", "delicious", "savouring"],
          k: [30, 35]
        },
        peach: {
          a: "Peach",
          b: "1F351",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "nature", "food"],
          k: [7, 19]
        },
        tiger: {
          a: "Tiger Face",
          b: "1F42F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cat", "danger", "wild", "nature", "roar"],
          k: [13, 25]
        },
        notes: {
          a: "Multiple Musical Notes",
          b: "1F3B6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "score"],
          k: [9, 16]
        },
        flags: {
          a: "Carp Streamer",
          b: "1F38F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fish", "japanese", "koinobori", "carp", "banner"],
          k: [8, 34]
        },
        beach_with_umbrella: {
          a: "Beach with Umbrella",
          b: "1F3D6-FE0F",
          c: "1F3D6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 39],
          o: 7
        },
        cherries: {
          a: "Cherries",
          b: "1F352",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "fruit"],
          k: [7, 20]
        },
        "flag-ai": {
          a: "Anguilla Flag",
          b: "1F1E6-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 36]
        },
        baggage_claim: {
          a: "Baggage Claim",
          b: "1F6C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "airport", "transport"],
          k: [36, 45]
        },
        sunglasses: {
          a: "Smiling Face with Sunglasses",
          b: "1F60E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "cool", "smile", "summer", "beach", "sunglass"],
          k: [30, 38],
          l: ["8)"]
        },
        left_luggage: {
          a: "Left Luggage",
          b: "1F6C5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "travel"],
          k: [36, 46]
        },
        wind_chime: {
          a: "Wind Chime",
          b: "1F390",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "ding", "spring", "bell"],
          k: [8, 35]
        },
        strawberry: {
          a: "Strawberry",
          b: "1F353",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "food", "nature"],
          k: [7, 21]
        },
        desert: {
          a: "Desert",
          b: "1F3DC-FE0F",
          c: "1F3DC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "warm", "saharah"],
          k: [11, 45],
          o: 7
        },
        studio_microphone: {
          a: "Studio Microphone",
          b: "1F399-FE0F",
          c: "1F399",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sing", "recording", "artist", "talkshow"],
          k: [8, 41],
          o: 7
        },
        "flag-al": {
          a: "Albania Flag",
          b: "1F1E6-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 37]
        },
        tiger2: {
          a: "Tiger",
          b: "1F405",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "roar"],
          k: [12, 35]
        },
        heart_eyes: {
          a: "Smiling Face with Heart-Shaped Eyes",
          b: "1F60D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "love", "like", "affection", "valentines", "infatuation", "crush", "heart"],
          k: [30, 37]
        },
        desert_island: {
          a: "Desert Island",
          b: "1F3DD-FE0F",
          c: "1F3DD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "tropical", "mojito"],
          k: [11, 46],
          o: 7
        },
        kiwifruit: {
          a: "Kiwifruit",
          b: "1F95D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 9],
          o: 9
        },
        rice_scene: {
          a: "Moon Viewing Ceremony",
          b: "1F391",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "japan", "asia", "tsukimi"],
          k: [8, 36]
        },
        kissing_heart: {
          a: "Face Throwing a Kiss",
          b: "1F618",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
          k: [30, 48],
          l: [":*", ":-*"]
        },
        warning: {
          a: "Warning Sign",
          b: "26A0-FE0F",
          c: "26A0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["exclamation", "wip", "alert", "error", "problem", "issue"],
          k: [48, 20],
          o: 4
        },
        "flag-am": {
          a: "Armenia Flag",
          b: "1F1E6-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 38]
        },
        leopard: {
          a: "Leopard",
          b: "1F406",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [12, 36]
        },
        level_slider: {
          a: "Level Slider",
          b: "1F39A-FE0F",
          c: "1F39A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["scale"],
          k: [8, 42],
          o: 7
        },
        horse: {
          a: "Horse Face",
          b: "1F434",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "brown", "nature"],
          k: [13, 30]
        },
        children_crossing: {
          a: "Children Crossing",
          b: "1F6B8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["school", "warning", "danger", "sign", "driving", "yellow-diamond"],
          k: [36, 28]
        },
        ribbon: {
          a: "Ribbon",
          b: "1F380",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["decoration", "pink", "girl", "bowtie"],
          k: [8, 14]
        },
        national_park: {
          a: "National Park",
          b: "1F3DE-FE0F",
          c: "1F3DE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "environment", "nature"],
          k: [11, 47],
          o: 7
        },
        control_knobs: {
          a: "Control Knobs",
          b: "1F39B-FE0F",
          c: "1F39B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["dial"],
          k: [8, 43],
          o: 7
        },
        kissing: {
          a: "Kissing Face",
          b: "1F617",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "face", "3", "valentines", "infatuation", "kiss"],
          k: [30, 47]
        },
        tomato: {
          a: "Tomato",
          b: "1F345",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fruit", "vegetable", "nature", "food"],
          k: [7, 7]
        },
        "flag-ao": {
          a: "Angola Flag",
          b: "1F1E6-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 39]
        },
        stadium: {
          a: "Stadium",
          b: "1F3DF-FE0F",
          c: "1F3DF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "place", "sports", "concert", "venue"],
          k: [11, 48],
          o: 7
        },
        "flag-aq": {
          a: "Antarctica Flag",
          b: "1F1E6-1F1F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 40]
        },
        gift: {
          a: "Wrapped Present",
          b: "1F381",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["present", "birthday", "christmas", "xmas"],
          k: [8, 15]
        },
        no_entry: {
          a: "No Entry",
          b: "26D4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["limit", "security", "privacy", "bad", "denied", "stop", "circle"],
          k: [48, 35],
          o: 5
        },
        kissing_smiling_eyes: {
          a: "Kissing Face with Smiling Eyes",
          b: "1F619",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "affection", "valentines", "infatuation", "kiss"],
          k: [30, 49]
        },
        coconut: {
          a: "Coconut",
          b: "1F965",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 17],
          o: 10
        },
        racehorse: {
          a: "Horse",
          b: "1F40E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "gamble", "luck"],
          k: [12, 44]
        },
        microphone: {
          a: "Microphone",
          b: "1F3A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sound", "music", "PA", "sing", "talkshow"],
          k: [8, 50]
        },
        classical_building: {
          a: "Classical Building",
          b: "1F3DB-FE0F",
          c: "1F3DB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["art", "culture", "history"],
          k: [11, 44],
          o: 7
        },
        no_entry_sign: {
          a: "No Entry Sign",
          b: "1F6AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["forbid", "stop", "limit", "denied", "disallow", "circle"],
          k: [35, 16]
        },
        reminder_ribbon: {
          a: "Reminder Ribbon",
          b: "1F397-FE0F",
          c: "1F397",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "cause", "support", "awareness"],
          k: [8, 40],
          o: 7
        },
        kissing_closed_eyes: {
          a: "Kissing Face with Closed Eyes",
          b: "1F61A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
          k: [30, 50]
        },
        unicorn_face: {
          a: "Unicorn Face",
          b: "1F984",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 28],
          o: 8
        },
        "flag-ar": {
          a: "Argentina Flag",
          b: "1F1E6-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 41]
        },
        headphones: {
          a: "Headphone",
          b: "1F3A7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "score", "gadgets"],
          k: [9, 1]
        },
        avocado: {
          a: "Avocado",
          b: "1F951",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["fruit", "food"],
          k: [41, 49],
          o: 9
        },
        relaxed: {
          a: "White Smiling Face",
          b: "263A-FE0F",
          c: "263A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "blush", "massage", "happiness"],
          k: [47, 41],
          o: 1
        },
        zebra_face: {
          a: "Zebra Face",
          b: "1F993",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 43],
          o: 10
        },
        eggplant: {
          a: "Aubergine",
          b: "1F346",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vegetable", "nature", "food", "aubergine"],
          k: [7, 8]
        },
        radio: {
          a: "Radio",
          b: "1F4FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["communication", "music", "podcast", "program"],
          k: [26, 50]
        },
        building_construction: {
          a: "Building Construction",
          b: "1F3D7-FE0F",
          c: "1F3D7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["wip", "working", "progress"],
          k: [11, 40],
          o: 7
        },
        "flag-as": {
          a: "American Samoa Flag",
          b: "1F1E6-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 42]
        },
        admission_tickets: {
          a: "Admission Tickets",
          b: "1F39F-FE0F",
          c: "1F39F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [8, 45],
          o: 7
        },
        no_bicycles: {
          a: "No Bicycles",
          b: "1F6B3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cyclist", "prohibited", "circle"],
          k: [35, 24]
        },
        no_smoking: {
          a: "No Smoking Symbol",
          b: "1F6AD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cigarette", "blue-square", "smell", "smoke"],
          k: [35, 18]
        },
        slightly_smiling_face: {
          a: "Slightly Smiling Face",
          b: "1F642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "smile"],
          k: [31, 38],
          l: [":)", "(:", ":-)"],
          o: 7
        },
        "flag-at": {
          a: "Austria Flag",
          b: "1F1E6-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 43]
        },
        ticket: {
          a: "Ticket",
          b: "1F3AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["event", "concert", "pass"],
          k: [9, 5]
        },
        saxophone: {
          a: "Saxophone",
          b: "1F3B7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "instrument", "jazz", "blues"],
          k: [9, 17]
        },
        deer: {
          a: "Deer",
          b: "1F98C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "horns", "venison"],
          k: [42, 36],
          o: 9
        },
        house_buildings: {
          a: "House Buildings",
          b: "1F3D8-FE0F",
          c: "1F3D8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 41],
          o: 7
        },
        potato: {
          a: "Potato",
          b: "1F954",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "tuber", "vegatable", "starch"],
          k: [42, 0],
          o: 9
        },
        guitar: {
          a: "Guitar",
          b: "1F3B8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "instrument"],
          k: [9, 18]
        },
        carrot: {
          a: "Carrot",
          b: "1F955",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vegetable", "food", "orange"],
          k: [42, 1],
          o: 9
        },
        cityscape: {
          a: "Cityscape",
          b: "1F3D9-FE0F",
          c: "1F3D9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["photo", "night life", "urban"],
          k: [11, 42],
          o: 7
        },
        "flag-au": {
          a: "Australia Flag",
          b: "1F1E6-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 44]
        },
        do_not_litter: {
          a: "Do Not Litter Symbol",
          b: "1F6AF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["trash", "bin", "garbage", "circle"],
          k: [35, 20]
        },
        hugging_face: {
          a: "Hugging Face",
          b: "1F917",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 31],
          o: 8
        },
        cow: {
          a: "Cow Face",
          b: "1F42E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beef", "ox", "animal", "nature", "moo", "milk"],
          k: [13, 24]
        },
        medal: {
          a: "Medal",
          b: "1F396-FE0F",
          c: "1F396",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [8, 39],
          o: 7
        },
        musical_keyboard: {
          a: "Musical Keyboard",
          b: "1F3B9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["piano", "instrument", "compose"],
          k: [9, 19]
        },
        corn: {
          a: "Ear of Maize",
          b: "1F33D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "vegetable", "plant"],
          k: [6, 51]
        },
        derelict_house_building: {
          a: "Derelict House Building",
          b: "1F3DA-FE0F",
          c: "1F3DA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 43],
          o: 7
        },
        "non-potable_water": {
          a: "Non-Potable Water Symbol",
          b: "1F6B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["drink", "faucet", "tap", "circle"],
          k: [35, 22]
        },
        trophy: {
          a: "Trophy",
          b: "1F3C6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["win", "award", "contest", "place", "ftw", "ceremony"],
          k: [10, 19]
        },
        "flag-aw": {
          a: "Aruba Flag",
          b: "1F1E6-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 45]
        },
        "star-struck": {
          a: "Grinning Face with Star Eyes",
          b: "1F929",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 49],
          n: ["grinning_face_with_star_eyes"],
          o: 10
        },
        ox: {
          a: "Ox",
          b: "1F402",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cow", "beef"],
          k: [12, 32]
        },
        trumpet: {
          a: "Trumpet",
          b: "1F3BA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "brass"],
          k: [9, 20]
        },
        hot_pepper: {
          a: "Hot Pepper",
          b: "1F336-FE0F",
          c: "1F336",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "spicy", "chilli", "chili"],
          k: [6, 44],
          o: 7
        },
        sports_medal: {
          a: "Sports Medal",
          b: "1F3C5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 18],
          o: 7
        },
        "flag-ax": {
          a: "\xc5land Islands Flag",
          b: "1F1E6-1F1FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 46]
        },
        water_buffalo: {
          a: "Water Buffalo",
          b: "1F403",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "ox", "cow"],
          k: [12, 33]
        },
        no_pedestrians: {
          a: "No Pedestrians",
          b: "1F6B7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["rules", "crossing", "walking", "circle"],
          k: [36, 27]
        },
        thinking_face: {
          a: "Thinking Face",
          b: "1F914",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 28],
          o: 8
        },
        house: {
          a: "House Building",
          b: "1F3E0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "home"],
          k: [11, 49]
        },
        no_mobile_phones: {
          a: "No Mobile Phones",
          b: "1F4F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["iphone", "mute", "circle"],
          k: [26, 44]
        },
        "flag-az": {
          a: "Azerbaijan Flag",
          b: "1F1E6-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 47]
        },
        first_place_medal: {
          a: "First Place Medal",
          b: "1F947",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 42],
          o: 9
        },
        house_with_garden: {
          a: "House with Garden",
          b: "1F3E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["home", "plant", "nature"],
          k: [11, 50]
        },
        violin: {
          a: "Violin",
          b: "1F3BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["music", "instrument", "orchestra", "symphony"],
          k: [9, 21]
        },
        face_with_raised_eyebrow: {
          a: "Face with One Eyebrow Raised",
          b: "1F928",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 48],
          n: ["face_with_one_eyebrow_raised"],
          o: 10
        },
        cucumber: {
          a: "Cucumber",
          b: "1F952",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["fruit", "food", "pickle"],
          k: [41, 50],
          o: 9
        },
        cow2: {
          a: "Cow",
          b: "1F404",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beef", "ox", "animal", "nature", "moo", "milk"],
          k: [12, 34]
        },
        "flag-ba": {
          a: "Bosnia & Herzegovina Flag",
          b: "1F1E7-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [0, 48]
        },
        pig: {
          a: "Pig Face",
          b: "1F437",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "oink", "nature"],
          k: [13, 33]
        },
        drum_with_drumsticks: {
          a: "Drum with Drumsticks",
          b: "1F941",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 37],
          o: 9
        },
        underage: {
          a: "No One Under Eighteen Symbol",
          b: "1F51E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["18", "drink", "pub", "night", "minor", "circle"],
          k: [27, 32]
        },
        broccoli: {
          a: "Broccoli",
          b: "1F966",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 18],
          o: 10
        },
        office: {
          a: "Office Building",
          b: "1F3E2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "bureau", "work"],
          k: [11, 51]
        },
        second_place_medal: {
          a: "Second Place Medal",
          b: "1F948",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 43],
          o: 9
        },
        neutral_face: {
          a: "Neutral Face",
          b: "1F610",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["indifference", "meh", ":|", "neutral"],
          k: [30, 40],
          l: [":|", ":-|"]
        },
        third_place_medal: {
          a: "Third Place Medal",
          b: "1F949",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 44],
          o: 9
        },
        mushroom: {
          a: "Mushroom",
          b: "1F344",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "vegetable"],
          k: [7, 6]
        },
        "flag-bb": {
          a: "Barbados Flag",
          b: "1F1E7-1F1E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 49]
        },
        radioactive_sign: {
          a: "Radioactive Sign",
          b: "2622-FE0F",
          c: "2622",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 33],
          o: 1
        },
        pig2: {
          a: "Pig",
          b: "1F416",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 0]
        },
        expressionless: {
          a: "Expressionless Face",
          b: "1F611",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "indifferent", "-_-", "meh", "deadpan"],
          k: [30, 41]
        },
        iphone: {
          a: "Mobile Phone",
          b: "1F4F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "apple", "gadgets", "dial"],
          k: [26, 40]
        },
        post_office: {
          a: "Japanese Post Office",
          b: "1F3E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "envelope", "communication"],
          k: [12, 0]
        },
        european_post_office: {
          a: "European Post Office",
          b: "1F3E4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "email"],
          k: [12, 1]
        },
        soccer: {
          a: "Soccer Ball",
          b: "26BD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "football"],
          k: [48, 26],
          o: 5
        },
        boar: {
          a: "Boar",
          b: "1F417",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 1]
        },
        peanuts: {
          a: "Peanuts",
          b: "1F95C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "nut"],
          k: [42, 8],
          o: 9
        },
        calling: {
          a: "Mobile Phone with Rightwards Arrow at Left",
          b: "1F4F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["iphone", "incoming"],
          k: [26, 41]
        },
        biohazard_sign: {
          a: "Biohazard Sign",
          b: "2623-FE0F",
          c: "2623",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 34],
          o: 1
        },
        "flag-bd": {
          a: "Bangladesh Flag",
          b: "1F1E7-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 50]
        },
        no_mouth: {
          a: "Face Without Mouth",
          b: "1F636",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "hellokitty"],
          k: [31, 26]
        },
        face_with_rolling_eyes: {
          a: "Face with Rolling Eyes",
          b: "1F644",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [31, 40],
          o: 8
        },
        phone: {
          a: "Black Telephone",
          b: "260E-FE0F",
          c: "260E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "communication", "dial", "telephone"],
          k: [47, 21],
          n: ["telephone"],
          o: 1
        },
        pig_nose: {
          a: "Pig Nose",
          b: "1F43D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "oink"],
          k: [13, 39]
        },
        chestnut: {
          a: "Chestnut",
          b: "1F330",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "squirrel"],
          k: [6, 38]
        },
        arrow_up: {
          a: "Upwards Black Arrow",
          b: "2B06-FE0F",
          c: "2B06",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "continue", "top", "direction"],
          k: [50, 18],
          o: 4
        },
        hospital: {
          a: "Hospital",
          b: "1F3E5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "health", "surgery", "doctor"],
          k: [12, 2]
        },
        "flag-be": {
          a: "Belgium Flag",
          b: "1F1E7-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [0, 51]
        },
        baseball: {
          a: "Baseball",
          b: "26BE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "balls"],
          k: [48, 27],
          o: 5
        },
        smirk: {
          a: "Smirking Face",
          b: "1F60F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "smile", "mean", "prank", "smug", "sarcasm"],
          k: [30, 39]
        },
        arrow_upper_right: {
          a: "North East Arrow",
          b: "2197-FE0F",
          c: "2197",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "point", "direction", "diagonal", "northeast"],
          k: [46, 36],
          o: 1
        },
        "flag-bf": {
          a: "Burkina Faso Flag",
          b: "1F1E7-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 0]
        },
        basketball: {
          a: "Basketball and Hoop",
          b: "1F3C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "balls", "NBA"],
          k: [9, 26]
        },
        ram: {
          a: "Ram",
          b: "1F40F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "sheep", "nature"],
          k: [12, 45]
        },
        bank: {
          a: "Bank",
          b: "1F3E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "money", "sales", "cash", "business", "enterprise"],
          k: [12, 3]
        },
        bread: {
          a: "Bread",
          b: "1F35E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "wheat", "breakfast", "toast"],
          k: [7, 32]
        },
        telephone_receiver: {
          a: "Telephone Receiver",
          b: "1F4DE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "communication", "dial"],
          k: [26, 21]
        },
        croissant: {
          a: "Croissant",
          b: "1F950",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "bread", "french"],
          k: [41, 48],
          o: 9
        },
        pager: {
          a: "Pager",
          b: "1F4DF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bbcall", "oldschool", "90s"],
          k: [26, 22]
        },
        sheep: {
          a: "Sheep",
          b: "1F411",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "wool", "shipit"],
          k: [12, 47]
        },
        arrow_right: {
          a: "Black Rightwards Arrow",
          b: "27A1-FE0F",
          c: "27A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "next"],
          k: [50, 12],
          o: 1
        },
        persevere: {
          a: "Persevering Face",
          b: "1F623",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "sick", "no", "upset", "oops"],
          k: [31, 7]
        },
        "flag-bg": {
          a: "Bulgaria Flag",
          b: "1F1E7-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 1]
        },
        volleyball: {
          a: "Volleyball",
          b: "1F3D0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "balls"],
          k: [11, 33],
          o: 8
        },
        hotel: {
          a: "Hotel",
          b: "1F3E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "accomodation", "checkin"],
          k: [12, 5]
        },
        arrow_lower_right: {
          a: "South East Arrow",
          b: "2198-FE0F",
          c: "2198",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "diagonal", "southeast"],
          k: [46, 37],
          o: 1
        },
        goat: {
          a: "Goat",
          b: "1F410",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [12, 46]
        },
        "flag-bh": {
          a: "Bahrain Flag",
          b: "1F1E7-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 2]
        },
        love_hotel: {
          a: "Love Hotel",
          b: "1F3E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["like", "affection", "dating"],
          k: [12, 6]
        },
        disappointed_relieved: {
          a: "Disappointed but Relieved Face",
          b: "1F625",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "phew", "sweat", "nervous"],
          k: [31, 9]
        },
        baguette_bread: {
          a: "Baguette Bread",
          b: "1F956",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "bread", "french"],
          k: [42, 2],
          o: 9
        },
        football: {
          a: "American Football",
          b: "1F3C8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "balls", "NFL"],
          k: [10, 26]
        },
        fax: {
          a: "Fax Machine",
          b: "1F4E0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["communication", "technology"],
          k: [26, 23]
        },
        convenience_store: {
          a: "Convenience Store",
          b: "1F3EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "shopping", "groceries"],
          k: [12, 7]
        },
        dromedary_camel: {
          a: "Dromedary Camel",
          b: "1F42A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "hot", "desert", "hump"],
          k: [13, 20]
        },
        arrow_down: {
          a: "Downwards Black Arrow",
          b: "2B07-FE0F",
          c: "2B07",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "bottom"],
          k: [50, 19],
          o: 4
        },
        battery: {
          a: "Battery",
          b: "1F50B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["power", "energy", "sustain"],
          k: [27, 13]
        },
        rugby_football: {
          a: "Rugby Football",
          b: "1F3C9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "team"],
          k: [10, 27]
        },
        pretzel: {
          a: "Pretzel",
          b: "1F968",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 20],
          o: 10
        },
        open_mouth: {
          a: "Face with Open Mouth",
          b: "1F62E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "surprise", "impressed", "wow", "whoa", ":O"],
          k: [31, 18],
          l: [":o", ":-o", ":O", ":-O"]
        },
        "flag-bi": {
          a: "Burundi Flag",
          b: "1F1E7-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 3]
        },
        "flag-bj": {
          a: "Benin Flag",
          b: "1F1E7-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 4]
        },
        pancakes: {
          a: "Pancakes",
          b: "1F95E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "breakfast", "flapjacks", "hotcakes"],
          k: [42, 10],
          o: 9
        },
        school: {
          a: "School",
          b: "1F3EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "student", "education", "learn", "teach"],
          k: [12, 8]
        },
        tennis: {
          a: "Tennis Racquet and Ball",
          b: "1F3BE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "balls", "green"],
          k: [9, 24]
        },
        zipper_mouth_face: {
          a: "Zipper-Mouth Face",
          b: "1F910",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "sealed", "zipper", "secret"],
          k: [37, 24],
          o: 8
        },
        camel: {
          a: "Bactrian Camel",
          b: "1F42B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "hot", "desert", "hump"],
          k: [13, 21]
        },
        arrow_lower_left: {
          a: "South West Arrow",
          b: "2199-FE0F",
          c: "2199",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "diagonal", "southwest"],
          k: [46, 38],
          o: 1
        },
        electric_plug: {
          a: "Electric Plug",
          b: "1F50C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["charger", "power"],
          k: [27, 14]
        },
        cheese_wedge: {
          a: "Cheese Wedge",
          b: "1F9C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 48],
          o: 8
        },
        hushed: {
          a: "Hushed Face",
          b: "1F62F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "woo", "shh"],
          k: [31, 19]
        },
        computer: {
          a: "Personal Computer",
          b: "1F4BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "laptop", "screen", "display", "monitor"],
          k: [25, 38]
        },
        giraffe_face: {
          a: "Giraffe Face",
          b: "1F992",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 42],
          o: 10
        },
        "8ball": {
          a: "Billiards",
          b: "1F3B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pool", "hobby", "game", "luck", "magic"],
          k: [9, 11]
        },
        "flag-bl": {
          a: "St. Barth\xe9lemy Flag",
          b: "1F1E7-1F1F1",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 5]
        },
        arrow_left: {
          a: "Leftwards Black Arrow",
          b: "2B05-FE0F",
          c: "2B05",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "previous", "back"],
          k: [50, 17],
          o: 4
        },
        department_store: {
          a: "Department Store",
          b: "1F3EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "shopping", "mall"],
          k: [12, 9]
        },
        meat_on_bone: {
          a: "Meat on Bone",
          b: "1F356",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["good", "food", "drumstick"],
          k: [7, 24]
        },
        arrow_upper_left: {
          a: "North West Arrow",
          b: "2196-FE0F",
          c: "2196",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "point", "direction", "diagonal", "northwest"],
          k: [46, 35],
          o: 1
        },
        "flag-bm": {
          a: "Bermuda Flag",
          b: "1F1E7-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 6]
        },
        sleepy: {
          a: "Sleepy Face",
          b: "1F62A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "tired", "rest", "nap"],
          k: [31, 14]
        },
        bowling: {
          a: "Bowling",
          b: "1F3B3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "fun", "play"],
          k: [9, 13]
        },
        factory: {
          a: "Factory",
          b: "1F3ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "industry", "pollution", "smoke"],
          k: [12, 10]
        },
        desktop_computer: {
          a: "Desktop Computer",
          b: "1F5A5-FE0F",
          c: "1F5A5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["technology", "computing", "screen"],
          k: [29, 51],
          o: 7
        },
        elephant: {
          a: "Elephant",
          b: "1F418",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "nose", "th", "circus"],
          k: [13, 2]
        },
        rhinoceros: {
          a: "Rhinoceros",
          b: "1F98F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "horn"],
          k: [42, 39],
          o: 9
        },
        arrow_up_down: {
          a: "Up Down Arrow",
          b: "2195-FE0F",
          c: "2195",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "way", "vertical"],
          k: [46, 34],
          o: 1
        },
        cricket_bat_and_ball: {
          a: "Cricket Bat and Ball",
          b: "1F3CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 32],
          o: 8
        },
        printer: {
          a: "Printer",
          b: "1F5A8-FE0F",
          c: "1F5A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["paper", "ink"],
          k: [30, 0],
          o: 7
        },
        poultry_leg: {
          a: "Poultry Leg",
          b: "1F357",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "meat", "drumstick", "bird", "chicken", "turkey"],
          k: [7, 25]
        },
        tired_face: {
          a: "Tired Face",
          b: "1F62B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sick", "whine", "upset", "frustrated"],
          k: [31, 15]
        },
        japanese_castle: {
          a: "Japanese Castle",
          b: "1F3EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "building"],
          k: [12, 12]
        },
        "flag-bn": {
          a: "Brunei Flag",
          b: "1F1E7-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [1, 7]
        },
        field_hockey_stick_and_ball: {
          a: "Field Hockey Stick and Ball",
          b: "1F3D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 34],
          o: 8
        },
        sleeping: {
          a: "Sleeping Face",
          b: "1F634",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "tired", "sleepy", "night", "zzz"],
          k: [31, 24]
        },
        left_right_arrow: {
          a: "Left Right Arrow",
          b: "2194-FE0F",
          c: "2194",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "direction", "horizontal", "sideways"],
          k: [46, 33],
          o: 1
        },
        keyboard: {
          a: "Keyboard",
          b: "2328-FE0F",
          c: "2328",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["technology", "computer", "type", "input", "text"],
          k: [46, 43],
          o: 1
        },
        european_castle: {
          a: "European Castle",
          b: "1F3F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "royalty", "history"],
          k: [12, 13]
        },
        mouse: {
          a: "Mouse Face",
          b: "1F42D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "cheese_wedge", "rodent"],
          k: [13, 23]
        },
        "flag-bo": {
          a: "Bolivia Flag",
          b: "1F1E7-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 8]
        },
        cut_of_meat: {
          a: "Cut of Meat",
          b: "1F969",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 21],
          o: 10
        },
        ice_hockey_stick_and_puck: {
          a: "Ice Hockey Stick and Puck",
          b: "1F3D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 35],
          o: 8
        },
        mouse2: {
          a: "Mouse",
          b: "1F401",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "rodent"],
          k: [12, 31]
        },
        three_button_mouse: {
          a: "Three Button Mouse",
          b: "1F5B1-FE0F",
          c: "1F5B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 1],
          o: 7
        },
        leftwards_arrow_with_hook: {
          a: "Leftwards Arrow with Hook",
          b: "21A9-FE0F",
          c: "21A9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["back", "return", "blue-square", "undo", "enter"],
          k: [46, 39],
          o: 1
        },
        bacon: {
          a: "Bacon",
          b: "1F953",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "breakfast", "pork", "pig", "meat"],
          k: [41, 51],
          o: 9
        },
        relieved: {
          a: "Relieved Face",
          b: "1F60C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "relaxed", "phew", "massage", "happiness"],
          k: [30, 36]
        },
        "flag-bq": {
          a: "Caribbean Netherlands Flag",
          b: "1F1E7-1F1F6",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 9]
        },
        wedding: {
          a: "Wedding",
          b: "1F492",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "couple", "marriage", "bride", "groom"],
          k: [24, 44]
        },
        tokyo_tower: {
          a: "Tokyo Tower",
          b: "1F5FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "japanese"],
          k: [30, 20]
        },
        arrow_right_hook: {
          a: "Rightwards Arrow with Hook",
          b: "21AA-FE0F",
          c: "21AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "return", "rotate", "direction"],
          k: [46, 40],
          o: 1
        },
        hamburger: {
          a: "Hamburger",
          b: "1F354",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["meat", "fast food", "beef", "cheeseburger", "mcdonalds", "burger king"],
          k: [7, 22]
        },
        stuck_out_tongue: {
          a: "Face with Stuck-out Tongue",
          b: "1F61B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "prank", "childish", "playful", "mischievous", "smile", "tongue"],
          k: [30, 51],
          l: [":p", ":-p", ":P", ":-P", ":b", ":-b"],
          m: ":p"
        },
        trackball: {
          a: "Trackball",
          b: "1F5B2-FE0F",
          c: "1F5B2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["technology", "trackpad"],
          k: [30, 2],
          o: 7
        },
        "flag-br": {
          a: "Brazil Flag",
          b: "1F1E7-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 10]
        },
        rat: {
          a: "Rat",
          b: "1F400",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "mouse", "rodent"],
          k: [12, 30]
        },
        table_tennis_paddle_and_ball: {
          a: "Table Tennis Paddle and Ball",
          b: "1F3D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 36],
          o: 8
        },
        minidisc: {
          a: "Minidisc",
          b: "1F4BD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "record", "data", "disk", "90s"],
          k: [25, 40]
        },
        stuck_out_tongue_winking_eye: {
          a: "Face with Stuck-out Tongue and Winking Eye",
          b: "1F61C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "prank", "childish", "playful", "mischievous", "smile", "wink", "tongue"],
          k: [31, 0],
          l: [";p", ";-p", ";b", ";-b", ";P", ";-P"],
          m: ";p"
        },
        fries: {
          a: "French Fries",
          b: "1F35F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chips", "snack", "fast food"],
          k: [7, 33]
        },
        badminton_racquet_and_shuttlecock: {
          a: "Badminton Racquet and Shuttlecock",
          b: "1F3F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 22],
          o: 8
        },
        statue_of_liberty: {
          a: "Statue of Liberty",
          b: "1F5FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["american", "newyork"],
          k: [30, 21]
        },
        "flag-bs": {
          a: "Bahamas Flag",
          b: "1F1E7-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 11]
        },
        arrow_heading_up: {
          a: "Arrow Pointing Rightwards Then Curving Upwards",
          b: "2934-FE0F",
          c: "2934",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "top"],
          k: [50, 15],
          o: 3
        },
        hamster: {
          a: "Hamster Face",
          b: "1F439",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 35]
        },
        stuck_out_tongue_closed_eyes: {
          a: "Face with Stuck-out Tongue and Tightly-Closed Eyes",
          b: "1F61D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "prank", "playful", "mischievous", "smile", "tongue"],
          k: [31, 1]
        },
        pizza: {
          a: "Slice of Pizza",
          b: "1F355",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "party"],
          k: [7, 23]
        },
        boxing_glove: {
          a: "Boxing Glove",
          b: "1F94A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "fighting"],
          k: [41, 45],
          o: 9
        },
        floppy_disk: {
          a: "Floppy Disk",
          b: "1F4BE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["oldschool", "technology", "save", "90s", "80s"],
          k: [25, 41]
        },
        arrow_heading_down: {
          a: "Arrow Pointing Rightwards Then Curving Downwards",
          b: "2935-FE0F",
          c: "2935",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "bottom"],
          k: [50, 16],
          o: 3
        },
        "flag-bt": {
          a: "Bhutan Flag",
          b: "1F1E7-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 12]
        },
        rabbit: {
          a: "Rabbit Face",
          b: "1F430",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "pet", "spring", "magic", "bunny"],
          k: [13, 26]
        },
        church: {
          a: "Church",
          b: "26EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["building", "religion", "christ"],
          k: [48, 37],
          o: 5
        },
        drooling_face: {
          a: "Drooling Face",
          b: "1F924",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face"],
          k: [38, 27],
          o: 9
        },
        "flag-bv": {
          a: "Bouvet Island Flag",
          b: "1F1E7-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 13]
        },
        mosque: {
          a: "Mosque",
          b: "1F54C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["islam", "worship", "minaret"],
          k: [28, 15],
          o: 8
        },
        rabbit2: {
          a: "Rabbit",
          b: "1F407",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "pet", "magic", "spring"],
          k: [12, 37]
        },
        hotdog: {
          a: "Hot Dog",
          b: "1F32D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "frankfurter"],
          k: [6, 35],
          o: 8
        },
        martial_arts_uniform: {
          a: "Martial Arts Uniform",
          b: "1F94B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["judo", "karate", "taekwondo"],
          k: [41, 46],
          o: 9
        },
        arrows_clockwise: {
          a: "Clockwise Downwards and Upwards Open Circle Arrows",
          b: "1F503",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sync", "cycle", "round", "repeat"],
          k: [27, 5]
        },
        cd: {
          a: "Optical Disc",
          b: "1F4BF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "dvd", "disk", "disc", "90s"],
          k: [25, 42]
        },
        arrows_counterclockwise: {
          a: "Anticlockwise Downwards and Upwards Open Circle Arrows",
          b: "1F504",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "sync", "cycle"],
          k: [27, 6]
        },
        sandwich: {
          a: "Sandwich",
          b: "1F96A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 22],
          o: 10
        },
        chipmunk: {
          a: "Chipmunk",
          b: "1F43F-FE0F",
          c: "1F43F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "rodent", "squirrel"],
          k: [13, 41],
          o: 7
        },
        synagogue: {
          a: "Synagogue",
          b: "1F54D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["judaism", "worship", "temple", "jewish"],
          k: [28, 16],
          o: 8
        },
        unamused: {
          a: "Unamused Face",
          b: "1F612",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["indifference", "bored", "straight face", "serious", "sarcasm"],
          k: [30, 42],
          m: ":("
        },
        goal_net: {
          a: "Goal Net",
          b: "1F945",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports"],
          k: [41, 41],
          o: 9
        },
        "flag-bw": {
          a: "Botswana Flag",
          b: "1F1E7-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 14]
        },
        dvd: {
          a: "Dvd",
          b: "1F4C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cd", "disk", "disc"],
          k: [25, 43]
        },
        hedgehog: {
          a: "Hedgehog",
          b: "1F994",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 44],
          o: 10
        },
        dart: {
          a: "Direct Hit",
          b: "1F3AF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["game", "play", "bar"],
          k: [9, 9]
        },
        taco: {
          a: "Taco",
          b: "1F32E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "mexican"],
          k: [6, 36],
          o: 8
        },
        back: {
          a: "Back with Leftwards Arrow Above",
          b: "1F519",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arrow", "words", "return"],
          k: [27, 27]
        },
        "flag-by": {
          a: "Belarus Flag",
          b: "1F1E7-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 15]
        },
        shinto_shrine: {
          a: "Shinto Shrine",
          b: "26E9-FE0F",
          c: "26E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["temple", "japan", "kyoto"],
          k: [48, 36],
          o: 5
        },
        movie_camera: {
          a: "Movie Camera",
          b: "1F3A5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["film", "record"],
          k: [8, 51]
        },
        sweat: {
          a: "Face with Cold Sweat",
          b: "1F613",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "hot", "sad", "tired", "exercise"],
          k: [30, 43]
        },
        burrito: {
          a: "Burrito",
          b: "1F32F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "mexican"],
          k: [6, 37],
          o: 8
        },
        "flag-bz": {
          a: "Belize Flag",
          b: "1F1E7-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 16]
        },
        pensive: {
          a: "Pensive Face",
          b: "1F614",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "sad", "depressed", "upset"],
          k: [30, 44]
        },
        kaaba: {
          a: "Kaaba",
          b: "1F54B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["mecca", "mosque", "islam"],
          k: [28, 14],
          o: 8
        },
        film_frames: {
          a: "Film Frames",
          b: "1F39E-FE0F",
          c: "1F39E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [8, 44],
          o: 7
        },
        bat: {
          a: "Bat",
          b: "1F987",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "blind", "vampire"],
          k: [42, 31],
          o: 9
        },
        golf: {
          a: "Flag in Hole",
          b: "26F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "business", "flag", "hole", "summer"],
          k: [48, 41],
          o: 5
        },
        end: {
          a: "End with Leftwards Arrow Above",
          b: "1F51A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["words", "arrow"],
          k: [27, 28]
        },
        film_projector: {
          a: "Film Projector",
          b: "1F4FD-FE0F",
          c: "1F4FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["video", "tape", "record", "movie"],
          k: [27, 0],
          o: 7
        },
        bear: {
          a: "Bear Face",
          b: "1F43B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "wild"],
          k: [13, 37]
        },
        ice_skate: {
          a: "Ice Skate",
          b: "26F8-FE0F",
          c: "26F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports"],
          k: [48, 45],
          o: 5
        },
        fountain: {
          a: "Fountain",
          b: "26F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "summer", "water", "fresh"],
          k: [48, 40],
          o: 5
        },
        confused: {
          a: "Confused Face",
          b: "1F615",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "indifference", "huh", "weird", "hmmm", ":/"],
          k: [30, 45],
          l: [":\\", ":-\\", ":/", ":-/"]
        },
        "flag-ca": {
          a: "Canada Flag",
          b: "1F1E8-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 17]
        },
        on: {
          a: "On with Exclamation Mark with Left Right Arrow Above",
          b: "1F51B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arrow", "words"],
          k: [27, 29]
        },
        stuffed_flatbread: {
          a: "Stuffed Flatbread",
          b: "1F959",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "flatbread", "stuffed", "gyro"],
          k: [42, 5],
          o: 9
        },
        soon: {
          a: "Soon with Rightwards Arrow Above",
          b: "1F51C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arrow", "words"],
          k: [27, 30]
        },
        upside_down_face: {
          a: "Upside-Down Face",
          b: "1F643",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "flipped", "silly", "smile"],
          k: [31, 39],
          o: 8
        },
        fishing_pole_and_fish: {
          a: "Fishing Pole and Fish",
          b: "1F3A3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "hobby", "summer"],
          k: [8, 49]
        },
        tent: {
          a: "Tent",
          b: "26FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "camping", "outdoors"],
          k: [49, 12],
          o: 5
        },
        clapper: {
          a: "Clapper Board",
          b: "1F3AC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["movie", "film", "record"],
          k: [9, 6]
        },
        egg: {
          a: "Egg",
          b: "1F95A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "chicken", "breakfast"],
          k: [42, 6],
          o: 9
        },
        "flag-cc": {
          a: "Cocos (keeling) Islands Flag",
          b: "1F1E8-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 18]
        },
        koala: {
          a: "Koala",
          b: "1F428",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 18]
        },
        foggy: {
          a: "Foggy",
          b: "1F301",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "mountain"],
          k: [5, 45]
        },
        tv: {
          a: "Television",
          b: "1F4FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["technology", "program", "oldschool", "show", "television"],
          k: [26, 49]
        },
        panda_face: {
          a: "Panda Face",
          b: "1F43C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "panda"],
          k: [13, 38]
        },
        fried_egg: {
          a: "Cooking",
          b: "1F373",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "breakfast", "kitchen", "egg"],
          k: [8, 1],
          n: ["cooking"]
        },
        top: {
          a: "Top with Upwards Arrow Above",
          b: "1F51D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["words", "blue-square"],
          k: [27, 31]
        },
        "flag-cd": {
          a: "Congo - Kinshasa Flag",
          b: "1F1E8-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 19]
        },
        money_mouth_face: {
          a: "Money-Mouth Face",
          b: "1F911",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "rich", "dollar", "money"],
          k: [37, 25],
          o: 8
        },
        running_shirt_with_sash: {
          a: "Running Shirt with Sash",
          b: "1F3BD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["play", "pageant"],
          k: [9, 23]
        },
        astonished: {
          a: "Astonished Face",
          b: "1F632",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "xox", "surprised", "poisoned"],
          k: [31, 22]
        },
        feet: {
          a: "Paw Prints",
          b: "1F43E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [13, 40],
          n: ["paw_prints"]
        },
        camera: {
          a: "Camera",
          b: "1F4F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["gadgets", "photography"],
          k: [26, 46]
        },
        "flag-cf": {
          a: "Central African Republic Flag",
          b: "1F1E8-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 20]
        },
        place_of_worship: {
          a: "Place of Worship",
          b: "1F6D0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["religion", "church", "temple", "prayer"],
          k: [37, 5],
          o: 8
        },
        night_with_stars: {
          a: "Night with Stars",
          b: "1F303",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["evening", "city", "downtown"],
          k: [5, 47]
        },
        ski: {
          a: "Ski and Ski Boot",
          b: "1F3BF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "winter", "cold", "snow"],
          k: [9, 25]
        },
        shallow_pan_of_food: {
          a: "Shallow Pan of Food",
          b: "1F958",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "cooking", "casserole", "paella"],
          k: [42, 4],
          o: 9
        },
        camera_with_flash: {
          a: "Camera with Flash",
          b: "1F4F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [26, 47],
          o: 7
        },
        sunrise_over_mountains: {
          a: "Sunrise over Mountains",
          b: "1F304",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["view", "vacation", "photo"],
          k: [5, 48]
        },
        turkey: {
          a: "Turkey",
          b: "1F983",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "bird"],
          k: [42, 27],
          o: 8
        },
        white_frowning_face: {
          a: "White Frowning Face",
          b: "2639-FE0F",
          c: "2639",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 40],
          o: 1
        },
        "flag-cg": {
          a: "Congo - Brazzaville Flag",
          b: "1F1E8-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 21]
        },
        stew: {
          a: "Pot of Food",
          b: "1F372",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "meat", "soup"],
          k: [8, 0]
        },
        sled: {
          a: "Sled",
          b: "1F6F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 22],
          o: 10
        },
        atom_symbol: {
          a: "Atom Symbol",
          b: "269B-FE0F",
          c: "269B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["science", "physics", "chemistry"],
          k: [48, 18],
          o: 4
        },
        curling_stone: {
          a: "Curling Stone",
          b: "1F94C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 47],
          o: 10
        },
        slightly_frowning_face: {
          a: "Slightly Frowning Face",
          b: "1F641",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "frowning", "disappointed", "sad", "upset"],
          k: [31, 37],
          o: 7
        },
        sunrise: {
          a: "Sunrise",
          b: "1F305",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["morning", "view", "vacation", "photo"],
          k: [5, 49]
        },
        om_symbol: {
          a: "Om Symbol",
          b: "1F549-FE0F",
          c: "1F549",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [28, 12],
          o: 7
        },
        chicken: {
          a: "Chicken",
          b: "1F414",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cluck", "nature", "bird"],
          k: [12, 50]
        },
        bowl_with_spoon: {
          a: "Bowl with Spoon",
          b: "1F963",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 15],
          o: 10
        },
        "flag-ch": {
          a: "Switzerland Flag",
          b: "1F1E8-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 22]
        },
        video_camera: {
          a: "Video Camera",
          b: "1F4F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["film", "record"],
          k: [26, 48]
        },
        video_game: {
          a: "Video Game",
          b: "1F3AE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["play", "console", "PS4", "controller"],
          k: [9, 8]
        },
        rooster: {
          a: "Rooster",
          b: "1F413",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "chicken"],
          k: [12, 49]
        },
        vhs: {
          a: "Videocassette",
          b: "1F4FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["record", "video", "oldschool", "90s", "80s"],
          k: [26, 51]
        },
        city_sunset: {
          a: "Cityscape at Dusk",
          b: "1F306",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "evening", "sky", "buildings"],
          k: [5, 50]
        },
        confounded: {
          a: "Confounded Face",
          b: "1F616",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "confused", "sick", "unwell", "oops", ":S"],
          k: [30, 46]
        },
        green_salad: {
          a: "Green Salad",
          b: "1F957",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "healthy", "lettuce"],
          k: [42, 3],
          o: 9
        },
        star_of_david: {
          a: "Star of David",
          b: "2721-FE0F",
          c: "2721",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["judaism"],
          k: [49, 47],
          o: 1
        },
        "flag-ci": {
          a: "C\xF4te D\u2019ivoire Flag",
          b: "1F1E8-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 23]
        },
        popcorn: {
          a: "Popcorn",
          b: "1F37F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["food", "movie theater", "films", "snack"],
          k: [8, 13],
          o: 8
        },
        city_sunrise: {
          a: "Sunset over Buildings",
          b: "1F307",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "good morning", "dawn"],
          k: [5, 51]
        },
        disappointed: {
          a: "Disappointed Face",
          b: "1F61E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "sad", "upset", "depressed", ":("],
          k: [31, 2],
          l: ["):", ":(", ":-("],
          m: ":("
        },
        mag: {
          a: "Left-Pointing Magnifying Glass",
          b: "1F50D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["search", "zoom", "find", "detective"],
          k: [27, 15]
        },
        hatching_chick: {
          a: "Hatching Chick",
          b: "1F423",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "chicken", "egg", "born", "baby", "bird"],
          k: [13, 13]
        },
        joystick: {
          a: "Joystick",
          b: "1F579-FE0F",
          c: "1F579",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["game", "play"],
          k: [29, 20],
          o: 7
        },
        wheel_of_dharma: {
          a: "Wheel of Dharma",
          b: "2638-FE0F",
          c: "2638",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["hinduism", "buddhism", "sikhism", "jainism"],
          k: [47, 39],
          o: 1
        },
        "flag-ck": {
          a: "Cook Islands Flag",
          b: "1F1E8-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 24]
        },
        canned_food: {
          a: "Canned Food",
          b: "1F96B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 23],
          o: 10
        },
        worried: {
          a: "Worried Face",
          b: "1F61F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "concern", "nervous", ":("],
          k: [31, 3]
        },
        baby_chick: {
          a: "Baby Chick",
          b: "1F424",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "chicken", "bird"],
          k: [13, 14]
        },
        "flag-cl": {
          a: "Chile Flag",
          b: "1F1E8-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 25]
        },
        game_die: {
          a: "Game Die",
          b: "1F3B2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dice", "random", "tabletop", "play", "luck"],
          k: [9, 12]
        },
        mag_right: {
          a: "Right-Pointing Magnifying Glass",
          b: "1F50E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["search", "zoom", "find", "detective"],
          k: [27, 16]
        },
        yin_yang: {
          a: "Yin Yang",
          b: "262F-FE0F",
          c: "262F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["balance"],
          k: [47, 38],
          o: 1
        },
        bridge_at_night: {
          a: "Bridge at Night",
          b: "1F309",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "sanfrancisco"],
          k: [6, 1]
        },
        spades: {
          a: "Black Spade Suit",
          b: "2660-FE0F",
          c: "2660",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "suits", "magic"],
          k: [48, 4],
          o: 1
        },
        hatched_chick: {
          a: "Front-Facing Baby Chick",
          b: "1F425",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "chicken", "baby", "bird"],
          k: [13, 15]
        },
        "flag-cm": {
          a: "Cameroon Flag",
          b: "1F1E8-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 26]
        },
        latin_cross: {
          a: "Latin Cross",
          b: "271D-FE0F",
          c: "271D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["christianity"],
          k: [49, 46],
          o: 1
        },
        triumph: {
          a: "Face with Look of Triumph",
          b: "1F624",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "gas", "phew", "proud", "pride"],
          k: [31, 8]
        },
        hotsprings: {
          a: "Hot Springs",
          b: "2668-FE0F",
          c: "2668",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bath", "warm", "relax"],
          k: [48, 8],
          o: 1
        },
        bento: {
          a: "Bento Box",
          b: "1F371",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese", "box"],
          k: [7, 51]
        },
        microscope: {
          a: "Microscope",
          b: "1F52C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["laboratory", "experiment", "zoomin", "science", "study"],
          k: [27, 46]
        },
        cry: {
          a: "Crying Face",
          b: "1F622",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "tears", "sad", "depressed", "upset", ":'("],
          k: [31, 6],
          l: [":'("],
          m: ":'("
        },
        bird: {
          a: "Bird",
          b: "1F426",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "fly", "tweet", "spring"],
          k: [13, 16]
        },
        cn: {
          a: "China Flag",
          b: "1F1E8-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["china", "chinese", "prc", "flag", "country", "nation", "banner"],
          k: [1, 27],
          n: ["flag-cn"]
        },
        telescope: {
          a: "Telescope",
          b: "1F52D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stars", "space", "zoom", "science", "astronomy"],
          k: [27, 47]
        },
        rice_cracker: {
          a: "Rice Cracker",
          b: "1F358",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese"],
          k: [7, 26]
        },
        hearts: {
          a: "Black Heart Suit",
          b: "2665-FE0F",
          c: "2665",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "magic", "suits"],
          k: [48, 6],
          o: 1
        },
        orthodox_cross: {
          a: "Orthodox Cross",
          b: "2626-FE0F",
          c: "2626",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["suppedaneum", "religion"],
          k: [47, 35],
          o: 1
        },
        milky_way: {
          a: "Milky Way",
          b: "1F30C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "space", "stars"],
          k: [6, 4]
        },
        rice_ball: {
          a: "Rice Ball",
          b: "1F359",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese"],
          k: [7, 27]
        },
        satellite_antenna: {
          a: "Satellite Antenna",
          b: "1F4E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [26, 24]
        },
        "flag-co": {
          a: "Colombia Flag",
          b: "1F1E8-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 28]
        },
        carousel_horse: {
          a: "Carousel Horse",
          b: "1F3A0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "carnival"],
          k: [8, 46]
        },
        sob: {
          a: "Loudly Crying Face",
          b: "1F62D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "cry", "tears", "sad", "upset", "depressed"],
          k: [31, 17],
          m: ":'("
        },
        diamonds: {
          a: "Black Diamond Suit",
          b: "2666-FE0F",
          c: "2666",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "magic", "suits"],
          k: [48, 7],
          o: 1
        },
        star_and_crescent: {
          a: "Star and Crescent",
          b: "262A-FE0F",
          c: "262A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["islam"],
          k: [47, 36],
          o: 1
        },
        penguin: {
          a: "Penguin",
          b: "1F427",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature"],
          k: [13, 17]
        },
        dove_of_peace: {
          a: "Dove of Peace",
          b: "1F54A-FE0F",
          c: "1F54A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [28, 13],
          o: 7
        },
        "flag-cp": {
          a: "Clipperton Island Flag",
          b: "1F1E8-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [1, 29]
        },
        ferris_wheel: {
          a: "Ferris Wheel",
          b: "1F3A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["photo", "carnival", "londoneye"],
          k: [8, 47]
        },
        clubs: {
          a: "Black Club Suit",
          b: "2663-FE0F",
          c: "2663",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "magic", "suits"],
          k: [48, 5],
          o: 1
        },
        peace_symbol: {
          a: "Peace Symbol",
          b: "262E-FE0F",
          c: "262E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["hippie"],
          k: [47, 37],
          o: 1
        },
        candle: {
          a: "Candle",
          b: "1F56F-FE0F",
          c: "1F56F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["fire", "wax"],
          k: [28, 42],
          o: 7
        },
        frowning: {
          a: "Frowning Face with Open Mouth",
          b: "1F626",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "aw", "what"],
          k: [31, 10]
        },
        rice: {
          a: "Cooked Rice",
          b: "1F35A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "china", "asian"],
          k: [7, 28]
        },
        "flag-cr": {
          a: "Costa Rica Flag",
          b: "1F1E8-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 30]
        },
        roller_coaster: {
          a: "Roller Coaster",
          b: "1F3A2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["carnival", "playground", "photo", "fun"],
          k: [8, 48]
        },
        menorah_with_nine_branches: {
          a: "Menorah with Nine Branches",
          b: "1F54E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [28, 17],
          o: 8
        },
        black_joker: {
          a: "Playing Card Black Joker",
          b: "1F0CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["poker", "cards", "game", "play", "magic"],
          k: [0, 15]
        },
        eagle: {
          a: "Eagle",
          b: "1F985",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "bird"],
          k: [42, 29],
          o: 9
        },
        curry: {
          a: "Curry and Rice",
          b: "1F35B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "spicy", "hot", "indian"],
          k: [7, 29]
        },
        bulb: {
          a: "Electric Light Bulb",
          b: "1F4A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["light", "electricity", "idea"],
          k: [25, 7]
        },
        anguished: {
          a: "Anguished Face",
          b: "1F627",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "stunned", "nervous"],
          k: [31, 11],
          l: ["D:"]
        },
        "flag-cu": {
          a: "Cuba Flag",
          b: "1F1E8-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 31]
        },
        barber: {
          a: "Barber Pole",
          b: "1F488",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hair", "salon", "style"],
          k: [24, 34]
        },
        duck: {
          a: "Duck",
          b: "1F986",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "bird", "mallard"],
          k: [42, 30],
          o: 9
        },
        six_pointed_star: {
          a: "Six Pointed Star with Middle Dot",
          b: "1F52F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "religion", "jewish", "hexagram"],
          k: [27, 49]
        },
        ramen: {
          a: "Steaming Bowl",
          b: "1F35C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese", "noodle", "chopsticks"],
          k: [7, 30]
        },
        flashlight: {
          a: "Electric Torch",
          b: "1F526",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dark", "camping", "sight", "night"],
          k: [27, 40]
        },
        mahjong: {
          a: "Mahjong Tile Red Dragon",
          b: "1F004",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["game", "play", "chinese", "kanji"],
          k: [0, 14],
          o: 5
        },
        fearful: {
          a: "Fearful Face",
          b: "1F628",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "scared", "terrified", "nervous", "oops", "huh"],
          k: [31, 12]
        },
        aries: {
          a: "Aries",
          b: "2648",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "zodiac", "astrology"],
          k: [47, 44],
          o: 1
        },
        spaghetti: {
          a: "Spaghetti",
          b: "1F35D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "italian", "noodle"],
          k: [7, 31]
        },
        circus_tent: {
          a: "Circus Tent",
          b: "1F3AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["festival", "carnival", "party"],
          k: [9, 4]
        },
        izakaya_lantern: {
          a: "Izakaya Lantern",
          b: "1F3EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["light", "paper", "halloween", "spooky"],
          k: [12, 11],
          n: ["lantern"]
        },
        "flag-cv": {
          a: "Cape Verde Flag",
          b: "1F1E8-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 32]
        },
        weary: {
          a: "Weary Face",
          b: "1F629",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "tired", "sleepy", "sad", "frustrated", "upset"],
          k: [31, 13]
        },
        flower_playing_cards: {
          a: "Flower Playing Cards",
          b: "1F3B4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["game", "sunset", "red"],
          k: [9, 14]
        },
        owl: {
          a: "Owl",
          b: "1F989",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "bird", "hoot"],
          k: [42, 33],
          o: 9
        },
        performing_arts: {
          a: "Performing Arts",
          b: "1F3AD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["acting", "theater", "drama"],
          k: [9, 7]
        },
        frog: {
          a: "Frog Face",
          b: "1F438",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "croak", "toad"],
          k: [13, 34]
        },
        "flag-cw": {
          a: "Cura\xe7ao Flag",
          b: "1F1E8-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 33]
        },
        notebook_with_decorative_cover: {
          a: "Notebook with Decorative Cover",
          b: "1F4D4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["classroom", "notes", "record", "paper", "study"],
          k: [26, 11]
        },
        exploding_head: {
          a: "Shocked Face with Exploding Head",
          b: "1F92F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 3],
          n: ["shocked_face_with_exploding_head"],
          o: 10
        },
        taurus: {
          a: "Taurus",
          b: "2649",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "sign", "zodiac", "astrology"],
          k: [47, 45],
          o: 1
        },
        sweet_potato: {
          a: "Roasted Sweet Potato",
          b: "1F360",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "nature"],
          k: [7, 34]
        },
        closed_book: {
          a: "Closed Book",
          b: "1F4D5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["read", "library", "knowledge", "textbook", "learn"],
          k: [26, 12]
        },
        gemini: {
          a: "Gemini",
          b: "264A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [47, 46],
          o: 1
        },
        frame_with_picture: {
          a: "Frame with Picture",
          b: "1F5BC-FE0F",
          c: "1F5BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 3],
          o: 7
        },
        "flag-cx": {
          a: "Christmas Island Flag",
          b: "1F1E8-1F1FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 34]
        },
        grimacing: {
          a: "Grimacing Face",
          b: "1F62C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "grimace", "teeth"],
          k: [31, 16]
        },
        crocodile: {
          a: "Crocodile",
          b: "1F40A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "reptile", "lizard", "alligator"],
          k: [12, 40]
        },
        oden: {
          a: "Oden",
          b: "1F362",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japanese"],
          k: [7, 36]
        },
        "flag-cy": {
          a: "Cyprus Flag",
          b: "1F1E8-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 35]
        },
        book: {
          a: "Open Book",
          b: "1F4D6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [26, 13],
          n: ["open_book"]
        },
        turtle: {
          a: "Turtle",
          b: "1F422",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "slow", "nature", "tortoise"],
          k: [13, 12]
        },
        art: {
          a: "Artist Palette",
          b: "1F3A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["design", "paint", "draw", "colors"],
          k: [9, 2]
        },
        sushi: {
          a: "Sushi",
          b: "1F363",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "fish", "japanese", "rice"],
          k: [7, 37]
        },
        cold_sweat: {
          a: "Face with Open Mouth and Cold Sweat",
          b: "1F630",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "nervous", "sweat"],
          k: [31, 20]
        },
        cancer: {
          a: "Cancer",
          b: "264B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [47, 47],
          o: 1
        },
        fried_shrimp: {
          a: "Fried Shrimp",
          b: "1F364",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "animal", "appetizer", "summer"],
          k: [7, 38]
        },
        slot_machine: {
          a: "Slot Machine",
          b: "1F3B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bet", "gamble", "vegas", "fruit machine", "luck", "casino"],
          k: [9, 10]
        },
        scream: {
          a: "Face Screaming in Fear",
          b: "1F631",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "munch", "scared", "omg"],
          k: [31, 21]
        },
        green_book: {
          a: "Green Book",
          b: "1F4D7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["read", "library", "knowledge", "study"],
          k: [26, 14]
        },
        leo: {
          a: "Leo",
          b: "264C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "zodiac", "astrology"],
          k: [47, 48],
          o: 1
        },
        "flag-cz": {
          a: "Czechia Flag",
          b: "1F1E8-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 36]
        },
        lizard: {
          a: "Lizard",
          b: "1F98E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "reptile"],
          k: [42, 38],
          o: 9
        },
        virgo: {
          a: "Virgo",
          b: "264D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [47, 49],
          o: 1
        },
        steam_locomotive: {
          a: "Steam Locomotive",
          b: "1F682",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "train"],
          k: [34, 10]
        },
        de: {
          a: "Germany Flag",
          b: "1F1E9-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["german", "nation", "flag", "country", "banner"],
          k: [1, 37],
          n: ["flag-de"]
        },
        flushed: {
          a: "Flushed Face",
          b: "1F633",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "blush", "shy", "flattered"],
          k: [31, 23]
        },
        blue_book: {
          a: "Blue Book",
          b: "1F4D8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["read", "library", "knowledge", "learn", "study"],
          k: [26, 15]
        },
        snake: {
          a: "Snake",
          b: "1F40D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "evil", "nature", "hiss", "python"],
          k: [12, 43]
        },
        fish_cake: {
          a: "Fish Cake with Swirl Design",
          b: "1F365",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "japan", "sea", "beach", "narutomaki", "pink", "swirl", "kamaboko", "surimi", "ramen"],
          k: [7, 39]
        },
        railway_car: {
          a: "Railway Car",
          b: "1F683",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 11]
        },
        dango: {
          a: "Dango",
          b: "1F361",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "dessert", "sweet", "japanese", "barbecue", "meat"],
          k: [7, 35]
        },
        orange_book: {
          a: "Orange Book",
          b: "1F4D9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["read", "library", "knowledge", "textbook", "study"],
          k: [26, 16]
        },
        libra: {
          a: "Libra",
          b: "264E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "zodiac", "astrology"],
          k: [47, 50],
          o: 1
        },
        dragon_face: {
          a: "Dragon Face",
          b: "1F432",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "myth", "nature", "chinese", "green"],
          k: [13, 28]
        },
        "flag-dg": {
          a: "Diego Garcia Flag",
          b: "1F1E9-1F1EC",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 38]
        },
        zany_face: {
          a: "Grinning Face with One Large and One Small Eye",
          b: "1F92A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 50],
          n: ["grinning_face_with_one_large_and_one_small_eye"],
          o: 10
        },
        books: {
          a: "Books",
          b: "1F4DA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["literature", "library", "study"],
          k: [26, 17]
        },
        dragon: {
          a: "Dragon",
          b: "1F409",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "myth", "nature", "chinese", "green"],
          k: [12, 39]
        },
        "flag-dj": {
          a: "Djibouti Flag",
          b: "1F1E9-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 39]
        },
        dumpling: {
          a: "Dumpling",
          b: "1F95F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 11],
          o: 10
        },
        dizzy_face: {
          a: "Dizzy Face",
          b: "1F635",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["spent", "unconscious", "xox", "dizzy"],
          k: [31, 25]
        },
        scorpius: {
          a: "Scorpius",
          b: "264F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology", "scorpio"],
          k: [47, 51],
          o: 1
        },
        bullettrain_side: {
          a: "High-Speed Train",
          b: "1F684",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 12]
        },
        bullettrain_front: {
          a: "High-Speed Train with Bullet Nose",
          b: "1F685",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "speed", "fast", "public", "travel"],
          k: [34, 13]
        },
        notebook: {
          a: "Notebook",
          b: "1F4D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "record", "notes", "paper", "study"],
          k: [26, 10]
        },
        fortune_cookie: {
          a: "Fortune Cookie",
          b: "1F960",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 12],
          o: 10
        },
        sagittarius: {
          a: "Sagittarius",
          b: "2650",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [48, 0],
          o: 1
        },
        sauropod: {
          a: "Sauropod",
          b: "1F995",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 45],
          o: 10
        },
        "flag-dk": {
          a: "Denmark Flag",
          b: "1F1E9-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 40]
        },
        rage: {
          a: "Pouting Face",
          b: "1F621",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["angry", "mad", "hate", "despise"],
          k: [31, 5]
        },
        ledger: {
          a: "Ledger",
          b: "1F4D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["notes", "paper"],
          k: [26, 9]
        },
        angry: {
          a: "Angry Face",
          b: "1F620",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mad", "face", "annoyed", "frustrated"],
          k: [31, 4],
          l: [">:(", ">:-("]
        },
        "t-rex": {
          a: "T-Rex",
          b: "1F996",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 46],
          o: 10
        },
        capricorn: {
          a: "Capricorn",
          b: "2651",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "zodiac", "purple-square", "astrology"],
          k: [48, 1],
          o: 1
        },
        takeout_box: {
          a: "Takeout Box",
          b: "1F961",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 13],
          o: 10
        },
        "flag-dm": {
          a: "Dominica Flag",
          b: "1F1E9-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 41]
        },
        train2: {
          a: "Train",
          b: "1F686",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 14]
        },
        page_with_curl: {
          a: "Page with Curl",
          b: "1F4C3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "office", "paper"],
          k: [25, 46]
        },
        whale: {
          a: "Spouting Whale",
          b: "1F433",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "sea", "ocean"],
          k: [13, 29]
        },
        face_with_symbols_on_mouth: {
          a: "Serious Face with Symbols Covering Mouth",
          b: "1F92C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 0],
          n: ["serious_face_with_symbols_covering_mouth"],
          o: 10
        },
        "flag-do": {
          a: "Dominican Republic Flag",
          b: "1F1E9-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 42]
        },
        metro: {
          a: "Metro",
          b: "1F687",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "blue-square", "mrt", "underground", "tube"],
          k: [34, 15]
        },
        icecream: {
          a: "Soft Ice Cream",
          b: "1F366",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "hot", "dessert", "summer"],
          k: [7, 40]
        },
        aquarius: {
          a: "Aquarius",
          b: "2652",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "zodiac", "astrology"],
          k: [48, 2],
          o: 1
        },
        "flag-dz": {
          a: "Algeria Flag",
          b: "1F1E9-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 43]
        },
        whale2: {
          a: "Whale",
          b: "1F40B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "sea", "ocean"],
          k: [12, 41]
        },
        mask: {
          a: "Face with Medical Mask",
          b: "1F637",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "sick", "ill", "disease"],
          k: [31, 27]
        },
        scroll: {
          a: "Scroll",
          b: "1F4DC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "ancient", "history", "paper"],
          k: [26, 19]
        },
        shaved_ice: {
          a: "Shaved Ice",
          b: "1F367",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hot", "dessert", "summer"],
          k: [7, 41]
        },
        pisces: {
          a: "Pisces",
          b: "2653",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "sign", "zodiac", "astrology"],
          k: [48, 3],
          o: 1
        },
        light_rail: {
          a: "Light Rail",
          b: "1F688",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 16]
        },
        dolphin: {
          a: "Dolphin",
          b: "1F42C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "fish", "sea", "ocean", "flipper", "fins", "beach"],
          k: [13, 22],
          n: ["flipper"]
        },
        face_with_thermometer: {
          a: "Face with Thermometer",
          b: "1F912",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sick", "temperature", "thermometer", "cold", "fever"],
          k: [37, 26],
          o: 8
        },
        "flag-ea": {
          a: "Ceuta & Melilla Flag",
          b: "1F1EA-1F1E6",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 44]
        },
        ophiuchus: {
          a: "Ophiuchus",
          b: "26CE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sign", "purple-square", "constellation", "astrology"],
          k: [48, 31]
        },
        station: {
          a: "Station",
          b: "1F689",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "public"],
          k: [34, 17]
        },
        ice_cream: {
          a: "Ice Cream",
          b: "1F368",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "hot", "dessert"],
          k: [7, 42]
        },
        page_facing_up: {
          a: "Page Facing Up",
          b: "1F4C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "office", "paper", "information"],
          k: [25, 47]
        },
        doughnut: {
          a: "Doughnut",
          b: "1F369",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "dessert", "snack", "sweet", "donut"],
          k: [7, 43]
        },
        face_with_head_bandage: {
          a: "Face with Head-Bandage",
          b: "1F915",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["injured", "clumsy", "bandage", "hurt"],
          k: [37, 29],
          o: 8
        },
        fish: {
          a: "Fish",
          b: "1F41F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "food", "nature"],
          k: [13, 9]
        },
        newspaper: {
          a: "Newspaper",
          b: "1F4F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["press", "headline"],
          k: [26, 39]
        },
        tram: {
          a: "Tram",
          b: "1F68A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 18]
        },
        "flag-ec": {
          a: "Ecuador Flag",
          b: "1F1EA-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 45]
        },
        twisted_rightwards_arrows: {
          a: "Twisted Rightwards Arrows",
          b: "1F500",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "shuffle", "music", "random"],
          k: [27, 2]
        },
        "flag-ee": {
          a: "Estonia Flag",
          b: "1F1EA-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 46]
        },
        cookie: {
          a: "Cookie",
          b: "1F36A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "snack", "oreo", "chocolate", "sweet", "dessert"],
          k: [7, 44]
        },
        monorail: {
          a: "Monorail",
          b: "1F69D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 37]
        },
        tropical_fish: {
          a: "Tropical Fish",
          b: "1F420",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "swim", "ocean", "beach", "nemo"],
          k: [13, 10]
        },
        rolled_up_newspaper: {
          a: "Rolled Up Newspaper",
          b: "1F5DE-FE0F",
          c: "1F5DE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 12],
          o: 7
        },
        nauseated_face: {
          a: "Nauseated Face",
          b: "1F922",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "vomit", "gross", "green", "sick", "throw up", "ill"],
          k: [38, 25],
          o: 9
        },
        repeat: {
          a: "Clockwise Rightwards and Leftwards Open Circle Arrows",
          b: "1F501",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["loop", "record"],
          k: [27, 3]
        },
        bookmark_tabs: {
          a: "Bookmark Tabs",
          b: "1F4D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["favorite", "save", "order", "tidy"],
          k: [26, 8]
        },
        repeat_one: {
          a: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay",
          b: "1F502",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "loop"],
          k: [27, 4]
        },
        "flag-eg": {
          a: "Egypt Flag",
          b: "1F1EA-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 47]
        },
        mountain_railway: {
          a: "Mountain Railway",
          b: "1F69E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 38]
        },
        birthday: {
          a: "Birthday Cake",
          b: "1F382",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "dessert", "cake"],
          k: [8, 16]
        },
        blowfish: {
          a: "Blowfish",
          b: "1F421",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "nature", "food", "sea", "ocean"],
          k: [13, 11]
        },
        face_vomiting: {
          a: "Face with Open Mouth Vomiting",
          b: "1F92E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 2],
          n: ["face_with_open_mouth_vomiting"],
          o: 10
        },
        arrow_forward: {
          a: "Black Right-Pointing Triangle",
          b: "25B6-FE0F",
          c: "25B6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "right", "direction", "play"],
          k: [47, 10],
          o: 1
        },
        bookmark: {
          a: "Bookmark",
          b: "1F516",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["favorite", "label", "save"],
          k: [27, 24]
        },
        "flag-eh": {
          a: "Western Sahara Flag",
          b: "1F1EA-1F1ED",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 48]
        },
        shark: {
          a: "Shark",
          b: "1F988",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "fish", "sea", "ocean", "jaws", "fins", "beach"],
          k: [42, 32],
          o: 9
        },
        train: {
          a: "Tram Car",
          b: "1F68B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "carriage", "public", "travel"],
          k: [34, 19]
        },
        sneezing_face: {
          a: "Sneezing Face",
          b: "1F927",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "gesundheit", "sneeze", "sick", "allergy"],
          k: [38, 47],
          o: 9
        },
        cake: {
          a: "Shortcake",
          b: "1F370",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "dessert"],
          k: [7, 50]
        },
        bus: {
          a: "Bus",
          b: "1F68C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["car", "vehicle", "transportation"],
          k: [34, 20]
        },
        pie: {
          a: "Pie",
          b: "1F967",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 19],
          o: 10
        },
        innocent: {
          a: "Smiling Face with Halo",
          b: "1F607",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "angel", "heaven", "halo"],
          k: [30, 31]
        },
        fast_forward: {
          a: "Black Right-Pointing Double Triangle",
          b: "23E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "play", "speed", "continue"],
          k: [46, 45]
        },
        label: {
          a: "Label",
          b: "1F3F7-FE0F",
          c: "1F3F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sale", "tag"],
          k: [12, 21],
          o: 7
        },
        octopus: {
          a: "Octopus",
          b: "1F419",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "creature", "ocean", "sea", "nature", "beach"],
          k: [13, 3]
        },
        "flag-er": {
          a: "Eritrea Flag",
          b: "1F1EA-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 49]
        },
        black_right_pointing_double_triangle_with_vertical_bar: {
          a: "Black Right Pointing Double Triangle with Vertical Bar",
          b: "23ED-FE0F",
          c: "23ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 49]
        },
        chocolate_bar: {
          a: "Chocolate Bar",
          b: "1F36B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "snack", "dessert", "sweet"],
          k: [7, 45]
        },
        oncoming_bus: {
          a: "Oncoming Bus",
          b: "1F68D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "transportation"],
          k: [34, 21]
        },
        shell: {
          a: "Spiral Shell",
          b: "1F41A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "sea", "beach"],
          k: [13, 4]
        },
        face_with_cowboy_hat: {
          a: "Face with Cowboy Hat",
          b: "1F920",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 23],
          o: 9
        },
        moneybag: {
          a: "Money Bag",
          b: "1F4B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dollar", "payment", "coins", "sale"],
          k: [25, 27]
        },
        es: {
          a: "Spain Flag",
          b: "1F1EA-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["spain", "flag", "nation", "country", "banner"],
          k: [1, 50],
          n: ["flag-es"]
        },
        crab: {
          a: "Crab",
          b: "1F980",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "crustacean"],
          k: [42, 24],
          o: 8
        },
        yen: {
          a: "Banknote with Yen Sign",
          b: "1F4B4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "japanese", "dollar", "currency"],
          k: [25, 31]
        },
        "flag-et": {
          a: "Ethiopia Flag",
          b: "1F1EA-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [1, 51]
        },
        clown_face: {
          a: "Clown Face",
          b: "1F921",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face"],
          k: [38, 24],
          o: 9
        },
        black_right_pointing_triangle_with_double_vertical_bar: {
          a: "Black Right Pointing Triangle with Double Vertical Bar",
          b: "23EF-FE0F",
          c: "23EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 51]
        },
        trolleybus: {
          a: "Trolleybus",
          b: "1F68E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bart", "transportation", "vehicle"],
          k: [34, 22]
        },
        candy: {
          a: "Candy",
          b: "1F36C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["snack", "dessert", "sweet", "lolly"],
          k: [7, 46]
        },
        lying_face: {
          a: "Lying Face",
          b: "1F925",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "lie", "pinocchio"],
          k: [38, 28],
          o: 9
        },
        arrow_backward: {
          a: "Black Left-Pointing Triangle",
          b: "25C0-FE0F",
          c: "25C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "left", "direction"],
          k: [47, 11],
          o: 1
        },
        dollar: {
          a: "Banknote with Dollar Sign",
          b: "1F4B5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "bill", "currency"],
          k: [25, 32]
        },
        shrimp: {
          a: "Shrimp",
          b: "1F990",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "ocean", "nature", "seafood"],
          k: [42, 40],
          o: 9
        },
        minibus: {
          a: "Minibus",
          b: "1F690",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "car", "transportation"],
          k: [34, 24]
        },
        "flag-eu": {
          a: "European Union Flag",
          b: "1F1EA-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 0]
        },
        lollipop: {
          a: "Lollipop",
          b: "1F36D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "snack", "candy", "sweet"],
          k: [7, 47]
        },
        squid: {
          a: "Squid",
          b: "1F991",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "nature", "ocean", "sea"],
          k: [42, 41],
          o: 9
        },
        euro: {
          a: "Banknote with Euro Sign",
          b: "1F4B6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "dollar", "currency"],
          k: [25, 33]
        },
        "flag-fi": {
          a: "Finland Flag",
          b: "1F1EB-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 1]
        },
        ambulance: {
          a: "Ambulance",
          b: "1F691",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["health", "911", "hospital"],
          k: [34, 25]
        },
        custard: {
          a: "Custard",
          b: "1F36E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dessert", "food"],
          k: [7, 48]
        },
        shushing_face: {
          a: "Face with Finger Covering Closed Lips",
          b: "1F92B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 51],
          n: ["face_with_finger_covering_closed_lips"],
          o: 10
        },
        rewind: {
          a: "Black Left-Pointing Double Triangle",
          b: "23EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["play", "blue-square"],
          k: [46, 46]
        },
        black_left_pointing_double_triangle_with_vertical_bar: {
          a: "Black Left Pointing Double Triangle with Vertical Bar",
          b: "23EE-FE0F",
          c: "23EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 50]
        },
        face_with_hand_over_mouth: {
          a: "Smiling Face with Smiling Eyes and Hand Covering Mouth",
          b: "1F92D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 1],
          n: ["smiling_face_with_smiling_eyes_and_hand_covering_mouth"],
          o: 10
        },
        "flag-fj": {
          a: "Fiji Flag",
          b: "1F1EB-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 2]
        },
        honey_pot: {
          a: "Honey Pot",
          b: "1F36F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bees", "sweet", "kitchen"],
          k: [7, 49]
        },
        snail: {
          a: "Snail",
          b: "1F40C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["slow", "animal", "shell"],
          k: [12, 42]
        },
        pound: {
          a: "Banknote with Pound Sign",
          b: "1F4B7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["british", "sterling", "money", "sales", "bills", "uk", "england", "currency"],
          k: [25, 34]
        },
        fire_engine: {
          a: "Fire Engine",
          b: "1F692",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "cars", "vehicle"],
          k: [34, 26]
        },
        baby_bottle: {
          a: "Baby Bottle",
          b: "1F37C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["food", "container", "milk"],
          k: [8, 10]
        },
        "flag-fk": {
          a: "Falkland Islands Flag",
          b: "1F1EB-1F1F0",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 3]
        },
        butterfly: {
          a: "Butterfly",
          b: "1F98B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "insect", "nature", "caterpillar"],
          k: [42, 35],
          o: 9
        },
        money_with_wings: {
          a: "Money with Wings",
          b: "1F4B8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dollar", "bills", "payment", "sale"],
          k: [25, 35]
        },
        face_with_monocle: {
          a: "Face with Monocle",
          b: "1F9D0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 49],
          o: 10
        },
        police_car: {
          a: "Police Car",
          b: "1F693",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "cars", "transportation", "law", "legal", "enforcement"],
          k: [34, 27]
        },
        arrow_up_small: {
          a: "Up-Pointing Small Red Triangle",
          b: "1F53C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "triangle", "direction", "point", "forward", "top"],
          k: [28, 10]
        },
        "flag-fm": {
          a: "Micronesia Flag",
          b: "1F1EB-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 4]
        },
        glass_of_milk: {
          a: "Glass of Milk",
          b: "1F95B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 7],
          o: 9
        },
        credit_card: {
          a: "Credit Card",
          b: "1F4B3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "dollar", "bill", "payment", "shopping"],
          k: [25, 30]
        },
        oncoming_police_car: {
          a: "Oncoming Police Car",
          b: "1F694",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "law", "legal", "enforcement", "911"],
          k: [34, 28]
        },
        bug: {
          a: "Bug",
          b: "1F41B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "insect", "nature", "worm"],
          k: [13, 5]
        },
        nerd_face: {
          a: "Nerd Face",
          b: "1F913",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "nerdy", "geek", "dork"],
          k: [37, 27],
          o: 8
        },
        arrow_double_up: {
          a: "Black Up-Pointing Double Triangle",
          b: "23EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "top"],
          k: [46, 47]
        },
        chart: {
          a: "Chart with Upwards Trend and Yen Sign",
          b: "1F4B9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["green-square", "graph", "presentation", "stats"],
          k: [25, 36]
        },
        "flag-fo": {
          a: "Faroe Islands Flag",
          b: "1F1EB-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 5]
        },
        ant: {
          a: "Ant",
          b: "1F41C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "insect", "nature", "bug"],
          k: [13, 6]
        },
        arrow_down_small: {
          a: "Down-Pointing Small Red Triangle",
          b: "1F53D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "bottom"],
          k: [28, 11]
        },
        smiling_imp: {
          a: "Smiling Face with Horns",
          b: "1F608",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["devil", "horns"],
          k: [30, 32]
        },
        taxi: {
          a: "Taxi",
          b: "1F695",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["uber", "vehicle", "cars", "transportation"],
          k: [34, 29]
        },
        coffee: {
          a: "Hot Beverage",
          b: "2615",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beverage", "caffeine", "latte", "espresso"],
          k: [47, 24],
          o: 4
        },
        fr: {
          a: "France Flag",
          b: "1F1EB-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["banner", "flag", "nation", "france", "french", "country"],
          k: [2, 6],
          n: ["flag-fr"]
        },
        oncoming_taxi: {
          a: "Oncoming Taxi",
          b: "1F696",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "cars", "uber"],
          k: [34, 30]
        },
        arrow_double_down: {
          a: "Black Down-Pointing Double Triangle",
          b: "23EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "direction", "bottom"],
          k: [46, 48]
        },
        imp: {
          a: "Imp",
          b: "1F47F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["devil", "angry", "horns"],
          k: [22, 51]
        },
        currency_exchange: {
          a: "Currency Exchange",
          b: "1F4B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "dollar", "travel"],
          k: [25, 28]
        },
        tea: {
          a: "Teacup Without Handle",
          b: "1F375",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["drink", "bowl", "breakfast", "green", "british"],
          k: [8, 3]
        },
        bee: {
          a: "Honeybee",
          b: "1F41D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [13, 7],
          n: ["honeybee"]
        },
        heavy_dollar_sign: {
          a: "Heavy Dollar Sign",
          b: "1F4B2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["money", "sales", "payment", "currency", "buck"],
          k: [25, 29]
        },
        car: {
          a: "Automobile",
          b: "1F697",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [34, 31],
          n: ["red_car"]
        },
        sake: {
          a: "Sake Bottle and Cup",
          b: "1F376",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wine", "drink", "drunk", "beverage", "japanese", "alcohol", "booze"],
          k: [8, 4]
        },
        "flag-ga": {
          a: "Gabon Flag",
          b: "1F1EC-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 7]
        },
        beetle: {
          a: "Lady Beetle",
          b: "1F41E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "insect", "nature", "ladybug"],
          k: [13, 8]
        },
        japanese_ogre: {
          a: "Japanese Ogre",
          b: "1F479",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["monster", "red", "mask", "halloween", "scary", "creepy", "devil", "demon", "japanese", "ogre"],
          k: [22, 40]
        },
        double_vertical_bar: {
          a: "Double Vertical Bar",
          b: "23F8-FE0F",
          c: "23F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 4],
          o: 7
        },
        champagne: {
          a: "Bottle with Popping Cork",
          b: "1F37E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["drink", "wine", "bottle", "celebration"],
          k: [8, 12],
          o: 8
        },
        japanese_goblin: {
          a: "Japanese Goblin",
          b: "1F47A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["red", "evil", "mask", "monster", "scary", "creepy", "japanese", "goblin"],
          k: [22, 41]
        },
        black_square_for_stop: {
          a: "Black Square for Stop",
          b: "23F9-FE0F",
          c: "23F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 5],
          o: 7
        },
        oncoming_automobile: {
          a: "Oncoming Automobile",
          b: "1F698",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["car", "vehicle", "transportation"],
          k: [34, 32]
        },
        email: {
          a: "Envelope",
          b: "2709-FE0F",
          c: "2709",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["letter", "postal", "inbox", "communication"],
          k: [49, 17],
          n: ["envelope"],
          o: 1
        },
        cricket: {
          a: "Cricket",
          b: "1F997",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports"],
          k: [42, 47],
          o: 10
        },
        gb: {
          a: "United Kingdom Flag",
          b: "1F1EC-1F1E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 8],
          n: ["uk", "flag-gb"]
        },
        black_circle_for_record: {
          a: "Black Circle for Record",
          b: "23FA-FE0F",
          c: "23FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 6],
          o: 7
        },
        "flag-gd": {
          a: "Grenada Flag",
          b: "1F1EC-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 9]
        },
        spider: {
          a: "Spider",
          b: "1F577-FE0F",
          c: "1F577",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "arachnid"],
          k: [29, 18],
          o: 7
        },
        blue_car: {
          a: "Recreational Vehicle",
          b: "1F699",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle"],
          k: [34, 33]
        },
        skull: {
          a: "Skull",
          b: "1F480",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dead", "skeleton", "creepy", "death"],
          k: [23, 0]
        },
        "e-mail": {
          a: "E-Mail Symbol",
          b: "1F4E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["communication", "inbox"],
          k: [26, 30]
        },
        wine_glass: {
          a: "Wine Glass",
          b: "1F377",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["drink", "beverage", "drunk", "alcohol", "booze"],
          k: [8, 5]
        },
        spider_web: {
          a: "Spider Web",
          b: "1F578-FE0F",
          c: "1F578",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "insect", "arachnid", "silk"],
          k: [29, 19],
          o: 7
        },
        cocktail: {
          a: "Cocktail Glass",
          b: "1F378",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["drink", "drunk", "alcohol", "beverage", "booze", "mojito"],
          k: [8, 6]
        },
        skull_and_crossbones: {
          a: "Skull and Crossbones",
          b: "2620-FE0F",
          c: "2620",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["poison", "danger", "deadly", "scary", "death", "pirate", "evil"],
          k: [47, 32],
          o: 1
        },
        "flag-ge": {
          a: "Georgia Flag",
          b: "1F1EC-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 10]
        },
        eject: {
          a: "Eject",
          b: "23CF-FE0F",
          c: "23CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 44],
          o: 4
        },
        truck: {
          a: "Delivery Truck",
          b: "1F69A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cars", "transportation"],
          k: [34, 34]
        },
        incoming_envelope: {
          a: "Incoming Envelope",
          b: "1F4E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "inbox"],
          k: [26, 31]
        },
        tropical_drink: {
          a: "Tropical Drink",
          b: "1F379",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beverage", "cocktail", "summer", "beach", "alcohol", "booze", "mojito"],
          k: [8, 7]
        },
        scorpion: {
          a: "Scorpion",
          b: "1F982",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["animal", "arachnid"],
          k: [42, 26],
          o: 8
        },
        cinema: {
          a: "Cinema",
          b: "1F3A6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "record", "film", "movie", "curtain", "stage", "theater"],
          k: [9, 0]
        },
        articulated_lorry: {
          a: "Articulated Lorry",
          b: "1F69B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "cars", "transportation", "express"],
          k: [34, 35]
        },
        envelope_with_arrow: {
          a: "Envelope with Downwards Arrow Above",
          b: "1F4E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "communication"],
          k: [26, 32]
        },
        ghost: {
          a: "Ghost",
          b: "1F47B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["halloween", "spooky", "scary"],
          k: [22, 42]
        },
        "flag-gf": {
          a: "French Guiana Flag",
          b: "1F1EC-1F1EB",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 11]
        },
        bouquet: {
          a: "Bouquet",
          b: "1F490",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["flowers", "nature", "spring"],
          k: [24, 42]
        },
        tractor: {
          a: "Tractor",
          b: "1F69C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "car", "farming", "agriculture"],
          k: [34, 36]
        },
        beer: {
          a: "Beer Mug",
          b: "1F37A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"],
          k: [8, 8]
        },
        outbox_tray: {
          a: "Outbox Tray",
          b: "1F4E4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["inbox", "email"],
          k: [26, 27]
        },
        low_brightness: {
          a: "Low Brightness Symbol",
          b: "1F505",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sun", "afternoon", "warm", "summer"],
          k: [27, 7]
        },
        alien: {
          a: "Extraterrestrial Alien",
          b: "1F47D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["UFO", "paul", "weird", "outer_space"],
          k: [22, 49]
        },
        "flag-gg": {
          a: "Guernsey Flag",
          b: "1F1EC-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 12]
        },
        cherry_blossom: {
          a: "Cherry Blossom",
          b: "1F338",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "spring", "flower"],
          k: [6, 46]
        },
        inbox_tray: {
          a: "Inbox Tray",
          b: "1F4E5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "documents"],
          k: [26, 28]
        },
        "flag-gh": {
          a: "Ghana Flag",
          b: "1F1EC-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 13]
        },
        bike: {
          a: "Bicycle",
          b: "1F6B2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "bicycle", "exercise", "hipster"],
          k: [35, 23]
        },
        space_invader: {
          a: "Alien Monster",
          b: "1F47E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["game", "arcade", "play"],
          k: [22, 50]
        },
        beers: {
          a: "Clinking Beer Mugs",
          b: "1F37B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"],
          k: [8, 9]
        },
        high_brightness: {
          a: "High Brightness Symbol",
          b: "1F506",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sun", "light"],
          k: [27, 8]
        },
        package: {
          a: "Package",
          b: "1F4E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mail", "gift", "cardboard", "box", "moving"],
          k: [26, 29]
        },
        scooter: {
          a: "Scooter",
          b: "1F6F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 19],
          o: 9
        },
        white_flower: {
          a: "White Flower",
          b: "1F4AE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "spring"],
          k: [25, 25]
        },
        clinking_glasses: {
          a: "Clinking Glasses",
          b: "1F942",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["beverage", "drink", "party", "alcohol", "celebrate", "cheers"],
          k: [41, 38],
          o: 9
        },
        robot_face: {
          a: "Robot Face",
          b: "1F916",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 30],
          o: 8
        },
        signal_strength: {
          a: "Antenna with Bars",
          b: "1F4F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "reception", "phone", "internet", "connection", "wifi", "bluetooth", "bars"],
          k: [26, 45]
        },
        "flag-gi": {
          a: "Gibraltar Flag",
          b: "1F1EC-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 14]
        },
        "flag-gl": {
          a: "Greenland Flag",
          b: "1F1EC-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 15]
        },
        motor_scooter: {
          a: "Motor Scooter",
          b: "1F6F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vehicle", "vespa", "sasha"],
          k: [37, 20],
          o: 9
        },
        mailbox: {
          a: "Closed Mailbox with Raised Flag",
          b: "1F4EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "inbox", "communication"],
          k: [26, 34]
        },
        vibration_mode: {
          a: "Vibration Mode",
          b: "1F4F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["orange-square", "phone"],
          k: [26, 42]
        },
        hankey: {
          a: "Pile of Poo",
          b: "1F4A9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [25, 15],
          n: ["poop", "shit"]
        },
        rosette: {
          a: "Rosette",
          b: "1F3F5-FE0F",
          c: "1F3F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["flower", "decoration", "military"],
          k: [12, 20],
          o: 7
        },
        tumbler_glass: {
          a: "Tumbler Glass",
          b: "1F943",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["drink", "beverage", "drunk", "alcohol", "liquor", "booze", "bourbon", "scotch", "whisky", "glass", "shot"],
          k: [41, 39],
          o: 9
        },
        cup_with_straw: {
          a: "Cup with Straw",
          b: "1F964",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 16],
          o: 10
        },
        "flag-gm": {
          a: "Gambia Flag",
          b: "1F1EC-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 16]
        },
        mailbox_closed: {
          a: "Closed Mailbox with Lowered Flag",
          b: "1F4EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "communication", "inbox"],
          k: [26, 33]
        },
        mobile_phone_off: {
          a: "Mobile Phone off",
          b: "1F4F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mute", "orange-square", "silence", "quiet"],
          k: [26, 43]
        },
        busstop: {
          a: "Bus Stop",
          b: "1F68F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "wait"],
          k: [34, 23]
        },
        smiley_cat: {
          a: "Smiling Cat Face with Open Mouth",
          b: "1F63A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "happy", "smile"],
          k: [31, 30]
        },
        rose: {
          a: "Rose",
          b: "1F339",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["flowers", "valentines", "love", "spring"],
          k: [6, 47]
        },
        motorway: {
          a: "Motorway",
          b: "1F6E3-FE0F",
          c: "1F6E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["road", "cupertino", "interstate", "highway"],
          k: [37, 11],
          o: 7
        },
        smile_cat: {
          a: "Grinning Cat Face with Smiling Eyes",
          b: "1F638",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "smile"],
          k: [31, 28]
        },
        "flag-gn": {
          a: "Guinea Flag",
          b: "1F1EC-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 17]
        },
        wilted_flower: {
          a: "Wilted Flower",
          b: "1F940",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["plant", "nature", "flower"],
          k: [41, 36],
          o: 9
        },
        mailbox_with_mail: {
          a: "Open Mailbox with Raised Flag",
          b: "1F4EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "inbox", "communication"],
          k: [26, 35]
        },
        chopsticks: {
          a: "Chopsticks",
          b: "1F962",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 14],
          o: 10
        },
        female_sign: {
          a: "Female Sign",
          b: "2640-FE0F",
          c: "2640",
          d: !1,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 42],
          o: 1
        },
        mailbox_with_no_mail: {
          a: "Open Mailbox with Lowered Flag",
          b: "1F4ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "inbox"],
          k: [26, 36]
        },
        knife_fork_plate: {
          a: "Knife Fork Plate",
          b: "1F37D-FE0F",
          c: "1F37D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [8, 11],
          o: 7
        },
        hibiscus: {
          a: "Hibiscus",
          b: "1F33A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "vegetable", "flowers", "beach"],
          k: [6, 48]
        },
        "flag-gp": {
          a: "Guadeloupe Flag",
          b: "1F1EC-1F1F5",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 18]
        },
        railway_track: {
          a: "Railway Track",
          b: "1F6E4-FE0F",
          c: "1F6E4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["train", "transportation"],
          k: [37, 12],
          o: 7
        },
        male_sign: {
          a: "Male Sign",
          b: "2642-FE0F",
          c: "2642",
          d: !1,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [47, 43],
          o: 1
        },
        joy_cat: {
          a: "Cat Face with Tears of Joy",
          b: "1F639",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "haha", "happy", "tears"],
          k: [31, 29]
        },
        fuelpump: {
          a: "Fuel Pump",
          b: "26FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["gas station", "petroleum"],
          k: [49, 13],
          o: 5
        },
        sunflower: {
          a: "Sunflower",
          b: "1F33B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "fall"],
          k: [6, 49]
        },
        postbox: {
          a: "Postbox",
          b: "1F4EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "letter", "envelope"],
          k: [26, 37]
        },
        "flag-gq": {
          a: "Equatorial Guinea Flag",
          b: "1F1EC-1F1F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 19]
        },
        heart_eyes_cat: {
          a: "Smiling Cat Face with Heart-Shaped Eyes",
          b: "1F63B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "love", "like", "affection", "cats", "valentines", "heart"],
          k: [31, 31]
        },
        fork_and_knife: {
          a: "Fork and Knife",
          b: "1F374",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cutlery", "kitchen"],
          k: [8, 2]
        },
        medical_symbol: {
          a: "Medical Symbol",
          b: "2695-FE0F",
          c: "2695",
          d: !1,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 14],
          n: ["staff_of_aesculapius"],
          o: 4
        },
        recycle: {
          a: "Black Universal Recycling Symbol",
          b: "267B-FE0F",
          c: "267B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arrow", "environment", "garbage", "trash"],
          k: [48, 9],
          o: 3
        },
        spoon: {
          a: "Spoon",
          b: "1F944",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["cutlery", "kitchen", "tableware"],
          k: [41, 40],
          o: 9
        },
        blossom: {
          a: "Blossom",
          b: "1F33C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "flowers", "yellow"],
          k: [6, 50]
        },
        rotating_light: {
          a: "Police Cars Revolving Light",
          b: "1F6A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["police", "ambulance", "911", "emergency", "alert", "error", "pinged", "law", "legal"],
          k: [35, 13]
        },
        smirk_cat: {
          a: "Cat Face with Wry Smile",
          b: "1F63C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "smirk"],
          k: [31, 32]
        },
        ballot_box_with_ballot: {
          a: "Ballot Box with Ballot",
          b: "1F5F3-FE0F",
          c: "1F5F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 17],
          o: 7
        },
        "flag-gr": {
          a: "Greece Flag",
          b: "1F1EC-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 20]
        },
        kissing_cat: {
          a: "Kissing Cat Face with Closed Eyes",
          b: "1F63D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "kiss"],
          k: [31, 33]
        },
        pencil2: {
          a: "Pencil",
          b: "270F-FE0F",
          c: "270F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "write", "paper", "writing", "school", "study"],
          k: [49, 42],
          o: 1
        },
        traffic_light: {
          a: "Horizontal Traffic Light",
          b: "1F6A5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "signal"],
          k: [35, 10]
        },
        fleur_de_lis: {
          a: "Fleur De Lis",
          b: "269C-FE0F",
          c: "269C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["decorative", "scout"],
          k: [48, 19],
          o: 4
        },
        tulip: {
          a: "Tulip",
          b: "1F337",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["flowers", "plant", "nature", "summer", "spring"],
          k: [6, 45]
        },
        hocho: {
          a: "Hocho",
          b: "1F52A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["knife", "blade", "cutlery", "kitchen", "weapon"],
          k: [27, 44],
          n: ["knife"]
        },
        "flag-gs": {
          a: "South Georgia & South Sandwich Islands Flag",
          b: "1F1EC-1F1F8",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 21]
        },
        seedling: {
          a: "Seedling",
          b: "1F331",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature", "grass", "lawn", "spring"],
          k: [6, 39]
        },
        amphora: {
          a: "Amphora",
          b: "1F3FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vase", "jar"],
          k: [12, 24],
          o: 8
        },
        scream_cat: {
          a: "Weary Cat Face",
          b: "1F640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats", "munch", "scared", "scream"],
          k: [31, 36]
        },
        vertical_traffic_light: {
          a: "Vertical Traffic Light",
          b: "1F6A6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "driving"],
          k: [35, 11]
        },
        black_nib: {
          a: "Black Nib",
          b: "2712-FE0F",
          c: "2712",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pen", "stationery", "writing", "write"],
          k: [49, 43],
          o: 1
        },
        "flag-gt": {
          a: "Guatemala Flag",
          b: "1F1EC-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 22]
        },
        trident: {
          a: "Trident Emblem",
          b: "1F531",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weapon", "spear"],
          k: [27, 51]
        },
        "flag-gu": {
          a: "Guam Flag",
          b: "1F1EC-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 23]
        },
        name_badge: {
          a: "Name Badge",
          b: "1F4DB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fire", "forbid"],
          k: [26, 18]
        },
        construction: {
          a: "Construction Sign",
          b: "1F6A7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wip", "progress", "caution", "warning"],
          k: [35, 12]
        },
        lower_left_fountain_pen: {
          a: "Lower Left Fountain Pen",
          b: "1F58B-FE0F",
          c: "1F58B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 29],
          o: 7
        },
        evergreen_tree: {
          a: "Evergreen Tree",
          b: "1F332",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature"],
          k: [6, 40]
        },
        crying_cat_face: {
          a: "Crying Cat Face",
          b: "1F63F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "tears", "weep", "sad", "cats", "upset", "cry"],
          k: [31, 35]
        },
        "flag-gw": {
          a: "Guinea-Bissau Flag",
          b: "1F1EC-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 24]
        },
        lower_left_ballpoint_pen: {
          a: "Lower Left Ballpoint Pen",
          b: "1F58A-FE0F",
          c: "1F58A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 28],
          o: 7
        },
        pouting_cat: {
          a: "Pouting Cat Face",
          b: "1F63E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "cats"],
          k: [31, 34]
        },
        deciduous_tree: {
          a: "Deciduous Tree",
          b: "1F333",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "nature"],
          k: [6, 41]
        },
        octagonal_sign: {
          a: "Octagonal Sign",
          b: "1F6D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 6],
          o: 9
        },
        beginner: {
          a: "Japanese Symbol for Beginner",
          b: "1F530",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["badge", "shield"],
          k: [27, 50]
        },
        "flag-gy": {
          a: "Guyana Flag",
          b: "1F1EC-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 25]
        },
        lower_left_paintbrush: {
          a: "Lower Left Paintbrush",
          b: "1F58C-FE0F",
          c: "1F58C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 30],
          o: 7
        },
        o: {
          a: "Heavy Large Circle",
          b: "2B55",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["circle", "round"],
          k: [50, 23],
          o: 5
        },
        palm_tree: {
          a: "Palm Tree",
          b: "1F334",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["plant", "vegetable", "nature", "summer", "beach", "mojito", "tropical"],
          k: [6, 42]
        },
        anchor: {
          a: "Anchor",
          b: "2693",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ship", "ferry", "sea", "boat"],
          k: [48, 12],
          o: 4
        },
        see_no_evil: {
          a: "See-No-Evil Monkey",
          b: "1F648",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["monkey", "animal", "nature", "haha"],
          k: [32, 43]
        },
        boat: {
          a: "Sailboat",
          b: "26F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [48, 43],
          n: ["sailboat"],
          o: 5
        },
        white_check_mark: {
          a: "White Heavy Check Mark",
          b: "2705",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["green-square", "ok", "agree", "vote", "election", "answer", "tick"],
          k: [49, 15]
        },
        "flag-hk": {
          a: "Hong Kong Sar China Flag",
          b: "1F1ED-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 26]
        },
        lower_left_crayon: {
          a: "Lower Left Crayon",
          b: "1F58D-FE0F",
          c: "1F58D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 31],
          o: 7
        },
        hear_no_evil: {
          a: "Hear-No-Evil Monkey",
          b: "1F649",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "monkey", "nature"],
          k: [32, 44]
        },
        cactus: {
          a: "Cactus",
          b: "1F335",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vegetable", "plant", "nature"],
          k: [6, 43]
        },
        ear_of_rice: {
          a: "Ear of Rice",
          b: "1F33E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant"],
          k: [7, 0]
        },
        speak_no_evil: {
          a: "Speak-No-Evil Monkey",
          b: "1F64A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["monkey", "animal", "nature", "omg"],
          k: [32, 45]
        },
        "flag-hm": {
          a: "Heard & Mcdonald Islands Flag",
          b: "1F1ED-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 27]
        },
        ballot_box_with_check: {
          a: "Ballot Box with Check",
          b: "2611-FE0F",
          c: "2611",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ok", "agree", "confirm", "black-square", "vote", "election", "yes", "tick"],
          k: [47, 22],
          o: 1
        },
        canoe: {
          a: "Canoe",
          b: "1F6F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["boat", "paddle", "water", "ship"],
          k: [37, 21],
          o: 9
        },
        memo: {
          a: "Memo",
          b: "1F4DD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["write", "documents", "stationery", "pencil", "paper", "writing", "legal", "exam", "quiz", "test", "study", "compose"],
          k: [26, 20],
          n: ["pencil"]
        },
        herb: {
          a: "Herb",
          b: "1F33F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vegetable", "plant", "medicine", "weed", "grass", "lawn"],
          k: [7, 1]
        },
        "flag-hn": {
          a: "Honduras Flag",
          b: "1F1ED-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 28]
        },
        heavy_check_mark: {
          a: "Heavy Check Mark",
          b: "2714-FE0F",
          c: "2714",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ok", "nike", "answer", "yes", "tick"],
          k: [49, 44],
          o: 1
        },
        briefcase: {
          a: "Briefcase",
          b: "1F4BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["business", "documents", "work", "law", "legal", "job", "career"],
          k: [25, 39]
        },
        speedboat: {
          a: "Speedboat",
          b: "1F6A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ship", "transportation", "vehicle", "summer"],
          k: [35, 9]
        },
        baby: {
          skin_variations: {
            "1F3FB": {
              unified: "1F476-1F3FB",
              non_qualified: null,
              image: "1f476-1f3fb.png",
              sheet_x: 22,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F476-1F3FC",
              non_qualified: null,
              image: "1f476-1f3fc.png",
              sheet_x: 22,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F476-1F3FD",
              non_qualified: null,
              image: "1f476-1f3fd.png",
              sheet_x: 22,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F476-1F3FE",
              non_qualified: null,
              image: "1f476-1f3fe.png",
              sheet_x: 22,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F476-1F3FF",
              non_qualified: null,
              image: "1f476-1f3ff.png",
              sheet_x: 22,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Baby",
          b: "1F476",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["child", "boy", "girl", "toddler"],
          k: [22, 10]
        },
        heavy_multiplication_x: {
          a: "Heavy Multiplication X",
          b: "2716-FE0F",
          c: "2716",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["math", "calculation"],
          k: [49, 45],
          o: 1
        },
        child: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D2-1F3FB",
              non_qualified: null,
              image: "1f9d2-1f3fb.png",
              sheet_x: 43,
              sheet_y: 5,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D2-1F3FC",
              non_qualified: null,
              image: "1f9d2-1f3fc.png",
              sheet_x: 43,
              sheet_y: 6,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D2-1F3FD",
              non_qualified: null,
              image: "1f9d2-1f3fd.png",
              sheet_x: 43,
              sheet_y: 7,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D2-1F3FE",
              non_qualified: null,
              image: "1f9d2-1f3fe.png",
              sheet_x: 43,
              sheet_y: 8,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D2-1F3FF",
              non_qualified: null,
              image: "1f9d2-1f3ff.png",
              sheet_x: 43,
              sheet_y: 9,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Child",
          b: "1F9D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 4],
          o: 10
        },
        shamrock: {
          a: "Shamrock",
          b: "2618-FE0F",
          c: "2618",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vegetable", "plant", "nature", "irish", "clover"],
          k: [47, 25],
          o: 4
        },
        passenger_ship: {
          a: "Passenger Ship",
          b: "1F6F3-FE0F",
          c: "1F6F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["yacht", "cruise", "ferry"],
          k: [37, 18],
          o: 7
        },
        "flag-hr": {
          a: "Croatia Flag",
          b: "1F1ED-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 29]
        },
        file_folder: {
          a: "File Folder",
          b: "1F4C1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "business", "office"],
          k: [25, 44]
        },
        x: {
          a: "Cross Mark",
          b: "274C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["no", "delete", "remove", "cancel"],
          k: [50, 1]
        },
        four_leaf_clover: {
          a: "Four Leaf Clover",
          b: "1F340",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vegetable", "plant", "nature", "lucky", "irish"],
          k: [7, 2]
        },
        open_file_folder: {
          a: "Open File Folder",
          b: "1F4C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "load"],
          k: [25, 45]
        },
        boy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F466-1F3FB",
              non_qualified: null,
              image: "1f466-1f3fb.png",
              sheet_x: 15,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F466-1F3FC",
              non_qualified: null,
              image: "1f466-1f3fc.png",
              sheet_x: 15,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F466-1F3FD",
              non_qualified: null,
              image: "1f466-1f3fd.png",
              sheet_x: 15,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F466-1F3FE",
              non_qualified: null,
              image: "1f466-1f3fe.png",
              sheet_x: 15,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F466-1F3FF",
              non_qualified: null,
              image: "1f466-1f3ff.png",
              sheet_x: 15,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Boy",
          b: "1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["man", "male", "guy", "teenager"],
          k: [15, 42]
        },
        ferry: {
          a: "Ferry",
          b: "26F4-FE0F",
          c: "26F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["boat", "ship", "yacht"],
          k: [48, 42],
          o: 5
        },
        "flag-ht": {
          a: "Haiti Flag",
          b: "1F1ED-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 30]
        },
        girl: {
          skin_variations: {
            "1F3FB": {
              unified: "1F467-1F3FB",
              non_qualified: null,
              image: "1f467-1f3fb.png",
              sheet_x: 15,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F467-1F3FC",
              non_qualified: null,
              image: "1f467-1f3fc.png",
              sheet_x: 15,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F467-1F3FD",
              non_qualified: null,
              image: "1f467-1f3fd.png",
              sheet_x: 15,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F467-1F3FE",
              non_qualified: null,
              image: "1f467-1f3fe.png",
              sheet_x: 16,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F467-1F3FF",
              non_qualified: null,
              image: "1f467-1f3ff.png",
              sheet_x: 16,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Girl",
          b: "1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["female", "woman", "teenager"],
          k: [15, 48]
        },
        negative_squared_cross_mark: {
          a: "Negative Squared Cross Mark",
          b: "274E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["x", "green-square", "no", "deny"],
          k: [50, 2]
        },
        "flag-hu": {
          a: "Hungary Flag",
          b: "1F1ED-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 31]
        },
        card_index_dividers: {
          a: "Card Index Dividers",
          b: "1F5C2-FE0F",
          c: "1F5C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["organizing", "business", "stationery"],
          k: [30, 4],
          o: 7
        },
        maple_leaf: {
          a: "Maple Leaf",
          b: "1F341",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "vegetable", "ca", "fall"],
          k: [7, 3]
        },
        motor_boat: {
          a: "Motor Boat",
          b: "1F6E5-FE0F",
          c: "1F6E5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["ship"],
          k: [37, 13],
          o: 7
        },
        "flag-ic": {
          a: "Canary Islands Flag",
          b: "1F1EE-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 32]
        },
        fallen_leaf: {
          a: "Fallen Leaf",
          b: "1F342",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "vegetable", "leaves"],
          k: [7, 4]
        },
        adult: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D1-1F3FB",
              non_qualified: null,
              image: "1f9d1-1f3fb.png",
              sheet_x: 42,
              sheet_y: 51,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D1-1F3FC",
              non_qualified: null,
              image: "1f9d1-1f3fc.png",
              sheet_x: 43,
              sheet_y: 0,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D1-1F3FD",
              non_qualified: null,
              image: "1f9d1-1f3fd.png",
              sheet_x: 43,
              sheet_y: 1,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D1-1F3FE",
              non_qualified: null,
              image: "1f9d1-1f3fe.png",
              sheet_x: 43,
              sheet_y: 2,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D1-1F3FF",
              non_qualified: null,
              image: "1f9d1-1f3ff.png",
              sheet_x: 43,
              sheet_y: 3,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Adult",
          b: "1F9D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [42, 50],
          o: 10
        },
        ship: {
          a: "Ship",
          b: "1F6A2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "titanic", "deploy"],
          k: [34, 42]
        },
        heavy_plus_sign: {
          a: "Heavy Plus Sign",
          b: "2795",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["math", "calculation", "addition", "more", "increase"],
          k: [50, 9]
        },
        date: {
          a: "Calendar",
          b: "1F4C5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["calendar", "schedule"],
          k: [25, 48]
        },
        man: {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB",
              non_qualified: null,
              image: "1f468-1f3fb.png",
              sheet_x: 18,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F468-1F3FC",
              non_qualified: null,
              image: "1f468-1f3fc.png",
              sheet_x: 18,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F468-1F3FD",
              non_qualified: null,
              image: "1f468-1f3fd.png",
              sheet_x: 18,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F468-1F3FE",
              non_qualified: null,
              image: "1f468-1f3fe.png",
              sheet_x: 18,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F468-1F3FF",
              non_qualified: null,
              image: "1f468-1f3ff.png",
              sheet_x: 18,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Man",
          b: "1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mustache", "father", "dad", "guy", "classy", "sir", "moustache"],
          k: [18, 11]
        },
        "flag-id": {
          a: "Indonesia Flag",
          b: "1F1EE-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 33]
        },
        leaves: {
          a: "Leaf Fluttering in Wind",
          b: "1F343",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "plant", "tree", "vegetable", "grass", "lawn", "spring"],
          k: [7, 5]
        },
        heavy_minus_sign: {
          a: "Heavy Minus Sign",
          b: "2796",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["math", "calculation", "subtract", "less"],
          k: [50, 10]
        },
        calendar: {
          a: "Tear-off Calendar",
          b: "1F4C6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["schedule", "date", "planning"],
          k: [25, 49]
        },
        airplane: {
          a: "Airplane",
          b: "2708-FE0F",
          c: "2708",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "transportation", "flight", "fly"],
          k: [49, 16],
          o: 1
        },
        spiral_note_pad: {
          a: "Spiral Note Pad",
          b: "1F5D2-FE0F",
          c: "1F5D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 8],
          o: 7
        },
        heavy_division_sign: {
          a: "Heavy Division Sign",
          b: "2797",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["divide", "math", "calculation"],
          k: [50, 11]
        },
        small_airplane: {
          a: "Small Airplane",
          b: "1F6E9-FE0F",
          c: "1F6E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["flight", "transportation", "fly", "vehicle"],
          k: [37, 14],
          o: 7
        },
        woman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB",
              non_qualified: null,
              image: "1f469-1f3fb.png",
              sheet_x: 20,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F469-1F3FC",
              non_qualified: null,
              image: "1f469-1f3fc.png",
              sheet_x: 20,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F469-1F3FD",
              non_qualified: null,
              image: "1f469-1f3fd.png",
              sheet_x: 20,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F469-1F3FE",
              non_qualified: null,
              image: "1f469-1f3fe.png",
              sheet_x: 20,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F469-1F3FF",
              non_qualified: null,
              image: "1f469-1f3ff.png",
              sheet_x: 20,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Woman",
          b: "1F469",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["female", "girls", "lady"],
          k: [20, 23]
        },
        "flag-ie": {
          a: "Ireland Flag",
          b: "1F1EE-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 34]
        },
        curly_loop: {
          a: "Curly Loop",
          b: "27B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["scribble", "draw", "shape", "squiggle"],
          k: [50, 13]
        },
        "flag-il": {
          a: "Israel Flag",
          b: "1F1EE-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 35]
        },
        airplane_departure: {
          a: "Airplane Departure",
          b: "1F6EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 15],
          o: 7
        },
        spiral_calendar_pad: {
          a: "Spiral Calendar Pad",
          b: "1F5D3-FE0F",
          c: "1F5D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 9],
          o: 7
        },
        older_adult: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D3-1F3FB",
              non_qualified: null,
              image: "1f9d3-1f3fb.png",
              sheet_x: 43,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D3-1F3FC",
              non_qualified: null,
              image: "1f9d3-1f3fc.png",
              sheet_x: 43,
              sheet_y: 12,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D3-1F3FD",
              non_qualified: null,
              image: "1f9d3-1f3fd.png",
              sheet_x: 43,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D3-1F3FE",
              non_qualified: null,
              image: "1f9d3-1f3fe.png",
              sheet_x: 43,
              sheet_y: 14,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D3-1F3FF",
              non_qualified: null,
              image: "1f9d3-1f3ff.png",
              sheet_x: 43,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Older Adult",
          b: "1F9D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 10],
          o: 10
        },
        airplane_arriving: {
          a: "Airplane Arriving",
          b: "1F6EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 16],
          o: 7
        },
        card_index: {
          a: "Card Index",
          b: "1F4C7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["business", "stationery"],
          k: [25, 50]
        },
        loop: {
          a: "Double Curly Loop",
          b: "27BF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["tape", "cassette"],
          k: [50, 14]
        },
        older_man: {
          skin_variations: {
            "1F3FB": {
              unified: "1F474-1F3FB",
              non_qualified: null,
              image: "1f474-1f3fb.png",
              sheet_x: 21,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F474-1F3FC",
              non_qualified: null,
              image: "1f474-1f3fc.png",
              sheet_x: 22,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F474-1F3FD",
              non_qualified: null,
              image: "1f474-1f3fd.png",
              sheet_x: 22,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F474-1F3FE",
              non_qualified: null,
              image: "1f474-1f3fe.png",
              sheet_x: 22,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F474-1F3FF",
              non_qualified: null,
              image: "1f474-1f3ff.png",
              sheet_x: 22,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Older Man",
          b: "1F474",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["human", "male", "men", "old", "elder", "senior"],
          k: [21, 50]
        },
        "flag-im": {
          a: "Isle of Man Flag",
          b: "1F1EE-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 36]
        },
        "flag-in": {
          a: "India Flag",
          b: "1F1EE-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 37]
        },
        chart_with_upwards_trend: {
          a: "Chart with Upwards Trend",
          b: "1F4C8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["graph", "presentation", "stats", "recovery", "business", "economics", "money", "sales", "good", "success"],
          k: [25, 51]
        },
        part_alternation_mark: {
          a: "Part Alternation Mark",
          b: "303D-FE0F",
          c: "303D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["graph", "presentation", "stats", "business", "economics", "bad"],
          k: [50, 25],
          o: 3
        },
        seat: {
          a: "Seat",
          b: "1F4BA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sit", "airplane", "transport", "bus", "flight", "fly"],
          k: [25, 37]
        },
        older_woman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F475-1F3FB",
              non_qualified: null,
              image: "1f475-1f3fb.png",
              sheet_x: 22,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F475-1F3FC",
              non_qualified: null,
              image: "1f475-1f3fc.png",
              sheet_x: 22,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F475-1F3FD",
              non_qualified: null,
              image: "1f475-1f3fd.png",
              sheet_x: 22,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F475-1F3FE",
              non_qualified: null,
              image: "1f475-1f3fe.png",
              sheet_x: 22,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F475-1F3FF",
              non_qualified: null,
              image: "1f475-1f3ff.png",
              sheet_x: 22,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Older Woman",
          b: "1F475",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["human", "female", "women", "lady", "old", "elder", "senior"],
          k: [22, 4]
        },
        eight_spoked_asterisk: {
          a: "Eight Spoked Asterisk",
          b: "2733-FE0F",
          c: "2733",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["star", "sparkle", "green-square"],
          k: [49, 49],
          o: 1
        },
        chart_with_downwards_trend: {
          a: "Chart with Downwards Trend",
          b: "1F4C9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["graph", "presentation", "stats", "recession", "business", "economics", "money", "sales", "bad", "failure"],
          k: [26, 0]
        },
        "flag-io": {
          a: "British Indian Ocean Territory Flag",
          b: "1F1EE-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 38]
        },
        "male-doctor": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-2695-FE0F",
              non_qualified: "1F468-1F3FB-200D-2695",
              image: "1f468-1f3fb-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-2695-FE0F",
              non_qualified: "1F468-1F3FC-200D-2695",
              image: "1f468-1f3fc-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-2695-FE0F",
              non_qualified: "1F468-1F3FD-200D-2695",
              image: "1f468-1f3fd-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-2695-FE0F",
              non_qualified: "1F468-1F3FE-200D-2695",
              image: "1f468-1f3fe-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-2695-FE0F",
              non_qualified: "1F468-1F3FF-200D-2695",
              image: "1f468-1f3ff-200d-2695-fe0f.png",
              sheet_x: 17,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Doctor",
          b: "1F468-200D-2695-FE0F",
          c: "1F468-200D-2695",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 43]
        },
        helicopter: {
          a: "Helicopter",
          b: "1F681",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "fly"],
          k: [34, 9]
        },
        "female-doctor": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-2695-FE0F",
              non_qualified: "1F469-1F3FB-200D-2695",
              image: "1f469-1f3fb-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-2695-FE0F",
              non_qualified: "1F469-1F3FC-200D-2695",
              image: "1f469-1f3fc-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-2695-FE0F",
              non_qualified: "1F469-1F3FD-200D-2695",
              image: "1f469-1f3fd-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-2695-FE0F",
              non_qualified: "1F469-1F3FE-200D-2695",
              image: "1f469-1f3fe-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-2695-FE0F",
              non_qualified: "1F469-1F3FF-200D-2695",
              image: "1f469-1f3ff-200d-2695-fe0f.png",
              sheet_x: 20,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Doctor",
          b: "1F469-200D-2695-FE0F",
          c: "1F469-200D-2695",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 1]
        },
        suspension_railway: {
          a: "Suspension Railway",
          b: "1F69F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["vehicle", "transportation"],
          k: [34, 39]
        },
        bar_chart: {
          a: "Bar Chart",
          b: "1F4CA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["graph", "presentation", "stats"],
          k: [26, 1]
        },
        "flag-iq": {
          a: "Iraq Flag",
          b: "1F1EE-1F1F6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 39]
        },
        eight_pointed_black_star: {
          a: "Eight Pointed Black Star",
          b: "2734-FE0F",
          c: "2734",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["orange-square", "shape", "polygon"],
          k: [49, 50],
          o: 1
        },
        mountain_cableway: {
          a: "Mountain Cableway",
          b: "1F6A0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "ski"],
          k: [34, 40]
        },
        "male-student": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F393",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f393.png",
              sheet_x: 16,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Student",
          b: "1F468-200D-1F393",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 14]
        },
        clipboard: {
          a: "Clipboard",
          b: "1F4CB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "documents"],
          k: [26, 2]
        },
        "flag-ir": {
          a: "Iran Flag",
          b: "1F1EE-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 40]
        },
        sparkle: {
          a: "Sparkle",
          b: "2747-FE0F",
          c: "2747",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stars", "green-square", "awesome", "good", "fireworks"],
          k: [50, 0],
          o: 1
        },
        "female-student": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F393",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f393.png",
              sheet_x: 18,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Student",
          b: "1F469-200D-1F393",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 29]
        },
        pushpin: {
          a: "Pushpin",
          b: "1F4CC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "mark", "here"],
          k: [26, 3]
        },
        aerial_tramway: {
          a: "Aerial Tramway",
          b: "1F6A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["transportation", "vehicle", "ski"],
          k: [34, 41]
        },
        "flag-is": {
          a: "Iceland Flag",
          b: "1F1EE-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 41]
        },
        bangbang: {
          a: "Double Exclamation Mark",
          b: "203C-FE0F",
          c: "203C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["exclamation", "surprise"],
          k: [46, 29],
          o: 1
        },
        interrobang: {
          a: "Exclamation Question Mark",
          b: "2049-FE0F",
          c: "2049",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wat", "punctuation", "surprise"],
          k: [46, 30],
          o: 3
        },
        satellite: {
          a: "Satellite",
          b: "1F6F0-FE0F",
          c: "1F6F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["communication", "future", "radio", "space"],
          k: [37, 17],
          o: 7
        },
        it: {
          a: "Italy Flag",
          b: "1F1EE-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["italy", "flag", "nation", "country", "banner"],
          k: [2, 42],
          n: ["flag-it"]
        },
        "male-teacher": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F3EB",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f3eb.png",
              sheet_x: 16,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Teacher",
          b: "1F468-200D-1F3EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 32]
        },
        round_pushpin: {
          a: "Round Pushpin",
          b: "1F4CD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "location", "map", "here"],
          k: [26, 4]
        },
        "flag-je": {
          a: "Jersey Flag",
          b: "1F1EF-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 43]
        },
        question: {
          a: "Black Question Mark Ornament",
          b: "2753",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["doubt", "confused"],
          k: [50, 3]
        },
        rocket: {
          a: "Rocket",
          b: "1F680",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["launch", "ship", "staffmode", "NASA", "outer space", "outer_space", "fly"],
          k: [34, 8]
        },
        "female-teacher": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f3eb.png",
              sheet_x: 18,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f3eb.png",
              sheet_x: 18,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f3eb.png",
              sheet_x: 18,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f3eb.png",
              sheet_x: 18,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F3EB",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f3eb.png",
              sheet_x: 19,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Teacher",
          b: "1F469-200D-1F3EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 47]
        },
        paperclip: {
          a: "Paperclip",
          b: "1F4CE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["documents", "stationery"],
          k: [26, 5]
        },
        linked_paperclips: {
          a: "Linked Paperclips",
          b: "1F587-FE0F",
          c: "1F587",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 27],
          o: 7
        },
        flying_saucer: {
          a: "Flying Saucer",
          b: "1F6F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 23],
          o: 10
        },
        "male-judge": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-2696-FE0F",
              non_qualified: "1F468-1F3FB-200D-2696",
              image: "1f468-1f3fb-200d-2696-fe0f.png",
              sheet_x: 17,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-2696-FE0F",
              non_qualified: "1F468-1F3FC-200D-2696",
              image: "1f468-1f3fc-200d-2696-fe0f.png",
              sheet_x: 17,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-2696-FE0F",
              non_qualified: "1F468-1F3FD-200D-2696",
              image: "1f468-1f3fd-200d-2696-fe0f.png",
              sheet_x: 18,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-2696-FE0F",
              non_qualified: "1F468-1F3FE-200D-2696",
              image: "1f468-1f3fe-200d-2696-fe0f.png",
              sheet_x: 18,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-2696-FE0F",
              non_qualified: "1F468-1F3FF-200D-2696",
              image: "1f468-1f3ff-200d-2696-fe0f.png",
              sheet_x: 18,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Judge",
          b: "1F468-200D-2696-FE0F",
          c: "1F468-200D-2696",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 49]
        },
        grey_question: {
          a: "White Question Mark Ornament",
          b: "2754",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["doubts", "gray", "huh", "confused"],
          k: [50, 4]
        },
        "flag-jm": {
          a: "Jamaica Flag",
          b: "1F1EF-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 44]
        },
        bellhop_bell: {
          a: "Bellhop Bell",
          b: "1F6CE-FE0F",
          c: "1F6CE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["service"],
          k: [37, 3],
          o: 7
        },
        straight_ruler: {
          a: "Straight Ruler",
          b: "1F4CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "calculate", "length", "math", "school", "drawing", "architect", "sketch"],
          k: [26, 6]
        },
        "flag-jo": {
          a: "Jordan Flag",
          b: "1F1EF-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 45]
        },
        "female-judge": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-2696-FE0F",
              non_qualified: "1F469-1F3FB-200D-2696",
              image: "1f469-1f3fb-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-2696-FE0F",
              non_qualified: "1F469-1F3FC-200D-2696",
              image: "1f469-1f3fc-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-2696-FE0F",
              non_qualified: "1F469-1F3FD-200D-2696",
              image: "1f469-1f3fd-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-2696-FE0F",
              non_qualified: "1F469-1F3FE-200D-2696",
              image: "1f469-1f3fe-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-2696-FE0F",
              non_qualified: "1F469-1F3FF-200D-2696",
              image: "1f469-1f3ff-200d-2696-fe0f.png",
              sheet_x: 20,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Judge",
          b: "1F469-200D-2696-FE0F",
          c: "1F469-200D-2696",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 7]
        },
        grey_exclamation: {
          a: "White Exclamation Mark Ornament",
          b: "2755",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["surprise", "punctuation", "gray", "wow", "warning"],
          k: [50, 5]
        },
        door: {
          a: "Door",
          b: "1F6AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["house", "entry", "exit"],
          k: [35, 15]
        },
        "male-farmer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F33E",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f33e.png",
              sheet_x: 16,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Farmer",
          b: "1F468-200D-1F33E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 2]
        },
        jp: {
          a: "Japan Flag",
          b: "1F1EF-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "nation", "flag", "country", "banner"],
          k: [2, 46],
          n: ["flag-jp"]
        },
        triangular_ruler: {
          a: "Triangular Ruler",
          b: "1F4D0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "math", "architect", "sketch"],
          k: [26, 7]
        },
        exclamation: {
          a: "Heavy Exclamation Mark Symbol",
          b: "2757",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["heavy_exclamation_mark", "danger", "surprise", "punctuation", "wow", "warning"],
          k: [50, 6],
          n: ["heavy_exclamation_mark"],
          o: 5
        },
        bed: {
          a: "Bed",
          b: "1F6CF-FE0F",
          c: "1F6CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sleep", "rest"],
          k: [37, 4],
          o: 7
        },
        "female-farmer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F33E",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f33e.png",
              sheet_x: 18,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Farmer",
          b: "1F469-200D-1F33E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 17]
        },
        scissors: {
          a: "Black Scissors",
          b: "2702-FE0F",
          c: "2702",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["stationery", "cut"],
          k: [49, 14],
          o: 1
        },
        wavy_dash: {
          a: "Wavy Dash",
          b: "3030-FE0F",
          c: "3030",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["draw", "line", "moustache", "mustache", "squiggle", "scribble"],
          k: [50, 24],
          o: 1
        },
        "flag-ke": {
          a: "Kenya Flag",
          b: "1F1F0-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 47]
        },
        "flag-kg": {
          a: "Kyrgyzstan Flag",
          b: "1F1F0-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 48]
        },
        couch_and_lamp: {
          a: "Couch and Lamp",
          b: "1F6CB-FE0F",
          c: "1F6CB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["read", "chill"],
          k: [36, 47],
          o: 7
        },
        "male-cook": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F373",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f373.png",
              sheet_x: 16,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Cook",
          b: "1F468-200D-1F373",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 8]
        },
        card_file_box: {
          a: "Card File Box",
          b: "1F5C3-FE0F",
          c: "1F5C3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["business", "stationery"],
          k: [30, 5],
          o: 7
        },
        copyright: {
          a: "Copyright Sign",
          b: "00A9-FE0F",
          c: "00A9",
          d: !0,
          e: !0,
          f: !1,
          g: !0,
          h: !1,
          i: !1,
          j: ["ip", "license", "circle", "law", "legal"],
          k: [0, 12],
          o: 1
        },
        file_cabinet: {
          a: "File Cabinet",
          b: "1F5C4-FE0F",
          c: "1F5C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["filing", "organizing"],
          k: [30, 6],
          o: 7
        },
        registered: {
          a: "Registered Sign",
          b: "00AE-FE0F",
          c: "00AE",
          d: !0,
          e: !0,
          f: !1,
          g: !0,
          h: !1,
          i: !1,
          j: ["alphabet", "circle"],
          k: [0, 13],
          o: 1
        },
        "flag-kh": {
          a: "Cambodia Flag",
          b: "1F1F0-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 49]
        },
        "female-cook": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F373",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f373.png",
              sheet_x: 18,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Cook",
          b: "1F469-200D-1F373",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 23]
        },
        toilet: {
          a: "Toilet",
          b: "1F6BD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["restroom", "wc", "washroom", "bathroom", "potty"],
          k: [36, 33]
        },
        wastebasket: {
          a: "Wastebasket",
          b: "1F5D1-FE0F",
          c: "1F5D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["bin", "trash", "rubbish", "garbage", "toss"],
          k: [30, 7],
          o: 7
        },
        "flag-ki": {
          a: "Kiribati Flag",
          b: "1F1F0-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 50]
        },
        shower: {
          a: "Shower",
          b: "1F6BF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["clean", "water", "bathroom"],
          k: [36, 35]
        },
        "male-mechanic": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F527",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f527.png",
              sheet_x: 17,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Mechanic",
          b: "1F468-200D-1F527",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 19]
        },
        tm: {
          a: "Trade Mark Sign",
          b: "2122-FE0F",
          c: "2122",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["trademark", "brand", "law", "legal"],
          k: [46, 31],
          o: 1
        },
        hash: {
          a: "Hash Key",
          b: "0023-FE0F-20E3",
          c: "0023-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["symbol", "blue-square", "twitter"],
          k: [0, 0],
          o: 3
        },
        "flag-km": {
          a: "Comoros Flag",
          b: "1F1F0-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [2, 51]
        },
        bathtub: {
          a: "Bathtub",
          b: "1F6C1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["clean", "shower", "bathroom"],
          k: [36, 42]
        },
        "female-mechanic": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F527",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f527.png",
              sheet_x: 19,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Mechanic",
          b: "1F469-200D-1F527",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 29]
        },
        lock: {
          a: "Lock",
          b: "1F512",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["security", "password", "padlock"],
          k: [27, 20]
        },
        "male-factory-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F3ED",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f3ed.png",
              sheet_x: 16,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Factory Worker",
          b: "1F468-200D-1F3ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 38]
        },
        "flag-kn": {
          a: "St. Kitts & Nevis Flag",
          b: "1F1F0-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 0]
        },
        hourglass: {
          a: "Hourglass",
          b: "231B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "clock", "oldschool", "limit", "exam", "quiz", "test"],
          k: [46, 42],
          o: 1
        },
        keycap_star: {
          a: "Keycap Star",
          b: "002A-FE0F-20E3",
          c: "002A-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [0, 1],
          o: 3
        },
        unlock: {
          a: "Open Lock",
          b: "1F513",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["privacy", "security"],
          k: [27, 21]
        },
        "flag-kp": {
          a: "North Korea Flag",
          b: "1F1F0-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 1]
        },
        "female-factory-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F3ED",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f3ed.png",
              sheet_x: 19,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Factory Worker",
          b: "1F469-200D-1F3ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 1]
        },
        zero: {
          a: "Keycap 0",
          b: "0030-FE0F-20E3",
          c: "0030-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["0", "numbers", "blue-square", "null"],
          k: [0, 2],
          o: 3
        },
        lock_with_ink_pen: {
          a: "Lock with Ink Pen",
          b: "1F50F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["security", "secret"],
          k: [27, 17]
        },
        hourglass_flowing_sand: {
          a: "Hourglass with Flowing Sand",
          b: "23F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["oldschool", "time", "countdown"],
          k: [47, 3]
        },
        one: {
          a: "Keycap 1",
          b: "0031-FE0F-20E3",
          c: "0031-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["blue-square", "numbers", "1"],
          k: [0, 3],
          o: 3
        },
        kr: {
          a: "South Korea Flag",
          b: "1F1F0-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["south", "korea", "nation", "flag", "country", "banner"],
          k: [3, 2],
          n: ["flag-kr"]
        },
        watch: {
          a: "Watch",
          b: "231A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "accessories"],
          k: [46, 41],
          o: 1
        },
        "male-office-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F4BC",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f4bc.png",
              sheet_x: 17,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Office Worker",
          b: "1F468-200D-1F4BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 13]
        },
        closed_lock_with_key: {
          a: "Closed Lock with Key",
          b: "1F510",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["security", "privacy"],
          k: [27, 18]
        },
        "female-office-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F4BC",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f4bc.png",
              sheet_x: 19,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Office Worker",
          b: "1F469-200D-1F4BC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 23]
        },
        two: {
          a: "Keycap 2",
          b: "0032-FE0F-20E3",
          c: "0032-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["numbers", "2", "prime", "blue-square"],
          k: [0, 4],
          o: 3
        },
        alarm_clock: {
          a: "Alarm Clock",
          b: "23F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "wake"],
          k: [47, 0]
        },
        key: {
          a: "Key",
          b: "1F511",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["lock", "door", "password"],
          k: [27, 19]
        },
        "flag-kw": {
          a: "Kuwait Flag",
          b: "1F1F0-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 3]
        },
        stopwatch: {
          a: "Stopwatch",
          b: "23F1-FE0F",
          c: "23F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["time", "deadline"],
          k: [47, 1]
        },
        "male-scientist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F52C",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f52c.png",
              sheet_x: 17,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Scientist",
          b: "1F468-200D-1F52C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 25]
        },
        three: {
          a: "Keycap 3",
          b: "0033-FE0F-20E3",
          c: "0033-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["3", "numbers", "prime", "blue-square"],
          k: [0, 5],
          o: 3
        },
        "flag-ky": {
          a: "Cayman Islands Flag",
          b: "1F1F0-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 4]
        },
        old_key: {
          a: "Old Key",
          b: "1F5DD-FE0F",
          c: "1F5DD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["lock", "door", "password"],
          k: [30, 11],
          o: 7
        },
        "flag-kz": {
          a: "Kazakhstan Flag",
          b: "1F1F0-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 5]
        },
        hammer: {
          a: "Hammer",
          b: "1F528",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["tools", "build", "create"],
          k: [27, 42]
        },
        "female-scientist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F52C",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f52c.png",
              sheet_x: 19,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Scientist",
          b: "1F469-200D-1F52C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 35]
        },
        timer_clock: {
          a: "Timer Clock",
          b: "23F2-FE0F",
          c: "23F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["alarm"],
          k: [47, 2]
        },
        four: {
          a: "Keycap 4",
          b: "0034-FE0F-20E3",
          c: "0034-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["4", "numbers", "blue-square"],
          k: [0, 6],
          o: 3
        },
        "male-technologist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F4BB",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f4bb.png",
              sheet_x: 17,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Technologist",
          b: "1F468-200D-1F4BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 7]
        },
        mantelpiece_clock: {
          a: "Mantelpiece Clock",
          b: "1F570-FE0F",
          c: "1F570",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["time"],
          k: [28, 43],
          o: 7
        },
        five: {
          a: "Keycap 5",
          b: "0035-FE0F-20E3",
          c: "0035-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["5", "numbers", "blue-square", "prime"],
          k: [0, 7],
          o: 3
        },
        "flag-la": {
          a: "Laos Flag",
          b: "1F1F1-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 6]
        },
        pick: {
          a: "Pick",
          b: "26CF-FE0F",
          c: "26CF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["tools", "dig"],
          k: [48, 32],
          o: 5
        },
        "flag-lb": {
          a: "Lebanon Flag",
          b: "1F1F1-1F1E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 7]
        },
        clock12: {
          a: "Clock Face Twelve Oclock",
          b: "1F55B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "noon", "midnight", "midday", "late", "early", "schedule"],
          k: [28, 29]
        },
        hammer_and_pick: {
          a: "Hammer and Pick",
          b: "2692-FE0F",
          c: "2692",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["tools", "build", "create"],
          k: [48, 11],
          o: 4
        },
        six: {
          a: "Keycap 6",
          b: "0036-FE0F-20E3",
          c: "0036-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["6", "numbers", "blue-square"],
          k: [0, 8],
          o: 3
        },
        "female-technologist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F4BB",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f4bb.png",
              sheet_x: 19,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Technologist",
          b: "1F469-200D-1F4BB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 17]
        },
        hammer_and_wrench: {
          a: "Hammer and Wrench",
          b: "1F6E0-FE0F",
          c: "1F6E0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["tools", "build", "create"],
          k: [37, 8],
          o: 7
        },
        "flag-lc": {
          a: "St. Lucia Flag",
          b: "1F1F1-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 8]
        },
        clock1230: {
          a: "Clock Face Twelve-Thirty",
          b: "1F567",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 41]
        },
        seven: {
          a: "Keycap 7",
          b: "0037-FE0F-20E3",
          c: "0037-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["7", "numbers", "blue-square", "prime"],
          k: [0, 9],
          o: 3
        },
        "male-singer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F3A4",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f3a4.png",
              sheet_x: 16,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Singer",
          b: "1F468-200D-1F3A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 20]
        },
        eight: {
          a: "Keycap 8",
          b: "0038-FE0F-20E3",
          c: "0038-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["8", "blue-square", "numbers"],
          k: [0, 10],
          o: 3
        },
        "flag-li": {
          a: "Liechtenstein Flag",
          b: "1F1F1-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 9]
        },
        dagger_knife: {
          a: "Dagger Knife",
          b: "1F5E1-FE0F",
          c: "1F5E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 13],
          o: 7
        },
        clock1: {
          a: "Clock Face One Oclock",
          b: "1F550",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 18]
        },
        "female-singer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F3A4",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f3a4.png",
              sheet_x: 18,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Singer",
          b: "1F469-200D-1F3A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 35]
        },
        "male-artist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F3A8",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f3a8.png",
              sheet_x: 16,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Artist",
          b: "1F468-200D-1F3A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 26]
        },
        crossed_swords: {
          a: "Crossed Swords",
          b: "2694-FE0F",
          c: "2694",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["weapon"],
          k: [48, 13],
          o: 4
        },
        nine: {
          a: "Keycap 9",
          b: "0039-FE0F-20E3",
          c: "0039-20E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          j: ["blue-square", "numbers", "9"],
          k: [0, 11],
          o: 3
        },
        "flag-lk": {
          a: "Sri Lanka Flag",
          b: "1F1F1-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 10]
        },
        clock130: {
          a: "Clock Face One-Thirty",
          b: "1F55C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 30]
        },
        clock2: {
          a: "Clock Face Two Oclock",
          b: "1F551",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 19]
        },
        gun: {
          a: "Pistol",
          b: "1F52B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["violence", "weapon", "pistol", "revolver"],
          k: [27, 45]
        },
        keycap_ten: {
          a: "Keycap Ten",
          b: "1F51F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["numbers", "10", "blue-square"],
          k: [27, 33]
        },
        "female-artist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F3A8",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f3a8.png",
              sheet_x: 18,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Artist",
          b: "1F469-200D-1F3A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 41]
        },
        "flag-lr": {
          a: "Liberia Flag",
          b: "1F1F1-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 11]
        },
        clock230: {
          a: "Clock Face Two-Thirty",
          b: "1F55D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 31]
        },
        bow_and_arrow: {
          a: "Bow and Arrow",
          b: "1F3F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports"],
          k: [12, 23],
          o: 8
        },
        "male-pilot": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-2708-FE0F",
              non_qualified: "1F468-1F3FB-200D-2708",
              image: "1f468-1f3fb-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-2708-FE0F",
              non_qualified: "1F468-1F3FC-200D-2708",
              image: "1f468-1f3fc-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-2708-FE0F",
              non_qualified: "1F468-1F3FD-200D-2708",
              image: "1f468-1f3fd-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-2708-FE0F",
              non_qualified: "1F468-1F3FE-200D-2708",
              image: "1f468-1f3fe-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-2708-FE0F",
              non_qualified: "1F468-1F3FF-200D-2708",
              image: "1f468-1f3ff-200d-2708-fe0f.png",
              sheet_x: 18,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Pilot",
          b: "1F468-200D-2708-FE0F",
          c: "1F468-200D-2708",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [18, 3]
        },
        "flag-ls": {
          a: "Lesotho Flag",
          b: "1F1F1-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 12]
        },
        "flag-lt": {
          a: "Lithuania Flag",
          b: "1F1F1-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 13]
        },
        capital_abcd: {
          a: "Input Symbol for Latin Capital Letters",
          b: "1F520",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["alphabet", "words", "blue-square"],
          k: [27, 34]
        },
        "female-pilot": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-2708-FE0F",
              non_qualified: "1F469-1F3FB-200D-2708",
              image: "1f469-1f3fb-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-2708-FE0F",
              non_qualified: "1F469-1F3FC-200D-2708",
              image: "1f469-1f3fc-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-2708-FE0F",
              non_qualified: "1F469-1F3FD-200D-2708",
              image: "1f469-1f3fd-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-2708-FE0F",
              non_qualified: "1F469-1F3FE-200D-2708",
              image: "1f469-1f3fe-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-2708-FE0F",
              non_qualified: "1F469-1F3FF-200D-2708",
              image: "1f469-1f3ff-200d-2708-fe0f.png",
              sheet_x: 20,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Pilot",
          b: "1F469-200D-2708-FE0F",
          c: "1F469-200D-2708",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 13]
        },
        clock3: {
          a: "Clock Face Three Oclock",
          b: "1F552",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 20]
        },
        shield: {
          a: "Shield",
          b: "1F6E1-FE0F",
          c: "1F6E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["protection", "security"],
          k: [37, 9],
          o: 7
        },
        "male-astronaut": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F680",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f680.png",
              sheet_x: 17,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Astronaut",
          b: "1F468-200D-1F680",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 31]
        },
        abcd: {
          a: "Input Symbol for Latin Small Letters",
          b: "1F521",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "alphabet"],
          k: [27, 35]
        },
        clock330: {
          a: "Clock Face Three-Thirty",
          b: "1F55E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 32]
        },
        "flag-lu": {
          a: "Luxembourg Flag",
          b: "1F1F1-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 14]
        },
        wrench: {
          a: "Wrench",
          b: "1F527",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["tools", "diy", "ikea", "fix", "maintainer"],
          k: [27, 41]
        },
        nut_and_bolt: {
          a: "Nut and Bolt",
          b: "1F529",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["handy", "tools", "fix"],
          k: [27, 43]
        },
        clock4: {
          a: "Clock Face Four Oclock",
          b: "1F553",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 21]
        },
        "female-astronaut": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F680",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f680.png",
              sheet_x: 19,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Astronaut",
          b: "1F469-200D-1F680",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 41]
        },
        "flag-lv": {
          a: "Latvia Flag",
          b: "1F1F1-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 15]
        },
        gear: {
          a: "Gear",
          b: "2699-FE0F",
          c: "2699",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["cog"],
          k: [48, 17],
          o: 4
        },
        "male-firefighter": {
          skin_variations: {
            "1F3FB": {
              unified: "1F468-1F3FB-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3fb-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F468-1F3FC-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3fc-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F468-1F3FD-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3fd-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F468-1F3FE-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3fe-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F468-1F3FF-200D-1F692",
              non_qualified: null,
              image: "1f468-1f3ff-200d-1f692.png",
              sheet_x: 17,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Male Firefighter",
          b: "1F468-200D-1F692",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [17, 37]
        },
        "flag-ly": {
          a: "Libya Flag",
          b: "1F1F1-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 16]
        },
        symbols: {
          a: "Input Symbol for Symbols",
          b: "1F523",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "music", "note", "ampersand", "percent", "glyphs", "characters"],
          k: [27, 37]
        },
        clock430: {
          a: "Clock Face Four-Thirty",
          b: "1F55F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 33]
        },
        "flag-ma": {
          a: "Morocco Flag",
          b: "1F1F2-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 17]
        },
        compression: {
          a: "Compression",
          b: "1F5DC-FE0F",
          c: "1F5DC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 10],
          o: 7
        },
        "female-firefighter": {
          skin_variations: {
            "1F3FB": {
              unified: "1F469-1F3FB-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3fb-200d-1f692.png",
              sheet_x: 19,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F469-1F3FC-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3fc-200d-1f692.png",
              sheet_x: 19,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F469-1F3FD-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3fd-200d-1f692.png",
              sheet_x: 19,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F469-1F3FE-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3fe-200d-1f692.png",
              sheet_x: 19,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F469-1F3FF-200D-1F692",
              non_qualified: null,
              image: "1f469-1f3ff-200d-1f692.png",
              sheet_x: 20,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Female Firefighter",
          b: "1F469-200D-1F692",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 47]
        },
        abc: {
          a: "Input Symbol for Latin Letters",
          b: "1F524",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "alphabet"],
          k: [27, 38]
        },
        clock5: {
          a: "Clock Face Five Oclock",
          b: "1F554",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 22]
        },
        clock530: {
          a: "Clock Face Five-Thirty",
          b: "1F560",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 34]
        },
        a: {
          a: "Negative Squared Latin Capital Letter a",
          b: "1F170-FE0F",
          c: "1F170",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["red-square", "alphabet", "letter"],
          k: [0, 16]
        },
        alembic: {
          a: "Alembic",
          b: "2697-FE0F",
          c: "2697",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["distilling", "science", "experiment", "chemistry"],
          k: [48, 16],
          o: 4
        },
        "flag-mc": {
          a: "Monaco Flag",
          b: "1F1F2-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 18]
        },
        cop: {
          skin_variations: {
            "1F3FB": {
              unified: "1F46E-1F3FB",
              non_qualified: null,
              image: "1f46e-1f3fb.png",
              sheet_x: 20,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F46E-1F3FC",
              non_qualified: null,
              image: "1f46e-1f3fc.png",
              sheet_x: 20,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F46E-1F3FD",
              non_qualified: null,
              image: "1f46e-1f3fd.png",
              sheet_x: 20,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F46E-1F3FE",
              non_qualified: null,
              image: "1f46e-1f3fe.png",
              sheet_x: 20,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F46E-1F3FF",
              non_qualified: null,
              image: "1f46e-1f3ff.png",
              sheet_x: 20,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F46E-200D-2642-FE0F",
          a: "Police Officer",
          b: "1F46E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [20, 45]
        },
        scales: {
          a: "Scales",
          b: "2696-FE0F",
          c: "2696",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 15],
          o: 4
        },
        clock6: {
          a: "Clock Face Six Oclock",
          b: "1F555",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule", "dawn", "dusk"],
          k: [28, 23]
        },
        "flag-md": {
          a: "Moldova Flag",
          b: "1F1F2-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 19]
        },
        ab: {
          a: "Negative Squared Ab",
          b: "1F18E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["red-square", "alphabet"],
          k: [0, 20]
        },
        "male-police-officer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F46E-1F3FB-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FB-200D-2642",
              image: "1f46e-1f3fb-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F46E-1F3FC-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FC-200D-2642",
              image: "1f46e-1f3fc-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F46E-1F3FD-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FD-200D-2642",
              image: "1f46e-1f3fd-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F46E-1F3FE-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FE-200D-2642",
              image: "1f46e-1f3fe-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F46E-1F3FF-200D-2642-FE0F",
              non_qualified: "1F46E-1F3FF-200D-2642",
              image: "1f46e-1f3ff-200d-2642-fe0f.png",
              sheet_x: 20,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F46E",
          a: "Male Police Officer",
          b: "1F46E-200D-2642-FE0F",
          c: "1F46E-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 39]
        },
        link: {
          a: "Link Symbol",
          b: "1F517",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["rings", "url"],
          k: [27, 25]
        },
        "flag-me": {
          a: "Montenegro Flag",
          b: "1F1F2-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 20]
        },
        clock630: {
          a: "Clock Face Six-Thirty",
          b: "1F561",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 35]
        },
        b: {
          a: "Negative Squared Latin Capital Letter B",
          b: "1F171-FE0F",
          c: "1F171",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["red-square", "alphabet", "letter"],
          k: [0, 17]
        },
        "female-police-officer": {
          skin_variations: {
            "1F3FB": {
              unified: "1F46E-1F3FB-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FB-200D-2640",
              image: "1f46e-1f3fb-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F46E-1F3FC-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FC-200D-2640",
              image: "1f46e-1f3fc-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F46E-1F3FD-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FD-200D-2640",
              image: "1f46e-1f3fd-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F46E-1F3FE-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FE-200D-2640",
              image: "1f46e-1f3fe-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F46E-1F3FF-200D-2640-FE0F",
              non_qualified: "1F46E-1F3FF-200D-2640",
              image: "1f46e-1f3ff-200d-2640-fe0f.png",
              sheet_x: 20,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Police Officer",
          b: "1F46E-200D-2640-FE0F",
          c: "1F46E-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 33]
        },
        clock7: {
          a: "Clock Face Seven Oclock",
          b: "1F556",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 24]
        },
        cl: {
          a: "Squared Cl",
          b: "1F191",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["alphabet", "words", "red-square"],
          k: [0, 21]
        },
        sleuth_or_spy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F575-1F3FB",
              non_qualified: null,
              image: "1f575-1f3fb.png",
              sheet_x: 29,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F575-1F3FC",
              non_qualified: null,
              image: "1f575-1f3fc.png",
              sheet_x: 29,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F575-1F3FD",
              non_qualified: null,
              image: "1f575-1f3fd.png",
              sheet_x: 29,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F575-1F3FE",
              non_qualified: null,
              image: "1f575-1f3fe.png",
              sheet_x: 29,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F575-1F3FF",
              non_qualified: null,
              image: "1f575-1f3ff.png",
              sheet_x: 29,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "1F575-FE0F-200D-2642-FE0F",
          a: "Sleuth or Spy",
          b: "1F575-FE0F",
          c: "1F575",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [29, 11],
          o: 7
        },
        "flag-mf": {
          a: "St. Martin Flag",
          b: "1F1F2-1F1EB",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 21]
        },
        chains: {
          a: "Chains",
          b: "26D3-FE0F",
          c: "26D3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["lock", "arrest"],
          k: [48, 34],
          o: 5
        },
        syringe: {
          a: "Syringe",
          b: "1F489",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["health", "hospital", "drugs", "blood", "medicine", "needle", "doctor", "nurse"],
          k: [24, 35]
        },
        "male-detective": {
          skin_variations: {
            "1F3FB": {
              unified: "1F575-1F3FB-200D-2642-FE0F",
              non_qualified: "1F575-1F3FB-200D-2642",
              image: "1f575-1f3fb-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F575-1F3FC-200D-2642-FE0F",
              non_qualified: "1F575-1F3FC-200D-2642",
              image: "1f575-1f3fc-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F575-1F3FD-200D-2642-FE0F",
              non_qualified: "1F575-1F3FD-200D-2642",
              image: "1f575-1f3fd-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F575-1F3FE-200D-2642-FE0F",
              non_qualified: "1F575-1F3FE-200D-2642",
              image: "1f575-1f3fe-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F575-1F3FF-200D-2642-FE0F",
              non_qualified: "1F575-1F3FF-200D-2642",
              image: "1f575-1f3ff-200d-2642-fe0f.png",
              sheet_x: 29,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F575-FE0F",
          a: "Male Detective",
          b: "1F575-FE0F-200D-2642-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [29, 5],
          o: 7
        },
        cool: {
          a: "Squared Cool",
          b: "1F192",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["words", "blue-square"],
          k: [0, 22]
        },
        clock730: {
          a: "Clock Face Seven-Thirty",
          b: "1F562",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 36]
        },
        "flag-mg": {
          a: "Madagascar Flag",
          b: "1F1F2-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 22]
        },
        free: {
          a: "Squared Free",
          b: "1F193",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "words"],
          k: [0, 23]
        },
        "flag-mh": {
          a: "Marshall Islands Flag",
          b: "1F1F2-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 23]
        },
        clock8: {
          a: "Clock Face Eight Oclock",
          b: "1F557",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 25]
        },
        pill: {
          a: "Pill",
          b: "1F48A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["health", "medicine", "doctor", "pharmacy", "drug"],
          k: [24, 36]
        },
        "female-detective": {
          skin_variations: {
            "1F3FB": {
              unified: "1F575-1F3FB-200D-2640-FE0F",
              non_qualified: "1F575-1F3FB-200D-2640",
              image: "1f575-1f3fb-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F575-1F3FC-200D-2640-FE0F",
              non_qualified: "1F575-1F3FC-200D-2640",
              image: "1f575-1f3fc-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F575-1F3FD-200D-2640-FE0F",
              non_qualified: "1F575-1F3FD-200D-2640",
              image: "1f575-1f3fd-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F575-1F3FE-200D-2640-FE0F",
              non_qualified: "1F575-1F3FE-200D-2640",
              image: "1f575-1f3fe-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F575-1F3FF-200D-2640-FE0F",
              non_qualified: "1F575-1F3FF-200D-2640",
              image: "1f575-1f3ff-200d-2640-fe0f.png",
              sheet_x: 29,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Detective",
          b: "1F575-FE0F-200D-2640-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [28, 51],
          o: 7
        },
        clock830: {
          a: "Clock Face Eight-Thirty",
          b: "1F563",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 37]
        },
        guardsman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F482-1F3FB",
              non_qualified: null,
              image: "1f482-1f3fb.png",
              sheet_x: 23,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F482-1F3FC",
              non_qualified: null,
              image: "1f482-1f3fc.png",
              sheet_x: 23,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F482-1F3FD",
              non_qualified: null,
              image: "1f482-1f3fd.png",
              sheet_x: 23,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F482-1F3FE",
              non_qualified: null,
              image: "1f482-1f3fe.png",
              sheet_x: 23,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F482-1F3FF",
              non_qualified: null,
              image: "1f482-1f3ff.png",
              sheet_x: 23,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F482-200D-2642-FE0F",
          a: "Guardsman",
          b: "1F482",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          j: ["uk", "gb", "british", "male", "guy", "royal"],
          k: [23, 31]
        },
        information_source: {
          a: "Information Source",
          b: "2139-FE0F",
          c: "2139",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "alphabet", "letter"],
          k: [46, 32],
          o: 3
        },
        "flag-mk": {
          a: "Macedonia Flag",
          b: "1F1F2-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 24]
        },
        smoking: {
          a: "Smoking Symbol",
          b: "1F6AC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["kills", "tobacco", "cigarette", "joint", "smoke"],
          k: [35, 17]
        },
        id: {
          a: "Squared Id",
          b: "1F194",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "words"],
          k: [0, 24]
        },
        clock9: {
          a: "Clock Face Nine Oclock",
          b: "1F558",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 26]
        },
        "flag-ml": {
          a: "Mali Flag",
          b: "1F1F2-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 25]
        },
        coffin: {
          a: "Coffin",
          b: "26B0-FE0F",
          c: "26B0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["vampire", "dead", "die", "death", "rip", "graveyard", "cemetery", "casket", "funeral", "box"],
          k: [48, 24],
          o: 4
        },
        "male-guard": {
          skin_variations: {
            "1F3FB": {
              unified: "1F482-1F3FB-200D-2642-FE0F",
              non_qualified: "1F482-1F3FB-200D-2642",
              image: "1f482-1f3fb-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F482-1F3FC-200D-2642-FE0F",
              non_qualified: "1F482-1F3FC-200D-2642",
              image: "1f482-1f3fc-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F482-1F3FD-200D-2642-FE0F",
              non_qualified: "1F482-1F3FD-200D-2642",
              image: "1f482-1f3fd-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F482-1F3FE-200D-2642-FE0F",
              non_qualified: "1F482-1F3FE-200D-2642",
              image: "1f482-1f3fe-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F482-1F3FF-200D-2642-FE0F",
              non_qualified: "1F482-1F3FF-200D-2642",
              image: "1f482-1f3ff-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F482",
          a: "Male Guard",
          b: "1F482-200D-2642-FE0F",
          c: "1F482-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 25]
        },
        m: {
          a: "Circled Latin Capital Letter M",
          b: "24C2-FE0F",
          c: "24C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["alphabet", "blue-circle", "letter"],
          k: [47, 7],
          o: 1
        },
        funeral_urn: {
          a: "Funeral Urn",
          b: "26B1-FE0F",
          c: "26B1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["dead", "die", "death", "rip", "ashes"],
          k: [48, 25],
          o: 4
        },
        "female-guard": {
          skin_variations: {
            "1F3FB": {
              unified: "1F482-1F3FB-200D-2640-FE0F",
              non_qualified: "1F482-1F3FB-200D-2640",
              image: "1f482-1f3fb-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F482-1F3FC-200D-2640-FE0F",
              non_qualified: "1F482-1F3FC-200D-2640",
              image: "1f482-1f3fc-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F482-1F3FD-200D-2640-FE0F",
              non_qualified: "1F482-1F3FD-200D-2640",
              image: "1f482-1f3fd-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F482-1F3FE-200D-2640-FE0F",
              non_qualified: "1F482-1F3FE-200D-2640",
              image: "1f482-1f3fe-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F482-1F3FF-200D-2640-FE0F",
              non_qualified: "1F482-1F3FF-200D-2640",
              image: "1f482-1f3ff-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Guard",
          b: "1F482-200D-2640-FE0F",
          c: "1F482-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 19]
        },
        "flag-mm": {
          a: "Myanmar (burma) Flag",
          b: "1F1F2-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 26]
        },
        clock930: {
          a: "Clock Face Nine-Thirty",
          b: "1F564",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 38]
        },
        moyai: {
          a: "Moyai",
          b: "1F5FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["rock", "easter island", "moai"],
          k: [30, 23]
        },
        new: {
          a: "Squared New",
          b: "1F195",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "words", "start"],
          k: [0, 25]
        },
        "flag-mn": {
          a: "Mongolia Flag",
          b: "1F1F2-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 27]
        },
        construction_worker: {
          skin_variations: {
            "1F3FB": {
              unified: "1F477-1F3FB",
              non_qualified: null,
              image: "1f477-1f3fb.png",
              sheet_x: 22,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F477-1F3FC",
              non_qualified: null,
              image: "1f477-1f3fc.png",
              sheet_x: 22,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F477-1F3FD",
              non_qualified: null,
              image: "1f477-1f3fd.png",
              sheet_x: 22,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F477-1F3FE",
              non_qualified: null,
              image: "1f477-1f3fe.png",
              sheet_x: 22,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F477-1F3FF",
              non_qualified: null,
              image: "1f477-1f3ff.png",
              sheet_x: 22,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F477-200D-2642-FE0F",
          a: "Construction Worker",
          b: "1F477",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [22, 28]
        },
        clock10: {
          a: "Clock Face Ten Oclock",
          b: "1F559",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 27]
        },
        clock1030: {
          a: "Clock Face Ten-Thirty",
          b: "1F565",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 39]
        },
        ng: {
          a: "Squared Ng",
          b: "1F196",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "words", "shape", "icon"],
          k: [0, 26]
        },
        "male-construction-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F477-1F3FB-200D-2642-FE0F",
              non_qualified: "1F477-1F3FB-200D-2642",
              image: "1f477-1f3fb-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F477-1F3FC-200D-2642-FE0F",
              non_qualified: "1F477-1F3FC-200D-2642",
              image: "1f477-1f3fc-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F477-1F3FD-200D-2642-FE0F",
              non_qualified: "1F477-1F3FD-200D-2642",
              image: "1f477-1f3fd-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F477-1F3FE-200D-2642-FE0F",
              non_qualified: "1F477-1F3FE-200D-2642",
              image: "1f477-1f3fe-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F477-1F3FF-200D-2642-FE0F",
              non_qualified: "1F477-1F3FF-200D-2642",
              image: "1f477-1f3ff-200d-2642-fe0f.png",
              sheet_x: 22,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F477",
          a: "Male Construction Worker",
          b: "1F477-200D-2642-FE0F",
          c: "1F477-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [22, 22]
        },
        "flag-mo": {
          a: "Macau Sar China Flag",
          b: "1F1F2-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 28]
        },
        oil_drum: {
          a: "Oil Drum",
          b: "1F6E2-FE0F",
          c: "1F6E2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["barrell"],
          k: [37, 10],
          o: 7
        },
        o2: {
          a: "Negative Squared Latin Capital Letter O",
          b: "1F17E-FE0F",
          c: "1F17E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["alphabet", "red-square", "letter"],
          k: [0, 18]
        },
        "female-construction-worker": {
          skin_variations: {
            "1F3FB": {
              unified: "1F477-1F3FB-200D-2640-FE0F",
              non_qualified: "1F477-1F3FB-200D-2640",
              image: "1f477-1f3fb-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F477-1F3FC-200D-2640-FE0F",
              non_qualified: "1F477-1F3FC-200D-2640",
              image: "1f477-1f3fc-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F477-1F3FD-200D-2640-FE0F",
              non_qualified: "1F477-1F3FD-200D-2640",
              image: "1f477-1f3fd-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F477-1F3FE-200D-2640-FE0F",
              non_qualified: "1F477-1F3FE-200D-2640",
              image: "1f477-1f3fe-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F477-1F3FF-200D-2640-FE0F",
              non_qualified: "1F477-1F3FF-200D-2640",
              image: "1f477-1f3ff-200d-2640-fe0f.png",
              sheet_x: 22,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Construction Worker",
          b: "1F477-200D-2640-FE0F",
          c: "1F477-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [22, 16]
        },
        clock11: {
          a: "Clock Face Eleven Oclock",
          b: "1F55A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 28]
        },
        crystal_ball: {
          a: "Crystal Ball",
          b: "1F52E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["disco", "party", "magic", "circus", "fortune_teller"],
          k: [27, 48]
        },
        "flag-mp": {
          a: "Northern Mariana Islands Flag",
          b: "1F1F2-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 29]
        },
        "flag-mq": {
          a: "Martinique Flag",
          b: "1F1F2-1F1F6",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 30]
        },
        prince: {
          skin_variations: {
            "1F3FB": {
              unified: "1F934-1F3FB",
              non_qualified: null,
              image: "1f934-1f3fb.png",
              sheet_x: 39,
              sheet_y: 29,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F934-1F3FC",
              non_qualified: null,
              image: "1f934-1f3fc.png",
              sheet_x: 39,
              sheet_y: 30,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F934-1F3FD",
              non_qualified: null,
              image: "1f934-1f3fd.png",
              sheet_x: 39,
              sheet_y: 31,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F934-1F3FE",
              non_qualified: null,
              image: "1f934-1f3fe.png",
              sheet_x: 39,
              sheet_y: 32,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F934-1F3FF",
              non_qualified: null,
              image: "1f934-1f3ff.png",
              sheet_x: 39,
              sheet_y: 33,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Prince",
          b: "1F934",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["boy", "man", "male", "crown", "royal", "king"],
          k: [39, 28],
          o: 9
        },
        ok: {
          a: "Squared Ok",
          b: "1F197",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["good", "agree", "yes", "blue-square"],
          k: [0, 27]
        },
        clock1130: {
          a: "Clock Face Eleven-Thirty",
          b: "1F566",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["time", "late", "early", "schedule"],
          k: [28, 40]
        },
        shopping_trolley: {
          a: "Shopping Trolley",
          b: "1F6D2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 7],
          o: 9
        },
        "flag-mr": {
          a: "Mauritania Flag",
          b: "1F1F2-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 31]
        },
        princess: {
          skin_variations: {
            "1F3FB": {
              unified: "1F478-1F3FB",
              non_qualified: null,
              image: "1f478-1f3fb.png",
              sheet_x: 22,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F478-1F3FC",
              non_qualified: null,
              image: "1f478-1f3fc.png",
              sheet_x: 22,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F478-1F3FD",
              non_qualified: null,
              image: "1f478-1f3fd.png",
              sheet_x: 22,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F478-1F3FE",
              non_qualified: null,
              image: "1f478-1f3fe.png",
              sheet_x: 22,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F478-1F3FF",
              non_qualified: null,
              image: "1f478-1f3ff.png",
              sheet_x: 22,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Princess",
          b: "1F478",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["girl", "woman", "female", "blond", "crown", "royal", "queen"],
          k: [22, 34]
        },
        new_moon: {
          a: "New Moon Symbol",
          b: "1F311",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 9]
        },
        parking: {
          a: "Negative Squared Latin Capital Letter P",
          b: "1F17F-FE0F",
          c: "1F17F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cars", "blue-square", "alphabet", "letter"],
          k: [0, 19],
          o: 5
        },
        sos: {
          a: "Squared Sos",
          b: "1F198",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["help", "red-square", "words", "emergency", "911"],
          k: [0, 28]
        },
        man_with_turban: {
          skin_variations: {
            "1F3FB": {
              unified: "1F473-1F3FB",
              non_qualified: null,
              image: "1f473-1f3fb.png",
              sheet_x: 21,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F473-1F3FC",
              non_qualified: null,
              image: "1f473-1f3fc.png",
              sheet_x: 21,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F473-1F3FD",
              non_qualified: null,
              image: "1f473-1f3fd.png",
              sheet_x: 21,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F473-1F3FE",
              non_qualified: null,
              image: "1f473-1f3fe.png",
              sheet_x: 21,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F473-1F3FF",
              non_qualified: null,
              image: "1f473-1f3ff.png",
              sheet_x: 21,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F473-200D-2642-FE0F",
          a: "Man with Turban",
          b: "1F473",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          j: ["male", "indian", "hinduism", "arabs"],
          k: [21, 44]
        },
        "flag-ms": {
          a: "Montserrat Flag",
          b: "1F1F2-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 32]
        },
        waxing_crescent_moon: {
          a: "Waxing Crescent Moon Symbol",
          b: "1F312",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 10]
        },
        up: {
          a: "Squared Up with Exclamation Mark",
          b: "1F199",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "above", "high"],
          k: [0, 29]
        },
        first_quarter_moon: {
          a: "First Quarter Moon Symbol",
          b: "1F313",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 11]
        },
        "flag-mt": {
          a: "Malta Flag",
          b: "1F1F2-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 33]
        },
        "man-wearing-turban": {
          skin_variations: {
            "1F3FB": {
              unified: "1F473-1F3FB-200D-2642-FE0F",
              non_qualified: "1F473-1F3FB-200D-2642",
              image: "1f473-1f3fb-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F473-1F3FC-200D-2642-FE0F",
              non_qualified: "1F473-1F3FC-200D-2642",
              image: "1f473-1f3fc-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F473-1F3FD-200D-2642-FE0F",
              non_qualified: "1F473-1F3FD-200D-2642",
              image: "1f473-1f3fd-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F473-1F3FE-200D-2642-FE0F",
              non_qualified: "1F473-1F3FE-200D-2642",
              image: "1f473-1f3fe-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F473-1F3FF-200D-2642-FE0F",
              non_qualified: "1F473-1F3FF-200D-2642",
              image: "1f473-1f3ff-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F473",
          a: "Man Wearing Turban",
          b: "1F473-200D-2642-FE0F",
          c: "1F473-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 38]
        },
        moon: {
          a: "Waxing Gibbous Moon Symbol",
          b: "1F314",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [6, 12],
          n: ["waxing_gibbous_moon"]
        },
        "woman-wearing-turban": {
          skin_variations: {
            "1F3FB": {
              unified: "1F473-1F3FB-200D-2640-FE0F",
              non_qualified: "1F473-1F3FB-200D-2640",
              image: "1f473-1f3fb-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F473-1F3FC-200D-2640-FE0F",
              non_qualified: "1F473-1F3FC-200D-2640",
              image: "1f473-1f3fc-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F473-1F3FD-200D-2640-FE0F",
              non_qualified: "1F473-1F3FD-200D-2640",
              image: "1f473-1f3fd-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F473-1F3FE-200D-2640-FE0F",
              non_qualified: "1F473-1F3FE-200D-2640",
              image: "1f473-1f3fe-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F473-1F3FF-200D-2640-FE0F",
              non_qualified: "1F473-1F3FF-200D-2640",
              image: "1f473-1f3ff-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Wearing Turban",
          b: "1F473-200D-2640-FE0F",
          c: "1F473-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 32]
        },
        vs: {
          a: "Squared Vs",
          b: "1F19A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["words", "orange-square"],
          k: [0, 30]
        },
        "flag-mu": {
          a: "Mauritius Flag",
          b: "1F1F2-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 34]
        },
        man_with_gua_pi_mao: {
          skin_variations: {
            "1F3FB": {
              unified: "1F472-1F3FB",
              non_qualified: null,
              image: "1f472-1f3fb.png",
              sheet_x: 21,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F472-1F3FC",
              non_qualified: null,
              image: "1f472-1f3fc.png",
              sheet_x: 21,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F472-1F3FD",
              non_qualified: null,
              image: "1f472-1f3fd.png",
              sheet_x: 21,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F472-1F3FE",
              non_qualified: null,
              image: "1f472-1f3fe.png",
              sheet_x: 21,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F472-1F3FF",
              non_qualified: null,
              image: "1f472-1f3ff.png",
              sheet_x: 21,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Man with Gua Pi Mao",
          b: "1F472",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["male", "boy", "chinese"],
          k: [21, 26]
        },
        koko: {
          a: "Squared Katakana Koko",
          b: "1F201",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue-square", "here", "katakana", "japanese", "destination"],
          k: [5, 29]
        },
        full_moon: {
          a: "Full Moon Symbol",
          b: "1F315",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "yellow", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 13]
        },
        "flag-mv": {
          a: "Maldives Flag",
          b: "1F1F2-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 35]
        },
        person_with_headscarf: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D5-1F3FB",
              non_qualified: null,
              image: "1f9d5-1f3fb.png",
              sheet_x: 43,
              sheet_y: 23,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D5-1F3FC",
              non_qualified: null,
              image: "1f9d5-1f3fc.png",
              sheet_x: 43,
              sheet_y: 24,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D5-1F3FD",
              non_qualified: null,
              image: "1f9d5-1f3fd.png",
              sheet_x: 43,
              sheet_y: 25,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D5-1F3FE",
              non_qualified: null,
              image: "1f9d5-1f3fe.png",
              sheet_x: 43,
              sheet_y: 26,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D5-1F3FF",
              non_qualified: null,
              image: "1f9d5-1f3ff.png",
              sheet_x: 43,
              sheet_y: 27,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Person with Headscarf",
          b: "1F9D5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 22],
          o: 10
        },
        waning_gibbous_moon: {
          a: "Waning Gibbous Moon Symbol",
          b: "1F316",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep", "waxing_gibbous_moon"],
          k: [6, 14]
        },
        sa: {
          a: "Squared Katakana Sa",
          b: "1F202-FE0F",
          c: "1F202",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "blue-square", "katakana"],
          k: [5, 30]
        },
        "flag-mw": {
          a: "Malawi Flag",
          b: "1F1F2-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 36]
        },
        last_quarter_moon: {
          a: "Last Quarter Moon Symbol",
          b: "1F317",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 15]
        },
        u6708: {
          a: "Squared Cjk Unified Ideograph-6708",
          b: "1F237-FE0F",
          c: "1F237",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "month", "moon", "japanese", "orange-square", "kanji"],
          k: [5, 38]
        },
        bearded_person: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D4-1F3FB",
              non_qualified: null,
              image: "1f9d4-1f3fb.png",
              sheet_x: 43,
              sheet_y: 17,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D4-1F3FC",
              non_qualified: null,
              image: "1f9d4-1f3fc.png",
              sheet_x: 43,
              sheet_y: 18,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D4-1F3FD",
              non_qualified: null,
              image: "1f9d4-1f3fd.png",
              sheet_x: 43,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D4-1F3FE",
              non_qualified: null,
              image: "1f9d4-1f3fe.png",
              sheet_x: 43,
              sheet_y: 20,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D4-1F3FF",
              non_qualified: null,
              image: "1f9d4-1f3ff.png",
              sheet_x: 43,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Bearded Person",
          b: "1F9D4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 16],
          o: 10
        },
        "flag-mx": {
          a: "Mexico Flag",
          b: "1F1F2-1F1FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 37]
        },
        u6709: {
          a: "Squared Cjk Unified Ideograph-6709",
          b: "1F236",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["orange-square", "chinese", "have", "kanji"],
          k: [5, 37]
        },
        person_with_blond_hair: {
          skin_variations: {
            "1F3FB": {
              unified: "1F471-1F3FB",
              non_qualified: null,
              image: "1f471-1f3fb.png",
              sheet_x: 21,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F471-1F3FC",
              non_qualified: null,
              image: "1f471-1f3fc.png",
              sheet_x: 21,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F471-1F3FD",
              non_qualified: null,
              image: "1f471-1f3fd.png",
              sheet_x: 21,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F471-1F3FE",
              non_qualified: null,
              image: "1f471-1f3fe.png",
              sheet_x: 21,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F471-1F3FF",
              non_qualified: null,
              image: "1f471-1f3ff.png",
              sheet_x: 21,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F471-200D-2642-FE0F",
          a: "Person with Blond Hair",
          b: "1F471",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [21, 20]
        },
        waning_crescent_moon: {
          a: "Waning Crescent Moon Symbol",
          b: "1F318",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 16]
        },
        "flag-my": {
          a: "Malaysia Flag",
          b: "1F1F2-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 38]
        },
        u6307: {
          a: "Squared Cjk Unified Ideograph-6307",
          b: "1F22F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "point", "green-square", "kanji"],
          k: [5, 32],
          o: 5
        },
        "blond-haired-man": {
          skin_variations: {
            "1F3FB": {
              unified: "1F471-1F3FB-200D-2642-FE0F",
              non_qualified: "1F471-1F3FB-200D-2642",
              image: "1f471-1f3fb-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F471-1F3FC-200D-2642-FE0F",
              non_qualified: "1F471-1F3FC-200D-2642",
              image: "1f471-1f3fc-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F471-1F3FD-200D-2642-FE0F",
              non_qualified: "1F471-1F3FD-200D-2642",
              image: "1f471-1f3fd-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F471-1F3FE-200D-2642-FE0F",
              non_qualified: "1F471-1F3FE-200D-2642",
              image: "1f471-1f3fe-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F471-1F3FF-200D-2642-FE0F",
              non_qualified: "1F471-1F3FF-200D-2642",
              image: "1f471-1f3ff-200d-2642-fe0f.png",
              sheet_x: 21,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F471",
          a: "Blond Haired Man",
          b: "1F471-200D-2642-FE0F",
          c: "1F471-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 14]
        },
        crescent_moon: {
          a: "Crescent Moon",
          b: "1F319",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["night", "sleep", "sky", "evening", "magic"],
          k: [6, 17]
        },
        "flag-mz": {
          a: "Mozambique Flag",
          b: "1F1F2-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 39]
        },
        new_moon_with_face: {
          a: "New Moon with Face",
          b: "1F31A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 18]
        },
        "flag-na": {
          a: "Namibia Flag",
          b: "1F1F3-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 40]
        },
        "blond-haired-woman": {
          skin_variations: {
            "1F3FB": {
              unified: "1F471-1F3FB-200D-2640-FE0F",
              non_qualified: "1F471-1F3FB-200D-2640",
              image: "1f471-1f3fb-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F471-1F3FC-200D-2640-FE0F",
              non_qualified: "1F471-1F3FC-200D-2640",
              image: "1f471-1f3fc-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F471-1F3FD-200D-2640-FE0F",
              non_qualified: "1F471-1F3FD-200D-2640",
              image: "1f471-1f3fd-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F471-1F3FE-200D-2640-FE0F",
              non_qualified: "1F471-1F3FE-200D-2640",
              image: "1f471-1f3fe-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F471-1F3FF-200D-2640-FE0F",
              non_qualified: "1F471-1F3FF-200D-2640",
              image: "1f471-1f3ff-200d-2640-fe0f.png",
              sheet_x: 21,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Blond Haired Woman",
          b: "1F471-200D-2640-FE0F",
          c: "1F471-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 8]
        },
        ideograph_advantage: {
          a: "Circled Ideograph Advantage",
          b: "1F250",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "kanji", "obtain", "get", "circle"],
          k: [5, 42]
        },
        first_quarter_moon_with_face: {
          a: "First Quarter Moon with Face",
          b: "1F31B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 19]
        },
        man_in_tuxedo: {
          skin_variations: {
            "1F3FB": {
              unified: "1F935-1F3FB",
              non_qualified: null,
              image: "1f935-1f3fb.png",
              sheet_x: 39,
              sheet_y: 35,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F935-1F3FC",
              non_qualified: null,
              image: "1f935-1f3fc.png",
              sheet_x: 39,
              sheet_y: 36,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F935-1F3FD",
              non_qualified: null,
              image: "1f935-1f3fd.png",
              sheet_x: 39,
              sheet_y: 37,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F935-1F3FE",
              non_qualified: null,
              image: "1f935-1f3fe.png",
              sheet_x: 39,
              sheet_y: 38,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F935-1F3FF",
              non_qualified: null,
              image: "1f935-1f3ff.png",
              sheet_x: 39,
              sheet_y: 39,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Man in Tuxedo",
          b: "1F935",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["couple", "marriage", "wedding", "groom"],
          k: [39, 34],
          o: 9
        },
        "flag-nc": {
          a: "New Caledonia Flag",
          b: "1F1F3-1F1E8",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 41]
        },
        u5272: {
          a: "Squared Cjk Unified Ideograph-5272",
          b: "1F239",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["cut", "divide", "chinese", "kanji", "pink-square"],
          k: [5, 40]
        },
        "flag-ne": {
          a: "Niger Flag",
          b: "1F1F3-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 42]
        },
        last_quarter_moon_with_face: {
          a: "Last Quarter Moon with Face",
          b: "1F31C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 20]
        },
        u7121: {
          a: "Squared Cjk Unified Ideograph-7121",
          b: "1F21A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nothing", "chinese", "kanji", "japanese", "orange-square"],
          k: [5, 31],
          o: 5
        },
        bride_with_veil: {
          skin_variations: {
            "1F3FB": {
              unified: "1F470-1F3FB",
              non_qualified: null,
              image: "1f470-1f3fb.png",
              sheet_x: 21,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F470-1F3FC",
              non_qualified: null,
              image: "1f470-1f3fc.png",
              sheet_x: 21,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F470-1F3FD",
              non_qualified: null,
              image: "1f470-1f3fd.png",
              sheet_x: 21,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F470-1F3FE",
              non_qualified: null,
              image: "1f470-1f3fe.png",
              sheet_x: 21,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F470-1F3FF",
              non_qualified: null,
              image: "1f470-1f3ff.png",
              sheet_x: 21,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Bride with Veil",
          b: "1F470",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["couple", "marriage", "wedding", "woman", "bride"],
          k: [21, 2]
        },
        u7981: {
          a: "Squared Cjk Unified Ideograph-7981",
          b: "1F232",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["kanji", "japanese", "chinese", "forbidden", "limit", "restricted", "red-square"],
          k: [5, 33]
        },
        pregnant_woman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F930-1F3FB",
              non_qualified: null,
              image: "1f930-1f3fb.png",
              sheet_x: 39,
              sheet_y: 5,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F930-1F3FC",
              non_qualified: null,
              image: "1f930-1f3fc.png",
              sheet_x: 39,
              sheet_y: 6,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F930-1F3FD",
              non_qualified: null,
              image: "1f930-1f3fd.png",
              sheet_x: 39,
              sheet_y: 7,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F930-1F3FE",
              non_qualified: null,
              image: "1f930-1f3fe.png",
              sheet_x: 39,
              sheet_y: 8,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F930-1F3FF",
              non_qualified: null,
              image: "1f930-1f3ff.png",
              sheet_x: 39,
              sheet_y: 9,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Pregnant Woman",
          b: "1F930",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["baby"],
          k: [39, 4],
          o: 9
        },
        thermometer: {
          a: "Thermometer",
          b: "1F321-FE0F",
          c: "1F321",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["weather", "temperature", "hot", "cold"],
          k: [6, 25],
          o: 7
        },
        "flag-nf": {
          a: "Norfolk Island Flag",
          b: "1F1F3-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 43]
        },
        sunny: {
          a: "Black Sun with Rays",
          b: "2600-FE0F",
          c: "2600",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "nature", "brightness", "summer", "beach", "spring"],
          k: [47, 16],
          o: 1
        },
        accept: {
          a: "Circled Ideograph Accept",
          b: "1F251",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["ok", "good", "chinese", "kanji", "agree", "yes", "orange-circle"],
          k: [5, 43]
        },
        "flag-ng": {
          a: "Nigeria Flag",
          b: "1F1F3-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 44]
        },
        "breast-feeding": {
          skin_variations: {
            "1F3FB": {
              unified: "1F931-1F3FB",
              non_qualified: null,
              image: "1f931-1f3fb.png",
              sheet_x: 39,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F931-1F3FC",
              non_qualified: null,
              image: "1f931-1f3fc.png",
              sheet_x: 39,
              sheet_y: 12,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F931-1F3FD",
              non_qualified: null,
              image: "1f931-1f3fd.png",
              sheet_x: 39,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F931-1F3FE",
              non_qualified: null,
              image: "1f931-1f3fe.png",
              sheet_x: 39,
              sheet_y: 14,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F931-1F3FF",
              non_qualified: null,
              image: "1f931-1f3ff.png",
              sheet_x: 39,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Breast-Feeding",
          b: "1F931",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 10],
          o: 10
        },
        full_moon_with_face: {
          a: "Full Moon with Face",
          b: "1F31D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
          k: [6, 21]
        },
        "flag-ni": {
          a: "Nicaragua Flag",
          b: "1F1F3-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 45]
        },
        u7533: {
          a: "Squared Cjk Unified Ideograph-7533",
          b: "1F238",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "japanese", "kanji", "orange-square"],
          k: [5, 39]
        },
        angel: {
          skin_variations: {
            "1F3FB": {
              unified: "1F47C-1F3FB",
              non_qualified: null,
              image: "1f47c-1f3fb.png",
              sheet_x: 22,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F47C-1F3FC",
              non_qualified: null,
              image: "1f47c-1f3fc.png",
              sheet_x: 22,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F47C-1F3FD",
              non_qualified: null,
              image: "1f47c-1f3fd.png",
              sheet_x: 22,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F47C-1F3FE",
              non_qualified: null,
              image: "1f47c-1f3fe.png",
              sheet_x: 22,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F47C-1F3FF",
              non_qualified: null,
              image: "1f47c-1f3ff.png",
              sheet_x: 22,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Baby Angel",
          b: "1F47C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["heaven", "wings", "halo"],
          k: [22, 43]
        },
        sun_with_face: {
          a: "Sun with Face",
          b: "1F31E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "morning", "sky"],
          k: [6, 22]
        },
        santa: {
          skin_variations: {
            "1F3FB": {
              unified: "1F385-1F3FB",
              non_qualified: null,
              image: "1f385-1f3fb.png",
              sheet_x: 8,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F385-1F3FC",
              non_qualified: null,
              image: "1f385-1f3fc.png",
              sheet_x: 8,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F385-1F3FD",
              non_qualified: null,
              image: "1f385-1f3fd.png",
              sheet_x: 8,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F385-1F3FE",
              non_qualified: null,
              image: "1f385-1f3fe.png",
              sheet_x: 8,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F385-1F3FF",
              non_qualified: null,
              image: "1f385-1f3ff.png",
              sheet_x: 8,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Father Christmas",
          b: "1F385",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["festival", "man", "male", "xmas", "father christmas"],
          k: [8, 19]
        },
        u5408: {
          a: "Squared Cjk Unified Ideograph-5408",
          b: "1F234",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "chinese", "join", "kanji", "red-square"],
          k: [5, 35]
        },
        "flag-nl": {
          a: "Netherlands Flag",
          b: "1F1F3-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 46]
        },
        mrs_claus: {
          skin_variations: {
            "1F3FB": {
              unified: "1F936-1F3FB",
              non_qualified: null,
              image: "1f936-1f3fb.png",
              sheet_x: 39,
              sheet_y: 41,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F936-1F3FC",
              non_qualified: null,
              image: "1f936-1f3fc.png",
              sheet_x: 39,
              sheet_y: 42,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F936-1F3FD",
              non_qualified: null,
              image: "1f936-1f3fd.png",
              sheet_x: 39,
              sheet_y: 43,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F936-1F3FE",
              non_qualified: null,
              image: "1f936-1f3fe.png",
              sheet_x: 39,
              sheet_y: 44,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F936-1F3FF",
              non_qualified: null,
              image: "1f936-1f3ff.png",
              sheet_x: 39,
              sheet_y: 45,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Mother Christmas",
          b: "1F936",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["woman", "female", "xmas", "mother christmas"],
          k: [39, 40],
          n: ["mother_christmas"],
          o: 9
        },
        u7a7a: {
          a: "Squared Cjk Unified Ideograph-7a7a",
          b: "1F233",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["kanji", "japanese", "chinese", "empty", "sky", "blue-square"],
          k: [5, 34]
        },
        star: {
          a: "White Medium Star",
          b: "2B50",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["night", "yellow"],
          k: [50, 22],
          o: 5
        },
        "flag-no": {
          a: "Norway Flag",
          b: "1F1F3-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 47]
        },
        mage: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D9-1F3FB",
              non_qualified: null,
              image: "1f9d9-1f3fb.png",
              sheet_x: 44,
              sheet_y: 43,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9D9-1F3FC",
              non_qualified: null,
              image: "1f9d9-1f3fc.png",
              sheet_x: 44,
              sheet_y: 44,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9D9-1F3FD",
              non_qualified: null,
              image: "1f9d9-1f3fd.png",
              sheet_x: 44,
              sheet_y: 45,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9D9-1F3FE",
              non_qualified: null,
              image: "1f9d9-1f3fe.png",
              sheet_x: 44,
              sheet_y: 46,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9D9-1F3FF",
              non_qualified: null,
              image: "1f9d9-1f3ff.png",
              sheet_x: 44,
              sheet_y: 47,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D9-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9D9-200D-2640-FE0F",
          a: "Mage",
          b: "1F9D9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 42],
          o: 10
        },
        star2: {
          a: "Glowing Star",
          b: "1F31F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["night", "sparkle", "awesome", "good", "magic"],
          k: [6, 23]
        },
        "flag-np": {
          a: "Nepal Flag",
          b: "1F1F3-1F1F5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 48]
        },
        congratulations: {
          a: "Circled Ideograph Congratulation",
          b: "3297-FE0F",
          c: "3297",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["chinese", "kanji", "japanese", "red-circle"],
          k: [50, 26],
          o: 1
        },
        "flag-nr": {
          a: "Nauru Flag",
          b: "1F1F3-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 49]
        },
        stars: {
          a: "Shooting Star",
          b: "1F320",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["night", "photo"],
          k: [6, 24]
        },
        female_mage: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D9-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FB-200D-2640",
              image: "1f9d9-1f3fb-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 31,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FB"
            },
            "1F3FC": {
              unified: "1F9D9-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FC-200D-2640",
              image: "1f9d9-1f3fc-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 32,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FC"
            },
            "1F3FD": {
              unified: "1F9D9-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FD-200D-2640",
              image: "1f9d9-1f3fd-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 33,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FD"
            },
            "1F3FE": {
              unified: "1F9D9-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FE-200D-2640",
              image: "1f9d9-1f3fe-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 34,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FE"
            },
            "1F3FF": {
              unified: "1F9D9-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9D9-1F3FF-200D-2640",
              image: "1f9d9-1f3ff-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 35,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D9-1F3FF"
            }
          },
          obsoletes: "1F9D9",
          a: "Female Mage",
          b: "1F9D9-200D-2640-FE0F",
          c: "1F9D9-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 30],
          o: 10
        },
        secret: {
          a: "Circled Ideograph Secret",
          b: "3299-FE0F",
          c: "3299",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["privacy", "chinese", "sshh", "kanji", "red-circle"],
          k: [50, 27],
          o: 1
        },
        "flag-nu": {
          a: "Niue Flag",
          b: "1F1F3-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 50]
        },
        u55b6: {
          a: "Squared Cjk Unified Ideograph-55b6",
          b: "1F23A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["japanese", "opening hours", "orange-square"],
          k: [5, 41]
        },
        male_mage: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D9-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FB-200D-2642",
              image: "1f9d9-1f3fb-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 37,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D9-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FC-200D-2642",
              image: "1f9d9-1f3fc-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 38,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D9-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FD-200D-2642",
              image: "1f9d9-1f3fd-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 39,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D9-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FE-200D-2642",
              image: "1f9d9-1f3fe-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 40,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D9-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9D9-1F3FF-200D-2642",
              image: "1f9d9-1f3ff-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 41,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Mage",
          b: "1F9D9-200D-2642-FE0F",
          c: "1F9D9-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 36],
          o: 10
        },
        cloud: {
          a: "Cloud",
          b: "2601-FE0F",
          c: "2601",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "sky"],
          k: [47, 17],
          o: 1
        },
        "flag-nz": {
          a: "New Zealand Flag",
          b: "1F1F3-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [3, 51]
        },
        partly_sunny: {
          a: "Sun Behind Cloud",
          b: "26C5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "nature", "cloudy", "morning", "fall", "spring"],
          k: [48, 29],
          o: 5
        },
        fairy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DA-1F3FB",
              non_qualified: null,
              image: "1f9da-1f3fb.png",
              sheet_x: 45,
              sheet_y: 9,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9DA-1F3FC",
              non_qualified: null,
              image: "1f9da-1f3fc.png",
              sheet_x: 45,
              sheet_y: 10,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9DA-1F3FD",
              non_qualified: null,
              image: "1f9da-1f3fd.png",
              sheet_x: 45,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9DA-1F3FE",
              non_qualified: null,
              image: "1f9da-1f3fe.png",
              sheet_x: 45,
              sheet_y: 12,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9DA-1F3FF",
              non_qualified: null,
              image: "1f9da-1f3ff.png",
              sheet_x: 45,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DA-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9DA-200D-2640-FE0F",
          a: "Fairy",
          b: "1F9DA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 8],
          o: 10
        },
        u6e80: {
          a: "Squared Cjk Unified Ideograph-6e80",
          b: "1F235",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["full", "chinese", "japanese", "red-square", "kanji"],
          k: [5, 36]
        },
        black_small_square: {
          a: "Black Small Square",
          b: "25AA-FE0F",
          c: "25AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon"],
          k: [47, 8],
          o: 1
        },
        thunder_cloud_and_rain: {
          a: "Thunder Cloud and Rain",
          b: "26C8-FE0F",
          c: "26C8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 30],
          o: 5
        },
        female_fairy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DA-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FB-200D-2640",
              image: "1f9da-1f3fb-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 49,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FB"
            },
            "1F3FC": {
              unified: "1F9DA-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FC-200D-2640",
              image: "1f9da-1f3fc-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 50,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FC"
            },
            "1F3FD": {
              unified: "1F9DA-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FD-200D-2640",
              image: "1f9da-1f3fd-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 51,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FD"
            },
            "1F3FE": {
              unified: "1F9DA-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FE-200D-2640",
              image: "1f9da-1f3fe-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 0,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FE"
            },
            "1F3FF": {
              unified: "1F9DA-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9DA-1F3FF-200D-2640",
              image: "1f9da-1f3ff-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 1,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DA-1F3FF"
            }
          },
          obsoletes: "1F9DA",
          a: "Female Fairy",
          b: "1F9DA-200D-2640-FE0F",
          c: "1F9DA-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 48],
          o: 10
        },
        "flag-om": {
          a: "Oman Flag",
          b: "1F1F4-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 0]
        },
        white_small_square: {
          a: "White Small Square",
          b: "25AB-FE0F",
          c: "25AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon"],
          k: [47, 9],
          o: 1
        },
        "flag-pa": {
          a: "Panama Flag",
          b: "1F1F5-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 1]
        },
        mostly_sunny: {
          a: "Mostly Sunny",
          b: "1F324-FE0F",
          c: "1F324",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 26],
          n: ["sun_small_cloud"],
          o: 7
        },
        male_fairy: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DA-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FB-200D-2642",
              image: "1f9da-1f3fb-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 3,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9DA-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FC-200D-2642",
              image: "1f9da-1f3fc-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 4,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9DA-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FD-200D-2642",
              image: "1f9da-1f3fd-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 5,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9DA-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FE-200D-2642",
              image: "1f9da-1f3fe-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 6,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9DA-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9DA-1F3FF-200D-2642",
              image: "1f9da-1f3ff-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 7,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Fairy",
          b: "1F9DA-200D-2642-FE0F",
          c: "1F9DA-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 2],
          o: 10
        },
        barely_sunny: {
          a: "Barely Sunny",
          b: "1F325-FE0F",
          c: "1F325",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 27],
          n: ["sun_behind_cloud"],
          o: 7
        },
        white_medium_square: {
          a: "White Medium Square",
          b: "25FB-FE0F",
          c: "25FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "stone", "icon"],
          k: [47, 12],
          o: 3
        },
        "flag-pe": {
          a: "Peru Flag",
          b: "1F1F5-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 2]
        },
        vampire: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DB-1F3FB",
              non_qualified: null,
              image: "1f9db-1f3fb.png",
              sheet_x: 45,
              sheet_y: 27,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9DB-1F3FC",
              non_qualified: null,
              image: "1f9db-1f3fc.png",
              sheet_x: 45,
              sheet_y: 28,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9DB-1F3FD",
              non_qualified: null,
              image: "1f9db-1f3fd.png",
              sheet_x: 45,
              sheet_y: 29,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9DB-1F3FE",
              non_qualified: null,
              image: "1f9db-1f3fe.png",
              sheet_x: 45,
              sheet_y: 30,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9DB-1F3FF",
              non_qualified: null,
              image: "1f9db-1f3ff.png",
              sheet_x: 45,
              sheet_y: 31,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoleted_by: "1F9DB-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9DB-200D-2640-FE0F",
          a: "Vampire",
          b: "1F9DB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 26],
          o: 10
        },
        female_vampire: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DB-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FB-200D-2640",
              image: "1f9db-1f3fb-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FB"
            },
            "1F3FC": {
              unified: "1F9DB-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FC-200D-2640",
              image: "1f9db-1f3fc-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 16,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FC"
            },
            "1F3FD": {
              unified: "1F9DB-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FD-200D-2640",
              image: "1f9db-1f3fd-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 17,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FD"
            },
            "1F3FE": {
              unified: "1F9DB-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FE-200D-2640",
              image: "1f9db-1f3fe-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 18,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FE"
            },
            "1F3FF": {
              unified: "1F9DB-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9DB-1F3FF-200D-2640",
              image: "1f9db-1f3ff-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DB-1F3FF"
            }
          },
          obsoletes: "1F9DB",
          a: "Female Vampire",
          b: "1F9DB-200D-2640-FE0F",
          c: "1F9DB-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 14],
          o: 10
        },
        partly_sunny_rain: {
          a: "Partly Sunny Rain",
          b: "1F326-FE0F",
          c: "1F326",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 28],
          n: ["sun_behind_rain_cloud"],
          o: 7
        },
        "flag-pf": {
          a: "French Polynesia Flag",
          b: "1F1F5-1F1EB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 3]
        },
        black_medium_square: {
          a: "Black Medium Square",
          b: "25FC-FE0F",
          c: "25FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "button", "icon"],
          k: [47, 13],
          o: 3
        },
        white_medium_small_square: {
          a: "White Medium Small Square",
          b: "25FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "stone", "icon", "button"],
          k: [47, 14],
          o: 3
        },
        rain_cloud: {
          a: "Rain Cloud",
          b: "1F327-FE0F",
          c: "1F327",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 29],
          o: 7
        },
        "flag-pg": {
          a: "Papua New Guinea Flag",
          b: "1F1F5-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 4]
        },
        male_vampire: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DB-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FB-200D-2642",
              image: "1f9db-1f3fb-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9DB-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FC-200D-2642",
              image: "1f9db-1f3fc-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 22,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9DB-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FD-200D-2642",
              image: "1f9db-1f3fd-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 23,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9DB-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FE-200D-2642",
              image: "1f9db-1f3fe-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 24,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9DB-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9DB-1F3FF-200D-2642",
              image: "1f9db-1f3ff-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 25,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Male Vampire",
          b: "1F9DB-200D-2642-FE0F",
          c: "1F9DB-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 20],
          o: 10
        },
        "flag-ph": {
          a: "Philippines Flag",
          b: "1F1F5-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 5]
        },
        merperson: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DC-1F3FB",
              non_qualified: null,
              image: "1f9dc-1f3fb.png",
              sheet_x: 45,
              sheet_y: 45,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FB-200D-2642-FE0F"
            },
            "1F3FC": {
              unified: "1F9DC-1F3FC",
              non_qualified: null,
              image: "1f9dc-1f3fc.png",
              sheet_x: 45,
              sheet_y: 46,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FC-200D-2642-FE0F"
            },
            "1F3FD": {
              unified: "1F9DC-1F3FD",
              non_qualified: null,
              image: "1f9dc-1f3fd.png",
              sheet_x: 45,
              sheet_y: 47,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FD-200D-2642-FE0F"
            },
            "1F3FE": {
              unified: "1F9DC-1F3FE",
              non_qualified: null,
              image: "1f9dc-1f3fe.png",
              sheet_x: 45,
              sheet_y: 48,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FE-200D-2642-FE0F"
            },
            "1F3FF": {
              unified: "1F9DC-1F3FF",
              non_qualified: null,
              image: "1f9dc-1f3ff.png",
              sheet_x: 45,
              sheet_y: 49,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DC-1F3FF-200D-2642-FE0F"
            }
          },
          obsoleted_by: "1F9DC-200D-2642-FE0F",
          a: "Merperson",
          b: "1F9DC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 44],
          o: 10
        },
        black_medium_small_square: {
          a: "Black Medium Small Square",
          b: "25FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["icon", "shape", "button"],
          k: [47, 15],
          o: 3
        },
        snow_cloud: {
          a: "Snow Cloud",
          b: "1F328-FE0F",
          c: "1F328",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 30],
          o: 7
        },
        lightning: {
          a: "Lightning",
          b: "1F329-FE0F",
          c: "1F329",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 31],
          n: ["lightning_cloud"],
          o: 7
        },
        black_large_square: {
          a: "Black Large Square",
          b: "2B1B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon", "button"],
          k: [50, 20],
          o: 5
        },
        mermaid: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DC-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FB-200D-2640",
              image: "1f9dc-1f3fb-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 33,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9DC-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FC-200D-2640",
              image: "1f9dc-1f3fc-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 34,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9DC-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FD-200D-2640",
              image: "1f9dc-1f3fd-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 35,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9DC-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FE-200D-2640",
              image: "1f9dc-1f3fe-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 36,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9DC-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9DC-1F3FF-200D-2640",
              image: "1f9dc-1f3ff-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 37,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Mermaid",
          b: "1F9DC-200D-2640-FE0F",
          c: "1F9DC-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 32],
          o: 10
        },
        "flag-pk": {
          a: "Pakistan Flag",
          b: "1F1F5-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 6]
        },
        merman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DC-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FB-200D-2642",
              image: "1f9dc-1f3fb-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 39,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FB"
            },
            "1F3FC": {
              unified: "1F9DC-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FC-200D-2642",
              image: "1f9dc-1f3fc-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 40,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FC"
            },
            "1F3FD": {
              unified: "1F9DC-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FD-200D-2642",
              image: "1f9dc-1f3fd-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 41,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FD"
            },
            "1F3FE": {
              unified: "1F9DC-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FE-200D-2642",
              image: "1f9dc-1f3fe-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 42,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FE"
            },
            "1F3FF": {
              unified: "1F9DC-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9DC-1F3FF-200D-2642",
              image: "1f9dc-1f3ff-200d-2642-fe0f.png",
              sheet_x: 45,
              sheet_y: 43,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DC-1F3FF"
            }
          },
          obsoletes: "1F9DC",
          a: "Merman",
          b: "1F9DC-200D-2642-FE0F",
          c: "1F9DC-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 38],
          o: 10
        },
        white_large_square: {
          a: "White Large Square",
          b: "2B1C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon", "stone", "button"],
          k: [50, 21],
          o: 5
        },
        tornado: {
          a: "Tornado",
          b: "1F32A-FE0F",
          c: "1F32A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["weather", "cyclone", "twister"],
          k: [6, 32],
          n: ["tornado_cloud"],
          o: 7
        },
        "flag-pl": {
          a: "Poland Flag",
          b: "1F1F5-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 7]
        },
        elf: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DD-1F3FB",
              non_qualified: null,
              image: "1f9dd-1f3fb.png",
              sheet_x: 46,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FB-200D-2642-FE0F"
            },
            "1F3FC": {
              unified: "1F9DD-1F3FC",
              non_qualified: null,
              image: "1f9dd-1f3fc.png",
              sheet_x: 46,
              sheet_y: 12,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FC-200D-2642-FE0F"
            },
            "1F3FD": {
              unified: "1F9DD-1F3FD",
              non_qualified: null,
              image: "1f9dd-1f3fd.png",
              sheet_x: 46,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FD-200D-2642-FE0F"
            },
            "1F3FE": {
              unified: "1F9DD-1F3FE",
              non_qualified: null,
              image: "1f9dd-1f3fe.png",
              sheet_x: 46,
              sheet_y: 14,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FE-200D-2642-FE0F"
            },
            "1F3FF": {
              unified: "1F9DD-1F3FF",
              non_qualified: null,
              image: "1f9dd-1f3ff.png",
              sheet_x: 46,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9DD-1F3FF-200D-2642-FE0F"
            }
          },
          obsoleted_by: "1F9DD-200D-2642-FE0F",
          a: "Elf",
          b: "1F9DD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 10],
          o: 10
        },
        fog: {
          a: "Fog",
          b: "1F32B-FE0F",
          c: "1F32B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["weather"],
          k: [6, 33],
          o: 7
        },
        large_orange_diamond: {
          a: "Large Orange Diamond",
          b: "1F536",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "jewel", "gem"],
          k: [28, 4]
        },
        "flag-pm": {
          a: "St. Pierre & Miquelon Flag",
          b: "1F1F5-1F1F2",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 8]
        },
        "flag-pn": {
          a: "Pitcairn Islands Flag",
          b: "1F1F5-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 9]
        },
        wind_blowing_face: {
          a: "Wind Blowing Face",
          b: "1F32C-FE0F",
          c: "1F32C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [6, 34],
          o: 7
        },
        female_elf: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DD-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FB-200D-2640",
              image: "1f9dd-1f3fb-200d-2640-fe0f.png",
              sheet_x: 45,
              sheet_y: 51,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9DD-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FC-200D-2640",
              image: "1f9dd-1f3fc-200d-2640-fe0f.png",
              sheet_x: 46,
              sheet_y: 0,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9DD-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FD-200D-2640",
              image: "1f9dd-1f3fd-200d-2640-fe0f.png",
              sheet_x: 46,
              sheet_y: 1,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9DD-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FE-200D-2640",
              image: "1f9dd-1f3fe-200d-2640-fe0f.png",
              sheet_x: 46,
              sheet_y: 2,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9DD-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9DD-1F3FF-200D-2640",
              image: "1f9dd-1f3ff-200d-2640-fe0f.png",
              sheet_x: 46,
              sheet_y: 3,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Female Elf",
          b: "1F9DD-200D-2640-FE0F",
          c: "1F9DD-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [45, 50],
          o: 10
        },
        large_blue_diamond: {
          a: "Large Blue Diamond",
          b: "1F537",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "jewel", "gem"],
          k: [28, 5]
        },
        male_elf: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9DD-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FB-200D-2642",
              image: "1f9dd-1f3fb-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 5,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FB"
            },
            "1F3FC": {
              unified: "1F9DD-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FC-200D-2642",
              image: "1f9dd-1f3fc-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 6,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FC"
            },
            "1F3FD": {
              unified: "1F9DD-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FD-200D-2642",
              image: "1f9dd-1f3fd-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 7,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FD"
            },
            "1F3FE": {
              unified: "1F9DD-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FE-200D-2642",
              image: "1f9dd-1f3fe-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 8,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FE"
            },
            "1F3FF": {
              unified: "1F9DD-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9DD-1F3FF-200D-2642",
              image: "1f9dd-1f3ff-200d-2642-fe0f.png",
              sheet_x: 46,
              sheet_y: 9,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9DD-1F3FF"
            }
          },
          obsoletes: "1F9DD",
          a: "Male Elf",
          b: "1F9DD-200D-2642-FE0F",
          c: "1F9DD-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 4],
          o: 10
        },
        small_orange_diamond: {
          a: "Small Orange Diamond",
          b: "1F538",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "jewel", "gem"],
          k: [28, 6]
        },
        "flag-pr": {
          a: "Puerto Rico Flag",
          b: "1F1F5-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 10]
        },
        cyclone: {
          a: "Cyclone",
          b: "1F300",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "swirl", "blue", "cloud", "vortex", "spiral", "whirlpool", "spin", "tornado", "hurricane", "typhoon"],
          k: [5, 44]
        },
        rainbow: {
          a: "Rainbow",
          b: "1F308",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["nature", "happy", "unicorn_face", "photo", "sky", "spring"],
          k: [6, 0]
        },
        small_blue_diamond: {
          a: "Small Blue Diamond",
          b: "1F539",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "jewel", "gem"],
          k: [28, 7]
        },
        genie: {
          obsoleted_by: "1F9DE-200D-2642-FE0F",
          a: "Genie",
          b: "1F9DE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 18],
          o: 10
        },
        "flag-ps": {
          a: "Palestinian Territories Flag",
          b: "1F1F5-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 11]
        },
        small_red_triangle: {
          a: "Up-Pointing Red Triangle",
          b: "1F53A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "direction", "up", "top"],
          k: [28, 8]
        },
        closed_umbrella: {
          a: "Closed Umbrella",
          b: "1F302",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["weather", "rain", "drizzle"],
          k: [5, 46]
        },
        female_genie: {
          a: "Female Genie",
          b: "1F9DE-200D-2640-FE0F",
          c: "1F9DE-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 16],
          o: 10
        },
        "flag-pt": {
          a: "Portugal Flag",
          b: "1F1F5-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 12]
        },
        "flag-pw": {
          a: "Palau Flag",
          b: "1F1F5-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 13]
        },
        small_red_triangle_down: {
          a: "Down-Pointing Red Triangle",
          b: "1F53B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "direction", "bottom"],
          k: [28, 9]
        },
        umbrella: {
          a: "Umbrella",
          b: "2602-FE0F",
          c: "2602",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["rainy", "weather", "spring"],
          k: [47, 18],
          o: 1
        },
        male_genie: {
          obsoletes: "1F9DE",
          a: "Male Genie",
          b: "1F9DE-200D-2642-FE0F",
          c: "1F9DE-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 17],
          o: 10
        },
        zombie: {
          obsoleted_by: "1F9DF-200D-2642-FE0F",
          a: "Zombie",
          b: "1F9DF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 21],
          o: 10
        },
        "flag-py": {
          a: "Paraguay Flag",
          b: "1F1F5-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 14]
        },
        diamond_shape_with_a_dot_inside: {
          a: "Diamond Shape with a Dot Inside",
          b: "1F4A0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["jewel", "blue", "gem", "crystal", "fancy"],
          k: [25, 6]
        },
        umbrella_with_rain_drops: {
          a: "Umbrella with Rain Drops",
          b: "2614",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [47, 23],
          o: 4
        },
        radio_button: {
          a: "Radio Button",
          b: "1F518",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["input", "old", "music", "circle"],
          k: [27, 26]
        },
        female_zombie: {
          a: "Female Zombie",
          b: "1F9DF-200D-2640-FE0F",
          c: "1F9DF-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 19],
          o: 10
        },
        "flag-qa": {
          a: "Qatar Flag",
          b: "1F1F6-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 15]
        },
        umbrella_on_ground: {
          a: "Umbrella on Ground",
          b: "26F1-FE0F",
          c: "26F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 39],
          o: 5
        },
        black_square_button: {
          a: "Black Square Button",
          b: "1F532",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "input", "frame"],
          k: [28, 0]
        },
        zap: {
          a: "High Voltage Sign",
          b: "26A1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["thunder", "weather", "lightning bolt", "fast"],
          k: [48, 21],
          o: 4
        },
        male_zombie: {
          obsoletes: "1F9DF",
          a: "Male Zombie",
          b: "1F9DF-200D-2642-FE0F",
          c: "1F9DF-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 20],
          o: 10
        },
        "flag-re": {
          a: "R\xe9union Flag",
          b: "1F1F7-1F1EA",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 16]
        },
        "flag-ro": {
          a: "Romania Flag",
          b: "1F1F7-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 17]
        },
        snowflake: {
          a: "Snowflake",
          b: "2744-FE0F",
          c: "2744",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["winter", "season", "cold", "weather", "christmas", "xmas"],
          k: [49, 51],
          o: 1
        },
        white_square_button: {
          a: "White Square Button",
          b: "1F533",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "input"],
          k: [28, 1]
        },
        person_frowning: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64D-1F3FB",
              non_qualified: null,
              image: "1f64d-1f3fb.png",
              sheet_x: 33,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64D-1F3FC",
              non_qualified: null,
              image: "1f64d-1f3fc.png",
              sheet_x: 33,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64D-1F3FD",
              non_qualified: null,
              image: "1f64d-1f3fd.png",
              sheet_x: 33,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64D-1F3FE",
              non_qualified: null,
              image: "1f64d-1f3fe.png",
              sheet_x: 33,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64D-1F3FF",
              non_qualified: null,
              image: "1f64d-1f3ff.png",
              sheet_x: 33,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F64D-200D-2640-FE0F",
          a: "Person Frowning",
          b: "1F64D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [33, 30]
        },
        "flag-rs": {
          a: "Serbia Flag",
          b: "1F1F7-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 18]
        },
        "man-frowning": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64D-1F3FB-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FB-200D-2642",
              image: "1f64d-1f3fb-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64D-1F3FC-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FC-200D-2642",
              image: "1f64d-1f3fc-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64D-1F3FD-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FD-200D-2642",
              image: "1f64d-1f3fd-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64D-1F3FE-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FE-200D-2642",
              image: "1f64d-1f3fe-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64D-1F3FF-200D-2642-FE0F",
              non_qualified: "1F64D-1F3FF-200D-2642",
              image: "1f64d-1f3ff-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Frowning",
          b: "1F64D-200D-2642-FE0F",
          c: "1F64D-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 24]
        },
        white_circle: {
          a: "Medium White Circle",
          b: "26AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "round"],
          k: [48, 22],
          o: 4
        },
        snowman: {
          a: "Snowman",
          b: "2603-FE0F",
          c: "2603",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["winter", "season", "cold", "weather", "christmas", "xmas", "frozen", "without_snow"],
          k: [47, 19],
          o: 1
        },
        snowman_without_snow: {
          a: "Snowman Without Snow",
          b: "26C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [48, 28],
          o: 5
        },
        ru: {
          a: "Russia Flag",
          b: "1F1F7-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["russian", "federation", "flag", "nation", "country", "banner"],
          k: [4, 19],
          n: ["flag-ru"]
        },
        black_circle: {
          a: "Medium Black Circle",
          b: "26AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "button", "round"],
          k: [48, 23],
          o: 4
        },
        "woman-frowning": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64D-1F3FB-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FB-200D-2640",
              image: "1f64d-1f3fb-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64D-1F3FC-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FC-200D-2640",
              image: "1f64d-1f3fc-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64D-1F3FD-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FD-200D-2640",
              image: "1f64d-1f3fd-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64D-1F3FE-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FE-200D-2640",
              image: "1f64d-1f3fe-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64D-1F3FF-200D-2640-FE0F",
              non_qualified: "1F64D-1F3FF-200D-2640",
              image: "1f64d-1f3ff-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F64D",
          a: "Woman Frowning",
          b: "1F64D-200D-2640-FE0F",
          c: "1F64D-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 18]
        },
        "flag-rw": {
          a: "Rwanda Flag",
          b: "1F1F7-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 20]
        },
        comet: {
          a: "Comet",
          b: "2604-FE0F",
          c: "2604",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["space"],
          k: [47, 20],
          o: 1
        },
        person_with_pouting_face: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64E-1F3FB",
              non_qualified: null,
              image: "1f64e-1f3fb.png",
              sheet_x: 33,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64E-1F3FC",
              non_qualified: null,
              image: "1f64e-1f3fc.png",
              sheet_x: 33,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64E-1F3FD",
              non_qualified: null,
              image: "1f64e-1f3fd.png",
              sheet_x: 33,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64E-1F3FE",
              non_qualified: null,
              image: "1f64e-1f3fe.png",
              sheet_x: 34,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64E-1F3FF",
              non_qualified: null,
              image: "1f64e-1f3ff.png",
              sheet_x: 34,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F64E-200D-2640-FE0F",
          a: "Person with Pouting Face",
          b: "1F64E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [33, 48]
        },
        red_circle: {
          a: "Large Red Circle",
          b: "1F534",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "error", "danger"],
          k: [28, 2]
        },
        large_blue_circle: {
          a: "Large Blue Circle",
          b: "1F535",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shape", "icon", "button"],
          k: [28, 3]
        },
        "man-pouting": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64E-1F3FB-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FB-200D-2642",
              image: "1f64e-1f3fb-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64E-1F3FC-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FC-200D-2642",
              image: "1f64e-1f3fc-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64E-1F3FD-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FD-200D-2642",
              image: "1f64e-1f3fd-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64E-1F3FE-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FE-200D-2642",
              image: "1f64e-1f3fe-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64E-1F3FF-200D-2642-FE0F",
              non_qualified: "1F64E-1F3FF-200D-2642",
              image: "1f64e-1f3ff-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Pouting",
          b: "1F64E-200D-2642-FE0F",
          c: "1F64E-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 42]
        },
        "flag-sa": {
          a: "Saudi Arabia Flag",
          b: "1F1F8-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 21]
        },
        fire: {
          a: "Fire",
          b: "1F525",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hot", "cook", "flame"],
          k: [27, 39]
        },
        "woman-pouting": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64E-1F3FB-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FB-200D-2640",
              image: "1f64e-1f3fb-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64E-1F3FC-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FC-200D-2640",
              image: "1f64e-1f3fc-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64E-1F3FD-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FD-200D-2640",
              image: "1f64e-1f3fd-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64E-1F3FE-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FE-200D-2640",
              image: "1f64e-1f3fe-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64E-1F3FF-200D-2640-FE0F",
              non_qualified: "1F64E-1F3FF-200D-2640",
              image: "1f64e-1f3ff-200d-2640-fe0f.png",
              sheet_x: 33,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F64E",
          a: "Woman Pouting",
          b: "1F64E-200D-2640-FE0F",
          c: "1F64E-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 36]
        },
        "flag-sb": {
          a: "Solomon Islands Flag",
          b: "1F1F8-1F1E7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 22]
        },
        droplet: {
          a: "Droplet",
          b: "1F4A7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["water", "drip", "faucet", "spring"],
          k: [25, 13]
        },
        no_good: {
          skin_variations: {
            "1F3FB": {
              unified: "1F645-1F3FB",
              non_qualified: null,
              image: "1f645-1f3fb.png",
              sheet_x: 32,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F645-1F3FC",
              non_qualified: null,
              image: "1f645-1f3fc.png",
              sheet_x: 32,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F645-1F3FD",
              non_qualified: null,
              image: "1f645-1f3fd.png",
              sheet_x: 32,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F645-1F3FE",
              non_qualified: null,
              image: "1f645-1f3fe.png",
              sheet_x: 32,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F645-1F3FF",
              non_qualified: null,
              image: "1f645-1f3ff.png",
              sheet_x: 32,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F645-200D-2640-FE0F",
          a: "Face with No Good Gesture",
          b: "1F645",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [32, 1]
        },
        "flag-sc": {
          a: "Seychelles Flag",
          b: "1F1F8-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 23]
        },
        ocean: {
          a: "Water Wave",
          b: "1F30A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sea", "water", "wave", "nature", "tsunami", "disaster"],
          k: [6, 2]
        },
        "man-gesturing-no": {
          skin_variations: {
            "1F3FB": {
              unified: "1F645-1F3FB-200D-2642-FE0F",
              non_qualified: "1F645-1F3FB-200D-2642",
              image: "1f645-1f3fb-200d-2642-fe0f.png",
              sheet_x: 31,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F645-1F3FC-200D-2642-FE0F",
              non_qualified: "1F645-1F3FC-200D-2642",
              image: "1f645-1f3fc-200d-2642-fe0f.png",
              sheet_x: 31,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F645-1F3FD-200D-2642-FE0F",
              non_qualified: "1F645-1F3FD-200D-2642",
              image: "1f645-1f3fd-200d-2642-fe0f.png",
              sheet_x: 31,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F645-1F3FE-200D-2642-FE0F",
              non_qualified: "1F645-1F3FE-200D-2642",
              image: "1f645-1f3fe-200d-2642-fe0f.png",
              sheet_x: 31,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F645-1F3FF-200D-2642-FE0F",
              non_qualified: "1F645-1F3FF-200D-2642",
              image: "1f645-1f3ff-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Gesturing No",
          b: "1F645-200D-2642-FE0F",
          c: "1F645-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [31, 47]
        },
        "flag-sd": {
          a: "Sudan Flag",
          b: "1F1F8-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 24]
        },
        "woman-gesturing-no": {
          skin_variations: {
            "1F3FB": {
              unified: "1F645-1F3FB-200D-2640-FE0F",
              non_qualified: "1F645-1F3FB-200D-2640",
              image: "1f645-1f3fb-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F645-1F3FC-200D-2640-FE0F",
              non_qualified: "1F645-1F3FC-200D-2640",
              image: "1f645-1f3fc-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F645-1F3FD-200D-2640-FE0F",
              non_qualified: "1F645-1F3FD-200D-2640",
              image: "1f645-1f3fd-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F645-1F3FE-200D-2640-FE0F",
              non_qualified: "1F645-1F3FE-200D-2640",
              image: "1f645-1f3fe-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F645-1F3FF-200D-2640-FE0F",
              non_qualified: "1F645-1F3FF-200D-2640",
              image: "1f645-1f3ff-200d-2640-fe0f.png",
              sheet_x: 31,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F645",
          a: "Woman Gesturing No",
          b: "1F645-200D-2640-FE0F",
          c: "1F645-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [31, 41]
        },
        "flag-se": {
          a: "Sweden Flag",
          b: "1F1F8-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 25]
        },
        "flag-sg": {
          a: "Singapore Flag",
          b: "1F1F8-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 26]
        },
        ok_woman: {
          skin_variations: {
            "1F3FB": {
              unified: "1F646-1F3FB",
              non_qualified: null,
              image: "1f646-1f3fb.png",
              sheet_x: 32,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F646-1F3FC",
              non_qualified: null,
              image: "1f646-1f3fc.png",
              sheet_x: 32,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F646-1F3FD",
              non_qualified: null,
              image: "1f646-1f3fd.png",
              sheet_x: 32,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F646-1F3FE",
              non_qualified: null,
              image: "1f646-1f3fe.png",
              sheet_x: 32,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F646-1F3FF",
              non_qualified: null,
              image: "1f646-1f3ff.png",
              sheet_x: 32,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F646-200D-2640-FE0F",
          a: "Face with Ok Gesture",
          b: "1F646",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          j: ["women", "girl", "female", "pink", "human", "woman"],
          k: [32, 19]
        },
        "flag-sh": {
          a: "St. Helena Flag",
          b: "1F1F8-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 27]
        },
        "man-gesturing-ok": {
          skin_variations: {
            "1F3FB": {
              unified: "1F646-1F3FB-200D-2642-FE0F",
              non_qualified: "1F646-1F3FB-200D-2642",
              image: "1f646-1f3fb-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F646-1F3FC-200D-2642-FE0F",
              non_qualified: "1F646-1F3FC-200D-2642",
              image: "1f646-1f3fc-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F646-1F3FD-200D-2642-FE0F",
              non_qualified: "1F646-1F3FD-200D-2642",
              image: "1f646-1f3fd-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F646-1F3FE-200D-2642-FE0F",
              non_qualified: "1F646-1F3FE-200D-2642",
              image: "1f646-1f3fe-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F646-1F3FF-200D-2642-FE0F",
              non_qualified: "1F646-1F3FF-200D-2642",
              image: "1f646-1f3ff-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Gesturing Ok",
          b: "1F646-200D-2642-FE0F",
          c: "1F646-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 13]
        },
        "flag-si": {
          a: "Slovenia Flag",
          b: "1F1F8-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 28]
        },
        "woman-gesturing-ok": {
          skin_variations: {
            "1F3FB": {
              unified: "1F646-1F3FB-200D-2640-FE0F",
              non_qualified: "1F646-1F3FB-200D-2640",
              image: "1f646-1f3fb-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F646-1F3FC-200D-2640-FE0F",
              non_qualified: "1F646-1F3FC-200D-2640",
              image: "1f646-1f3fc-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F646-1F3FD-200D-2640-FE0F",
              non_qualified: "1F646-1F3FD-200D-2640",
              image: "1f646-1f3fd-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F646-1F3FE-200D-2640-FE0F",
              non_qualified: "1F646-1F3FE-200D-2640",
              image: "1f646-1f3fe-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F646-1F3FF-200D-2640-FE0F",
              non_qualified: "1F646-1F3FF-200D-2640",
              image: "1f646-1f3ff-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F646",
          a: "Woman Gesturing Ok",
          b: "1F646-200D-2640-FE0F",
          c: "1F646-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 7]
        },
        information_desk_person: {
          skin_variations: {
            "1F3FB": {
              unified: "1F481-1F3FB",
              non_qualified: null,
              image: "1f481-1f3fb.png",
              sheet_x: 23,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F481-1F3FC",
              non_qualified: null,
              image: "1f481-1f3fc.png",
              sheet_x: 23,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F481-1F3FD",
              non_qualified: null,
              image: "1f481-1f3fd.png",
              sheet_x: 23,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F481-1F3FE",
              non_qualified: null,
              image: "1f481-1f3fe.png",
              sheet_x: 23,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F481-1F3FF",
              non_qualified: null,
              image: "1f481-1f3ff.png",
              sheet_x: 23,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F481-200D-2640-FE0F",
          a: "Information Desk Person",
          b: "1F481",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [23, 13]
        },
        "flag-sj": {
          a: "Svalbard & Jan Mayen Flag",
          b: "1F1F8-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 29]
        },
        "man-tipping-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F481-1F3FB-200D-2642-FE0F",
              non_qualified: "1F481-1F3FB-200D-2642",
              image: "1f481-1f3fb-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F481-1F3FC-200D-2642-FE0F",
              non_qualified: "1F481-1F3FC-200D-2642",
              image: "1f481-1f3fc-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F481-1F3FD-200D-2642-FE0F",
              non_qualified: "1F481-1F3FD-200D-2642",
              image: "1f481-1f3fd-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F481-1F3FE-200D-2642-FE0F",
              non_qualified: "1F481-1F3FE-200D-2642",
              image: "1f481-1f3fe-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F481-1F3FF-200D-2642-FE0F",
              non_qualified: "1F481-1F3FF-200D-2642",
              image: "1f481-1f3ff-200d-2642-fe0f.png",
              sheet_x: 23,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Tipping Hand",
          b: "1F481-200D-2642-FE0F",
          c: "1F481-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 7]
        },
        "flag-sk": {
          a: "Slovakia Flag",
          b: "1F1F8-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 30]
        },
        "flag-sl": {
          a: "Sierra Leone Flag",
          b: "1F1F8-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 31]
        },
        "woman-tipping-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F481-1F3FB-200D-2640-FE0F",
              non_qualified: "1F481-1F3FB-200D-2640",
              image: "1f481-1f3fb-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F481-1F3FC-200D-2640-FE0F",
              non_qualified: "1F481-1F3FC-200D-2640",
              image: "1f481-1f3fc-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F481-1F3FD-200D-2640-FE0F",
              non_qualified: "1F481-1F3FD-200D-2640",
              image: "1f481-1f3fd-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F481-1F3FE-200D-2640-FE0F",
              non_qualified: "1F481-1F3FE-200D-2640",
              image: "1f481-1f3fe-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F481-1F3FF-200D-2640-FE0F",
              non_qualified: "1F481-1F3FF-200D-2640",
              image: "1f481-1f3ff-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F481",
          a: "Woman Tipping Hand",
          b: "1F481-200D-2640-FE0F",
          c: "1F481-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 1]
        },
        "flag-sm": {
          a: "San Marino Flag",
          b: "1F1F8-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 32]
        },
        raising_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64B-1F3FB",
              non_qualified: null,
              image: "1f64b-1f3fb.png",
              sheet_x: 33,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64B-1F3FC",
              non_qualified: null,
              image: "1f64b-1f3fc.png",
              sheet_x: 33,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64B-1F3FD",
              non_qualified: null,
              image: "1f64b-1f3fd.png",
              sheet_x: 33,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64B-1F3FE",
              non_qualified: null,
              image: "1f64b-1f3fe.png",
              sheet_x: 33,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64B-1F3FF",
              non_qualified: null,
              image: "1f64b-1f3ff.png",
              sheet_x: 33,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F64B-200D-2640-FE0F",
          a: "Happy Person Raising One Hand",
          b: "1F64B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [33, 6]
        },
        "flag-sn": {
          a: "Senegal Flag",
          b: "1F1F8-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 33]
        },
        "man-raising-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64B-1F3FB-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FB-200D-2642",
              image: "1f64b-1f3fb-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64B-1F3FC-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FC-200D-2642",
              image: "1f64b-1f3fc-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64B-1F3FD-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FD-200D-2642",
              image: "1f64b-1f3fd-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64B-1F3FE-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FE-200D-2642",
              image: "1f64b-1f3fe-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64B-1F3FF-200D-2642-FE0F",
              non_qualified: "1F64B-1F3FF-200D-2642",
              image: "1f64b-1f3ff-200d-2642-fe0f.png",
              sheet_x: 33,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Raising Hand",
          b: "1F64B-200D-2642-FE0F",
          c: "1F64B-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [33, 0]
        },
        "flag-so": {
          a: "Somalia Flag",
          b: "1F1F8-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 34]
        },
        "woman-raising-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F64B-1F3FB-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FB-200D-2640",
              image: "1f64b-1f3fb-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F64B-1F3FC-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FC-200D-2640",
              image: "1f64b-1f3fc-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F64B-1F3FD-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FD-200D-2640",
              image: "1f64b-1f3fd-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F64B-1F3FE-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FE-200D-2640",
              image: "1f64b-1f3fe-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F64B-1F3FF-200D-2640-FE0F",
              non_qualified: "1F64B-1F3FF-200D-2640",
              image: "1f64b-1f3ff-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F64B",
          a: "Woman Raising Hand",
          b: "1F64B-200D-2640-FE0F",
          c: "1F64B-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 46]
        },
        "flag-sr": {
          a: "Suriname Flag",
          b: "1F1F8-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 35]
        },
        bow: {
          skin_variations: {
            "1F3FB": {
              unified: "1F647-1F3FB",
              non_qualified: null,
              image: "1f647-1f3fb.png",
              sheet_x: 32,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F647-1F3FC",
              non_qualified: null,
              image: "1f647-1f3fc.png",
              sheet_x: 32,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F647-1F3FD",
              non_qualified: null,
              image: "1f647-1f3fd.png",
              sheet_x: 32,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F647-1F3FE",
              non_qualified: null,
              image: "1f647-1f3fe.png",
              sheet_x: 32,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F647-1F3FF",
              non_qualified: null,
              image: "1f647-1f3ff.png",
              sheet_x: 32,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F647-200D-2642-FE0F",
          a: "Person Bowing Deeply",
          b: "1F647",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [32, 37]
        },
        "man-bowing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F647-1F3FB-200D-2642-FE0F",
              non_qualified: "1F647-1F3FB-200D-2642",
              image: "1f647-1f3fb-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F647-1F3FC-200D-2642-FE0F",
              non_qualified: "1F647-1F3FC-200D-2642",
              image: "1f647-1f3fc-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F647-1F3FD-200D-2642-FE0F",
              non_qualified: "1F647-1F3FD-200D-2642",
              image: "1f647-1f3fd-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F647-1F3FE-200D-2642-FE0F",
              non_qualified: "1F647-1F3FE-200D-2642",
              image: "1f647-1f3fe-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F647-1F3FF-200D-2642-FE0F",
              non_qualified: "1F647-1F3FF-200D-2642",
              image: "1f647-1f3ff-200d-2642-fe0f.png",
              sheet_x: 32,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F647",
          a: "Man Bowing",
          b: "1F647-200D-2642-FE0F",
          c: "1F647-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 31]
        },
        "flag-ss": {
          a: "South Sudan Flag",
          b: "1F1F8-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 36]
        },
        "woman-bowing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F647-1F3FB-200D-2640-FE0F",
              non_qualified: "1F647-1F3FB-200D-2640",
              image: "1f647-1f3fb-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F647-1F3FC-200D-2640-FE0F",
              non_qualified: "1F647-1F3FC-200D-2640",
              image: "1f647-1f3fc-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F647-1F3FD-200D-2640-FE0F",
              non_qualified: "1F647-1F3FD-200D-2640",
              image: "1f647-1f3fd-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F647-1F3FE-200D-2640-FE0F",
              non_qualified: "1F647-1F3FE-200D-2640",
              image: "1f647-1f3fe-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F647-1F3FF-200D-2640-FE0F",
              non_qualified: "1F647-1F3FF-200D-2640",
              image: "1f647-1f3ff-200d-2640-fe0f.png",
              sheet_x: 32,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Bowing",
          b: "1F647-200D-2640-FE0F",
          c: "1F647-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [32, 25]
        },
        "flag-st": {
          a: "S\xe3o Tom\xe9 & Pr\xedncipe Flag",
          b: "1F1F8-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 37]
        },
        face_palm: {
          skin_variations: {
            "1F3FB": {
              unified: "1F926-1F3FB",
              non_qualified: null,
              image: "1f926-1f3fb.png",
              sheet_x: 38,
              sheet_y: 42,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F926-1F3FC",
              non_qualified: null,
              image: "1f926-1f3fc.png",
              sheet_x: 38,
              sheet_y: 43,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F926-1F3FD",
              non_qualified: null,
              image: "1f926-1f3fd.png",
              sheet_x: 38,
              sheet_y: 44,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F926-1F3FE",
              non_qualified: null,
              image: "1f926-1f3fe.png",
              sheet_x: 38,
              sheet_y: 45,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F926-1F3FF",
              non_qualified: null,
              image: "1f926-1f3ff.png",
              sheet_x: 38,
              sheet_y: 46,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Face Palm",
          b: "1F926",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [38, 41],
          o: 9
        },
        "flag-sv": {
          a: "El Salvador Flag",
          b: "1F1F8-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 38]
        },
        "man-facepalming": {
          skin_variations: {
            "1F3FB": {
              unified: "1F926-1F3FB-200D-2642-FE0F",
              non_qualified: "1F926-1F3FB-200D-2642",
              image: "1f926-1f3fb-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 36,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F926-1F3FC-200D-2642-FE0F",
              non_qualified: "1F926-1F3FC-200D-2642",
              image: "1f926-1f3fc-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 37,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F926-1F3FD-200D-2642-FE0F",
              non_qualified: "1F926-1F3FD-200D-2642",
              image: "1f926-1f3fd-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 38,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F926-1F3FE-200D-2642-FE0F",
              non_qualified: "1F926-1F3FE-200D-2642",
              image: "1f926-1f3fe-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 39,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F926-1F3FF-200D-2642-FE0F",
              non_qualified: "1F926-1F3FF-200D-2642",
              image: "1f926-1f3ff-200d-2642-fe0f.png",
              sheet_x: 38,
              sheet_y: 40,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Facepalming",
          b: "1F926-200D-2642-FE0F",
          c: "1F926-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 35],
          o: 9
        },
        "flag-sx": {
          a: "Sint Maarten Flag",
          b: "1F1F8-1F1FD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 39]
        },
        "flag-sy": {
          a: "Syria Flag",
          b: "1F1F8-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 40]
        },
        "woman-facepalming": {
          skin_variations: {
            "1F3FB": {
              unified: "1F926-1F3FB-200D-2640-FE0F",
              non_qualified: "1F926-1F3FB-200D-2640",
              image: "1f926-1f3fb-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 30,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F926-1F3FC-200D-2640-FE0F",
              non_qualified: "1F926-1F3FC-200D-2640",
              image: "1f926-1f3fc-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 31,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F926-1F3FD-200D-2640-FE0F",
              non_qualified: "1F926-1F3FD-200D-2640",
              image: "1f926-1f3fd-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 32,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F926-1F3FE-200D-2640-FE0F",
              non_qualified: "1F926-1F3FE-200D-2640",
              image: "1f926-1f3fe-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 33,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F926-1F3FF-200D-2640-FE0F",
              non_qualified: "1F926-1F3FF-200D-2640",
              image: "1f926-1f3ff-200d-2640-fe0f.png",
              sheet_x: 38,
              sheet_y: 34,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Facepalming",
          b: "1F926-200D-2640-FE0F",
          c: "1F926-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 29],
          o: 9
        },
        shrug: {
          skin_variations: {
            "1F3FB": {
              unified: "1F937-1F3FB",
              non_qualified: null,
              image: "1f937-1f3fb.png",
              sheet_x: 40,
              sheet_y: 7,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F937-1F3FC",
              non_qualified: null,
              image: "1f937-1f3fc.png",
              sheet_x: 40,
              sheet_y: 8,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F937-1F3FD",
              non_qualified: null,
              image: "1f937-1f3fd.png",
              sheet_x: 40,
              sheet_y: 9,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F937-1F3FE",
              non_qualified: null,
              image: "1f937-1f3fe.png",
              sheet_x: 40,
              sheet_y: 10,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F937-1F3FF",
              non_qualified: null,
              image: "1f937-1f3ff.png",
              sheet_x: 40,
              sheet_y: 11,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Shrug",
          b: "1F937",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 6],
          o: 9
        },
        "flag-sz": {
          a: "Swaziland Flag",
          b: "1F1F8-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 41]
        },
        "flag-ta": {
          a: "Tristan Da Cunha Flag",
          b: "1F1F9-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 42]
        },
        "man-shrugging": {
          skin_variations: {
            "1F3FB": {
              unified: "1F937-1F3FB-200D-2642-FE0F",
              non_qualified: "1F937-1F3FB-200D-2642",
              image: "1f937-1f3fb-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 1,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F937-1F3FC-200D-2642-FE0F",
              non_qualified: "1F937-1F3FC-200D-2642",
              image: "1f937-1f3fc-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 2,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F937-1F3FD-200D-2642-FE0F",
              non_qualified: "1F937-1F3FD-200D-2642",
              image: "1f937-1f3fd-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 3,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F937-1F3FE-200D-2642-FE0F",
              non_qualified: "1F937-1F3FE-200D-2642",
              image: "1f937-1f3fe-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 4,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F937-1F3FF-200D-2642-FE0F",
              non_qualified: "1F937-1F3FF-200D-2642",
              image: "1f937-1f3ff-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 5,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Shrugging",
          b: "1F937-200D-2642-FE0F",
          c: "1F937-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 0],
          o: 9
        },
        "woman-shrugging": {
          skin_variations: {
            "1F3FB": {
              unified: "1F937-1F3FB-200D-2640-FE0F",
              non_qualified: "1F937-1F3FB-200D-2640",
              image: "1f937-1f3fb-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 47,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F937-1F3FC-200D-2640-FE0F",
              non_qualified: "1F937-1F3FC-200D-2640",
              image: "1f937-1f3fc-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 48,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F937-1F3FD-200D-2640-FE0F",
              non_qualified: "1F937-1F3FD-200D-2640",
              image: "1f937-1f3fd-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 49,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F937-1F3FE-200D-2640-FE0F",
              non_qualified: "1F937-1F3FE-200D-2640",
              image: "1f937-1f3fe-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 50,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F937-1F3FF-200D-2640-FE0F",
              non_qualified: "1F937-1F3FF-200D-2640",
              image: "1f937-1f3ff-200d-2640-fe0f.png",
              sheet_x: 39,
              sheet_y: 51,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Shrugging",
          b: "1F937-200D-2640-FE0F",
          c: "1F937-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 46],
          o: 9
        },
        "flag-tc": {
          a: "Turks & Caicos Islands Flag",
          b: "1F1F9-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 43]
        },
        massage: {
          skin_variations: {
            "1F3FB": {
              unified: "1F486-1F3FB",
              non_qualified: null,
              image: "1f486-1f3fb.png",
              sheet_x: 24,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F486-1F3FC",
              non_qualified: null,
              image: "1f486-1f3fc.png",
              sheet_x: 24,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F486-1F3FD",
              non_qualified: null,
              image: "1f486-1f3fd.png",
              sheet_x: 24,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F486-1F3FE",
              non_qualified: null,
              image: "1f486-1f3fe.png",
              sheet_x: 24,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F486-1F3FF",
              non_qualified: null,
              image: "1f486-1f3ff.png",
              sheet_x: 24,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F486-200D-2640-FE0F",
          a: "Face Massage",
          b: "1F486",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [24, 10]
        },
        "flag-td": {
          a: "Chad Flag",
          b: "1F1F9-1F1E9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 44]
        },
        "man-getting-massage": {
          skin_variations: {
            "1F3FB": {
              unified: "1F486-1F3FB-200D-2642-FE0F",
              non_qualified: "1F486-1F3FB-200D-2642",
              image: "1f486-1f3fb-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F486-1F3FC-200D-2642-FE0F",
              non_qualified: "1F486-1F3FC-200D-2642",
              image: "1f486-1f3fc-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F486-1F3FD-200D-2642-FE0F",
              non_qualified: "1F486-1F3FD-200D-2642",
              image: "1f486-1f3fd-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F486-1F3FE-200D-2642-FE0F",
              non_qualified: "1F486-1F3FE-200D-2642",
              image: "1f486-1f3fe-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F486-1F3FF-200D-2642-FE0F",
              non_qualified: "1F486-1F3FF-200D-2642",
              image: "1f486-1f3ff-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Getting Massage",
          b: "1F486-200D-2642-FE0F",
          c: "1F486-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [24, 4]
        },
        "flag-tf": {
          a: "French Southern Territories Flag",
          b: "1F1F9-1F1EB",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 45]
        },
        "woman-getting-massage": {
          skin_variations: {
            "1F3FB": {
              unified: "1F486-1F3FB-200D-2640-FE0F",
              non_qualified: "1F486-1F3FB-200D-2640",
              image: "1f486-1f3fb-200d-2640-fe0f.png",
              sheet_x: 23,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F486-1F3FC-200D-2640-FE0F",
              non_qualified: "1F486-1F3FC-200D-2640",
              image: "1f486-1f3fc-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F486-1F3FD-200D-2640-FE0F",
              non_qualified: "1F486-1F3FD-200D-2640",
              image: "1f486-1f3fd-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F486-1F3FE-200D-2640-FE0F",
              non_qualified: "1F486-1F3FE-200D-2640",
              image: "1f486-1f3fe-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F486-1F3FF-200D-2640-FE0F",
              non_qualified: "1F486-1F3FF-200D-2640",
              image: "1f486-1f3ff-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F486",
          a: "Woman Getting Massage",
          b: "1F486-200D-2640-FE0F",
          c: "1F486-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [23, 50]
        },
        "flag-tg": {
          a: "Togo Flag",
          b: "1F1F9-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 46]
        },
        haircut: {
          skin_variations: {
            "1F3FB": {
              unified: "1F487-1F3FB",
              non_qualified: null,
              image: "1f487-1f3fb.png",
              sheet_x: 24,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F487-1F3FC",
              non_qualified: null,
              image: "1f487-1f3fc.png",
              sheet_x: 24,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F487-1F3FD",
              non_qualified: null,
              image: "1f487-1f3fd.png",
              sheet_x: 24,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F487-1F3FE",
              non_qualified: null,
              image: "1f487-1f3fe.png",
              sheet_x: 24,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F487-1F3FF",
              non_qualified: null,
              image: "1f487-1f3ff.png",
              sheet_x: 24,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F487-200D-2640-FE0F",
          a: "Haircut",
          b: "1F487",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [24, 28]
        },
        "flag-th": {
          a: "Thailand Flag",
          b: "1F1F9-1F1ED",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 47]
        },
        "man-getting-haircut": {
          skin_variations: {
            "1F3FB": {
              unified: "1F487-1F3FB-200D-2642-FE0F",
              non_qualified: "1F487-1F3FB-200D-2642",
              image: "1f487-1f3fb-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F487-1F3FC-200D-2642-FE0F",
              non_qualified: "1F487-1F3FC-200D-2642",
              image: "1f487-1f3fc-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F487-1F3FD-200D-2642-FE0F",
              non_qualified: "1F487-1F3FD-200D-2642",
              image: "1f487-1f3fd-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F487-1F3FE-200D-2642-FE0F",
              non_qualified: "1F487-1F3FE-200D-2642",
              image: "1f487-1f3fe-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F487-1F3FF-200D-2642-FE0F",
              non_qualified: "1F487-1F3FF-200D-2642",
              image: "1f487-1f3ff-200d-2642-fe0f.png",
              sheet_x: 24,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Getting Haircut",
          b: "1F487-200D-2642-FE0F",
          c: "1F487-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [24, 22]
        },
        "flag-tj": {
          a: "Tajikistan Flag",
          b: "1F1F9-1F1EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 48]
        },
        "flag-tk": {
          a: "Tokelau Flag",
          b: "1F1F9-1F1F0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 49]
        },
        "woman-getting-haircut": {
          skin_variations: {
            "1F3FB": {
              unified: "1F487-1F3FB-200D-2640-FE0F",
              non_qualified: "1F487-1F3FB-200D-2640",
              image: "1f487-1f3fb-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F487-1F3FC-200D-2640-FE0F",
              non_qualified: "1F487-1F3FC-200D-2640",
              image: "1f487-1f3fc-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F487-1F3FD-200D-2640-FE0F",
              non_qualified: "1F487-1F3FD-200D-2640",
              image: "1f487-1f3fd-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F487-1F3FE-200D-2640-FE0F",
              non_qualified: "1F487-1F3FE-200D-2640",
              image: "1f487-1f3fe-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F487-1F3FF-200D-2640-FE0F",
              non_qualified: "1F487-1F3FF-200D-2640",
              image: "1f487-1f3ff-200d-2640-fe0f.png",
              sheet_x: 24,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F487",
          a: "Woman Getting Haircut",
          b: "1F487-200D-2640-FE0F",
          c: "1F487-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [24, 16]
        },
        walking: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B6-1F3FB",
              non_qualified: null,
              image: "1f6b6-1f3fb.png",
              sheet_x: 36,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F6B6-1F3FC",
              non_qualified: null,
              image: "1f6b6-1f3fc.png",
              sheet_x: 36,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F6B6-1F3FD",
              non_qualified: null,
              image: "1f6b6-1f3fd.png",
              sheet_x: 36,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F6B6-1F3FE",
              non_qualified: null,
              image: "1f6b6-1f3fe.png",
              sheet_x: 36,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F6B6-1F3FF",
              non_qualified: null,
              image: "1f6b6-1f3ff.png",
              sheet_x: 36,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F6B6-200D-2642-FE0F",
          a: "Pedestrian",
          b: "1F6B6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [36, 21]
        },
        "flag-tl": {
          a: "Timor-Leste Flag",
          b: "1F1F9-1F1F1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 50]
        },
        "man-walking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B6-1F3FB-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FB-200D-2642",
              image: "1f6b6-1f3fb-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B6-1F3FC-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FC-200D-2642",
              image: "1f6b6-1f3fc-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B6-1F3FD-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FD-200D-2642",
              image: "1f6b6-1f3fd-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B6-1F3FE-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FE-200D-2642",
              image: "1f6b6-1f3fe-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B6-1F3FF-200D-2642-FE0F",
              non_qualified: "1F6B6-1F3FF-200D-2642",
              image: "1f6b6-1f3ff-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F6B6",
          a: "Man Walking",
          b: "1F6B6-200D-2642-FE0F",
          c: "1F6B6-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [36, 15]
        },
        "flag-tm": {
          a: "Turkmenistan Flag",
          b: "1F1F9-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [4, 51]
        },
        "woman-walking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B6-1F3FB-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FB-200D-2640",
              image: "1f6b6-1f3fb-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B6-1F3FC-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FC-200D-2640",
              image: "1f6b6-1f3fc-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B6-1F3FD-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FD-200D-2640",
              image: "1f6b6-1f3fd-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B6-1F3FE-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FE-200D-2640",
              image: "1f6b6-1f3fe-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B6-1F3FF-200D-2640-FE0F",
              non_qualified: "1F6B6-1F3FF-200D-2640",
              image: "1f6b6-1f3ff-200d-2640-fe0f.png",
              sheet_x: 36,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Walking",
          b: "1F6B6-200D-2640-FE0F",
          c: "1F6B6-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [36, 9]
        },
        "flag-tn": {
          a: "Tunisia Flag",
          b: "1F1F9-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 0]
        },
        runner: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C3-1F3FB",
              non_qualified: null,
              image: "1f3c3-1f3fb.png",
              sheet_x: 9,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3C3-1F3FC",
              non_qualified: null,
              image: "1f3c3-1f3fc.png",
              sheet_x: 9,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3C3-1F3FD",
              non_qualified: null,
              image: "1f3c3-1f3fd.png",
              sheet_x: 9,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3C3-1F3FE",
              non_qualified: null,
              image: "1f3c3-1f3fe.png",
              sheet_x: 9,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3C3-1F3FF",
              non_qualified: null,
              image: "1f3c3-1f3ff.png",
              sheet_x: 9,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F3C3-200D-2642-FE0F",
          a: "Runner",
          b: "1F3C3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [9, 46],
          n: ["running"]
        },
        "flag-to": {
          a: "Tonga Flag",
          b: "1F1F9-1F1F4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 1]
        },
        "man-running": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C3-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FB-200D-2642",
              image: "1f3c3-1f3fb-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3C3-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FC-200D-2642",
              image: "1f3c3-1f3fc-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3C3-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FD-200D-2642",
              image: "1f3c3-1f3fd-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3C3-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FE-200D-2642",
              image: "1f3c3-1f3fe-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3C3-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3C3-1F3FF-200D-2642",
              image: "1f3c3-1f3ff-200d-2642-fe0f.png",
              sheet_x: 9,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3C3",
          a: "Man Running",
          b: "1F3C3-200D-2642-FE0F",
          c: "1F3C3-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [9, 40]
        },
        "flag-tr": {
          a: "Turkey Flag",
          b: "1F1F9-1F1F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 2]
        },
        "flag-tt": {
          a: "Trinidad & Tobago Flag",
          b: "1F1F9-1F1F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 3]
        },
        "woman-running": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C3-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FB-200D-2640",
              image: "1f3c3-1f3fb-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3C3-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FC-200D-2640",
              image: "1f3c3-1f3fc-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3C3-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FD-200D-2640",
              image: "1f3c3-1f3fd-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3C3-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FE-200D-2640",
              image: "1f3c3-1f3fe-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3C3-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3C3-1F3FF-200D-2640",
              image: "1f3c3-1f3ff-200d-2640-fe0f.png",
              sheet_x: 9,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Running",
          b: "1F3C3-200D-2640-FE0F",
          c: "1F3C3-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [9, 34]
        },
        "flag-tv": {
          a: "Tuvalu Flag",
          b: "1F1F9-1F1FB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 4]
        },
        dancer: {
          skin_variations: {
            "1F3FB": {
              unified: "1F483-1F3FB",
              non_qualified: null,
              image: "1f483-1f3fb.png",
              sheet_x: 23,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F483-1F3FC",
              non_qualified: null,
              image: "1f483-1f3fc.png",
              sheet_x: 23,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F483-1F3FD",
              non_qualified: null,
              image: "1f483-1f3fd.png",
              sheet_x: 23,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F483-1F3FE",
              non_qualified: null,
              image: "1f483-1f3fe.png",
              sheet_x: 23,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F483-1F3FF",
              non_qualified: null,
              image: "1f483-1f3ff.png",
              sheet_x: 23,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Dancer",
          b: "1F483",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["female", "girl", "woman", "fun"],
          k: [23, 37]
        },
        "flag-tw": {
          a: "Taiwan Flag",
          b: "1F1F9-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 5]
        },
        man_dancing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F57A-1F3FB",
              non_qualified: null,
              image: "1f57a-1f3fb.png",
              sheet_x: 29,
              sheet_y: 22,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F57A-1F3FC",
              non_qualified: null,
              image: "1f57a-1f3fc.png",
              sheet_x: 29,
              sheet_y: 23,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F57A-1F3FD",
              non_qualified: null,
              image: "1f57a-1f3fd.png",
              sheet_x: 29,
              sheet_y: 24,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F57A-1F3FE",
              non_qualified: null,
              image: "1f57a-1f3fe.png",
              sheet_x: 29,
              sheet_y: 25,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F57A-1F3FF",
              non_qualified: null,
              image: "1f57a-1f3ff.png",
              sheet_x: 29,
              sheet_y: 26,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Man Dancing",
          b: "1F57A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["male", "boy", "fun", "dancer"],
          k: [29, 21],
          o: 9
        },
        dancers: {
          obsoleted_by: "1F46F-200D-2640-FE0F",
          a: "Woman with Bunny Ears",
          b: "1F46F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [21, 1]
        },
        "flag-tz": {
          a: "Tanzania Flag",
          b: "1F1F9-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 6]
        },
        "flag-ua": {
          a: "Ukraine Flag",
          b: "1F1FA-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 7]
        },
        "man-with-bunny-ears-partying": {
          a: "Man with Bunny Ears Partying",
          b: "1F46F-200D-2642-FE0F",
          c: "1F46F-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [21, 0]
        },
        "woman-with-bunny-ears-partying": {
          obsoletes: "1F46F",
          a: "Woman with Bunny Ears Partying",
          b: "1F46F-200D-2640-FE0F",
          c: "1F46F-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 51]
        },
        "flag-ug": {
          a: "Uganda Flag",
          b: "1F1FA-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 8]
        },
        "flag-um": {
          a: "U.s. Outlying Islands Flag",
          b: "1F1FA-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 9]
        },
        person_in_steamy_room: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D6-1F3FB",
              non_qualified: null,
              image: "1f9d6-1f3fb.png",
              sheet_x: 43,
              sheet_y: 41,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FB-200D-2642-FE0F"
            },
            "1F3FC": {
              unified: "1F9D6-1F3FC",
              non_qualified: null,
              image: "1f9d6-1f3fc.png",
              sheet_x: 43,
              sheet_y: 42,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FC-200D-2642-FE0F"
            },
            "1F3FD": {
              unified: "1F9D6-1F3FD",
              non_qualified: null,
              image: "1f9d6-1f3fd.png",
              sheet_x: 43,
              sheet_y: 43,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FD-200D-2642-FE0F"
            },
            "1F3FE": {
              unified: "1F9D6-1F3FE",
              non_qualified: null,
              image: "1f9d6-1f3fe.png",
              sheet_x: 43,
              sheet_y: 44,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FE-200D-2642-FE0F"
            },
            "1F3FF": {
              unified: "1F9D6-1F3FF",
              non_qualified: null,
              image: "1f9d6-1f3ff.png",
              sheet_x: 43,
              sheet_y: 45,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D6-1F3FF-200D-2642-FE0F"
            }
          },
          obsoleted_by: "1F9D6-200D-2642-FE0F",
          a: "Person in Steamy Room",
          b: "1F9D6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 40],
          o: 10
        },
        woman_in_steamy_room: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D6-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FB-200D-2640",
              image: "1f9d6-1f3fb-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 29,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D6-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FC-200D-2640",
              image: "1f9d6-1f3fc-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 30,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D6-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FD-200D-2640",
              image: "1f9d6-1f3fd-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 31,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D6-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FE-200D-2640",
              image: "1f9d6-1f3fe-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 32,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D6-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9D6-1F3FF-200D-2640",
              image: "1f9d6-1f3ff-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 33,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman in Steamy Room",
          b: "1F9D6-200D-2640-FE0F",
          c: "1F9D6-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 28],
          o: 10
        },
        "flag-un": {
          a: "United Nations Flag",
          b: "1F1FA-1F1F3",
          d: !1,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [5, 10]
        },
        us: {
          a: "United States Flag",
          b: "1F1FA-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["united", "states", "america", "flag", "nation", "country", "banner"],
          k: [5, 11],
          n: ["flag-us"]
        },
        man_in_steamy_room: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D6-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FB-200D-2642",
              image: "1f9d6-1f3fb-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 35,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FB"
            },
            "1F3FC": {
              unified: "1F9D6-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FC-200D-2642",
              image: "1f9d6-1f3fc-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 36,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FC"
            },
            "1F3FD": {
              unified: "1F9D6-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FD-200D-2642",
              image: "1f9d6-1f3fd-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 37,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FD"
            },
            "1F3FE": {
              unified: "1F9D6-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FE-200D-2642",
              image: "1f9d6-1f3fe-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 38,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FE"
            },
            "1F3FF": {
              unified: "1F9D6-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9D6-1F3FF-200D-2642",
              image: "1f9d6-1f3ff-200d-2642-fe0f.png",
              sheet_x: 43,
              sheet_y: 39,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D6-1F3FF"
            }
          },
          obsoletes: "1F9D6",
          a: "Man in Steamy Room",
          b: "1F9D6-200D-2642-FE0F",
          c: "1F9D6-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 34],
          o: 10
        },
        person_climbing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D7-1F3FB",
              non_qualified: null,
              image: "1f9d7-1f3fb.png",
              sheet_x: 44,
              sheet_y: 7,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9D7-1F3FC",
              non_qualified: null,
              image: "1f9d7-1f3fc.png",
              sheet_x: 44,
              sheet_y: 8,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9D7-1F3FD",
              non_qualified: null,
              image: "1f9d7-1f3fd.png",
              sheet_x: 44,
              sheet_y: 9,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9D7-1F3FE",
              non_qualified: null,
              image: "1f9d7-1f3fe.png",
              sheet_x: 44,
              sheet_y: 10,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9D7-1F3FF",
              non_qualified: null,
              image: "1f9d7-1f3ff.png",
              sheet_x: 44,
              sheet_y: 11,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D7-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9D7-200D-2640-FE0F",
          a: "Person Climbing",
          b: "1F9D7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 6],
          o: 10
        },
        "flag-uy": {
          a: "Uruguay Flag",
          b: "1F1FA-1F1FE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 12]
        },
        woman_climbing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D7-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FB-200D-2640",
              image: "1f9d7-1f3fb-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 47,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FB"
            },
            "1F3FC": {
              unified: "1F9D7-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FC-200D-2640",
              image: "1f9d7-1f3fc-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 48,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FC"
            },
            "1F3FD": {
              unified: "1F9D7-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FD-200D-2640",
              image: "1f9d7-1f3fd-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 49,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FD"
            },
            "1F3FE": {
              unified: "1F9D7-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FE-200D-2640",
              image: "1f9d7-1f3fe-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 50,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FE"
            },
            "1F3FF": {
              unified: "1F9D7-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9D7-1F3FF-200D-2640",
              image: "1f9d7-1f3ff-200d-2640-fe0f.png",
              sheet_x: 43,
              sheet_y: 51,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D7-1F3FF"
            }
          },
          obsoletes: "1F9D7",
          a: "Woman Climbing",
          b: "1F9D7-200D-2640-FE0F",
          c: "1F9D7-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [43, 46],
          o: 10
        },
        "flag-uz": {
          a: "Uzbekistan Flag",
          b: "1F1FA-1F1FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 13]
        },
        man_climbing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D7-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FB-200D-2642",
              image: "1f9d7-1f3fb-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 1,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D7-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FC-200D-2642",
              image: "1f9d7-1f3fc-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 2,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D7-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FD-200D-2642",
              image: "1f9d7-1f3fd-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 3,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D7-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FE-200D-2642",
              image: "1f9d7-1f3fe-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 4,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D7-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9D7-1F3FF-200D-2642",
              image: "1f9d7-1f3ff-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 5,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Climbing",
          b: "1F9D7-200D-2642-FE0F",
          c: "1F9D7-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 0],
          o: 10
        },
        "flag-va": {
          a: "Vatican City Flag",
          b: "1F1FB-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 14]
        },
        person_in_lotus_position: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D8-1F3FB",
              non_qualified: null,
              image: "1f9d8-1f3fb.png",
              sheet_x: 44,
              sheet_y: 25,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FB-200D-2640-FE0F"
            },
            "1F3FC": {
              unified: "1F9D8-1F3FC",
              non_qualified: null,
              image: "1f9d8-1f3fc.png",
              sheet_x: 44,
              sheet_y: 26,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FC-200D-2640-FE0F"
            },
            "1F3FD": {
              unified: "1F9D8-1F3FD",
              non_qualified: null,
              image: "1f9d8-1f3fd.png",
              sheet_x: 44,
              sheet_y: 27,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FD-200D-2640-FE0F"
            },
            "1F3FE": {
              unified: "1F9D8-1F3FE",
              non_qualified: null,
              image: "1f9d8-1f3fe.png",
              sheet_x: 44,
              sheet_y: 28,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FE-200D-2640-FE0F"
            },
            "1F3FF": {
              unified: "1F9D8-1F3FF",
              non_qualified: null,
              image: "1f9d8-1f3ff.png",
              sheet_x: 44,
              sheet_y: 29,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1,
              obsoleted_by: "1F9D8-1F3FF-200D-2640-FE0F"
            }
          },
          obsoleted_by: "1F9D8-200D-2640-FE0F",
          a: "Person in Lotus Position",
          b: "1F9D8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 24],
          o: 10
        },
        "flag-vc": {
          a: "St. Vincent & Grenadines Flag",
          b: "1F1FB-1F1E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 15]
        },
        "flag-ve": {
          a: "Venezuela Flag",
          b: "1F1FB-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 16]
        },
        woman_in_lotus_position: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D8-1F3FB-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FB-200D-2640",
              image: "1f9d8-1f3fb-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 13,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FB"
            },
            "1F3FC": {
              unified: "1F9D8-1F3FC-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FC-200D-2640",
              image: "1f9d8-1f3fc-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 14,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FC"
            },
            "1F3FD": {
              unified: "1F9D8-1F3FD-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FD-200D-2640",
              image: "1f9d8-1f3fd-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 15,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FD"
            },
            "1F3FE": {
              unified: "1F9D8-1F3FE-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FE-200D-2640",
              image: "1f9d8-1f3fe-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 16,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FE"
            },
            "1F3FF": {
              unified: "1F9D8-1F3FF-200D-2640-FE0F",
              non_qualified: "1F9D8-1F3FF-200D-2640",
              image: "1f9d8-1f3ff-200d-2640-fe0f.png",
              sheet_x: 44,
              sheet_y: 17,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1,
              obsoletes: "1F9D8-1F3FF"
            }
          },
          obsoletes: "1F9D8",
          a: "Woman in Lotus Position",
          b: "1F9D8-200D-2640-FE0F",
          c: "1F9D8-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 12],
          o: 10
        },
        man_in_lotus_position: {
          skin_variations: {
            "1F3FB": {
              unified: "1F9D8-1F3FB-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FB-200D-2642",
              image: "1f9d8-1f3fb-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F9D8-1F3FC-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FC-200D-2642",
              image: "1f9d8-1f3fc-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 20,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F9D8-1F3FD-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FD-200D-2642",
              image: "1f9d8-1f3fd-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F9D8-1F3FE-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FE-200D-2642",
              image: "1f9d8-1f3fe-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 22,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F9D8-1F3FF-200D-2642-FE0F",
              non_qualified: "1F9D8-1F3FF-200D-2642",
              image: "1f9d8-1f3ff-200d-2642-fe0f.png",
              sheet_x: 44,
              sheet_y: 23,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man in Lotus Position",
          b: "1F9D8-200D-2642-FE0F",
          c: "1F9D8-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [44, 18],
          o: 10
        },
        "flag-vg": {
          a: "British Virgin Islands Flag",
          b: "1F1FB-1F1EC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 17]
        },
        "flag-vi": {
          a: "U.s. Virgin Islands Flag",
          b: "1F1FB-1F1EE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 18]
        },
        bath: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6C0-1F3FB",
              non_qualified: null,
              image: "1f6c0-1f3fb.png",
              sheet_x: 36,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F6C0-1F3FC",
              non_qualified: null,
              image: "1f6c0-1f3fc.png",
              sheet_x: 36,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F6C0-1F3FD",
              non_qualified: null,
              image: "1f6c0-1f3fd.png",
              sheet_x: 36,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F6C0-1F3FE",
              non_qualified: null,
              image: "1f6c0-1f3fe.png",
              sheet_x: 36,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F6C0-1F3FF",
              non_qualified: null,
              image: "1f6c0-1f3ff.png",
              sheet_x: 36,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Bath",
          b: "1F6C0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["clean", "shower", "bathroom"],
          k: [36, 36]
        },
        sleeping_accommodation: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6CC-1F3FB",
              non_qualified: null,
              image: "1f6cc-1f3fb.png",
              sheet_x: 36,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6CC-1F3FC",
              non_qualified: null,
              image: "1f6cc-1f3fc.png",
              sheet_x: 36,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6CC-1F3FD",
              non_qualified: null,
              image: "1f6cc-1f3fd.png",
              sheet_x: 36,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6CC-1F3FE",
              non_qualified: null,
              image: "1f6cc-1f3fe.png",
              sheet_x: 37,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6CC-1F3FF",
              non_qualified: null,
              image: "1f6cc-1f3ff.png",
              sheet_x: 37,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Sleeping Accommodation",
          b: "1F6CC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [36, 48],
          o: 7
        },
        "flag-vn": {
          a: "Vietnam Flag",
          b: "1F1FB-1F1F3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 19]
        },
        man_in_business_suit_levitating: {
          skin_variations: {
            "1F3FB": {
              unified: "1F574-1F3FB",
              non_qualified: null,
              image: "1f574-1f3fb.png",
              sheet_x: 28,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F574-1F3FC",
              non_qualified: null,
              image: "1f574-1f3fc.png",
              sheet_x: 28,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F574-1F3FD",
              non_qualified: null,
              image: "1f574-1f3fd.png",
              sheet_x: 28,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F574-1F3FE",
              non_qualified: null,
              image: "1f574-1f3fe.png",
              sheet_x: 28,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F574-1F3FF",
              non_qualified: null,
              image: "1f574-1f3ff.png",
              sheet_x: 28,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Man in Business Suit Levitating",
          b: "1F574-FE0F",
          c: "1F574",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [28, 45],
          o: 7
        },
        "flag-vu": {
          a: "Vanuatu Flag",
          b: "1F1FB-1F1FA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 20]
        },
        "flag-wf": {
          a: "Wallis & Futuna Flag",
          b: "1F1FC-1F1EB",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 21]
        },
        speaking_head_in_silhouette: {
          a: "Speaking Head in Silhouette",
          b: "1F5E3-FE0F",
          c: "1F5E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [30, 14],
          o: 7
        },
        bust_in_silhouette: {
          a: "Bust in Silhouette",
          b: "1F464",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["user", "person", "human"],
          k: [15, 40]
        },
        "flag-ws": {
          a: "Samoa Flag",
          b: "1F1FC-1F1F8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 22]
        },
        busts_in_silhouette: {
          a: "Busts in Silhouette",
          b: "1F465",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["user", "person", "human", "group", "team"],
          k: [15, 41]
        },
        "flag-xk": {
          a: "Kosovo Flag",
          b: "1F1FD-1F1F0",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 23]
        },
        fencer: {
          a: "Fencer",
          b: "1F93A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 48],
          o: 9
        },
        "flag-ye": {
          a: "Yemen Flag",
          b: "1F1FE-1F1EA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 24]
        },
        "flag-yt": {
          a: "Mayotte Flag",
          b: "1F1FE-1F1F9",
          d: !0,
          e: !1,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 25]
        },
        horse_racing: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C7-1F3FB",
              non_qualified: null,
              image: "1f3c7-1f3fb.png",
              sheet_x: 10,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3C7-1F3FC",
              non_qualified: null,
              image: "1f3c7-1f3fc.png",
              sheet_x: 10,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3C7-1F3FD",
              non_qualified: null,
              image: "1f3c7-1f3fd.png",
              sheet_x: 10,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3C7-1F3FE",
              non_qualified: null,
              image: "1f3c7-1f3fe.png",
              sheet_x: 10,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3C7-1F3FF",
              non_qualified: null,
              image: "1f3c7-1f3ff.png",
              sheet_x: 10,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Horse Racing",
          b: "1F3C7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["animal", "betting", "competition", "gambling", "luck"],
          k: [10, 20]
        },
        "flag-za": {
          a: "South Africa Flag",
          b: "1F1FF-1F1E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 26]
        },
        skier: {
          a: "Skier",
          b: "26F7-FE0F",
          c: "26F7",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "winter", "snow"],
          k: [48, 44],
          o: 5
        },
        "flag-zm": {
          a: "Zambia Flag",
          b: "1F1FF-1F1F2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 27]
        },
        snowboarder: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C2-1F3FB",
              non_qualified: null,
              image: "1f3c2-1f3fb.png",
              sheet_x: 9,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3C2-1F3FC",
              non_qualified: null,
              image: "1f3c2-1f3fc.png",
              sheet_x: 9,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3C2-1F3FD",
              non_qualified: null,
              image: "1f3c2-1f3fd.png",
              sheet_x: 9,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3C2-1F3FE",
              non_qualified: null,
              image: "1f3c2-1f3fe.png",
              sheet_x: 9,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3C2-1F3FF",
              non_qualified: null,
              image: "1f3c2-1f3ff.png",
              sheet_x: 9,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Snowboarder",
          b: "1F3C2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sports", "winter"],
          k: [9, 28]
        },
        golfer: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CC-1F3FB",
              non_qualified: null,
              image: "1f3cc-1f3fb.png",
              sheet_x: 11,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CC-1F3FC",
              non_qualified: null,
              image: "1f3cc-1f3fc.png",
              sheet_x: 11,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CC-1F3FD",
              non_qualified: null,
              image: "1f3cc-1f3fd.png",
              sheet_x: 11,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CC-1F3FE",
              non_qualified: null,
              image: "1f3cc-1f3fe.png",
              sheet_x: 11,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CC-1F3FF",
              non_qualified: null,
              image: "1f3cc-1f3ff.png",
              sheet_x: 11,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "1F3CC-FE0F-200D-2642-FE0F",
          a: "Golfer",
          b: "1F3CC-FE0F",
          c: "1F3CC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 24],
          o: 7
        },
        "flag-zw": {
          a: "Zimbabwe Flag",
          b: "1F1FF-1F1FC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [5, 28]
        },
        "man-golfing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CC-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FB-200D-2642",
              image: "1f3cc-1f3fb-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CC-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FC-200D-2642",
              image: "1f3cc-1f3fc-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CC-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FD-200D-2642",
              image: "1f3cc-1f3fd-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CC-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FE-200D-2642",
              image: "1f3cc-1f3fe-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CC-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3CC-1F3FF-200D-2642",
              image: "1f3cc-1f3ff-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3CC-FE0F",
          a: "Man Golfing",
          b: "1F3CC-FE0F-200D-2642-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 18],
          o: 7
        },
        "flag-england": {
          a: "England Flag",
          b: "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 16],
          o: 7
        },
        "woman-golfing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CC-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FB-200D-2640",
              image: "1f3cc-1f3fb-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CC-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FC-200D-2640",
              image: "1f3cc-1f3fc-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CC-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FD-200D-2640",
              image: "1f3cc-1f3fd-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CC-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FE-200D-2640",
              image: "1f3cc-1f3fe-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CC-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3CC-1F3FF-200D-2640",
              image: "1f3cc-1f3ff-200d-2640-fe0f.png",
              sheet_x: 11,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Golfing",
          b: "1F3CC-FE0F-200D-2640-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 12],
          o: 7
        },
        "flag-scotland": {
          a: "Scotland Flag",
          b: "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 17],
          o: 7
        },
        "flag-wales": {
          a: "Wales Flag",
          b: "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [12, 18],
          o: 7
        },
        surfer: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C4-1F3FB",
              non_qualified: null,
              image: "1f3c4-1f3fb.png",
              sheet_x: 10,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3C4-1F3FC",
              non_qualified: null,
              image: "1f3c4-1f3fc.png",
              sheet_x: 10,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3C4-1F3FD",
              non_qualified: null,
              image: "1f3c4-1f3fd.png",
              sheet_x: 10,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3C4-1F3FE",
              non_qualified: null,
              image: "1f3c4-1f3fe.png",
              sheet_x: 10,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3C4-1F3FF",
              non_qualified: null,
              image: "1f3c4-1f3ff.png",
              sheet_x: 10,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F3C4-200D-2642-FE0F",
          a: "Surfer",
          b: "1F3C4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [10, 12]
        },
        "man-surfing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C4-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FB-200D-2642",
              image: "1f3c4-1f3fb-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3C4-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FC-200D-2642",
              image: "1f3c4-1f3fc-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3C4-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FD-200D-2642",
              image: "1f3c4-1f3fd-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3C4-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FE-200D-2642",
              image: "1f3c4-1f3fe-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3C4-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3C4-1F3FF-200D-2642",
              image: "1f3c4-1f3ff-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3C4",
          a: "Man Surfing",
          b: "1F3C4-200D-2642-FE0F",
          c: "1F3C4-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 6]
        },
        "woman-surfing": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3C4-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FB-200D-2640",
              image: "1f3c4-1f3fb-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3C4-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FC-200D-2640",
              image: "1f3c4-1f3fc-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3C4-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FD-200D-2640",
              image: "1f3c4-1f3fd-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3C4-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FE-200D-2640",
              image: "1f3c4-1f3fe-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3C4-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3C4-1F3FF-200D-2640",
              image: "1f3c4-1f3ff-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Surfing",
          b: "1F3C4-200D-2640-FE0F",
          c: "1F3C4-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 0]
        },
        rowboat: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6A3-1F3FB",
              non_qualified: null,
              image: "1f6a3-1f3fb.png",
              sheet_x: 35,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6A3-1F3FC",
              non_qualified: null,
              image: "1f6a3-1f3fc.png",
              sheet_x: 35,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6A3-1F3FD",
              non_qualified: null,
              image: "1f6a3-1f3fd.png",
              sheet_x: 35,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6A3-1F3FE",
              non_qualified: null,
              image: "1f6a3-1f3fe.png",
              sheet_x: 35,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6A3-1F3FF",
              non_qualified: null,
              image: "1f6a3-1f3ff.png",
              sheet_x: 35,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "1F6A3-200D-2642-FE0F",
          a: "Rowboat",
          b: "1F6A3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [35, 3]
        },
        "man-rowing-boat": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6A3-1F3FB-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FB-200D-2642",
              image: "1f6a3-1f3fb-200d-2642-fe0f.png",
              sheet_x: 34,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6A3-1F3FC-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FC-200D-2642",
              image: "1f6a3-1f3fc-200d-2642-fe0f.png",
              sheet_x: 34,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6A3-1F3FD-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FD-200D-2642",
              image: "1f6a3-1f3fd-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6A3-1F3FE-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FE-200D-2642",
              image: "1f6a3-1f3fe-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6A3-1F3FF-200D-2642-FE0F",
              non_qualified: "1F6A3-1F3FF-200D-2642",
              image: "1f6a3-1f3ff-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F6A3",
          a: "Man Rowing Boat",
          b: "1F6A3-200D-2642-FE0F",
          c: "1F6A3-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [34, 49]
        },
        "woman-rowing-boat": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6A3-1F3FB-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FB-200D-2640",
              image: "1f6a3-1f3fb-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6A3-1F3FC-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FC-200D-2640",
              image: "1f6a3-1f3fc-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6A3-1F3FD-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FD-200D-2640",
              image: "1f6a3-1f3fd-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6A3-1F3FE-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FE-200D-2640",
              image: "1f6a3-1f3fe-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6A3-1F3FF-200D-2640-FE0F",
              non_qualified: "1F6A3-1F3FF-200D-2640",
              image: "1f6a3-1f3ff-200d-2640-fe0f.png",
              sheet_x: 34,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Rowing Boat",
          b: "1F6A3-200D-2640-FE0F",
          c: "1F6A3-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [34, 43]
        },
        swimmer: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CA-1F3FB",
              non_qualified: null,
              image: "1f3ca-1f3fb.png",
              sheet_x: 10,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F3CA-1F3FC",
              non_qualified: null,
              image: "1f3ca-1f3fc.png",
              sheet_x: 10,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F3CA-1F3FD",
              non_qualified: null,
              image: "1f3ca-1f3fd.png",
              sheet_x: 10,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F3CA-1F3FE",
              non_qualified: null,
              image: "1f3ca-1f3fe.png",
              sheet_x: 10,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F3CA-1F3FF",
              non_qualified: null,
              image: "1f3ca-1f3ff.png",
              sheet_x: 10,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F3CA-200D-2642-FE0F",
          a: "Swimmer",
          b: "1F3CA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [10, 40]
        },
        "man-swimming": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CA-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FB-200D-2642",
              image: "1f3ca-1f3fb-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CA-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FC-200D-2642",
              image: "1f3ca-1f3fc-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CA-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FD-200D-2642",
              image: "1f3ca-1f3fd-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CA-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FE-200D-2642",
              image: "1f3ca-1f3fe-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CA-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3CA-1F3FF-200D-2642",
              image: "1f3ca-1f3ff-200d-2642-fe0f.png",
              sheet_x: 10,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3CA",
          a: "Man Swimming",
          b: "1F3CA-200D-2642-FE0F",
          c: "1F3CA-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 34]
        },
        "woman-swimming": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CA-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FB-200D-2640",
              image: "1f3ca-1f3fb-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CA-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FC-200D-2640",
              image: "1f3ca-1f3fc-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CA-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FD-200D-2640",
              image: "1f3ca-1f3fd-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CA-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FE-200D-2640",
              image: "1f3ca-1f3fe-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CA-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3CA-1F3FF-200D-2640",
              image: "1f3ca-1f3ff-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Swimming",
          b: "1F3CA-200D-2640-FE0F",
          c: "1F3CA-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [10, 28]
        },
        person_with_ball: {
          skin_variations: {
            "1F3FB": {
              unified: "26F9-1F3FB",
              non_qualified: null,
              image: "26f9-1f3fb.png",
              sheet_x: 49,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "26F9-1F3FC",
              non_qualified: null,
              image: "26f9-1f3fc.png",
              sheet_x: 49,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "26F9-1F3FD",
              non_qualified: null,
              image: "26f9-1f3fd.png",
              sheet_x: 49,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "26F9-1F3FE",
              non_qualified: null,
              image: "26f9-1f3fe.png",
              sheet_x: 49,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "26F9-1F3FF",
              non_qualified: null,
              image: "26f9-1f3ff.png",
              sheet_x: 49,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "26F9-FE0F-200D-2642-FE0F",
          a: "Person with Ball",
          b: "26F9-FE0F",
          c: "26F9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [49, 6],
          o: 5
        },
        "man-bouncing-ball": {
          skin_variations: {
            "1F3FB": {
              unified: "26F9-1F3FB-200D-2642-FE0F",
              non_qualified: "26F9-1F3FB-200D-2642",
              image: "26f9-1f3fb-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "26F9-1F3FC-200D-2642-FE0F",
              non_qualified: "26F9-1F3FC-200D-2642",
              image: "26f9-1f3fc-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "26F9-1F3FD-200D-2642-FE0F",
              non_qualified: "26F9-1F3FD-200D-2642",
              image: "26f9-1f3fd-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "26F9-1F3FE-200D-2642-FE0F",
              non_qualified: "26F9-1F3FE-200D-2642",
              image: "26f9-1f3fe-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "26F9-1F3FF-200D-2642-FE0F",
              non_qualified: "26F9-1F3FF-200D-2642",
              image: "26f9-1f3ff-200d-2642-fe0f.png",
              sheet_x: 49,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "26F9-FE0F",
          a: "Man Bouncing Ball",
          b: "26F9-FE0F-200D-2642-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [49, 0],
          o: 5
        },
        "woman-bouncing-ball": {
          skin_variations: {
            "1F3FB": {
              unified: "26F9-1F3FB-200D-2640-FE0F",
              non_qualified: "26F9-1F3FB-200D-2640",
              image: "26f9-1f3fb-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "26F9-1F3FC-200D-2640-FE0F",
              non_qualified: "26F9-1F3FC-200D-2640",
              image: "26f9-1f3fc-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "26F9-1F3FD-200D-2640-FE0F",
              non_qualified: "26F9-1F3FD-200D-2640",
              image: "26f9-1f3fd-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "26F9-1F3FE-200D-2640-FE0F",
              non_qualified: "26F9-1F3FE-200D-2640",
              image: "26f9-1f3fe-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "26F9-1F3FF-200D-2640-FE0F",
              non_qualified: "26F9-1F3FF-200D-2640",
              image: "26f9-1f3ff-200d-2640-fe0f.png",
              sheet_x: 48,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Bouncing Ball",
          b: "26F9-FE0F-200D-2640-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [48, 46],
          o: 5
        },
        weight_lifter: {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CB-1F3FB",
              non_qualified: null,
              image: "1f3cb-1f3fb.png",
              sheet_x: 11,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CB-1F3FC",
              non_qualified: null,
              image: "1f3cb-1f3fc.png",
              sheet_x: 11,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CB-1F3FD",
              non_qualified: null,
              image: "1f3cb-1f3fd.png",
              sheet_x: 11,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CB-1F3FE",
              non_qualified: null,
              image: "1f3cb-1f3fe.png",
              sheet_x: 11,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CB-1F3FF",
              non_qualified: null,
              image: "1f3cb-1f3ff.png",
              sheet_x: 11,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoleted_by: "1F3CB-FE0F-200D-2642-FE0F",
          a: "Weight Lifter",
          b: "1F3CB-FE0F",
          c: "1F3CB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 6],
          o: 7
        },
        "man-lifting-weights": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CB-1F3FB-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FB-200D-2642",
              image: "1f3cb-1f3fb-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CB-1F3FC-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FC-200D-2642",
              image: "1f3cb-1f3fc-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CB-1F3FD-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FD-200D-2642",
              image: "1f3cb-1f3fd-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CB-1F3FE-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FE-200D-2642",
              image: "1f3cb-1f3fe-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CB-1F3FF-200D-2642-FE0F",
              non_qualified: "1F3CB-1F3FF-200D-2642",
              image: "1f3cb-1f3ff-200d-2642-fe0f.png",
              sheet_x: 11,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F3CB-FE0F",
          a: "Man Lifting Weights",
          b: "1F3CB-FE0F-200D-2642-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [11, 0],
          o: 7
        },
        "woman-lifting-weights": {
          skin_variations: {
            "1F3FB": {
              unified: "1F3CB-1F3FB-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FB-200D-2640",
              image: "1f3cb-1f3fb-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F3CB-1F3FC-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FC-200D-2640",
              image: "1f3cb-1f3fc-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F3CB-1F3FD-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FD-200D-2640",
              image: "1f3cb-1f3fd-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F3CB-1F3FE-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FE-200D-2640",
              image: "1f3cb-1f3fe-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F3CB-1F3FF-200D-2640-FE0F",
              non_qualified: "1F3CB-1F3FF-200D-2640",
              image: "1f3cb-1f3ff-200d-2640-fe0f.png",
              sheet_x: 10,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Lifting Weights",
          b: "1F3CB-FE0F-200D-2640-FE0F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [10, 46],
          o: 7
        },
        bicyclist: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B4-1F3FB",
              non_qualified: null,
              image: "1f6b4-1f3fb.png",
              sheet_x: 35,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F6B4-1F3FC",
              non_qualified: null,
              image: "1f6b4-1f3fc.png",
              sheet_x: 35,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F6B4-1F3FD",
              non_qualified: null,
              image: "1f6b4-1f3fd.png",
              sheet_x: 35,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F6B4-1F3FE",
              non_qualified: null,
              image: "1f6b4-1f3fe.png",
              sheet_x: 35,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F6B4-1F3FF",
              non_qualified: null,
              image: "1f6b4-1f3ff.png",
              sheet_x: 35,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F6B4-200D-2642-FE0F",
          a: "Bicyclist",
          b: "1F6B4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [35, 37]
        },
        "man-biking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B4-1F3FB-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FB-200D-2642",
              image: "1f6b4-1f3fb-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B4-1F3FC-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FC-200D-2642",
              image: "1f6b4-1f3fc-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B4-1F3FD-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FD-200D-2642",
              image: "1f6b4-1f3fd-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B4-1F3FE-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FE-200D-2642",
              image: "1f6b4-1f3fe-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B4-1F3FF-200D-2642-FE0F",
              non_qualified: "1F6B4-1F3FF-200D-2642",
              image: "1f6b4-1f3ff-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F6B4",
          a: "Man Biking",
          b: "1F6B4-200D-2642-FE0F",
          c: "1F6B4-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [35, 31]
        },
        "woman-biking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B4-1F3FB-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FB-200D-2640",
              image: "1f6b4-1f3fb-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B4-1F3FC-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FC-200D-2640",
              image: "1f6b4-1f3fc-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B4-1F3FD-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FD-200D-2640",
              image: "1f6b4-1f3fd-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B4-1F3FE-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FE-200D-2640",
              image: "1f6b4-1f3fe-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B4-1F3FF-200D-2640-FE0F",
              non_qualified: "1F6B4-1F3FF-200D-2640",
              image: "1f6b4-1f3ff-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Biking",
          b: "1F6B4-200D-2640-FE0F",
          c: "1F6B4-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [35, 25]
        },
        mountain_bicyclist: {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B5-1F3FB",
              non_qualified: null,
              image: "1f6b5-1f3fb.png",
              sheet_x: 36,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F6B5-1F3FC",
              non_qualified: null,
              image: "1f6b5-1f3fc.png",
              sheet_x: 36,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F6B5-1F3FD",
              non_qualified: null,
              image: "1f6b5-1f3fd.png",
              sheet_x: 36,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F6B5-1F3FE",
              non_qualified: null,
              image: "1f6b5-1f3fe.png",
              sheet_x: 36,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F6B5-1F3FF",
              non_qualified: null,
              image: "1f6b5-1f3ff.png",
              sheet_x: 36,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !0
            }
          },
          obsoleted_by: "1F6B5-200D-2642-FE0F",
          a: "Mountain Bicyclist",
          b: "1F6B5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [36, 3]
        },
        "man-mountain-biking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B5-1F3FB-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FB-200D-2642",
              image: "1f6b5-1f3fb-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B5-1F3FC-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FC-200D-2642",
              image: "1f6b5-1f3fc-200d-2642-fe0f.png",
              sheet_x: 35,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B5-1F3FD-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FD-200D-2642",
              image: "1f6b5-1f3fd-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B5-1F3FE-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FE-200D-2642",
              image: "1f6b5-1f3fe-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B5-1F3FF-200D-2642-FE0F",
              non_qualified: "1F6B5-1F3FF-200D-2642",
              image: "1f6b5-1f3ff-200d-2642-fe0f.png",
              sheet_x: 36,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          obsoletes: "1F6B5",
          a: "Man Mountain Biking",
          b: "1F6B5-200D-2642-FE0F",
          c: "1F6B5-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [35, 49]
        },
        "woman-mountain-biking": {
          skin_variations: {
            "1F3FB": {
              unified: "1F6B5-1F3FB-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FB-200D-2640",
              image: "1f6b5-1f3fb-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F6B5-1F3FC-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FC-200D-2640",
              image: "1f6b5-1f3fc-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F6B5-1F3FD-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FD-200D-2640",
              image: "1f6b5-1f3fd-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F6B5-1F3FE-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FE-200D-2640",
              image: "1f6b5-1f3fe-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F6B5-1F3FF-200D-2640-FE0F",
              non_qualified: "1F6B5-1F3FF-200D-2640",
              image: "1f6b5-1f3ff-200d-2640-fe0f.png",
              sheet_x: 35,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Mountain Biking",
          b: "1F6B5-200D-2640-FE0F",
          c: "1F6B5-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [35, 43]
        },
        racing_car: {
          a: "Racing Car",
          b: "1F3CE-FE0F",
          c: "1F3CE",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["sports", "race", "fast", "formula", "f1"],
          k: [11, 31],
          o: 7
        },
        racing_motorcycle: {
          a: "Racing Motorcycle",
          b: "1F3CD-FE0F",
          c: "1F3CD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [11, 30],
          o: 7
        },
        person_doing_cartwheel: {
          skin_variations: {
            "1F3FB": {
              unified: "1F938-1F3FB",
              non_qualified: null,
              image: "1f938-1f3fb.png",
              sheet_x: 40,
              sheet_y: 25,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F938-1F3FC",
              non_qualified: null,
              image: "1f938-1f3fc.png",
              sheet_x: 40,
              sheet_y: 26,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F938-1F3FD",
              non_qualified: null,
              image: "1f938-1f3fd.png",
              sheet_x: 40,
              sheet_y: 27,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F938-1F3FE",
              non_qualified: null,
              image: "1f938-1f3fe.png",
              sheet_x: 40,
              sheet_y: 28,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F938-1F3FF",
              non_qualified: null,
              image: "1f938-1f3ff.png",
              sheet_x: 40,
              sheet_y: 29,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Person Doing Cartwheel",
          b: "1F938",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 24],
          o: 9
        },
        "man-cartwheeling": {
          skin_variations: {
            "1F3FB": {
              unified: "1F938-1F3FB-200D-2642-FE0F",
              non_qualified: "1F938-1F3FB-200D-2642",
              image: "1f938-1f3fb-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 19,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F938-1F3FC-200D-2642-FE0F",
              non_qualified: "1F938-1F3FC-200D-2642",
              image: "1f938-1f3fc-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 20,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F938-1F3FD-200D-2642-FE0F",
              non_qualified: "1F938-1F3FD-200D-2642",
              image: "1f938-1f3fd-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 21,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F938-1F3FE-200D-2642-FE0F",
              non_qualified: "1F938-1F3FE-200D-2642",
              image: "1f938-1f3fe-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 22,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F938-1F3FF-200D-2642-FE0F",
              non_qualified: "1F938-1F3FF-200D-2642",
              image: "1f938-1f3ff-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 23,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Cartwheeling",
          b: "1F938-200D-2642-FE0F",
          c: "1F938-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 18],
          o: 9
        },
        "woman-cartwheeling": {
          skin_variations: {
            "1F3FB": {
              unified: "1F938-1F3FB-200D-2640-FE0F",
              non_qualified: "1F938-1F3FB-200D-2640",
              image: "1f938-1f3fb-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 13,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F938-1F3FC-200D-2640-FE0F",
              non_qualified: "1F938-1F3FC-200D-2640",
              image: "1f938-1f3fc-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 14,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F938-1F3FD-200D-2640-FE0F",
              non_qualified: "1F938-1F3FD-200D-2640",
              image: "1f938-1f3fd-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 15,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F938-1F3FE-200D-2640-FE0F",
              non_qualified: "1F938-1F3FE-200D-2640",
              image: "1f938-1f3fe-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 16,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F938-1F3FF-200D-2640-FE0F",
              non_qualified: "1F938-1F3FF-200D-2640",
              image: "1f938-1f3ff-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 17,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Cartwheeling",
          b: "1F938-200D-2640-FE0F",
          c: "1F938-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 12],
          o: 9
        },
        wrestlers: {
          a: "Wrestlers",
          b: "1F93C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 51],
          o: 9
        },
        "man-wrestling": {
          a: "Man Wrestling",
          b: "1F93C-200D-2642-FE0F",
          c: "1F93C-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 50],
          o: 9
        },
        "woman-wrestling": {
          a: "Woman Wrestling",
          b: "1F93C-200D-2640-FE0F",
          c: "1F93C-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 49],
          o: 9
        },
        water_polo: {
          skin_variations: {
            "1F3FB": {
              unified: "1F93D-1F3FB",
              non_qualified: null,
              image: "1f93d-1f3fb.png",
              sheet_x: 41,
              sheet_y: 13,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93D-1F3FC",
              non_qualified: null,
              image: "1f93d-1f3fc.png",
              sheet_x: 41,
              sheet_y: 14,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93D-1F3FD",
              non_qualified: null,
              image: "1f93d-1f3fd.png",
              sheet_x: 41,
              sheet_y: 15,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93D-1F3FE",
              non_qualified: null,
              image: "1f93d-1f3fe.png",
              sheet_x: 41,
              sheet_y: 16,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93D-1F3FF",
              non_qualified: null,
              image: "1f93d-1f3ff.png",
              sheet_x: 41,
              sheet_y: 17,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Water Polo",
          b: "1F93D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [41, 12],
          o: 9
        },
        "man-playing-water-polo": {
          skin_variations: {
            "1F3FB": {
              unified: "1F93D-1F3FB-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FB-200D-2642",
              image: "1f93d-1f3fb-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 7,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93D-1F3FC-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FC-200D-2642",
              image: "1f93d-1f3fc-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 8,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93D-1F3FD-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FD-200D-2642",
              image: "1f93d-1f3fd-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 9,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93D-1F3FE-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FE-200D-2642",
              image: "1f93d-1f3fe-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 10,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93D-1F3FF-200D-2642-FE0F",
              non_qualified: "1F93D-1F3FF-200D-2642",
              image: "1f93d-1f3ff-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 11,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Playing Water Polo",
          b: "1F93D-200D-2642-FE0F",
          c: "1F93D-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 6],
          o: 9
        },
        "woman-playing-water-polo": {
          skin_variations: {
            "1F3FB": {
              unified: "1F93D-1F3FB-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FB-200D-2640",
              image: "1f93d-1f3fb-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 1,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93D-1F3FC-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FC-200D-2640",
              image: "1f93d-1f3fc-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 2,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93D-1F3FD-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FD-200D-2640",
              image: "1f93d-1f3fd-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 3,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93D-1F3FE-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FE-200D-2640",
              image: "1f93d-1f3fe-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 4,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93D-1F3FF-200D-2640-FE0F",
              non_qualified: "1F93D-1F3FF-200D-2640",
              image: "1f93d-1f3ff-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 5,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Playing Water Polo",
          b: "1F93D-200D-2640-FE0F",
          c: "1F93D-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 0],
          o: 9
        },
        handball: {
          skin_variations: {
            "1F3FB": {
              unified: "1F93E-1F3FB",
              non_qualified: null,
              image: "1f93e-1f3fb.png",
              sheet_x: 41,
              sheet_y: 31,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93E-1F3FC",
              non_qualified: null,
              image: "1f93e-1f3fc.png",
              sheet_x: 41,
              sheet_y: 32,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93E-1F3FD",
              non_qualified: null,
              image: "1f93e-1f3fd.png",
              sheet_x: 41,
              sheet_y: 33,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93E-1F3FE",
              non_qualified: null,
              image: "1f93e-1f3fe.png",
              sheet_x: 41,
              sheet_y: 34,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93E-1F3FF",
              non_qualified: null,
              image: "1f93e-1f3ff.png",
              sheet_x: 41,
              sheet_y: 35,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Handball",
          b: "1F93E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [41, 30],
          o: 9
        },
        "man-playing-handball": {
          skin_variations: {
            "1F3FB": {
              unified: "1F93E-1F3FB-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FB-200D-2642",
              image: "1f93e-1f3fb-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 25,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93E-1F3FC-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FC-200D-2642",
              image: "1f93e-1f3fc-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 26,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93E-1F3FD-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FD-200D-2642",
              image: "1f93e-1f3fd-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 27,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93E-1F3FE-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FE-200D-2642",
              image: "1f93e-1f3fe-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 28,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93E-1F3FF-200D-2642-FE0F",
              non_qualified: "1F93E-1F3FF-200D-2642",
              image: "1f93e-1f3ff-200d-2642-fe0f.png",
              sheet_x: 41,
              sheet_y: 29,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Playing Handball",
          b: "1F93E-200D-2642-FE0F",
          c: "1F93E-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 24],
          o: 9
        },
        "woman-playing-handball": {
          skin_variations: {
            "1F3FB": {
              unified: "1F93E-1F3FB-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FB-200D-2640",
              image: "1f93e-1f3fb-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 19,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F93E-1F3FC-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FC-200D-2640",
              image: "1f93e-1f3fc-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 20,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F93E-1F3FD-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FD-200D-2640",
              image: "1f93e-1f3fd-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 21,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F93E-1F3FE-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FE-200D-2640",
              image: "1f93e-1f3fe-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 22,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F93E-1F3FF-200D-2640-FE0F",
              non_qualified: "1F93E-1F3FF-200D-2640",
              image: "1f93e-1f3ff-200d-2640-fe0f.png",
              sheet_x: 41,
              sheet_y: 23,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Playing Handball",
          b: "1F93E-200D-2640-FE0F",
          c: "1F93E-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [41, 18],
          o: 9
        },
        juggling: {
          skin_variations: {
            "1F3FB": {
              unified: "1F939-1F3FB",
              non_qualified: null,
              image: "1f939-1f3fb.png",
              sheet_x: 40,
              sheet_y: 43,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F939-1F3FC",
              non_qualified: null,
              image: "1f939-1f3fc.png",
              sheet_x: 40,
              sheet_y: 44,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F939-1F3FD",
              non_qualified: null,
              image: "1f939-1f3fd.png",
              sheet_x: 40,
              sheet_y: 45,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F939-1F3FE",
              non_qualified: null,
              image: "1f939-1f3fe.png",
              sheet_x: 40,
              sheet_y: 46,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F939-1F3FF",
              non_qualified: null,
              image: "1f939-1f3ff.png",
              sheet_x: 40,
              sheet_y: 47,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Juggling",
          b: "1F939",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [40, 42],
          o: 9
        },
        "man-juggling": {
          skin_variations: {
            "1F3FB": {
              unified: "1F939-1F3FB-200D-2642-FE0F",
              non_qualified: "1F939-1F3FB-200D-2642",
              image: "1f939-1f3fb-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 37,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F939-1F3FC-200D-2642-FE0F",
              non_qualified: "1F939-1F3FC-200D-2642",
              image: "1f939-1f3fc-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 38,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F939-1F3FD-200D-2642-FE0F",
              non_qualified: "1F939-1F3FD-200D-2642",
              image: "1f939-1f3fd-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 39,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F939-1F3FE-200D-2642-FE0F",
              non_qualified: "1F939-1F3FE-200D-2642",
              image: "1f939-1f3fe-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 40,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F939-1F3FF-200D-2642-FE0F",
              non_qualified: "1F939-1F3FF-200D-2642",
              image: "1f939-1f3ff-200d-2642-fe0f.png",
              sheet_x: 40,
              sheet_y: 41,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Man Juggling",
          b: "1F939-200D-2642-FE0F",
          c: "1F939-200D-2642",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 36],
          o: 9
        },
        "woman-juggling": {
          skin_variations: {
            "1F3FB": {
              unified: "1F939-1F3FB-200D-2640-FE0F",
              non_qualified: "1F939-1F3FB-200D-2640",
              image: "1f939-1f3fb-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 31,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F939-1F3FC-200D-2640-FE0F",
              non_qualified: "1F939-1F3FC-200D-2640",
              image: "1f939-1f3fc-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 32,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F939-1F3FD-200D-2640-FE0F",
              non_qualified: "1F939-1F3FD-200D-2640",
              image: "1f939-1f3fd-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 33,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F939-1F3FE-200D-2640-FE0F",
              non_qualified: "1F939-1F3FE-200D-2640",
              image: "1f939-1f3fe-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 34,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F939-1F3FF-200D-2640-FE0F",
              non_qualified: "1F939-1F3FF-200D-2640",
              image: "1f939-1f3ff-200d-2640-fe0f.png",
              sheet_x: 40,
              sheet_y: 35,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !1,
              has_img_messenger: !1
            }
          },
          a: "Woman Juggling",
          b: "1F939-200D-2640-FE0F",
          c: "1F939-200D-2640",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !1,
          k: [40, 30],
          o: 9
        },
        couple: {
          a: "Man and Woman Holding Hands",
          b: "1F46B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pair", "people", "human", "love", "date", "dating", "like", "affection", "valentines", "marriage"],
          k: [20, 30],
          n: ["man_and_woman_holding_hands"]
        },
        two_men_holding_hands: {
          a: "Two Men Holding Hands",
          b: "1F46C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pair", "couple", "love", "like", "bromance", "friendship", "people", "human"],
          k: [20, 31]
        },
        two_women_holding_hands: {
          a: "Two Women Holding Hands",
          b: "1F46D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["pair", "friendship", "couple", "love", "like", "female", "people", "human"],
          k: [20, 32]
        },
        couplekiss: {
          obsoleted_by: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
          a: "Kiss",
          b: "1F48F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [24, 41]
        },
        "woman-kiss-man": {
          obsoletes: "1F48F",
          a: "Woman Kiss Man",
          b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
          c: "1F469-200D-2764-200D-1F48B-200D-1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 21]
        },
        "man-kiss-man": {
          a: "Man Kiss Man",
          b: "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
          c: "1F468-200D-2764-200D-1F48B-200D-1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [18, 10]
        },
        "woman-kiss-woman": {
          a: "Woman Kiss Woman",
          b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
          c: "1F469-200D-2764-200D-1F48B-200D-1F469",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [20, 22]
        },
        couple_with_heart: {
          obsoleted_by: "1F469-200D-2764-FE0F-200D-1F468",
          a: "Couple with Heart",
          b: "1F491",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [24, 43]
        },
        "woman-heart-man": {
          obsoletes: "1F491",
          a: "Woman Heart Man",
          b: "1F469-200D-2764-FE0F-200D-1F468",
          c: "1F469-200D-2764-200D-1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [20, 19]
        },
        "man-heart-man": {
          a: "Man Heart Man",
          b: "1F468-200D-2764-FE0F-200D-1F468",
          c: "1F468-200D-2764-200D-1F468",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [18, 9]
        },
        "woman-heart-woman": {
          a: "Woman Heart Woman",
          b: "1F469-200D-2764-FE0F-200D-1F469",
          c: "1F469-200D-2764-200D-1F469",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [20, 20]
        },
        family: {
          obsoleted_by: "1F468-200D-1F469-200D-1F466",
          a: "Family",
          b: "1F46A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !1,
          i: !0,
          k: [20, 29],
          n: ["man-woman-boy"]
        },
        "man-woman-boy": {
          obsoletes: "1F46A",
          a: "Man Woman Boy",
          b: "1F468-200D-1F469-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 2],
          n: ["family"]
        },
        "man-woman-girl": {
          a: "Man Woman Girl",
          b: "1F468-200D-1F469-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 4]
        },
        "man-woman-girl-boy": {
          a: "Man Woman Girl Boy",
          b: "1F468-200D-1F469-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 5]
        },
        "man-woman-boy-boy": {
          a: "Man Woman Boy Boy",
          b: "1F468-200D-1F469-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 3]
        },
        "man-woman-girl-girl": {
          a: "Man Woman Girl Girl",
          b: "1F468-200D-1F469-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 6]
        },
        "man-man-boy": {
          a: "Man Man Boy",
          b: "1F468-200D-1F468-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [16, 49]
        },
        "man-man-girl": {
          a: "Man Man Girl",
          b: "1F468-200D-1F468-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [16, 51]
        },
        "man-man-girl-boy": {
          a: "Man Man Girl Boy",
          b: "1F468-200D-1F468-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 0]
        },
        "man-man-boy-boy": {
          a: "Man Man Boy Boy",
          b: "1F468-200D-1F468-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [16, 50]
        },
        "man-man-girl-girl": {
          a: "Man Man Girl Girl",
          b: "1F468-200D-1F468-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [17, 1]
        },
        "woman-woman-boy": {
          a: "Woman Woman Boy",
          b: "1F469-200D-1F469-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 12]
        },
        "woman-woman-girl": {
          a: "Woman Woman Girl",
          b: "1F469-200D-1F469-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 14]
        },
        "woman-woman-girl-boy": {
          a: "Woman Woman Girl Boy",
          b: "1F469-200D-1F469-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 15]
        },
        "woman-woman-boy-boy": {
          a: "Woman Woman Boy Boy",
          b: "1F469-200D-1F469-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 13]
        },
        "woman-woman-girl-girl": {
          a: "Woman Woman Girl Girl",
          b: "1F469-200D-1F469-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [19, 16]
        },
        "man-boy": {
          a: "Man Boy",
          b: "1F468-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 45]
        },
        "man-boy-boy": {
          a: "Man Boy Boy",
          b: "1F468-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 44]
        },
        "man-girl": {
          a: "Man Girl",
          b: "1F468-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 48]
        },
        "man-girl-boy": {
          a: "Man Girl Boy",
          b: "1F468-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 46]
        },
        "man-girl-girl": {
          a: "Man Girl Girl",
          b: "1F468-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [16, 47]
        },
        "woman-boy": {
          a: "Woman Boy",
          b: "1F469-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 8]
        },
        "woman-boy-boy": {
          a: "Woman Boy Boy",
          b: "1F469-200D-1F466-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 7]
        },
        "woman-girl": {
          a: "Woman Girl",
          b: "1F469-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 11]
        },
        "woman-girl-boy": {
          a: "Woman Girl Boy",
          b: "1F469-200D-1F467-200D-1F466",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 9]
        },
        "woman-girl-girl": {
          a: "Woman Girl Girl",
          b: "1F469-200D-1F467-200D-1F467",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [19, 10]
        },
        selfie: {
          skin_variations: {
            "1F3FB": {
              unified: "1F933-1F3FB",
              non_qualified: null,
              image: "1f933-1f3fb.png",
              sheet_x: 39,
              sheet_y: 23,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F933-1F3FC",
              non_qualified: null,
              image: "1f933-1f3fc.png",
              sheet_x: 39,
              sheet_y: 24,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F933-1F3FD",
              non_qualified: null,
              image: "1f933-1f3fd.png",
              sheet_x: 39,
              sheet_y: 25,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F933-1F3FE",
              non_qualified: null,
              image: "1f933-1f3fe.png",
              sheet_x: 39,
              sheet_y: 26,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F933-1F3FF",
              non_qualified: null,
              image: "1f933-1f3ff.png",
              sheet_x: 39,
              sheet_y: 27,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Selfie",
          b: "1F933",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["camera", "phone"],
          k: [39, 22],
          o: 9
        },
        muscle: {
          skin_variations: {
            "1F3FB": {
              unified: "1F4AA-1F3FB",
              non_qualified: null,
              image: "1f4aa-1f3fb.png",
              sheet_x: 25,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F4AA-1F3FC",
              non_qualified: null,
              image: "1f4aa-1f3fc.png",
              sheet_x: 25,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F4AA-1F3FD",
              non_qualified: null,
              image: "1f4aa-1f3fd.png",
              sheet_x: 25,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F4AA-1F3FE",
              non_qualified: null,
              image: "1f4aa-1f3fe.png",
              sheet_x: 25,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F4AA-1F3FF",
              non_qualified: null,
              image: "1f4aa-1f3ff.png",
              sheet_x: 25,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Flexed Biceps",
          b: "1F4AA",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["arm", "flex", "hand", "summer", "strong", "biceps"],
          k: [25, 16]
        },
        point_left: {
          skin_variations: {
            "1F3FB": {
              unified: "1F448-1F3FB",
              non_qualified: null,
              image: "1f448-1f3fb.png",
              sheet_x: 14,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F448-1F3FC",
              non_qualified: null,
              image: "1f448-1f3fc.png",
              sheet_x: 14,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F448-1F3FD",
              non_qualified: null,
              image: "1f448-1f3fd.png",
              sheet_x: 14,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F448-1F3FE",
              non_qualified: null,
              image: "1f448-1f3fe.png",
              sheet_x: 14,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F448-1F3FF",
              non_qualified: null,
              image: "1f448-1f3ff.png",
              sheet_x: 14,
              sheet_y: 24,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Left Pointing Backhand Index",
          b: "1F448",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["direction", "fingers", "hand", "left"],
          k: [14, 19]
        },
        point_right: {
          skin_variations: {
            "1F3FB": {
              unified: "1F449-1F3FB",
              non_qualified: null,
              image: "1f449-1f3fb.png",
              sheet_x: 14,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F449-1F3FC",
              non_qualified: null,
              image: "1f449-1f3fc.png",
              sheet_x: 14,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F449-1F3FD",
              non_qualified: null,
              image: "1f449-1f3fd.png",
              sheet_x: 14,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F449-1F3FE",
              non_qualified: null,
              image: "1f449-1f3fe.png",
              sheet_x: 14,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F449-1F3FF",
              non_qualified: null,
              image: "1f449-1f3ff.png",
              sheet_x: 14,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Right Pointing Backhand Index",
          b: "1F449",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "hand", "direction", "right"],
          k: [14, 25]
        },
        point_up: {
          skin_variations: {
            "1F3FB": {
              unified: "261D-1F3FB",
              non_qualified: null,
              image: "261d-1f3fb.png",
              sheet_x: 47,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "261D-1F3FC",
              non_qualified: null,
              image: "261d-1f3fc.png",
              sheet_x: 47,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "261D-1F3FD",
              non_qualified: null,
              image: "261d-1f3fd.png",
              sheet_x: 47,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "261D-1F3FE",
              non_qualified: null,
              image: "261d-1f3fe.png",
              sheet_x: 47,
              sheet_y: 30,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "261D-1F3FF",
              non_qualified: null,
              image: "261d-1f3ff.png",
              sheet_x: 47,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Up Pointing Index",
          b: "261D-FE0F",
          c: "261D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hand", "fingers", "direction", "up"],
          k: [47, 26],
          o: 1
        },
        point_up_2: {
          skin_variations: {
            "1F3FB": {
              unified: "1F446-1F3FB",
              non_qualified: null,
              image: "1f446-1f3fb.png",
              sheet_x: 14,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F446-1F3FC",
              non_qualified: null,
              image: "1f446-1f3fc.png",
              sheet_x: 14,
              sheet_y: 9,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F446-1F3FD",
              non_qualified: null,
              image: "1f446-1f3fd.png",
              sheet_x: 14,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F446-1F3FE",
              non_qualified: null,
              image: "1f446-1f3fe.png",
              sheet_x: 14,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F446-1F3FF",
              non_qualified: null,
              image: "1f446-1f3ff.png",
              sheet_x: 14,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Up Pointing Backhand Index",
          b: "1F446",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "hand", "direction", "up"],
          k: [14, 7]
        },
        middle_finger: {
          skin_variations: {
            "1F3FB": {
              unified: "1F595-1F3FB",
              non_qualified: null,
              image: "1f595-1f3fb.png",
              sheet_x: 29,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F595-1F3FC",
              non_qualified: null,
              image: "1f595-1f3fc.png",
              sheet_x: 29,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F595-1F3FD",
              non_qualified: null,
              image: "1f595-1f3fd.png",
              sheet_x: 29,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F595-1F3FE",
              non_qualified: null,
              image: "1f595-1f3fe.png",
              sheet_x: 29,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F595-1F3FF",
              non_qualified: null,
              image: "1f595-1f3ff.png",
              sheet_x: 29,
              sheet_y: 43,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Reversed Hand with Middle Finger Extended",
          b: "1F595",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 38],
          n: ["reversed_hand_with_middle_finger_extended"],
          o: 7
        },
        point_down: {
          skin_variations: {
            "1F3FB": {
              unified: "1F447-1F3FB",
              non_qualified: null,
              image: "1f447-1f3fb.png",
              sheet_x: 14,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F447-1F3FC",
              non_qualified: null,
              image: "1f447-1f3fc.png",
              sheet_x: 14,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F447-1F3FD",
              non_qualified: null,
              image: "1f447-1f3fd.png",
              sheet_x: 14,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F447-1F3FE",
              non_qualified: null,
              image: "1f447-1f3fe.png",
              sheet_x: 14,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F447-1F3FF",
              non_qualified: null,
              image: "1f447-1f3ff.png",
              sheet_x: 14,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "White Down Pointing Backhand Index",
          b: "1F447",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "hand", "direction", "down"],
          k: [14, 13]
        },
        v: {
          skin_variations: {
            "1F3FB": {
              unified: "270C-1F3FB",
              non_qualified: null,
              image: "270c-1f3fb.png",
              sheet_x: 49,
              sheet_y: 31,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "270C-1F3FC",
              non_qualified: null,
              image: "270c-1f3fc.png",
              sheet_x: 49,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "270C-1F3FD",
              non_qualified: null,
              image: "270c-1f3fd.png",
              sheet_x: 49,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "270C-1F3FE",
              non_qualified: null,
              image: "270c-1f3fe.png",
              sheet_x: 49,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "270C-1F3FF",
              non_qualified: null,
              image: "270c-1f3ff.png",
              sheet_x: 49,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Victory Hand",
          b: "270C-FE0F",
          c: "270C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "ohyeah", "hand", "peace", "victory", "two"],
          k: [49, 30],
          o: 1
        },
        crossed_fingers: {
          skin_variations: {
            "1F3FB": {
              unified: "1F91E-1F3FB",
              non_qualified: null,
              image: "1f91e-1f3fb.png",
              sheet_x: 38,
              sheet_y: 12,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91E-1F3FC",
              non_qualified: null,
              image: "1f91e-1f3fc.png",
              sheet_x: 38,
              sheet_y: 13,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91E-1F3FD",
              non_qualified: null,
              image: "1f91e-1f3fd.png",
              sheet_x: 38,
              sheet_y: 14,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91E-1F3FE",
              non_qualified: null,
              image: "1f91e-1f3fe.png",
              sheet_x: 38,
              sheet_y: 15,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91E-1F3FF",
              non_qualified: null,
              image: "1f91e-1f3ff.png",
              sheet_x: 38,
              sheet_y: 16,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Hand with Index and Middle Fingers Crossed",
          b: "1F91E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["good", "lucky"],
          k: [38, 11],
          n: ["hand_with_index_and_middle_fingers_crossed"],
          o: 9
        },
        "spock-hand": {
          skin_variations: {
            "1F3FB": {
              unified: "1F596-1F3FB",
              non_qualified: null,
              image: "1f596-1f3fb.png",
              sheet_x: 29,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F596-1F3FC",
              non_qualified: null,
              image: "1f596-1f3fc.png",
              sheet_x: 29,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F596-1F3FD",
              non_qualified: null,
              image: "1f596-1f3fd.png",
              sheet_x: 29,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F596-1F3FE",
              non_qualified: null,
              image: "1f596-1f3fe.png",
              sheet_x: 29,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F596-1F3FF",
              non_qualified: null,
              image: "1f596-1f3ff.png",
              sheet_x: 29,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Raised Hand with Part Between Middle and Ring Fingers",
          b: "1F596",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [29, 44],
          o: 7
        },
        the_horns: {
          skin_variations: {
            "1F3FB": {
              unified: "1F918-1F3FB",
              non_qualified: null,
              image: "1f918-1f3fb.png",
              sheet_x: 37,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F918-1F3FC",
              non_qualified: null,
              image: "1f918-1f3fc.png",
              sheet_x: 37,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F918-1F3FD",
              non_qualified: null,
              image: "1f918-1f3fd.png",
              sheet_x: 37,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F918-1F3FE",
              non_qualified: null,
              image: "1f918-1f3fe.png",
              sheet_x: 37,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F918-1F3FF",
              non_qualified: null,
              image: "1f918-1f3ff.png",
              sheet_x: 37,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Sign of the Horns",
          b: "1F918",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 32],
          n: ["sign_of_the_horns"],
          o: 8
        },
        call_me_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "1F919-1F3FB",
              non_qualified: null,
              image: "1f919-1f3fb.png",
              sheet_x: 37,
              sheet_y: 39,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F919-1F3FC",
              non_qualified: null,
              image: "1f919-1f3fc.png",
              sheet_x: 37,
              sheet_y: 40,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F919-1F3FD",
              non_qualified: null,
              image: "1f919-1f3fd.png",
              sheet_x: 37,
              sheet_y: 41,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F919-1F3FE",
              non_qualified: null,
              image: "1f919-1f3fe.png",
              sheet_x: 37,
              sheet_y: 42,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F919-1F3FF",
              non_qualified: null,
              image: "1f919-1f3ff.png",
              sheet_x: 37,
              sheet_y: 43,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Call Me Hand",
          b: "1F919",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["hands", "gesture"],
          k: [37, 38],
          o: 9
        },
        raised_hand_with_fingers_splayed: {
          skin_variations: {
            "1F3FB": {
              unified: "1F590-1F3FB",
              non_qualified: null,
              image: "1f590-1f3fb.png",
              sheet_x: 29,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F590-1F3FC",
              non_qualified: null,
              image: "1f590-1f3fc.png",
              sheet_x: 29,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F590-1F3FD",
              non_qualified: null,
              image: "1f590-1f3fd.png",
              sheet_x: 29,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F590-1F3FE",
              non_qualified: null,
              image: "1f590-1f3fe.png",
              sheet_x: 29,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F590-1F3FF",
              non_qualified: null,
              image: "1f590-1f3ff.png",
              sheet_x: 29,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Raised Hand with Fingers Splayed",
          b: "1F590-FE0F",
          c: "1F590",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["hand", "fingers", "palm"],
          k: [29, 32],
          o: 7
        },
        hand: {
          skin_variations: {
            "1F3FB": {
              unified: "270B-1F3FB",
              non_qualified: null,
              image: "270b-1f3fb.png",
              sheet_x: 49,
              sheet_y: 25,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "270B-1F3FC",
              non_qualified: null,
              image: "270b-1f3fc.png",
              sheet_x: 49,
              sheet_y: 26,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "270B-1F3FD",
              non_qualified: null,
              image: "270b-1f3fd.png",
              sheet_x: 49,
              sheet_y: 27,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "270B-1F3FE",
              non_qualified: null,
              image: "270b-1f3fe.png",
              sheet_x: 49,
              sheet_y: 28,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "270B-1F3FF",
              non_qualified: null,
              image: "270b-1f3ff.png",
              sheet_x: 49,
              sheet_y: 29,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Raised Hand",
          b: "270B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [49, 24],
          n: ["raised_hand"]
        },
        ok_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "1F44C-1F3FB",
              non_qualified: null,
              image: "1f44c-1f3fb.png",
              sheet_x: 14,
              sheet_y: 44,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44C-1F3FC",
              non_qualified: null,
              image: "1f44c-1f3fc.png",
              sheet_x: 14,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44C-1F3FD",
              non_qualified: null,
              image: "1f44c-1f3fd.png",
              sheet_x: 14,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44C-1F3FE",
              non_qualified: null,
              image: "1f44c-1f3fe.png",
              sheet_x: 14,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44C-1F3FF",
              non_qualified: null,
              image: "1f44c-1f3ff.png",
              sheet_x: 14,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Ok Hand Sign",
          b: "1F44C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "limbs", "perfect", "ok", "okay"],
          k: [14, 43]
        },
        "+1": {
          skin_variations: {
            "1F3FB": {
              unified: "1F44D-1F3FB",
              non_qualified: null,
              image: "1f44d-1f3fb.png",
              sheet_x: 14,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44D-1F3FC",
              non_qualified: null,
              image: "1f44d-1f3fc.png",
              sheet_x: 14,
              sheet_y: 51,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44D-1F3FD",
              non_qualified: null,
              image: "1f44d-1f3fd.png",
              sheet_x: 15,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44D-1F3FE",
              non_qualified: null,
              image: "1f44d-1f3fe.png",
              sheet_x: 15,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44D-1F3FF",
              non_qualified: null,
              image: "1f44d-1f3ff.png",
              sheet_x: 15,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Thumbs Up Sign",
          b: "1F44D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["thumbsup", "yes", "awesome", "good", "agree", "accept", "cool", "hand", "like"],
          k: [14, 49],
          n: ["thumbsup"]
        },
        "-1": {
          skin_variations: {
            "1F3FB": {
              unified: "1F44E-1F3FB",
              non_qualified: null,
              image: "1f44e-1f3fb.png",
              sheet_x: 15,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44E-1F3FC",
              non_qualified: null,
              image: "1f44e-1f3fc.png",
              sheet_x: 15,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44E-1F3FD",
              non_qualified: null,
              image: "1f44e-1f3fd.png",
              sheet_x: 15,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44E-1F3FE",
              non_qualified: null,
              image: "1f44e-1f3fe.png",
              sheet_x: 15,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44E-1F3FF",
              non_qualified: null,
              image: "1f44e-1f3ff.png",
              sheet_x: 15,
              sheet_y: 8,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Thumbs Down Sign",
          b: "1F44E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["thumbsdown", "no", "dislike", "hand"],
          k: [15, 3],
          n: ["thumbsdown"]
        },
        fist: {
          skin_variations: {
            "1F3FB": {
              unified: "270A-1F3FB",
              non_qualified: null,
              image: "270a-1f3fb.png",
              sheet_x: 49,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "270A-1F3FC",
              non_qualified: null,
              image: "270a-1f3fc.png",
              sheet_x: 49,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "270A-1F3FD",
              non_qualified: null,
              image: "270a-1f3fd.png",
              sheet_x: 49,
              sheet_y: 21,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "270A-1F3FE",
              non_qualified: null,
              image: "270a-1f3fe.png",
              sheet_x: 49,
              sheet_y: 22,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "270A-1F3FF",
              non_qualified: null,
              image: "270a-1f3ff.png",
              sheet_x: 49,
              sheet_y: 23,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Raised Fist",
          b: "270A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "hand", "grasp"],
          k: [49, 18]
        },
        facepunch: {
          skin_variations: {
            "1F3FB": {
              unified: "1F44A-1F3FB",
              non_qualified: null,
              image: "1f44a-1f3fb.png",
              sheet_x: 14,
              sheet_y: 32,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44A-1F3FC",
              non_qualified: null,
              image: "1f44a-1f3fc.png",
              sheet_x: 14,
              sheet_y: 33,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44A-1F3FD",
              non_qualified: null,
              image: "1f44a-1f3fd.png",
              sheet_x: 14,
              sheet_y: 34,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44A-1F3FE",
              non_qualified: null,
              image: "1f44a-1f3fe.png",
              sheet_x: 14,
              sheet_y: 35,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44A-1F3FF",
              non_qualified: null,
              image: "1f44a-1f3ff.png",
              sheet_x: 14,
              sheet_y: 36,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Fisted Hand Sign",
          b: "1F44A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["angry", "violence", "fist", "hit", "attack", "hand"],
          k: [14, 31],
          n: ["punch"]
        },
        "left-facing_fist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F91B-1F3FB",
              non_qualified: null,
              image: "1f91b-1f3fb.png",
              sheet_x: 37,
              sheet_y: 51,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91B-1F3FC",
              non_qualified: null,
              image: "1f91b-1f3fc.png",
              sheet_x: 38,
              sheet_y: 0,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91B-1F3FD",
              non_qualified: null,
              image: "1f91b-1f3fd.png",
              sheet_x: 38,
              sheet_y: 1,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91B-1F3FE",
              non_qualified: null,
              image: "1f91b-1f3fe.png",
              sheet_x: 38,
              sheet_y: 2,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91B-1F3FF",
              non_qualified: null,
              image: "1f91b-1f3ff.png",
              sheet_x: 38,
              sheet_y: 3,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Left-Facing Fist",
          b: "1F91B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 50],
          o: 9
        },
        "right-facing_fist": {
          skin_variations: {
            "1F3FB": {
              unified: "1F91C-1F3FB",
              non_qualified: null,
              image: "1f91c-1f3fb.png",
              sheet_x: 38,
              sheet_y: 5,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91C-1F3FC",
              non_qualified: null,
              image: "1f91c-1f3fc.png",
              sheet_x: 38,
              sheet_y: 6,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91C-1F3FD",
              non_qualified: null,
              image: "1f91c-1f3fd.png",
              sheet_x: 38,
              sheet_y: 7,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91C-1F3FE",
              non_qualified: null,
              image: "1f91c-1f3fe.png",
              sheet_x: 38,
              sheet_y: 8,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91C-1F3FF",
              non_qualified: null,
              image: "1f91c-1f3ff.png",
              sheet_x: 38,
              sheet_y: 9,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Right-Facing Fist",
          b: "1F91C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 4],
          o: 9
        },
        raised_back_of_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "1F91A-1F3FB",
              non_qualified: null,
              image: "1f91a-1f3fb.png",
              sheet_x: 37,
              sheet_y: 45,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91A-1F3FC",
              non_qualified: null,
              image: "1f91a-1f3fc.png",
              sheet_x: 37,
              sheet_y: 46,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91A-1F3FD",
              non_qualified: null,
              image: "1f91a-1f3fd.png",
              sheet_x: 37,
              sheet_y: 47,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91A-1F3FE",
              non_qualified: null,
              image: "1f91a-1f3fe.png",
              sheet_x: 37,
              sheet_y: 48,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91A-1F3FF",
              non_qualified: null,
              image: "1f91a-1f3ff.png",
              sheet_x: 37,
              sheet_y: 49,
              added_in: "9.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Raised Back of Hand",
          b: "1F91A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["fingers", "raised", "backhand"],
          k: [37, 44],
          o: 9
        },
        wave: {
          skin_variations: {
            "1F3FB": {
              unified: "1F44B-1F3FB",
              non_qualified: null,
              image: "1f44b-1f3fb.png",
              sheet_x: 14,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44B-1F3FC",
              non_qualified: null,
              image: "1f44b-1f3fc.png",
              sheet_x: 14,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44B-1F3FD",
              non_qualified: null,
              image: "1f44b-1f3fd.png",
              sheet_x: 14,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44B-1F3FE",
              non_qualified: null,
              image: "1f44b-1f3fe.png",
              sheet_x: 14,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44B-1F3FF",
              non_qualified: null,
              image: "1f44b-1f3ff.png",
              sheet_x: 14,
              sheet_y: 42,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Waving Hand Sign",
          b: "1F44B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hands", "gesture", "goodbye", "solong", "farewell", "hello", "hi", "palm"],
          k: [14, 37]
        },
        i_love_you_hand_sign: {
          skin_variations: {
            "1F3FB": {
              unified: "1F91F-1F3FB",
              non_qualified: null,
              image: "1f91f-1f3fb.png",
              sheet_x: 38,
              sheet_y: 18,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F91F-1F3FC",
              non_qualified: null,
              image: "1f91f-1f3fc.png",
              sheet_x: 38,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F91F-1F3FD",
              non_qualified: null,
              image: "1f91f-1f3fd.png",
              sheet_x: 38,
              sheet_y: 20,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F91F-1F3FE",
              non_qualified: null,
              image: "1f91f-1f3fe.png",
              sheet_x: 38,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F91F-1F3FF",
              non_qualified: null,
              image: "1f91f-1f3ff.png",
              sheet_x: 38,
              sheet_y: 22,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "I Love You Hand Sign",
          b: "1F91F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [38, 17],
          o: 10
        },
        writing_hand: {
          skin_variations: {
            "1F3FB": {
              unified: "270D-1F3FB",
              non_qualified: null,
              image: "270d-1f3fb.png",
              sheet_x: 49,
              sheet_y: 37,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "270D-1F3FC",
              non_qualified: null,
              image: "270d-1f3fc.png",
              sheet_x: 49,
              sheet_y: 38,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "270D-1F3FD",
              non_qualified: null,
              image: "270d-1f3fd.png",
              sheet_x: 49,
              sheet_y: 39,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "270D-1F3FE",
              non_qualified: null,
              image: "270d-1f3fe.png",
              sheet_x: 49,
              sheet_y: 40,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "270D-1F3FF",
              non_qualified: null,
              image: "270d-1f3ff.png",
              sheet_x: 49,
              sheet_y: 41,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Writing Hand",
          b: "270D-FE0F",
          c: "270D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["lower_left_ballpoint_pen", "stationery", "write", "compose"],
          k: [49, 36],
          o: 1
        },
        clap: {
          skin_variations: {
            "1F3FB": {
              unified: "1F44F-1F3FB",
              non_qualified: null,
              image: "1f44f-1f3fb.png",
              sheet_x: 15,
              sheet_y: 10,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F44F-1F3FC",
              non_qualified: null,
              image: "1f44f-1f3fc.png",
              sheet_x: 15,
              sheet_y: 11,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F44F-1F3FD",
              non_qualified: null,
              image: "1f44f-1f3fd.png",
              sheet_x: 15,
              sheet_y: 12,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F44F-1F3FE",
              non_qualified: null,
              image: "1f44f-1f3fe.png",
              sheet_x: 15,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F44F-1F3FF",
              non_qualified: null,
              image: "1f44f-1f3ff.png",
              sheet_x: 15,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Clapping Hands Sign",
          b: "1F44F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["hands", "praise", "applause", "congrats", "yay"],
          k: [15, 9]
        },
        open_hands: {
          skin_variations: {
            "1F3FB": {
              unified: "1F450-1F3FB",
              non_qualified: null,
              image: "1f450-1f3fb.png",
              sheet_x: 15,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F450-1F3FC",
              non_qualified: null,
              image: "1f450-1f3fc.png",
              sheet_x: 15,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F450-1F3FD",
              non_qualified: null,
              image: "1f450-1f3fd.png",
              sheet_x: 15,
              sheet_y: 18,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F450-1F3FE",
              non_qualified: null,
              image: "1f450-1f3fe.png",
              sheet_x: 15,
              sheet_y: 19,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F450-1F3FF",
              non_qualified: null,
              image: "1f450-1f3ff.png",
              sheet_x: 15,
              sheet_y: 20,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Open Hands Sign",
          b: "1F450",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fingers", "butterfly", "hands", "open"],
          k: [15, 15]
        },
        raised_hands: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64C-1F3FB",
              non_qualified: null,
              image: "1f64c-1f3fb.png",
              sheet_x: 33,
              sheet_y: 13,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64C-1F3FC",
              non_qualified: null,
              image: "1f64c-1f3fc.png",
              sheet_x: 33,
              sheet_y: 14,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64C-1F3FD",
              non_qualified: null,
              image: "1f64c-1f3fd.png",
              sheet_x: 33,
              sheet_y: 15,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64C-1F3FE",
              non_qualified: null,
              image: "1f64c-1f3fe.png",
              sheet_x: 33,
              sheet_y: 16,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64C-1F3FF",
              non_qualified: null,
              image: "1f64c-1f3ff.png",
              sheet_x: 33,
              sheet_y: 17,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Person Raising Both Hands in Celebration",
          b: "1F64C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["gesture", "hooray", "yea", "celebration", "hands"],
          k: [33, 12]
        },
        palms_up_together: {
          skin_variations: {
            "1F3FB": {
              unified: "1F932-1F3FB",
              non_qualified: null,
              image: "1f932-1f3fb.png",
              sheet_x: 39,
              sheet_y: 17,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FC": {
              unified: "1F932-1F3FC",
              non_qualified: null,
              image: "1f932-1f3fc.png",
              sheet_x: 39,
              sheet_y: 18,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FD": {
              unified: "1F932-1F3FD",
              non_qualified: null,
              image: "1f932-1f3fd.png",
              sheet_x: 39,
              sheet_y: 19,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FE": {
              unified: "1F932-1F3FE",
              non_qualified: null,
              image: "1f932-1f3fe.png",
              sheet_x: 39,
              sheet_y: 20,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            },
            "1F3FF": {
              unified: "1F932-1F3FF",
              non_qualified: null,
              image: "1f932-1f3ff.png",
              sheet_x: 39,
              sheet_y: 21,
              added_in: "10.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !1
            }
          },
          a: "Palms Up Together",
          b: "1F932",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [39, 16],
          o: 10
        },
        pray: {
          skin_variations: {
            "1F3FB": {
              unified: "1F64F-1F3FB",
              non_qualified: null,
              image: "1f64f-1f3fb.png",
              sheet_x: 34,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F64F-1F3FC",
              non_qualified: null,
              image: "1f64f-1f3fc.png",
              sheet_x: 34,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F64F-1F3FD",
              non_qualified: null,
              image: "1f64f-1f3fd.png",
              sheet_x: 34,
              sheet_y: 5,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F64F-1F3FE",
              non_qualified: null,
              image: "1f64f-1f3fe.png",
              sheet_x: 34,
              sheet_y: 6,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F64F-1F3FF",
              non_qualified: null,
              image: "1f64f-1f3ff.png",
              sheet_x: 34,
              sheet_y: 7,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Person with Folded Hands",
          b: "1F64F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["please", "hope", "wish", "namaste", "highfive"],
          k: [34, 2]
        },
        handshake: {
          a: "Handshake",
          b: "1F91D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["agreement", "shake"],
          k: [38, 10],
          o: 9
        },
        nail_care: {
          skin_variations: {
            "1F3FB": {
              unified: "1F485-1F3FB",
              non_qualified: null,
              image: "1f485-1f3fb.png",
              sheet_x: 23,
              sheet_y: 45,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F485-1F3FC",
              non_qualified: null,
              image: "1f485-1f3fc.png",
              sheet_x: 23,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F485-1F3FD",
              non_qualified: null,
              image: "1f485-1f3fd.png",
              sheet_x: 23,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F485-1F3FE",
              non_qualified: null,
              image: "1f485-1f3fe.png",
              sheet_x: 23,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F485-1F3FF",
              non_qualified: null,
              image: "1f485-1f3ff.png",
              sheet_x: 23,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Nail Polish",
          b: "1F485",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["beauty", "manicure", "finger", "fashion", "nail"],
          k: [23, 44]
        },
        ear: {
          skin_variations: {
            "1F3FB": {
              unified: "1F442-1F3FB",
              non_qualified: null,
              image: "1f442-1f3fb.png",
              sheet_x: 13,
              sheet_y: 46,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F442-1F3FC",
              non_qualified: null,
              image: "1f442-1f3fc.png",
              sheet_x: 13,
              sheet_y: 47,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F442-1F3FD",
              non_qualified: null,
              image: "1f442-1f3fd.png",
              sheet_x: 13,
              sheet_y: 48,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F442-1F3FE",
              non_qualified: null,
              image: "1f442-1f3fe.png",
              sheet_x: 13,
              sheet_y: 49,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F442-1F3FF",
              non_qualified: null,
              image: "1f442-1f3ff.png",
              sheet_x: 13,
              sheet_y: 50,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Ear",
          b: "1F442",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "hear", "sound", "listen"],
          k: [13, 45]
        },
        nose: {
          skin_variations: {
            "1F3FB": {
              unified: "1F443-1F3FB",
              non_qualified: null,
              image: "1f443-1f3fb.png",
              sheet_x: 14,
              sheet_y: 0,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FC": {
              unified: "1F443-1F3FC",
              non_qualified: null,
              image: "1f443-1f3fc.png",
              sheet_x: 14,
              sheet_y: 1,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FD": {
              unified: "1F443-1F3FD",
              non_qualified: null,
              image: "1f443-1f3fd.png",
              sheet_x: 14,
              sheet_y: 2,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FE": {
              unified: "1F443-1F3FE",
              non_qualified: null,
              image: "1f443-1f3fe.png",
              sheet_x: 14,
              sheet_y: 3,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            },
            "1F3FF": {
              unified: "1F443-1F3FF",
              non_qualified: null,
              image: "1f443-1f3ff.png",
              sheet_x: 14,
              sheet_y: 4,
              added_in: "8.0",
              has_img_apple: !0,
              has_img_google: !0,
              has_img_twitter: !0,
              has_img_emojione: !0,
              has_img_facebook: !0,
              has_img_messenger: !0
            }
          },
          a: "Nose",
          b: "1F443",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["smell", "sniff"],
          k: [13, 51]
        },
        footprints: {
          a: "Footprints",
          b: "1F463",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["feet", "tracking", "walking", "beach"],
          k: [15, 39]
        },
        eyes: {
          a: "Eyes",
          b: "1F440",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["look", "watch", "stalk", "peek", "see"],
          k: [13, 42]
        },
        eye: {
          a: "Eye",
          b: "1F441-FE0F",
          c: "1F441",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "look", "see", "watch", "stare"],
          k: [13, 44],
          o: 7
        },
        "eye-in-speech-bubble": {
          a: "Eye in Speech Bubble",
          b: "1F441-FE0F-200D-1F5E8-FE0F",
          d: !0,
          e: !0,
          f: !1,
          g: !0,
          h: !1,
          i: !1,
          k: [13, 43],
          o: 7
        },
        brain: {
          a: "Brain",
          b: "1F9E0",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 22],
          o: 10
        },
        tongue: {
          a: "Tongue",
          b: "1F445",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mouth", "playful"],
          k: [14, 6]
        },
        lips: {
          a: "Mouth",
          b: "1F444",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["mouth", "kiss"],
          k: [14, 5]
        },
        kiss: {
          a: "Kiss Mark",
          b: "1F48B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["face", "lips", "love", "like", "affection", "valentines"],
          k: [24, 37]
        },
        cupid: {
          a: "Heart with Arrow",
          b: "1F498",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "heart", "affection", "valentines"],
          k: [24, 50]
        },
        heart: {
          a: "Heavy Black Heart",
          b: "2764-FE0F",
          c: "2764",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "valentines"],
          k: [50, 8],
          l: ["<3"],
          m: "<3",
          o: 1
        },
        heartbeat: {
          a: "Beating Heart",
          b: "1F493",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines", "pink", "heart"],
          k: [24, 45]
        },
        broken_heart: {
          a: "Broken Heart",
          b: "1F494",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sad", "sorry", "break", "heart", "heartbreak"],
          k: [24, 46],
          l: ["</3"],
          m: "</3"
        },
        two_hearts: {
          a: "Two Hearts",
          b: "1F495",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines", "heart"],
          k: [24, 47]
        },
        sparkling_heart: {
          a: "Sparkling Heart",
          b: "1F496",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [24, 48]
        },
        heartpulse: {
          a: "Growing Heart",
          b: "1F497",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["like", "love", "affection", "valentines", "pink"],
          k: [24, 49]
        },
        blue_heart: {
          a: "Blue Heart",
          b: "1F499",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [24, 51],
          m: "<3"
        },
        green_heart: {
          a: "Green Heart",
          b: "1F49A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [25, 0],
          m: "<3"
        },
        yellow_heart: {
          a: "Yellow Heart",
          b: "1F49B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [25, 1],
          m: "<3"
        },
        orange_heart: {
          a: "Orange Heart",
          b: "1F9E1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 23],
          o: 10
        },
        purple_heart: {
          a: "Purple Heart",
          b: "1F49C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [25, 2],
          m: "<3"
        },
        black_heart: {
          a: "Black Heart",
          b: "1F5A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["evil"],
          k: [29, 50],
          o: 9
        },
        gift_heart: {
          a: "Heart with Ribbon",
          b: "1F49D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "valentines"],
          k: [25, 3]
        },
        revolving_hearts: {
          a: "Revolving Hearts",
          b: "1F49E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["love", "like", "affection", "valentines"],
          k: [25, 4]
        },
        heart_decoration: {
          a: "Heart Decoration",
          b: "1F49F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["purple-square", "love", "like"],
          k: [25, 5]
        },
        heavy_heart_exclamation_mark_ornament: {
          a: "Heavy Heart Exclamation Mark Ornament",
          b: "2763-FE0F",
          c: "2763",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [50, 7],
          o: 1
        },
        love_letter: {
          a: "Love Letter",
          b: "1F48C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["email", "like", "affection", "envelope", "valentines"],
          k: [24, 38]
        },
        zzz: {
          a: "Sleeping Symbol",
          b: "1F4A4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["sleepy", "tired", "dream"],
          k: [25, 10]
        },
        anger: {
          a: "Anger Symbol",
          b: "1F4A2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["angry", "mad"],
          k: [25, 8]
        },
        bomb: {
          a: "Bomb",
          b: "1F4A3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["boom", "explode", "explosion", "terrorism"],
          k: [25, 9]
        },
        boom: {
          a: "Collision Symbol",
          b: "1F4A5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bomb", "explode", "explosion", "collision", "blown"],
          k: [25, 11],
          n: ["collision"]
        },
        sweat_drops: {
          a: "Splashing Sweat Symbol",
          b: "1F4A6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["water", "drip", "oops"],
          k: [25, 12]
        },
        dash: {
          a: "Dash Symbol",
          b: "1F4A8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wind", "air", "fast", "shoo", "fart", "smoke", "puff"],
          k: [25, 14]
        },
        dizzy: {
          a: "Dizzy Symbol",
          b: "1F4AB",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["star", "sparkle", "shoot", "magic"],
          k: [25, 22]
        },
        speech_balloon: {
          a: "Speech Balloon",
          b: "1F4AC",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bubble", "words", "message", "talk", "chatting"],
          k: [25, 23]
        },
        left_speech_bubble: {
          a: "Left Speech Bubble",
          b: "1F5E8-FE0F",
          c: "1F5E8",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["words", "message", "talk", "chatting"],
          k: [30, 15],
          o: 7
        },
        right_anger_bubble: {
          a: "Right Anger Bubble",
          b: "1F5EF-FE0F",
          c: "1F5EF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["caption", "speech", "thinking", "mad"],
          k: [30, 16],
          o: 7
        },
        thought_balloon: {
          a: "Thought Balloon",
          b: "1F4AD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bubble", "cloud", "speech", "thinking", "dream"],
          k: [25, 24]
        },
        hole: {
          a: "Hole",
          b: "1F573-FE0F",
          c: "1F573",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["embarrassing"],
          k: [28, 44],
          o: 7
        },
        eyeglasses: {
          a: "Eyeglasses",
          b: "1F453",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "accessories", "eyesight", "nerdy", "dork", "geek"],
          k: [15, 23]
        },
        dark_sunglasses: {
          a: "Dark Sunglasses",
          b: "1F576-FE0F",
          c: "1F576",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["face", "cool", "accessories"],
          k: [29, 17],
          o: 7
        },
        necktie: {
          a: "Necktie",
          b: "1F454",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shirt", "suitup", "formal", "fashion", "cloth", "business"],
          k: [15, 24]
        },
        shirt: {
          a: "T-Shirt",
          b: "1F455",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          k: [15, 25],
          n: ["tshirt"]
        },
        jeans: {
          a: "Jeans",
          b: "1F456",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "shopping"],
          k: [15, 26]
        },
        scarf: {
          a: "Scarf",
          b: "1F9E3",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 25],
          o: 10
        },
        gloves: {
          a: "Gloves",
          b: "1F9E4",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 26],
          o: 10
        },
        coat: {
          a: "Coat",
          b: "1F9E5",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 27],
          o: 10
        },
        socks: {
          a: "Socks",
          b: "1F9E6",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 28],
          o: 10
        },
        dress: {
          a: "Dress",
          b: "1F457",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["clothes", "fashion", "shopping"],
          k: [15, 27]
        },
        kimono: {
          a: "Kimono",
          b: "1F458",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["dress", "fashion", "women", "female", "japanese"],
          k: [15, 28]
        },
        bikini: {
          a: "Bikini",
          b: "1F459",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["swimming", "female", "woman", "girl", "fashion", "beach", "summer"],
          k: [15, 29]
        },
        womans_clothes: {
          a: "Womans Clothes",
          b: "1F45A",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "shopping_bags", "female"],
          k: [15, 30]
        },
        purse: {
          a: "Purse",
          b: "1F45B",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "accessories", "money", "sales", "shopping"],
          k: [15, 31]
        },
        handbag: {
          a: "Handbag",
          b: "1F45C",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "accessory", "accessories", "shopping"],
          k: [15, 32]
        },
        pouch: {
          a: "Pouch",
          b: "1F45D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["bag", "accessories", "shopping"],
          k: [15, 33]
        },
        shopping_bags: {
          a: "Shopping Bags",
          b: "1F6CD-FE0F",
          c: "1F6CD",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [37, 2],
          o: 7
        },
        school_satchel: {
          a: "School Satchel",
          b: "1F392",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["student", "education", "bag", "backpack"],
          k: [8, 37]
        },
        mans_shoe: {
          a: "Mans Shoe",
          b: "1F45E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "male"],
          k: [15, 34],
          n: ["shoe"]
        },
        athletic_shoe: {
          a: "Athletic Shoe",
          b: "1F45F",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shoes", "sports", "sneakers"],
          k: [15, 35]
        },
        high_heel: {
          a: "High-Heeled Shoe",
          b: "1F460",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "shoes", "female", "pumps", "stiletto"],
          k: [15, 36]
        },
        sandal: {
          a: "Womans Sandal",
          b: "1F461",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shoes", "fashion", "flip flops"],
          k: [15, 37]
        },
        boot: {
          a: "Womans Boots",
          b: "1F462",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["shoes", "fashion"],
          k: [15, 38]
        },
        crown: {
          a: "Crown",
          b: "1F451",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["king", "kod", "leader", "royalty", "lord"],
          k: [15, 21]
        },
        womans_hat: {
          a: "Womans Hat",
          b: "1F452",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["fashion", "accessories", "female", "lady", "spring"],
          k: [15, 22]
        },
        tophat: {
          a: "Top Hat",
          b: "1F3A9",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["magic", "gentleman", "classy", "circus"],
          k: [9, 3]
        },
        mortar_board: {
          a: "Graduation Cap",
          b: "1F393",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["school", "college", "degree", "university", "graduation", "cap", "hat", "legal", "learn", "education"],
          k: [8, 38]
        },
        billed_cap: {
          a: "Billed Cap",
          b: "1F9E2",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [46, 24],
          o: 10
        },
        helmet_with_white_cross: {
          a: "Helmet with White Cross",
          b: "26D1-FE0F",
          c: "26D1",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          k: [48, 33],
          o: 5
        },
        prayer_beads: {
          a: "Prayer Beads",
          b: "1F4FF",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !1,
          j: ["dhikr", "religious"],
          k: [27, 1],
          o: 8
        },
        lipstick: {
          a: "Lipstick",
          b: "1F484",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["female", "girl", "fashion", "woman"],
          k: [23, 43]
        },
        ring: {
          a: "Ring",
          b: "1F48D",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["wedding", "propose", "marriage", "valentines", "diamond", "fashion", "jewelry", "gem", "engagement"],
          k: [24, 39]
        },
        gem: {
          a: "Gem Stone",
          b: "1F48E",
          d: !0,
          e: !0,
          f: !0,
          g: !0,
          h: !0,
          i: !0,
          j: ["blue", "ruby", "diamond", "jewelry"],
          k: [24, 40]
        }
      },
      aliases: {
        satisfied: "laughing",
        grinning_face_with_star_eyes: "star-struck",
        face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
        telephone: "phone",
        cooking: "fried_egg",
        paw_prints: "feet",
        "flag-cn": "cn",
        lantern: "izakaya_lantern",
        shocked_face_with_exploding_head: "exploding_head",
        open_book: "book",
        "flag-de": "de",
        grinning_face_with_one_large_and_one_small_eye: "zany_face",
        serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
        flipper: "dolphin",
        face_with_open_mouth_vomiting: "face_vomiting",
        "flag-es": "es",
        face_with_finger_covering_closed_lips: "shushing_face",
        smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
        "flag-fr": "fr",
        honeybee: "bee",
        red_car: "car",
        envelope: "email",
        uk: "gb",
        "flag-gb": "gb",
        poop: "hankey",
        shit: "hankey",
        staff_of_aesculapius: "medical_symbol",
        knife: "hocho",
        sailboat: "boat",
        pencil: "memo",
        "flag-it": "it",
        "flag-jp": "jp",
        heavy_exclamation_mark: "exclamation",
        "flag-kr": "kr",
        waxing_gibbous_moon: "moon",
        mother_christmas: "mrs_claus",
        sun_small_cloud: "mostly_sunny",
        sun_behind_cloud: "barely_sunny",
        sun_behind_rain_cloud: "partly_sunny_rain",
        lightning_cloud: "lightning",
        tornado_cloud: "tornado",
        "flag-ru": "ru",
        running: "runner",
        "flag-us": "us",
        man_and_woman_holding_hands: "couple",
        "man-woman-boy": "family",
        family: "man-woman-boy",
        reversed_hand_with_middle_finger_extended: "middle_finger",
        hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
        sign_of_the_horns: "the_horns",
        raised_hand: "hand",
        thumbsup: "+1",
        thumbsdown: "-1",
        punch: "facepunch",
        collision: "boom",
        tshirt: "shirt",
        shoe: "mans_shoe"
      }
    };
  }, function (e, i, a) {
    "use strict";

    Object.defineProperty(i, "__esModule", {
      value: !0
    });

    for (var n = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), t = {
      alt: "altKey",
      control: "ctrlKey",
      meta: "metaKey",
      shift: "shiftKey"
    }, o = {
      add: "+",
      break: "pause",
      cmd: "meta",
      command: "meta",
      ctl: "control",
      ctrl: "control",
      del: "delete",
      down: "arrowdown",
      esc: "escape",
      ins: "insert",
      left: "arrowleft",
      mod: n ? "meta" : "control",
      opt: "alt",
      option: "alt",
      return: "enter",
      right: "arrowright",
      space: " ",
      spacebar: " ",
      up: "arrowup",
      win: "meta",
      windows: "meta"
    }, s = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      control: 17,
      alt: 18,
      pause: 19,
      capslock: 20,
      escape: 27,
      " ": 32,
      pageup: 33,
      pagedown: 34,
      end: 35,
      home: 36,
      arrowleft: 37,
      arrowup: 38,
      arrowright: 39,
      arrowdown: 40,
      insert: 45,
      delete: 46,
      meta: 91,
      numlock: 144,
      scrolllock: 145,
      ";": 186,
      "=": 187,
      ",": 188,
      "-": 189,
      ".": 190,
      "/": 191,
      "`": 192,
      "[": 219,
      "\\": 220,
      "]": 221,
      "'": 222
    }, r = 1; r < 20; r++) {
      s["f" + r] = 111 + r;
    }

    function isHotkey(e, i, a) {
      !i || "byKey" in i || (a = i, i = null), Array.isArray(e) || (e = [e]);

      var n = e.map(function (e) {
        return parseHotkey(e, i);
      }),
          t = function check(e) {
        return n.some(function (i) {
          return compareHotkey(i, e);
        });
      };

      return null == a ? t : t(a);
    }

    function parseHotkey(e, i) {
      var a = i && i.byKey,
          n = {},
          o = (e = e.replace("++", "+add")).split("+"),
          s = o.length;

      for (var r in t) {
        n[t[r]] = !1;
      }

      var g = !0,
          l = !1,
          f = void 0;

      try {
        for (var h, m = o[Symbol.iterator](); !(g = (h = m.next()).done); g = !0) {
          var _ = h.value,
              d = _.endsWith("?") && _.length > 1;
          d && (_ = _.slice(0, -1));
          var c = toKeyName(_),
              F = t[c];
          1 !== s && F || (a ? n.key = c : n.which = toKeyCode(_)), F && (n[F] = !d || null);
        }
      } catch (u) {
        l = !0, f = u;
      } finally {
        try {
          !g && m.return && m.return();
        } finally {
          if (l) throw f;
        }
      }

      return n;
    }

    function compareHotkey(e, i) {
      for (var a in e) {
        var n = e[a],
            t = void 0;
        if (null != n && (null != (t = "key" === a && null != i.key ? i.key.toLowerCase() : "which" === a ? 91 === n && 93 === i.which ? 91 : i.which : i[a]) || !1 !== n) && t !== n) return !1;
      }

      return !0;
    }

    function toKeyCode(e) {
      return e = toKeyName(e), s[e] || e.toUpperCase().charCodeAt(0);
    }

    function toKeyName(e) {
      return e = e.toLowerCase(), e = o[e] || e;
    }

    i.default = isHotkey, i.isHotkey = isHotkey, i.isCodeHotkey = function isCodeHotkey(e, i) {
      return isHotkey(e, i);
    }, i.isKeyHotkey = function isKeyHotkey(e, i) {
      return isHotkey(e, {
        byKey: !0
      }, i);
    }, i.parseHotkey = parseHotkey, i.compareHotkey = compareHotkey, i.toKeyCode = toKeyCode, i.toKeyName = toKeyName;
  }, function (e, i, a) {
    var n = a(85),
        t = a(86);

    e.exports = function copyObject(e, i, a, o) {
      var s = !a;
      a || (a = {});

      for (var r = -1, g = i.length; ++r < g;) {
        var l = i[r],
            f = o ? o(a[l], e[l], l, a, e) : void 0;
        void 0 === f && (f = e[l]), s ? t(a, l, f) : n(a, l, f);
      }

      return a;
    };
  }, function (e, i) {
    var a = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = a);
  }, function (e, i, a) {
    e.exports = !a(92)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, i, a) {
    e.exports = {
      default: a(223),
      __esModule: !0
    };
  }, function (e, i, a) {
    var n = a(17),
        t = a(12),
        o = "[object Symbol]";

    e.exports = function isSymbol(e) {
      return "symbol" == typeof e || t(e) && n(e) == o;
    };
  }, function (e, i) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, i, a) {
    var n = a(129),
        t = a(130),
        o = a(131),
        s = a(132),
        r = a(133);

    function ListCache(e) {
      var i = -1,
          a = null == e ? 0 : e.length;

      for (this.clear(); ++i < a;) {
        var n = e[i];
        this.set(n[0], n[1]);
      }
    }

    ListCache.prototype.clear = n, ListCache.prototype.delete = t, ListCache.prototype.get = o, ListCache.prototype.has = s, ListCache.prototype.set = r, e.exports = ListCache;
  }, function (e, i, a) {
    var n = a(38);

    e.exports = function assocIndexOf(e, i) {
      for (var a = e.length; a--;) {
        if (n(e[a][0], i)) return a;
      }

      return -1;
    };
  }, function (e, i, a) {
    var n = a(14)(Object, "create");
    e.exports = n;
  }, function (e, i, a) {
    var n = a(151);

    e.exports = function getMapData(e, i) {
      var a = e.__data__;
      return n(i) ? a["string" == typeof i ? "string" : "hash"] : a.map;
    };
  }, function (e, i, a) {
    var n = a(172),
        t = a(39),
        o = a(173),
        s = a(174),
        r = a(175),
        g = a(17),
        l = a(72),
        f = l(n),
        h = l(t),
        m = l(o),
        _ = l(s),
        d = l(r),
        c = g;

    (n && "[object DataView]" != c(new n(new ArrayBuffer(1))) || t && "[object Map]" != c(new t()) || o && "[object Promise]" != c(o.resolve()) || s && "[object Set]" != c(new s()) || r && "[object WeakMap]" != c(new r())) && (c = function getTag(e) {
      var i = g(e),
          a = "[object Object]" == i ? e.constructor : void 0,
          n = a ? l(a) : "";
      if (n) switch (n) {
        case f:
          return "[object DataView]";

        case h:
          return "[object Map]";

        case m:
          return "[object Promise]";

        case _:
          return "[object Set]";

        case d:
          return "[object WeakMap]";
      }
      return i;
    }), e.exports = c;
  }, function (e, i, a) {
    var n = a(34),
        t = a(55);
    e.exports = a(24) ? function (e, i, a) {
      return n.f(e, i, t(1, a));
    } : function (e, i, a) {
      return e[i] = a, e;
    };
  }, function (e, i, a) {
    var n = a(35),
        t = a(227),
        o = a(228),
        s = Object.defineProperty;
    i.f = a(24) ? Object.defineProperty : function defineProperty(e, i, a) {
      if (n(e), i = o(i, !0), n(a), t) try {
        return s(e, i, a);
      } catch (r) {}
      if ("get" in a || "set" in a) throw TypeError("Accessors not supported!");
      return "value" in a && (e[i] = a.value), e;
    };
  }, function (e, i, a) {
    var n = a(54);

    e.exports = function (e) {
      if (!n(e)) throw TypeError(e + " is not an object!");
      return e;
    };
  }, function (e, i) {
    var a = {}.hasOwnProperty;

    e.exports = function (e, i) {
      return a.call(e, i);
    };
  }, function (e, i) {
    e.exports = function isUrl(e) {
      if ("string" !== typeof e) return !1;
      var i = e.match(a);
      if (!i) return !1;
      var o = i[1];
      if (!o) return !1;
      if (n.test(o) || t.test(o)) return !0;
      return !1;
    };

    var a = /^(?:\w+:)?\/\/(\S+)$/,
        n = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/,
        t = /^[^\s\.]+\.\S{2,}$/;
  }, function (e, i) {
    e.exports = function eq(e, i) {
      return e === i || e !== e && i !== i;
    };
  }, function (e, i, a) {
    var n = a(14)(a(6), "Map");
    e.exports = n;
  }, function (e, i, a) {
    var n = a(143),
        t = a(150),
        o = a(152),
        s = a(153),
        r = a(154);

    function MapCache(e) {
      var i = -1,
          a = null == e ? 0 : e.length;

      for (this.clear(); ++i < a;) {
        var n = e[i];
        this.set(n[0], n[1]);
      }
    }

    MapCache.prototype.clear = n, MapCache.prototype.delete = t, MapCache.prototype.get = o, MapCache.prototype.has = s, MapCache.prototype.set = r, e.exports = MapCache;
  }, function (e, i) {
    e.exports = function arrayPush(e, i) {
      for (var a = -1, n = i.length, t = e.length; ++a < n;) {
        e[t + a] = i[a];
      }

      return e;
    };
  }, function (e, i, a) {
    var n = a(164),
        t = a(77),
        o = Object.prototype.propertyIsEnumerable,
        s = Object.getOwnPropertySymbols,
        r = s ? function (e) {
      return null == e ? [] : (e = Object(e), n(s(e), function (i) {
        return o.call(e, i);
      }));
    } : t;
    e.exports = r;
  }, function (e, i, a) {
    var n = a(78),
        t = a(170),
        o = a(83);

    e.exports = function keys(e) {
      return o(e) ? n(e) : t(e);
    };
  }, function (e, i, a) {
    (function (e) {
      var n = a(6),
          t = a(167),
          o = i && !i.nodeType && i,
          s = o && "object" == typeof e && e && !e.nodeType && e,
          r = s && s.exports === o ? n.Buffer : void 0,
          g = (r ? r.isBuffer : void 0) || t;
      e.exports = g;
    }).call(this, a(27)(e));
  }, function (e, i) {
    e.exports = function baseUnary(e) {
      return function (i) {
        return e(i);
      };
    };
  }, function (e, i, a) {
    (function (e) {
      var n = a(68),
          t = i && !i.nodeType && i,
          o = t && "object" == typeof e && e && !e.nodeType && e,
          s = o && o.exports === t && n.process,
          r = function () {
        try {
          var e = o && o.require && o.require("util").types;

          return e || s && s.binding && s.binding("util");
        } catch (i) {}
      }();

      e.exports = r;
    }).call(this, a(27)(e));
  }, function (e, i) {
    var a = Object.prototype;

    e.exports = function isPrototype(e) {
      var i = e && e.constructor;
      return e === ("function" == typeof i && i.prototype || a);
    };
  }, function (e, i, a) {
    var n = a(78),
        t = a(180),
        o = a(83);

    e.exports = function keysIn(e) {
      return o(e) ? n(e, !0) : t(e);
    };
  }, function (e, i, a) {
    var n = a(82)(Object.getPrototypeOf, Object);
    e.exports = n;
  }, function (e, i, a) {
    var n = a(74);

    e.exports = function cloneArrayBuffer(e) {
      var i = new e.constructor(e.byteLength);
      return new n(i).set(new n(e)), i;
    };
  }, function (e, i, a) {
    var n = a(13),
        t = a(199),
        o = a(200),
        s = a(203);

    e.exports = function castPath(e, i) {
      return n(e) ? e : t(e, i) ? [e] : o(s(e));
    };
  }, function (e, i, a) {
    var n = a(222);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var t = {
      insert: "head",
      singleton: !1
    };
    a(10)(n, t);
    n.locals && (e.exports = n.locals);
  }, function (e, i, a) {
    var n = a(23),
        t = a(19),
        o = a(91),
        s = a(33),
        r = a(36),
        g = function $export(e, i, a) {
      var g,
          l,
          f,
          h = e & $export.F,
          m = e & $export.G,
          _ = e & $export.S,
          d = e & $export.P,
          c = e & $export.B,
          F = e & $export.W,
          u = m ? t : t[i] || (t[i] = {}),
          p = u.prototype,
          b = m ? n : _ ? n[i] : (n[i] || {}).prototype;

      for (g in m && (a = i), a) {
        (l = !h && b && void 0 !== b[g]) && r(u, g) || (f = l ? b[g] : a[g], u[g] = m && "function" != typeof b[g] ? a[g] : c && l ? o(f, n) : F && b[g] == f ? function (e) {
          var i = function F(i, a, n) {
            if (this instanceof e) {
              switch (arguments.length) {
                case 0:
                  return new e();

                case 1:
                  return new e(i);

                case 2:
                  return new e(i, a);
              }

              return new e(i, a, n);
            }

            return e.apply(this, arguments);
          };

          return i.prototype = e.prototype, i;
        }(f) : d && "function" == typeof f ? o(Function.call, f) : f, d && ((u.virtual || (u.virtual = {}))[g] = f, e & $export.R && p && !p[g] && s(p, g, f)));
      }
    };

    g.F = 1, g.G = 2, g.S = 4, g.P = 8, g.B = 16, g.W = 32, g.U = 64, g.R = 128, e.exports = g;
  }, function (e, i) {
    e.exports = function (e) {
      return "object" === typeof e ? null !== e : "function" === typeof e;
    };
  }, function (e, i) {
    e.exports = function (e, i) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: i
      };
    };
  }, function (e, i, a) {
    var n = a(231),
        t = a(57);

    e.exports = function (e) {
      return n(t(e));
    };
  }, function (e, i) {
    e.exports = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on  " + e);
      return e;
    };
  }, function (e, i) {
    var a = Math.ceil,
        n = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? n : a)(e);
    };
  }, function (e, i, a) {
    var n = a(97)("keys"),
        t = a(99);

    e.exports = function (e) {
      return n[e] || (n[e] = t(e));
    };
  }, function (e, i) {
    e.exports = {};
  }, function (e, i) {
    e.exports = o;
  }, function (e, i, a) {
    "use strict";

    var n = a(114),
        t = a(115),
        o = a(67);
    e.exports = {
      formats: o,
      parse: t,
      stringify: n
    };
  }, function (e, i, a) {
    "use strict";

    e.exports = function direction(e) {
      if (e = String(e || ""), t.test(e)) return "rtl";
      if (o.test(e)) return "ltr";
      return "neutral";
    };

    var n = "A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF",
        t = new RegExp("^[^" + n + "]*[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]"),
        o = new RegExp("^[^\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]*[" + n + "]");
  }, function (e, i, a) {
    var n = a(84),
        t = a(176),
        o = a(198),
        s = a(51),
        r = a(22),
        g = a(209),
        l = a(211),
        f = a(89),
        h = l(function (e, i) {
      var a = {};
      if (null == e) return a;
      var l = !1;
      i = n(i, function (i) {
        return i = s(i, e), l || (l = i.length > 1), i;
      }), r(e, f(e), a), l && (a = t(a, 7, g));

      for (var h = i.length; h--;) {
        o(a, i[h]);
      }

      return a;
    });
    e.exports = h;
  }, function (e, i, a) {
    "use strict";

    var n = /["'&<>]/;

    e.exports = function escapeHtml(e) {
      var i,
          a = "" + e,
          t = n.exec(a);
      if (!t) return a;
      var o = "",
          s = 0,
          r = 0;

      for (s = t.index; s < a.length; s++) {
        switch (a.charCodeAt(s)) {
          case 34:
            i = "&quot;";
            break;

          case 38:
            i = "&amp;";
            break;

          case 39:
            i = "&#39;";
            break;

          case 60:
            i = "&lt;";
            break;

          case 62:
            i = "&gt;";
            break;

          default:
            continue;
        }

        r !== s && (o += a.substring(r, s)), r = s + 1, o += i;
      }

      return r !== s ? o + a.substring(r, s) : o;
    };
  }, function (e, i, a) {
    "use strict";

    var n = Object.prototype.hasOwnProperty,
        t = Array.isArray,
        o = function () {
      for (var e = [], i = 0; i < 256; ++i) {
        e.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
      }

      return e;
    }(),
        s = function arrayToObject(e, i) {
      for (var a = i && i.plainObjects ? Object.create(null) : {}, n = 0; n < e.length; ++n) {
        "undefined" !== typeof e[n] && (a[n] = e[n]);
      }

      return a;
    };

    e.exports = {
      arrayToObject: s,
      assign: function assignSingleSource(e, i) {
        return Object.keys(i).reduce(function (e, a) {
          return e[a] = i[a], e;
        }, e);
      },
      combine: function combine(e, i) {
        return [].concat(e, i);
      },
      compact: function compact(e) {
        for (var i = [{
          obj: {
            o: e
          },
          prop: "o"
        }], a = [], n = 0; n < i.length; ++n) {
          for (var o = i[n], s = o.obj[o.prop], r = Object.keys(s), g = 0; g < r.length; ++g) {
            var l = r[g],
                f = s[l];
            "object" === typeof f && null !== f && -1 === a.indexOf(f) && (i.push({
              obj: s,
              prop: l
            }), a.push(f));
          }
        }

        return function compactQueue(e) {
          for (; e.length > 1;) {
            var i = e.pop(),
                a = i.obj[i.prop];

            if (t(a)) {
              for (var n = [], o = 0; o < a.length; ++o) {
                "undefined" !== typeof a[o] && n.push(a[o]);
              }

              i.obj[i.prop] = n;
            }
          }
        }(i), e;
      },
      decode: function decode(e, i, a) {
        var n = e.replace(/\+/g, " ");
        if ("iso-8859-1" === a) return n.replace(/%[0-9a-f]{2}/gi, unescape);

        try {
          return decodeURIComponent(n);
        } catch (t) {
          return n;
        }
      },
      encode: function encode(e, i, a) {
        if (0 === e.length) return e;
        var n = "string" === typeof e ? e : String(e);
        if ("iso-8859-1" === a) return escape(n).replace(/%u[0-9a-f]{4}/gi, function (e) {
          return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
        });

        for (var t = "", s = 0; s < n.length; ++s) {
          var r = n.charCodeAt(s);
          45 === r || 46 === r || 95 === r || 126 === r || r >= 48 && r <= 57 || r >= 65 && r <= 90 || r >= 97 && r <= 122 ? t += n.charAt(s) : r < 128 ? t += o[r] : r < 2048 ? t += o[192 | r >> 6] + o[128 | 63 & r] : r < 55296 || r >= 57344 ? t += o[224 | r >> 12] + o[128 | r >> 6 & 63] + o[128 | 63 & r] : (s += 1, r = 65536 + ((1023 & r) << 10 | 1023 & n.charCodeAt(s)), t += o[240 | r >> 18] + o[128 | r >> 12 & 63] + o[128 | r >> 6 & 63] + o[128 | 63 & r]);
        }

        return t;
      },
      isBuffer: function isBuffer(e) {
        return !(!e || "object" !== typeof e) && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
      },
      isRegExp: function isRegExp(e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      },
      merge: function merge(e, i, a) {
        if (!i) return e;

        if ("object" !== typeof i) {
          if (t(e)) e.push(i);else {
            if (!e || "object" !== typeof e) return [e, i];
            (a && (a.plainObjects || a.allowPrototypes) || !n.call(Object.prototype, i)) && (e[i] = !0);
          }
          return e;
        }

        if (!e || "object" !== typeof e) return [e].concat(i);
        var o = e;
        return t(e) && !t(i) && (o = s(e, a)), t(e) && t(i) ? (i.forEach(function (i, t) {
          if (n.call(e, t)) {
            var o = e[t];
            o && "object" === typeof o && i && "object" === typeof i ? e[t] = merge(o, i, a) : e.push(i);
          } else e[t] = i;
        }), e) : Object.keys(i).reduce(function (e, t) {
          var o = i[t];
          return n.call(e, t) ? e[t] = merge(e[t], o, a) : e[t] = o, e;
        }, o);
      }
    };
  }, function (e, i, a) {
    "use strict";

    var n = String.prototype.replace,
        t = /%20/g;
    e.exports = {
      default: "RFC3986",
      formatters: {
        RFC1738: function RFC1738(e) {
          return n.call(e, t, "+");
        },
        RFC3986: function RFC3986(e) {
          return e;
        }
      },
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
  }, function (e, i, a) {
    (function (i) {
      var a = "object" == typeof i && i && i.Object === Object && i;
      e.exports = a;
    }).call(this, a(69));
  }, function (e, i) {
    var a;

    a = function () {
      return this;
    }();

    try {
      a = a || new Function("return this")();
    } catch (n) {
      "object" === typeof window && (a = window);
    }

    e.exports = a;
  }, function (e, i, a) {
    var n = a(28),
        t = a(134),
        o = a(135),
        s = a(136),
        r = a(137),
        g = a(138);

    function Stack(e) {
      var i = this.__data__ = new n(e);
      this.size = i.size;
    }

    Stack.prototype.clear = t, Stack.prototype.delete = o, Stack.prototype.get = s, Stack.prototype.has = r, Stack.prototype.set = g, e.exports = Stack;
  }, function (e, i, a) {
    var n = a(17),
        t = a(11),
        o = "[object AsyncFunction]",
        s = "[object Function]",
        r = "[object GeneratorFunction]",
        g = "[object Proxy]";

    e.exports = function isFunction(e) {
      if (!t(e)) return !1;
      var i = n(e);
      return i == s || i == r || i == o || i == g;
    };
  }, function (e, i) {
    var a = Function.prototype.toString;

    e.exports = function toSource(e) {
      if (null != e) {
        try {
          return a.call(e);
        } catch (i) {}

        try {
          return e + "";
        } catch (i) {}
      }

      return "";
    };
  }, function (e, i, a) {
    var n = a(155),
        t = a(158),
        o = a(159),
        s = 1,
        r = 2;

    e.exports = function equalArrays(e, i, a, g, l, f) {
      var h = a & s,
          m = e.length,
          _ = i.length;
      if (m != _ && !(h && _ > m)) return !1;
      var d = f.get(e),
          c = f.get(i);
      if (d && c) return d == i && c == e;
      var F = -1,
          u = !0,
          p = a & r ? new n() : void 0;

      for (f.set(e, i), f.set(i, e); ++F < m;) {
        var b = e[F],
            k = i[F];
        if (g) var A = h ? g(k, b, F, i, e, f) : g(b, k, F, e, i, f);

        if (void 0 !== A) {
          if (A) continue;
          u = !1;
          break;
        }

        if (p) {
          if (!t(i, function (e, i) {
            if (!o(p, i) && (b === e || l(b, e, a, g, f))) return p.push(i);
          })) {
            u = !1;
            break;
          }
        } else if (b !== k && !l(b, k, a, g, f)) {
          u = !1;
          break;
        }
      }

      return f.delete(e), f.delete(i), u;
    };
  }, function (e, i, a) {
    var n = a(6).Uint8Array;
    e.exports = n;
  }, function (e, i, a) {
    var n = a(76),
        t = a(42),
        o = a(43);

    e.exports = function getAllKeys(e) {
      return n(e, o, t);
    };
  }, function (e, i, a) {
    var n = a(41),
        t = a(13);

    e.exports = function baseGetAllKeys(e, i, a) {
      var o = i(e);
      return t(e) ? o : n(o, a(e));
    };
  }, function (e, i) {
    e.exports = function stubArray() {
      return [];
    };
  }, function (e, i, a) {
    var n = a(165),
        t = a(79),
        o = a(13),
        s = a(44),
        r = a(168),
        g = a(80),
        l = Object.prototype.hasOwnProperty;

    e.exports = function arrayLikeKeys(e, i) {
      var a = o(e),
          f = !a && t(e),
          h = !a && !f && s(e),
          m = !a && !f && !h && g(e),
          _ = a || f || h || m,
          d = _ ? n(e.length, String) : [],
          c = d.length;

      for (var F in e) {
        !i && !l.call(e, F) || _ && ("length" == F || h && ("offset" == F || "parent" == F) || m && ("buffer" == F || "byteLength" == F || "byteOffset" == F) || r(F, c)) || d.push(F);
      }

      return d;
    };
  }, function (e, i, a) {
    var n = a(166),
        t = a(12),
        o = Object.prototype,
        s = o.hasOwnProperty,
        r = o.propertyIsEnumerable,
        g = n(function () {
      return arguments;
    }()) ? n : function (e) {
      return t(e) && s.call(e, "callee") && !r.call(e, "callee");
    };
    e.exports = g;
  }, function (e, i, a) {
    var n = a(169),
        t = a(45),
        o = a(46),
        s = o && o.isTypedArray,
        r = s ? t(s) : n;
    e.exports = r;
  }, function (e, i) {
    var a = 9007199254740991;

    e.exports = function isLength(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= a;
    };
  }, function (e, i) {
    e.exports = function overArg(e, i) {
      return function (a) {
        return e(i(a));
      };
    };
  }, function (e, i, a) {
    var n = a(71),
        t = a(81);

    e.exports = function isArrayLike(e) {
      return null != e && t(e.length) && !n(e);
    };
  }, function (e, i) {
    e.exports = function arrayMap(e, i) {
      for (var a = -1, n = null == e ? 0 : e.length, t = Array(n); ++a < n;) {
        t[a] = i(e[a], a, e);
      }

      return t;
    };
  }, function (e, i, a) {
    var n = a(86),
        t = a(38),
        o = Object.prototype.hasOwnProperty;

    e.exports = function assignValue(e, i, a) {
      var s = e[i];
      o.call(e, i) && t(s, a) && (void 0 !== a || i in e) || n(e, i, a);
    };
  }, function (e, i, a) {
    var n = a(87);

    e.exports = function baseAssignValue(e, i, a) {
      "__proto__" == i && n ? n(e, i, {
        configurable: !0,
        enumerable: !0,
        value: a,
        writable: !0
      }) : e[i] = a;
    };
  }, function (e, i, a) {
    var n = a(14),
        t = function () {
      try {
        var e = n(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (i) {}
    }();

    e.exports = t;
  }, function (e, i, a) {
    var n = a(41),
        t = a(49),
        o = a(42),
        s = a(77),
        r = Object.getOwnPropertySymbols ? function (e) {
      for (var i = []; e;) {
        n(i, o(e)), e = t(e);
      }

      return i;
    } : s;
    e.exports = r;
  }, function (e, i, a) {
    var n = a(76),
        t = a(88),
        o = a(48);

    e.exports = function getAllKeysIn(e) {
      return n(e, o, t);
    };
  }, function (e, i, a) {
    var n = a(26),
        t = 1 / 0;

    e.exports = function toKey(e) {
      if ("string" == typeof e || n(e)) return e;
      var i = e + "";
      return "0" == i && 1 / e == -t ? "-0" : i;
    };
  }, function (e, i, a) {
    var n = a(226);

    e.exports = function (e, i, a) {
      if (n(e), void 0 === i) return e;

      switch (a) {
        case 1:
          return function (a) {
            return e.call(i, a);
          };

        case 2:
          return function (a, n) {
            return e.call(i, a, n);
          };

        case 3:
          return function (a, n, t) {
            return e.call(i, a, n, t);
          };
      }

      return function () {
        return e.apply(i, arguments);
      };
    };
  }, function (e, i) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (i) {
        return !0;
      }
    };
  }, function (e, i, a) {
    var n = a(54),
        t = a(23).document,
        o = n(t) && n(t.createElement);

    e.exports = function (e) {
      return o ? t.createElement(e) : {};
    };
  }, function (e, i, a) {
    var n = a(230),
        t = a(100);

    e.exports = Object.keys || function keys(e) {
      return n(e, t);
    };
  }, function (e, i) {
    var a = {}.toString;

    e.exports = function (e) {
      return a.call(e).slice(8, -1);
    };
  }, function (e, i, a) {
    var n = a(58),
        t = Math.min;

    e.exports = function (e) {
      return e > 0 ? t(n(e), 9007199254740991) : 0;
    };
  }, function (e, i, a) {
    var n = a(19),
        t = a(23),
        o = t["__core-js_shared__"] || (t["__core-js_shared__"] = {});
    (e.exports = function (e, i) {
      return o[e] || (o[e] = void 0 !== i ? i : {});
    })("versions", []).push({
      version: n.version,
      mode: a(98) ? "pure" : "global",
      copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, i) {
    e.exports = !0;
  }, function (e, i) {
    var a = 0,
        n = Math.random();

    e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++a + n).toString(36));
    };
  }, function (e, i) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, i, a) {
    var n = a(34).f,
        t = a(36),
        o = a(15)("toStringTag");

    e.exports = function (e, i, a) {
      e && !t(e = a ? e : e.prototype, o) && n(e, o, {
        configurable: !0,
        value: i
      });
    };
  }, function (e, i, a) {
    var n = a(57);

    e.exports = function (e) {
      return Object(n(e));
    };
  }, function (e, i) {
    e.exports = s;
  }, function (e) {
    e.exports = {
      FILE_API: "https://file2.api.driftqa.com",
      CUSTOMER_API: "https://customer2.api.driftqa.com",
      CONVERSATION_API: "https://conversation2.api.driftqa.com",
      PAGES_API: "https://pages.api.driftqa.com",
      PAGES_HOST: "driftqa.click",
      ACCOUNTS_API: "https://account.api.driftqa.com",
      WS_API: "https://ws.api.driftqa.com",
      WS: "wss://ws.api.driftqa.com",
      SALES_INBOX_ID: 44,
      SALES_USER_ID: 46894,
      AUTH_CLIENT_ID: "AUTH_CLIENT_ID"
    };
  }, function (e) {
    e.exports = {
      FILE_API: "https://file2.api.drift.com",
      CUSTOMER_API: "https://customer.api.drift.com",
      CONVERSATION_API: "https://conversation.api.drift.com",
      PAGES_API: "https://pages.api.drift.com",
      PAGES_HOST: "drift.click",
      ACCOUNTS_API: "https://account.api.drift.com",
      WS_API: "https://ws.api.drift.com",
      WS: "wss://ws.api.drift.com",
      SALES_INBOX_ID: 44,
      SALES_USER_ID: 46894,
      AUTH_CLIENT_ID: "AUTH_CLIENT_ID"
    };
  }, function (e, i, a) {
    var n = a(120),
        t = a(11),
        o = "Expected a function";

    e.exports = function throttle(e, i, a) {
      var s = !0,
          r = !0;
      if ("function" != typeof e) throw new TypeError(o);
      return t(a) && (s = "leading" in a ? !!a.leading : s, r = "trailing" in a ? !!a.trailing : r), n(e, i, {
        leading: s,
        maxWait: i,
        trailing: r
      });
    };
  }, function (e, i, a) {
    (function (e, n) {
      var t;
      !function (o) {
        var s = i,
            r = (e && e.exports, "object" == typeof n && n);
        r.global !== r && r.window;
        var g = /([\0-\u02FF\u0370-\u1AAF\u1B00-\u1DBF\u1E00-\u20CF\u2100-\uD7FF\uE000-\uFE1F\uFE30-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])([\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]+)/g,
            l = /([\uD800-\uDBFF])([\uDC00-\uDFFF])/g,
            f = {
          version: "0.2.0",
          reverse: function reverse(e) {
            for (var i = "", a = (e = e.replace(g, function (e, i, a) {
              return reverse(a) + i;
            }).replace(l, "$2$1")).length; a--;) {
              i += e.charAt(a);
            }

            return i;
          }
        };
        void 0 === (t = function () {
          return f;
        }.call(i, a, i, e)) || (e.exports = t);
      }();
    }).call(this, a(27)(e), a(69));
  }, function (e, i, a) {
    var n = a(127);

    e.exports = function isEqual(e, i) {
      return n(e, i);
    };
  }, function (e, i, a) {
    e.exports = {
      default: a(224),
      __esModule: !0
    };
  }, function (e, i, a) {
    "use strict";

    i.__esModule = !0;

    var n = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(a(235));

    i.default = function (e) {
      if (Array.isArray(e)) {
        for (var i = 0, a = Array(e.length); i < e.length; i++) {
          a[i] = e[i];
        }

        return a;
      }

      return (0, n.default)(e);
    };
  }, function (e, i) {
    e.exports = r;
  }, function (e, i, a) {
    e.exports = a(266);
  }, function (e, i, a) {
    var n = function (e) {
      "use strict";

      var i,
          a = Object.prototype,
          n = a.hasOwnProperty,
          t = "function" === typeof Symbol ? Symbol : {},
          o = t.iterator || "@@iterator",
          s = t.asyncIterator || "@@asyncIterator",
          r = t.toStringTag || "@@toStringTag";

      function define(e, i, a) {
        return Object.defineProperty(e, i, {
          value: a,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[i];
      }

      try {
        define({}, "");
      } catch (u) {
        define = function define(e, i, a) {
          return e[i] = a;
        };
      }

      function wrap(e, i, a, n) {
        var t = i && i.prototype instanceof Generator ? i : Generator,
            o = Object.create(t.prototype),
            s = new Context(n || []);
        return o._invoke = function makeInvokeMethod(e, i, a) {
          var n = g;
          return function invoke(t, o) {
            if (n === f) throw new Error("Generator is already running");

            if (n === h) {
              if ("throw" === t) throw o;
              return doneResult();
            }

            for (a.method = t, a.arg = o;;) {
              var s = a.delegate;

              if (s) {
                var r = maybeInvokeDelegate(s, a);

                if (r) {
                  if (r === m) continue;
                  return r;
                }
              }

              if ("next" === a.method) a.sent = a._sent = a.arg;else if ("throw" === a.method) {
                if (n === g) throw n = h, a.arg;
                a.dispatchException(a.arg);
              } else "return" === a.method && a.abrupt("return", a.arg);
              n = f;

              var _ = tryCatch(e, i, a);

              if ("normal" === _.type) {
                if (n = a.done ? h : l, _.arg === m) continue;
                return {
                  value: _.arg,
                  done: a.done
                };
              }

              "throw" === _.type && (n = h, a.method = "throw", a.arg = _.arg);
            }
          };
        }(e, a, s), o;
      }

      function tryCatch(e, i, a) {
        try {
          return {
            type: "normal",
            arg: e.call(i, a)
          };
        } catch (u) {
          return {
            type: "throw",
            arg: u
          };
        }
      }

      e.wrap = wrap;
      var g = "suspendedStart",
          l = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {}

      var _ = {};

      _[o] = function () {
        return this;
      };

      var d = Object.getPrototypeOf,
          c = d && d(d(values([])));
      c && c !== a && n.call(c, o) && (_ = c);
      var F = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(_);

      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (i) {
          define(e, i, function (e) {
            return this._invoke(i, e);
          });
        });
      }

      function AsyncIterator(e, i) {
        var a;

        this._invoke = function enqueue(t, o) {
          function callInvokeWithMethodAndArg() {
            return new i(function (a, s) {
              !function invoke(a, t, o, s) {
                var r = tryCatch(e[a], e, t);

                if ("throw" !== r.type) {
                  var g = r.arg,
                      l = g.value;
                  return l && "object" === typeof l && n.call(l, "__await") ? i.resolve(l.__await).then(function (e) {
                    invoke("next", e, o, s);
                  }, function (e) {
                    invoke("throw", e, o, s);
                  }) : i.resolve(l).then(function (e) {
                    g.value = e, o(g);
                  }, function (e) {
                    return invoke("throw", e, o, s);
                  });
                }

                s(r.arg);
              }(t, o, a, s);
            });
          }

          return a = a ? a.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }

      function maybeInvokeDelegate(e, a) {
        var n = e.iterator[a.method];

        if (n === i) {
          if (a.delegate = null, "throw" === a.method) {
            if (e.iterator.return && (a.method = "return", a.arg = i, maybeInvokeDelegate(e, a), "throw" === a.method)) return m;
            a.method = "throw", a.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return m;
        }

        var t = tryCatch(n, e.iterator, a.arg);
        if ("throw" === t.type) return a.method = "throw", a.arg = t.arg, a.delegate = null, m;
        var o = t.arg;
        return o ? o.done ? (a[e.resultName] = o.value, a.next = e.nextLoc, "return" !== a.method && (a.method = "next", a.arg = i), a.delegate = null, m) : o : (a.method = "throw", a.arg = new TypeError("iterator result is not an object"), a.delegate = null, m);
      }

      function pushTryEntry(e) {
        var i = {
          tryLoc: e[0]
        };
        1 in e && (i.catchLoc = e[1]), 2 in e && (i.finallyLoc = e[2], i.afterLoc = e[3]), this.tryEntries.push(i);
      }

      function resetTryEntry(e) {
        var i = e.completion || {};
        i.type = "normal", delete i.arg, e.completion = i;
      }

      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }

      function values(e) {
        if (e) {
          var a = e[o];
          if (a) return a.call(e);
          if ("function" === typeof e.next) return e;

          if (!isNaN(e.length)) {
            var t = -1,
                s = function next() {
              for (; ++t < e.length;) {
                if (n.call(e, t)) return next.value = e[t], next.done = !1, next;
              }

              return next.value = i, next.done = !0, next;
            };

            return s.next = s;
          }
        }

        return {
          next: doneResult
        };
      }

      function doneResult() {
        return {
          value: i,
          done: !0
        };
      }

      return GeneratorFunction.prototype = F.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunction.displayName = define(GeneratorFunctionPrototype, r, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var i = "function" === typeof e && e.constructor;
        return !!i && (i === GeneratorFunction || "GeneratorFunction" === (i.displayName || i.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, define(e, r, "GeneratorFunction")), e.prototype = Object.create(F), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[s] = function () {
        return this;
      }, e.AsyncIterator = AsyncIterator, e.async = function (i, a, n, t, o) {
        void 0 === o && (o = Promise);
        var s = new AsyncIterator(wrap(i, a, n, t), o);
        return e.isGeneratorFunction(a) ? s : s.next().then(function (e) {
          return e.done ? e.value : s.next();
        });
      }, defineIteratorMethods(F), define(F, r, "Generator"), F[o] = function () {
        return this;
      }, F.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var i = [];

        for (var a in e) {
          i.push(a);
        }

        return i.reverse(), function next() {
          for (; i.length;) {
            var a = i.pop();
            if (a in e) return next.value = a, next.done = !1, next;
          }

          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = i, this.done = !1, this.delegate = null, this.method = "next", this.arg = i, this.tryEntries.forEach(resetTryEntry), !e) for (var a in this) {
            "t" === a.charAt(0) && n.call(this, a) && !isNaN(+a.slice(1)) && (this[a] = i);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var a = this;

          function handle(n, t) {
            return s.type = "throw", s.arg = e, a.next = n, t && (a.method = "next", a.arg = i), !!t;
          }

          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var o = this.tryEntries[t],
                s = o.completion;
            if ("root" === o.tryLoc) return handle("end");

            if (o.tryLoc <= this.prev) {
              var r = n.call(o, "catchLoc"),
                  g = n.call(o, "finallyLoc");

              if (r && g) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              } else if (r) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
              } else {
                if (!g) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, i) {
          for (var a = this.tryEntries.length - 1; a >= 0; --a) {
            var t = this.tryEntries[a];

            if (t.tryLoc <= this.prev && n.call(t, "finallyLoc") && this.prev < t.finallyLoc) {
              var o = t;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= i && i <= o.finallyLoc && (o = null);
          var s = o ? o.completion : {};
          return s.type = e, s.arg = i, o ? (this.method = "next", this.next = o.finallyLoc, m) : this.complete(s);
        },
        complete: function complete(e, i) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && i && (this.next = i), m;
        },
        finish: function finish(e) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i];
            if (a.finallyLoc === e) return this.complete(a.completion, a.afterLoc), resetTryEntry(a), m;
          }
        },
        catch: function _catch(e) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i];

            if (a.tryLoc === e) {
              var n = a.completion;

              if ("throw" === n.type) {
                var t = n.arg;
                resetTryEntry(a);
              }

              return t;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, a, n) {
          return this.delegate = {
            iterator: values(e),
            resultName: a,
            nextLoc: n
          }, "next" === this.method && (this.arg = i), m;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = n;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (e, i, a) {
    "use strict";

    var n = a(66),
        t = a(67),
        o = Object.prototype.hasOwnProperty,
        s = {
      brackets: function brackets(e) {
        return e + "[]";
      },
      comma: "comma",
      indices: function indices(e, i) {
        return e + "[" + i + "]";
      },
      repeat: function repeat(e) {
        return e;
      }
    },
        r = Array.isArray,
        g = Array.prototype.push,
        l = function pushToArray(e, i) {
      g.apply(e, r(i) ? i : [i]);
    },
        f = Date.prototype.toISOString,
        h = {
      addQueryPrefix: !1,
      allowDots: !1,
      charset: "utf-8",
      charsetSentinel: !1,
      delimiter: "&",
      encode: !0,
      encoder: n.encode,
      encodeValuesOnly: !1,
      formatter: t.formatters[t.default],
      indices: !1,
      serializeDate: function serializeDate(e) {
        return f.call(e);
      },
      skipNulls: !1,
      strictNullHandling: !1
    },
        m = function stringify(e, i, a, t, o, s, g, f, m, _, d, c, F) {
      var u = e;

      if ("function" === typeof g ? u = g(i, u) : u instanceof Date ? u = _(u) : "comma" === a && r(u) && (u = u.join(",")), null === u) {
        if (t) return s && !c ? s(i, h.encoder, F) : i;
        u = "";
      }

      if ("string" === typeof u || "number" === typeof u || "boolean" === typeof u || n.isBuffer(u)) return s ? [d(c ? i : s(i, h.encoder, F)) + "=" + d(s(u, h.encoder, F))] : [d(i) + "=" + d(String(u))];
      var p,
          b = [];
      if ("undefined" === typeof u) return b;
      if (r(g)) p = g;else {
        var k = Object.keys(u);
        p = f ? k.sort(f) : k;
      }

      for (var A = 0; A < p.length; ++A) {
        var y = p[A];
        o && null === u[y] || (r(u) ? l(b, stringify(u[y], "function" === typeof a ? a(i, y) : i, a, t, o, s, g, f, m, _, d, c, F)) : l(b, stringify(u[y], i + (m ? "." + y : "[" + y + "]"), a, t, o, s, g, f, m, _, d, c, F)));
      }

      return b;
    };

    e.exports = function (e, i) {
      var a,
          n = e,
          g = function normalizeStringifyOptions(e) {
        if (!e) return h;
        if (null !== e.encoder && void 0 !== e.encoder && "function" !== typeof e.encoder) throw new TypeError("Encoder has to be a function.");
        var i = e.charset || h.charset;
        if ("undefined" !== typeof e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var a = t.default;

        if ("undefined" !== typeof e.format) {
          if (!o.call(t.formatters, e.format)) throw new TypeError("Unknown format option provided.");
          a = e.format;
        }

        var n = t.formatters[a],
            s = h.filter;
        return ("function" === typeof e.filter || r(e.filter)) && (s = e.filter), {
          addQueryPrefix: "boolean" === typeof e.addQueryPrefix ? e.addQueryPrefix : h.addQueryPrefix,
          allowDots: "undefined" === typeof e.allowDots ? h.allowDots : !!e.allowDots,
          charset: i,
          charsetSentinel: "boolean" === typeof e.charsetSentinel ? e.charsetSentinel : h.charsetSentinel,
          delimiter: "undefined" === typeof e.delimiter ? h.delimiter : e.delimiter,
          encode: "boolean" === typeof e.encode ? e.encode : h.encode,
          encoder: "function" === typeof e.encoder ? e.encoder : h.encoder,
          encodeValuesOnly: "boolean" === typeof e.encodeValuesOnly ? e.encodeValuesOnly : h.encodeValuesOnly,
          filter: s,
          formatter: n,
          serializeDate: "function" === typeof e.serializeDate ? e.serializeDate : h.serializeDate,
          skipNulls: "boolean" === typeof e.skipNulls ? e.skipNulls : h.skipNulls,
          sort: "function" === typeof e.sort ? e.sort : null,
          strictNullHandling: "boolean" === typeof e.strictNullHandling ? e.strictNullHandling : h.strictNullHandling
        };
      }(i);

      "function" === typeof g.filter ? n = (0, g.filter)("", n) : r(g.filter) && (a = g.filter);
      var f,
          _ = [];
      if ("object" !== typeof n || null === n) return "";
      f = i && i.arrayFormat in s ? i.arrayFormat : i && "indices" in i ? i.indices ? "indices" : "repeat" : "indices";
      var d = s[f];
      a || (a = Object.keys(n)), g.sort && a.sort(g.sort);

      for (var c = 0; c < a.length; ++c) {
        var F = a[c];
        g.skipNulls && null === n[F] || l(_, m(n[F], F, d, g.strictNullHandling, g.skipNulls, g.encode ? g.encoder : null, g.filter, g.sort, g.allowDots, g.serializeDate, g.formatter, g.encodeValuesOnly, g.charset));
      }

      var u = _.join(g.delimiter),
          p = !0 === g.addQueryPrefix ? "?" : "";

      return g.charsetSentinel && ("iso-8859-1" === g.charset ? p += "utf8=%26%2310003%3B&" : p += "utf8=%E2%9C%93&"), u.length > 0 ? p + u : "";
    };
  }, function (e, i, a) {
    "use strict";

    var n = a(66),
        t = Object.prototype.hasOwnProperty,
        o = {
      allowDots: !1,
      allowPrototypes: !1,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: !1,
      comma: !1,
      decoder: n.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: !1,
      interpretNumericEntities: !1,
      parameterLimit: 1e3,
      parseArrays: !0,
      plainObjects: !1,
      strictNullHandling: !1
    },
        s = function interpretNumericEntities(e) {
      return e.replace(/&#(\d+);/g, function (e, i) {
        return String.fromCharCode(parseInt(i, 10));
      });
    },
        r = function parseQueryStringKeys(e, i, a) {
      if (e) {
        var n = a.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
            o = /(\[[^[\]]*])/g,
            s = /(\[[^[\]]*])/.exec(n),
            r = s ? n.slice(0, s.index) : n,
            g = [];

        if (r) {
          if (!a.plainObjects && t.call(Object.prototype, r) && !a.allowPrototypes) return;
          g.push(r);
        }

        for (var l = 0; null !== (s = o.exec(n)) && l < a.depth;) {
          if (l += 1, !a.plainObjects && t.call(Object.prototype, s[1].slice(1, -1)) && !a.allowPrototypes) return;
          g.push(s[1]);
        }

        return s && g.push("[" + n.slice(s.index) + "]"), function parseObject(e, i, a) {
          for (var n = i, t = e.length - 1; t >= 0; --t) {
            var o,
                s = e[t];
            if ("[]" === s && a.parseArrays) o = [].concat(n);else {
              o = a.plainObjects ? Object.create(null) : {};
              var r = "[" === s.charAt(0) && "]" === s.charAt(s.length - 1) ? s.slice(1, -1) : s,
                  g = parseInt(r, 10);
              a.parseArrays || "" !== r ? !isNaN(g) && s !== r && String(g) === r && g >= 0 && a.parseArrays && g <= a.arrayLimit ? (o = [])[g] = n : o[r] = n : o = {
                0: n
              };
            }
            n = o;
          }

          return n;
        }(g, i, a);
      }
    };

    e.exports = function (e, i) {
      var a = function normalizeParseOptions(e) {
        if (!e) return o;
        if (null !== e.decoder && void 0 !== e.decoder && "function" !== typeof e.decoder) throw new TypeError("Decoder has to be a function.");
        if ("undefined" !== typeof e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new Error("The charset option must be either utf-8, iso-8859-1, or undefined");
        var i = "undefined" === typeof e.charset ? o.charset : e.charset;
        return {
          allowDots: "undefined" === typeof e.allowDots ? o.allowDots : !!e.allowDots,
          allowPrototypes: "boolean" === typeof e.allowPrototypes ? e.allowPrototypes : o.allowPrototypes,
          arrayLimit: "number" === typeof e.arrayLimit ? e.arrayLimit : o.arrayLimit,
          charset: i,
          charsetSentinel: "boolean" === typeof e.charsetSentinel ? e.charsetSentinel : o.charsetSentinel,
          comma: "boolean" === typeof e.comma ? e.comma : o.comma,
          decoder: "function" === typeof e.decoder ? e.decoder : o.decoder,
          delimiter: "string" === typeof e.delimiter || n.isRegExp(e.delimiter) ? e.delimiter : o.delimiter,
          depth: "number" === typeof e.depth ? e.depth : o.depth,
          ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
          interpretNumericEntities: "boolean" === typeof e.interpretNumericEntities ? e.interpretNumericEntities : o.interpretNumericEntities,
          parameterLimit: "number" === typeof e.parameterLimit ? e.parameterLimit : o.parameterLimit,
          parseArrays: !1 !== e.parseArrays,
          plainObjects: "boolean" === typeof e.plainObjects ? e.plainObjects : o.plainObjects,
          strictNullHandling: "boolean" === typeof e.strictNullHandling ? e.strictNullHandling : o.strictNullHandling
        };
      }(i);

      if ("" === e || null === e || "undefined" === typeof e) return a.plainObjects ? Object.create(null) : {};

      for (var g = "string" === typeof e ? function parseQueryStringValues(e, i) {
        var a,
            r = {},
            g = i.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
            l = i.parameterLimit === 1 / 0 ? void 0 : i.parameterLimit,
            f = g.split(i.delimiter, l),
            h = -1,
            m = i.charset;
        if (i.charsetSentinel) for (a = 0; a < f.length; ++a) {
          0 === f[a].indexOf("utf8=") && ("utf8=%E2%9C%93" === f[a] ? m = "utf-8" : "utf8=%26%2310003%3B" === f[a] && (m = "iso-8859-1"), h = a, a = f.length);
        }

        for (a = 0; a < f.length; ++a) {
          if (a !== h) {
            var _,
                d,
                c = f[a],
                F = c.indexOf("]="),
                u = -1 === F ? c.indexOf("=") : F + 1;

            -1 === u ? (_ = i.decoder(c, o.decoder, m), d = i.strictNullHandling ? null : "") : (_ = i.decoder(c.slice(0, u), o.decoder, m), d = i.decoder(c.slice(u + 1), o.decoder, m)), d && i.interpretNumericEntities && "iso-8859-1" === m && (d = s(d)), d && i.comma && d.indexOf(",") > -1 && (d = d.split(",")), t.call(r, _) ? r[_] = n.combine(r[_], d) : r[_] = d;
          }
        }

        return r;
      }(e, a) : e, l = a.plainObjects ? Object.create(null) : {}, f = Object.keys(g), h = 0; h < f.length; ++h) {
        var m = f[h],
            _ = r(m, g[m], a);

        l = n.merge(l, _, a);
      }

      return n.compact(l);
    };
  }, function (e, i, a) {
    var n = a(117);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var t = {
      insert: "head",
      singleton: !1
    };
    a(10)(n, t);
    n.locals && (e.exports = n.locals);
  }, function (e, i, a) {
    (e.exports = a(9)(!0)).push([e.i, ".email-wysiwyg-image {\n  display: block;\n  max-width: 100%;\n}\n\n.email-wysiwyg-image--focused {\n  box-shadow: 0 0 0 2px var(--color-p3-6);\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC",
      file: "style.css",
      sourcesContent: [".email-wysiwyg-image {\n  display: block;\n  max-width: 100%;\n}\n\n.email-wysiwyg-image--focused {\n  box-shadow: 0 0 0 2px var(--color-p3-6);\n}"]
    }]);
  }, function (e, i, a) {
    var n = a(119);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var t = {
      insert: "head",
      singleton: !1
    };
    a(10)(n, t);
    n.locals && (e.exports = n.locals);
  }, function (e, i, a) {
    (e.exports = a(9)(!0)).push([e.i, ".image-resize-input input {\n  width: 60px;\n  margin: 0 4px;\n}\n\n.width-input-unit {\n  margin-right: 16px;\n}\n\n.image-resize-input {\n  position: relative;\n  top: 0px;\n}\n\n.alt-text-input input {\n  width: 272px;\n}\n\n.alt-text-input p {\n  margin: 0px;\n}\n\n.alt-text-input {\n  margin-top: 16px;\n}\n\n.resizable-inputs-wrapper {\n  position: absolute;\n  padding: 16px 16px 8px 16px;\n  background: var(--color-p1-2);\n  box-shadow: var(--box-shadow-1);\n  border-radius: 3px;\n  width: 272px;\n  margin-top: 4px;\n  z-index: 3;\n  color: var(--color-p1-10);\n}\n\n.resizable-inputs-wrapper-row {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: baseline;\n          align-items: baseline;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,qBAAa;EAAb,aAAa;EACb,6BAAqB;UAArB,qBAAqB;AACvB",
      file: "style.css",
      sourcesContent: [".image-resize-input input {\n  width: 60px;\n  margin: 0 4px;\n}\n\n.width-input-unit {\n  margin-right: 16px;\n}\n\n.image-resize-input {\n  position: relative;\n  top: 0px;\n}\n\n.alt-text-input input {\n  width: 272px;\n}\n\n.alt-text-input p {\n  margin: 0px;\n}\n\n.alt-text-input {\n  margin-top: 16px;\n}\n\n.resizable-inputs-wrapper {\n  position: absolute;\n  padding: 16px 16px 8px 16px;\n  background: var(--color-p1-2);\n  box-shadow: var(--box-shadow-1);\n  border-radius: 3px;\n  width: 272px;\n  margin-top: 4px;\n  z-index: 3;\n  color: var(--color-p1-10);\n}\n\n.resizable-inputs-wrapper-row {\n  display: flex;\n  align-items: baseline;\n}\n"]
    }]);
  }, function (e, i, a) {
    var n = a(11),
        t = a(121),
        o = a(122),
        s = "Expected a function",
        r = Math.max,
        g = Math.min;

    e.exports = function debounce(e, i, a) {
      var l,
          f,
          h,
          m,
          _,
          d,
          c = 0,
          F = !1,
          u = !1,
          p = !0;

      if ("function" != typeof e) throw new TypeError(s);

      function invokeFunc(i) {
        var a = l,
            n = f;
        return l = f = void 0, c = i, m = e.apply(n, a);
      }

      function shouldInvoke(e) {
        var a = e - d;
        return void 0 === d || a >= i || a < 0 || u && e - c >= h;
      }

      function timerExpired() {
        var e = t();
        if (shouldInvoke(e)) return trailingEdge(e);
        _ = setTimeout(timerExpired, function remainingWait(e) {
          var a = i - (e - d);
          return u ? g(a, h - (e - c)) : a;
        }(e));
      }

      function trailingEdge(e) {
        return _ = void 0, p && l ? invokeFunc(e) : (l = f = void 0, m);
      }

      function debounced() {
        var e = t(),
            a = shouldInvoke(e);

        if (l = arguments, f = this, d = e, a) {
          if (void 0 === _) return function leadingEdge(e) {
            return c = e, _ = setTimeout(timerExpired, i), F ? invokeFunc(e) : m;
          }(d);
          if (u) return clearTimeout(_), _ = setTimeout(timerExpired, i), invokeFunc(d);
        }

        return void 0 === _ && (_ = setTimeout(timerExpired, i)), m;
      }

      return i = o(i) || 0, n(a) && (F = !!a.leading, h = (u = "maxWait" in a) ? r(o(a.maxWait) || 0, i) : h, p = "trailing" in a ? !!a.trailing : p), debounced.cancel = function cancel() {
        void 0 !== _ && clearTimeout(_), c = 0, l = d = f = _ = void 0;
      }, debounced.flush = function flush() {
        return void 0 === _ ? m : trailingEdge(t());
      }, debounced;
    };
  }, function (e, i, a) {
    var n = a(6);

    e.exports = function now() {
      return n.Date.now();
    };
  }, function (e, i, a) {
    var n = a(123),
        t = a(11),
        o = a(26),
        s = NaN,
        r = /^[-+]0x[0-9a-f]+$/i,
        g = /^0b[01]+$/i,
        l = /^0o[0-7]+$/i,
        f = parseInt;

    e.exports = function toNumber(e) {
      if ("number" == typeof e) return e;
      if (o(e)) return s;

      if (t(e)) {
        var i = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = t(i) ? i + "" : i;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = n(e);
      var a = g.test(e);
      return a || l.test(e) ? f(e.slice(2), a ? 2 : 8) : r.test(e) ? s : +e;
    };
  }, function (e, i, a) {
    var n = a(124),
        t = /^\s+/;

    e.exports = function baseTrim(e) {
      return e ? e.slice(0, n(e) + 1).replace(t, "") : e;
    };
  }, function (e, i) {
    var a = /\s/;

    e.exports = function trimmedEndIndex(e) {
      for (var i = e.length; i-- && a.test(e.charAt(i));) {
        ;
      }

      return i;
    };
  }, function (e, i, a) {
    var n = a(18),
        t = Object.prototype,
        o = t.hasOwnProperty,
        s = t.toString,
        r = n ? n.toStringTag : void 0;

    e.exports = function getRawTag(e) {
      var i = o.call(e, r),
          a = e[r];

      try {
        e[r] = void 0;
        var n = !0;
      } catch (g) {}

      var t = s.call(e);
      return n && (i ? e[r] = a : delete e[r]), t;
    };
  }, function (e, i) {
    var a = Object.prototype.toString;

    e.exports = function objectToString(e) {
      return a.call(e);
    };
  }, function (e, i, a) {
    var n = a(128),
        t = a(12);

    e.exports = function baseIsEqual(e, i, a, o, s) {
      return e === i || (null == e || null == i || !t(e) && !t(i) ? e !== e && i !== i : n(e, i, a, o, baseIsEqual, s));
    };
  }, function (e, i, a) {
    var n = a(70),
        t = a(73),
        o = a(160),
        s = a(163),
        r = a(32),
        g = a(13),
        l = a(44),
        f = a(80),
        h = 1,
        m = "[object Arguments]",
        _ = "[object Array]",
        d = "[object Object]",
        c = Object.prototype.hasOwnProperty;

    e.exports = function baseIsEqualDeep(e, i, a, F, u, p) {
      var b = g(e),
          k = g(i),
          A = b ? _ : r(e),
          y = k ? _ : r(i),
          v = (A = A == m ? d : A) == d,
          w = (y = y == m ? d : y) == d,
          E = A == y;

      if (E && l(e)) {
        if (!l(i)) return !1;
        b = !0, v = !1;
      }

      if (E && !v) return p || (p = new n()), b || f(e) ? t(e, i, a, F, u, p) : o(e, i, A, a, F, u, p);

      if (!(a & h)) {
        var j = v && c.call(e, "__wrapped__"),
            D = w && c.call(i, "__wrapped__");

        if (j || D) {
          var x = j ? e.value() : e,
              C = D ? i.value() : i;
          return p || (p = new n()), u(x, C, a, F, p);
        }
      }

      return !!E && (p || (p = new n()), s(e, i, a, F, u, p));
    };
  }, function (e, i) {
    e.exports = function listCacheClear() {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, i, a) {
    var n = a(29),
        t = Array.prototype.splice;

    e.exports = function listCacheDelete(e) {
      var i = this.__data__,
          a = n(i, e);
      return !(a < 0) && (a == i.length - 1 ? i.pop() : t.call(i, a, 1), --this.size, !0);
    };
  }, function (e, i, a) {
    var n = a(29);

    e.exports = function listCacheGet(e) {
      var i = this.__data__,
          a = n(i, e);
      return a < 0 ? void 0 : i[a][1];
    };
  }, function (e, i, a) {
    var n = a(29);

    e.exports = function listCacheHas(e) {
      return n(this.__data__, e) > -1;
    };
  }, function (e, i, a) {
    var n = a(29);

    e.exports = function listCacheSet(e, i) {
      var a = this.__data__,
          t = n(a, e);
      return t < 0 ? (++this.size, a.push([e, i])) : a[t][1] = i, this;
    };
  }, function (e, i, a) {
    var n = a(28);

    e.exports = function stackClear() {
      this.__data__ = new n(), this.size = 0;
    };
  }, function (e, i) {
    e.exports = function stackDelete(e) {
      var i = this.__data__,
          a = i.delete(e);
      return this.size = i.size, a;
    };
  }, function (e, i) {
    e.exports = function stackGet(e) {
      return this.__data__.get(e);
    };
  }, function (e, i) {
    e.exports = function stackHas(e) {
      return this.__data__.has(e);
    };
  }, function (e, i, a) {
    var n = a(28),
        t = a(39),
        o = a(40),
        s = 200;

    e.exports = function stackSet(e, i) {
      var a = this.__data__;

      if (a instanceof n) {
        var r = a.__data__;
        if (!t || r.length < s - 1) return r.push([e, i]), this.size = ++a.size, this;
        a = this.__data__ = new o(r);
      }

      return a.set(e, i), this.size = a.size, this;
    };
  }, function (e, i, a) {
    var n = a(71),
        t = a(140),
        o = a(11),
        s = a(72),
        r = /^\[object .+?Constructor\]$/,
        g = Function.prototype,
        l = Object.prototype,
        f = g.toString,
        h = l.hasOwnProperty,
        m = RegExp("^" + f.call(h).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function baseIsNative(e) {
      return !(!o(e) || t(e)) && (n(e) ? m : r).test(s(e));
    };
  }, function (e, i, a) {
    var n = a(141),
        t = function () {
      var e = /[^.]+$/.exec(n && n.keys && n.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }();

    e.exports = function isMasked(e) {
      return !!t && t in e;
    };
  }, function (e, i, a) {
    var n = a(6)["__core-js_shared__"];
    e.exports = n;
  }, function (e, i) {
    e.exports = function getValue(e, i) {
      return null == e ? void 0 : e[i];
    };
  }, function (e, i, a) {
    var n = a(144),
        t = a(28),
        o = a(39);

    e.exports = function mapCacheClear() {
      this.size = 0, this.__data__ = {
        hash: new n(),
        map: new (o || t)(),
        string: new n()
      };
    };
  }, function (e, i, a) {
    var n = a(145),
        t = a(146),
        o = a(147),
        s = a(148),
        r = a(149);

    function Hash(e) {
      var i = -1,
          a = null == e ? 0 : e.length;

      for (this.clear(); ++i < a;) {
        var n = e[i];
        this.set(n[0], n[1]);
      }
    }

    Hash.prototype.clear = n, Hash.prototype.delete = t, Hash.prototype.get = o, Hash.prototype.has = s, Hash.prototype.set = r, e.exports = Hash;
  }, function (e, i, a) {
    var n = a(30);

    e.exports = function hashClear() {
      this.__data__ = n ? n(null) : {}, this.size = 0;
    };
  }, function (e, i) {
    e.exports = function hashDelete(e) {
      var i = this.has(e) && delete this.__data__[e];
      return this.size -= i ? 1 : 0, i;
    };
  }, function (e, i, a) {
    var n = a(30),
        t = "__lodash_hash_undefined__",
        o = Object.prototype.hasOwnProperty;

    e.exports = function hashGet(e) {
      var i = this.__data__;

      if (n) {
        var a = i[e];
        return a === t ? void 0 : a;
      }

      return o.call(i, e) ? i[e] : void 0;
    };
  }, function (e, i, a) {
    var n = a(30),
        t = Object.prototype.hasOwnProperty;

    e.exports = function hashHas(e) {
      var i = this.__data__;
      return n ? void 0 !== i[e] : t.call(i, e);
    };
  }, function (e, i, a) {
    var n = a(30),
        t = "__lodash_hash_undefined__";

    e.exports = function hashSet(e, i) {
      var a = this.__data__;
      return this.size += this.has(e) ? 0 : 1, a[e] = n && void 0 === i ? t : i, this;
    };
  }, function (e, i, a) {
    var n = a(31);

    e.exports = function mapCacheDelete(e) {
      var i = n(this, e).delete(e);
      return this.size -= i ? 1 : 0, i;
    };
  }, function (e, i) {
    e.exports = function isKeyable(e) {
      var i = typeof e;
      return "string" == i || "number" == i || "symbol" == i || "boolean" == i ? "__proto__" !== e : null === e;
    };
  }, function (e, i, a) {
    var n = a(31);

    e.exports = function mapCacheGet(e) {
      return n(this, e).get(e);
    };
  }, function (e, i, a) {
    var n = a(31);

    e.exports = function mapCacheHas(e) {
      return n(this, e).has(e);
    };
  }, function (e, i, a) {
    var n = a(31);

    e.exports = function mapCacheSet(e, i) {
      var a = n(this, e),
          t = a.size;
      return a.set(e, i), this.size += a.size == t ? 0 : 1, this;
    };
  }, function (e, i, a) {
    var n = a(40),
        t = a(156),
        o = a(157);

    function SetCache(e) {
      var i = -1,
          a = null == e ? 0 : e.length;

      for (this.__data__ = new n(); ++i < a;) {
        this.add(e[i]);
      }
    }

    SetCache.prototype.add = SetCache.prototype.push = t, SetCache.prototype.has = o, e.exports = SetCache;
  }, function (e, i) {
    var a = "__lodash_hash_undefined__";

    e.exports = function setCacheAdd(e) {
      return this.__data__.set(e, a), this;
    };
  }, function (e, i) {
    e.exports = function setCacheHas(e) {
      return this.__data__.has(e);
    };
  }, function (e, i) {
    e.exports = function arraySome(e, i) {
      for (var a = -1, n = null == e ? 0 : e.length; ++a < n;) {
        if (i(e[a], a, e)) return !0;
      }

      return !1;
    };
  }, function (e, i) {
    e.exports = function cacheHas(e, i) {
      return e.has(i);
    };
  }, function (e, i, a) {
    var n = a(18),
        t = a(74),
        o = a(38),
        s = a(73),
        r = a(161),
        g = a(162),
        l = 1,
        f = 2,
        h = "[object Boolean]",
        m = "[object Date]",
        _ = "[object Error]",
        d = "[object Map]",
        c = "[object Number]",
        F = "[object RegExp]",
        u = "[object Set]",
        p = "[object String]",
        b = "[object Symbol]",
        k = "[object ArrayBuffer]",
        A = "[object DataView]",
        y = n ? n.prototype : void 0,
        v = y ? y.valueOf : void 0;

    e.exports = function equalByTag(e, i, a, n, y, w, E) {
      switch (a) {
        case A:
          if (e.byteLength != i.byteLength || e.byteOffset != i.byteOffset) return !1;
          e = e.buffer, i = i.buffer;

        case k:
          return !(e.byteLength != i.byteLength || !w(new t(e), new t(i)));

        case h:
        case m:
        case c:
          return o(+e, +i);

        case _:
          return e.name == i.name && e.message == i.message;

        case F:
        case p:
          return e == i + "";

        case d:
          var j = r;

        case u:
          var D = n & l;
          if (j || (j = g), e.size != i.size && !D) return !1;
          var x = E.get(e);
          if (x) return x == i;
          n |= f, E.set(e, i);
          var C = s(j(e), j(i), n, y, w, E);
          return E.delete(e), C;

        case b:
          if (v) return v.call(e) == v.call(i);
      }

      return !1;
    };
  }, function (e, i) {
    e.exports = function mapToArray(e) {
      var i = -1,
          a = Array(e.size);
      return e.forEach(function (e, n) {
        a[++i] = [n, e];
      }), a;
    };
  }, function (e, i) {
    e.exports = function setToArray(e) {
      var i = -1,
          a = Array(e.size);
      return e.forEach(function (e) {
        a[++i] = e;
      }), a;
    };
  }, function (e, i, a) {
    var n = a(75),
        t = 1,
        o = Object.prototype.hasOwnProperty;

    e.exports = function equalObjects(e, i, a, s, r, g) {
      var l = a & t,
          f = n(e),
          h = f.length;
      if (h != n(i).length && !l) return !1;

      for (var m = h; m--;) {
        var _ = f[m];
        if (!(l ? _ in i : o.call(i, _))) return !1;
      }

      var d = g.get(e),
          c = g.get(i);
      if (d && c) return d == i && c == e;
      var F = !0;
      g.set(e, i), g.set(i, e);

      for (var u = l; ++m < h;) {
        var p = e[_ = f[m]],
            b = i[_];
        if (s) var k = l ? s(b, p, _, i, e, g) : s(p, b, _, e, i, g);

        if (!(void 0 === k ? p === b || r(p, b, a, s, g) : k)) {
          F = !1;
          break;
        }

        u || (u = "constructor" == _);
      }

      if (F && !u) {
        var A = e.constructor,
            y = i.constructor;
        A != y && "constructor" in e && "constructor" in i && !("function" == typeof A && A instanceof A && "function" == typeof y && y instanceof y) && (F = !1);
      }

      return g.delete(e), g.delete(i), F;
    };
  }, function (e, i) {
    e.exports = function arrayFilter(e, i) {
      for (var a = -1, n = null == e ? 0 : e.length, t = 0, o = []; ++a < n;) {
        var s = e[a];
        i(s, a, e) && (o[t++] = s);
      }

      return o;
    };
  }, function (e, i) {
    e.exports = function baseTimes(e, i) {
      for (var a = -1, n = Array(e); ++a < e;) {
        n[a] = i(a);
      }

      return n;
    };
  }, function (e, i, a) {
    var n = a(17),
        t = a(12),
        o = "[object Arguments]";

    e.exports = function baseIsArguments(e) {
      return t(e) && n(e) == o;
    };
  }, function (e, i) {
    e.exports = function stubFalse() {
      return !1;
    };
  }, function (e, i) {
    var a = 9007199254740991,
        n = /^(?:0|[1-9]\d*)$/;

    e.exports = function isIndex(e, i) {
      var t = typeof e;
      return !!(i = null == i ? a : i) && ("number" == t || "symbol" != t && n.test(e)) && e > -1 && e % 1 == 0 && e < i;
    };
  }, function (e, i, a) {
    var n = a(17),
        t = a(81),
        o = a(12),
        s = {};
    s["[object Float32Array]"] = s["[object Float64Array]"] = s["[object Int8Array]"] = s["[object Int16Array]"] = s["[object Int32Array]"] = s["[object Uint8Array]"] = s["[object Uint8ClampedArray]"] = s["[object Uint16Array]"] = s["[object Uint32Array]"] = !0, s["[object Arguments]"] = s["[object Array]"] = s["[object ArrayBuffer]"] = s["[object Boolean]"] = s["[object DataView]"] = s["[object Date]"] = s["[object Error]"] = s["[object Function]"] = s["[object Map]"] = s["[object Number]"] = s["[object Object]"] = s["[object RegExp]"] = s["[object Set]"] = s["[object String]"] = s["[object WeakMap]"] = !1, e.exports = function baseIsTypedArray(e) {
      return o(e) && t(e.length) && !!s[n(e)];
    };
  }, function (e, i, a) {
    var n = a(47),
        t = a(171),
        o = Object.prototype.hasOwnProperty;

    e.exports = function baseKeys(e) {
      if (!n(e)) return t(e);
      var i = [];

      for (var a in Object(e)) {
        o.call(e, a) && "constructor" != a && i.push(a);
      }

      return i;
    };
  }, function (e, i, a) {
    var n = a(82)(Object.keys, Object);
    e.exports = n;
  }, function (e, i, a) {
    var n = a(14)(a(6), "DataView");
    e.exports = n;
  }, function (e, i, a) {
    var n = a(14)(a(6), "Promise");
    e.exports = n;
  }, function (e, i, a) {
    var n = a(14)(a(6), "Set");
    e.exports = n;
  }, function (e, i, a) {
    var n = a(14)(a(6), "WeakMap");
    e.exports = n;
  }, function (e, i, a) {
    var n = a(70),
        t = a(177),
        o = a(85),
        s = a(178),
        r = a(179),
        g = a(182),
        l = a(183),
        f = a(184),
        h = a(185),
        m = a(75),
        _ = a(89),
        d = a(32),
        c = a(186),
        F = a(187),
        u = a(192),
        p = a(13),
        b = a(44),
        k = a(194),
        A = a(11),
        y = a(196),
        v = a(43),
        w = a(48),
        E = 1,
        j = 2,
        D = 4,
        x = "[object Arguments]",
        C = "[object Function]",
        B = "[object GeneratorFunction]",
        M = "[object Object]",
        q = {};

    q[x] = q["[object Array]"] = q["[object ArrayBuffer]"] = q["[object DataView]"] = q["[object Boolean]"] = q["[object Date]"] = q["[object Float32Array]"] = q["[object Float64Array]"] = q["[object Int8Array]"] = q["[object Int16Array]"] = q["[object Int32Array]"] = q["[object Map]"] = q["[object Number]"] = q[M] = q["[object RegExp]"] = q["[object Set]"] = q["[object String]"] = q["[object Symbol]"] = q["[object Uint8Array]"] = q["[object Uint8ClampedArray]"] = q["[object Uint16Array]"] = q["[object Uint32Array]"] = !0, q["[object Error]"] = q[C] = q["[object WeakMap]"] = !1, e.exports = function baseClone(e, i, a, P, O, T) {
      var S,
          z = i & E,
          R = i & j,
          H = i & D;
      if (a && (S = O ? a(e, P, O, T) : a(e)), void 0 !== S) return S;
      if (!A(e)) return e;
      var L = p(e);

      if (L) {
        if (S = c(e), !z) return l(e, S);
      } else {
        var X = d(e),
            N = X == C || X == B;
        if (b(e)) return g(e, z);

        if (X == M || X == x || N && !O) {
          if (S = R || N ? {} : u(e), !z) return R ? h(e, r(S, e)) : f(e, s(S, e));
        } else {
          if (!q[X]) return O ? e : {};
          S = F(e, X, z);
        }
      }

      T || (T = new n());
      var Z = T.get(e);
      if (Z) return Z;
      T.set(e, S), y(e) ? e.forEach(function (n) {
        S.add(baseClone(n, i, a, n, e, T));
      }) : k(e) && e.forEach(function (n, t) {
        S.set(t, baseClone(n, i, a, t, e, T));
      });
      var W = L ? void 0 : (H ? R ? _ : m : R ? w : v)(e);
      return t(W || e, function (n, t) {
        W && (n = e[t = n]), o(S, t, baseClone(n, i, a, t, e, T));
      }), S;
    };
  }, function (e, i) {
    e.exports = function arrayEach(e, i) {
      for (var a = -1, n = null == e ? 0 : e.length; ++a < n && !1 !== i(e[a], a, e);) {
        ;
      }

      return e;
    };
  }, function (e, i, a) {
    var n = a(22),
        t = a(43);

    e.exports = function baseAssign(e, i) {
      return e && n(i, t(i), e);
    };
  }, function (e, i, a) {
    var n = a(22),
        t = a(48);

    e.exports = function baseAssignIn(e, i) {
      return e && n(i, t(i), e);
    };
  }, function (e, i, a) {
    var n = a(11),
        t = a(47),
        o = a(181),
        s = Object.prototype.hasOwnProperty;

    e.exports = function baseKeysIn(e) {
      if (!n(e)) return o(e);
      var i = t(e),
          a = [];

      for (var r in e) {
        ("constructor" != r || !i && s.call(e, r)) && a.push(r);
      }

      return a;
    };
  }, function (e, i) {
    e.exports = function nativeKeysIn(e) {
      var i = [];
      if (null != e) for (var a in Object(e)) {
        i.push(a);
      }
      return i;
    };
  }, function (e, i, a) {
    (function (e) {
      var n = a(6),
          t = i && !i.nodeType && i,
          o = t && "object" == typeof e && e && !e.nodeType && e,
          s = o && o.exports === t ? n.Buffer : void 0,
          r = s ? s.allocUnsafe : void 0;

      e.exports = function cloneBuffer(e, i) {
        if (i) return e.slice();
        var a = e.length,
            n = r ? r(a) : new e.constructor(a);
        return e.copy(n), n;
      };
    }).call(this, a(27)(e));
  }, function (e, i) {
    e.exports = function copyArray(e, i) {
      var a = -1,
          n = e.length;

      for (i || (i = Array(n)); ++a < n;) {
        i[a] = e[a];
      }

      return i;
    };
  }, function (e, i, a) {
    var n = a(22),
        t = a(42);

    e.exports = function copySymbols(e, i) {
      return n(e, t(e), i);
    };
  }, function (e, i, a) {
    var n = a(22),
        t = a(88);

    e.exports = function copySymbolsIn(e, i) {
      return n(e, t(e), i);
    };
  }, function (e, i) {
    var a = Object.prototype.hasOwnProperty;

    e.exports = function initCloneArray(e) {
      var i = e.length,
          n = new e.constructor(i);
      return i && "string" == typeof e[0] && a.call(e, "index") && (n.index = e.index, n.input = e.input), n;
    };
  }, function (e, i, a) {
    var n = a(50),
        t = a(188),
        o = a(189),
        s = a(190),
        r = a(191),
        g = "[object Boolean]",
        l = "[object Date]",
        f = "[object Map]",
        h = "[object Number]",
        m = "[object RegExp]",
        _ = "[object Set]",
        d = "[object String]",
        c = "[object Symbol]",
        F = "[object ArrayBuffer]",
        u = "[object DataView]",
        p = "[object Float32Array]",
        b = "[object Float64Array]",
        k = "[object Int8Array]",
        A = "[object Int16Array]",
        y = "[object Int32Array]",
        v = "[object Uint8Array]",
        w = "[object Uint8ClampedArray]",
        E = "[object Uint16Array]",
        j = "[object Uint32Array]";

    e.exports = function initCloneByTag(e, i, a) {
      var D = e.constructor;

      switch (i) {
        case F:
          return n(e);

        case g:
        case l:
          return new D(+e);

        case u:
          return t(e, a);

        case p:
        case b:
        case k:
        case A:
        case y:
        case v:
        case w:
        case E:
        case j:
          return r(e, a);

        case f:
          return new D();

        case h:
        case d:
          return new D(e);

        case m:
          return o(e);

        case _:
          return new D();

        case c:
          return s(e);
      }
    };
  }, function (e, i, a) {
    var n = a(50);

    e.exports = function cloneDataView(e, i) {
      var a = i ? n(e.buffer) : e.buffer;
      return new e.constructor(a, e.byteOffset, e.byteLength);
    };
  }, function (e, i) {
    var a = /\w*$/;

    e.exports = function cloneRegExp(e) {
      var i = new e.constructor(e.source, a.exec(e));
      return i.lastIndex = e.lastIndex, i;
    };
  }, function (e, i, a) {
    var n = a(18),
        t = n ? n.prototype : void 0,
        o = t ? t.valueOf : void 0;

    e.exports = function cloneSymbol(e) {
      return o ? Object(o.call(e)) : {};
    };
  }, function (e, i, a) {
    var n = a(50);

    e.exports = function cloneTypedArray(e, i) {
      var a = i ? n(e.buffer) : e.buffer;
      return new e.constructor(a, e.byteOffset, e.length);
    };
  }, function (e, i, a) {
    var n = a(193),
        t = a(49),
        o = a(47);

    e.exports = function initCloneObject(e) {
      return "function" != typeof e.constructor || o(e) ? {} : n(t(e));
    };
  }, function (e, i, a) {
    var n = a(11),
        t = Object.create,
        o = function () {
      function object() {}

      return function (e) {
        if (!n(e)) return {};
        if (t) return t(e);
        object.prototype = e;
        var i = new object();
        return object.prototype = void 0, i;
      };
    }();

    e.exports = o;
  }, function (e, i, a) {
    var n = a(195),
        t = a(45),
        o = a(46),
        s = o && o.isMap,
        r = s ? t(s) : n;
    e.exports = r;
  }, function (e, i, a) {
    var n = a(32),
        t = a(12),
        o = "[object Map]";

    e.exports = function baseIsMap(e) {
      return t(e) && n(e) == o;
    };
  }, function (e, i, a) {
    var n = a(197),
        t = a(45),
        o = a(46),
        s = o && o.isSet,
        r = s ? t(s) : n;
    e.exports = r;
  }, function (e, i, a) {
    var n = a(32),
        t = a(12),
        o = "[object Set]";

    e.exports = function baseIsSet(e) {
      return t(e) && n(e) == o;
    };
  }, function (e, i, a) {
    var n = a(51),
        t = a(205),
        o = a(206),
        s = a(90);

    e.exports = function baseUnset(e, i) {
      return i = n(i, e), null == (e = o(e, i)) || delete e[s(t(i))];
    };
  }, function (e, i, a) {
    var n = a(13),
        t = a(26),
        o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        s = /^\w*$/;

    e.exports = function isKey(e, i) {
      if (n(e)) return !1;
      var a = typeof e;
      return !("number" != a && "symbol" != a && "boolean" != a && null != e && !t(e)) || s.test(e) || !o.test(e) || null != i && e in Object(i);
    };
  }, function (e, i, a) {
    var n = a(201),
        t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        o = /\\(\\)?/g,
        s = n(function (e) {
      var i = [];
      return 46 === e.charCodeAt(0) && i.push(""), e.replace(t, function (e, a, n, t) {
        i.push(n ? t.replace(o, "$1") : a || e);
      }), i;
    });
    e.exports = s;
  }, function (e, i, a) {
    var n = a(202),
        t = 500;

    e.exports = function memoizeCapped(e) {
      var i = n(e, function (e) {
        return a.size === t && a.clear(), e;
      }),
          a = i.cache;
      return i;
    };
  }, function (e, i, a) {
    var n = a(40),
        t = "Expected a function";

    function memoize(e, i) {
      if ("function" != typeof e || null != i && "function" != typeof i) throw new TypeError(t);

      var a = function memoized() {
        var a = arguments,
            n = i ? i.apply(this, a) : a[0],
            t = memoized.cache;
        if (t.has(n)) return t.get(n);
        var o = e.apply(this, a);
        return memoized.cache = t.set(n, o) || t, o;
      };

      return a.cache = new (memoize.Cache || n)(), a;
    }

    memoize.Cache = n, e.exports = memoize;
  }, function (e, i, a) {
    var n = a(204);

    e.exports = function toString(e) {
      return null == e ? "" : n(e);
    };
  }, function (e, i, a) {
    var n = a(18),
        t = a(84),
        o = a(13),
        s = a(26),
        r = 1 / 0,
        g = n ? n.prototype : void 0,
        l = g ? g.toString : void 0;

    e.exports = function baseToString(e) {
      if ("string" == typeof e) return e;
      if (o(e)) return t(e, baseToString) + "";
      if (s(e)) return l ? l.call(e) : "";
      var i = e + "";
      return "0" == i && 1 / e == -r ? "-0" : i;
    };
  }, function (e, i) {
    e.exports = function last(e) {
      var i = null == e ? 0 : e.length;
      return i ? e[i - 1] : void 0;
    };
  }, function (e, i, a) {
    var n = a(207),
        t = a(208);

    e.exports = function parent(e, i) {
      return i.length < 2 ? e : n(e, t(i, 0, -1));
    };
  }, function (e, i, a) {
    var n = a(51),
        t = a(90);

    e.exports = function baseGet(e, i) {
      for (var a = 0, o = (i = n(i, e)).length; null != e && a < o;) {
        e = e[t(i[a++])];
      }

      return a && a == o ? e : void 0;
    };
  }, function (e, i) {
    e.exports = function baseSlice(e, i, a) {
      var n = -1,
          t = e.length;
      i < 0 && (i = -i > t ? 0 : t + i), (a = a > t ? t : a) < 0 && (a += t), t = i > a ? 0 : a - i >>> 0, i >>>= 0;

      for (var o = Array(t); ++n < t;) {
        o[n] = e[n + i];
      }

      return o;
    };
  }, function (e, i, a) {
    var n = a(210);

    e.exports = function customOmitClone(e) {
      return n(e) ? void 0 : e;
    };
  }, function (e, i, a) {
    var n = a(17),
        t = a(49),
        o = a(12),
        s = "[object Object]",
        r = Function.prototype,
        g = Object.prototype,
        l = r.toString,
        f = g.hasOwnProperty,
        h = l.call(Object);

    e.exports = function isPlainObject(e) {
      if (!o(e) || n(e) != s) return !1;
      var i = t(e);
      if (null === i) return !0;
      var a = f.call(i, "constructor") && i.constructor;
      return "function" == typeof a && a instanceof a && l.call(a) == h;
    };
  }, function (e, i, a) {
    var n = a(212),
        t = a(215),
        o = a(217);

    e.exports = function flatRest(e) {
      return o(t(e, void 0, n), e + "");
    };
  }, function (e, i, a) {
    var n = a(213);

    e.exports = function flatten(e) {
      return null != e && e.length ? n(e, 1) : [];
    };
  }, function (e, i, a) {
    var n = a(41),
        t = a(214);

    e.exports = function baseFlatten(e, i, a, o, s) {
      var r = -1,
          g = e.length;

      for (a || (a = t), s || (s = []); ++r < g;) {
        var l = e[r];
        i > 0 && a(l) ? i > 1 ? baseFlatten(l, i - 1, a, o, s) : n(s, l) : o || (s[s.length] = l);
      }

      return s;
    };
  }, function (e, i, a) {
    var n = a(18),
        t = a(79),
        o = a(13),
        s = n ? n.isConcatSpreadable : void 0;

    e.exports = function isFlattenable(e) {
      return o(e) || t(e) || !!(s && e && e[s]);
    };
  }, function (e, i, a) {
    var n = a(216),
        t = Math.max;

    e.exports = function overRest(e, i, a) {
      return i = t(void 0 === i ? e.length - 1 : i, 0), function () {
        for (var o = arguments, s = -1, r = t(o.length - i, 0), g = Array(r); ++s < r;) {
          g[s] = o[i + s];
        }

        s = -1;

        for (var l = Array(i + 1); ++s < i;) {
          l[s] = o[s];
        }

        return l[i] = a(g), n(e, this, l);
      };
    };
  }, function (e, i) {
    e.exports = function apply(e, i, a) {
      switch (a.length) {
        case 0:
          return e.call(i);

        case 1:
          return e.call(i, a[0]);

        case 2:
          return e.call(i, a[0], a[1]);

        case 3:
          return e.call(i, a[0], a[1], a[2]);
      }

      return e.apply(i, a);
    };
  }, function (e, i, a) {
    var n = a(218),
        t = a(221)(n);
    e.exports = t;
  }, function (e, i, a) {
    var n = a(219),
        t = a(87),
        o = a(220),
        s = t ? function (e, i) {
      return t(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: n(i),
        writable: !0
      });
    } : o;
    e.exports = s;
  }, function (e, i) {
    e.exports = function constant(e) {
      return function () {
        return e;
      };
    };
  }, function (e, i) {
    e.exports = function identity(e) {
      return e;
    };
  }, function (e, i) {
    var a = 800,
        n = 16,
        t = Date.now;

    e.exports = function shortOut(e) {
      var i = 0,
          o = 0;
      return function () {
        var s = t(),
            r = n - (s - o);

        if (o = s, r > 0) {
          if (++i >= a) return arguments[0];
        } else i = 0;

        return e.apply(void 0, arguments);
      };
    };
  }, function (e, i, a) {
    (e.exports = a(9)(!0)).push([e.i, ".wysiwyg-toolbar--default-value-creator {\n  padding: 16px;\n}\n\n.wysiwyg-toolbar--default-value-subheader {\n  margin-bottom: 16px;\n}\n\n.wysiwyg-toolbar--default-value-body {\n  height: 100%;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n}\n\n.wysiwyg-toolbar--default-value-body input {\n  width: 100%;\n}\n\n.wysiwyg-toolbar--default-value-buttons {\n  margin-top: 16px;\n}\n\n.wysiwyg-toolbar--insert-button {\n  margin-right: 8px;\n}\n\n.wysiwyg-toolbar--default-value-no-fallback-text {\n  color: var(--color-p1-6);\n  margin-bottom: 13px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAa;EAAb,aAAa;EACb,8BAAsB;UAAtB,sBAAsB;EACtB,sCAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB",
      file: "style.css",
      sourcesContent: [".wysiwyg-toolbar--default-value-creator {\n  padding: 16px;\n}\n\n.wysiwyg-toolbar--default-value-subheader {\n  margin-bottom: 16px;\n}\n\n.wysiwyg-toolbar--default-value-body {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.wysiwyg-toolbar--default-value-body input {\n  width: 100%;\n}\n\n.wysiwyg-toolbar--default-value-buttons {\n  margin-top: 16px;\n}\n\n.wysiwyg-toolbar--insert-button {\n  margin-right: 8px;\n}\n\n.wysiwyg-toolbar--default-value-no-fallback-text {\n  color: var(--color-p1-6);\n  margin-bottom: 13px;\n}\n"]
    }]);
  }, function (e, i, a) {
    var n = a(19),
        t = n.JSON || (n.JSON = {
      stringify: JSON.stringify
    });

    e.exports = function stringify(e) {
      return t.stringify.apply(t, arguments);
    };
  }, function (e, i, a) {
    a(225), e.exports = a(19).Object.values;
  }, function (e, i, a) {
    var n = a(53),
        t = a(229)(!1);
    n(n.S, "Object", {
      values: function values(e) {
        return t(e);
      }
    });
  }, function (e, i) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    };
  }, function (e, i, a) {
    e.exports = !a(24) && !a(92)(function () {
      return 7 != Object.defineProperty(a(93)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, i, a) {
    var n = a(54);

    e.exports = function (e, i) {
      if (!n(e)) return e;
      var a, t;
      if (i && "function" == typeof (a = e.toString) && !n(t = a.call(e))) return t;
      if ("function" == typeof (a = e.valueOf) && !n(t = a.call(e))) return t;
      if (!i && "function" == typeof (a = e.toString) && !n(t = a.call(e))) return t;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, i, a) {
    var n = a(24),
        t = a(94),
        o = a(56),
        s = a(234).f;

    e.exports = function (e) {
      return function (i) {
        for (var a, r = o(i), g = t(r), l = g.length, f = 0, h = []; l > f;) {
          a = g[f++], n && !s.call(r, a) || h.push(e ? [a, r[a]] : r[a]);
        }

        return h;
      };
    };
  }, function (e, i, a) {
    var n = a(36),
        t = a(56),
        o = a(232)(!1),
        s = a(59)("IE_PROTO");

    e.exports = function (e, i) {
      var a,
          r = t(e),
          g = 0,
          l = [];

      for (a in r) {
        a != s && n(r, a) && l.push(a);
      }

      for (; i.length > g;) {
        n(r, a = i[g++]) && (~o(l, a) || l.push(a));
      }

      return l;
    };
  }, function (e, i, a) {
    var n = a(95);
    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == n(e) ? e.split("") : Object(e);
    };
  }, function (e, i, a) {
    var n = a(56),
        t = a(96),
        o = a(233);

    e.exports = function (e) {
      return function (i, a, s) {
        var r,
            g = n(i),
            l = t(g.length),
            f = o(s, l);

        if (e && a != a) {
          for (; l > f;) {
            if ((r = g[f++]) != r) return !0;
          }
        } else for (; l > f; f++) {
          if ((e || f in g) && g[f] === a) return e || f || 0;
        }

        return !e && -1;
      };
    };
  }, function (e, i, a) {
    var n = a(58),
        t = Math.max,
        o = Math.min;

    e.exports = function (e, i) {
      return (e = n(e)) < 0 ? t(e + i, 0) : o(e, i);
    };
  }, function (e, i) {
    i.f = {}.propertyIsEnumerable;
  }, function (e, i, a) {
    e.exports = {
      default: a(236),
      __esModule: !0
    };
  }, function (e, i, a) {
    a(237), a(246), e.exports = a(19).Array.from;
  }, function (e, i, a) {
    "use strict";

    var n = a(238)(!0);
    a(239)(String, "String", function (e) {
      this._t = String(e), this._i = 0;
    }, function () {
      var e,
          i = this._t,
          a = this._i;
      return a >= i.length ? {
        value: void 0,
        done: !0
      } : (e = n(i, a), this._i += e.length, {
        value: e,
        done: !1
      });
    });
  }, function (e, i, a) {
    var n = a(58),
        t = a(57);

    e.exports = function (e) {
      return function (i, a) {
        var o,
            s,
            r = String(t(i)),
            g = n(a),
            l = r.length;
        return g < 0 || g >= l ? e ? "" : void 0 : (o = r.charCodeAt(g)) < 55296 || o > 56319 || g + 1 === l || (s = r.charCodeAt(g + 1)) < 56320 || s > 57343 ? e ? r.charAt(g) : o : e ? r.slice(g, g + 2) : s - 56320 + (o - 55296 << 10) + 65536;
      };
    };
  }, function (e, i, a) {
    "use strict";

    var n = a(98),
        t = a(53),
        o = a(240),
        s = a(33),
        r = a(60),
        g = a(241),
        l = a(101),
        f = a(245),
        h = a(15)("iterator"),
        m = !([].keys && "next" in [].keys()),
        _ = function returnThis() {
      return this;
    };

    e.exports = function (e, i, a, d, c, F, u) {
      g(a, i, d);

      var p,
          b,
          k,
          A = function getMethod(e) {
        if (!m && e in E) return E[e];

        switch (e) {
          case "keys":
            return function keys() {
              return new a(this, e);
            };

          case "values":
            return function values() {
              return new a(this, e);
            };
        }

        return function entries() {
          return new a(this, e);
        };
      },
          y = i + " Iterator",
          v = "values" == c,
          w = !1,
          E = e.prototype,
          j = E[h] || E["@@iterator"] || c && E[c],
          D = j || A(c),
          x = c ? v ? A("entries") : D : void 0,
          C = "Array" == i && E.entries || j;

      if (C && (k = f(C.call(new e()))) !== Object.prototype && k.next && (l(k, y, !0), n || "function" == typeof k[h] || s(k, h, _)), v && j && "values" !== j.name && (w = !0, D = function values() {
        return j.call(this);
      }), n && !u || !m && !w && E[h] || s(E, h, D), r[i] = D, r[y] = _, c) if (p = {
        values: v ? D : A("values"),
        keys: F ? D : A("keys"),
        entries: x
      }, u) for (b in p) {
        b in E || o(E, b, p[b]);
      } else t(t.P + t.F * (m || w), i, p);
      return p;
    };
  }, function (e, i, a) {
    e.exports = a(33);
  }, function (e, i, a) {
    "use strict";

    var n = a(242),
        t = a(55),
        o = a(101),
        s = {};
    a(33)(s, a(15)("iterator"), function () {
      return this;
    }), e.exports = function (e, i, a) {
      e.prototype = n(s, {
        next: t(1, a)
      }), o(e, i + " Iterator");
    };
  }, function (e, i, a) {
    var n = a(35),
        t = a(243),
        o = a(100),
        s = a(59)("IE_PROTO"),
        r = function Empty() {},
        g = function createDict() {
      var e,
          i = a(93)("iframe"),
          n = o.length;

      for (i.style.display = "none", a(244).appendChild(i), i.src = "javascript:", (e = i.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), g = e.F; n--;) {
        delete g.prototype[o[n]];
      }

      return g();
    };

    e.exports = Object.create || function create(e, i) {
      var a;
      return null !== e ? (r.prototype = n(e), a = new r(), r.prototype = null, a[s] = e) : a = g(), void 0 === i ? a : t(a, i);
    };
  }, function (e, i, a) {
    var n = a(34),
        t = a(35),
        o = a(94);
    e.exports = a(24) ? Object.defineProperties : function defineProperties(e, i) {
      t(e);

      for (var a, s = o(i), r = s.length, g = 0; r > g;) {
        n.f(e, a = s[g++], i[a]);
      }

      return e;
    };
  }, function (e, i, a) {
    var n = a(23).document;
    e.exports = n && n.documentElement;
  }, function (e, i, a) {
    var n = a(36),
        t = a(102),
        o = a(59)("IE_PROTO"),
        s = Object.prototype;

    e.exports = Object.getPrototypeOf || function (e) {
      return e = t(e), n(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? s : null;
    };
  }, function (e, i, a) {
    "use strict";

    var n = a(91),
        t = a(53),
        o = a(102),
        s = a(247),
        r = a(248),
        g = a(96),
        l = a(249),
        f = a(250);
    t(t.S + t.F * !a(252)(function (e) {
      Array.from(e);
    }), "Array", {
      from: function from(e) {
        var i,
            a,
            t,
            h,
            m = o(e),
            _ = "function" == typeof this ? this : Array,
            d = arguments.length,
            c = d > 1 ? arguments[1] : void 0,
            F = void 0 !== c,
            u = 0,
            p = f(m);

        if (F && (c = n(c, d > 2 ? arguments[2] : void 0, 2)), void 0 == p || _ == Array && r(p)) for (a = new _(i = g(m.length)); i > u; u++) {
          l(a, u, F ? c(m[u], u) : m[u]);
        } else for (h = p.call(m), a = new _(); !(t = h.next()).done; u++) {
          l(a, u, F ? s(h, c, [t.value, u], !0) : t.value);
        }
        return a.length = u, a;
      }
    });
  }, function (e, i, a) {
    var n = a(35);

    e.exports = function (e, i, a, t) {
      try {
        return t ? i(n(a)[0], a[1]) : i(a);
      } catch (s) {
        var o = e.return;
        throw void 0 !== o && n(o.call(e)), s;
      }
    };
  }, function (e, i, a) {
    var n = a(60),
        t = a(15)("iterator"),
        o = Array.prototype;

    e.exports = function (e) {
      return void 0 !== e && (n.Array === e || o[t] === e);
    };
  }, function (e, i, a) {
    "use strict";

    var n = a(34),
        t = a(55);

    e.exports = function (e, i, a) {
      i in e ? n.f(e, i, t(0, a)) : e[i] = a;
    };
  }, function (e, i, a) {
    var n = a(251),
        t = a(15)("iterator"),
        o = a(60);

    e.exports = a(19).getIteratorMethod = function (e) {
      if (void 0 != e) return e[t] || e["@@iterator"] || o[n(e)];
    };
  }, function (e, i, a) {
    var n = a(95),
        t = a(15)("toStringTag"),
        o = "Arguments" == n(function () {
      return arguments;
    }());

    e.exports = function (e) {
      var i, a, s;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (a = function tryGet(e, i) {
        try {
          return e[i];
        } catch (a) {}
      }(i = Object(e), t)) ? a : o ? n(i) : "Object" == (s = n(i)) && "function" == typeof i.callee ? "Arguments" : s;
    };
  }, function (e, i, a) {
    var n = a(15)("iterator"),
        t = !1;

    try {
      var o = [7][n]();
      o.return = function () {
        t = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (s) {}

    e.exports = function (e, i) {
      if (!i && !t) return !1;
      var a = !1;

      try {
        var o = [7],
            r = o[n]();
        r.next = function () {
          return {
            done: a = !0
          };
        }, o[n] = function () {
          return r;
        }, e(o);
      } catch (s) {}

      return a;
    };
  }, function (e, i) {
    "undefined" !== typeof window && function () {
      for (var e = 0, i = ["ms", "moz", "webkit", "o"], a = 0; a < i.length && !window.requestAnimationFrame; ++a) {
        window.requestAnimationFrame = window[i[a] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[i[a] + "CancelAnimationFrame"] || window[i[a] + "CancelRequestAnimationFrame"];
      }

      window.requestAnimationFrame || (window.requestAnimationFrame = function (i, a) {
        var n = new Date().getTime(),
            t = Math.max(0, 16 - (n - e)),
            o = window.setTimeout(function () {
          i(n + t);
        }, t);
        return e = n + t, o;
      }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (e) {
        clearTimeout(e);
      });
    }();
  }, function (e, i, a) {
    "use strict";

    var n = a(255);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, e.exports = function () {
      function shim(e, i, a, t, o, s) {
        if (s !== n) {
          var r = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw r.name = "Invariant Violation", r;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return e.PropTypes = e, e;
    };
  }, function (e, i, a) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, i, a) {
    var n = a(257);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var t = {
      insert: "head",
      singleton: !1
    };
    a(10)(n, t);
    n.locals && (e.exports = n.locals);
  }, function (e, i, a) {
    (e.exports = a(9)(!0)).push([e.i, '.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n\n.emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9;\n}\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.emoji-mart-anchors {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  padding: 0 6px;\n  line-height: 0;\n}\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  -webkit-flex: 1 1 auto;\n          flex: 1 1 auto;\n  color: #858585;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color .1s ease-out;\n  margin: 0;\n  box-shadow: none;\n  background: none;\n  border: none;\n}\n.emoji-mart-anchor:focus { outline: 0 }\n.emoji-mart-anchor:hover,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor-selected {\n  color: #464646;\n}\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0;\n}\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px; left: 0;\n  width: 100%; height: 3px;\n  background-color: #464646;\n}\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n.emoji-mart-anchors svg,\n.emoji-mart-anchors img {\n  fill: currentColor;\n  height: 18px;\n  width: 18px;\n}\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  height: 270px;\n  padding: 0 6px 6px 6px;\n  will-change: transform; /* avoids "repaints on scroll" in mobile Chrome */\n}\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative;\n}\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 5px 25px 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration {\n  /* remove webkit/blink styles for <input type="search">\n   * via https://stackoverflow.com/a/9422689 */\n  -webkit-appearance: none;\n}\n\n.emoji-mart-search-icon {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  z-index: 2;\n  padding: 2px 5px 1px;\n  border: none;\n  background: none;\n}\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: "";\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n}\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, .95);\n}\n\n.emoji-mart-category-list {\n  margin: 0;\n  padding: 0;\n}\n\n.emoji-mart-category-list li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n}\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n\n.emoji-mart-emoji-native {\n  font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji";\n}\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n.emoji-mart-no-results-img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none;\n}\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: .2em;\n}\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none;\n}\n\n.emoji-mart-preview {\n  position: relative;\n  height: 70px;\n}\n\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-data,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n\n.emoji-mart-preview-emoji {\n  left: 12px;\n}\n\n.emoji-mart-preview-data {\n  left: 68px; right: 12px;\n  word-break: break-all;\n}\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right;\n}\n\n.emoji-mart-preview-skins.custom {\n  right: 10px;\n  text-align: right;\n}\n\n.emoji-mart-preview-name {\n  font-size: 14px;\n}\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888;\n}\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {\n  margin-left: .5em;\n}\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb;\n}\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0;\n}\n\n.emoji-mart-title-label {\n  color: #999A9C;\n  font-size: 26px;\n  font-weight: 300;\n}\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.custom {\n  font-size: 0;\n  border: none;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n}\n\n.emoji-mart-skin-swatch:nth-child(1) { transition-delay: 0s }\n.emoji-mart-skin-swatch:nth-child(2) { transition-delay: .03s }\n.emoji-mart-skin-swatch:nth-child(3) { transition-delay: .06s }\n.emoji-mart-skin-swatch:nth-child(4) { transition-delay: .09s }\n.emoji-mart-skin-swatch:nth-child(5) { transition-delay: .12s }\n.emoji-mart-skin-swatch:nth-child(6) { transition-delay: .15s }\n\n.emoji-mart-skin-swatch.selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatch.selected:after {\n  content: "";\n  position: absolute;\n  top: 50%; left: 50%;\n  width: 4px; height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s ease-out;\n}\n\n.emoji-mart-skin-swatch.custom {\n  display: inline-block;\n  width: 0;\n  height: 38px;\n  overflow: hidden;\n  vertical-align: middle;\n  transition-property: width, height;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n  cursor: default;\n}\n\n.emoji-mart-skin-swatch.custom.selected {\n  position: relative;\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatch.custom.selected:after {\n  content: "";\n  width: 0;\n  height: 0;\n}\n\n.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {\n  background-color: #f4f4f4;\n  border-radius: 10%;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-text.opened {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  color: #888;\n  font-size: 11px;\n  padding: 5px 2px;\n  width: 95px;\n  height: 40px;\n  border-radius: 10%;\n  background-color: #fff;\n}\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n\n.emoji-mart-skin-tone-1 { background-color: #ffc93a }\n.emoji-mart-skin-tone-2 { background-color: #fadcbc }\n.emoji-mart-skin-tone-3 { background-color: #e0bb95 }\n.emoji-mart-skin-tone-4 { background-color: #bf8f68 }\n.emoji-mart-skin-tone-5 { background-color: #9b643d }\n.emoji-mart-skin-tone-6 { background-color: #594539 }\n\n/* For screenreaders only, via https://stackoverflow.com/a/19758620 */\n.emoji-mart-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n/*\n * Dark mode styles\n */\n\n.emoji-mart-dark {\n  color: #fff;\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-bar {\n  border-color: #555453;\n}\n\n.emoji-mart-dark .emoji-mart-search input {\n  color: #fff;\n  border-color: #555453;\n  background-color: #2f2f2f;\n}\n\n.emoji-mart-dark .emoji-mart-search-icon svg {\n  fill: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {\n  background-color: #444;\n}\n\n.emoji-mart-dark .emoji-mart-category-label span {\n  background-color: #222;\n  color: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-skin-swatches {\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-anchor:hover,\n.emoji-mart-dark .emoji-mart-anchor:focus,\n.emoji-mart-dark .emoji-mart-anchor-selected {\n  color: #bfbfbf;\n}\n', "", {
      version: 3,
      sources: ["emoji-mart.css"],
      names: [],
      mappings: "AAAA;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,4EAA4E;EAC5E,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,qBAAa;EAAb,aAAa;EACb,2BAAmB;UAAnB,mBAAmB;EACnB,sCAA8B;UAA9B,8BAA8B;EAC9B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAc;UAAd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA,2BAA2B,WAAW;AACtC;;;EAGE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,OAAO;EACrB,WAAW,EAAE,WAAW;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB,EAAE,iDAAiD;AAC3E;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;;;EAKE;8CAC4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2JAA2J;AAC7J;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU,EAAE,WAAW;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,mCAAmC;EACnC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,uCAAuC,qBAAqB;AAC5D,uCAAuC,uBAAuB;AAC9D,uCAAuC,uBAAuB;AAC9D,uCAAuC,uBAAuB;AAC9D,uCAAuC,uBAAuB;AAC9D,uCAAuC,uBAAuB;;AAE9D;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,UAAU,EAAE,WAAW;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;EAC1B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;AACpD,0BAA0B,0BAA0B;;AAEpD,qEAAqE;AACrE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE;;AAEF;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;AAChB",
      file: "emoji-mart.css",
      sourcesContent: ['.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n\n.emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9;\n}\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  line-height: 0;\n}\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  color: #858585;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color .1s ease-out;\n  margin: 0;\n  box-shadow: none;\n  background: none;\n  border: none;\n}\n.emoji-mart-anchor:focus { outline: 0 }\n.emoji-mart-anchor:hover,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor-selected {\n  color: #464646;\n}\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0;\n}\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px; left: 0;\n  width: 100%; height: 3px;\n  background-color: #464646;\n}\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n.emoji-mart-anchors svg,\n.emoji-mart-anchors img {\n  fill: currentColor;\n  height: 18px;\n  width: 18px;\n}\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  height: 270px;\n  padding: 0 6px 6px 6px;\n  will-change: transform; /* avoids "repaints on scroll" in mobile Chrome */\n}\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative;\n}\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 5px 25px 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration {\n  /* remove webkit/blink styles for <input type="search">\n   * via https://stackoverflow.com/a/9422689 */\n  -webkit-appearance: none;\n}\n\n.emoji-mart-search-icon {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  z-index: 2;\n  padding: 2px 5px 1px;\n  border: none;\n  background: none;\n}\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: "";\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n}\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, .95);\n}\n\n.emoji-mart-category-list {\n  margin: 0;\n  padding: 0;\n}\n\n.emoji-mart-category-list li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n}\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n\n.emoji-mart-emoji-native {\n  font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji";\n}\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n.emoji-mart-no-results-img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none;\n}\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: .2em;\n}\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none;\n}\n\n.emoji-mart-preview {\n  position: relative;\n  height: 70px;\n}\n\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-data,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.emoji-mart-preview-emoji {\n  left: 12px;\n}\n\n.emoji-mart-preview-data {\n  left: 68px; right: 12px;\n  word-break: break-all;\n}\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right;\n}\n\n.emoji-mart-preview-skins.custom {\n  right: 10px;\n  text-align: right;\n}\n\n.emoji-mart-preview-name {\n  font-size: 14px;\n}\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888;\n}\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {\n  margin-left: .5em;\n}\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb;\n}\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0;\n}\n\n.emoji-mart-title-label {\n  color: #999A9C;\n  font-size: 26px;\n  font-weight: 300;\n}\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.custom {\n  font-size: 0;\n  border: none;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n}\n\n.emoji-mart-skin-swatch:nth-child(1) { transition-delay: 0s }\n.emoji-mart-skin-swatch:nth-child(2) { transition-delay: .03s }\n.emoji-mart-skin-swatch:nth-child(3) { transition-delay: .06s }\n.emoji-mart-skin-swatch:nth-child(4) { transition-delay: .09s }\n.emoji-mart-skin-swatch:nth-child(5) { transition-delay: .12s }\n.emoji-mart-skin-swatch:nth-child(6) { transition-delay: .15s }\n\n.emoji-mart-skin-swatch.selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatch.selected:after {\n  content: "";\n  position: absolute;\n  top: 50%; left: 50%;\n  width: 4px; height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s ease-out;\n}\n\n.emoji-mart-skin-swatch.custom {\n  display: inline-block;\n  width: 0;\n  height: 38px;\n  overflow: hidden;\n  vertical-align: middle;\n  transition-property: width, height;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n  cursor: default;\n}\n\n.emoji-mart-skin-swatch.custom.selected {\n  position: relative;\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatch.custom.selected:after {\n  content: "";\n  width: 0;\n  height: 0;\n}\n\n.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {\n  background-color: #f4f4f4;\n  border-radius: 10%;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after {\n  opacity: .75;\n}\n\n.emoji-mart-skin-text.opened {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  color: #888;\n  font-size: 11px;\n  padding: 5px 2px;\n  width: 95px;\n  height: 40px;\n  border-radius: 10%;\n  background-color: #fff;\n}\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n\n.emoji-mart-skin-tone-1 { background-color: #ffc93a }\n.emoji-mart-skin-tone-2 { background-color: #fadcbc }\n.emoji-mart-skin-tone-3 { background-color: #e0bb95 }\n.emoji-mart-skin-tone-4 { background-color: #bf8f68 }\n.emoji-mart-skin-tone-5 { background-color: #9b643d }\n.emoji-mart-skin-tone-6 { background-color: #594539 }\n\n/* For screenreaders only, via https://stackoverflow.com/a/19758620 */\n.emoji-mart-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n/*\n * Dark mode styles\n */\n\n.emoji-mart-dark {\n  color: #fff;\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-bar {\n  border-color: #555453;\n}\n\n.emoji-mart-dark .emoji-mart-search input {\n  color: #fff;\n  border-color: #555453;\n  background-color: #2f2f2f;\n}\n\n.emoji-mart-dark .emoji-mart-search-icon svg {\n  fill: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {\n  background-color: #444;\n}\n\n.emoji-mart-dark .emoji-mart-category-label span {\n  background-color: #222;\n  color: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-skin-swatches {\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-anchor:hover,\n.emoji-mart-dark .emoji-mart-anchor:focus,\n.emoji-mart-dark .emoji-mart-anchor-selected {\n  color: #bfbfbf;\n}\n']
    }]);
  }, function (e, i, a) {
    var n = a(259);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var t = {
      insert: "head",
      singleton: !1
    };
    a(10)(n, t);
    n.locals && (e.exports = n.locals);
  }, function (e, i, a) {
    (e.exports = a(9)(!0)).push([e.i, ".toolbar-menu-popover--container .property-list-container {\n  max-height: 242px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.toolbar-menu-popover--container .property-list-section-header {\n  font-size: var(--font-size-subtle);\n  font-family: var(--main-font-family--semibold);\n  margin: 0;\n  padding: 6px 15px;\n  background-color: var(--color-p3-2);\n  color: var(--color-p1-10);\n  text-transform: capitalize;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.toolbar-menu-popover--container .property-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.toolbar-menu-popover--container .property-list li {\n  padding: 5px 15px;\n  margin: 13px 0;\n  font-size: var(--font-size-copy);\n  color: var(--color-p1-10);\n  cursor: pointer;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n}\n\n.toolbar-menu-popover--container .property-list li:hover {\n  background: var(--color-p3-2);\n}\n\n.toolbar-menu-popover--container .property-list-filter input {\n  width: 100%;\n  cursor: text;\n  padding-left: 12px;\n  border-radius: 0px !important; /* overriding tide */\n  border: 1px solid var(--main-white) !important; /* overriding tide */\n  transition: all 0.2s ease;\n}\n\n.toolbar-menu-popover--container .property-list-filter input:focus {\n  border-color: var(--color-p3-6) !important; /* overriding tide */\n}\n\n.toolbar-menu-popover--container .empty-state-container {\n  padding: 32px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-justify-content: space-evenly;\n          justify-content: space-evenly;\n  -webkit-align-items: center;\n          align-items: center;\n  border-top: 1px solid var(--color-p1-4);\n}\n\n.toolbar-menu-popover--container .empty-state-container p {\n  text-align: center;\n}\n\n.toolbar-menu-popover--container .tide-text-loader {\n  margin-top: 87px;\n  margin-left: -10px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;EAC9C,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,qBAAa;EAAb,aAAa;EACb,2BAAmB;UAAnB,mBAAmB;EACnB,sCAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B,EAAE,oBAAoB;EACnD,8CAA8C,EAAE,oBAAoB;EACpE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C,EAAE,oBAAoB;AAClE;;AAEA;EACE,aAAa;EACb,qBAAa;EAAb,aAAa;EACb,8BAAsB;UAAtB,sBAAsB;EACtB,qCAA6B;UAA7B,6BAA6B;EAC7B,2BAAmB;UAAnB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB",
      file: "style.css",
      sourcesContent: [".toolbar-menu-popover--container .property-list-container {\n  max-height: 242px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.toolbar-menu-popover--container .property-list-section-header {\n  font-size: var(--font-size-subtle);\n  font-family: var(--main-font-family--semibold);\n  margin: 0;\n  padding: 6px 15px;\n  background-color: var(--color-p3-2);\n  color: var(--color-p1-10);\n  text-transform: capitalize;\n  position: sticky;\n  top: 0;\n}\n\n.toolbar-menu-popover--container .property-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.toolbar-menu-popover--container .property-list li {\n  padding: 5px 15px;\n  margin: 13px 0;\n  font-size: var(--font-size-copy);\n  color: var(--color-p1-10);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.toolbar-menu-popover--container .property-list li:hover {\n  background: var(--color-p3-2);\n}\n\n.toolbar-menu-popover--container .property-list-filter input {\n  width: 100%;\n  cursor: text;\n  padding-left: 12px;\n  border-radius: 0px !important; /* overriding tide */\n  border: 1px solid var(--main-white) !important; /* overriding tide */\n  transition: all 0.2s ease;\n}\n\n.toolbar-menu-popover--container .property-list-filter input:focus {\n  border-color: var(--color-p3-6) !important; /* overriding tide */\n}\n\n.toolbar-menu-popover--container .empty-state-container {\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  border-top: 1px solid var(--color-p1-4);\n}\n\n.toolbar-menu-popover--container .empty-state-container p {\n  text-align: center;\n}\n\n.toolbar-menu-popover--container .tide-text-loader {\n  margin-top: 87px;\n  margin-left: -10px;\n}\n"]
    }]);
  }, function (e, i, a) {
    var n = a(261);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var t = {
      insert: "head",
      singleton: !1
    };
    a(10)(n, t);
    n.locals && (e.exports = n.locals);
  }, function (e, i, a) {
    (e.exports = a(9)(!0)).push([e.i, ".dynamic-content-toolbar-menu-popover--container {\n  max-height: 248px;\n  overflow-y: scroll;\n}\n\n.dynamic-content-toolbar-menu-popover--attribute-picker, .book-a-meeting-popup-container {\n  padding: 16px;\n}\n\n.dynamic-content-toolbar-menu-popover--subtext {\n  margin-bottom: 16px;\n}\n\n.dynamic-content-attribute-select {\n  margin: 16px 0;\n}\n\n.dynamic-content-toolbar-menu-popover--back-button path {\n  fill: var(--color-p1-10);\n}\n\nh4.dynamic-content-toolbar-menu-popover--header--offset {\n  margin-left: 25px;\n  transition: var(--transition-catchall-simple);\n}\n\n.dynamic-content-toolbar-menu-popover--back-button-container {\n  cursor: pointer;\n  position: absolute;\n  left: 16px;\n}\n\n.attribute-search-input .tide-input {\n  width: 272px;\n}\n\n.attribute-search-input {\n  margin-top: 16px;\n}\n\n.attribute-list-section-header-wrapper {\n  background-color: var(--color-p1-2);\n  font-size: var(--font-size-subtle);\n  font-family: var(--main-font-family--semibold);\n  padding: 6px 0px;\n  text-transform: uppercase;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.attribute-list-section-header {\n  margin: 0 16px;\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.attribute-list-option {\n  padding: 5px 15px;\n  cursor: pointer;\n  max-width: 274px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.attribute-list-option:hover {\n  background-color: var(--color-p3-3);\n  transition: var(--transition-catchall-simple);\n}\n.dynamic-content-toolbar-menu-popover--header,\n.book-meeting-toolbar-menu-popover--header {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n\n}\n\n.dynamic-content-toolbar-menu-popover--header {\n  padding: 16px;\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.dynamic-content-toolbar-menu-popover--header h4,\n.book-meeting-toolbar-menu-popover--header h4 {\n  margin-top: 0px;\n  transition: all 0.3s ease;\n  max-width: 175px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.dynamic-content-jinja-code--editor {\n  color: var(--color-s4-10);\n  background-color: var(--color-s1-3);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n  padding: 3px 7px;\n}\n\n.dynamic-content-placeholder-text--editor {\n  color: var(--color-p1-5-5);\n}\n\n.book-a-meeting-popup-container .driftiwyg-tag-property--editor {\n  width: -webkit-min-content;\n  width: min-content;\n  background: var(--color-s4-3);\n  color: var(--color-s4-10);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n  padding: 3px 7px;\n  margin: 16px 0 0;\n}\n\n.book-a-meeting-popup-container .book-a-meeting-fallback-input {\n  padding-bottom: 16px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,8CAA8C;EAC9C,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;;EAEE,qBAAa;EAAb,aAAa;EACb,2BAAmB;UAAnB,mBAAmB;EACnB,sCAA8B;UAA9B,8BAA8B;;AAEhC;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAAkB;EAAlB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB",
      file: "style.css",
      sourcesContent: [".dynamic-content-toolbar-menu-popover--container {\n  max-height: 248px;\n  overflow-y: scroll;\n}\n\n.dynamic-content-toolbar-menu-popover--attribute-picker, .book-a-meeting-popup-container {\n  padding: 16px;\n}\n\n.dynamic-content-toolbar-menu-popover--subtext {\n  margin-bottom: 16px;\n}\n\n.dynamic-content-attribute-select {\n  margin: 16px 0;\n}\n\n.dynamic-content-toolbar-menu-popover--back-button path {\n  fill: var(--color-p1-10);\n}\n\nh4.dynamic-content-toolbar-menu-popover--header--offset {\n  margin-left: 25px;\n  transition: var(--transition-catchall-simple);\n}\n\n.dynamic-content-toolbar-menu-popover--back-button-container {\n  cursor: pointer;\n  position: absolute;\n  left: 16px;\n}\n\n.attribute-search-input .tide-input {\n  width: 272px;\n}\n\n.attribute-search-input {\n  margin-top: 16px;\n}\n\n.attribute-list-section-header-wrapper {\n  background-color: var(--color-p1-2);\n  font-size: var(--font-size-subtle);\n  font-family: var(--main-font-family--semibold);\n  padding: 6px 0px;\n  text-transform: uppercase;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.attribute-list-section-header {\n  margin: 0 16px;\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.attribute-list-option {\n  padding: 5px 15px;\n  cursor: pointer;\n  max-width: 274px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.attribute-list-option:hover {\n  background-color: var(--color-p3-3);\n  transition: var(--transition-catchall-simple);\n}\n.dynamic-content-toolbar-menu-popover--header,\n.book-meeting-toolbar-menu-popover--header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n}\n\n.dynamic-content-toolbar-menu-popover--header {\n  padding: 16px;\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.dynamic-content-toolbar-menu-popover--header h4,\n.book-meeting-toolbar-menu-popover--header h4 {\n  margin-top: 0px;\n  transition: all 0.3s ease;\n  max-width: 175px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.dynamic-content-jinja-code--editor {\n  color: var(--color-s4-10);\n  background-color: var(--color-s1-3);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n  padding: 3px 7px;\n}\n\n.dynamic-content-placeholder-text--editor {\n  color: var(--color-p1-5-5);\n}\n\n.book-a-meeting-popup-container .driftiwyg-tag-property--editor {\n  width: min-content;\n  background: var(--color-s4-3);\n  color: var(--color-s4-10);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n  padding: 3px 7px;\n  margin: 16px 0 0;\n}\n\n.book-a-meeting-popup-container .book-a-meeting-fallback-input {\n  padding-bottom: 16px;\n}\n"]
    }]);
  }, function (e, i, a) {
    var n = a(263);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var t = {
      insert: "head",
      singleton: !1
    };
    a(10)(n, t);
    n.locals && (e.exports = n.locals);
  }, function (e, i, a) {
    (e.exports = a(9)(!0)).push([e.i, ".dynamic-content-toolbar-menu-popover--variation-builder {\n  padding: 16px;\n}\n.dynamic-content-variation-wrapper {\n  margin-bottom: 16px;\n}\n.dynamic-content-variation {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: flex-end;\n          align-items: flex-end;\n}\n\n.dynamic-content-variation-operator-select__control {\n  width: 160px;\n}\n\n.dynamic-content-variation-value-input {\n  margin-left: 4px;\n}\n\n.dynamic-content-variation-value-input.invalid input.tide-input,\n.dynamic-content-variation-value-input.invalid input.tide-input:hover {\n  border: 1px solid  var(--color-s3-6);\n}\n\n.dynamic-content-variation-quick-action-button {\n  margin-bottom: 16px;\n  width: 112px;\n}\n\n.dynamic-content-variation-delete-button {\n  margin: 0 0 0 4px;\n}\n\n.dynamic-content-variation-delete-button.dynamic-content-variation-delete-button--hidden {\n  display: none;\n}\n\n.dynamic-content-variation-warning {\n  color: var(--color-s3-6);\n  margin: 4px 0 0 4px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAa;EAAb,aAAa;EACb,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB",
      file: "style.css",
      sourcesContent: [".dynamic-content-toolbar-menu-popover--variation-builder {\n  padding: 16px;\n}\n.dynamic-content-variation-wrapper {\n  margin-bottom: 16px;\n}\n.dynamic-content-variation {\n  display: flex;\n  align-items: flex-end;\n}\n\n.dynamic-content-variation-operator-select__control {\n  width: 160px;\n}\n\n.dynamic-content-variation-value-input {\n  margin-left: 4px;\n}\n\n.dynamic-content-variation-value-input.invalid input.tide-input,\n.dynamic-content-variation-value-input.invalid input.tide-input:hover {\n  border: 1px solid  var(--color-s3-6);\n}\n\n.dynamic-content-variation-quick-action-button {\n  margin-bottom: 16px;\n  width: 112px;\n}\n\n.dynamic-content-variation-delete-button {\n  margin: 0 0 0 4px;\n}\n\n.dynamic-content-variation-delete-button.dynamic-content-variation-delete-button--hidden {\n  display: none;\n}\n\n.dynamic-content-variation-warning {\n  color: var(--color-s3-6);\n  margin: 4px 0 0 4px;\n}\n"]
    }]);
  }, function (e, i, a) {
    var n = a(265);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var t = {
      insert: "head",
      singleton: !1
    };
    a(10)(n, t);
    n.locals && (e.exports = n.locals);
  }, function (e, i, a) {
    (e.exports = a(9)(!0)).push([e.i, ':root {\n  --wysiwyg-secondary: rgb(230, 236, 239);\n  --wysiwyg-tag-purple: #5767e4;\n}\n\n.wysiwyg-slate-editor {\n  padding: 16px;\n  width: calc(100% - 32px);\n  overflow-y: scroll;\n  border: 1px solid var(--color-p1-5);\n  border-top: none;\n  border-radius: 0 0 3px 3px;\n  background: var(--color-p1-2);\n}\n\n.wysiwyg-slate-editor p {\n  margin: 0;\n  line-height: 1.4;\n}\n\n.wysiwyg-slate-editor-menu {\n  padding: 5px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n          flex-wrap: wrap;\n  background: var(--color-p1-2);\n  position: relative;\n  border: 1px solid var(--color-p1-5);\n  padding: 0px;\n  width: 100%;\n}\n\n.wysiwyg-toolbar-button-group-container {\n  display: -webkit-flex;\n  display: flex;\n}\n\n/* toolbar button dividers */\n.wysiwyg-toolbar-button-group-container:not(:last-of-type):not(:empty) {\n  border-right: 1px solid var(--color-p1-5);\n}\n\n.wysiwyg-toolbar-popover-button-container {\n  display: -webkit-flex;\n  display: flex;\n  max-height: 35px;\n}\n\n.wysiwyg-toolbar-button {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  padding: 10px;\n  cursor: pointer;\n  background: var(--color-p1-2);\n  transition: background-color 0.3s ease;\n}\n\n.wysiwyg-toolbar-button:hover,\n.wysiwyg-toolbar-button--active {\n  background: var(--color-p3-2);\n}\n\n.toolbar-menu-popover {\n  position: absolute;\n  left: 10px;\n  top: 38px;\n  z-index: 20000;\n  max-width: 304px;\n  min-width: 200px;\n  height: 340px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart {\n  border: none;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-scroll {\n  height: 200px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-category-label {\n  font-family: var(--main-font-family--semibold);\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search-icon {\n  top: 7px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search input {\n  font-size: var(--font-size-subtle);\n  transition: all 0.3s ease;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search input:focus {\n  border-color: var(--main-green);\n}\n\n.toolbar-menu-popover--link {\n  bottom: -250px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--link button {\n  margin-top: 10px;\n}\n\n.toolbar-menu-popover-container--link {\n  padding: 16px;\n  width: calc(100% - 32px);\n}\n\n.toolbar-menu-popover-container--link .tide-input,\n.toolbar-menu-popover-container--link .tide-label {\n  width: 100%;\n}\n\n.toolbar-menu-popover--tag-properties {\n  bottom: -282px;\n  right: 20px;\n  width: 100%;\n  cursor: default;\n}\n\n.toolbar-menu-popover--image {\n  bottom: -257px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--container .toolbar-menu-popover-container--link .link-popover-text-input {\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--container .toolbar-menu-popover-container--link .link-popover-link-input {\n  margin-bottom: 8px;\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--container .toolbar-menu-popover--image-container {\n  display: block;\n  padding: 16px;\n}\n\n.toolbar-menu-popover--image .image-uploader {\n  width: calc(100% - 34px);\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--image-container .image-popover-alt-text-input {\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--image .image-popover-alt-text-input input {\n  width: 272px;\n}\n\n.toolbar-menu-popover--container {\n  background: var(--color-p1-2);\n  width: 100%;\n  max-width: 304px;\n  border-radius: 3px;\n  border-top: 8px solid var(--color-p1-10);\n  box-shadow: var(--box-shadow-1);\n}\n\n.toolbar-menu-popover--container h3 {\n  margin: 0;\n}\n\n.toolbar-menu-popover--header {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  padding: 14px;\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.toolbar-menu-popover--header h4 {\n  margin-top: 2px;\n  transition: all 0.3s ease;\n}\n\n.toolbar-menu-popover--header--offset {\n  margin-left: 25px !important;\n}\n\n.toolbar-menu-popover--header a {\n  color: var(--color-p3-6);\n  margin: 0;\n  text-decoration: none;\n}\n\n.toolbar-menu-popover--back-button-container {\n  cursor: pointer;\n  position: absolute;\n  left: 15px;\n}\n\n.toolbar-menu-popover--back-button path {\n  fill: var(--color-p3-5);\n}\n\n/* need different class names because slate wraps things in two span elements */\n.driftiwyg-tag-property,\n.driftiwyg-tag-property--editor span span span {\n  background: var(--color-s4-3);\n  color: var(--color-s4-10);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n}\n\n.driftiwyg-tag-property {\n  padding: 5px 7px;\n}\n\n.driftiwyg-tag-property--editor span span span {\n  padding: 3px 7px;\n  margin: 0 2px;\n}\n\n[contenteditable=\'true\'] {\n  user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  -webkit-user-select: text;\n}\n\n.resizable-image {\n  border: 2px solid transparent;\n}\n\n.resizable-image.focused {\n  border-color: var(--color-p3-6);\n}\n\n.wysiwyg-image-upload-error {\n  color: var(--color-s3-6);\n  margin-top: 8px;\n}\n\n.email-wysiwyg-link-tooltip {\n  max-width: 400px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\ndiv[data-slate-node="element"] > span.driftiwyg-tag-property--editor.drift-content-variable {\n  display: inline-block;\n  width: -webkit-min-content;\n  width: min-content;\n  height: 24px;\n}\n\ndiv[data-slate-node="element"] > span.driftiwyg-tag-property--editor.drift-content-variable > * {\n  display: none;\n  visibility: hidden;\n  width: 75px;\n  white-space: nowrap;\n}\n\ndiv[data-slate-node="element"] > span.driftiwyg-tag-property--editor.drift-content-variable::after {\n  display: inline-block;\n  width: -webkit-max-content;\n  width: max-content;\n  height: 20px;\n  content: attr(data-contentvareditordisplay);\n  position: relative;\n  background: var(--color-s4-3);\n  color: var(--color-s4-10);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n  padding: 3px 5px 1px;\n  left: -1px;\n}\n', "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAa;EAAb,aAAa;EACb,uBAAe;UAAf,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAa;EAAb,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAa;EAAb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAa;EAAb,aAAa;EACb,2BAAmB;UAAnB,mBAAmB;EACnB,+BAAuB;UAAvB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAa;EAAb,aAAa;EACb,2BAAmB;UAAnB,mBAAmB;EACnB,sCAA8B;UAA9B,8BAA8B;EAC9B,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA,+EAA+E;AAC/E;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,qBAAqB;EACrB,0BAAkB;EAAlB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0BAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,UAAU;AACZ",
      file: "styles.css",
      sourcesContent: [':root {\n  --wysiwyg-secondary: rgb(230, 236, 239);\n  --wysiwyg-tag-purple: #5767e4;\n}\n\n.wysiwyg-slate-editor {\n  padding: 16px;\n  width: calc(100% - 32px);\n  overflow-y: scroll;\n  border: 1px solid var(--color-p1-5);\n  border-top: none;\n  border-radius: 0 0 3px 3px;\n  background: var(--color-p1-2);\n}\n\n.wysiwyg-slate-editor p {\n  margin: 0;\n  line-height: 1.4;\n}\n\n.wysiwyg-slate-editor-menu {\n  padding: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  background: var(--color-p1-2);\n  position: relative;\n  border: 1px solid var(--color-p1-5);\n  padding: 0px;\n  width: 100%;\n}\n\n.wysiwyg-toolbar-button-group-container {\n  display: flex;\n}\n\n/* toolbar button dividers */\n.wysiwyg-toolbar-button-group-container:not(:last-of-type):not(:empty) {\n  border-right: 1px solid var(--color-p1-5);\n}\n\n.wysiwyg-toolbar-popover-button-container {\n  display: flex;\n  max-height: 35px;\n}\n\n.wysiwyg-toolbar-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  cursor: pointer;\n  background: var(--color-p1-2);\n  transition: background-color 0.3s ease;\n}\n\n.wysiwyg-toolbar-button:hover,\n.wysiwyg-toolbar-button--active {\n  background: var(--color-p3-2);\n}\n\n.toolbar-menu-popover {\n  position: absolute;\n  left: 10px;\n  top: 38px;\n  z-index: 20000;\n  max-width: 304px;\n  min-width: 200px;\n  height: 340px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart {\n  border: none;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-scroll {\n  height: 200px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-category-label {\n  font-family: var(--main-font-family--semibold);\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search-icon {\n  top: 7px;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search input {\n  font-size: var(--font-size-subtle);\n  transition: all 0.3s ease;\n}\n\n.toolbar-menu-popover--emoji .emoji-mart-search input:focus {\n  border-color: var(--main-green);\n}\n\n.toolbar-menu-popover--link {\n  bottom: -250px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--link button {\n  margin-top: 10px;\n}\n\n.toolbar-menu-popover-container--link {\n  padding: 16px;\n  width: calc(100% - 32px);\n}\n\n.toolbar-menu-popover-container--link .tide-input,\n.toolbar-menu-popover-container--link .tide-label {\n  width: 100%;\n}\n\n.toolbar-menu-popover--tag-properties {\n  bottom: -282px;\n  right: 20px;\n  width: 100%;\n  cursor: default;\n}\n\n.toolbar-menu-popover--image {\n  bottom: -257px;\n  right: 20px;\n  width: 100%;\n}\n\n.toolbar-menu-popover--container .toolbar-menu-popover-container--link .link-popover-text-input {\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--container .toolbar-menu-popover-container--link .link-popover-link-input {\n  margin-bottom: 8px;\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--container .toolbar-menu-popover--image-container {\n  display: block;\n  padding: 16px;\n}\n\n.toolbar-menu-popover--image .image-uploader {\n  width: calc(100% - 34px);\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--image .toolbar-menu-popover--image-container .image-popover-alt-text-input {\n  margin-bottom: 16px;\n}\n\n.toolbar-menu-popover--image .image-popover-alt-text-input input {\n  width: 272px;\n}\n\n.toolbar-menu-popover--container {\n  background: var(--color-p1-2);\n  width: 100%;\n  max-width: 304px;\n  border-radius: 3px;\n  border-top: 8px solid var(--color-p1-10);\n  box-shadow: var(--box-shadow-1);\n}\n\n.toolbar-menu-popover--container h3 {\n  margin: 0;\n}\n\n.toolbar-menu-popover--header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px;\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.toolbar-menu-popover--header h4 {\n  margin-top: 2px;\n  transition: all 0.3s ease;\n}\n\n.toolbar-menu-popover--header--offset {\n  margin-left: 25px !important;\n}\n\n.toolbar-menu-popover--header a {\n  color: var(--color-p3-6);\n  margin: 0;\n  text-decoration: none;\n}\n\n.toolbar-menu-popover--back-button-container {\n  cursor: pointer;\n  position: absolute;\n  left: 15px;\n}\n\n.toolbar-menu-popover--back-button path {\n  fill: var(--color-p3-5);\n}\n\n/* need different class names because slate wraps things in two span elements */\n.driftiwyg-tag-property,\n.driftiwyg-tag-property--editor span span span {\n  background: var(--color-s4-3);\n  color: var(--color-s4-10);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n}\n\n.driftiwyg-tag-property {\n  padding: 5px 7px;\n}\n\n.driftiwyg-tag-property--editor span span span {\n  padding: 3px 7px;\n  margin: 0 2px;\n}\n\n[contenteditable=\'true\'] {\n  user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  -webkit-user-select: text;\n}\n\n.resizable-image {\n  border: 2px solid transparent;\n}\n\n.resizable-image.focused {\n  border-color: var(--color-p3-6);\n}\n\n.wysiwyg-image-upload-error {\n  color: var(--color-s3-6);\n  margin-top: 8px;\n}\n\n.email-wysiwyg-link-tooltip {\n  max-width: 400px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\ndiv[data-slate-node="element"] > span.driftiwyg-tag-property--editor.drift-content-variable {\n  display: inline-block;\n  width: min-content;\n  height: 24px;\n}\n\ndiv[data-slate-node="element"] > span.driftiwyg-tag-property--editor.drift-content-variable > * {\n  display: none;\n  visibility: hidden;\n  width: 75px;\n  white-space: nowrap;\n}\n\ndiv[data-slate-node="element"] > span.driftiwyg-tag-property--editor.drift-content-variable::after {\n  display: inline-block;\n  width: max-content;\n  height: 20px;\n  content: attr(data-contentvareditordisplay);\n  position: relative;\n  background: var(--color-s4-3);\n  color: var(--color-s4-10);\n  border-radius: 3px;\n  font-size: var(--font-size-subtle);\n  padding: 3px 5px 1px;\n  left: -1px;\n}\n']
    }]);
  }, function (i, a, t) {
    "use strict";

    t.r(a);
    var o = {};

    function _defineProperty(e, i, a) {
      return i in e ? Object.defineProperty(e, i, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[i] = a, e;
    }

    function _arrayLikeToArray(e, i) {
      (null == i || i > e.length) && (i = e.length);

      for (var a = 0, n = new Array(i); a < i; a++) {
        n[a] = e[a];
      }

      return n;
    }

    function _unsupportedIterableToArray(e, i) {
      if (e) {
        if ("string" === typeof e) return _arrayLikeToArray(e, i);
        var a = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(a) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? _arrayLikeToArray(e, i) : void 0;
      }
    }

    function _createForOfIteratorHelper(i) {
      if ("undefined" === typeof Symbol || null == i[Symbol.iterator]) {
        if (Array.isArray(i) || (i = _unsupportedIterableToArray(i))) {
          var a = 0,
              t = function F() {};

          return {
            s: t,
            n: function n() {
              return a >= i.length ? {
                done: !0
              } : {
                done: !1,
                value: i[a++]
              };
            },
            e: function e(i) {
              throw i;
            },
            f: t
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var o,
          r,
          g = !0,
          l = !1;
      return {
        s: function s() {
          o = i[Symbol.iterator]();
        },
        n: function n() {
          var e = o.next();
          return g = e.done, e;
        },
        e: function e(i) {
          l = !0, r = i;
        },
        f: function f() {
          try {
            g || null == o.return || o.return();
          } finally {
            if (l) throw r;
          }
        }
      };
    }

    function _slicedToArray(e, i) {
      return function _arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function _iterableToArrayLimit(e, i) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) {
          var a = [],
              n = !0,
              t = !1,
              o = void 0;

          try {
            for (var s, r = e[Symbol.iterator](); !(n = (s = r.next()).done) && (a.push(s.value), !i || a.length !== i); n = !0) {
              ;
            }
          } catch (g) {
            t = !0, o = g;
          } finally {
            try {
              n || null == r.return || r.return();
            } finally {
              if (t) throw o;
            }
          }

          return a;
        }
      }(e, i) || _unsupportedIterableToArray(e, i) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    t.r(o), t.d(o, "categories", function () {
      return it;
    }), t.d(o, "search", function () {
      return at;
    });
    var s = t(0),
        r = t.n(s);

    function isObjectObject(e) {
      return !0 === function isObject(e) {
        return null != e && "object" === typeof e && !1 === Array.isArray(e);
      }(e) && "[object Object]" === Object.prototype.toString.call(e);
    }

    var m = function isPlainObject(e) {
      var i, a;
      return !1 !== isObjectObject(e) && "function" === typeof (i = e.constructor) && !1 !== isObjectObject(a = i.prototype) && !1 !== a.hasOwnProperty("isPrototypeOf");
    },
        d = t(3),
        c = t.n(d);

    function _toConsumableArray(e) {
      return function _arrayWithoutHoles(e) {
        if (Array.isArray(e)) return _arrayLikeToArray(e);
      }(e) || function _iterableToArray(e) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || _unsupportedIterableToArray(e) || function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    var F = t(107);

    function immer_esm_n(e) {
      for (var i = arguments.length, a = Array(i > 1 ? i - 1 : 0), n = 1; n < i; n++) {
        a[n - 1] = arguments[n];
      }

      throw Error("[Immer] minified error nr: " + e + (a.length ? " " + a.map(function (e) {
        return "'" + e + "'";
      }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
    }

    function immer_esm_t(e) {
      return !!e && !!e[T];
    }

    function immer_esm_r(e) {
      return !!e && (function (e) {
        if (!e || "object" != typeof e) return !1;
        var i = Object.getPrototypeOf(e);
        return !i || i === Object.prototype;
      }(e) || Array.isArray(e) || !!e[q] || !!e.constructor[q] || immer_esm_s(e) || immer_esm_v(e));
    }

    function immer_esm_i(e, i, a) {
      void 0 === a && (a = !1), 0 === immer_esm_o(e) ? (a ? Object.keys : H)(e).forEach(function (n) {
        a && "symbol" == typeof n || i(n, e[n], e);
      }) : e.forEach(function (a, n) {
        return i(n, a, e);
      });
    }

    function immer_esm_o(e) {
      var i = e[T];
      return i ? i.i > 3 ? i.i - 4 : i.i : Array.isArray(e) ? 1 : immer_esm_s(e) ? 2 : immer_esm_v(e) ? 3 : 0;
    }

    function u(e, i) {
      return 2 === immer_esm_o(e) ? e.has(i) : Object.prototype.hasOwnProperty.call(e, i);
    }

    function immer_esm_a(e, i) {
      return 2 === immer_esm_o(e) ? e.get(i) : e[i];
    }

    function f(e, i, a) {
      var n = immer_esm_o(e);
      2 === n ? e.set(i, a) : 3 === n ? (e.delete(i), e.add(a)) : e[i] = a;
    }

    function immer_esm_c(e, i) {
      return e === i ? 0 !== e || 1 / e == 1 / i : e != e && i != i;
    }

    function immer_esm_s(e) {
      return v && e instanceof Map;
    }

    function immer_esm_v(e) {
      return x && e instanceof Set;
    }

    function immer_esm_p(e) {
      return e.o || e.t;
    }

    function l(e) {
      if (Array.isArray(e)) return Array.prototype.slice.call(e);
      var i = L(e);
      delete i[T];

      for (var a = H(i), n = 0; n < a.length; n++) {
        var t = a[n],
            o = i[t];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (i[t] = {
          configurable: !0,
          writable: !0,
          enumerable: o.enumerable,
          value: e[t]
        });
      }

      return Object.create(Object.getPrototypeOf(e), i);
    }

    function immer_esm_d(e, i) {
      immer_esm_y(e) || immer_esm_t(e) || !immer_esm_r(e) || (immer_esm_o(e) > 1 && (e.set = e.add = e.clear = e.delete = h), Object.freeze(e), i && immer_esm_i(e, function (e, i) {
        return immer_esm_d(i, !0);
      }, !0));
    }

    function h() {
      immer_esm_n(2);
    }

    function immer_esm_y(e) {
      return null == e || "object" != typeof e || Object.isFrozen(e);
    }

    function b(e) {
      var i = X[e];
      return i || immer_esm_n(18, e), i;
    }

    function _() {
      return k;
    }

    function j(e, i) {
      i && (b("Patches"), e.u = [], e.s = [], e.v = i);
    }

    function g(e) {
      O(e), e.p.forEach(S), e.p = null;
    }

    function O(e) {
      e === k && (k = e.l);
    }

    function w(e) {
      return k = {
        p: [],
        l: k,
        h: e,
        m: !0,
        _: 0
      };
    }

    function S(e) {
      var i = e[T];
      0 === i.i || 1 === i.i ? i.j() : i.g = !0;
    }

    function P(e, i) {
      i._ = i.p.length;
      var a = i.p[0],
          n = void 0 !== e && e !== a;
      return i.h.O || b("ES5").S(i, e, n), n ? (a[T].P && (g(i), immer_esm_n(4)), immer_esm_r(e) && (e = M(i, e), i.l || immer_esm_x(i, e)), i.u && b("Patches").M(a[T], e, i.u, i.s)) : e = M(i, a, []), g(i), i.u && i.v(i.u, i.s), e !== B ? e : void 0;
    }

    function M(e, i, a) {
      if (immer_esm_y(i)) return i;
      var n = i[T];
      if (!n) return immer_esm_i(i, function (t, o) {
        return A(e, n, i, t, o, a);
      }, !0), i;
      if (n.A !== e) return i;
      if (!n.P) return immer_esm_x(e, n.t, !0), n.t;

      if (!n.I) {
        n.I = !0, n.A._--;
        var t = 4 === n.i || 5 === n.i ? n.o = l(n.k) : n.o;
        immer_esm_i(3 === n.i ? new Set(t) : t, function (i, o) {
          return A(e, n, t, i, o, a);
        }), immer_esm_x(e, t, !1), a && e.u && b("Patches").R(n, a, e.u, e.s);
      }

      return n.o;
    }

    function A(e, i, a, n, t, o) {
      if (immer_esm_t(t)) {
        var s = M(e, t, o && i && 3 !== i.i && !u(i.D, n) ? o.concat(n) : void 0);
        if (f(a, n, s), !immer_esm_t(s)) return;
        e.m = !1;
      }

      if (immer_esm_r(t) && !immer_esm_y(t)) {
        if (!e.h.N && e._ < 1) return;
        M(e, t), i && i.A.l || immer_esm_x(e, t);
      }
    }

    function immer_esm_x(e, i, a) {
      void 0 === a && (a = !1), e.h.N && e.m && immer_esm_d(i, a);
    }

    function z(e, i) {
      var a = e[T];
      return (a ? immer_esm_p(a) : e)[i];
    }

    function I(e, i) {
      if (i in e) for (var a = Object.getPrototypeOf(e); a;) {
        var n = Object.getOwnPropertyDescriptor(a, i);
        if (n) return n;
        a = Object.getPrototypeOf(a);
      }
    }

    function E(e) {
      e.P || (e.P = !0, e.l && E(e.l));
    }

    function immer_esm_k(e) {
      e.o || (e.o = l(e.t));
    }

    function R(e, i, a) {
      var n = immer_esm_s(i) ? b("MapSet").T(i, a) : immer_esm_v(i) ? b("MapSet").F(i, a) : e.O ? function (e, i) {
        var a = Array.isArray(e),
            n = {
          i: a ? 1 : 0,
          A: i ? i.A : _(),
          P: !1,
          I: !1,
          D: {},
          l: i,
          t: e,
          k: null,
          o: null,
          j: null,
          C: !1
        },
            t = n,
            o = Z;
        a && (t = [n], o = W);
        var s = Proxy.revocable(t, o),
            r = s.revoke,
            g = s.proxy;
        return n.k = g, n.j = r, g;
      }(i, a) : b("ES5").J(i, a);
      return (a ? a.A : _()).p.push(n), n;
    }

    function N(e, i) {
      switch (i) {
        case 2:
          return new Map(e);

        case 3:
          return Array.from(e);
      }

      return l(e);
    }

    var p,
        k,
        y = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
        v = "undefined" != typeof Map,
        x = "undefined" != typeof Set,
        C = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
        B = y ? Symbol.for("immer-nothing") : ((p = {})["immer-nothing"] = !0, p),
        q = y ? Symbol.for("immer-draftable") : "__$immer_draftable",
        T = y ? Symbol.for("immer-state") : "__$immer_state",
        H = ("undefined" != typeof Symbol && Symbol.iterator, "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (e) {
      return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
    } : Object.getOwnPropertyNames),
        L = Object.getOwnPropertyDescriptors || function (e) {
      var i = {};
      return H(e).forEach(function (a) {
        i[a] = Object.getOwnPropertyDescriptor(e, a);
      }), i;
    },
        X = {},
        Z = {
      get: function get(e, i) {
        if (i === T) return e;
        var a = immer_esm_p(e);
        if (!u(a, i)) return function (e, i, a) {
          var n,
              t = I(i, a);
          return t ? "value" in t ? t.value : null === (n = t.get) || void 0 === n ? void 0 : n.call(e.k) : void 0;
        }(e, a, i);
        var n = a[i];
        return e.I || !immer_esm_r(n) ? n : n === z(e.t, i) ? (immer_esm_k(e), e.o[i] = R(e.A.h, n, e)) : n;
      },
      has: function has(e, i) {
        return i in immer_esm_p(e);
      },
      ownKeys: function ownKeys(e) {
        return Reflect.ownKeys(immer_esm_p(e));
      },
      set: function set(e, i, a) {
        var n = I(immer_esm_p(e), i);
        if (null == n ? void 0 : n.set) return n.set.call(e.k, a), !0;

        if (!e.P) {
          var t = z(immer_esm_p(e), i),
              o = null == t ? void 0 : t[T];
          if (o && o.t === a) return e.o[i] = a, e.D[i] = !1, !0;
          if (immer_esm_c(a, t) && (void 0 !== a || u(e.t, i))) return !0;
          immer_esm_k(e), E(e);
        }

        return e.o[i] = a, e.D[i] = !0, !0;
      },
      deleteProperty: function deleteProperty(e, i) {
        return void 0 !== z(e.t, i) || i in e.t ? (e.D[i] = !1, immer_esm_k(e), E(e)) : delete e.D[i], e.o && delete e.o[i], !0;
      },
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, i) {
        var a = immer_esm_p(e),
            n = Reflect.getOwnPropertyDescriptor(a, i);
        return n ? {
          writable: !0,
          configurable: 1 !== e.i || "length" !== i,
          enumerable: n.enumerable,
          value: a[i]
        } : n;
      },
      defineProperty: function defineProperty() {
        immer_esm_n(11);
      },
      getPrototypeOf: function getPrototypeOf(e) {
        return Object.getPrototypeOf(e.t);
      },
      setPrototypeOf: function setPrototypeOf() {
        immer_esm_n(12);
      }
    },
        W = {};

    immer_esm_i(Z, function (e, i) {
      W[e] = function () {
        return arguments[0] = arguments[0][0], i.apply(this, arguments);
      };
    }), W.deleteProperty = function (e, i) {
      return Z.deleteProperty.call(this, e[0], i);
    }, W.set = function (e, i, a) {
      return Z.set.call(this, e[0], i, a, e[0]);
    };
    var Y = new (function () {
      function e(e) {
        this.O = C, this.N = !1, "boolean" == typeof (null == e ? void 0 : e.useProxies) && this.setUseProxies(e.useProxies), "boolean" == typeof (null == e ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze), this.produce = this.produce.bind(this), this.produceWithPatches = this.produceWithPatches.bind(this);
      }

      var i = e.prototype;
      return i.produce = function (e, i, a) {
        if ("function" == typeof e && "function" != typeof i) {
          var n = i;
          i = e;
          var t = this;
          return function (e) {
            var a = this;
            void 0 === e && (e = n);

            for (var o = arguments.length, s = Array(o > 1 ? o - 1 : 0), r = 1; r < o; r++) {
              s[r - 1] = arguments[r];
            }

            return t.produce(e, function (e) {
              var n;
              return (n = i).call.apply(n, [a, e].concat(s));
            });
          };
        }

        var o;

        if ("function" != typeof i && immer_esm_n(6), void 0 !== a && "function" != typeof a && immer_esm_n(7), immer_esm_r(e)) {
          var s = w(this),
              r = R(this, e, void 0),
              l = !0;

          try {
            o = i(r), l = !1;
          } finally {
            l ? g(s) : O(s);
          }

          return "undefined" != typeof Promise && o instanceof Promise ? o.then(function (e) {
            return j(s, a), P(e, s);
          }, function (e) {
            throw g(s), e;
          }) : (j(s, a), P(o, s));
        }

        if (!e || "object" != typeof e) {
          if ((o = i(e)) === B) return;
          return void 0 === o && (o = e), this.N && immer_esm_d(o, !0), o;
        }

        immer_esm_n(21, e);
      }, i.produceWithPatches = function (e, i) {
        var a,
            n,
            t = this;
        return "function" == typeof e ? function (i) {
          for (var a = arguments.length, n = Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) {
            n[o - 1] = arguments[o];
          }

          return t.produceWithPatches(i, function (i) {
            return e.apply(void 0, [i].concat(n));
          });
        } : [this.produce(e, i, function (e, i) {
          a = e, n = i;
        }), a, n];
      }, i.createDraft = function (e) {
        immer_esm_r(e) || immer_esm_n(8), immer_esm_t(e) && (e = function D(e) {
          return immer_esm_t(e) || immer_esm_n(22, e), function n(e) {
            if (!immer_esm_r(e)) return e;
            var i,
                a = e[T],
                t = immer_esm_o(e);

            if (a) {
              if (!a.P && (a.i < 4 || !b("ES5").K(a))) return a.t;
              a.I = !0, i = N(e, t), a.I = !1;
            } else i = N(e, t);

            return immer_esm_i(i, function (e, t) {
              a && immer_esm_a(a.t, e) === t || f(i, e, n(t));
            }), 3 === t ? new Set(i) : i;
          }(e);
        }(e));
        var i = w(this),
            a = R(this, e, void 0);
        return a[T].C = !0, O(i), a;
      }, i.finishDraft = function (e, i) {
        var a = (e && e[T]).A;
        return j(a, i), P(void 0, a);
      }, i.setAutoFreeze = function (e) {
        this.N = e;
      }, i.setUseProxies = function (e) {
        e && !C && immer_esm_n(20), this.O = e;
      }, i.applyPatches = function (e, i) {
        var a;

        for (a = i.length - 1; a >= 0; a--) {
          var n = i[a];

          if (0 === n.path.length && "replace" === n.op) {
            e = n.value;
            break;
          }
        }

        var t = b("Patches").$;
        return immer_esm_t(e) ? t(e, i) : this.produce(e, function (e) {
          return t(e, i.slice(a + 1));
        });
      }, e;
    }())(),
        J = Y.produce,
        U = (Y.produceWithPatches.bind(Y), Y.setAutoFreeze.bind(Y), Y.setUseProxies.bind(Y), Y.applyPatches.bind(Y), Y.createDraft.bind(Y)),
        G = Y.finishDraft.bind(Y),
        V = t(108),
        K = t.n(V),
        Q = t(64),
        $ = t.n(Q);

    function index_es_defineProperty(e, i, a) {
      return i in e ? Object.defineProperty(e, i, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[i] = a, e;
    }

    var ee = new WeakMap(),
        ie = new WeakMap(),
        ae = new WeakMap(),
        ne = new WeakMap(),
        te = new WeakMap(),
        oe = new WeakMap();

    function ownKeys(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var se = function createEditor() {
      var e = {
        children: [],
        operations: [],
        selection: null,
        marks: null,
        isInline: function isInline() {
          return !1;
        },
        isVoid: function isVoid() {
          return !1;
        },
        onChange: function onChange() {},
        apply: function apply(i) {
          var a,
              n = _createForOfIteratorHelper(ke.pathRefs(e));

          try {
            for (n.s(); !(a = n.n()).done;) {
              var t = a.value;
              je.transform(t, i);
            }
          } catch (A) {
            n.e(A);
          } finally {
            n.f();
          }

          var o,
              s = _createForOfIteratorHelper(ke.pointRefs(e));

          try {
            for (s.s(); !(o = s.n()).done;) {
              var r = o.value;
              xe.transform(r, i);
            }
          } catch (A) {
            s.e(A);
          } finally {
            s.f();
          }

          var g,
              l = _createForOfIteratorHelper(ke.rangeRefs(e));

          try {
            for (l.s(); !(g = l.n()).done;) {
              var f = g.value;
              Be.transform(f, i);
            }
          } catch (A) {
            l.e(A);
          } finally {
            l.f();
          }

          var h,
              m = new Set(),
              _ = [],
              d = function add(e) {
            if (e) {
              var i = e.join(",");
              m.has(i) || (m.add(i), _.push(e));
            }
          },
              c = ee.get(e) || [],
              F = re(i),
              u = _createForOfIteratorHelper(c);

          try {
            for (u.s(); !(h = u.n()).done;) {
              var p = h.value;
              d(Ee.transform(p, i));
            }
          } catch (A) {
            u.e(A);
          } finally {
            u.f();
          }

          var b,
              k = _createForOfIteratorHelper(F);

          try {
            for (k.s(); !(b = k.n()).done;) {
              d(b.value);
            }
          } catch (A) {
            k.e(A);
          } finally {
            k.f();
          }

          ee.set(e, _), Re.transform(e, i), e.operations.push(i), ke.normalize(e), "set_selection" === i.type && (e.marks = null), ie.get(e) || (ie.set(e, !0), Promise.resolve().then(function () {
            ie.set(e, !1), e.onChange(), e.operations = [];
          }));
        },
        addMark: function addMark(i, a) {
          var n = e.selection;
          if (n) if (Ce.isExpanded(n)) Re.setNodes(e, _defineProperty({}, i, a), {
            match: Me.isText,
            split: !0
          });else {
            var t = _objectSpread(_objectSpread({}, ke.marks(e) || {}), {}, _defineProperty({}, i, a));

            e.marks = t, e.onChange();
          }
        },
        deleteBackward: function deleteBackward(i) {
          var a = e.selection;
          a && Ce.isCollapsed(a) && Re.delete(e, {
            unit: i,
            reverse: !0
          });
        },
        deleteForward: function deleteForward(i) {
          var a = e.selection;
          a && Ce.isCollapsed(a) && Re.delete(e, {
            unit: i
          });
        },
        deleteFragment: function deleteFragment(i) {
          var a = e.selection;
          a && Ce.isExpanded(a) && Re.delete(e, {
            reverse: "backward" === i
          });
        },
        getFragment: function getFragment() {
          var i = e.selection;
          return i ? ve.fragment(e, i) : [];
        },
        insertBreak: function insertBreak() {
          Re.splitNodes(e, {
            always: !0
          });
        },
        insertFragment: function insertFragment(i) {
          Re.insertFragment(e, i);
        },
        insertNode: function insertNode(i) {
          Re.insertNodes(e, i);
        },
        insertText: function insertText(i) {
          var a = e.selection,
              n = e.marks;

          if (a) {
            if (Ce.isCollapsed(a)) {
              var t = ke.above(e, {
                match: function match(i) {
                  return ke.isInline(e, i);
                },
                mode: "highest"
              });

              if (t) {
                var o = _slicedToArray(t, 2)[1];

                if (ke.isEnd(e, a.anchor, o)) {
                  var s = ke.after(e, o);
                  Re.setSelection(e, {
                    anchor: s,
                    focus: s
                  });
                }
              }
            }

            if (n) {
              var r = _objectSpread({
                text: i
              }, n);

              Re.insertNodes(e, r);
            } else Re.insertText(e, i);

            e.marks = null;
          }
        },
        normalizeNode: function normalizeNode(i) {
          var a = _slicedToArray(i, 2),
              n = a[0],
              t = a[1];

          if (!Me.isText(n)) if (pe.isElement(n) && 0 === n.children.length) {
            Re.insertNodes(e, {
              text: ""
            }, {
              at: t.concat(0),
              voids: !0
            });
          } else for (var o = !ke.isEditor(n) && pe.isElement(n) && (e.isInline(n) || 0 === n.children.length || Me.isText(n.children[0]) || e.isInline(n.children[0])), s = 0, r = 0; r < n.children.length; r++, s++) {
            var g = ve.get(e, t);

            if (!Me.isText(g)) {
              var l = n.children[r],
                  f = g.children[s - 1],
                  h = r === n.children.length - 1;
              if ((Me.isText(l) || pe.isElement(l) && e.isInline(l)) !== o) Re.removeNodes(e, {
                at: t.concat(s),
                voids: !0
              }), s--;else if (pe.isElement(l)) {
                if (e.isInline(l)) if (null != f && Me.isText(f)) {
                  if (h) {
                    Re.insertNodes(e, {
                      text: ""
                    }, {
                      at: t.concat(s + 1),
                      voids: !0
                    }), s++;
                  }
                } else {
                  Re.insertNodes(e, {
                    text: ""
                  }, {
                    at: t.concat(s),
                    voids: !0
                  }), s++;
                }
              } else null != f && Me.isText(f) && (Me.equals(l, f, {
                loose: !0
              }) ? (Re.mergeNodes(e, {
                at: t.concat(s),
                voids: !0
              }), s--) : "" === f.text ? (Re.removeNodes(e, {
                at: t.concat(s - 1),
                voids: !0
              }), s--) : h && "" === l.text && (Re.removeNodes(e, {
                at: t.concat(s),
                voids: !0
              }), s--));
            }
          }
        },
        removeMark: function removeMark(i) {
          var a = e.selection;
          if (a) if (Ce.isExpanded(a)) Re.unsetNodes(e, i, {
            match: Me.isText,
            split: !0
          });else {
            var n = _objectSpread({}, ke.marks(e) || {});

            delete n[i], e.marks = n, e.onChange();
          }
        }
      };
      return e;
    },
        re = function getDirtyPaths(e) {
      switch (e.type) {
        case "insert_text":
        case "remove_text":
        case "set_node":
          var i = e.path;
          return Ee.levels(i);

        case "insert_node":
          var a = e.node,
              n = e.path,
              t = Ee.levels(n),
              o = Me.isText(a) ? [] : Array.from(ve.nodes(a), function (e) {
            var i = _slicedToArray(e, 2)[1];

            return n.concat(i);
          });
          return [].concat(_toConsumableArray(t), _toConsumableArray(o));

        case "merge_node":
          var s = e.path,
              r = Ee.ancestors(s),
              g = Ee.previous(s);
          return [].concat(_toConsumableArray(r), [g]);

        case "move_node":
          var l = e.path,
              f = e.newPath;
          if (Ee.equals(l, f)) return [];

          var h,
              m = [],
              _ = [],
              d = _createForOfIteratorHelper(Ee.ancestors(l));

          try {
            for (d.s(); !(h = d.n()).done;) {
              var c = h.value,
                  F = Ee.transform(c, e);
              m.push(F);
            }
          } catch (x) {
            d.e(x);
          } finally {
            d.f();
          }

          var u,
              p = _createForOfIteratorHelper(Ee.ancestors(f));

          try {
            for (p.s(); !(u = p.n()).done;) {
              var b = u.value,
                  k = Ee.transform(b, e);

              _.push(k);
            }
          } catch (x) {
            p.e(x);
          } finally {
            p.f();
          }

          var A = _[_.length - 1],
              y = f[f.length - 1],
              v = A.concat(y);
          return [].concat(m, _, [v]);

        case "remove_node":
          var w = e.path;
          return _toConsumableArray(Ee.ancestors(w));

        case "split_node":
          var E = e.path,
              j = Ee.levels(E),
              D = Ee.next(E);
          return [].concat(_toConsumableArray(j), [D]);

        default:
          return [];
      }
    };

    function _objectWithoutProperties(e, i) {
      if (null == e) return {};

      var a,
          n,
          t = function _objectWithoutPropertiesLoose(e, i) {
        if (null == e) return {};
        var a,
            n,
            t = {},
            o = Object.keys(e);

        for (n = 0; n < o.length; n++) {
          a = o[n], i.indexOf(a) >= 0 || (t[a] = e[a]);
        }

        return t;
      }(e, i);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (n = 0; n < o.length; n++) {
          a = o[n], i.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (t[a] = e[a]);
        }
      }

      return t;
    }

    var ge = /\s/,
        le = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/,
        fe = /['\u2018\u2019]/,
        he = function getCharacterDistance(e) {
      for (var i = 0, a = null, n = e.charCodeAt(0); n;) {
        if (de(n)) {
          var t = ce(n, e, i);
          if ("SURR" === a || "BMP" === a) break;
          i += 2, a = t ? "MOD" : "SURR", n = e.charCodeAt(i);
        } else if (8205 !== n) {
          if (ue(n)) {
            if (a && "ZWJ" !== a && "VAR" !== a) break;
            i += 1, a = "BMP", n = e.charCodeAt(i);
          } else {
            if (!Fe(n)) {
              if ("MOD" === a) {
                i += 1;
                break;
              }

              break;
            }

            if (a && "ZWJ" !== a) break;
            i += 1, a = "VAR", n = e.charCodeAt(i);
          }
        } else i += 1, a = "ZWJ", n = e.charCodeAt(i);
      }

      return i || 1;
    },
        me = function getWordDistance(e) {
      for (var i, a = 0, n = 0, t = !1; i = e.charAt(n);) {
        var o = he(i);
        i = e.slice(n, n + o);
        var s = e.slice(n + o);
        if (_e(i, s)) t = !0, a += o;else {
          if (t) break;
          a += o;
        }
        n += o;
      }

      return a;
    },
        _e = function isWordCharacter(e, i) {
      if (ge.test(e)) return !1;

      if (fe.test(e)) {
        var a = i.charAt(0),
            n = he(a);
        if (isWordCharacter(a = i.slice(0, n), i.slice(n))) return !0;
      }

      return !le.test(e);
    },
        de = function isSurrogate(e) {
      return 55296 <= e && e <= 57343;
    },
        ce = function isModifier(e, i, a) {
      if (55356 === e) {
        var n = i.charCodeAt(a + 1);
        return n <= 57343 && n >= 57339;
      }

      return !1;
    },
        Fe = function isVariationSelector(e) {
      return e <= 65039 && e >= 65024;
    },
        ue = function isBMPEmoji(e) {
      return 10084 === e || 9794 === e || 9792 === e || 9760 === e || 9877 === e || 9992 === e || 9711 === e;
    },
        pe = {
      isAncestor: function isAncestor(e) {
        return m(e) && ve.isNodeList(e.children);
      },
      isElement: function isElement(e) {
        return m(e) && ve.isNodeList(e.children) && !ke.isEditor(e);
      },
      isElementList: function isElementList(e) {
        return Array.isArray(e) && e.every(function (e) {
          return pe.isElement(e);
        });
      },
      isElementProps: function isElementProps(e) {
        return void 0 !== e.children;
      },
      matches: function matches(e, i) {
        for (var a in i) {
          if ("children" !== a && e[a] !== i[a]) return !1;
        }

        return !0;
      }
    };

    function ownKeys$1(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread$1(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$1(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var be = new WeakMap(),
        ke = {
      above: function above(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = i.voids,
            n = void 0 !== a && a,
            t = i.mode,
            o = void 0 === t ? "lowest" : t,
            s = i.at,
            r = void 0 === s ? e.selection : s,
            g = i.match;

        if (r) {
          var l,
              f = ke.path(e, r),
              h = "lowest" === o,
              m = _createForOfIteratorHelper(ke.levels(e, {
            at: f,
            voids: n,
            match: g,
            reverse: h
          }));

          try {
            for (m.s(); !(l = m.n()).done;) {
              var _ = _slicedToArray(l.value, 2),
                  d = _[0],
                  c = _[1];

              if (!Me.isText(d) && !Ee.equals(f, c)) return [d, c];
            }
          } catch (F) {
            m.e(F);
          } finally {
            m.f();
          }
        }
      },
      addMark: function addMark(e, i, a) {
        e.addMark(i, a);
      },
      after: function after(e, i) {
        var a,
            n,
            t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = {
          anchor: ke.point(e, i, {
            edge: "end"
          }),
          focus: ke.end(e, [])
        },
            s = t.distance,
            r = void 0 === s ? 1 : s,
            g = 0,
            l = _createForOfIteratorHelper(ke.positions(e, _objectSpread$1(_objectSpread$1({}, t), {}, {
          at: o
        })));

        try {
          for (l.s(); !(n = l.n()).done;) {
            var f = n.value;
            if (g > r) break;
            0 !== g && (a = f), g++;
          }
        } catch (h) {
          l.e(h);
        } finally {
          l.f();
        }

        return a;
      },
      before: function before(e, i) {
        var a,
            n,
            t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = {
          anchor: ke.start(e, []),
          focus: ke.point(e, i, {
            edge: "start"
          })
        },
            s = t.distance,
            r = void 0 === s ? 1 : s,
            g = 0,
            l = _createForOfIteratorHelper(ke.positions(e, _objectSpread$1(_objectSpread$1({}, t), {}, {
          at: o,
          reverse: !0
        })));

        try {
          for (l.s(); !(n = l.n()).done;) {
            var f = n.value;
            if (g > r) break;
            0 !== g && (a = f), g++;
          }
        } catch (h) {
          l.e(h);
        } finally {
          l.f();
        }

        return a;
      },
      deleteBackward: function deleteBackward(e) {
        var i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).unit,
            a = void 0 === i ? "character" : i;
        e.deleteBackward(a);
      },
      deleteForward: function deleteForward(e) {
        var i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).unit,
            a = void 0 === i ? "character" : i;
        e.deleteForward(a);
      },
      deleteFragment: function deleteFragment(e) {
        var i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).direction,
            a = void 0 === i ? "forward" : i;
        e.deleteFragment(a);
      },
      edges: function edges(e, i) {
        return [ke.start(e, i), ke.end(e, i)];
      },
      end: function end(e, i) {
        return ke.point(e, i, {
          edge: "end"
        });
      },
      first: function first(e, i) {
        var a = ke.path(e, i, {
          edge: "start"
        });
        return ke.node(e, a);
      },
      fragment: function fragment(e, i) {
        var a = ke.range(e, i),
            fragment = ve.fragment(e, a);
        return fragment;
      },
      hasBlocks: function hasBlocks(e, i) {
        return i.children.some(function (i) {
          return ke.isBlock(e, i);
        });
      },
      hasInlines: function hasInlines(e, i) {
        return i.children.some(function (i) {
          return Me.isText(i) || ke.isInline(e, i);
        });
      },
      hasTexts: function hasTexts(e, i) {
        return i.children.every(function (e) {
          return Me.isText(e);
        });
      },
      insertBreak: function insertBreak(e) {
        e.insertBreak();
      },
      insertFragment: function insertFragment(e, i) {
        e.insertFragment(i);
      },
      insertNode: function insertNode(e, i) {
        e.insertNode(i);
      },
      insertText: function insertText(e, i) {
        e.insertText(i);
      },
      isBlock: function isBlock(e, i) {
        return pe.isElement(i) && !e.isInline(i);
      },
      isEditor: function isEditor(e) {
        if (!m(e)) return !1;
        var i = be.get(e);
        if (void 0 !== i) return i;
        var isEditor = "function" === typeof e.addMark && "function" === typeof e.apply && "function" === typeof e.deleteBackward && "function" === typeof e.deleteForward && "function" === typeof e.deleteFragment && "function" === typeof e.insertBreak && "function" === typeof e.insertFragment && "function" === typeof e.insertNode && "function" === typeof e.insertText && "function" === typeof e.isInline && "function" === typeof e.isVoid && "function" === typeof e.normalizeNode && "function" === typeof e.onChange && "function" === typeof e.removeMark && (null === e.marks || m(e.marks)) && (null === e.selection || Ce.isRange(e.selection)) && ve.isNodeList(e.children) && we.isOperationList(e.operations);
        return be.set(e, isEditor), isEditor;
      },
      isEnd: function isEnd(e, i, a) {
        var n = ke.end(e, a);
        return De.equals(i, n);
      },
      isEdge: function isEdge(e, i, a) {
        return ke.isStart(e, i, a) || ke.isEnd(e, i, a);
      },
      isEmpty: function isEmpty(e, i) {
        var a = i.children,
            n = _slicedToArray(a, 1)[0];

        return 0 === a.length || 1 === a.length && Me.isText(n) && "" === n.text && !e.isVoid(i);
      },
      isInline: function isInline(e, i) {
        return pe.isElement(i) && e.isInline(i);
      },
      isNormalizing: function isNormalizing(e) {
        var isNormalizing = ae.get(e);
        return void 0 === isNormalizing || isNormalizing;
      },
      isStart: function isStart(e, i, a) {
        if (0 !== i.offset) return !1;
        var n = ke.start(e, a);
        return De.equals(i, n);
      },
      isVoid: function isVoid(e, i) {
        return pe.isElement(i) && e.isVoid(i);
      },
      last: function last(e, i) {
        var a = ke.path(e, i, {
          edge: "end"
        });
        return ke.node(e, a);
      },
      leaf: function leaf(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = ke.path(e, i, a);
        return [ve.leaf(e, n), n];
      },
      levels: c.a.mark(function levels(e) {
        var i,
            a,
            n,
            t,
            o,
            s,
            r,
            g,
            levels,
            l,
            f,
            h,
            m,
            _,
            d,
            F = arguments;

        return c.a.wrap(function levels$(c) {
          for (;;) {
            switch (c.prev = c.next) {
              case 0:
                if (i = F.length > 1 && void 0 !== F[1] ? F[1] : {}, a = i.at, n = void 0 === a ? e.selection : a, t = i.reverse, o = void 0 !== t && t, s = i.voids, r = void 0 !== s && s, null == (g = i.match) && (g = function match() {
                  return !0;
                }), n) {
                  c.next = 6;
                  break;
                }

                return c.abrupt("return");

              case 6:
                levels = [], l = ke.path(e, n), f = _createForOfIteratorHelper(ve.levels(e, l)), c.prev = 9, f.s();

              case 11:
                if ((h = f.n()).done) {
                  c.next = 20;
                  break;
                }

                if (m = _slicedToArray(h.value, 2), _ = m[0], d = m[1], g(_, d)) {
                  c.next = 15;
                  break;
                }

                return c.abrupt("continue", 18);

              case 15:
                if (levels.push([_, d]), r || !ke.isVoid(e, _)) {
                  c.next = 18;
                  break;
                }

                return c.abrupt("break", 20);

              case 18:
                c.next = 11;
                break;

              case 20:
                c.next = 25;
                break;

              case 22:
                c.prev = 22, c.t0 = c.catch(9), f.e(c.t0);

              case 25:
                return c.prev = 25, f.f(), c.finish(25);

              case 28:
                return o && levels.reverse(), c.delegateYield(levels, "t1", 30);

              case 30:
              case "end":
                return c.stop();
            }
          }
        }, levels, null, [[9, 22, 25, 28]]);
      }),
      marks: function marks(e) {
        var marks = e.marks,
            i = e.selection;
        if (!i) return null;
        if (marks) return marks;

        if (Ce.isExpanded(i)) {
          var a = _slicedToArray(ke.nodes(e, {
            match: Me.isText
          }), 1)[0];

          return a ? _objectWithoutProperties(_slicedToArray(a, 1)[0], ["text"]) : {};
        }

        var n = i.anchor,
            t = n.path,
            o = _slicedToArray(ke.leaf(e, t), 1)[0];

        if (0 === n.offset) {
          var s = ke.previous(e, {
            at: t,
            match: Me.isText
          }),
              r = ke.above(e, {
            match: function match(i) {
              return ke.isBlock(e, i);
            }
          });

          if (s && r) {
            var g = _slicedToArray(s, 2),
                l = g[0],
                f = g[1],
                h = _slicedToArray(r, 2)[1];

            Ee.isAncestor(h, f) && (o = l);
          }
        }

        return _objectWithoutProperties(o, ["text"]);
      },
      next: function next(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = i.mode,
            n = void 0 === a ? "lowest" : a,
            t = i.voids,
            o = void 0 !== t && t,
            s = i.match,
            r = i.at,
            g = void 0 === r ? e.selection : r;

        if (g) {
          var l = ke.after(e, g, {
            voids: o
          });

          if (l) {
            var f = _slicedToArray(ke.last(e, []), 2)[1],
                h = [l.path, f];

            if (Ee.isPath(g) && 0 === g.length) throw new Error("Cannot get the next node from the root node!");
            if (null == s) if (Ee.isPath(g)) {
              var m = _slicedToArray(ke.parent(e, g), 1)[0];

              s = function match(e) {
                return m.children.includes(e);
              };
            } else s = function match() {
              return !0;
            };

            var next = _slicedToArray(ke.nodes(e, {
              at: h,
              match: s,
              mode: n,
              voids: o
            }), 1)[0];

            return next;
          }
        }
      },
      node: function node(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = ke.path(e, i, a),
            node = ve.get(e, n);
        return [node, n];
      },
      nodes: c.a.mark(function nodes(e) {
        var i,
            a,
            n,
            t,
            o,
            s,
            r,
            g,
            l,
            f,
            h,
            m,
            _,
            d,
            F,
            u,
            p,
            b,
            k,
            A,
            y,
            v,
            w,
            E,
            j,
            D,
            x = arguments;

        return c.a.wrap(function nodes$(c) {
          for (;;) {
            switch (c.prev = c.next) {
              case 0:
                if (i = x.length > 1 && void 0 !== x[1] ? x[1] : {}, a = i.at, n = void 0 === a ? e.selection : a, t = i.mode, o = void 0 === t ? "all" : t, s = i.universal, r = void 0 !== s && s, g = i.reverse, l = void 0 !== g && g, f = i.voids, h = void 0 !== f && f, (m = i.match) || (m = function match() {
                  return !0;
                }), n) {
                  c.next = 6;
                  break;
                }

                return c.abrupt("return");

              case 6:
                Ae.isSpan(n) ? (_ = n[0], d = n[1]) : (F = ke.path(e, n, {
                  edge: "start"
                }), u = ke.path(e, n, {
                  edge: "end"
                }), _ = l ? u : F, d = l ? F : u), p = ve.nodes(e, {
                  reverse: l,
                  from: _,
                  to: d,
                  pass: function pass(i) {
                    var a = _slicedToArray(i, 1)[0];

                    return !h && ke.isVoid(e, a);
                  }
                }), b = [], A = _createForOfIteratorHelper(p), c.prev = 10, A.s();

              case 12:
                if ((y = A.n()).done) {
                  c.next = 37;
                  break;
                }

                if (v = _slicedToArray(y.value, 2), w = v[0], E = v[1], j = k && 0 === Ee.compare(E, k[1]), "highest" !== o || !j) {
                  c.next = 17;
                  break;
                }

                return c.abrupt("continue", 35);

              case 17:
                if (m(w, E)) {
                  c.next = 23;
                  break;
                }

                if (!r || j || !Me.isText(w)) {
                  c.next = 22;
                  break;
                }

                return c.abrupt("return");

              case 22:
                return c.abrupt("continue", 35);

              case 23:
                if ("lowest" !== o || !j) {
                  c.next = 26;
                  break;
                }

                return k = [w, E], c.abrupt("continue", 35);

              case 26:
                if (!(D = "lowest" === o ? k : [w, E])) {
                  c.next = 34;
                  break;
                }

                if (!r) {
                  c.next = 32;
                  break;
                }

                b.push(D), c.next = 34;
                break;

              case 32:
                return c.next = 34, D;

              case 34:
                k = [w, E];

              case 35:
                c.next = 12;
                break;

              case 37:
                c.next = 42;
                break;

              case 39:
                c.prev = 39, c.t0 = c.catch(10), A.e(c.t0);

              case 42:
                return c.prev = 42, A.f(), c.finish(42);

              case 45:
                if ("lowest" !== o || !k) {
                  c.next = 52;
                  break;
                }

                if (!r) {
                  c.next = 50;
                  break;
                }

                b.push(k), c.next = 52;
                break;

              case 50:
                return c.next = 52, k;

              case 52:
                if (!r) {
                  c.next = 54;
                  break;
                }

                return c.delegateYield(b, "t1", 54);

              case 54:
              case "end":
                return c.stop();
            }
          }
        }, nodes, null, [[10, 39, 42, 45]]);
      }),
      normalize: function normalize(e) {
        var i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).force,
            a = void 0 !== i && i,
            n = function getDirtyPaths(e) {
          return ee.get(e) || [];
        };

        if (ke.isNormalizing(e)) {
          if (a) {
            var t = Array.from(ve.nodes(e), function (e) {
              return _slicedToArray(e, 2)[1];
            });
            ee.set(e, t);
          }

          0 !== n(e).length && ke.withoutNormalizing(e, function () {
            for (var i = 42 * n(e).length, a = 0; 0 !== n(e).length;) {
              if (a > i) throw new Error("\n            Could not completely normalize the editor after ".concat(i, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.\n          "));
              var t = n(e).pop();

              if (ve.has(e, t)) {
                var o = ke.node(e, t);
                e.normalizeNode(o);
              }

              a++;
            }
          });
        }
      },
      parent: function parent(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = ke.path(e, i, a),
            t = Ee.parent(n);
        return ke.node(e, t);
      },
      path: function path(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = a.depth,
            t = a.edge;
        if (Ee.isPath(i)) if ("start" === t) i = _slicedToArray(ve.first(e, i), 2)[1];else if ("end" === t) {
          i = _slicedToArray(ve.last(e, i), 2)[1];
        }
        return Ce.isRange(i) && (i = "start" === t ? Ce.start(i) : "end" === t ? Ce.end(i) : Ee.common(i.anchor.path, i.focus.path)), De.isPoint(i) && (i = i.path), null != n && (i = i.slice(0, n)), i;
      },
      hasPath: function hasPath(e, i) {
        return ve.has(e, i);
      },
      pathRef: function pathRef(e, i) {
        var a = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).affinity,
            n = {
          current: i,
          affinity: void 0 === a ? "forward" : a,
          unref: function unref() {
            var i = n.current;
            return ke.pathRefs(e).delete(n), n.current = null, i;
          }
        };
        return ke.pathRefs(e).add(n), n;
      },
      pathRefs: function pathRefs(e) {
        var i = ne.get(e);
        return i || (i = new Set(), ne.set(e, i)), i;
      },
      point: function point(e, i) {
        var a = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).edge,
            n = void 0 === a ? "start" : a;

        if (Ee.isPath(i)) {
          var t;
          if ("end" === n) t = _slicedToArray(ve.last(e, i), 2)[1];else t = _slicedToArray(ve.first(e, i), 2)[1];
          var o = ve.get(e, t);
          if (!Me.isText(o)) throw new Error("Cannot get the ".concat(n, " point in the node at path [").concat(i, "] because it has no ").concat(n, " text node."));
          return {
            path: t,
            offset: "end" === n ? o.text.length : 0
          };
        }

        if (Ce.isRange(i)) {
          var s = _slicedToArray(Ce.edges(i), 2),
              r = s[0],
              g = s[1];

          return "start" === n ? r : g;
        }

        return i;
      },
      pointRef: function pointRef(e, i) {
        var a = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).affinity,
            n = {
          current: i,
          affinity: void 0 === a ? "forward" : a,
          unref: function unref() {
            var i = n.current;
            return ke.pointRefs(e).delete(n), n.current = null, i;
          }
        };
        return ke.pointRefs(e).add(n), n;
      },
      pointRefs: function pointRefs(e) {
        var i = te.get(e);
        return i || (i = new Set(), te.set(e, i)), i;
      },
      positions: c.a.mark(function positions(e) {
        var i,
            a,
            n,
            t,
            o,
            s,
            r,
            g,
            l,
            f,
            h,
            m,
            _,
            d,
            u,
            p,
            b,
            k,
            A,
            y,
            v,
            w,
            E,
            j,
            D,
            x,
            C,
            B,
            M,
            q = arguments;

        return c.a.wrap(function positions$(c) {
          for (;;) {
            switch (c.prev = c.next) {
              case 0:
                if (M = function _calcDistance(e, i) {
                  return "character" === i ? he(e) : "word" === i ? me(e) : "line" === i || "block" === i ? e.length : 1;
                }, i = q.length > 1 && void 0 !== q[1] ? q[1] : {}, a = i.at, n = void 0 === a ? e.selection : a, t = i.unit, o = void 0 === t ? "offset" : t, s = i.reverse, r = void 0 !== s && s, g = i.voids, l = void 0 !== g && g, n) {
                  c.next = 5;
                  break;
                }

                return c.abrupt("return");

              case 5:
                f = ke.range(e, n), h = Ce.edges(f), m = _slicedToArray(h, 2), _ = m[0], d = m[1], u = r ? d : _, p = !1, b = "", k = 0, A = 0, y = 0, v = _createForOfIteratorHelper(ke.nodes(e, {
                  at: n,
                  reverse: r,
                  voids: l
                })), c.prev = 14, v.s();

              case 16:
                if ((w = v.n()).done) {
                  c.next = 51;
                  break;
                }

                if (E = _slicedToArray(w.value, 2), j = E[0], D = E[1], !pe.isElement(j)) {
                  c.next = 26;
                  break;
                }

                if (l || !e.isVoid(j)) {
                  c.next = 23;
                  break;
                }

                return c.next = 22, ke.start(e, D);

              case 22:
                return c.abrupt("continue", 49);

              case 23:
                if (!e.isInline(j)) {
                  c.next = 25;
                  break;
                }

                return c.abrupt("continue", 49);

              case 25:
                ke.hasInlines(e, j) && (x = Ee.isAncestor(D, d.path) ? d : ke.end(e, D), C = Ee.isAncestor(D, _.path) ? _ : ke.start(e, D), b = ke.string(e, {
                  anchor: C,
                  focus: x
                }, {
                  voids: l
                }), b = r ? Object(F.reverse)(b) : b, p = !0);

              case 26:
                if (!Me.isText(j)) {
                  c.next = 49;
                  break;
                }

                if ((B = Ee.equals(D, u.path)) ? (A = r ? u.offset : j.text.length - u.offset, y = u.offset) : (A = j.text.length, y = r ? A : 0), !B && !p && "offset" !== o) {
                  c.next = 33;
                  break;
                }

                return c.next = 32, {
                  path: D,
                  offset: y
                };

              case 32:
                p = !1;

              case 33:
                if (0 !== k) {
                  c.next = 39;
                  break;
                }

                if ("" !== b) {
                  c.next = 37;
                  break;
                }

                return c.abrupt("break", 49);

              case 37:
                k = M(b, o), b = b.slice(k);

              case 39:
                if (y = r ? y - k : y + k, !((A -= k) < 0)) {
                  c.next = 44;
                  break;
                }

                return k = -A, c.abrupt("break", 49);

              case 44:
                return k = 0, c.next = 47, {
                  path: D,
                  offset: y
                };

              case 47:
                c.next = 33;
                break;

              case 49:
                c.next = 16;
                break;

              case 51:
                c.next = 56;
                break;

              case 53:
                c.prev = 53, c.t0 = c.catch(14), v.e(c.t0);

              case 56:
                return c.prev = 56, v.f(), c.finish(56);

              case 59:
              case "end":
                return c.stop();
            }
          }
        }, positions, null, [[14, 53, 56, 59]]);
      }),
      previous: function previous(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = i.mode,
            n = void 0 === a ? "lowest" : a,
            t = i.voids,
            o = void 0 !== t && t,
            s = i.match,
            r = i.at,
            g = void 0 === r ? e.selection : r;

        if (g) {
          var l = ke.before(e, g, {
            voids: o
          });

          if (l) {
            var f = _slicedToArray(ke.first(e, []), 2)[1],
                h = [l.path, f];

            if (Ee.isPath(g) && 0 === g.length) throw new Error("Cannot get the previous node from the root node!");
            if (null == s) if (Ee.isPath(g)) {
              var m = _slicedToArray(ke.parent(e, g), 1)[0];

              s = function match(e) {
                return m.children.includes(e);
              };
            } else s = function match() {
              return !0;
            };

            var previous = _slicedToArray(ke.nodes(e, {
              reverse: !0,
              at: h,
              match: s,
              mode: n,
              voids: o
            }), 1)[0];

            return previous;
          }
        }
      },
      range: function range(e, i, a) {
        return Ce.isRange(i) && !a ? i : {
          anchor: ke.start(e, i),
          focus: ke.end(e, a || i)
        };
      },
      rangeRef: function rangeRef(e, i) {
        var a = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).affinity,
            n = {
          current: i,
          affinity: void 0 === a ? "forward" : a,
          unref: function unref() {
            var i = n.current;
            return ke.rangeRefs(e).delete(n), n.current = null, i;
          }
        };
        return ke.rangeRefs(e).add(n), n;
      },
      rangeRefs: function rangeRefs(e) {
        var i = oe.get(e);
        return i || (i = new Set(), oe.set(e, i)), i;
      },
      removeMark: function removeMark(e, i) {
        e.removeMark(i);
      },
      start: function start(e, i) {
        return ke.point(e, i, {
          edge: "start"
        });
      },
      string: function string(e, i) {
        var a,
            n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).voids,
            t = void 0 !== n && n,
            o = ke.range(e, i),
            s = _slicedToArray(Ce.edges(o), 2),
            r = s[0],
            g = s[1],
            l = "",
            f = _createForOfIteratorHelper(ke.nodes(e, {
          at: o,
          match: Me.isText,
          voids: t
        }));

        try {
          for (f.s(); !(a = f.n()).done;) {
            var h = _slicedToArray(a.value, 2),
                m = h[0],
                _ = h[1],
                d = m.text;

            Ee.equals(_, g.path) && (d = d.slice(0, g.offset)), Ee.equals(_, r.path) && (d = d.slice(r.offset)), l += d;
          }
        } catch (c) {
          f.e(c);
        } finally {
          f.f();
        }

        return l;
      },
      unhangRange: function unhangRange(e, i) {
        var a = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).voids,
            n = void 0 !== a && a,
            t = _slicedToArray(Ce.edges(i), 2),
            o = t[0],
            s = t[1];

        if (0 !== o.offset || 0 !== s.offset || Ce.isCollapsed(i)) return i;

        var r,
            g = ke.above(e, {
          at: s,
          match: function match(i) {
            return ke.isBlock(e, i);
          }
        }),
            l = g ? g[1] : [],
            f = {
          anchor: ke.start(e, []),
          focus: s
        },
            h = !0,
            m = _createForOfIteratorHelper(ke.nodes(e, {
          at: f,
          match: Me.isText,
          reverse: !0,
          voids: n
        }));

        try {
          for (m.s(); !(r = m.n()).done;) {
            var _ = _slicedToArray(r.value, 2),
                d = _[0],
                c = _[1];

            if (h) h = !1;else if ("" !== d.text || Ee.isBefore(c, l)) {
              s = {
                path: c,
                offset: d.text.length
              };
              break;
            }
          }
        } catch (F) {
          m.e(F);
        } finally {
          m.f();
        }

        return {
          anchor: o,
          focus: s
        };
      },
      void: function _void(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return ke.above(e, _objectSpread$1(_objectSpread$1({}, i), {}, {
          match: function match(i) {
            return ke.isVoid(e, i);
          }
        }));
      },
      withoutNormalizing: function withoutNormalizing(e, i) {
        var a = ke.isNormalizing(e);
        ae.set(e, !1), i(), ae.set(e, a), ke.normalize(e);
      }
    },
        Ae = {
      isSpan: function isSpan(e) {
        return Array.isArray(e) && 2 === e.length && e.every(Ee.isPath);
      }
    },
        ye = new WeakMap(),
        ve = {
      ancestor: function ancestor(e, i) {
        var a = ve.get(e, i);
        if (Me.isText(a)) throw new Error("Cannot get the ancestor node at path [".concat(i, "] because it refers to a text node instead: ").concat(a));
        return a;
      },
      ancestors: c.a.mark(function ancestors(e, i) {
        var a,
            n,
            t,
            o,
            s,
            r,
            g = arguments;
        return c.a.wrap(function ancestors$(l) {
          for (;;) {
            switch (l.prev = l.next) {
              case 0:
                a = g.length > 2 && void 0 !== g[2] ? g[2] : {}, n = _createForOfIteratorHelper(Ee.ancestors(i, a)), l.prev = 2, n.s();

              case 4:
                if ((t = n.n()).done) {
                  l.next = 12;
                  break;
                }

                return o = t.value, s = ve.ancestor(e, o), r = [s, o], l.next = 10, r;

              case 10:
                l.next = 4;
                break;

              case 12:
                l.next = 17;
                break;

              case 14:
                l.prev = 14, l.t0 = l.catch(2), n.e(l.t0);

              case 17:
                return l.prev = 17, n.f(), l.finish(17);

              case 20:
              case "end":
                return l.stop();
            }
          }
        }, ancestors, null, [[2, 14, 17, 20]]);
      }),
      child: function child(e, i) {
        if (Me.isText(e)) throw new Error("Cannot get the child of a text node: ".concat(JSON.stringify(e)));
        var a = e.children[i];
        if (null == a) throw new Error("Cannot get child at index `".concat(i, "` in node: ").concat(JSON.stringify(e)));
        return a;
      },
      children: c.a.mark(function children(e, i) {
        var a,
            n,
            t,
            o,
            children,
            s,
            r,
            g,
            l = arguments;
        return c.a.wrap(function children$(f) {
          for (;;) {
            switch (f.prev = f.next) {
              case 0:
                a = l.length > 2 && void 0 !== l[2] ? l[2] : {}, n = a.reverse, t = void 0 !== n && n, o = ve.ancestor(e, i), children = o.children, s = t ? children.length - 1 : 0;

              case 5:
                if (!(t ? s >= 0 : s < children.length)) {
                  f.next = 13;
                  break;
                }

                return r = ve.child(o, s), g = i.concat(s), f.next = 10, [r, g];

              case 10:
                s = t ? s - 1 : s + 1, f.next = 5;
                break;

              case 13:
              case "end":
                return f.stop();
            }
          }
        }, children);
      }),
      common: function common(e, i, a) {
        var n = Ee.common(i, a);
        return [ve.get(e, n), n];
      },
      descendant: function descendant(e, i) {
        var a = ve.get(e, i);
        if (ke.isEditor(a)) throw new Error("Cannot get the descendant node at path [".concat(i, "] because it refers to the root editor node instead: ").concat(a));
        return a;
      },
      descendants: c.a.mark(function descendants(e) {
        var i,
            a,
            n,
            t,
            o,
            s,
            r = arguments;
        return c.a.wrap(function descendants$(g) {
          for (;;) {
            switch (g.prev = g.next) {
              case 0:
                i = r.length > 1 && void 0 !== r[1] ? r[1] : {}, a = _createForOfIteratorHelper(ve.nodes(e, i)), g.prev = 2, a.s();

              case 4:
                if ((n = a.n()).done) {
                  g.next = 11;
                  break;
                }

                if (t = _slicedToArray(n.value, 2), o = t[0], 0 === (s = t[1]).length) {
                  g.next = 9;
                  break;
                }

                return g.next = 9, [o, s];

              case 9:
                g.next = 4;
                break;

              case 11:
                g.next = 16;
                break;

              case 13:
                g.prev = 13, g.t0 = g.catch(2), a.e(g.t0);

              case 16:
                return g.prev = 16, a.f(), g.finish(16);

              case 19:
              case "end":
                return g.stop();
            }
          }
        }, descendants, null, [[2, 13, 16, 19]]);
      }),
      elements: c.a.mark(function elements(e) {
        var i,
            a,
            n,
            t,
            o,
            s,
            r = arguments;
        return c.a.wrap(function elements$(g) {
          for (;;) {
            switch (g.prev = g.next) {
              case 0:
                i = r.length > 1 && void 0 !== r[1] ? r[1] : {}, a = _createForOfIteratorHelper(ve.nodes(e, i)), g.prev = 2, a.s();

              case 4:
                if ((n = a.n()).done) {
                  g.next = 11;
                  break;
                }

                if (t = _slicedToArray(n.value, 2), o = t[0], s = t[1], !pe.isElement(o)) {
                  g.next = 9;
                  break;
                }

                return g.next = 9, [o, s];

              case 9:
                g.next = 4;
                break;

              case 11:
                g.next = 16;
                break;

              case 13:
                g.prev = 13, g.t0 = g.catch(2), a.e(g.t0);

              case 16:
                return g.prev = 16, a.f(), g.finish(16);

              case 19:
              case "end":
                return g.stop();
            }
          }
        }, elements, null, [[2, 13, 16, 19]]);
      }),
      extractProps: function extractProps(e) {
        return pe.isAncestor(e) ? _objectWithoutProperties(e, ["children"]) : _objectWithoutProperties(e, ["text"]);
      },
      first: function first(e, i) {
        for (var a = i.slice(), n = ve.get(e, a); n && !Me.isText(n) && 0 !== n.children.length;) {
          n = n.children[0], a.push(0);
        }

        return [n, a];
      },
      fragment: function fragment(e, i) {
        if (Me.isText(e)) throw new Error("Cannot get a fragment starting from a root text node: ".concat(JSON.stringify(e)));
        return J({
          children: e.children
        }, function (e) {
          var a,
              n = _slicedToArray(Ce.edges(i), 2),
              t = n[0],
              o = n[1],
              s = _createForOfIteratorHelper(ve.nodes(e, {
            reverse: !0,
            pass: function pass(e) {
              var a = _slicedToArray(e, 2)[1];

              return !Ce.includes(i, a);
            }
          }));

          try {
            for (s.s(); !(a = s.n()).done;) {
              var r = _slicedToArray(a.value, 2)[1];

              if (!Ce.includes(i, r)) {
                var g = ve.parent(e, r),
                    l = r[r.length - 1];
                g.children.splice(l, 1);
              }

              if (Ee.equals(r, o.path)) {
                var f = ve.leaf(e, r);
                f.text = f.text.slice(0, o.offset);
              }

              if (Ee.equals(r, t.path)) {
                var h = ve.leaf(e, r);
                h.text = h.text.slice(t.offset);
              }
            }
          } catch (m) {
            s.e(m);
          } finally {
            s.f();
          }

          ke.isEditor(e) && (e.selection = null);
        }).children;
      },
      get: function get(e, i) {
        for (var a = e, n = 0; n < i.length; n++) {
          var t = i[n];
          if (Me.isText(a) || !a.children[t]) throw new Error("Cannot find a descendant at path [".concat(i, "] in node: ").concat(JSON.stringify(e)));
          a = a.children[t];
        }

        return a;
      },
      has: function has(e, i) {
        for (var a = e, n = 0; n < i.length; n++) {
          var t = i[n];
          if (Me.isText(a) || !a.children[t]) return !1;
          a = a.children[t];
        }

        return !0;
      },
      isNode: function isNode(e) {
        return Me.isText(e) || pe.isElement(e) || ke.isEditor(e);
      },
      isNodeList: function isNodeList(e) {
        if (!Array.isArray(e)) return !1;
        var i = ye.get(e);
        if (void 0 !== i) return i;
        var isNodeList = e.every(function (e) {
          return ve.isNode(e);
        });
        return ye.set(e, isNodeList), isNodeList;
      },
      last: function last(e, i) {
        for (var a = i.slice(), n = ve.get(e, a); n && !Me.isText(n) && 0 !== n.children.length;) {
          var t = n.children.length - 1;
          n = n.children[t], a.push(t);
        }

        return [n, a];
      },
      leaf: function leaf(e, i) {
        var a = ve.get(e, i);
        if (!Me.isText(a)) throw new Error("Cannot get the leaf node at path [".concat(i, "] because it refers to a non-leaf node: ").concat(a));
        return a;
      },
      levels: c.a.mark(function levels(e, i) {
        var a,
            n,
            t,
            o,
            s,
            r = arguments;
        return c.a.wrap(function levels$(g) {
          for (;;) {
            switch (g.prev = g.next) {
              case 0:
                a = r.length > 2 && void 0 !== r[2] ? r[2] : {}, n = _createForOfIteratorHelper(Ee.levels(i, a)), g.prev = 2, n.s();

              case 4:
                if ((t = n.n()).done) {
                  g.next = 11;
                  break;
                }

                return o = t.value, s = ve.get(e, o), g.next = 9, [s, o];

              case 9:
                g.next = 4;
                break;

              case 11:
                g.next = 16;
                break;

              case 13:
                g.prev = 13, g.t0 = g.catch(2), n.e(g.t0);

              case 16:
                return g.prev = 16, n.f(), g.finish(16);

              case 19:
              case "end":
                return g.stop();
            }
          }
        }, levels, null, [[2, 13, 16, 19]]);
      }),
      matches: function matches(e, i) {
        return pe.isElement(e) && pe.isElementProps(i) && pe.matches(e, i) || Me.isText(e) && Me.isTextProps(i) && Me.matches(e, i);
      },
      nodes: c.a.mark(function nodes(e) {
        var i,
            a,
            n,
            t,
            o,
            s,
            r,
            g,
            l,
            f,
            h,
            m,
            _,
            d = arguments;

        return c.a.wrap(function nodes$(c) {
          for (;;) {
            switch (c.prev = c.next) {
              case 0:
                i = d.length > 1 && void 0 !== d[1] ? d[1] : {}, a = i.pass, n = i.reverse, t = void 0 !== n && n, o = i.from, s = void 0 === o ? [] : o, r = i.to, g = new Set(), l = [], f = e;

              case 6:
                if (!(r && (t ? Ee.isBefore(l, r) : Ee.isAfter(l, r)))) {
                  c.next = 9;
                  break;
                }

                return c.abrupt("break", 37);

              case 9:
                if (g.has(f)) {
                  c.next = 12;
                  break;
                }

                return c.next = 12, [f, l];

              case 12:
                if (g.has(f) || Me.isText(f) || 0 === f.children.length || null != a && !1 !== a([f, l])) {
                  c.next = 19;
                  break;
                }

                return g.add(f), h = t ? f.children.length - 1 : 0, Ee.isAncestor(l, s) && (h = s[l.length]), l = l.concat(h), f = ve.get(e, l), c.abrupt("continue", 6);

              case 19:
                if (0 !== l.length) {
                  c.next = 21;
                  break;
                }

                return c.abrupt("break", 37);

              case 21:
                if (t) {
                  c.next = 27;
                  break;
                }

                if (m = Ee.next(l), !ve.has(e, m)) {
                  c.next = 27;
                  break;
                }

                return l = m, f = ve.get(e, l), c.abrupt("continue", 6);

              case 27:
                if (!t || 0 === l[l.length - 1]) {
                  c.next = 32;
                  break;
                }

                return _ = Ee.previous(l), l = _, f = ve.get(e, l), c.abrupt("continue", 6);

              case 32:
                l = Ee.parent(l), f = ve.get(e, l), g.add(f), c.next = 6;
                break;

              case 37:
              case "end":
                return c.stop();
            }
          }
        }, nodes);
      }),
      parent: function parent(e, i) {
        var a = Ee.parent(i),
            n = ve.get(e, a);
        if (Me.isText(n)) throw new Error("Cannot get the parent of path [".concat(i, "] because it does not exist in the root."));
        return n;
      },
      string: function string(e) {
        return Me.isText(e) ? e.text : e.children.map(ve.string).join("");
      },
      texts: c.a.mark(function texts(e) {
        var i,
            a,
            n,
            t,
            o,
            s,
            r = arguments;
        return c.a.wrap(function texts$(g) {
          for (;;) {
            switch (g.prev = g.next) {
              case 0:
                i = r.length > 1 && void 0 !== r[1] ? r[1] : {}, a = _createForOfIteratorHelper(ve.nodes(e, i)), g.prev = 2, a.s();

              case 4:
                if ((n = a.n()).done) {
                  g.next = 11;
                  break;
                }

                if (t = _slicedToArray(n.value, 2), o = t[0], s = t[1], !Me.isText(o)) {
                  g.next = 9;
                  break;
                }

                return g.next = 9, [o, s];

              case 9:
                g.next = 4;
                break;

              case 11:
                g.next = 16;
                break;

              case 13:
                g.prev = 13, g.t0 = g.catch(2), a.e(g.t0);

              case 16:
                return g.prev = 16, a.f(), g.finish(16);

              case 19:
              case "end":
                return g.stop();
            }
          }
        }, texts, null, [[2, 13, 16, 19]]);
      })
    };

    function ownKeys$2(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread$2(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$2(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var we = {
      isNodeOperation: function isNodeOperation(e) {
        return we.isOperation(e) && e.type.endsWith("_node");
      },
      isOperation: function isOperation(e) {
        if (!m(e)) return !1;

        switch (e.type) {
          case "insert_node":
            return Ee.isPath(e.path) && ve.isNode(e.node);

          case "insert_text":
            return "number" === typeof e.offset && "string" === typeof e.text && Ee.isPath(e.path);

          case "merge_node":
            return "number" === typeof e.position && Ee.isPath(e.path) && m(e.properties);

          case "move_node":
            return Ee.isPath(e.path) && Ee.isPath(e.newPath);

          case "remove_node":
            return Ee.isPath(e.path) && ve.isNode(e.node);

          case "remove_text":
            return "number" === typeof e.offset && "string" === typeof e.text && Ee.isPath(e.path);

          case "set_node":
            return Ee.isPath(e.path) && m(e.properties) && m(e.newProperties);

          case "set_selection":
            return null === e.properties && Ce.isRange(e.newProperties) || null === e.newProperties && Ce.isRange(e.properties) || m(e.properties) && m(e.newProperties);

          case "split_node":
            return Ee.isPath(e.path) && "number" === typeof e.position && m(e.properties);

          default:
            return !1;
        }
      },
      isOperationList: function isOperationList(e) {
        return Array.isArray(e) && e.every(function (e) {
          return we.isOperation(e);
        });
      },
      isSelectionOperation: function isSelectionOperation(e) {
        return we.isOperation(e) && e.type.endsWith("_selection");
      },
      isTextOperation: function isTextOperation(e) {
        return we.isOperation(e) && e.type.endsWith("_text");
      },
      inverse: function inverse(e) {
        switch (e.type) {
          case "insert_node":
            return _objectSpread$2(_objectSpread$2({}, e), {}, {
              type: "remove_node"
            });

          case "insert_text":
            return _objectSpread$2(_objectSpread$2({}, e), {}, {
              type: "remove_text"
            });

          case "merge_node":
            return _objectSpread$2(_objectSpread$2({}, e), {}, {
              type: "split_node",
              path: Ee.previous(e.path)
            });

          case "move_node":
            var i = e.newPath,
                a = e.path;
            if (Ee.equals(i, a)) return e;
            if (Ee.isSibling(a, i)) return _objectSpread$2(_objectSpread$2({}, e), {}, {
              path: i,
              newPath: a
            });
            var n = Ee.transform(a, e),
                t = Ee.transform(Ee.next(a), e);
            return _objectSpread$2(_objectSpread$2({}, e), {}, {
              path: n,
              newPath: t
            });

          case "remove_node":
            return _objectSpread$2(_objectSpread$2({}, e), {}, {
              type: "insert_node"
            });

          case "remove_text":
            return _objectSpread$2(_objectSpread$2({}, e), {}, {
              type: "insert_text"
            });

          case "set_node":
            var o = e.properties,
                s = e.newProperties;
            return _objectSpread$2(_objectSpread$2({}, e), {}, {
              properties: s,
              newProperties: o
            });

          case "set_selection":
            var r = e.properties,
                g = e.newProperties;
            return _objectSpread$2(_objectSpread$2({}, e), {}, null == r ? {
              properties: g,
              newProperties: null
            } : null == g ? {
              properties: null,
              newProperties: r
            } : {
              properties: g,
              newProperties: r
            });

          case "split_node":
            return _objectSpread$2(_objectSpread$2({}, e), {}, {
              type: "merge_node",
              path: Ee.next(e.path)
            });
        }
      }
    },
        Ee = {
      ancestors: function ancestors(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = i.reverse,
            n = void 0 !== a && a,
            t = Ee.levels(e, i);
        return t = n ? t.slice(1) : t.slice(0, -1);
      },
      common: function common(e, i) {
        for (var common = [], a = 0; a < e.length && a < i.length; a++) {
          var n = e[a];
          if (n !== i[a]) break;
          common.push(n);
        }

        return common;
      },
      compare: function compare(e, i) {
        for (var a = Math.min(e.length, i.length), n = 0; n < a; n++) {
          if (e[n] < i[n]) return -1;
          if (e[n] > i[n]) return 1;
        }

        return 0;
      },
      endsAfter: function endsAfter(e, i) {
        var a = e.length - 1,
            n = e.slice(0, a),
            t = i.slice(0, a),
            o = e[a],
            s = i[a];
        return Ee.equals(n, t) && o > s;
      },
      endsAt: function endsAt(e, i) {
        var a = e.length,
            n = e.slice(0, a),
            t = i.slice(0, a);
        return Ee.equals(n, t);
      },
      endsBefore: function endsBefore(e, i) {
        var a = e.length - 1,
            n = e.slice(0, a),
            t = i.slice(0, a),
            o = e[a],
            s = i[a];
        return Ee.equals(n, t) && o < s;
      },
      equals: function equals(e, i) {
        return e.length === i.length && e.every(function (e, a) {
          return e === i[a];
        });
      },
      hasPrevious: function hasPrevious(e) {
        return e[e.length - 1] > 0;
      },
      isAfter: function isAfter(e, i) {
        return 1 === Ee.compare(e, i);
      },
      isAncestor: function isAncestor(e, i) {
        return e.length < i.length && 0 === Ee.compare(e, i);
      },
      isBefore: function isBefore(e, i) {
        return -1 === Ee.compare(e, i);
      },
      isChild: function isChild(e, i) {
        return e.length === i.length + 1 && 0 === Ee.compare(e, i);
      },
      isCommon: function isCommon(e, i) {
        return e.length <= i.length && 0 === Ee.compare(e, i);
      },
      isDescendant: function isDescendant(e, i) {
        return e.length > i.length && 0 === Ee.compare(e, i);
      },
      isParent: function isParent(e, i) {
        return e.length + 1 === i.length && 0 === Ee.compare(e, i);
      },
      isPath: function isPath(e) {
        return Array.isArray(e) && (0 === e.length || "number" === typeof e[0]);
      },
      isSibling: function isSibling(e, i) {
        if (e.length !== i.length) return !1;
        var a = e.slice(0, -1),
            n = i.slice(0, -1);
        return e[e.length - 1] !== i[i.length - 1] && Ee.equals(a, n);
      },
      levels: function levels(e) {
        for (var i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).reverse, a = void 0 !== i && i, n = [], t = 0; t <= e.length; t++) {
          n.push(e.slice(0, t));
        }

        return a && n.reverse(), n;
      },
      next: function next(e) {
        if (0 === e.length) throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
        var i = e[e.length - 1];
        return e.slice(0, -1).concat(i + 1);
      },
      parent: function parent(e) {
        if (0 === e.length) throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
        return e.slice(0, -1);
      },
      previous: function previous(e) {
        if (0 === e.length) throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
        var i = e[e.length - 1];
        if (i <= 0) throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
        return e.slice(0, -1).concat(i - 1);
      },
      relative: function relative(e, i) {
        if (!Ee.isAncestor(i, e) && !Ee.equals(e, i)) throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(i, "], because it is not above or equal to the path."));
        return e.slice(i.length);
      },
      transform: function transform(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return J(e, function (n) {
          var t = a.affinity,
              o = void 0 === t ? "forward" : t;
          if (0 !== e.length) switch (i.type) {
            case "insert_node":
              var s = i.path;
              (Ee.equals(s, n) || Ee.endsBefore(s, n) || Ee.isAncestor(s, n)) && (n[s.length - 1] += 1);
              break;

            case "remove_node":
              var r = i.path;
              if (Ee.equals(r, n) || Ee.isAncestor(r, n)) return null;
              Ee.endsBefore(r, n) && (n[r.length - 1] -= 1);
              break;

            case "merge_node":
              var g = i.path,
                  l = i.position;
              Ee.equals(g, n) || Ee.endsBefore(g, n) ? n[g.length - 1] -= 1 : Ee.isAncestor(g, n) && (n[g.length - 1] -= 1, n[g.length] += l);
              break;

            case "split_node":
              var f = i.path,
                  h = i.position;

              if (Ee.equals(f, n)) {
                if ("forward" === o) n[n.length - 1] += 1;else if ("backward" !== o) return null;
              } else Ee.endsBefore(f, n) ? n[f.length - 1] += 1 : Ee.isAncestor(f, n) && e[f.length] >= h && (n[f.length - 1] += 1, n[f.length] -= h);

              break;

            case "move_node":
              var m = i.path,
                  _ = i.newPath;
              if (Ee.equals(m, _)) return;

              if (Ee.isAncestor(m, n) || Ee.equals(m, n)) {
                var d = _.slice();

                return Ee.endsBefore(m, _) && m.length < _.length && (d[m.length - 1] -= 1), d.concat(n.slice(m.length));
              }

              Ee.isSibling(m, _) && (Ee.isAncestor(_, n) || Ee.equals(_, n)) ? Ee.endsBefore(m, n) ? n[m.length - 1] -= 1 : n[m.length - 1] += 1 : Ee.endsBefore(_, n) || Ee.equals(_, n) || Ee.isAncestor(_, n) ? (Ee.endsBefore(m, n) && (n[m.length - 1] -= 1), n[_.length - 1] += 1) : Ee.endsBefore(m, n) && (Ee.equals(_, n) && (n[_.length - 1] += 1), n[m.length - 1] -= 1);
          }
        });
      }
    },
        je = {
      transform: function transform(e, i) {
        var a = e.current,
            n = e.affinity;

        if (null != a) {
          var t = Ee.transform(a, i, {
            affinity: n
          });
          e.current = t, null == t && e.unref();
        }
      }
    };

    function ownKeys$3(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread$3(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$3(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$3(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var De = {
      compare: function compare(e, i) {
        var a = Ee.compare(e.path, i.path);
        return 0 === a ? e.offset < i.offset ? -1 : e.offset > i.offset ? 1 : 0 : a;
      },
      isAfter: function isAfter(e, i) {
        return 1 === De.compare(e, i);
      },
      isBefore: function isBefore(e, i) {
        return -1 === De.compare(e, i);
      },
      equals: function equals(e, i) {
        return e.offset === i.offset && Ee.equals(e.path, i.path);
      },
      isPoint: function isPoint(e) {
        return m(e) && "number" === typeof e.offset && Ee.isPath(e.path);
      },
      transform: function transform(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return J(e, function (e) {
          var n = a.affinity,
              t = void 0 === n ? "forward" : n,
              o = e.path,
              s = e.offset;

          switch (i.type) {
            case "insert_node":
            case "move_node":
              e.path = Ee.transform(o, i, a);
              break;

            case "insert_text":
              Ee.equals(i.path, o) && i.offset <= s && (e.offset += i.text.length);
              break;

            case "merge_node":
              Ee.equals(i.path, o) && (e.offset += i.position), e.path = Ee.transform(o, i, a);
              break;

            case "remove_text":
              Ee.equals(i.path, o) && i.offset <= s && (e.offset -= Math.min(s - i.offset, i.text.length));
              break;

            case "remove_node":
              if (Ee.equals(i.path, o) || Ee.isAncestor(i.path, o)) return null;
              e.path = Ee.transform(o, i, a);
              break;

            case "split_node":
              if (Ee.equals(i.path, o)) {
                if (i.position === s && null == t) return null;
                (i.position < s || i.position === s && "forward" === t) && (e.offset -= i.position, e.path = Ee.transform(o, i, _objectSpread$3(_objectSpread$3({}, a), {}, {
                  affinity: "forward"
                })));
              } else e.path = Ee.transform(o, i, a);

          }
        });
      }
    },
        xe = {
      transform: function transform(e, i) {
        var a = e.current,
            n = e.affinity;

        if (null != a) {
          var t = De.transform(a, i, {
            affinity: n
          });
          e.current = t, null == t && e.unref();
        }
      }
    };

    function ownKeys$4(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    var Ce = {
      edges: function edges(e) {
        var i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).reverse,
            a = void 0 !== i && i,
            n = e.anchor,
            t = e.focus;
        return Ce.isBackward(e) === a ? [n, t] : [t, n];
      },
      end: function end(e) {
        var end = _slicedToArray(Ce.edges(e), 2)[1];

        return end;
      },
      equals: function equals(e, i) {
        return De.equals(e.anchor, i.anchor) && De.equals(e.focus, i.focus);
      },
      includes: function includes(e, i) {
        if (Ce.isRange(i)) {
          if (Ce.includes(e, i.anchor) || Ce.includes(e, i.focus)) return !0;

          var a = _slicedToArray(Ce.edges(e), 2),
              n = a[0],
              t = a[1],
              o = _slicedToArray(Ce.edges(i), 2),
              s = o[0],
              r = o[1];

          return De.isBefore(n, s) && De.isAfter(t, r);
        }

        var g = _slicedToArray(Ce.edges(e), 2),
            l = g[0],
            f = g[1],
            h = !1,
            m = !1;

        return De.isPoint(i) ? (h = De.compare(i, l) >= 0, m = De.compare(i, f) <= 0) : (h = Ee.compare(i, l.path) >= 0, m = Ee.compare(i, f.path) <= 0), h && m;
      },
      intersection: function intersection(e, i) {
        var a = _objectWithoutProperties(e, ["anchor", "focus"]),
            n = _slicedToArray(Ce.edges(e), 2),
            t = n[0],
            o = n[1],
            s = _slicedToArray(Ce.edges(i), 2),
            r = s[0],
            g = s[1],
            l = De.isBefore(t, r) ? r : t,
            f = De.isBefore(o, g) ? o : g;

        return De.isBefore(f, l) ? null : function _objectSpread$4(e) {
          for (var i = 1; i < arguments.length; i++) {
            var a = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys$4(Object(a), !0).forEach(function (i) {
              index_es_defineProperty(e, i, a[i]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$4(Object(a)).forEach(function (i) {
              Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
            });
          }

          return e;
        }({
          anchor: l,
          focus: f
        }, a);
      },
      isBackward: function isBackward(e) {
        var i = e.anchor,
            a = e.focus;
        return De.isAfter(i, a);
      },
      isCollapsed: function isCollapsed(e) {
        var i = e.anchor,
            a = e.focus;
        return De.equals(i, a);
      },
      isExpanded: function isExpanded(e) {
        return !Ce.isCollapsed(e);
      },
      isForward: function isForward(e) {
        return !Ce.isBackward(e);
      },
      isRange: function isRange(e) {
        return m(e) && De.isPoint(e.anchor) && De.isPoint(e.focus);
      },
      points: c.a.mark(function points(e) {
        return c.a.wrap(function points$(i) {
          for (;;) {
            switch (i.prev = i.next) {
              case 0:
                return i.next = 2, [e.anchor, "anchor"];

              case 2:
                return i.next = 4, [e.focus, "focus"];

              case 4:
              case "end":
                return i.stop();
            }
          }
        }, points);
      }),
      start: function start(e) {
        var start = _slicedToArray(Ce.edges(e), 1)[0];

        return start;
      },
      transform: function transform(e, i) {
        var a,
            n,
            t = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).affinity,
            o = void 0 === t ? "inward" : t;
        return "inward" === o ? Ce.isForward(e) ? (a = "forward", n = "backward") : (a = "backward", n = "forward") : "outward" === o ? Ce.isForward(e) ? (a = "backward", n = "forward") : (a = "forward", n = "backward") : (a = o, n = o), J(e, function (e) {
          var t = De.transform(e.anchor, i, {
            affinity: a
          }),
              o = De.transform(e.focus, i, {
            affinity: n
          });
          if (!t || !o) return null;
          e.anchor = t, e.focus = o;
        });
      }
    },
        Be = {
      transform: function transform(e, i) {
        var a = e.current,
            n = e.affinity;

        if (null != a) {
          var t = Ce.transform(a, i, {
            affinity: n
          });
          e.current = t, null == t && e.unref();
        }
      }
    };

    function ownKeys$5(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread$5(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$5(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$5(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var Me = {
      equals: function equals(e, i) {
        var a = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).loose,
            n = void 0 !== a && a;
        return K()(n ? $()(e, "text") : e, n ? $()(i, "text") : i);
      },
      isText: function isText(e) {
        return m(e) && "string" === typeof e.text;
      },
      isTextList: function isTextList(e) {
        return Array.isArray(e) && e.every(function (e) {
          return Me.isText(e);
        });
      },
      isTextProps: function isTextProps(e) {
        return void 0 !== e.text;
      },
      matches: function matches(e, i) {
        for (var a in i) {
          if ("text" !== a && (!e.hasOwnProperty(a) || e[a] !== i[a])) return !1;
        }

        return !0;
      },
      decorations: function decorations(e, i) {
        var a,
            n = [_objectSpread$5({}, e)],
            t = _createForOfIteratorHelper(i);

        try {
          for (t.s(); !(a = t.n()).done;) {
            var o,
                s = a.value,
                r = _objectWithoutProperties(s, ["anchor", "focus"]),
                g = _slicedToArray(Ce.edges(s), 2),
                l = g[0],
                f = g[1],
                h = [],
                m = 0,
                _ = _createForOfIteratorHelper(n);

            try {
              for (_.s(); !(o = _.n()).done;) {
                var d = o.value,
                    c = d.text.length,
                    F = m;
                if (m += c, l.offset <= F && f.offset >= m) Object.assign(d, r), h.push(d);else if (l.offset !== f.offset && (l.offset === m || f.offset === F) || l.offset > m || f.offset < F || f.offset === F && 0 !== F) h.push(d);else {
                  var u = d,
                      p = void 0,
                      b = void 0;

                  if (f.offset < m) {
                    var k = f.offset - F;
                    b = _objectSpread$5(_objectSpread$5({}, u), {}, {
                      text: u.text.slice(k)
                    }), u = _objectSpread$5(_objectSpread$5({}, u), {}, {
                      text: u.text.slice(0, k)
                    });
                  }

                  if (l.offset > F) {
                    var A = l.offset - F;
                    p = _objectSpread$5(_objectSpread$5({}, u), {}, {
                      text: u.text.slice(0, A)
                    }), u = _objectSpread$5(_objectSpread$5({}, u), {}, {
                      text: u.text.slice(A)
                    });
                  }

                  Object.assign(u, r), p && h.push(p), h.push(u), b && h.push(b);
                }
              }
            } catch (y) {
              _.e(y);
            } finally {
              _.f();
            }

            n = h;
          }
        } catch (y) {
          t.e(y);
        } finally {
          t.f();
        }

        return n;
      }
    };

    function ownKeys$6(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread$6(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$6(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$6(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    function ownKeys$7(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread$7(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$7(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$7(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var qe = {
      insertNodes: function insertNodes(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        ke.withoutNormalizing(e, function () {
          var n = a.hanging,
              t = void 0 !== n && n,
              o = a.voids,
              s = void 0 !== o && o,
              r = a.mode,
              g = void 0 === r ? "lowest" : r,
              l = a.at,
              f = a.match,
              h = a.select;

          if (ve.isNode(i) && (i = [i]), 0 !== i.length) {
            var m = _slicedToArray(i, 1)[0];

            if (l || (l = e.selection ? e.selection : e.children.length > 0 ? ke.end(e, []) : [0], h = !0), null == h && (h = !1), Ce.isRange(l)) if (t || (l = ke.unhangRange(e, l)), Ce.isCollapsed(l)) l = l.anchor;else {
              var _ = _slicedToArray(Ce.edges(l), 2)[1],
                  d = ke.pointRef(e, _);

              Re.delete(e, {
                at: l
              }), l = d.unref();
            }

            if (De.isPoint(l)) {
              null == f && (f = Me.isText(m) ? function match(e) {
                return Me.isText(e);
              } : e.isInline(m) ? function match(i) {
                return Me.isText(i) || ke.isInline(e, i);
              } : function match(i) {
                return ke.isBlock(e, i);
              });

              var c = _slicedToArray(ke.nodes(e, {
                at: l.path,
                match: f,
                mode: g,
                voids: s
              }), 1)[0];

              if (!c) return;

              var F = _slicedToArray(c, 2)[1],
                  u = ke.pathRef(e, F),
                  p = ke.isEnd(e, l, F);

              Re.splitNodes(e, {
                at: l,
                match: f,
                mode: g,
                voids: s
              });
              var b = u.unref();
              l = p ? Ee.next(b) : b;
            }

            var k = Ee.parent(l),
                A = l[l.length - 1];

            if (s || !ke.void(e, {
              at: k
            })) {
              var y,
                  v = _createForOfIteratorHelper(i);

              try {
                for (v.s(); !(y = v.n()).done;) {
                  var w = y.value,
                      E = k.concat(A);
                  A++, e.apply({
                    type: "insert_node",
                    path: E,
                    node: w
                  });
                }
              } catch (D) {
                v.e(D);
              } finally {
                v.f();
              }

              if (h) {
                var j = ke.end(e, l);
                j && Re.select(e, j);
              }
            }
          }
        });
      },
      liftNodes: function liftNodes(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        ke.withoutNormalizing(e, function () {
          var a = i.at,
              n = void 0 === a ? e.selection : a,
              t = i.mode,
              o = void 0 === t ? "lowest" : t,
              s = i.voids,
              r = void 0 !== s && s,
              g = i.match;
          if (null == g && (g = Ee.isPath(n) ? Te(e, n) : function (i) {
            return ke.isBlock(e, i);
          }), n) for (var l = ke.nodes(e, {
            at: n,
            match: g,
            mode: o,
            voids: r
          }), f = 0, h = Array.from(l, function (i) {
            var a = _slicedToArray(i, 2)[1];

            return ke.pathRef(e, a);
          }); f < h.length; f++) {
            var m = h[f].unref();
            if (m.length < 2) throw new Error("Cannot lift node at a path [".concat(m, "] because it has a depth of less than `2`."));

            var _ = _slicedToArray(ke.node(e, Ee.parent(m)), 2),
                d = _[0],
                c = _[1],
                F = m[m.length - 1],
                u = d.children.length;

            if (1 === u) {
              var p = Ee.next(c);
              Re.moveNodes(e, {
                at: m,
                to: p,
                voids: r
              }), Re.removeNodes(e, {
                at: c,
                voids: r
              });
            } else if (0 === F) Re.moveNodes(e, {
              at: m,
              to: c,
              voids: r
            });else if (F === u - 1) {
              var b = Ee.next(c);
              Re.moveNodes(e, {
                at: m,
                to: b,
                voids: r
              });
            } else {
              var k = Ee.next(m),
                  A = Ee.next(c);
              Re.splitNodes(e, {
                at: k,
                voids: r
              }), Re.moveNodes(e, {
                at: m,
                to: A,
                voids: r
              });
            }
          }
        });
      },
      mergeNodes: function mergeNodes(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        ke.withoutNormalizing(e, function () {
          var a = i.match,
              n = i.at,
              t = void 0 === n ? e.selection : n,
              o = i.hanging,
              s = void 0 !== o && o,
              r = i.voids,
              g = void 0 !== r && r,
              l = i.mode,
              f = void 0 === l ? "lowest" : l;

          if (t) {
            if (null == a) if (Ee.isPath(t)) {
              var h = _slicedToArray(ke.parent(e, t), 1)[0];

              a = function match(e) {
                return h.children.includes(e);
              };
            } else a = function match(i) {
              return ke.isBlock(e, i);
            };
            if (!s && Ce.isRange(t) && (t = ke.unhangRange(e, t)), Ce.isRange(t)) if (Ce.isCollapsed(t)) t = t.anchor;else {
              var m = _slicedToArray(Ce.edges(t), 2)[1],
                  _ = ke.pointRef(e, m);

              Re.delete(e, {
                at: t
              }), t = _.unref(), null == i.at && Re.select(e, t);
            }

            var d = _slicedToArray(ke.nodes(e, {
              at: t,
              match: a,
              voids: g,
              mode: f
            }), 1)[0],
                c = ke.previous(e, {
              at: t,
              match: a,
              voids: g,
              mode: f
            });

            if (d && c) {
              var F = _slicedToArray(d, 2),
                  u = F[0],
                  p = F[1],
                  b = _slicedToArray(c, 2),
                  k = b[0],
                  A = b[1];

              if (0 !== p.length && 0 !== A.length) {
                var y,
                    v,
                    w = Ee.next(A),
                    E = Ee.common(p, A),
                    j = Ee.isSibling(p, A),
                    D = Array.from(ke.levels(e, {
                  at: p
                }), function (e) {
                  return _slicedToArray(e, 1)[0];
                }).slice(E.length).slice(0, -1),
                    x = ke.above(e, {
                  at: p,
                  mode: "highest",
                  match: function match(i) {
                    return D.includes(i) && Pe(e, i);
                  }
                }),
                    C = x && ke.pathRef(e, x[1]);

                if (Me.isText(u) && Me.isText(k)) {
                  var B = _objectWithoutProperties(u, ["text"]);

                  v = k.text.length, y = B;
                } else {
                  if (!pe.isElement(u) || !pe.isElement(k)) throw new Error("Cannot merge the node at path [".concat(p, "] with the previous sibling because it is not the same kind: ").concat(JSON.stringify(u), " ").concat(JSON.stringify(k)));
                  B = _objectWithoutProperties(u, ["children"]);
                  v = k.children.length, y = B;
                }

                j || Re.moveNodes(e, {
                  at: p,
                  to: w,
                  voids: g
                }), C && Re.removeNodes(e, {
                  at: C.current,
                  voids: g
                }), pe.isElement(k) && ke.isEmpty(e, k) || Me.isText(k) && "" === k.text ? Re.removeNodes(e, {
                  at: A,
                  voids: g
                }) : e.apply({
                  type: "merge_node",
                  path: w,
                  position: v,
                  properties: y
                }), C && C.unref();
              }
            }
          }
        });
      },
      moveNodes: function moveNodes(e, i) {
        ke.withoutNormalizing(e, function () {
          var a = i.to,
              n = i.at,
              t = void 0 === n ? e.selection : n,
              o = i.mode,
              s = void 0 === o ? "lowest" : o,
              r = i.voids,
              g = void 0 !== r && r,
              l = i.match;

          if (t) {
            null == l && (l = Ee.isPath(t) ? Te(e, t) : function (i) {
              return ke.isBlock(e, i);
            });

            for (var f = ke.pathRef(e, a), h = ke.nodes(e, {
              at: t,
              match: l,
              mode: s,
              voids: g
            }), m = 0, _ = Array.from(h, function (i) {
              var a = _slicedToArray(i, 2)[1];

              return ke.pathRef(e, a);
            }); m < _.length; m++) {
              var d = _[m].unref(),
                  c = f.current;

              0 !== d.length && e.apply({
                type: "move_node",
                path: d,
                newPath: c
              }), f.current && Ee.isSibling(c, d) && Ee.isAfter(c, d) && (f.current = Ee.next(f.current));
            }

            f.unref();
          }
        });
      },
      removeNodes: function removeNodes(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        ke.withoutNormalizing(e, function () {
          var a = i.hanging,
              n = void 0 !== a && a,
              t = i.voids,
              o = void 0 !== t && t,
              s = i.mode,
              r = void 0 === s ? "lowest" : s,
              g = i.at,
              l = void 0 === g ? e.selection : g,
              f = i.match;

          if (l) {
            null == f && (f = Ee.isPath(l) ? Te(e, l) : function (i) {
              return ke.isBlock(e, i);
            }), !n && Ce.isRange(l) && (l = ke.unhangRange(e, l));

            for (var h = ke.nodes(e, {
              at: l,
              match: f,
              mode: r,
              voids: o
            }), m = 0, _ = Array.from(h, function (i) {
              var a = _slicedToArray(i, 2)[1];

              return ke.pathRef(e, a);
            }); m < _.length; m++) {
              var d = _[m].unref();

              if (d) {
                var c = _slicedToArray(ke.node(e, d), 1)[0];

                e.apply({
                  type: "remove_node",
                  path: d,
                  node: c
                });
              }
            }
          }
        });
      },
      setNodes: function setNodes(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        ke.withoutNormalizing(e, function () {
          var n = a.match,
              t = a.at,
              o = void 0 === t ? e.selection : t,
              s = a.hanging,
              r = void 0 !== s && s,
              g = a.mode,
              l = void 0 === g ? "lowest" : g,
              f = a.split,
              h = void 0 !== f && f,
              m = a.voids,
              _ = void 0 !== m && m;

          if (o) {
            if (null == n && (n = Ee.isPath(o) ? Te(e, o) : function (i) {
              return ke.isBlock(e, i);
            }), !r && Ce.isRange(o) && (o = ke.unhangRange(e, o)), h && Ce.isRange(o)) {
              var d = ke.rangeRef(e, o, {
                affinity: "inward"
              }),
                  c = _slicedToArray(Ce.edges(o), 2),
                  F = c[0],
                  u = c[1],
                  p = "lowest" === l ? "lowest" : "highest",
                  b = ke.isEnd(e, u, u.path);

              Re.splitNodes(e, {
                at: u,
                match: n,
                mode: p,
                voids: _,
                always: !b
              });
              var k = ke.isStart(e, F, F.path);
              Re.splitNodes(e, {
                at: F,
                match: n,
                mode: p,
                voids: _,
                always: !k
              }), o = d.unref(), null == a.at && Re.select(e, o);
            }

            var A,
                y = _createForOfIteratorHelper(ke.nodes(e, {
              at: o,
              match: n,
              mode: l,
              voids: _
            }));

            try {
              for (y.s(); !(A = y.n()).done;) {
                var v = _slicedToArray(A.value, 2),
                    w = v[0],
                    E = v[1],
                    j = {},
                    D = {};

                if (0 !== E.length) {
                  for (var x in i) {
                    "children" !== x && "text" !== x && i[x] !== w[x] && (w.hasOwnProperty(x) && (j[x] = w[x]), D[x] = i[x]);
                  }

                  0 !== Object.keys(D).length && e.apply({
                    type: "set_node",
                    path: E,
                    properties: j,
                    newProperties: D
                  });
                }
              }
            } catch (C) {
              y.e(C);
            } finally {
              y.f();
            }
          }
        });
      },
      splitNodes: function splitNodes(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        ke.withoutNormalizing(e, function () {
          var a = i.mode,
              n = void 0 === a ? "lowest" : a,
              t = i.voids,
              o = void 0 !== t && t,
              s = i.match,
              r = i.at,
              g = void 0 === r ? e.selection : r,
              l = i.height,
              f = void 0 === l ? 0 : l,
              h = i.always,
              m = void 0 !== h && h;

          if (null == s && (s = function match(i) {
            return ke.isBlock(e, i);
          }), Ce.isRange(g) && (g = Oe(e, g)), Ee.isPath(g)) {
            var _ = g,
                d = ke.point(e, _),
                c = _slicedToArray(ke.parent(e, _), 1)[0];

            s = function match(e) {
              return e === c;
            }, f = d.path.length - _.length + 1, g = d, m = !0;
          }

          if (g) {
            var F = ke.pointRef(e, g, {
              affinity: "backward"
            }),
                u = _slicedToArray(ke.nodes(e, {
              at: g,
              match: s,
              mode: n,
              voids: o
            }), 1)[0];

            if (u) {
              var p = ke.void(e, {
                at: g,
                mode: "highest"
              });

              if (!o && p) {
                var b = _slicedToArray(p, 2),
                    k = b[0],
                    A = b[1];

                if (pe.isElement(k) && e.isInline(k)) {
                  var y = ke.after(e, A);

                  if (!y) {
                    var v = Ee.next(A);
                    Re.insertNodes(e, {
                      text: ""
                    }, {
                      at: v,
                      voids: o
                    }), y = ke.point(e, v);
                  }

                  g = y, m = !0;
                }

                f = g.path.length - A.length + 1, m = !0;
              }

              var w,
                  E = ke.pointRef(e, g),
                  j = g.path.length - f,
                  D = _slicedToArray(u, 2)[1],
                  x = g.path.slice(0, j),
                  C = 0 === f ? g.offset : g.path[j] + 0,
                  B = _createForOfIteratorHelper(ke.levels(e, {
                at: x,
                reverse: !0,
                voids: o
              }));

              try {
                for (B.s(); !(w = B.n()).done;) {
                  var M = _slicedToArray(w.value, 2),
                      q = M[0],
                      P = M[1],
                      O = !1;

                  if (P.length < D.length || 0 === P.length || !o && ke.isVoid(e, q)) break;
                  var T = F.current,
                      S = ke.isEnd(e, T, P);

                  if (m || !F || !ke.isEdge(e, T, P)) {
                    O = !0;
                    var z = ve.extractProps(q);
                    e.apply({
                      type: "split_node",
                      path: P,
                      position: C,
                      properties: z
                    });
                  }

                  C = P[P.length - 1] + (O || S ? 1 : 0);
                }
              } catch (H) {
                B.e(H);
              } finally {
                B.f();
              }

              if (null == i.at) {
                var R = E.current || ke.end(e, []);
                Re.select(e, R);
              }

              F.unref(), E.unref();
            }
          }
        });
      },
      unsetNodes: function unsetNodes(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        Array.isArray(i) || (i = [i]);

        var n,
            t = {},
            o = _createForOfIteratorHelper(i);

        try {
          for (o.s(); !(n = o.n()).done;) {
            t[n.value] = null;
          }
        } catch (s) {
          o.e(s);
        } finally {
          o.f();
        }

        Re.setNodes(e, t, a);
      },
      unwrapNodes: function unwrapNodes(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        ke.withoutNormalizing(e, function () {
          var a = i.mode,
              n = void 0 === a ? "lowest" : a,
              t = i.split,
              o = void 0 !== t && t,
              s = i.voids,
              r = void 0 !== s && s,
              g = i.at,
              l = void 0 === g ? e.selection : g,
              f = i.match;

          if (l) {
            null == f && (f = Ee.isPath(l) ? Te(e, l) : function (i) {
              return ke.isBlock(e, i);
            }), Ee.isPath(l) && (l = ke.range(e, l));

            for (var h = Ce.isRange(l) ? ke.rangeRef(e, l) : null, m = ke.nodes(e, {
              at: l,
              match: f,
              mode: n,
              voids: r
            }), _ = function _loop(i) {
              var a = i.unref(),
                  n = _slicedToArray(ke.node(e, a), 1)[0],
                  t = ke.range(e, a);

              o && h && (t = Ce.intersection(h.current, t)), Re.liftNodes(e, {
                at: t,
                match: function match(e) {
                  return pe.isAncestor(n) && n.children.includes(e);
                },
                voids: r
              });
            }, d = 0, c = Array.from(m, function (i) {
              var a = _slicedToArray(i, 2)[1];

              return ke.pathRef(e, a);
            }); d < c.length; d++) {
              _(c[d]);
            }

            h && h.unref();
          }
        });
      },
      wrapNodes: function wrapNodes(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        ke.withoutNormalizing(e, function () {
          var n = a.mode,
              t = void 0 === n ? "lowest" : n,
              o = a.split,
              s = void 0 !== o && o,
              r = a.voids,
              g = void 0 !== r && r,
              l = a.match,
              f = a.at,
              h = void 0 === f ? e.selection : f;

          if (h) {
            if (null == l && (l = Ee.isPath(h) ? Te(e, h) : e.isInline(i) ? function match(i) {
              return ke.isInline(e, i) || Me.isText(i);
            } : function match(i) {
              return ke.isBlock(e, i);
            }), s && Ce.isRange(h)) {
              var m = _slicedToArray(Ce.edges(h), 2),
                  _ = m[0],
                  d = m[1],
                  c = ke.rangeRef(e, h, {
                affinity: "inward"
              });

              Re.splitNodes(e, {
                at: d,
                match: l,
                voids: g
              }), Re.splitNodes(e, {
                at: _,
                match: l,
                voids: g
              }), h = c.unref(), null == a.at && Re.select(e, h);
            }

            for (var F = 0, u = Array.from(ke.nodes(e, {
              at: h,
              match: e.isInline(i) ? function (i) {
                return ke.isBlock(e, i);
              } : function (e) {
                return ke.isEditor(e);
              },
              mode: "lowest",
              voids: g
            })); F < u.length; F++) {
              var p = _slicedToArray(u[F], 2)[1],
                  b = Ce.isRange(h) ? Ce.intersection(h, ke.range(e, p)) : h;

              if (b) {
                var k = Array.from(ke.nodes(e, {
                  at: b,
                  match: l,
                  mode: t,
                  voids: g
                }));
                k.length > 0 && function () {
                  var a = _slicedToArray(k, 1)[0],
                      n = k[k.length - 1],
                      t = _slicedToArray(a, 2)[1],
                      o = _slicedToArray(n, 2)[1],
                      s = Ee.equals(t, o) ? Ee.parent(t) : Ee.common(t, o),
                      r = ke.range(e, t, o),
                      l = _slicedToArray(ke.node(e, s), 1)[0],
                      f = s.length + 1,
                      h = Ee.next(o.slice(0, f)),
                      m = _objectSpread$7(_objectSpread$7({}, i), {}, {
                    children: []
                  });

                  Re.insertNodes(e, m, {
                    at: h,
                    voids: g
                  }), Re.moveNodes(e, {
                    at: r,
                    match: function match(e) {
                      return pe.isAncestor(l) && l.children.includes(e);
                    },
                    to: h.concat(0),
                    voids: g
                  });
                }();
              }
            }
          }
        });
      }
    },
        Pe = function hasSingleChildNest(e, i) {
      if (pe.isElement(i)) {
        var a = i;
        return !!ke.isVoid(e, i) || 1 === a.children.length && hasSingleChildNest(e, a.children[0]);
      }

      return !ke.isEditor(i);
    },
        Oe = function deleteRange(e, i) {
      if (Ce.isCollapsed(i)) return i.anchor;

      var a = _slicedToArray(Ce.edges(i), 2)[1],
          n = ke.pointRef(e, a);

      return Re.delete(e, {
        at: i
      }), n.unref();
    },
        Te = function matchPath(e, i) {
      var a = _slicedToArray(ke.node(e, i), 1)[0];

      return function (e) {
        return e === a;
      };
    };

    function ownKeys$8(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread$8(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$8(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$8(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var Se = {
      collapse: function collapse(e) {
        var i = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).edge,
            a = void 0 === i ? "anchor" : i,
            n = e.selection;
        if (n) if ("anchor" === a) Re.select(e, n.anchor);else if ("focus" === a) Re.select(e, n.focus);else if ("start" === a) {
          var t = _slicedToArray(Ce.edges(n), 1)[0];

          Re.select(e, t);
        } else if ("end" === a) {
          var o = _slicedToArray(Ce.edges(n), 2)[1];

          Re.select(e, o);
        }
      },
      deselect: function deselect(e) {
        var i = e.selection;
        i && e.apply({
          type: "set_selection",
          properties: i,
          newProperties: null
        });
      },
      move: function move(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = e.selection,
            n = i.distance,
            t = void 0 === n ? 1 : n,
            o = i.unit,
            s = void 0 === o ? "character" : o,
            r = i.reverse,
            g = void 0 !== r && r,
            l = i.edge,
            f = void 0 === l ? null : l;

        if (a) {
          "start" === f && (f = Ce.isBackward(a) ? "focus" : "anchor"), "end" === f && (f = Ce.isBackward(a) ? "anchor" : "focus");
          var h = a.anchor,
              m = a.focus,
              _ = {
            distance: t,
            unit: s
          },
              d = {};

          if (null == f || "anchor" === f) {
            var c = g ? ke.before(e, h, _) : ke.after(e, h, _);
            c && (d.anchor = c);
          }

          if (null == f || "focus" === f) {
            var F = g ? ke.before(e, m, _) : ke.after(e, m, _);
            F && (d.focus = F);
          }

          Re.setSelection(e, d);
        }
      },
      select: function select(e, i) {
        var a = e.selection;
        if (i = ke.range(e, i), a) Re.setSelection(e, i);else {
          if (!Ce.isRange(i)) throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(JSON.stringify(i)));
          e.apply({
            type: "set_selection",
            properties: a,
            newProperties: i
          });
        }
      },
      setPoint: function setPoint(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = e.selection,
            t = a.edge,
            o = void 0 === t ? "both" : t;

        if (n) {
          "start" === o && (o = Ce.isBackward(n) ? "focus" : "anchor"), "end" === o && (o = Ce.isBackward(n) ? "anchor" : "focus");
          var s = n.anchor,
              r = n.focus,
              g = "anchor" === o ? s : r;
          Re.setSelection(e, _defineProperty({}, "anchor" === o ? "anchor" : "focus", _objectSpread$8(_objectSpread$8({}, g), i)));
        }
      },
      setSelection: function setSelection(e, i) {
        var a = e.selection,
            n = {},
            t = {};

        if (a) {
          for (var o in i) {
            ("anchor" === o && null != i.anchor && !De.equals(i.anchor, a.anchor) || "focus" === o && null != i.focus && !De.equals(i.focus, a.focus) || "anchor" !== o && "focus" !== o && i[o] !== a[o]) && (n[o] = a[o], t[o] = i[o]);
          }

          Object.keys(n).length > 0 && e.apply({
            type: "set_selection",
            properties: n,
            newProperties: t
          });
        }
      }
    },
        ze = {
      delete: function _delete(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        ke.withoutNormalizing(e, function () {
          var a = i.reverse,
              n = void 0 !== a && a,
              t = i.unit,
              o = void 0 === t ? "character" : t,
              s = i.distance,
              r = void 0 === s ? 1 : s,
              g = i.voids,
              l = void 0 !== g && g,
              f = i.at,
              h = void 0 === f ? e.selection : f,
              m = i.hanging,
              _ = void 0 !== m && m;

          if (h) {
            if (Ce.isRange(h) && Ce.isCollapsed(h) && (h = h.anchor), De.isPoint(h)) {
              var d = ke.void(e, {
                at: h,
                mode: "highest"
              });

              if (!l && d) {
                h = _slicedToArray(d, 2)[1];
              } else {
                var c = {
                  unit: o,
                  distance: r
                };
                h = {
                  anchor: h,
                  focus: n ? ke.before(e, h, c) || ke.start(e, []) : ke.after(e, h, c) || ke.end(e, [])
                }, _ = !0;
              }
            }

            if (Ee.isPath(h)) Re.removeNodes(e, {
              at: h,
              voids: l
            });else if (!Ce.isCollapsed(h)) {
              if (!_) {
                var F = _slicedToArray(Ce.edges(h), 2)[1],
                    u = ke.end(e, []);

                De.equals(F, u) || (h = ke.unhangRange(e, h, {
                  voids: l
                }));
              }

              var p = _slicedToArray(Ce.edges(h), 2),
                  b = p[0],
                  k = p[1],
                  A = ke.above(e, {
                match: function match(i) {
                  return ke.isBlock(e, i);
                },
                at: b,
                voids: l
              }),
                  y = ke.above(e, {
                match: function match(i) {
                  return ke.isBlock(e, i);
                },
                at: k,
                voids: l
              }),
                  v = A && y && !Ee.equals(A[1], y[1]),
                  w = Ee.equals(b.path, k.path),
                  E = l ? null : ke.void(e, {
                at: b,
                mode: "highest"
              }),
                  j = l ? null : ke.void(e, {
                at: k,
                mode: "highest"
              });

              if (E) {
                var D = ke.before(e, b);
                D && A && Ee.isAncestor(A[1], D.path) && (b = D);
              }

              if (j) {
                var x = ke.after(e, k);
                x && y && Ee.isAncestor(y[1], x.path) && (k = x);
              }

              var C,
                  B,
                  M = [],
                  q = _createForOfIteratorHelper(ke.nodes(e, {
                at: h,
                voids: l
              }));

              try {
                for (q.s(); !(B = q.n()).done;) {
                  var P = B.value,
                      O = _slicedToArray(P, 2),
                      T = O[0],
                      S = O[1];

                  C && 0 === Ee.compare(S, C) || (!l && ke.isVoid(e, T) || !Ee.isCommon(S, b.path) && !Ee.isCommon(S, k.path)) && (M.push(P), C = S);
                }
              } catch (ee) {
                q.e(ee);
              } finally {
                q.f();
              }

              var z = Array.from(M, function (i) {
                var a = _slicedToArray(i, 2)[1];

                return ke.pathRef(e, a);
              }),
                  R = ke.pointRef(e, b),
                  H = ke.pointRef(e, k);

              if (!w && !E) {
                var L = R.current,
                    X = _slicedToArray(ke.leaf(e, L), 1)[0],
                    N = L.path,
                    Z = b.offset,
                    W = X.text.slice(Z);

                W.length > 0 && e.apply({
                  type: "remove_text",
                  path: N,
                  offset: Z,
                  text: W
                });
              }

              for (var Y = 0, I = z; Y < I.length; Y++) {
                var J = I[Y].unref();
                Re.removeNodes(e, {
                  at: J,
                  voids: l
                });
              }

              if (!j) {
                var U = H.current,
                    G = _slicedToArray(ke.leaf(e, U), 1)[0],
                    V = U.path,
                    K = w ? b.offset : 0,
                    Q = G.text.slice(K, k.offset);

                Q.length > 0 && e.apply({
                  type: "remove_text",
                  path: V,
                  offset: K,
                  text: Q
                });
              }

              !w && v && H.current && R.current && Re.mergeNodes(e, {
                at: H.current,
                hanging: !0,
                voids: l
              });
              var $ = n ? R.unref() || H.unref() : H.unref() || R.unref();
              null == i.at && $ && Re.select(e, $);
            }
          }
        });
      },
      insertFragment: function insertFragment(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        ke.withoutNormalizing(e, function () {
          var n = a.hanging,
              t = void 0 !== n && n,
              o = a.voids,
              s = void 0 !== o && o,
              r = a.at,
              g = void 0 === r ? e.selection : r;

          if (i.length && g) {
            if (Ce.isRange(g)) {
              if (t || (g = ke.unhangRange(e, g)), Ce.isCollapsed(g)) g = g.anchor;else {
                var l = _slicedToArray(Ce.edges(g), 2)[1];

                if (!s && ke.void(e, {
                  at: l
                })) return;
                var f = ke.pointRef(e, l);
                Re.delete(e, {
                  at: g
                }), g = f.unref();
              }
            } else Ee.isPath(g) && (g = ke.start(e, g));

            if (s || !ke.void(e, {
              at: g
            })) {
              var h = ke.above(e, {
                at: g,
                match: function match(i) {
                  return ke.isInline(e, i);
                },
                mode: "highest",
                voids: s
              });

              if (h) {
                var m = _slicedToArray(h, 2)[1];

                if (ke.isEnd(e, g, m)) g = ke.after(e, m);else if (ke.isStart(e, g, m)) {
                  g = ke.before(e, m);
                }
              }

              var _,
                  d = _slicedToArray(ke.above(e, {
                match: function match(i) {
                  return ke.isBlock(e, i);
                },
                at: g,
                voids: s
              }), 2)[1],
                  c = ke.isStart(e, g, d),
                  F = ke.isEnd(e, g, d),
                  u = !c || c && F,
                  p = !F,
                  b = _slicedToArray(ve.first({
                children: i
              }, []), 2)[1],
                  k = _slicedToArray(ve.last({
                children: i
              }, []), 2)[1],
                  A = [],
                  y = function matcher(i) {
                var a = _slicedToArray(i, 2),
                    n = a[0],
                    t = a[1];

                return !(u && Ee.isAncestor(t, b) && pe.isElement(n) && !e.isVoid(n) && !e.isInline(n)) && !(p && Ee.isAncestor(t, k) && pe.isElement(n) && !e.isVoid(n) && !e.isInline(n));
              },
                  v = _createForOfIteratorHelper(ve.nodes({
                children: i
              }, {
                pass: y
              }));

              try {
                for (v.s(); !(_ = v.n()).done;) {
                  var w = _.value;
                  w[1].length > 0 && y(w) && A.push(w);
                }
              } catch (N) {
                v.e(N);
              } finally {
                v.f();
              }

              for (var E = [], j = [], D = [], x = !0, C = !1, B = 0, M = A; B < M.length; B++) {
                var q = _slicedToArray(M[B], 1)[0];

                pe.isElement(q) && !e.isInline(q) ? (x = !1, C = !0, j.push(q)) : x ? E.push(q) : D.push(q);
              }

              var P = _slicedToArray(ke.nodes(e, {
                at: g,
                match: function match(i) {
                  return Me.isText(i) || ke.isInline(e, i);
                },
                mode: "highest",
                voids: s
              }), 1),
                  O = _slicedToArray(P[0], 2)[1],
                  T = ke.isStart(e, g, O),
                  S = ke.isEnd(e, g, O),
                  z = ke.pathRef(e, F ? Ee.next(d) : d),
                  R = ke.pathRef(e, S ? Ee.next(O) : O);

              Re.splitNodes(e, {
                at: g,
                match: function match(i) {
                  return C ? ke.isBlock(e, i) : Me.isText(i) || ke.isInline(e, i);
                },
                mode: C ? "lowest" : "highest",
                voids: s
              });
              var H = ke.pathRef(e, !T || T && S ? Ee.next(O) : O);

              if (Re.insertNodes(e, E, {
                at: H.current,
                match: function match(i) {
                  return Me.isText(i) || ke.isInline(e, i);
                },
                mode: "highest",
                voids: s
              }), Re.insertNodes(e, j, {
                at: z.current,
                match: function match(i) {
                  return ke.isBlock(e, i);
                },
                mode: "lowest",
                voids: s
              }), Re.insertNodes(e, D, {
                at: R.current,
                match: function match(i) {
                  return Me.isText(i) || ke.isInline(e, i);
                },
                mode: "highest",
                voids: s
              }), !a.at) {
                var L;
                L = D.length > 0 ? Ee.previous(R.current) : j.length > 0 ? Ee.previous(z.current) : Ee.previous(H.current);
                var X = ke.end(e, L);
                Re.select(e, X);
              }

              H.unref(), z.unref(), R.unref();
            }
          }
        });
      },
      insertText: function insertText(e, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        ke.withoutNormalizing(e, function () {
          var n = a.voids,
              t = void 0 !== n && n,
              o = a.at,
              s = void 0 === o ? e.selection : o;

          if (s) {
            if (Ee.isPath(s) && (s = ke.range(e, s)), Ce.isRange(s)) if (Ce.isCollapsed(s)) s = s.anchor;else {
              var r = Ce.end(s);
              if (!t && ke.void(e, {
                at: r
              })) return;
              var g = ke.pointRef(e, r);
              Re.delete(e, {
                at: s,
                voids: t
              }), s = g.unref(), Re.setSelection(e, {
                anchor: s,
                focus: s
              });
            }

            if (t || !ke.void(e, {
              at: s
            })) {
              var l = s,
                  f = l.path,
                  h = l.offset;
              i.length > 0 && e.apply({
                type: "insert_text",
                path: f,
                offset: h,
                text: i
              });
            }
          }
        });
      }
    };

    function ownKeys$9(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread$9(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$9(Object(a), !0).forEach(function (i) {
          index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ownKeys$9(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var Re = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, {
      transform: function transform(e, i) {
        e.children = U(e.children);
        var a = e.selection && U(e.selection);

        switch (i.type) {
          case "insert_node":
            var n = i.path,
                t = i.node,
                o = ve.parent(e, n),
                s = n[n.length - 1];

            if (o.children.splice(s, 0, t), a) {
              var r,
                  g = _createForOfIteratorHelper(Ce.points(a));

              try {
                for (g.s(); !(r = g.n()).done;) {
                  var l = _slicedToArray(r.value, 2),
                      f = l[0];

                  a[l[1]] = De.transform(f, i);
                }
              } catch (Je) {
                g.e(Je);
              } finally {
                g.f();
              }
            }

            break;

          case "insert_text":
            var h = i.path,
                m = i.offset,
                _ = i.text;
            if (0 === _.length) break;
            var d = ve.leaf(e, h),
                c = d.text.slice(0, m),
                F = d.text.slice(m);

            if (d.text = c + _ + F, a) {
              var u,
                  p = _createForOfIteratorHelper(Ce.points(a));

              try {
                for (p.s(); !(u = p.n()).done;) {
                  var b = _slicedToArray(u.value, 2),
                      k = b[0];

                  a[b[1]] = De.transform(k, i);
                }
              } catch (Je) {
                p.e(Je);
              } finally {
                p.f();
              }
            }

            break;

          case "merge_node":
            var A = i.path,
                y = ve.get(e, A),
                v = Ee.previous(A),
                w = ve.get(e, v),
                E = ve.parent(e, A),
                j = A[A.length - 1];
            if (Me.isText(y) && Me.isText(w)) w.text += y.text;else {
              if (Me.isText(y) || Me.isText(w)) throw new Error('Cannot apply a "merge_node" operation at path ['.concat(A, "] to nodes of different interfaces: ").concat(y, " ").concat(w));
              var D;
              (D = w.children).push.apply(D, _toConsumableArray(y.children));
            }

            if (E.children.splice(j, 1), a) {
              var x,
                  C = _createForOfIteratorHelper(Ce.points(a));

              try {
                for (C.s(); !(x = C.n()).done;) {
                  var B = _slicedToArray(x.value, 2),
                      M = B[0];

                  a[B[1]] = De.transform(M, i);
                }
              } catch (Je) {
                C.e(Je);
              } finally {
                C.f();
              }
            }

            break;

          case "move_node":
            var q = i.path,
                P = i.newPath;
            if (Ee.isAncestor(q, P)) throw new Error("Cannot move a path [".concat(q, "] to new path [").concat(P, "] because the destination is inside itself."));
            var O = ve.get(e, q),
                T = ve.parent(e, q),
                S = q[q.length - 1];
            T.children.splice(S, 1);
            var z = Ee.transform(q, i),
                R = ve.get(e, Ee.parent(z)),
                H = z[z.length - 1];

            if (R.children.splice(H, 0, O), a) {
              var L,
                  X = _createForOfIteratorHelper(Ce.points(a));

              try {
                for (X.s(); !(L = X.n()).done;) {
                  var N = _slicedToArray(L.value, 2),
                      Z = N[0];

                  a[N[1]] = De.transform(Z, i);
                }
              } catch (Je) {
                X.e(Je);
              } finally {
                X.f();
              }
            }

            break;

          case "remove_node":
            var W = i.path,
                Y = W[W.length - 1];

            if (ve.parent(e, W).children.splice(Y, 1), a) {
              var I,
                  J = _createForOfIteratorHelper(Ce.points(a));

              try {
                for (J.s(); !(I = J.n()).done;) {
                  var V = _slicedToArray(I.value, 2),
                      K = V[0],
                      Q = V[1],
                      $ = De.transform(K, i);

                  if (null != a && null != $) a[Q] = $;else {
                    var ee,
                        ie = void 0,
                        ae = void 0,
                        ne = _createForOfIteratorHelper(ve.texts(e));

                    try {
                      for (ne.s(); !(ee = ne.n()).done;) {
                        var te = _slicedToArray(ee.value, 2),
                            oe = te[0],
                            se = te[1];

                        if (-1 !== Ee.compare(se, W)) {
                          ae = [oe, se];
                          break;
                        }

                        ie = [oe, se];
                      }
                    } catch (Je) {
                      ne.e(Je);
                    } finally {
                      ne.f();
                    }

                    ie ? (K.path = ie[1], K.offset = ie[0].text.length) : ae ? (K.path = ae[1], K.offset = 0) : a = null;
                  }
                }
              } catch (Je) {
                J.e(Je);
              } finally {
                J.f();
              }
            }

            break;

          case "remove_text":
            var re = i.path,
                ge = i.offset,
                le = i.text;
            if (0 === le.length) break;
            var fe = ve.leaf(e, re),
                he = fe.text.slice(0, ge),
                me = fe.text.slice(ge + le.length);

            if (fe.text = he + me, a) {
              var _e,
                  de = _createForOfIteratorHelper(Ce.points(a));

              try {
                for (de.s(); !(_e = de.n()).done;) {
                  var ce = _slicedToArray(_e.value, 2),
                      Fe = ce[0];

                  a[ce[1]] = De.transform(Fe, i);
                }
              } catch (Je) {
                de.e(Je);
              } finally {
                de.f();
              }
            }

            break;

          case "set_node":
            var ue = i.path,
                pe = i.properties,
                be = i.newProperties;
            if (0 === ue.length) throw new Error("Cannot set properties on the root node!");
            var ke = ve.get(e, ue);

            for (var Ae in be) {
              if ("children" === Ae || "text" === Ae) throw new Error('Cannot set the "'.concat(Ae, '" property of nodes!'));
              var ye = be[Ae];
              null == ye ? delete ke[Ae] : ke[Ae] = ye;
            }

            for (var we in pe) {
              be.hasOwnProperty(we) || delete ke[we];
            }

            break;

          case "set_selection":
            var je = i.newProperties;
            if (null == je) a = je;else {
              if (null == a) {
                if (!Ce.isRange(je)) throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(JSON.stringify(je), " when there is no current selection."));
                a = _objectSpread$6({}, je);
              }

              for (var xe in je) {
                var Be = je[xe];

                if (null == Be) {
                  if ("anchor" === xe || "focus" === xe) throw new Error('Cannot remove the "'.concat(xe, '" selection property'));
                  delete a[xe];
                } else a[xe] = Be;
              }
            }
            break;

          case "split_node":
            var qe = i.path,
                Pe = i.position,
                Oe = i.properties;
            if (0 === qe.length) throw new Error('Cannot apply a "split_node" operation at path ['.concat(qe, "] because the root node cannot be split."));
            var Te,
                Se = ve.get(e, qe),
                ze = ve.parent(e, qe),
                Re = qe[qe.length - 1];

            if (Me.isText(Se)) {
              var He = Se.text.slice(0, Pe),
                  Le = Se.text.slice(Pe);
              Se.text = He, Te = _objectSpread$6(_objectSpread$6({}, Oe), {}, {
                text: Le
              });
            } else {
              var Xe = Se.children.slice(0, Pe),
                  Ne = Se.children.slice(Pe);
              Se.children = Xe, Te = _objectSpread$6(_objectSpread$6({}, Oe), {}, {
                children: Ne
              });
            }

            if (ze.children.splice(Re + 1, 0, Te), a) {
              var Ze,
                  We = _createForOfIteratorHelper(Ce.points(a));

              try {
                for (We.s(); !(Ze = We.n()).done;) {
                  var Ye = _slicedToArray(Ze.value, 2),
                      Ie = Ye[0];

                  a[Ye[1]] = De.transform(Ie, i);
                }
              } catch (Je) {
                We.e(Je);
              } finally {
                We.f();
              }
            }

        }

        e.children = G(e.children), e.selection = a ? immer_esm_t(a) ? G(a) : a : null;
      }
    }), qe), Se), ze),
        He = function isHistory(e) {
      return m(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (0 === e.redos.length || we.isOperationList(e.redos[0])) && (0 === e.undos.length || we.isOperationList(e.undos[0]));
    },
        Le = (new WeakMap(), new WeakMap()),
        Xe = new WeakMap(),
        Ne = {
      isHistoryEditor: function isHistoryEditor(e) {
        return He(e.history) && ke.isEditor(e);
      },
      isMerging: function isMerging(e) {
        return Xe.get(e);
      },
      isSaving: function isSaving(e) {
        return Le.get(e);
      },
      redo: function redo(e) {
        e.redo();
      },
      undo: function undo(e) {
        e.undo();
      },
      withoutMerging: function withoutMerging(e, i) {
        var a = Ne.isMerging(e);
        Xe.set(e, !1), i(), Xe.set(e, a);
      },
      withoutSaving: function withoutSaving(e, i) {
        var a = Ne.isSaving(e);
        Le.set(e, !1), i(), Le.set(e, a);
      }
    },
        Ze = function shouldMerge(e, i) {
      return "set_selection" === e.type || !(!i || "insert_text" !== e.type || "insert_text" !== i.type || e.offset !== i.offset + i.text.length || !Ee.equals(e.path, i.path)) || !(!i || "remove_text" !== e.type || "remove_text" !== i.type || e.offset + e.text.length !== i.offset || !Ee.equals(e.path, i.path));
    },
        We = function shouldSave(e, i) {
      return "set_selection" !== e.type || null != e.properties && null != e.newProperties;
    },
        Ye = function shouldOverwrite(e, i) {
      return !(!i || "set_selection" !== e.type || "set_selection" !== i.type);
    },
        Ie = function shouldClear(e) {
      return "set_selection" !== e.type;
    },
        Je = t(37),
        Ue = t.n(Je);

    function _setPrototypeOf(e, i) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, i) {
        return e.__proto__ = i, e;
      })(e, i);
    }

    function _inherits(e, i) {
      if ("function" !== typeof i && null !== i) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(i && i.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), i && _setPrototypeOf(e, i);
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _possibleConstructorReturn(e, i) {
      return !i || "object" !== _typeof(i) && "function" !== typeof i ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : i;
    }

    function _createSuper(e) {
      return function () {
        var i,
            a = _getPrototypeOf(e);

        if (function _isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var n = _getPrototypeOf(this).constructor;

          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);

        return _possibleConstructorReturn(this, i);
      };
    }

    function _classCallCheck(e, i) {
      if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
    }

    function dist_index_es_defineProperty(e, i, a) {
      return i in e ? Object.defineProperty(e, i, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[i] = a, e;
    }

    var Ge = new WeakMap(),
        Ve = new WeakMap(),
        Ke = function Token() {
      _classCallCheck(this, Token);
    },
        Qe = function (e) {
      _inherits(AnchorToken, Ke);

      var i = _createSuper(AnchorToken);

      function AnchorToken() {
        var e;

        _classCallCheck(this, AnchorToken);

        var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        e = i.call(this);
        var n = a.offset,
            t = a.path;
        return e.offset = n, e.path = t, e;
      }

      return AnchorToken;
    }(),
        $e = function (e) {
      _inherits(FocusToken, Ke);

      var i = _createSuper(FocusToken);

      function FocusToken() {
        var e;

        _classCallCheck(this, FocusToken);

        var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        e = i.call(this);
        var n = a.offset,
            t = a.path;
        return e.offset = n, e.path = t, e;
      }

      return FocusToken;
    }(),
        ei = function getAnchorOffset(e) {
      return Ge.get(e);
    },
        ii = function getFocusOffset(e) {
      return Ve.get(e);
    };

    function index_es_ownKeys(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function index_es_objectSpread(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? index_es_ownKeys(Object(a), !0).forEach(function (i) {
          dist_index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : index_es_ownKeys(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var ai = new WeakSet(),
        ni = function resolveDescendants(e) {
      var i,
          a = [],
          n = function addChild(e) {
        if (null != e) {
          var i = a[a.length - 1];

          if ("string" === typeof e) {
            var n = {
              text: e
            };
            ai.add(n), e = n;
          }

          if (Me.isText(e)) {
            var t = e;
            Me.isText(i) && ai.has(i) && ai.has(t) && Me.equals(i, t, {
              loose: !0
            }) ? i.text += t.text : a.push(t);
          } else if (pe.isElement(e)) a.push(e);else {
            if (!(e instanceof Ke)) throw new Error("Unexpected hyperscript child object: ".concat(e));
            var o = a[a.length - 1];
            Me.isText(o) || (addChild(""), o = a[a.length - 1]), e instanceof Qe ? function addAnchorToken(e, i) {
              var a = e.text.length;
              Ge.set(e, [a, i]);
            }(o, e) : e instanceof $e && function addFocusToken(e, i) {
              var a = e.text.length;
              Ve.set(e, [a, i]);
            }(o, e);
          }
        }
      },
          t = _createForOfIteratorHelper(e.flat(1 / 0));

      try {
        for (t.s(); !(i = t.n()).done;) {
          n(i.value);
        }
      } catch (o) {
        t.e(o);
      } finally {
        t.f();
      }

      return a;
    };

    function createElement(e, i, a) {
      return index_es_objectSpread(index_es_objectSpread({}, i), {}, {
        children: ni(a)
      });
    }

    function index_es_ownKeys$1(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function index_es_objectSpread$1(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? index_es_ownKeys$1(Object(a), !0).forEach(function (i) {
          dist_index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : index_es_ownKeys$1(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var ti = {
      anchor: function createAnchor(e, i, a) {
        return new Qe(i);
      },
      cursor: function createCursor(e, i, a) {
        return [new Qe(i), new $e(i)];
      },
      editor: function dist_index_es_createEditor(e, i, a) {
        var n,
            t,
            o = [],
            s = _createForOfIteratorHelper(a);

        try {
          for (s.s(); !(t = s.n()).done;) {
            var r = t.value;
            Ce.isRange(r) ? n = r : o.push(r);
          }
        } catch (k) {
          s.e(k);
        } finally {
          s.f();
        }

        var g = ni(o),
            l = {},
            f = se();
        Object.assign(f, i), f.children = g;

        var h,
            m = _createForOfIteratorHelper(ve.texts(f));

        try {
          for (m.s(); !(h = m.n()).done;) {
            var _ = _slicedToArray(h.value, 2),
                d = _[0],
                c = _[1],
                F = ei(d),
                u = ii(d);

            if (null != F) {
              var p = _slicedToArray(F, 1)[0];

              l.anchor = {
                path: c,
                offset: p
              };
            }

            if (null != u) {
              var b = _slicedToArray(u, 1)[0];

              l.focus = {
                path: c,
                offset: b
              };
            }
          }
        } catch (k) {
          m.e(k);
        } finally {
          m.f();
        }

        if (l.anchor && !l.focus) throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<anchor />`. For collapsed selections, use `<cursor />` instead.");
        if (!l.anchor && l.focus) throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<focus />`. For collapsed selections, use `<cursor />` instead.");
        return null != n ? f.selection = n : Ce.isRange(l) && (f.selection = l), f;
      },
      element: createElement,
      focus: function createFocus(e, i, a) {
        return new $e(i);
      },
      fragment: function createFragment(e, i, a) {
        return ni(a);
      },
      selection: function createSelection(e, i, a) {
        var n = a.find(function (e) {
          return e instanceof Qe;
        }),
            t = a.find(function (e) {
          return e instanceof $e;
        });
        if (!n || null == n.offset || null == n.path) throw new Error("The <selection> hyperscript tag must have an <anchor> tag as a child with `path` and `offset` attributes defined.");
        if (!t || null == t.offset || null == t.path) throw new Error("The <selection> hyperscript tag must have a <focus> tag as a child with `path` and `offset` attributes defined.");
        return index_es_objectSpread({
          anchor: {
            offset: n.offset,
            path: n.path
          },
          focus: {
            offset: t.offset,
            path: t.path
          }
        }, i);
      },
      text: function createText(e, i, a) {
        var n = ni(a);
        if (n.length > 1) throw new Error("The <text> hyperscript tag must only contain a single node's worth of children.");

        var t = _slicedToArray(n, 1)[0];

        if (null == t && (t = {
          text: ""
        }), !Me.isText(t)) throw new Error("\n    The <text> hyperscript tag can only contain text content as children.");
        return ai.delete(t), Object.assign(t, i), t;
      }
    },
        oi = function createFactory(e) {
      return function jsx(i, a) {
        for (var n = arguments.length, t = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
          t[o - 2] = arguments[o];
        }

        var s = e[i];
        if (!s) throw new Error("No hyperscript creator found for tag: <".concat(i, ">"));
        return null == a && (a = {}), m(a) || (t = [a].concat(t), a = {}), s(i, a, t = t.filter(function (e) {
          return Boolean(e);
        }).flat());
      };
    },
        si = function normalizeElements(e) {
      var i = {},
          a = function _loop(a) {
        var n = e[a];
        if ("object" !== typeof n) throw new Error("Properties specified for a hyperscript shorthand should be an object, but for the custom element <".concat(a, ">  tag you passed: ").concat(n));

        i[a] = function (e, i, a) {
          return createElement(0, index_es_objectSpread$1(index_es_objectSpread$1({}, n), i), a);
        };
      };

      for (var n in e) {
        a(n);
      }

      return i;
    },
        ri = function createHyperscript() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          i = e.elements,
          a = si(void 0 === i ? {} : i),
          n = index_es_objectSpread$1(index_es_objectSpread$1(index_es_objectSpread$1({}, ti), a), e.creators);
      return oi(n);
    }(),
        gi = t(2),
        li = t(103);

    var fi = t(16),
        hi = t(104),
        mi = t(105),
        _i = "PRODUCTION" === window.__ENV__ ? mi : hi,
        di = t(62),
        ci = t.n(di),
        Fi = (Object(fi.createAuthedHttpClient)({
      baseConfig: {
        baseURL: _i.CUSTOMER_API,
        paramsSerializer: function paramsSerializer(e) {
          return ci.a.stringify(e, {
            arrayFormat: "repeat"
          });
        }
      }
    }), Object(fi.createAuthedHttpClient)({
      baseConfig: {
        baseURL: _i.CONVERSATION_API,
        paramsSerializer: function paramsSerializer(e) {
          return ci.a.stringify(e, {
            arrayFormat: "repeat"
          });
        }
      }
    }), Object(fi.createAuthedHttpClient)({
      baseConfig: {
        baseURL: _i.ACCOUNTS_API
      }
    }), Object(fi.createAuthedHttpClient)({
      baseConfig: {
        baseURL: _i.WS_API
      }
    }), Object(fi.createAuthedHttpClient)({
      baseConfig: {
        baseURL: _i.TICKET_API
      }
    }), Object(fi.createAuthedHttpClient)({
      baseConfig: {
        baseURL: _i.FILE_API,
        raw: !0
      }
    })),
        ui = function uploadImage(e) {
      return Fi.post("/upload", {
        file: e
      });
    },
        pi = t(63),
        bi = t.n(pi),
        ki = t(106),
        Ai = t.n(ki);

    function index_module_t(e) {
      return "object" == typeof e && null != e && 1 === e.nodeType;
    }

    function index_module_e(e, i) {
      return (!i || "hidden" !== e) && "visible" !== e && "clip" !== e;
    }

    function index_module_n(e, i) {
      if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
        var a = getComputedStyle(e, null);
        return index_module_e(a.overflowY, i) || index_module_e(a.overflowX, i) || function (e) {
          var i = function (e) {
            if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;

            try {
              return e.ownerDocument.defaultView.frameElement;
            } catch (e) {
              return null;
            }
          }(e);

          return !!i && (i.clientHeight < e.scrollHeight || i.clientWidth < e.scrollWidth);
        }(e);
      }

      return !1;
    }

    function index_module_r(e, i, a, n, t, o, s, r) {
      return o < e && s > i || o > e && s < i ? 0 : o <= e && r <= a || s >= i && r >= a ? o - e - n : s > i && r < a || o < e && r > a ? s - i + t : 0;
    }

    var yi = function yi(e, i) {
      var a = window,
          n = i.scrollMode,
          t = i.block,
          o = i.inline,
          s = i.boundary,
          r = i.skipOverflowHiddenElements,
          g = "function" == typeof s ? s : function (e) {
        return e !== s;
      };
      if (!index_module_t(e)) throw new TypeError("Invalid target");

      for (var l = document.scrollingElement || document.documentElement, f = [], h = e; index_module_t(h) && g(h);) {
        if ((h = h.parentElement) === l) {
          f.push(h);
          break;
        }

        null != h && h === document.body && index_module_n(h) && !index_module_n(document.documentElement) || null != h && index_module_n(h, r) && f.push(h);
      }

      for (var m = a.visualViewport ? a.visualViewport.width : innerWidth, _ = a.visualViewport ? a.visualViewport.height : innerHeight, d = window.scrollX || pageXOffset, c = window.scrollY || pageYOffset, F = e.getBoundingClientRect(), u = F.height, p = F.width, b = F.top, k = F.right, A = F.bottom, y = F.left, v = "start" === t || "nearest" === t ? b : "end" === t ? A : b + u / 2, w = "center" === o ? y + p / 2 : "end" === o ? k : y, E = [], j = 0; j < f.length; j++) {
        var D = f[j],
            x = D.getBoundingClientRect(),
            C = x.height,
            B = x.width,
            M = x.top,
            q = x.right,
            P = x.bottom,
            O = x.left;
        if ("if-needed" === n && b >= 0 && y >= 0 && A <= _ && k <= m && b >= M && A <= P && y >= O && k <= q) return E;
        var T = getComputedStyle(D),
            S = parseInt(T.borderLeftWidth, 10),
            z = parseInt(T.borderTopWidth, 10),
            R = parseInt(T.borderRightWidth, 10),
            H = parseInt(T.borderBottomWidth, 10),
            L = 0,
            X = 0,
            N = "offsetWidth" in D ? D.offsetWidth - D.clientWidth - S - R : 0,
            Z = "offsetHeight" in D ? D.offsetHeight - D.clientHeight - z - H : 0;
        if (l === D) L = "start" === t ? v : "end" === t ? v - _ : "nearest" === t ? index_module_r(c, c + _, _, z, H, c + v, c + v + u, u) : v - _ / 2, X = "start" === o ? w : "center" === o ? w - m / 2 : "end" === o ? w - m : index_module_r(d, d + m, m, S, R, d + w, d + w + p, p), L = Math.max(0, L + c), X = Math.max(0, X + d);else {
          L = "start" === t ? v - M - z : "end" === t ? v - P + H + Z : "nearest" === t ? index_module_r(M, P, C, z, H + Z, v, v + u, u) : v - (M + C / 2) + Z / 2, X = "start" === o ? w - O - S : "center" === o ? w - (O + B / 2) + N / 2 : "end" === o ? w - q + R + N : index_module_r(O, q, B, S, R + N, w, w + p, p);
          var W = D.scrollLeft,
              Y = D.scrollTop;
          v += Y - (L = Math.max(0, Math.min(Y + L, D.scrollHeight - C + Z))), w += W - (X = Math.max(0, Math.min(W + X, D.scrollWidth - B + N)));
        }
        E.push({
          el: D,
          top: L,
          left: X
        });
      }

      return E;
    };

    function isOptionsObject(e) {
      return e === Object(e) && 0 !== Object.keys(e).length;
    }

    var vi = function scrollIntoView(e, i) {
      var a = !e.ownerDocument.documentElement.contains(e);
      if (isOptionsObject(i) && "function" === typeof i.behavior) return i.behavior(a ? [] : yi(e, i));

      if (!a) {
        var n = function getOptions(e) {
          return !1 === e ? {
            block: "end",
            inline: "nearest"
          } : isOptionsObject(e) ? e : {
            block: "start",
            inline: "nearest"
          };
        }(i);

        return function defaultBehavior(e, i) {
          void 0 === i && (i = "auto");
          var a = ("scrollBehavior" in document.body.style);
          e.forEach(function (e) {
            var n = e.el,
                t = e.top,
                o = e.left;
            n.scroll && a ? n.scroll({
              top: t,
              left: o,
              behavior: i
            }) : (n.scrollTop = t, n.scrollLeft = o);
          });
        }(yi(e, n), n.behavior);
      }
    },
        wi = t(21),
        Ei = t.n(wi),
        ji = !0,
        Di = "Invariant failed";

    var xi = function invariant(e, i) {
      if (!e) throw ji ? new Error(Di) : new Error(Di + ": " + (i || ""));
    },
        Ci = t(61),
        Bi = t.n(Ci);

    function slate_react_dist_index_es_defineProperty(e, i, a) {
      return i in e ? Object.defineProperty(e, i, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[i] = a, e;
    }

    function index_es_objectWithoutProperties(e, i) {
      if (null == e) return {};

      var a,
          n,
          t = function index_es_objectWithoutPropertiesLoose(e, i) {
        if (null == e) return {};
        var a,
            n,
            t = {},
            o = Object.keys(e);

        for (n = 0; n < o.length; n++) {
          a = o[n], i.indexOf(a) >= 0 || (t[a] = e[a]);
        }

        return t;
      }(e, i);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (n = 0; n < o.length; n++) {
          a = o[n], i.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (t[a] = e[a]);
        }
      }

      return t;
    }

    var Mi = function isHistory(e) {
      return m(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (0 === e.redos.length || we.isOperationList(e.redos[0])) && (0 === e.undos.length || we.isOperationList(e.undos[0]));
    },
        qi = new WeakMap(),
        Pi = new WeakMap(),
        Oi = {
      isHistoryEditor: function isHistoryEditor(e) {
        return Mi(e.history) && ke.isEditor(e);
      },
      isMerging: function isMerging(e) {
        return Pi.get(e);
      },
      isSaving: function isSaving(e) {
        return qi.get(e);
      },
      redo: function redo(e) {
        e.redo();
      },
      undo: function undo(e) {
        e.undo();
      },
      withoutMerging: function withoutMerging(e, i) {
        var a = Oi.isMerging(e);
        Pi.set(e, !1), i(), Pi.set(e, a);
      },
      withoutSaving: function withoutSaving(e, i) {
        var a = Oi.isSaving(e);
        qi.set(e, !1), i(), qi.set(e, a);
      }
    },
        Ti = function String(e) {
      var i = e.isLast,
          a = e.leaf,
          n = e.parent,
          t = e.text,
          o = Fa(),
          s = Ja.findPath(o, t),
          g = Ee.parent(s);
      return o.isVoid(n) ? r.a.createElement(zi, {
        length: ve.string(n).length
      }) : "" !== a.text || n.children[n.children.length - 1] !== t || o.isInline(n) || "" !== ke.string(o, g) ? "" === a.text ? r.a.createElement(zi, null) : i && "\n" === a.text.slice(-1) ? r.a.createElement(Si, {
        isTrailing: !0,
        text: a.text
      }) : r.a.createElement(Si, {
        text: a.text
      }) : r.a.createElement(zi, {
        isLineBreak: !0
      });
    },
        Si = function TextString(e) {
      var i = e.text,
          a = e.isTrailing,
          n = void 0 !== a && a;
      return r.a.createElement("span", {
        "data-slate-string": !0
      }, i, n ? "\n" : null);
    },
        zi = function ZeroWidthString(e) {
      var i = e.length,
          a = void 0 === i ? 0 : i,
          n = e.isLineBreak,
          t = void 0 !== n && n;
      return r.a.createElement("span", {
        "data-slate-zero-width": t ? "n" : "z",
        "data-slate-length": a
      }, "\uFEFF", t ? r.a.createElement("br", null) : null);
    },
        Ri = new WeakMap(),
        Hi = new WeakMap(),
        Li = new WeakMap(),
        Xi = new WeakMap(),
        Ni = new WeakMap(),
        Zi = new WeakMap(),
        Wi = new WeakMap(),
        Yi = new WeakMap(),
        Ii = new WeakMap(),
        Ji = new WeakMap(),
        Ui = new WeakMap(),
        Gi = Symbol("placeholder"),
        Vi = 0,
        Ki = function Leaf(e) {
      var i = e.leaf,
          a = e.isLast,
          n = e.text,
          t = e.parent,
          o = e.renderPlaceholder,
          g = e.renderLeaf,
          l = void 0 === g ? function (e) {
        return r.a.createElement($i, Object.assign({}, e));
      } : g,
          f = Object(s.useRef)(null);
      Object(s.useEffect)(function () {
        var e = null === f || void 0 === f ? void 0 : f.current,
            i = document.querySelector('[data-slate-editor="true"]');
        if (e && i) return i.style.minHeight = "".concat(e.clientHeight, "px"), function () {
          i.style.minHeight = "auto";
        };
      }, [f, i]);
      var h = r.a.createElement(Ti, {
        key: Vi++,
        isLast: a,
        leaf: i,
        parent: t,
        text: n
      });

      if (i[Gi]) {
        var m = {
          children: i.placeholder,
          attributes: {
            "data-slate-placeholder": !0,
            style: {
              position: "absolute",
              pointerEvents: "none",
              width: "100%",
              maxWidth: "100%",
              display: "block",
              opacity: "0.333",
              userSelect: "none",
              textDecoration: "none"
            },
            contentEditable: !1,
            ref: f
          }
        };
        h = r.a.createElement(r.a.Fragment, null, o(m), h);
      }

      return l({
        attributes: {
          "data-slate-leaf": !0
        },
        children: h,
        leaf: i,
        text: n
      });
    },
        Qi = r.a.memo(Ki, function (e, i) {
      return i.parent === e.parent && i.isLast === e.isLast && i.renderLeaf === e.renderLeaf && i.renderPlaceholder === e.renderPlaceholder && i.text === e.text && i.leaf.text === e.leaf.text && Me.matches(i.leaf, e.leaf) && i.leaf[Gi] === e.leaf[Gi];
    }),
        $i = function DefaultLeaf(e) {
      var i = e.attributes,
          a = e.children;
      return r.a.createElement("span", Object.assign({}, i), a);
    },
        ea = ("undefined" !== typeof navigator && "undefined" !== typeof window && /iPad|iPhone|iPod/.test(navigator.userAgent) && window.MSStream, "undefined" !== typeof navigator && /Mac OS X/.test(navigator.userAgent)),
        ia = "undefined" !== typeof navigator && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent),
        aa = "undefined" !== typeof navigator && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent),
        na = "undefined" !== typeof navigator && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])/i.test(navigator.userAgent),
        ta = "undefined" !== typeof navigator && /Chrome/i.test(navigator.userAgent),
        oa = "undefined" !== typeof navigator && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])/i.test(navigator.userAgent),
        sa = ("undefined" !== typeof navigator && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])).*/i.test(navigator.userAgent), !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement) ? s.useLayoutEffect : s.useEffect),
        ra = function shallowCompare(e, i) {
      return Object.keys(e).length === Object.keys(i).length && Object.keys(e).every(function (a) {
        return i.hasOwnProperty(a) && e[a] === i[a];
      });
    },
        ga = function isDecoratorRangeListEqual(e, i) {
      if (e.length !== i.length) return !1;

      for (var a = 0; a < e.length; a++) {
        var n = e[a],
            t = i[a],
            o = index_es_objectWithoutProperties(n, ["anchor", "focus"]),
            s = index_es_objectWithoutProperties(t, ["anchor", "focus"]);
        if (!Ce.equals(n, t) || n[Gi] !== t[Gi] || !ra(o, s)) return !1;
      }

      return !0;
    },
        la = function Text(e) {
      for (var i = e.decorations, a = e.isLast, n = e.parent, t = e.renderPlaceholder, o = e.renderLeaf, g = e.text, l = Fa(), f = Object(s.useRef)(null), h = Me.decorations(g, i), m = Ja.findKey(l, g), _ = [], d = 0; d < h.length; d++) {
        var c = h[d];

        _.push(r.a.createElement(Qi, {
          isLast: a && d === h.length - 1,
          key: "".concat(m.id, "-").concat(d),
          renderPlaceholder: t,
          leaf: c,
          text: g,
          parent: n,
          renderLeaf: o
        }));
      }

      return sa(function () {
        f.current ? (Zi.set(m, f.current), Wi.set(g, f.current), Ni.set(f.current, g)) : (Zi.delete(m), Wi.delete(g));
      }), r.a.createElement("span", {
        "data-slate-node": "text",
        ref: f
      }, _);
    },
        fa = r.a.memo(la, function (e, i) {
      return i.parent === e.parent && i.isLast === e.isLast && i.renderLeaf === e.renderLeaf && i.text === e.text && ga(i.decorations, e.decorations);
    }),
        ha = Object(s.createContext)(!1),
        ma = function Element(e) {
      var i = e.decorations,
          a = e.element,
          n = e.renderElement,
          t = void 0 === n ? function (e) {
        return r.a.createElement(da, Object.assign({}, e));
      } : n,
          o = e.renderPlaceholder,
          g = e.renderLeaf,
          l = e.selection,
          f = Object(s.useRef)(null),
          h = Fa(),
          m = Ea(),
          _ = h.isInline(a),
          d = Ja.findKey(h, a),
          c = pa({
        decorations: i,
        node: a,
        renderElement: t,
        renderPlaceholder: o,
        renderLeaf: g,
        selection: l
      }),
          F = {
        "data-slate-node": "element",
        ref: f
      };

      if (_ && (F["data-slate-inline"] = !0), !_ && ke.hasInlines(h, a)) {
        var u = ve.string(a),
            p = bi()(u);
        "rtl" === p && (F.dir = p);
      }

      if (ke.isVoid(h, a)) {
        F["data-slate-void"] = !0, !m && _ && (F.contentEditable = !1);

        var b = _ ? "span" : "div",
            k = _slicedToArray(ve.texts(a), 1),
            A = _slicedToArray(k[0], 1)[0];

        c = m ? null : r.a.createElement(b, {
          "data-slate-spacer": !0,
          style: {
            height: "0",
            color: "transparent",
            outline: "none",
            position: "absolute"
          }
        }, r.a.createElement(fa, {
          renderPlaceholder: o,
          decorations: [],
          isLast: !1,
          parent: a,
          text: A
        })), Ri.set(A, 0), Hi.set(A, a);
      }

      return sa(function () {
        f.current ? (Zi.set(d, f.current), Wi.set(a, f.current), Ni.set(f.current, a)) : (Zi.delete(d), Wi.delete(a));
      }), r.a.createElement(ha.Provider, {
        value: !!l
      }, t({
        attributes: F,
        children: c,
        element: a
      }));
    },
        _a = r.a.memo(ma, function (e, i) {
      return e.element === i.element && e.renderElement === i.renderElement && e.renderLeaf === i.renderLeaf && ga(e.decorations, i.decorations) && (e.selection === i.selection || !!e.selection && !!i.selection && Ce.equals(e.selection, i.selection));
    }),
        da = function DefaultElement(e) {
      var i = e.attributes,
          a = e.children,
          n = e.element,
          t = Fa().isInline(n) ? "span" : "div";
      return r.a.createElement(t, Object.assign({}, i, {
        style: {
          position: "relative"
        }
      }), a);
    },
        ca = Object(s.createContext)(null),
        Fa = function useSlateStatic() {
      var e = Object(s.useContext)(ca);
      if (!e) throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
      return e;
    },
        ua = Object(s.createContext)(function () {
      return [];
    }),
        pa = function useChildren(e) {
      for (var i = e.decorations, a = e.node, n = e.renderElement, t = e.renderPlaceholder, o = e.renderLeaf, g = e.selection, l = function useDecorate() {
        return Object(s.useContext)(ua);
      }(), f = Fa(), h = Ja.findPath(f, a), m = [], _ = pe.isElement(a) && !f.isInline(a) && ke.hasInlines(f, a), d = 0; d < a.children.length; d++) {
        var c,
            F = h.concat(d),
            u = a.children[d],
            p = Ja.findKey(f, u),
            b = ke.range(f, F),
            k = g && Ce.intersection(b, g),
            A = l([u, F]),
            y = _createForOfIteratorHelper(i);

        try {
          for (y.s(); !(c = y.n()).done;) {
            var v = c.value,
                w = Ce.intersection(v, b);
            w && A.push(w);
          }
        } catch (E) {
          y.e(E);
        } finally {
          y.f();
        }

        pe.isElement(u) ? m.push(r.a.createElement(_a, {
          decorations: A,
          element: u,
          key: p.id,
          renderElement: n,
          renderPlaceholder: t,
          renderLeaf: o,
          selection: k
        })) : m.push(r.a.createElement(fa, {
          decorations: A,
          key: p.id,
          isLast: _ && d === a.children.length - 1,
          parent: a,
          renderPlaceholder: t,
          renderLeaf: o,
          text: u
        })), Ri.set(u, d), Hi.set(u, a);
      }

      return m;
    },
        ba = {
      bold: "mod+b",
      compose: ["down", "left", "right", "up", "backspace", "enter"],
      moveBackward: "left",
      moveForward: "right",
      moveWordBackward: "ctrl+left",
      moveWordForward: "ctrl+right",
      deleteBackward: "shift?+backspace",
      deleteForward: "shift?+delete",
      extendBackward: "shift+left",
      extendForward: "shift+right",
      italic: "mod+i",
      splitBlock: "shift?+enter",
      undo: "mod+z"
    },
        ka = {
      moveLineBackward: "opt+up",
      moveLineForward: "opt+down",
      moveWordBackward: "opt+left",
      moveWordForward: "opt+right",
      deleteBackward: ["ctrl+backspace", "ctrl+h"],
      deleteForward: ["ctrl+delete", "ctrl+d"],
      deleteLineBackward: "cmd+shift?+backspace",
      deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
      deleteWordBackward: "opt+shift?+backspace",
      deleteWordForward: "opt+shift?+delete",
      extendLineBackward: "opt+shift+up",
      extendLineForward: "opt+shift+down",
      redo: "cmd+shift+z",
      transposeCharacter: "ctrl+t"
    },
        Aa = {
      deleteWordBackward: "ctrl+shift?+backspace",
      deleteWordForward: "ctrl+shift?+delete",
      redo: ["ctrl+y", "ctrl+shift+z"]
    },
        ya = function create(e) {
      var i = ba[e],
          a = ka[e],
          n = Aa[e],
          t = i && Object(wi.isKeyHotkey)(i),
          o = a && Object(wi.isKeyHotkey)(a),
          s = n && Object(wi.isKeyHotkey)(n);
      return function (e) {
        return !(!t || !t(e)) || !!(ea && o && o(e)) || !(ea || !s || !s(e));
      };
    },
        va = {
      isBold: ya("bold"),
      isCompose: ya("compose"),
      isMoveBackward: ya("moveBackward"),
      isMoveForward: ya("moveForward"),
      isDeleteBackward: ya("deleteBackward"),
      isDeleteForward: ya("deleteForward"),
      isDeleteLineBackward: ya("deleteLineBackward"),
      isDeleteLineForward: ya("deleteLineForward"),
      isDeleteWordBackward: ya("deleteWordBackward"),
      isDeleteWordForward: ya("deleteWordForward"),
      isExtendBackward: ya("extendBackward"),
      isExtendForward: ya("extendForward"),
      isExtendLineBackward: ya("extendLineBackward"),
      isExtendLineForward: ya("extendLineForward"),
      isItalic: ya("italic"),
      isMoveLineBackward: ya("moveLineBackward"),
      isMoveLineForward: ya("moveLineForward"),
      isMoveWordBackward: ya("moveWordBackward"),
      isMoveWordForward: ya("moveWordForward"),
      isRedo: ya("redo"),
      isSplitBlock: ya("splitBlock"),
      isTransposeCharacter: ya("transposeCharacter"),
      isUndo: ya("undo")
    },
        wa = Object(s.createContext)(!1),
        Ea = function useReadOnly() {
      return Object(s.useContext)(wa);
    },
        ja = Object(s.createContext)(null),
        Da = function useSlate() {
      var e = Object(s.useContext)(ja);
      if (!e) throw new Error("The `useSlate` hook must be used inside the <SlateProvider> component's context.");
      return _slicedToArray(e, 1)[0];
    },
        xa = function getDefaultView(e) {
      return e && e.ownerDocument && e.ownerDocument.defaultView || null;
    },
        Ca = function isDOMComment(e) {
      return Ma(e) && 8 === e.nodeType;
    },
        Ba = function isDOMElement(e) {
      return Ma(e) && 1 === e.nodeType;
    },
        Ma = function isDOMNode(e) {
      var i = xa(e);
      return !!i && e instanceof i.Node;
    },
        qa = function isDOMSelection(e) {
      var i = e && e.anchorNode && xa(e.anchorNode);
      return !!i && e instanceof i.Selection;
    },
        Pa = function isDOMText(e) {
      return Ma(e) && 3 === e.nodeType;
    },
        Oa = function getEditableChildAndIndex(e, i, a) {
      for (var n = e.childNodes, t = n[i], o = i, s = !1, r = !1; (Ca(t) || Ba(t) && 0 === t.childNodes.length || Ba(t) && "false" === t.getAttribute("contenteditable")) && (!s || !r);) {
        o >= n.length ? (s = !0, o = i - 1, a = "backward") : o < 0 ? (r = !0, o = i + 1, a = "forward") : (t = n[o], i = o, o += "forward" === a ? 1 : -1);
      }

      return [t, i];
    },
        Ta = function getEditableChild(e, i, a) {
      return _slicedToArray(Oa(e, i, a), 1)[0];
    };

    function dist_index_es_ownKeys(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function dist_index_es_objectSpread(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? dist_index_es_ownKeys(Object(a), !0).forEach(function (i) {
          slate_react_dist_index_es_defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : dist_index_es_ownKeys(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var Sa = !oa && !na && globalThis.InputEvent && "function" === typeof globalThis.InputEvent.prototype.getTargetRanges,
        za = function Editable(e) {
      var i = e.autoFocus,
          a = e.decorate,
          n = void 0 === a ? Ha : a,
          t = e.onDOMBeforeInput,
          o = e.placeholder,
          g = e.readOnly,
          l = void 0 !== g && g,
          f = e.renderElement,
          h = e.renderLeaf,
          m = e.renderPlaceholder,
          _ = void 0 === m ? function (e) {
        return r.a.createElement(Ra, Object.assign({}, e));
      } : m,
          d = e.style,
          c = void 0 === d ? {} : d,
          F = e.as,
          u = void 0 === F ? "div" : F,
          p = index_es_objectWithoutProperties(e, ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "style", "as"]),
          b = Da(),
          k = Object(s.useRef)(null);

      Ii.set(b, l);
      var A = Object(s.useMemo)(function () {
        return {
          isComposing: !1,
          isUpdatingSelection: !1,
          latestElement: null
        };
      }, []);
      sa(function () {
        var e;
        k.current && (e = xa(k.current)) ? (Li.set(b, e), Xi.set(b, k.current), Wi.set(b, k.current), Ni.set(k.current, b)) : Wi.delete(b);
      }), sa(function () {
        var e = b.selection,
            i = Ja.findDocumentOrShadowRoot(b).getSelection();

        if (!A.isComposing && i && Ja.isFocused(b)) {
          var a = "None" !== i.type;

          if (e || a) {
            var n = Xi.get(b),
                t = !1;

            if (n.contains(i.anchorNode) && n.contains(i.focusNode) && (t = !0), a && t && e) {
              var o = Ja.toSlateRange(b, i, {
                exactMatch: !0
              });
              if (o && Ce.equals(o, e)) return;
            }

            if (!e || Ja.hasRange(b, e)) {
              var s = Ja.toDOMNode(b, b);
              A.isUpdatingSelection = !0;
              var r = e && Ja.toDOMRange(b, e);

              if (r) {
                Ce.isBackward(e) ? i.setBaseAndExtent(r.endContainer, r.endOffset, r.startContainer, r.startOffset) : i.setBaseAndExtent(r.startContainer, r.startOffset, r.endContainer, r.endOffset);
                var g = r.startContainer.parentElement;
                g.getBoundingClientRect = r.getBoundingClientRect.bind(r), vi(g, {
                  scrollMode: "if-needed",
                  boundary: s
                }), delete g.getBoundingClientRect;
              } else i.removeAllRanges();

              setTimeout(function () {
                r && ia && s.focus(), A.isUpdatingSelection = !1;
              });
            } else b.selection = Ja.toSlateRange(b, i, {
              exactMatch: !1
            });
          }
        }
      }), Object(s.useEffect)(function () {
        k.current && i && k.current.focus();
      }, [i]);
      var y = Object(s.useCallback)(function (e) {
        if (!l && Xa(b, e.target) && !Wa(e, t)) {
          var i = b.selection,
              a = e.inputType,
              n = e.dataTransfer || e.data || void 0;
          if ("insertCompositionText" === a || "deleteCompositionText" === a) return;

          if (e.preventDefault(), !a.startsWith("delete") || a.startsWith("deleteBy")) {
            var o = _slicedToArray(e.getTargetRanges(), 1)[0];

            if (o) {
              var s = Ja.toSlateRange(b, o, {
                exactMatch: !1
              });
              i && Ce.equals(i, s) || Re.select(b, s);
            }
          }

          if (i && Ce.isExpanded(i) && a.startsWith("delete")) {
            var r = a.endsWith("Backward") ? "backward" : "forward";
            return void ke.deleteFragment(b, {
              direction: r
            });
          }

          switch (a) {
            case "deleteByComposition":
            case "deleteByCut":
            case "deleteByDrag":
              ke.deleteFragment(b);
              break;

            case "deleteContent":
            case "deleteContentForward":
              ke.deleteForward(b);
              break;

            case "deleteContentBackward":
              ke.deleteBackward(b);
              break;

            case "deleteEntireSoftLine":
              ke.deleteBackward(b, {
                unit: "line"
              }), ke.deleteForward(b, {
                unit: "line"
              });
              break;

            case "deleteHardLineBackward":
              ke.deleteBackward(b, {
                unit: "block"
              });
              break;

            case "deleteSoftLineBackward":
              ke.deleteBackward(b, {
                unit: "line"
              });
              break;

            case "deleteHardLineForward":
              ke.deleteForward(b, {
                unit: "block"
              });
              break;

            case "deleteSoftLineForward":
              ke.deleteForward(b, {
                unit: "line"
              });
              break;

            case "deleteWordBackward":
              ke.deleteBackward(b, {
                unit: "word"
              });
              break;

            case "deleteWordForward":
              ke.deleteForward(b, {
                unit: "word"
              });
              break;

            case "insertLineBreak":
            case "insertParagraph":
              ke.insertBreak(b);
              break;

            case "insertFromComposition":
            case "insertFromDrop":
            case "insertFromPaste":
            case "insertFromYank":
            case "insertReplacementText":
            case "insertText":
              "insertFromComposition" === a && (A.isComposing = !1), n instanceof Ja.getWindow(b).DataTransfer ? Ja.insertData(b, n) : "string" === typeof n && ke.insertText(b, n);
          }
        }
      }, [l, t]);
      sa(function () {
        return k.current && Sa && k.current.addEventListener("beforeinput", y), function () {
          k.current && Sa && k.current.removeEventListener("beforeinput", y);
        };
      }, [y]);
      var v = Object(s.useCallback)(Ai()(function () {
        if (!l && !A.isComposing && !A.isUpdatingSelection) {
          var e = Ja.findDocumentOrShadowRoot(b),
              i = e.activeElement,
              a = Ja.toDOMNode(b, b),
              n = e.getSelection();
          if (i === a ? (A.latestElement = i, Ji.set(b, !0)) : Ji.delete(b), !n) return Re.deselect(b);
          var t = n.anchorNode,
              o = n.focusNode,
              s = Xa(b, t) || Na(b, t),
              r = Xa(b, o) || Na(b, o);

          if (s && r) {
            var g = Ja.toSlateRange(b, n, {
              exactMatch: !1
            });
            Re.select(b, g);
          } else Re.deselect(b);
        }
      }, 100), [l]);
      sa(function () {
        var e = Ja.getWindow(b);
        return e.document.addEventListener("selectionchange", v), function () {
          e.document.removeEventListener("selectionchange", v);
        };
      }, [v]);
      var w = n([b, []]);

      if (o && 1 === b.children.length && 1 === Array.from(ve.texts(b)).length && "" === ve.string(b)) {
        var E,
            j = ke.start(b, []);
        w.push((_defineProperty(E = {}, Gi, !0), _defineProperty(E, "placeholder", o), _defineProperty(E, "anchor", j), _defineProperty(E, "focus", j), E));
      }

      return r.a.createElement(wa.Provider, {
        value: l
      }, r.a.createElement(ua.Provider, {
        value: n
      }, r.a.createElement(u, Object.assign({
        "data-gramm": !1,
        role: l ? void 0 : "textbox"
      }, p, {
        spellCheck: !!Sa && p.spellCheck,
        autoCorrect: !!Sa && p.autoCorrect,
        autoCapitalize: !!Sa && p.autoCapitalize,
        "data-slate-editor": !0,
        "data-slate-node": "value",
        contentEditable: !l || void 0,
        suppressContentEditableWarning: !0,
        ref: k,
        style: dist_index_es_objectSpread({
          position: "relative",
          outline: "none",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word"
        }, c),
        onBeforeInput: Object(s.useCallback)(function (e) {
          if (!Sa && !l && !Za(e, p.onBeforeInput) && Xa(b, e.target) && (e.preventDefault(), !A.isComposing)) {
            var i = e.data;
            ke.insertText(b, i);
          }
        }, [l]),
        onBlur: Object(s.useCallback)(function (e) {
          if (!l && !A.isUpdatingSelection && Xa(b, e.target) && !Za(e, p.onBlur)) {
            Ja.getWindow(b);
            var i = Ja.findDocumentOrShadowRoot(b);

            if (A.latestElement !== i.activeElement) {
              var a = e.relatedTarget;

              if (a !== Ja.toDOMNode(b, b) && (!Ba(a) || !a.hasAttribute("data-slate-spacer"))) {
                if (null != a && Ma(a) && Ja.hasDOMNode(b, a)) {
                  var n = Ja.toSlateNode(b, a);
                  if (pe.isElement(n) && !b.isVoid(n)) return;
                }

                Ji.delete(b);
              }
            }
          }
        }, [l, p.onBlur]),
        onClick: Object(s.useCallback)(function (e) {
          if (!l && La(b, e.target) && !Za(e, p.onClick) && Ma(e.target)) {
            var i = Ja.toSlateNode(b, e.target),
                a = Ja.findPath(b, i),
                n = ke.start(b, a),
                t = ke.end(b, a),
                o = ke.void(b, {
              at: n
            }),
                s = ke.void(b, {
              at: t
            });

            if (o && s && Ee.equals(o[1], s[1])) {
              var r = ke.range(b, n);
              Re.select(b, r);
            }
          }
        }, [l, p.onClick]),
        onCompositionEnd: Object(s.useCallback)(function (e) {
          Xa(b, e.target) && !Za(e, p.onCompositionEnd) && (A.isComposing = !1, aa || ia || !e.data || ke.insertText(b, e.data));
        }, [p.onCompositionEnd]),
        onCompositionUpdate: Object(s.useCallback)(function (e) {
          Xa(b, e.target) && !Za(e, p.onCompositionUpdate) && (A.isComposing = !0);
        }, [p.onCompositionUpdate]),
        onCompositionStart: Object(s.useCallback)(function (e) {
          if (Xa(b, e.target) && !Za(e, p.onCompositionStart)) {
            var i = b.selection;
            i && Ce.isExpanded(i) && ke.deleteFragment(b);
          }
        }, [p.onCompositionStart]),
        onCopy: Object(s.useCallback)(function (e) {
          Xa(b, e.target) && !Za(e, p.onCopy) && (e.preventDefault(), Ja.setFragmentData(b, e.clipboardData));
        }, [p.onCopy]),
        onCut: Object(s.useCallback)(function (e) {
          if (!l && Xa(b, e.target) && !Za(e, p.onCut)) {
            e.preventDefault(), Ja.setFragmentData(b, e.clipboardData);
            var i = b.selection;
            if (i) if (Ce.isExpanded(i)) ke.deleteFragment(b);else {
              var a = ve.parent(b, i.anchor.path);
              ke.isVoid(b, a) && Re.delete(b);
            }
          }
        }, [l, p.onCut]),
        onDragOver: Object(s.useCallback)(function (e) {
          if (La(b, e.target) && !Za(e, p.onDragOver)) {
            var i = Ja.toSlateNode(b, e.target);
            ke.isVoid(b, i) && e.preventDefault();
          }
        }, [p.onDragOver]),
        onDragStart: Object(s.useCallback)(function (e) {
          if (La(b, e.target) && !Za(e, p.onDragStart)) {
            var i = Ja.toSlateNode(b, e.target),
                a = Ja.findPath(b, i);

            if (ke.void(b, {
              at: a
            })) {
              var n = ke.range(b, a);
              Re.select(b, n);
            }

            Ja.setFragmentData(b, e.dataTransfer);
          }
        }, [p.onDragStart]),
        onDrop: Object(s.useCallback)(function (e) {
          if (La(b, e.target) && !l && !Za(e, p.onDrop) && (!Sa || !aa && e.dataTransfer.files.length > 0)) {
            e.preventDefault();
            var i = Ja.findEventRange(b, e),
                a = e.dataTransfer;
            Re.select(b, i), Ja.insertData(b, a);
          }
        }, [l, p.onDrop]),
        onFocus: Object(s.useCallback)(function (e) {
          if (!l && !A.isUpdatingSelection && Xa(b, e.target) && !Za(e, p.onFocus)) {
            var i = Ja.toDOMNode(b, b),
                a = Ja.findDocumentOrShadowRoot(b);
            if (A.latestElement = a.activeElement, ia && e.target !== i) return void i.focus();
            Ji.set(b, !0);
          }
        }, [l, p.onFocus]),
        onKeyDown: Object(s.useCallback)(function (e) {
          if (!l && Xa(b, e.target) && !Za(e, p.onKeyDown)) {
            var i = e.nativeEvent,
                a = b.selection,
                n = b.children[null !== a ? a.focus.path[0] : 0],
                t = "rtl" === bi()(ve.string(n));
            if (va.isRedo(i)) return e.preventDefault(), void (Oi.isHistoryEditor(b) && b.redo());
            if (va.isUndo(i)) return e.preventDefault(), void (Oi.isHistoryEditor(b) && b.undo());
            if (va.isMoveLineBackward(i)) return e.preventDefault(), void Re.move(b, {
              unit: "line",
              reverse: !0
            });
            if (va.isMoveLineForward(i)) return e.preventDefault(), void Re.move(b, {
              unit: "line"
            });
            if (va.isExtendLineBackward(i)) return e.preventDefault(), void Re.move(b, {
              unit: "line",
              edge: "focus",
              reverse: !0
            });
            if (va.isExtendLineForward(i)) return e.preventDefault(), void Re.move(b, {
              unit: "line",
              edge: "focus"
            });
            if (va.isMoveBackward(i)) return e.preventDefault(), void (a && Ce.isCollapsed(a) ? Re.move(b, {
              reverse: !t
            }) : Re.collapse(b, {
              edge: "start"
            }));
            if (va.isMoveForward(i)) return e.preventDefault(), void (a && Ce.isCollapsed(a) ? Re.move(b, {
              reverse: t
            }) : Re.collapse(b, {
              edge: "end"
            }));
            if (va.isMoveWordBackward(i)) return e.preventDefault(), a && Ce.isExpanded(a) && Re.collapse(b, {
              edge: "focus"
            }), void Re.move(b, {
              unit: "word",
              reverse: !t
            });
            if (va.isMoveWordForward(i)) return e.preventDefault(), a && Ce.isExpanded(a) && Re.collapse(b, {
              edge: "focus"
            }), void Re.move(b, {
              unit: "word",
              reverse: t
            });

            if (!Sa) {
              if (va.isBold(i) || va.isItalic(i) || va.isTransposeCharacter(i)) return void e.preventDefault();
              if (va.isSplitBlock(i)) return e.preventDefault(), void ke.insertBreak(b);
              if (va.isDeleteBackward(i)) return e.preventDefault(), void (a && Ce.isExpanded(a) ? ke.deleteFragment(b, {
                direction: "backward"
              }) : ke.deleteBackward(b));
              if (va.isDeleteForward(i)) return e.preventDefault(), void (a && Ce.isExpanded(a) ? ke.deleteFragment(b, {
                direction: "forward"
              }) : ke.deleteForward(b));
              if (va.isDeleteLineBackward(i)) return e.preventDefault(), void (a && Ce.isExpanded(a) ? ke.deleteFragment(b, {
                direction: "backward"
              }) : ke.deleteBackward(b, {
                unit: "line"
              }));
              if (va.isDeleteLineForward(i)) return e.preventDefault(), void (a && Ce.isExpanded(a) ? ke.deleteFragment(b, {
                direction: "forward"
              }) : ke.deleteForward(b, {
                unit: "line"
              }));
              if (va.isDeleteWordBackward(i)) return e.preventDefault(), void (a && Ce.isExpanded(a) ? ke.deleteFragment(b, {
                direction: "backward"
              }) : ke.deleteBackward(b, {
                unit: "word"
              }));
              if (va.isDeleteWordForward(i)) return e.preventDefault(), void (a && Ce.isExpanded(a) ? ke.deleteFragment(b, {
                direction: "forward"
              }) : ke.deleteForward(b, {
                unit: "word"
              }));
            }
          }
        }, [l, p.onKeyDown]),
        onPaste: Object(s.useCallback)(function (e) {
          l || !Xa(b, e.target) || Za(e, p.onPaste) || Sa && !function isPlainTextOnlyPaste(e) {
            return e.clipboardData && "" !== e.clipboardData.getData("text/plain") && 1 === e.clipboardData.types.length;
          }(e.nativeEvent) || (e.preventDefault(), Ja.insertData(b, e.clipboardData));
        }, [l, p.onPaste])
      }), pa({
        decorations: w,
        node: b,
        renderElement: f,
        renderPlaceholder: _,
        renderLeaf: h,
        selection: b.selection
      }))));
    },
        Ra = function DefaultPlaceholder(e) {
      var i = e.attributes,
          a = e.children;
      return r.a.createElement("span", Object.assign({}, i), a);
    },
        Ha = function defaultDecorate() {
      return [];
    },
        La = function hasTarget(e, i) {
      return Ma(i) && Ja.hasDOMNode(e, i);
    },
        Xa = function hasEditableTarget(e, i) {
      return Ma(i) && Ja.hasDOMNode(e, i, {
        editable: !0
      });
    },
        Na = function isTargetInsideVoid(e, i) {
      var a = La(e, i) && Ja.toSlateNode(e, i);
      return ke.isVoid(e, a);
    },
        Za = function isEventHandled(e, i) {
      return !!i && (i(e), e.isDefaultPrevented() || e.isPropagationStopped());
    },
        Wa = function isDOMEventHandled(e, i) {
      return !!i && (i(e), e.defaultPrevented);
    },
        Ya = 0,
        Ia = function Key() {
      _classCallCheck(this, Key), this.id = "".concat(Ya++);
    },
        Ja = {
      getWindow: function getWindow(e) {
        var i = Li.get(e);
        if (!i) throw new Error("Unable to find a host window element for this editor");
        return i;
      },
      findKey: function findKey(e, i) {
        var a = Yi.get(i);
        return a || (a = new Ia(), Yi.set(i, a)), a;
      },
      findPath: function findPath(e, i) {
        for (var a = [], n = i;;) {
          var t = Hi.get(n);

          if (null == t) {
            if (ke.isEditor(n)) return a;
            break;
          }

          var o = Ri.get(n);
          if (null == o) break;
          a.unshift(o), n = t;
        }

        throw new Error("Unable to find the path for Slate node: ".concat(JSON.stringify(i)));
      },
      findDocumentOrShadowRoot: function findDocumentOrShadowRoot(e) {
        var i = Ja.toDOMNode(e, e),
            a = i.getRootNode();
        if (i.ownerDocument !== document) return i.ownerDocument;
        if (!(a instanceof Document || a instanceof ShadowRoot)) throw new Error("Unable to find DocumentOrShadowRoot for editor element: ".concat(i));
        return void 0 === a.getSelection && null !== i.ownerDocument ? i.ownerDocument : a;
      },
      isFocused: function isFocused(e) {
        return !!Ji.get(e);
      },
      isReadOnly: function isReadOnly(e) {
        return !!Ii.get(e);
      },
      blur: function blur(e) {
        var i = Ja.toDOMNode(e, e),
            a = Ja.findDocumentOrShadowRoot(e);
        Ji.set(e, !1), a.activeElement === i && i.blur();
      },
      focus: function focus(e) {
        var i = Ja.toDOMNode(e, e),
            a = Ja.findDocumentOrShadowRoot(e);
        Ji.set(e, !0), a.activeElement !== i && i.focus({
          preventScroll: !0
        });
      },
      deselect: function deselect(e) {
        Ja.toDOMNode(e, e);
        var i = e.selection,
            a = Ja.findDocumentOrShadowRoot(e).getSelection();
        a && a.rangeCount > 0 && a.removeAllRanges(), i && Re.deselect(e);
      },
      hasDOMNode: function hasDOMNode(e, i) {
        var a,
            n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).editable,
            t = void 0 !== n && n,
            o = Ja.toDOMNode(e, e);

        try {
          a = Ba(i) ? i : i.parentElement;
        } catch (s) {
          if (!s.message.includes('Permission denied to access property "nodeType"')) throw s;
        }

        return !!a && a.closest("[data-slate-editor]") === o && (!t || a.isContentEditable || !!a.getAttribute("data-slate-zero-width"));
      },
      insertData: function insertData(e, i) {
        e.insertData(i);
      },
      setFragmentData: function setFragmentData(e, i) {
        e.setFragmentData(i);
      },
      toDOMNode: function toDOMNode(e, i) {
        var a = ke.isEditor(i) ? Xi.get(e) : Zi.get(Ja.findKey(e, i));
        if (!a) throw new Error("Cannot resolve a DOM node from Slate node: ".concat(JSON.stringify(i)));
        return a;
      },
      toDOMPoint: function toDOMPoint(e, i) {
        var a,
            n = _slicedToArray(ke.node(e, i.path), 1)[0],
            t = Ja.toDOMNode(e, n);

        ke.void(e, {
          at: i
        }) && (i = {
          path: i.path,
          offset: 0
        });

        for (var o = 0, s = 0, r = Array.from(t.querySelectorAll("[data-slate-string], [data-slate-zero-width]")); s < r.length; s++) {
          var g = r[s],
              l = g.childNodes[0];

          if (null != l && null != l.textContent) {
            var f = l.textContent.length,
                h = g.getAttribute("data-slate-length"),
                m = o + (null == h ? f : parseInt(h, 10));

            if (i.offset <= m) {
              a = [l, Math.min(f, Math.max(0, i.offset - o))];
              break;
            }

            o = m;
          }
        }

        if (!a) throw new Error("Cannot resolve a DOM point from Slate point: ".concat(JSON.stringify(i)));
        return a;
      },
      toDOMRange: function toDOMRange(e, i) {
        var a = i.anchor,
            n = i.focus,
            t = Ce.isBackward(i),
            o = Ja.toDOMPoint(e, a),
            s = Ce.isCollapsed(i) ? o : Ja.toDOMPoint(e, n),
            r = Ja.getWindow(e).document.createRange(),
            g = _slicedToArray(t ? s : o, 2),
            l = g[0],
            f = g[1],
            h = _slicedToArray(t ? o : s, 2),
            m = h[0],
            _ = h[1],
            d = !!(Ba(l) ? l : l.parentElement).getAttribute("data-slate-zero-width"),
            c = !!(Ba(m) ? m : m.parentElement).getAttribute("data-slate-zero-width");

        return r.setStart(l, d ? 1 : f), r.setEnd(m, c ? 1 : _), r;
      },
      toSlateNode: function toSlateNode(e, i) {
        var a = Ba(i) ? i : i.parentElement;
        a && !a.hasAttribute("data-slate-node") && (a = a.closest("[data-slate-node]"));
        var n = a ? Ni.get(a) : null;
        if (!n) throw new Error("Cannot resolve a Slate node from DOM node: ".concat(a));
        return n;
      },
      findEventRange: function findEventRange(e, i) {
        "nativeEvent" in i && (i = i.nativeEvent);
        var a = i,
            n = a.clientX,
            t = a.clientY,
            o = a.target;
        if (null == n || null == t) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(i));
        var s,
            r = Ja.toSlateNode(e, i.target),
            g = Ja.findPath(e, r);

        if (ke.isVoid(e, r)) {
          var l = o.getBoundingClientRect(),
              f = e.isInline(r) ? n - l.left < l.left + l.width - n : t - l.top < l.top + l.height - t,
              h = ke.point(e, g, {
            edge: f ? "start" : "end"
          }),
              m = f ? ke.before(e, h) : ke.after(e, h);
          if (m) return ke.range(e, m);
        }

        var _ = window.document;
        if (_.caretRangeFromPoint) s = _.caretRangeFromPoint(n, t);else {
          var d = _.caretPositionFromPoint(n, t);

          d && ((s = _.createRange()).setStart(d.offsetNode, d.offset), s.setEnd(d.offsetNode, d.offset));
        }
        if (!s) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(i));
        return Ja.toSlateRange(e, s, {
          exactMatch: !1
        });
      },
      toSlatePoint: function toSlatePoint(e, i, a) {
        var n = a ? i : function normalizeDOMPoint(e) {
          var i = _slicedToArray(e, 2),
              a = i[0],
              n = i[1];

          if (Ba(a) && a.childNodes.length) {
            var t = n === a.childNodes.length,
                o = t ? n - 1 : n,
                s = _slicedToArray(Oa(a, o, t ? "backward" : "forward"), 2);

            for (a = s[0], t = (o = s[1]) < n; Ba(a) && a.childNodes.length;) {
              var r = t ? a.childNodes.length - 1 : 0;
              a = Ta(a, r, t ? "backward" : "forward");
            }

            n = t && null != a.textContent ? a.textContent.length : 0;
          }

          return [a, n];
        }(i),
            t = _slicedToArray(n, 2),
            o = t[0],
            s = t[1],
            r = o.parentNode,
            g = null,
            l = 0;

        if (r) {
          var f = r.closest('[data-slate-void="true"]'),
              h = r.closest("[data-slate-leaf]"),
              m = null;

          if (h) {
            g = h.closest('[data-slate-node="text"]');

            var _ = Ja.getWindow(e).document.createRange();

            _.setStart(g, 0), _.setEnd(o, s);

            var d = _.cloneContents();

            [].concat(_toConsumableArray(Array.prototype.slice.call(d.querySelectorAll("[data-slate-zero-width]"))), _toConsumableArray(Array.prototype.slice.call(d.querySelectorAll("[contenteditable=false]")))).forEach(function (e) {
              e.parentNode.removeChild(e);
            }), l = d.textContent.length, m = g;
          } else f && ((h = f.querySelector("[data-slate-leaf]")) ? (g = h.closest('[data-slate-node="text"]'), l = (m = h).textContent.length, m.querySelectorAll("[data-slate-zero-width]").forEach(function (e) {
            l -= e.textContent.length;
          })) : l = 1);

          m && l === m.textContent.length && r.hasAttribute("data-slate-zero-width") && l--;
        }

        if (!g) {
          if (a) return null;
          throw new Error("Cannot resolve a Slate point from DOM point: ".concat(i));
        }

        var c = Ja.toSlateNode(e, g);
        return {
          path: Ja.findPath(e, c),
          offset: l
        };
      },
      toSlateRange: function toSlateRange(e, i, a) {
        var n,
            t,
            o,
            s,
            r,
            g = a.exactMatch;
        if ((qa(i) ? i.anchorNode : i.startContainer) && (qa(i) ? (n = i.anchorNode, t = i.anchorOffset, o = i.focusNode, s = i.focusOffset, r = ta && function hasShadowRoot() {
          return !(!window.document.activeElement || !window.document.activeElement.shadowRoot);
        }() ? i.anchorNode === i.focusNode && i.anchorOffset === i.focusOffset : i.isCollapsed) : (n = i.startContainer, t = i.startOffset, o = i.endContainer, s = i.endOffset, r = i.collapsed)), null == n || null == o || null == t || null == s) throw new Error("Cannot resolve a Slate range from DOM range: ".concat(i));
        var l = Ja.toSlatePoint(e, [n, t], g);
        if (!l) return null;
        var f = r ? l : Ja.toSlatePoint(e, [o, s], g);
        return f ? {
          anchor: l,
          focus: f
        } : null;
      },
      hasRange: function hasRange(e, i) {
        var a = i.anchor,
            n = i.focus;
        return ke.hasPath(e, a.path) && ke.hasPath(e, n.path);
      }
    },
        Ua = Object(s.createContext)(!1),
        Ga = function Slate(e) {
      var i = e.editor,
          a = e.children,
          n = e.onChange,
          t = e.value,
          o = index_es_objectWithoutProperties(e, ["editor", "children", "onChange", "value"]),
          g = _slicedToArray(Object(s.useState)(0), 2),
          l = g[0],
          f = g[1],
          h = Object(s.useMemo)(function () {
        return xi(ve.isNodeList(t), "[Slate] value is invalid! Expected a list of elements but got: ".concat(JSON.stringify(t))), xi(ke.isEditor(i), "[Slate] editor is invalid! you passed: ".concat(JSON.stringify(i))), i.children = t, Object.assign(i, o), [i];
      }, [l, t].concat(_toConsumableArray(Object.values(o)))),
          m = Object(s.useCallback)(function () {
        n(i.children), f(l + 1);
      }, [l, n]);

      Ui.set(i, m), Object(s.useEffect)(function () {
        return function () {
          Ui.set(i, function () {});
        };
      }, []);

      var _ = _slicedToArray(Object(s.useState)(Ja.isFocused(i)), 2),
          d = _[0],
          c = _[1];

      return Object(s.useEffect)(function () {
        c(Ja.isFocused(i));
      }), sa(function () {
        var e = function fn() {
          return c(Ja.isFocused(i));
        };

        return document.addEventListener("focus", e, !0), function () {
          return document.removeEventListener("focus", e, !0);
        };
      }, []), sa(function () {
        var e = function fn() {
          return c(Ja.isFocused(i));
        };

        return document.addEventListener("blur", e, !0), function () {
          return document.removeEventListener("blur", e, !0);
        };
      }, []), r.a.createElement(ja.Provider, {
        value: h
      }, r.a.createElement(ca.Provider, {
        value: i
      }, r.a.createElement(Ua.Provider, {
        value: d
      }, a)));
    },
        Va = function doRectsIntersect(e, i) {
      var a = (i.top + i.bottom) / 2;
      return e.top <= a && e.bottom >= a;
    },
        Ka = function areRangesSameLine(e, i, a) {
      var n = Ja.toDOMRange(e, i).getBoundingClientRect(),
          t = Ja.toDOMRange(e, a).getBoundingClientRect();
      return Va(n, t) && Va(t, n);
    },
        Qa = function withReact(e) {
      var i = e,
          a = i.apply,
          n = i.onChange,
          t = i.deleteBackward;
      return i.deleteBackward = function (a) {
        if ("line" !== a) return t(a);

        if (e.selection && Ce.isCollapsed(e.selection)) {
          var n = ke.above(e, {
            match: function match(i) {
              return ke.isBlock(e, i);
            },
            at: e.selection
          });

          if (n) {
            var o = _slicedToArray(n, 2)[1],
                s = ke.range(e, o, e.selection.anchor),
                r = function findCurrentLineRange(e, i) {
              var a = ke.range(e, Ce.end(i)),
                  n = Array.from(ke.positions(e, {
                at: i
              })),
                  t = 0,
                  o = n.length,
                  s = Math.floor(o / 2);
              if (Ka(e, ke.range(e, n[t]), a)) return ke.range(e, n[t], a);
              if (n.length < 2) return ke.range(e, n[n.length - 1], a);

              for (; s !== n.length && s !== t;) {
                Ka(e, ke.range(e, n[s]), a) ? o = s : t = s, s = Math.floor((t + o) / 2);
              }

              return ke.range(e, n[o], a);
            }(i, s);

            Ce.isCollapsed(r) || Re.delete(e, {
              at: r
            });
          }
        }
      }, i.apply = function (e) {
        var n = [];

        switch (e.type) {
          case "insert_text":
          case "remove_text":
          case "set_node":
            var t,
                o = _createForOfIteratorHelper(ke.levels(i, {
              at: e.path
            }));

            try {
              for (o.s(); !(t = o.n()).done;) {
                var s = _slicedToArray(t.value, 2),
                    r = s[0],
                    g = s[1],
                    l = Ja.findKey(i, r);

                n.push([g, l]);
              }
            } catch (x) {
              o.e(x);
            } finally {
              o.f();
            }

            break;

          case "insert_node":
          case "remove_node":
          case "merge_node":
          case "split_node":
            var f,
                h = _createForOfIteratorHelper(ke.levels(i, {
              at: Ee.parent(e.path)
            }));

            try {
              for (h.s(); !(f = h.n()).done;) {
                var m = _slicedToArray(f.value, 2),
                    _ = m[0],
                    d = m[1],
                    c = Ja.findKey(i, _);

                n.push([d, c]);
              }
            } catch (x) {
              h.e(x);
            } finally {
              h.f();
            }

            break;

          case "move_node":
            var F,
                u = _createForOfIteratorHelper(ke.levels(i, {
              at: Ee.common(Ee.parent(e.path), Ee.parent(e.newPath))
            }));

            try {
              for (u.s(); !(F = u.n()).done;) {
                var p = _slicedToArray(F.value, 2),
                    b = p[0],
                    k = p[1],
                    A = Ja.findKey(i, b);

                n.push([k, A]);
              }
            } catch (x) {
              u.e(x);
            } finally {
              u.f();
            }

        }

        a(e);

        for (var y = 0, v = n; y < v.length; y++) {
          var w = _slicedToArray(v[y], 2),
              E = w[0],
              j = w[1],
              D = _slicedToArray(ke.node(i, E), 1)[0];

          Yi.set(D, j);
        }
      }, i.setFragmentData = function (e) {
        var a = i.selection;

        if (a) {
          var n = _slicedToArray(Ce.edges(a), 2),
              t = n[0],
              o = n[1],
              s = ke.void(i, {
            at: t.path
          }),
              r = ke.void(i, {
            at: o.path
          });

          if (!Ce.isCollapsed(a) || s) {
            var g = Ja.toDOMRange(i, a),
                l = g.cloneContents(),
                f = l.childNodes[0];

            if (l.childNodes.forEach(function (e) {
              e.textContent && "" !== e.textContent.trim() && (f = e);
            }), r) {
              var h = _slicedToArray(r, 1)[0],
                  m = g.cloneRange(),
                  _ = Ja.toDOMNode(i, h);

              m.setEndAfter(_), l = m.cloneContents();
            }

            if (s && (f = l.querySelector("[data-slate-spacer]")), Array.from(l.querySelectorAll("[data-slate-zero-width]")).forEach(function (e) {
              var i = "n" === e.getAttribute("data-slate-zero-width");
              e.textContent = i ? "\n" : "";
            }), Pa(f)) {
              var d = document.createElement("span");
              d.style.whiteSpace = "pre", d.appendChild(f), l.appendChild(d), f = d;
            }

            var c = i.getFragment(),
                F = JSON.stringify(c),
                u = window.btoa(encodeURIComponent(F));
            f.setAttribute("data-slate-fragment", u), e.setData("application/x-slate-fragment", u);
            var p = document.createElement("div");
            p.appendChild(l), p.setAttribute("hidden", "true"), document.body.appendChild(p), e.setData("text/html", p.innerHTML), e.setData("text/plain", function getPlainText(e) {
              var i = "";
              if (Pa(e) && e.nodeValue) return e.nodeValue;

              if (Ba(e)) {
                for (var a = 0, n = Array.from(e.childNodes); a < n.length; a++) {
                  i += getPlainText(n[a]);
                }

                var t = getComputedStyle(e).getPropertyValue("display");
                "block" !== t && "list" !== t && "BR" !== e.tagName || (i += "\n");
              }

              return i;
            }(p)), document.body.removeChild(p);
          }
        }
      }, i.insertData = function (e) {
        var a = e.getData("application/x-slate-fragment");

        if (a) {
          var n = decodeURIComponent(window.atob(a)),
              t = JSON.parse(n);
          i.insertFragment(t);
        } else {
          var o = e.getData("text/plain");

          if (o) {
            var s,
                r = !1,
                g = _createForOfIteratorHelper(o.split(/\r\n|\r|\n/));

            try {
              for (g.s(); !(s = g.n()).done;) {
                var l = s.value;
                r && Re.splitNodes(i, {
                  always: !0
                }), i.insertText(l), r = !0;
              }
            } catch (f) {
              g.e(f);
            } finally {
              g.f();
            }
          }
        }
      }, i.onChange = function () {
        Bi.a.unstable_batchedUpdates(function () {
          var e = Ui.get(i);
          e && e(), n();
        });
      }, i;
    },
        $a = t(5),
        en = t.n($a),
        an = (t(116), t(118), t(8)),
        nn = t.n(an),
        tn = t(4),
        on = nn()(function ResizeImageMenu(e) {
      var i = e.imgAltText,
          a = e.imgHeight,
          n = e.imgWidth,
          t = Da(),
          o = a / n,
          g = _slicedToArray(Object(s.useState)(i), 2),
          l = g[0],
          f = g[1],
          h = _slicedToArray(Object(s.useState)(a), 2),
          m = h[0],
          _ = h[1],
          d = _slicedToArray(Object(s.useState)(n), 2),
          c = d[0],
          F = d[1],
          u = function onChangeWidthOrHeight(e) {
        var i = e.newWidth,
            a = void 0 === i ? 0 : i,
            n = e.newHeight,
            s = void 0 === n ? 0 : n;
        s > 0 ? a = s / o : a > 0 && (s = o * a);
        var r = {
          width: a,
          height: s
        };
        Re.setNodes(t, r), _(s), F(a);
      };

      return r.a.createElement(gi.Div, {
        className: "resizable-inputs-wrapper"
      }, r.a.createElement(gi.Div, {
        className: "resizable-inputs-wrapper-row"
      }, r.a.createElement(gi.Label, null, "Width"), r.a.createElement(gi.Input, {
        className: "image-resize-input",
        onChange: function onChange(e) {
          return u({
            newWidth: e.target.value
          });
        },
        type: "number",
        value: c,
        inline: !0,
        placeholder: "default"
      }), r.a.createElement(gi.Div, {
        className: "width-input-unit"
      }, "px"), r.a.createElement(gi.Label, null, "Height"), r.a.createElement(gi.Input, {
        className: "image-resize-input",
        onChange: function onChange(e) {
          return u({
            newHeight: e.target.value
          });
        },
        type: "number",
        value: m,
        inline: !0,
        placeholder: "default"
      }), "px"), r.a.createElement(gi.Input, {
        label: "Link",
        className: "alt-text-input",
        onBlur: function onChangeAltText() {
          !function unwrapLinkedImage(e) {
            Re.unwrapNodes(e, {
              match: function match(e) {
                return !ke.isEditor(e) && pe.isElement(e) && "image-link" === e.type;
              }
            });
          }(t), l && function wrapImageWithLink(e, i) {
            var a = {
              type: "image-link",
              target: "_blank",
              url: i
            };
            Re.wrapNodes(e, a);
          }(t, l);
          var e = {
            alt: l
          };
          Re.setNodes(t, e), Re.deselect(t);
        },
        onChange: function onChange(e) {
          f(e.target.value);
        },
        type: "text",
        value: l,
        placeholder: "Type or paste a link"
      }));
    }),
        sn = function Image(e) {
      var i = e.attributes,
          a = e.children,
          n = e.element,
          t = e.hideImageControls,
          o = function useSelected() {
        return Object(s.useContext)(ha);
      }(),
          g = Da(),
          l = o && !t;

      return r.a.createElement("div", i, r.a.createElement("div", {
        contentEditable: !1
      }, r.a.createElement("img", {
        alt: n.alt,
        src: n.url,
        width: n.width,
        className: en()("email-wysiwyg-image", {
          "email-wysiwyg-image--focused": l
        })
      })), l && rn(g), a);
    },
        rn = function renderResizableImageMenu(e) {
      var i = Object(tn.pathOr)(null, ["selection", "anchor", "path", "0"], e),
          a = Object(tn.pathOr)(null, ["children", i], e);

      if (a) {
        var n = Ja.toDOMNode(e, a).querySelector("img.email-wysiwyg-image");
        if (n) return r.a.createElement("div", {
          contentEditable: !1
        }, r.a.createElement(on, {
          imgAltText: n.alt,
          imgHeight: n.height,
          imgWidth: n.width
        }));
      }
    },
        gn = t(65),
        ln = t.n(gn),
        hn = {
      EM: function EM() {
        return {
          italic: !0
        };
      },
      STRONG: function STRONG() {
        return {
          bold: !0
        };
      },
      U: function U() {
        return {
          underline: !0
        };
      }
    },
        mn = function Element(e) {
      var i = e.attributes,
          a = e.children,
          n = e.element,
          t = e.hideImageControls;

      switch (n.type) {
        case "link":
          return r.a.createElement(gi.ToolTip, {
            flow: "right",
            render: function render() {
              return r.a.createElement("div", {
                className: "email-wysiwyg-link-tooltip"
              }, n.url);
            }
          }, r.a.createElement("a", Object.assign({}, i, {
            href: n.url,
            target: n.target
          }), a));

        case "image-link":
          return r.a.createElement("a", Object.assign({}, i, {
            href: n.url,
            target: n.target
          }), a);

        case "division":
          return r.a.createElement("div", i, a);

        case "image":
          return r.a.createElement(sn, {
            attributes: i,
            children: a,
            element: n,
            hideImageControls: t
          });

        case "text-span":
          var o = "contentVariable" === n.propertySource ? {
            "data-contentvareditordisplay": n.propertyName
          } : {};
          return r.a.createElement("span", Object.assign({}, i, {
            className: n.class,
            children: a
          }, o));

        case "bulleted-list":
          return r.a.createElement("ul", i, a);

        case "list-item":
          return r.a.createElement("li", i, a);

        case "numbered-list":
          return r.a.createElement("ol", i, a);

        default:
          return r.a.createElement("div", i, a);
      }
    },
        _n = {
      "mod+b": "bold",
      "mod+i": "italic",
      "mod+u": "underline",
      "mod+`": "code"
    },
        dn = ["numbered-list", "bulleted-list"],
        cn = {
      bold: {
        name: "Bold",
        icon: "bold",
        type: "mark"
      },
      underline: {
        name: "Underline",
        icon: "underline",
        type: "mark"
      },
      italic: {
        name: "Italic",
        icon: "text-italic",
        type: "mark"
      },
      "numbered-list": {
        name: "Numbered List",
        icon: "list-numbers",
        type: "block"
      },
      "bulleted-list": {
        name: "Bulleted List",
        icon: "list-bullets",
        type: "block"
      },
      link: {
        name: "Link",
        icon: "link-1",
        type: "content"
      },
      emoji: {
        name: "Emoji",
        icon: "emoji-face",
        type: "content"
      },
      image: {
        name: "Image",
        icon: "photo",
        type: "content"
      },
      personalization: {
        name: "Personalization",
        icon: "shopping-tag",
        type: "drift"
      },
      bookAMeeting: {
        name: "Book a meeting",
        icon: "calendar-check",
        type: "drift"
      },
      dynamicContent: {
        name: "Dynamic content",
        icon: "config-1",
        type: "drift"
      }
    },
        Fn = t(7),
        un = (t(52), t(20)),
        pn = function pn(e, i) {
      if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
    },
        bn = Object,
        kn = function createClass() {
      function defineProperties(e, i) {
        for (var a = 0; a < i.length; a++) {
          var n = i[a];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), bn.defineProperty(e, n.key, n);
        }
      }

      return function (e, i, a) {
        return i && defineProperties(e.prototype, i), a && defineProperties(e, a), e;
      };
    }(),
        An = t(25),
        yn = t.n(An),
        vn = Object.prototype.hasOwnProperty,
        wn = !{
      toString: null
    }.propertyIsEnumerable("toString"),
        En = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
        jn = En.length,
        Dn = function Dn(e) {
      if ("function" !== typeof e && ("object" !== typeof e || null === e)) throw new TypeError("Object.keys called on non-object");
      var i,
          a,
          n = [];

      for (i in e) {
        vn.call(e, i) && n.push(i);
      }

      if (wn) for (a = 0; a < jn; a++) {
        vn.call(e, En[a]) && n.push(En[a]);
      }
      return n;
    },
        xn = {
      name: "a",
      unified: "b",
      non_qualified: "c",
      has_img_apple: "d",
      has_img_google: "e",
      has_img_twitter: "f",
      has_img_emojione: "g",
      has_img_facebook: "h",
      has_img_messenger: "i",
      keywords: "j",
      sheet: "k",
      emoticons: "l",
      text: "m",
      short_names: "n",
      added_in: "o"
    },
        Cn = function buildSearch(e) {
      var i = [],
          a = function addToSearch(e, a) {
        e && (Array.isArray(e) ? e : [e]).forEach(function (e) {
          (a ? e.split(/[-|_|\s]+/) : [e]).forEach(function (e) {
            e = e.toLowerCase(), -1 == i.indexOf(e) && i.push(e);
          });
        });
      };

      return a(e.short_names, !0), a(e.name, !0), a(e.keywords, !1), a(e.emoticons, !1), i.join(",");
    },
        Bn = function uncompress(e) {
      for (var i in e.compressed = !1, e.emojis) {
        var a = e.emojis[i];

        for (var n in xn) {
          a[n] = a[xn[n]], delete a[xn[n]];
        }

        a.short_names || (a.short_names = []), a.short_names.unshift(i), a.sheet_x = a.sheet[0], a.sheet_y = a.sheet[1], delete a.sheet, a.text || (a.text = ""), a.added_in || (a.added_in = 6), a.added_in = a.added_in.toFixed(1), a.search = Cn(a);
      }
    },
        Mn = String.fromCodePoint || function stringFromCodePoint() {
      var e,
          i,
          a = [],
          n = -1,
          t = arguments.length;
      if (!t) return "";

      for (var o = ""; ++n < t;) {
        var s = Number(arguments[n]);
        if (!isFinite(s) || s < 0 || s > 1114111 || Math.floor(s) != s) throw RangeError("Invalid code point: " + s);
        s <= 65535 ? a.push(s) : (e = 55296 + ((s -= 65536) >> 10), i = s % 1024 + 56320, a.push(e, i)), (n + 1 === t || a.length > 16384) && (o += String.fromCharCode.apply(null, a), a.length = 0);
      }

      return o;
    },
        qn = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/,
        Pn = ["1F3FA", "1F3FB", "1F3FC", "1F3FD", "1F3FE", "1F3FF"];

    function unifiedToNative(e) {
      var i = e.split("-").map(function (e) {
        return "0x" + e;
      });
      return Mn.apply(null, i);
    }

    function getSanitizedData() {
      return function sanitize(e) {
        var i = e.name,
            a = e.short_names,
            n = e.skin_tone,
            t = e.skin_variations,
            o = e.emoticons,
            s = e.unified,
            r = e.custom,
            g = e.customCategory,
            l = e.imageUrl,
            f = e.id || a[0],
            h = ":" + f + ":";
        return r ? {
          id: f,
          name: i,
          short_names: a,
          colons: h,
          emoticons: o,
          custom: r,
          customCategory: g,
          imageUrl: l
        } : (n && (h += ":skin-tone-" + n + ":"), {
          id: f,
          name: i,
          short_names: a,
          colons: h,
          emoticons: o,
          unified: s.toLowerCase(),
          skin: n || (t ? 1 : null),
          native: unifiedToNative(s)
        });
      }(getData.apply(void 0, arguments));
    }

    function getData(e, i, a, n) {
      var t = {};

      if ("string" == typeof e) {
        var o = e.match(qn);
        if (o && (e = o[1], o[2] && (i = parseInt(o[2], 10))), n.aliases.hasOwnProperty(e) && (e = n.aliases[e]), !n.emojis.hasOwnProperty(e)) return null;
        t = n.emojis[e];
      } else e.id && (n.aliases.hasOwnProperty(e.id) && (e.id = n.aliases[e.id]), n.emojis.hasOwnProperty(e.id) && (t = n.emojis[e.id], i || (i = e.skin)));

      if (Dn(t).length || ((t = e).custom = !0, t.search || (t.search = Cn(e))), t.emoticons || (t.emoticons = []), t.variations || (t.variations = []), t.skin_variations && i > 1) {
        t = JSON.parse(yn()(t));
        var s = Pn[i - 1],
            r = t.skin_variations[s];
        if (!r.variations && t.variations && delete t.variations, a && (void 0 == r["has_img_" + a] || r["has_img_" + a]) || !a) for (var g in t.skin_tone = i, r) {
          var l = r[g];
          t[g] = l;
        }
      }

      return t.variations && t.variations.length && ((t = JSON.parse(yn()(t))).unified = t.variations.shift()), t;
    }

    function uniq(e) {
      return e.reduce(function (e, i) {
        return -1 === e.indexOf(i) && e.push(i), e;
      }, []);
    }

    function deepMerge(e, i) {
      var a = {};

      for (var n in e) {
        var t = e[n],
            o = t;
        i.hasOwnProperty(n) && (o = i[n]), "object" === typeof o && (o = deepMerge(t, o)), a[n] = o;
      }

      return a;
    }

    var On = "emoji-mart",
        Tn = "undefined" !== typeof window && "localStorage" in window,
        Sn = void 0,
        zn = void 0;

    function store_set(e, i) {
      if (zn) zn(e, i);else {
        if (!Tn) return;

        try {
          window.localStorage[On + "." + e] = yn()(i);
        } catch (a) {}
      }
    }

    var Rn = {
      update: function update(e) {
        for (var i in e) {
          store_set(i, e[i]);
        }
      },
      set: store_set,
      get: function get(e) {
        if (Sn) return Sn(e);
        if (Tn) try {
          var i = window.localStorage[On + "." + e];
          if (i) return JSON.parse(i);
        } catch (a) {
          return;
        }
      },
      setNamespace: function setNamespace(e) {
        On = e;
      },
      setHandlers: function setHandlers(e) {
        e || (e = {}), Sn = e.getter, zn = e.setter;
      }
    },
        Hn = function () {
      function NimbleEmojiIndex(e, i) {
        pn(this, NimbleEmojiIndex), e.compressed && Bn(e), this.data = e || {}, this.set = i || null, this.originalPool = {}, this.index = {}, this.emojis = {}, this.emoticons = {}, this.customEmojisList = [], this.buildIndex();
      }

      return kn(NimbleEmojiIndex, [{
        key: "buildIndex",
        value: function buildIndex() {
          var e = this,
              i = function _loop(i) {
            var a = e.data.emojis[i],
                n = a.short_names,
                t = a.emoticons,
                o = a.skin_variations,
                s = n[0];

            if (t && t.forEach(function (i) {
              e.emoticons[i] || (e.emoticons[i] = s);
            }), o) {
              e.emojis[s] = {};

              for (var r = 1; r <= 6; r++) {
                e.emojis[s][r] = getSanitizedData({
                  id: s,
                  skin: r
                }, r, e.set, e.data);
              }
            } else e.emojis[s] = getSanitizedData(s, null, e.set, e.data);

            e.originalPool[s] = a;
          };

          for (var a in this.data.emojis) {
            i(a);
          }
        }
      }, {
        key: "clearCustomEmojis",
        value: function clearCustomEmojis(e) {
          var i = this;
          this.customEmojisList.forEach(function (a) {
            var n = a.id || a.short_names[0];
            delete e[n], delete i.emojis[n];
          });
        }
      }, {
        key: "addCustomToPool",
        value: function addCustomToPool(e, i) {
          var a = this;
          this.customEmojisList.length && this.clearCustomEmojis(i), e.forEach(function (e) {
            var n = e.id || e.short_names[0];
            n && !i[n] && (i[n] = getData(e, null, null, a.data), a.emojis[n] = getSanitizedData(e, null, null, a.data));
          }), this.customEmojisList = e, this.index = {};
        }
      }, {
        key: "search",
        value: function search(e) {
          var i = this,
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = a.emojisToShowFilter,
              t = a.maxResults,
              o = a.include,
              s = a.exclude,
              r = a.custom,
              g = void 0 === r ? [] : r;
          this.customEmojisList != g && this.addCustomToPool(g, this.originalPool);
          var l = Rn.get("skin") || 1;
          t || (t = 75), o || (o = []), s || (s = []);
          var f = null,
              h = this.originalPool;

          if (e.length) {
            if ("-" == e || "-1" == e) return [this.emojis[-1][l]];

            var m,
                _ = e.toLowerCase().split(/[\s|,|\-|_]+/);

            if (_.length > 2 && (_ = [_[0], _[1]]), (o.length || s.length) && (h = {}, this.data.categories.forEach(function (e) {
              var a = !o || !o.length || o.indexOf(e.id) > -1,
                  n = !(!s || !s.length) && s.indexOf(e.id) > -1;
              a && !n && e.emojis.forEach(function (e) {
                return h[e] = i.data.emojis[e];
              });
            }), g.length)) {
              var d = !o || !o.length || o.indexOf("custom") > -1,
                  c = !(!s || !s.length) && s.indexOf("custom") > -1;
              d && !c && this.addCustomToPool(g, h);
            }

            f = (m = _.map(function (e) {
              for (var a = h, n = i.index, t = 0, o = 0; o < e.length; o++) {
                var s = e[o];
                t++, n[s] || (n[s] = {}), (n = n[s]).results || function () {
                  var o = {};

                  for (var s in n.results = [], n.pool = {}, a) {
                    var r = a[s],
                        g = r.search,
                        f = e.substr(0, t),
                        h = g.indexOf(f);

                    if (-1 != h) {
                      var m = h + 1;
                      f == s && (m = 0), i.emojis[s] && i.emojis[s][l] ? n.results.push(i.emojis[s][l]) : n.results.push(i.emojis[s]), n.pool[s] = r, o[s] = m;
                    }
                  }

                  n.results.sort(function (e, i) {
                    var a = o[e.id],
                        n = o[i.id];
                    return a == n ? e.id.localeCompare(i.id) : a - n;
                  });
                }(), a = n.pool;
              }

              return n.results;
            }).filter(function (e) {
              return e;
            })).length > 1 ? function intersect(e, i) {
              var a = uniq(e),
                  n = uniq(i);
              return a.filter(function (e) {
                return n.indexOf(e) >= 0;
              });
            }.apply(null, m) : m.length ? m[0] : [];
          }

          return f && (n && (f = f.filter(function (e) {
            return n(h[e.id]);
          })), f && f.length > t && (f = f.slice(0, t))), f;
        }
      }]), NimbleEmojiIndex;
    }(),
        Ln = new Hn(un);

    Ln.emojis, Ln.emoticons;
    var Xn = ["+1", "grinning", "kissing_heart", "heart_eyes", "laughing", "stuck_out_tongue_winking_eye", "sweat_smile", "joy", "scream", "disappointed", "unamused", "weary", "sob", "sunglasses", "heart", "poop"],
        Nn = void 0,
        Zn = void 0,
        Wn = {};

    function init() {
      Zn = !0, Nn = Rn.get("frequently");
    }

    var Yn = {
      add: function frequently_add(e) {
        Zn || init();
        var i = e.id;
        Nn || (Nn = Wn), Nn[i] || (Nn[i] = 0), Nn[i] += 1, Rn.set("last", i), Rn.set("frequently", Nn);
      },
      get: function frequently_get(e) {
        if (Zn || init(), !Nn) {
          Wn = {};

          for (var i = [], a = 0; a < e; a++) {
            Wn[Xn[a]] = e - a, i.push(Xn[a]);
          }

          return i;
        }

        var n = 4 * e,
            t = [];

        for (var o in Nn) {
          Nn.hasOwnProperty(o) && t.push(o);
        }

        var s = t.sort(function (e, i) {
          return Nn[e] - Nn[i];
        }).reverse().slice(0, n),
            r = Rn.get("last");
        return r && -1 == s.indexOf(r) && (s.pop(), s.push(r)), s;
      }
    },
        In = Object.assign || function (e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = arguments[i];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
        }
      }

      return e;
    },
        Jn = Object.getPrototypeOf || function (e) {
      return "function" === typeof (e = Object(e)).constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? Object.prototype : null;
    };

    function possibleConstructorReturn(e, i) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !i || "object" !== typeof i && "function" !== typeof i ? e : i;
    }

    var Un = Object;

    function inherits(e, i) {
      if ("function" !== typeof i && null !== i) throw new TypeError("Super expression must either be null or a function, not " + typeof i);
      e.prototype = Un.create(i && i.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), i && (Un.setPrototypeOf ? Un.setPrototypeOf(e, i) : e.__proto__ = i);
    }

    var Gn = t(109),
        Vn = t.n(Gn),
        Kn = t(110),
        Qn = t.n(Kn),
        $n = (t(253), t(1)),
        et = t.n($n),
        it = {
      activity: function activity() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
        }));
      },
      custom: function custom() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("g", {
          transform: "translate(2.000000, 1.000000)"
        }, r.a.createElement("rect", {
          id: "Rectangle",
          x: "8",
          y: "0",
          width: "3",
          height: "21",
          rx: "1.5"
        }), r.a.createElement("rect", {
          id: "Rectangle",
          transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
          x: "8.343",
          y: "0.049",
          width: "3",
          height: "21",
          rx: "1.5"
        }), r.a.createElement("rect", {
          id: "Rectangle",
          transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
          x: "8.343",
          y: "0.049",
          width: "3",
          height: "21",
          rx: "1.5"
        })));
      },
      flags: function flags() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
        }));
      },
      foods: function foods() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
        }));
      },
      nature: function nature() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
        }), r.a.createElement("path", {
          d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
        }));
      },
      objects: function objects() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
        }), r.a.createElement("path", {
          d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
        }));
      },
      people: function people() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        }), r.a.createElement("path", {
          d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
        }));
      },
      places: function places() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
        }), r.a.createElement("path", {
          d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
        }));
      },
      recent: function recent() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
        }), r.a.createElement("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        }));
      },
      symbols: function symbols() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, r.a.createElement("path", {
          d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
        }));
      }
    },
        at = {
      search: function search() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "13",
          height: "13",
          viewBox: "0 0 20 20",
          opacity: "0.5"
        }, r.a.createElement("path", {
          d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
        }));
      },
      delete: function _delete() {
        return r.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "13",
          height: "13",
          viewBox: "0 0 20 20",
          opacity: "0.5"
        }, r.a.createElement("path", {
          d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
        }));
      }
    },
        nt = {
      data: et.a.object.isRequired,
      onOver: et.a.func,
      onLeave: et.a.func,
      onClick: et.a.func,
      fallback: et.a.func,
      backgroundImageFn: et.a.func,
      native: et.a.bool,
      forceSize: et.a.bool,
      tooltip: et.a.bool,
      skin: et.a.oneOf([1, 2, 3, 4, 5, 6]),
      sheetSize: et.a.oneOf([16, 20, 32, 64]),
      sheetColumns: et.a.number,
      sheetRows: et.a.number,
      set: et.a.oneOf(["apple", "google", "twitter", "emojione", "messenger", "facebook"]),
      size: et.a.number.isRequired,
      emoji: et.a.oneOfType([et.a.string, et.a.object]).isRequired
    },
        tt = {
      onClick: et.a.func,
      onSelect: et.a.func,
      onSkinChange: et.a.func,
      perLine: et.a.number,
      emojiSize: et.a.number,
      i18n: et.a.object,
      style: et.a.object,
      title: et.a.string,
      emoji: et.a.string,
      color: et.a.string,
      set: nt.set,
      skin: nt.skin,
      native: et.a.bool,
      backgroundImageFn: nt.backgroundImageFn,
      sheetSize: nt.sheetSize,
      emojisToShowFilter: et.a.func,
      showPreview: et.a.bool,
      showSkinTones: et.a.bool,
      emojiTooltip: nt.tooltip,
      include: et.a.arrayOf(et.a.string),
      exclude: et.a.arrayOf(et.a.string),
      recent: et.a.arrayOf(et.a.string),
      autoFocus: et.a.bool,
      custom: et.a.arrayOf(et.a.shape({
        name: et.a.string.isRequired,
        short_names: et.a.arrayOf(et.a.string).isRequired,
        emoticons: et.a.arrayOf(et.a.string),
        keywords: et.a.arrayOf(et.a.string),
        imageUrl: et.a.string,
        spriteUrl: et.a.string,
        sheet_x: et.a.number,
        sheet_y: et.a.number,
        size: et.a.number,
        sheetColumns: et.a.number,
        sheetRows: et.a.number
      })),
      skinEmoji: et.a.string,
      notFound: et.a.func,
      notFoundEmoji: et.a.string,
      icons: et.a.object
    },
        ot = function (e) {
      function Anchors(e) {
        pn(this, Anchors);
        var i = possibleConstructorReturn(this, (Anchors.__proto__ || Jn(Anchors)).call(this, e)),
            a = e.categories.filter(function (e) {
          return e.first;
        })[0];
        return i.state = {
          selected: a.name
        }, i.handleClick = i.handleClick.bind(i), i;
      }

      return inherits(Anchors, r.a.PureComponent), kn(Anchors, [{
        key: "handleClick",
        value: function handleClick(e) {
          var i = e.currentTarget.getAttribute("data-index"),
              a = this.props,
              n = a.categories;
          (0, a.onAnchorClick)(n[i], i);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              i = this.props,
              a = i.categories,
              n = i.color,
              t = i.i18n,
              o = i.icons,
              s = this.state.selected;
          return r.a.createElement("nav", {
            className: "emoji-mart-anchors",
            "aria-label": t.categorieslabel
          }, a.map(function (i, a) {
            var g = i.id,
                l = i.name,
                f = i.anchor,
                h = l == s;
            if (!1 === f) return null;
            var m = g.startsWith("custom-") ? "custom" : g;
            return r.a.createElement("button", {
              key: g,
              "aria-label": t.categories[g],
              title: t.categories[g],
              "data-index": a,
              type: "button",
              onClick: e.handleClick,
              className: "emoji-mart-anchor " + (h ? "emoji-mart-anchor-selected" : ""),
              style: {
                color: h ? n : null
              }
            }, r.a.createElement("div", {
              className: "emoji-mart-anchor-icon"
            }, o.categories[m]()), r.a.createElement("span", {
              className: "emoji-mart-anchor-bar",
              style: {
                backgroundColor: n
              }
            }));
          }));
        }
      }]), Anchors;
    }(),
        st = ot;

    ot.propTypes = {
      categories: et.a.array,
      onAnchorClick: et.a.func,
      icons: et.a.object
    }, ot.defaultProps = {
      categories: [],
      onAnchorClick: function onAnchorClick() {},
      icons: {}
    };

    var rt = {
      skin: 1,
      set: "apple",
      sheetSize: 64,
      sheetColumns: 52,
      sheetRows: 52,
      native: !1,
      forceSize: !1,
      tooltip: !1,
      backgroundImageFn: function backgroundImageFn(e, i) {
        return "https://unpkg.com/emoji-datasource-" + e + "@4.0.4/img/" + e + "/sheets-256/" + i + ".png";
      }
    },
        gt = {
      onClick: function onClick() {},
      onSelect: function onSelect() {},
      onSkinChange: function onSkinChange() {},
      emojiSize: 24,
      perLine: 9,
      i18n: {},
      style: {},
      title: "Emoji Mart\u2122",
      emoji: "department_store",
      color: "#ae65c5",
      set: rt.set,
      skin: null,
      defaultSkin: rt.skin,
      native: rt.native,
      sheetSize: rt.sheetSize,
      backgroundImageFn: rt.backgroundImageFn,
      emojisToShowFilter: null,
      showPreview: !0,
      showSkinTones: !0,
      darkMode: !("function" !== typeof matchMedia || !matchMedia("(prefers-color-scheme: dark)").matches),
      emojiTooltip: rt.tooltip,
      autoFocus: !1,
      custom: [],
      skinEmoji: "",
      notFound: function notFound() {},
      notFoundEmoji: "sleuth_or_spy",
      icons: {}
    },
        lt = function _getData(e) {
      return getData(e.emoji, e.skin, e.set, e.data);
    },
        ft = function _getPosition(e) {
      var i = lt(e),
          a = i.sheet_x,
          n = i.sheet_y;
      return 100 / (e.sheetColumns - 1) * a + "% " + 100 / (e.sheetRows - 1) * n + "%";
    },
        ht = function _getSanitizedData(e) {
      return getSanitizedData(e.emoji, e.skin, e.set, e.data);
    },
        mt = function _isNumeric(e) {
      return !isNaN(e - parseFloat(e));
    },
        _t = function NimbleEmoji(e) {
      for (var i in e.data.compressed && Bn(e.data), NimbleEmoji.defaultProps) {
        void 0 == e[i] && void 0 != NimbleEmoji.defaultProps[i] && (e[i] = NimbleEmoji.defaultProps[i]);
      }

      var a = lt(e);
      if (!a) return e.fallback ? e.fallback(null, e) : null;
      var n = a.unified,
          t = a.custom,
          o = a.short_names,
          s = a.imageUrl,
          g = {},
          l = e.children,
          f = "emoji-mart-emoji",
          h = n && unifiedToNative(n),
          m = [h].concat(o).filter(Boolean).join(", "),
          _ = null;
      if (!n && !t) return e.fallback ? e.fallback(a, e) : null;
      if (e.tooltip && (_ = o[0]), e.native && n) f += " emoji-mart-emoji-native", g = {
        fontSize: e.size
      }, l = h, e.forceSize && (g.display = "inline-block", g.width = e.size, g.height = e.size, g.wordBreak = "keep-all");else if (t) f += " emoji-mart-emoji-custom", g = {
        width: e.size,
        height: e.size,
        display: "inline-block"
      }, g = a.spriteUrl ? In({}, g, {
        backgroundImage: "url(" + a.spriteUrl + ")",
        backgroundSize: 100 * e.sheetColumns + "% " + 100 * e.sheetRows + "%",
        backgroundPosition: ft(e)
      }) : In({}, g, {
        backgroundImage: "url(" + s + ")",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      });else {
        if (!(void 0 == a["has_img_" + e.set] || a["has_img_" + e.set])) return e.fallback ? e.fallback(a, e) : null;
        g = {
          width: e.size,
          height: e.size,
          display: "inline-block",
          backgroundImage: "url(" + e.backgroundImageFn(e.set, e.sheetSize) + ")",
          backgroundSize: 100 * e.sheetColumns + "% " + 100 * e.sheetRows + "%",
          backgroundPosition: ft(e)
        };
      }
      var d = {
        name: "span",
        props: {}
      };
      return e.onClick && (d.name = "button", d.props = {
        type: "button"
      }), e.html ? (g = function _convertStyleToCSS(e) {
        var i = document.createElement("div");

        for (var a in e) {
          var n = e[a];
          mt(n) && (n += "px"), i.style[a] = n;
        }

        return i.getAttribute("style");
      }(g), "<" + d.name + " style='" + g + "' aria-label='" + m + "' " + (_ ? "title='" + _ + "'" : "") + " class='" + f + "'>" + (l || "") + "</" + d.name + ">") : r.a.createElement(d.name, In({
        onClick: function onClick(i) {
          return function _handleClick(e, i) {
            i.onClick && (0, i.onClick)(ht(i), e);
          }(i, e);
        },
        onMouseEnter: function onMouseEnter(i) {
          return function _handleOver(e, i) {
            i.onOver && (0, i.onOver)(ht(i), e);
          }(i, e);
        },
        onMouseLeave: function onMouseLeave(i) {
          return function _handleLeave(e, i) {
            i.onLeave && (0, i.onLeave)(ht(i), e);
          }(i, e);
        },
        "aria-label": m,
        title: _,
        className: f
      }, d.props), r.a.createElement("span", {
        style: g
      }, l));
    };

    _t.propTypes = In({}, nt, {
      data: et.a.object.isRequired
    }), _t.defaultProps = rt;

    var dt = _t,
        ct = function (e) {
      function NotFound() {
        return pn(this, NotFound), possibleConstructorReturn(this, (NotFound.__proto__ || Jn(NotFound)).apply(this, arguments));
      }

      return inherits(NotFound, r.a.PureComponent), kn(NotFound, [{
        key: "render",
        value: function render() {
          var e = this.props,
              i = e.data,
              a = e.emojiProps,
              n = e.i18n,
              t = e.notFound,
              o = e.notFoundEmoji;
          return t && t() || r.a.createElement("div", {
            className: "emoji-mart-no-results"
          }, dt(In({
            data: i
          }, a, {
            size: 38,
            emoji: o,
            onOver: null,
            onLeave: null,
            onClick: null
          })), r.a.createElement("div", {
            className: "emoji-mart-no-results-label"
          }, n.notfound));
        }
      }]), NotFound;
    }(),
        Ft = ct;

    ct.propTypes = {
      notFound: et.a.func.isRequired,
      emojiProps: et.a.object.isRequired
    };

    var ut = function (e) {
      function Category(e) {
        pn(this, Category);
        var i = possibleConstructorReturn(this, (Category.__proto__ || Jn(Category)).call(this, e));
        return i.data = e.data, i.setContainerRef = i.setContainerRef.bind(i), i.setLabelRef = i.setLabelRef.bind(i), i;
      }

      return inherits(Category, r.a.Component), kn(Category, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.margin = 0, this.minMargin = 0, this.memoizeSize();
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(e, i) {
          var a = this.props,
              n = a.name,
              t = a.perLine,
              o = a.native,
              s = a.hasStickyPosition,
              r = a.emojis,
              g = a.emojiProps,
              l = g.skin,
              f = g.size,
              h = g.set,
              m = e.perLine,
              _ = e.native,
              d = e.hasStickyPosition,
              c = e.emojis,
              F = e.emojiProps,
              u = F.skin,
              p = F.size,
              b = F.set,
              k = !1;
          return "Recent" == n && t != m && (k = !0), "Search" == n && (k = !(r == c)), l == u && f == p && o == _ && h == b && s == d || (k = !0), k;
        }
      }, {
        key: "memoizeSize",
        value: function memoizeSize() {
          if (!this.container) return this.top = 0, void (this.maxMargin = 0);
          var e = this.container.parentElement,
              i = this.container.getBoundingClientRect(),
              a = i.top,
              n = i.height,
              t = e.getBoundingClientRect().top,
              o = this.label.getBoundingClientRect().height;
          this.top = a - t + e.scrollTop, this.maxMargin = 0 == n ? 0 : n - o;
        }
      }, {
        key: "handleScroll",
        value: function handleScroll(e) {
          var i = e - this.top;
          if ((i = (i = i < this.minMargin ? this.minMargin : i) > this.maxMargin ? this.maxMargin : i) != this.margin) return this.props.hasStickyPosition || (this.label.style.top = i + "px"), this.margin = i, !0;
        }
      }, {
        key: "getEmojis",
        value: function getEmojis() {
          var e = this,
              i = this.props,
              a = i.name,
              n = i.emojis,
              t = i.recent,
              o = i.perLine;

          if ("Recent" == a) {
            var s = this.props.custom,
                r = t || Yn.get(o);
            if (r.length && (n = r.map(function (e) {
              var i = s.filter(function (i) {
                return i.id === e;
              })[0];
              return i || e;
            }).filter(function (i) {
              return !!getData(i, null, null, e.data);
            })), 0 === n.length && r.length > 0) return null;
          }

          return n && (n = n.slice(0)), n;
        }
      }, {
        key: "updateDisplay",
        value: function updateDisplay(e) {
          this.getEmojis() && this.container && (this.container.style.display = e);
        }
      }, {
        key: "setContainerRef",
        value: function setContainerRef(e) {
          this.container = e;
        }
      }, {
        key: "setLabelRef",
        value: function setLabelRef(e) {
          this.label = e;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              i = this.props,
              a = i.id,
              n = i.name,
              t = i.hasStickyPosition,
              o = i.emojiProps,
              s = i.i18n,
              g = i.notFound,
              l = i.notFoundEmoji,
              f = this.getEmojis(),
              h = {},
              m = {},
              _ = {};
          f || (_ = {
            display: "none"
          }), t || (h = {
            height: 28
          }, m = {
            position: "absolute"
          });
          var d = s.categories[a] || n;
          return r.a.createElement("section", {
            ref: this.setContainerRef,
            className: "emoji-mart-category",
            "aria-label": d,
            style: _
          }, r.a.createElement("div", {
            style: h,
            "data-name": n,
            className: "emoji-mart-category-label"
          }, r.a.createElement("span", {
            style: m,
            ref: this.setLabelRef,
            "aria-hidden": !0
          }, d)), r.a.createElement("ul", {
            className: "emoji-mart-category-list"
          }, f && f.map(function (i) {
            return r.a.createElement("li", {
              key: i.short_names && i.short_names.join("_") || i
            }, dt(In({
              emoji: i,
              data: e.data
            }, o)));
          })), f && !f.length && r.a.createElement(Ft, {
            i18n: s,
            notFound: g,
            notFoundEmoji: l,
            data: this.data,
            emojiProps: o
          }));
        }
      }]), Category;
    }(),
        pt = ut;

    ut.propTypes = {
      emojis: et.a.array,
      hasStickyPosition: et.a.bool,
      name: et.a.string.isRequired,
      native: et.a.bool.isRequired,
      perLine: et.a.number.isRequired,
      emojiProps: et.a.object.isRequired,
      recent: et.a.arrayOf(et.a.string),
      notFound: et.a.func,
      notFoundEmoji: et.a.string.isRequired
    }, ut.defaultProps = {
      emojis: [],
      hasStickyPosition: !0
    };

    var bt = function (e) {
      function Skins(e) {
        pn(this, Skins);
        var i = possibleConstructorReturn(this, (Skins.__proto__ || Jn(Skins)).call(this, e));
        return i.state = {
          opened: !1
        }, i;
      }

      return inherits(Skins, r.a.PureComponent), kn(Skins, [{
        key: "handleClick",
        value: function handleClick(e) {
          var i = parseInt(e.currentTarget.getAttribute("data-skin")),
              a = this.props.onChange;
          this.state.opened ? (this.setState({
            opened: !1
          }), i != this.props.skin && a(i)) : this.setState({
            opened: !0
          });
        }
      }, {
        key: "render",
        value: function render() {
          return null;
        }
      }]), Skins;
    }(),
        kt = bt;

    bt.propTypes = {
      onChange: et.a.func,
      skin: et.a.number.isRequired
    }, bt.defaultProps = {
      onChange: function onChange() {}
    };

    var At = function (e) {
      function SkinsEmoji(e) {
        pn(this, SkinsEmoji);
        var i = possibleConstructorReturn(this, (SkinsEmoji.__proto__ || Jn(SkinsEmoji)).call(this, e));
        return i.handleClick = i.handleClick.bind(i), i;
      }

      return inherits(SkinsEmoji, kt), kn(SkinsEmoji, [{
        key: "render",
        value: function render() {
          for (var e = this.props, i = e.skin, a = e.emojiProps, n = e.data, t = e.skinEmoji, o = e.i18n, s = this.state.opened, g = [], l = 1; l <= 6; l++) {
            var f = l === i;
            g.push(r.a.createElement("span", {
              key: "skin-tone-" + l,
              className: "emoji-mart-skin-swatch custom" + (f ? " selected" : "")
            }, r.a.createElement("span", {
              onClick: this.handleClick,
              "data-skin": l,
              className: "emoji-mart-skin-tone-" + l
            }, dt({
              emoji: t,
              data: n,
              skin: l,
              backgroundImageFn: a.backgroundImageFn,
              native: a.native,
              set: a.set,
              sheetSize: a.sheetSize,
              size: 23
            }))));
          }

          return r.a.createElement("div", {
            className: "emoji-mart-skin-swatches custom" + (s ? " opened" : "")
          }, r.a.createElement("div", {
            className: "emoji-mart-skin-text" + (s ? " opened" : "")
          }, o.skintext), g);
        }
      }]), SkinsEmoji;
    }(),
        yt = At;

    At.propTypes = {
      onChange: et.a.func,
      skin: et.a.number.isRequired,
      emojiProps: et.a.object.isRequired,
      skinTone: et.a.number,
      skinEmoji: et.a.string.isRequired,
      i18n: et.a.object
    }, At.defaultProps = {
      onChange: function onChange() {},
      skinTone: null
    };

    var vt = function (e) {
      function SkinsDot(e) {
        pn(this, SkinsDot);
        var i = possibleConstructorReturn(this, (SkinsDot.__proto__ || Jn(SkinsDot)).call(this, e));
        return i.handleClick = i.handleClick.bind(i), i.handleKeyDown = i.handleKeyDown.bind(i), i;
      }

      return inherits(SkinsDot, kt), kn(SkinsDot, [{
        key: "handleKeyDown",
        value: function handleKeyDown(e) {
          13 !== e.keyCode && 32 !== e.keyCode || this.handleClick(e);
        }
      }, {
        key: "render",
        value: function render() {
          for (var e = this.props, i = e.skin, a = e.i18n, n = this.state.opened, t = [], o = 1; o <= 6; o++) {
            var s = o === i,
                g = n || s;
            t.push(r.a.createElement("span", In({
              key: "skin-tone-" + o,
              className: "emoji-mart-skin-swatch" + (s ? " selected" : ""),
              "aria-label": a.skintones[o],
              "aria-hidden": !g
            }, n ? {
              role: "menuitem"
            } : {}), r.a.createElement("span", In({
              onClick: this.handleClick,
              onKeyDown: this.handleKeyDown,
              role: "button"
            }, s ? {
              "aria-haspopup": !0,
              "aria-expanded": !!n
            } : {}, n ? {
              "aria-pressed": !!s
            } : {}, {
              tabIndex: g ? "0" : "",
              "aria-label": a.skintones[o],
              title: a.skintones[o],
              "data-skin": o,
              className: "emoji-mart-skin emoji-mart-skin-tone-" + o
            }))));
          }

          return r.a.createElement("section", {
            className: "emoji-mart-skin-swatches" + (n ? " opened" : ""),
            "aria-label": a.skintext
          }, r.a.createElement("div", n ? {
            role: "menubar"
          } : {}, t));
        }
      }]), SkinsDot;
    }(),
        wt = vt;

    vt.propTypes = {
      onChange: et.a.func,
      skin: et.a.number.isRequired,
      i18n: et.a.object
    }, vt.defaultProps = {
      onChange: function onChange() {}
    };

    var Et = function (e) {
      function Preview(e) {
        pn(this, Preview);
        var i = possibleConstructorReturn(this, (Preview.__proto__ || Jn(Preview)).call(this, e));
        return i.data = e.data, i.state = {
          emoji: null
        }, i;
      }

      return inherits(Preview, r.a.PureComponent), kn(Preview, [{
        key: "render",
        value: function render() {
          var e = this.state.emoji,
              i = this.props,
              a = i.emojiProps,
              n = i.skinsProps,
              t = i.showSkinTones,
              o = i.title,
              s = i.emoji,
              g = i.i18n,
              l = i.showPreview;

          if (e && l) {
            var f = getData(e, null, null, this.data),
                h = f.emoticons,
                m = [],
                _ = [];
            return (void 0 === h ? [] : h).forEach(function (e) {
              m.indexOf(e.toLowerCase()) >= 0 || (m.push(e.toLowerCase()), _.push(e));
            }), r.a.createElement("div", {
              className: "emoji-mart-preview"
            }, r.a.createElement("div", {
              className: "emoji-mart-preview-emoji",
              "aria-hidden": "true"
            }, dt(In({
              key: e.id,
              emoji: e,
              data: this.data
            }, a))), r.a.createElement("div", {
              className: "emoji-mart-preview-data",
              "aria-hidden": "true"
            }, r.a.createElement("div", {
              className: "emoji-mart-preview-name"
            }, e.name), r.a.createElement("div", {
              className: "emoji-mart-preview-shortnames"
            }, f.short_names.map(function (e) {
              return r.a.createElement("span", {
                key: e,
                className: "emoji-mart-preview-shortname"
              }, ":", e, ":");
            })), r.a.createElement("div", {
              className: "emoji-mart-preview-emoticons"
            }, _.map(function (e) {
              return r.a.createElement("span", {
                key: e,
                className: "emoji-mart-preview-emoticon"
              }, e);
            }))));
          }

          return r.a.createElement("div", {
            className: "emoji-mart-preview"
          }, r.a.createElement("div", {
            className: "emoji-mart-preview-emoji",
            "aria-hidden": "true"
          }, s && s.length && dt(In({
            emoji: s,
            data: this.data
          }, a))), r.a.createElement("div", {
            className: "emoji-mart-preview-data",
            "aria-hidden": "true"
          }, r.a.createElement("span", {
            className: "emoji-mart-title-label"
          }, o)), t && r.a.createElement("div", {
            className: "emoji-mart-preview-skins" + (n.skinEmoji ? " custom" : "")
          }, n.skinEmoji ? r.a.createElement(yt, {
            skin: n.skin,
            emojiProps: a,
            data: this.data,
            skinEmoji: n.skinEmoji,
            i18n: g,
            onChange: n.onChange
          }) : r.a.createElement(wt, {
            skin: n.skin,
            i18n: g,
            onChange: n.onChange
          })));
        }
      }]), Preview;
    }(),
        jt = Et;

    Et.propTypes = {
      showSkinTones: et.a.bool,
      title: et.a.string.isRequired,
      emoji: et.a.string.isRequired,
      emojiProps: et.a.object.isRequired,
      skinsProps: et.a.object.isRequired
    }, Et.defaultProps = {
      showSkinTones: !0,
      onChange: function onChange() {}
    };

    var Dt = 0,
        xt = function (e) {
      function Search(e) {
        pn(this, Search);
        var i = possibleConstructorReturn(this, (Search.__proto__ || Jn(Search)).call(this, e));
        return i.state = {
          icon: at.search,
          isSearching: !1,
          id: ++Dt
        }, i.data = e.data, i.emojiIndex = new Hn(i.data), i.setRef = i.setRef.bind(i), i.clear = i.clear.bind(i), i.handleKeyUp = i.handleKeyUp.bind(i), i.handleChange = function throttleIdleTask(e) {
          var i = "function" === typeof requestIdleCallback ? requestIdleCallback : setTimeout,
              a = !1;
          return function throttled() {
            a || (a = !0, i(function () {
              a = !1, e();
            }));
          };
        }(i.handleChange.bind(i)), i;
      }

      return inherits(Search, r.a.PureComponent), kn(Search, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.input && this.input.value && this.search(this.input.value);
        }
      }, {
        key: "search",
        value: function search(e) {
          "" == e ? this.setState({
            icon: at.search,
            isSearching: !1
          }) : this.setState({
            icon: at.delete,
            isSearching: !0
          }), this.props.onSearch(this.emojiIndex.search(e, {
            emojisToShowFilter: this.props.emojisToShowFilter,
            maxResults: this.props.maxResults,
            include: this.props.include,
            exclude: this.props.exclude,
            custom: this.props.custom
          }));
        }
      }, {
        key: "clear",
        value: function clear() {
          "" != this.input.value && (this.input.value = "", this.input.focus(), this.search(""));
        }
      }, {
        key: "handleChange",
        value: function handleChange() {
          this.search(this.input.value);
        }
      }, {
        key: "handleKeyUp",
        value: function handleKeyUp(e) {
          13 === e.keyCode && this.clear();
        }
      }, {
        key: "setRef",
        value: function setRef(e) {
          this.input = e;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              i = e.i18n,
              a = e.autoFocus,
              n = this.state,
              t = n.icon,
              o = n.isSearching,
              s = "emoji-mart-search-" + n.id;
          return r.a.createElement("section", {
            className: "emoji-mart-search",
            "aria-label": i.search
          }, r.a.createElement("input", {
            id: s,
            ref: this.setRef,
            type: "search",
            onChange: this.handleChange,
            placeholder: i.search,
            autoFocus: a
          }), r.a.createElement("label", {
            className: "emoji-mart-sr-only",
            htmlFor: s
          }, i.search), r.a.createElement("button", {
            className: "emoji-mart-search-icon",
            onClick: this.clear,
            onKeyUp: this.handleKeyUp,
            "aria-label": i.clear,
            disabled: !o
          }, t()));
        }
      }]), Search;
    }(),
        Ct = xt;

    xt.propTypes = {
      onSearch: et.a.func,
      maxResults: et.a.number,
      emojisToShowFilter: et.a.func,
      autoFocus: et.a.bool
    }, xt.defaultProps = {
      onSearch: function onSearch() {},
      maxResults: 75,
      emojisToShowFilter: null,
      autoFocus: !1
    };

    var Bt = {
      search: "Search",
      clear: "Clear",
      notfound: "No Emoji Found",
      skintext: "Choose your default skin tone",
      categories: {
        search: "Search Results",
        recent: "Frequently Used",
        people: "Smileys & People",
        nature: "Animals & Nature",
        foods: "Food & Drink",
        activity: "Activity",
        places: "Travel & Places",
        objects: "Objects",
        symbols: "Symbols",
        flags: "Flags",
        custom: "Custom"
      },
      categorieslabel: "Emoji categories",
      skintones: {
        1: "Default Skin Tone",
        2: "Light Skin Tone",
        3: "Medium-Light Skin Tone",
        4: "Medium Skin Tone",
        5: "Medium-Dark Skin Tone",
        6: "Dark Skin Tone"
      }
    },
        Mt = function (e) {
      function NimblePicker(e) {
        pn(this, NimblePicker);
        var i = possibleConstructorReturn(this, (NimblePicker.__proto__ || Jn(NimblePicker)).call(this, e));
        i.CUSTOM = [], i.RECENT_CATEGORY = {
          id: "recent",
          name: "Recent",
          emojis: null
        }, i.SEARCH_CATEGORY = {
          id: "search",
          name: "Search",
          emojis: null,
          anchor: !1
        }, e.data.compressed && Bn(e.data), i.data = e.data, i.i18n = deepMerge(Bt, e.i18n), i.icons = deepMerge(o, e.icons), i.state = {
          skin: e.skin || Rn.get("skin") || e.defaultSkin,
          firstRender: !0
        }, i.categories = [];
        var a = [].concat(i.data.categories);

        if (e.custom.length > 0) {
          var n = {},
              t = 0;
          e.custom.forEach(function (e) {
            n[e.customCategory] || (n[e.customCategory] = {
              id: e.customCategory ? "custom-" + e.customCategory : "custom",
              name: e.customCategory || "Custom",
              emojis: [],
              anchor: 0 === t
            }, t++);
            var a = n[e.customCategory],
                o = In({}, e, {
              id: e.short_names[0],
              custom: !0
            });
            a.emojis.push(o), i.CUSTOM.push(o);
          }), a.push.apply(a, Qn()(Vn()(n)));
        }

        i.hideRecent = !0, void 0 != e.include && a.sort(function (i, a) {
          return e.include.indexOf(i.id) > e.include.indexOf(a.id) ? 1 : -1;
        });

        for (var s = 0; s < a.length; s++) {
          var r = a[s],
              g = !e.include || !e.include.length || e.include.indexOf(r.id) > -1,
              l = !(!e.exclude || !e.exclude.length) && e.exclude.indexOf(r.id) > -1;
          if (g && !l) if (e.emojisToShowFilter) {
            for (var f = [], h = r.emojis, m = 0; m < h.length; m++) {
              var _ = h[m];
              e.emojisToShowFilter(i.data.emojis[_] || _) && f.push(_);
            }

            if (f.length) {
              var d = {
                emojis: f,
                name: r.name,
                id: r.id
              };
              i.categories.push(d);
            }
          } else i.categories.push(r);
        }

        var c = !e.include || !e.include.length || e.include.indexOf(i.RECENT_CATEGORY.id) > -1,
            F = !(!e.exclude || !e.exclude.length) && e.exclude.indexOf(i.RECENT_CATEGORY.id) > -1;
        return c && !F && (i.hideRecent = !1, i.categories.unshift(i.RECENT_CATEGORY)), i.categories[0] && (i.categories[0].first = !0), i.categories.unshift(i.SEARCH_CATEGORY), i.setAnchorsRef = i.setAnchorsRef.bind(i), i.handleAnchorClick = i.handleAnchorClick.bind(i), i.setSearchRef = i.setSearchRef.bind(i), i.handleSearch = i.handleSearch.bind(i), i.setScrollRef = i.setScrollRef.bind(i), i.handleScroll = i.handleScroll.bind(i), i.handleScrollPaint = i.handleScrollPaint.bind(i), i.handleEmojiOver = i.handleEmojiOver.bind(i), i.handleEmojiLeave = i.handleEmojiLeave.bind(i), i.handleEmojiClick = i.handleEmojiClick.bind(i), i.handleEmojiSelect = i.handleEmojiSelect.bind(i), i.setPreviewRef = i.setPreviewRef.bind(i), i.handleSkinChange = i.handleSkinChange.bind(i), i.handleKeyDown = i.handleKeyDown.bind(i), i;
      }

      return inherits(NimblePicker, r.a.PureComponent), kn(NimblePicker, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var e = this;
          this.state.firstRender && (this.testStickyPosition(), this.firstRenderTimeout = setTimeout(function () {
            e.setState({
              firstRender: !1
            });
          }, 60));
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.updateCategoriesSize(), this.handleScroll();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.SEARCH_CATEGORY.emojis = null, clearTimeout(this.leaveTimeout), clearTimeout(this.firstRenderTimeout);
        }
      }, {
        key: "testStickyPosition",
        value: function testStickyPosition() {
          var e = document.createElement("div");
          ["", "-webkit-", "-ms-", "-moz-", "-o-"].forEach(function (i) {
            return e.style.position = i + "sticky";
          }), this.hasStickyPosition = !!e.style.position.length;
        }
      }, {
        key: "handleEmojiOver",
        value: function handleEmojiOver(e) {
          var i = this.preview;

          if (i) {
            var a = this.CUSTOM.filter(function (i) {
              return i.id === e.id;
            })[0];

            for (var n in a) {
              a.hasOwnProperty(n) && (e[n] = a[n]);
            }

            i.setState({
              emoji: e
            }), clearTimeout(this.leaveTimeout);
          }
        }
      }, {
        key: "handleEmojiLeave",
        value: function handleEmojiLeave(e) {
          var i = this.preview;
          i && (this.leaveTimeout = setTimeout(function () {
            i.setState({
              emoji: null
            });
          }, 16));
        }
      }, {
        key: "handleEmojiClick",
        value: function handleEmojiClick(e, i) {
          this.props.onClick(e, i), this.handleEmojiSelect(e);
        }
      }, {
        key: "handleEmojiSelect",
        value: function handleEmojiSelect(e) {
          var i = this;
          this.props.onSelect(e), this.hideRecent || this.props.recent || Yn.add(e);
          var a = this.categoryRefs["category-1"];

          if (a) {
            var n = a.maxMargin;
            a.forceUpdate(), window.requestAnimationFrame(function () {
              i.scroll && (a.memoizeSize(), n != a.maxMargin && (i.updateCategoriesSize(), i.handleScrollPaint(), i.SEARCH_CATEGORY.emojis && a.updateDisplay("none")));
            });
          }
        }
      }, {
        key: "handleScroll",
        value: function handleScroll() {
          this.waitingForPaint || (this.waitingForPaint = !0, window.requestAnimationFrame(this.handleScrollPaint));
        }
      }, {
        key: "handleScrollPaint",
        value: function handleScrollPaint() {
          if (this.waitingForPaint = !1, this.scroll) {
            var e = null;
            if (this.SEARCH_CATEGORY.emojis) e = this.SEARCH_CATEGORY;else {
              for (var i = this.scroll.scrollTop, a = i > (this.scrollTop || 0), n = 0, t = 0, o = this.categories.length; t < o; t++) {
                var s = a ? this.categories.length - 1 - t : t,
                    r = this.categories[s],
                    g = this.categoryRefs["category-" + s];

                if (g) {
                  var l = g.handleScroll(i);
                  (!n || g.top < n) && g.top > 0 && (n = g.top), l && !e && (e = r);
                }
              }

              i < n ? e = this.categories.filter(function (e) {
                return !(!1 === e.anchor);
              })[0] : i + this.clientHeight >= this.scrollHeight && (e = this.categories[this.categories.length - 1]);
            }

            if (e) {
              var f = this.anchors,
                  h = e.name;
              f.state.selected != h && f.setState({
                selected: h
              });
            }

            this.scrollTop = i;
          }
        }
      }, {
        key: "handleSearch",
        value: function handleSearch(e) {
          this.SEARCH_CATEGORY.emojis = e;

          for (var i = 0, a = this.categories.length; i < a; i++) {
            var n = this.categoryRefs["category-" + i];

            if (n && "Search" != n.props.name) {
              var t = e ? "none" : "inherit";
              n.updateDisplay(t);
            }
          }

          this.forceUpdate(), this.scroll && (this.scroll.scrollTop = 0), this.handleScroll();
        }
      }, {
        key: "handleAnchorClick",
        value: function handleAnchorClick(e, i) {
          var a,
              n = this.categoryRefs["category-" + i],
              t = this.scroll;
          this.anchors;
          a = function scrollToComponent() {
            if (n) {
              var i = n.top;
              e.first ? i = 0 : i += 1, t.scrollTop = i;
            }
          }, this.SEARCH_CATEGORY.emojis ? (this.handleSearch(null), this.search.clear(), window.requestAnimationFrame(a)) : a();
        }
      }, {
        key: "handleSkinChange",
        value: function handleSkinChange(e) {
          var i = {
            skin: e
          },
              a = this.props.onSkinChange;
          this.setState(i), Rn.update(i), a(e);
        }
      }, {
        key: "handleKeyDown",
        value: function handleKeyDown(e) {
          var i = !1;

          switch (e.keyCode) {
            case 13:
              var a = void 0;
              this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (a = getSanitizedData(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data)) && (this.handleEmojiSelect(a), i = !0);
          }

          i && e.preventDefault();
        }
      }, {
        key: "updateCategoriesSize",
        value: function updateCategoriesSize() {
          for (var e = 0, i = this.categories.length; e < i; e++) {
            var a = this.categoryRefs["category-" + e];
            a && a.memoizeSize();
          }

          if (this.scroll) {
            var n = this.scroll;
            this.scrollHeight = n.scrollHeight, this.clientHeight = n.clientHeight;
          }
        }
      }, {
        key: "getCategories",
        value: function getCategories() {
          return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
        }
      }, {
        key: "setAnchorsRef",
        value: function setAnchorsRef(e) {
          this.anchors = e;
        }
      }, {
        key: "setSearchRef",
        value: function setSearchRef(e) {
          this.search = e;
        }
      }, {
        key: "setPreviewRef",
        value: function setPreviewRef(e) {
          this.preview = e;
        }
      }, {
        key: "setScrollRef",
        value: function setScrollRef(e) {
          this.scroll = e;
        }
      }, {
        key: "setCategoryRef",
        value: function setCategoryRef(e, i) {
          this.categoryRefs || (this.categoryRefs = {}), this.categoryRefs[e] = i;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              i = this.props,
              a = i.perLine,
              n = i.emojiSize,
              t = i.set,
              o = i.sheetSize,
              s = i.sheetColumns,
              g = i.sheetRows,
              l = i.style,
              f = i.title,
              h = i.emoji,
              m = i.color,
              _ = i.native,
              d = i.backgroundImageFn,
              c = i.emojisToShowFilter,
              F = i.showPreview,
              u = i.showSkinTones,
              p = i.emojiTooltip,
              b = i.include,
              k = i.exclude,
              A = i.recent,
              y = i.autoFocus,
              v = i.skinEmoji,
              w = i.notFound,
              E = i.notFoundEmoji,
              j = i.darkMode,
              D = this.state.skin,
              x = a * (n + 12) + 12 + 2 + function measureScrollbar() {
            if ("undefined" == typeof document) return 0;
            var e = document.createElement("div");
            e.style.width = "100px", e.style.height = "100px", e.style.overflow = "scroll", e.style.position = "absolute", e.style.top = "-9999px", document.body.appendChild(e);
            var i = e.offsetWidth - e.clientWidth;
            return document.body.removeChild(e), i;
          }();

          return r.a.createElement("section", {
            style: In({
              width: x
            }, l),
            className: "emoji-mart " + (j ? "emoji-mart-dark" : ""),
            "aria-label": f,
            onKeyDown: this.handleKeyDown
          }, r.a.createElement("div", {
            className: "emoji-mart-bar"
          }, r.a.createElement(st, {
            ref: this.setAnchorsRef,
            data: this.data,
            i18n: this.i18n,
            color: m,
            categories: this.categories,
            onAnchorClick: this.handleAnchorClick,
            icons: this.icons
          })), r.a.createElement(Ct, {
            ref: this.setSearchRef,
            onSearch: this.handleSearch,
            data: this.data,
            i18n: this.i18n,
            emojisToShowFilter: c,
            include: b,
            exclude: k,
            custom: this.CUSTOM,
            autoFocus: y
          }), r.a.createElement("div", {
            ref: this.setScrollRef,
            className: "emoji-mart-scroll",
            onScroll: this.handleScroll
          }, this.getCategories().map(function (i, l) {
            return r.a.createElement(pt, {
              ref: e.setCategoryRef.bind(e, "category-" + l),
              key: i.name,
              id: i.id,
              name: i.name,
              emojis: i.emojis,
              perLine: a,
              native: _,
              hasStickyPosition: e.hasStickyPosition,
              data: e.data,
              i18n: e.i18n,
              recent: i.id == e.RECENT_CATEGORY.id ? A : void 0,
              custom: i.id == e.RECENT_CATEGORY.id ? e.CUSTOM : void 0,
              emojiProps: {
                native: _,
                skin: D,
                size: n,
                set: t,
                sheetSize: o,
                sheetColumns: s,
                sheetRows: g,
                forceSize: _,
                tooltip: p,
                backgroundImageFn: d,
                onOver: e.handleEmojiOver,
                onLeave: e.handleEmojiLeave,
                onClick: e.handleEmojiClick
              },
              notFound: w,
              notFoundEmoji: E
            });
          })), (F || u) && r.a.createElement("div", {
            className: "emoji-mart-bar"
          }, r.a.createElement(jt, {
            ref: this.setPreviewRef,
            data: this.data,
            title: f,
            emoji: h,
            showSkinTones: u,
            showPreview: F,
            emojiProps: {
              native: _,
              size: 38,
              skin: D,
              set: t,
              sheetSize: o,
              sheetColumns: s,
              sheetRows: g,
              backgroundImageFn: d
            },
            skinsProps: {
              skin: D,
              onChange: this.handleSkinChange,
              skinEmoji: v
            },
            i18n: this.i18n
          })));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(e, i) {
          return e.skin ? In({}, i, {
            skin: e.skin
          }) : e.defaultSkin && !Rn.get("skin") ? In({}, i, {
            skin: e.defaultSkin
          }) : i;
        }
      }]), NimblePicker;
    }(),
        qt = Mt;

    Mt.propTypes = In({}, tt, {
      data: et.a.object.isRequired
    }), Mt.defaultProps = In({}, gt);

    var Pt = function (e) {
      function Picker() {
        return pn(this, Picker), possibleConstructorReturn(this, (Picker.__proto__ || Jn(Picker)).apply(this, arguments));
      }

      return inherits(Picker, r.a.PureComponent), kn(Picker, [{
        key: "render",
        value: function render() {
          return r.a.createElement(qt, In({}, this.props, this.state));
        }
      }]), Picker;
    }(),
        Ot = Pt;

    Pt.propTypes = tt, Pt.defaultProps = In({}, gt, {
      data: un
    });

    var Tt = function Emoji(e) {
      for (var i in Emoji.defaultProps) {
        void 0 == e[i] && void 0 != Emoji.defaultProps[i] && (e[i] = Emoji.defaultProps[i]);
      }

      return dt(In({}, e));
    };

    Tt.propTypes = nt, Tt.defaultProps = In({}, rt, {
      data: un
    });
    t(256);

    function _defineProperties(e, i) {
      for (var a = 0; a < i.length; a++) {
        var n = i[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function _createClass(e, i, a) {
      return i && _defineProperties(e.prototype, i), a && _defineProperties(e, a), e;
    }

    var St,
        zt,
        Rt = function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (e) {
        return (e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16);
      });
    },
        Ht = function getSelectOption(e, i) {
      return i ? i.filter(function (i) {
        return i.value === e;
      }) : null;
    },
        Lt = function (e) {
      _inherits(DefaultCreator, s["Component"]);

      var i = _createSuper(DefaultCreator);

      function DefaultCreator(e) {
        var a;
        return _classCallCheck(this, DefaultCreator), (a = i.call(this, e)).saveTag = function () {
          var e = a.props,
              i = e.onSave,
              n = e.value,
              t = e.hasNoFallback,
              o = e.propertySelected,
              s = a.state.defaultToSet;
          i(t ? n : "".concat(n, ' or "').concat(s, '"'), o);
        }, a.setDefault = function (e) {
          var i = e.target.value;
          a.setState({
            defaultToSet: i
          });
        }, a.state = {
          defaultToSet: ""
        }, a;
      }

      return _createClass(DefaultCreator, [{
        key: "render",
        value: function render() {
          var e = this.state.defaultToSet,
              i = this.props,
              a = i.value,
              n = i.dismiss,
              t = i.hasNoFallback,
              o = i.propertySelected,
              s = t ? r.a.createElement(gi.Div, {
            className: "wysiwyg-toolbar--default-value-no-fallback-text"
          }, "We\u2019got your back! We\u2019ll always have a value for this type of property token") : r.a.createElement(gi.Div, null, r.a.createElement(gi.Input, {
            value: e,
            label: "Fallback text",
            onChange: this.setDefault,
            placeholder: "Default text...",
            autoFocus: !0,
            description: "If we can\u2019t find a name for this variable, we\u2019ll display this instead"
          }));
          return r.a.createElement(gi.Div, {
            className: "wysiwyg-toolbar--default-value-creator"
          }, r.a.createElement(gi.Div, {
            className: "wysiwyg-toolbar--default-value-body"
          }, r.a.createElement(gi.Div, {
            className: "wysiwyg-toolbar--default-value-subheader"
          }, r.a.createElement("span", {
            className: "driftiwyg-tag-property"
          }, "contentVariable" === o.source ? o.label : "{{".concat(a, "}}"))), s, r.a.createElement(gi.Div, {
            className: "wysiwyg-toolbar--default-value-buttons"
          }, r.a.createElement(gi.Button, {
            className: "wysiwyg-toolbar--insert-button",
            type: "primary",
            onClick: this.saveTag
          }, "Insert"), r.a.createElement(gi.Button, {
            type: "tertiary",
            onClick: n
          }, "Cancel"))));
        }
      }]), DefaultCreator;
    }(),
        Xt = function formatContentVariablesList(e) {
      return e.map(function (e) {
        return {
          label: e.name,
          value: e.name,
          source: "contentVariable",
          properties: e,
          hasNoFallback: !0
        };
      });
    },
        Nt = function (e) {
      _inherits(DriftPropertyPluginDropdown, s["Component"]);

      var i = _createSuper(DriftPropertyPluginDropdown);

      function DriftPropertyPluginDropdown(e) {
        var a;
        _classCallCheck(this, DriftPropertyPluginDropdown), (a = i.call(this, e)).openDefaultCreator = function (e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = arguments.length > 2 ? arguments[2] : void 0;
          a.setState(function (a) {
            return {
              defaultCreatorOpen: !a.defaultCreatorOpen,
              createDefaultFor: e,
              propertySelected: n,
              hasNoFallback: i
            };
          });
        }, a.dismissDefaultValueCreator = function () {
          a.setState(function (e) {
            return {
              defaultCreatorOpen: !e.defaultCreatorOpen,
              createDefaultFor: null,
              hasNoFallback: !1,
              propertySelected: null
            };
          });
        }, a.filterProps = function (e) {
          a.setState({
            filterQuery: e.target.value
          }, a.doFilter);
        }, a.doFilter = function () {
          var e = [];
          a.state.defaultProperties.map(function (i, n) {
            var t = i.properties.filter(function (e) {
              return e.label.toLowerCase().includes(a.state.filterQuery);
            });
            return 0 !== t.length && e.push({
              name: i.name,
              properties: t
            });
          }), a.setState({
            filteredProperties: e
          });
        }, a.renderDropdownList = function () {
          var e = 0 !== a.state.filteredProperties.length;
          return r.a.createElement("div", {
            className: "property-list-container"
          }, e ? a.state.filteredProperties.map(function (e, i) {
            return r.a.createElement("div", {
              key: "properties-list-".concat(e.name)
            }, r.a.createElement("p", {
              className: "property-list-section-header"
            }, e.name), r.a.createElement("ul", {
              className: "property-list"
            }, e.properties.map(function (e) {
              var i = "contentVariable" !== e.source ? "".concat(e.source, ".").concat(e.value) : "".concat(e.source, "._").concat(e.properties.id, ".contentVariableUsageId.").concat(Rt());
              return r.a.createElement("li", {
                key: "plugin-properties-".concat(e.source, "-").concat(e.value),
                onClick: function onClick() {
                  return a.openDefaultCreator(i, e.hasNoFallback, e);
                }
              }, e.label);
            })));
          }) : r.a.createElement("div", {
            className: "empty-state-container"
          }, r.a.createElement(gi.Colorway, {
            type: "2"
          }, r.a.createElement(Fn.Icon, {
            name: "cw-empty-search"
          })), r.a.createElement("div", null, "There are no personalization", r.a.createElement("br", null), "tokens matching your search.")));
        };
        var n = [],
            t = [];

        if (e.userTagList && (n.unshift({
          name: "contact",
          properties: e.userTagList
        }), t.unshift({
          name: "contact",
          properties: e.userTagList
        })), e.driftIntelTagList && (n.unshift({
          name: "drift intel",
          properties: e.driftIntelTagList
        }), t.unshift({
          name: "drift intel",
          properties: e.driftIntelTagList
        })), e.demandbaseTagList && (n.unshift({
          name: "demandbase",
          properties: e.demandbaseTagList
        }), t.unshift({
          name: "demandbase",
          properties: e.demandbaseTagList
        })), e.contentVariablesList) {
          var o = Xt(e.contentVariablesList);
          n.unshift({
            name: "content variables",
            properties: o
          }), t.unshift({
            name: "content variables",
            properties: o
          });
        }

        return a.state = {
          defaultCreatorOpen: !1,
          createDefaultFor: null,
          defaultProperties: n,
          filteredProperties: t,
          filterQuery: ""
        }, a;
      }

      return _createClass(DriftPropertyPluginDropdown, [{
        key: "render",
        value: function render() {
          var e = this.state,
              i = e.defaultCreatorOpen,
              a = e.createDefaultFor,
              n = e.filterQuery,
              t = e.hasNoFallback,
              o = e.propertySelected,
              s = this.props.onClick;
          return r.a.createElement("div", {
            className: "toolbar-menu-popover toolbar-menu-popover--tag-properties"
          }, r.a.createElement("div", {
            className: "toolbar-menu-popover--container"
          }, r.a.createElement("div", {
            className: "toolbar-menu-popover--header"
          }, i && r.a.createElement("span", {
            className: "toolbar-menu-popover--back-button-container",
            onClick: this.dismissDefaultValueCreator
          }, r.a.createElement(Fn.Icon, {
            name: "arrow-1-left",
            className: "toolbar-menu-popover--back-button",
            width: 14,
            height: 14
          })), r.a.createElement(gi.H4, {
            className: en()({
              "toolbar-menu-popover--header--offset": i
            })
          }, "Personalization tokens"), r.a.createElement("a", {
            href: "https://drift.force.com/s/article/How-to-Use-Personalization-Tokens",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Learn more")), i ? r.a.createElement(Lt, {
            onSave: s,
            value: a,
            hasNoFallback: t,
            dismiss: this.dismissDefaultValueCreator,
            propertySelected: o
          }) : r.a.createElement("div", null, r.a.createElement(gi.Input, {
            value: n,
            onChange: this.filterProps,
            className: "property-list-filter",
            placeholder: "Search..."
          }), this.renderDropdownList())));
        }
      }]), DriftPropertyPluginDropdown;
    }();

    t(258);

    function _extends() {
      return (_extends = Object.assign || function (e) {
        for (var i = 1; i < arguments.length; i++) {
          var a = arguments[i];

          for (var n in a) {
            Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function SvgBookAMeeting(e, i) {
      return s.createElement("svg", _extends({
        width: 272,
        height: 152,
        viewBox: "0 0 272 152",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        ref: i
      }, e), St || (St = s.createElement("rect", {
        width: 272,
        height: 151.157,
        fill: "url(#pattern0)"
      })), zt || (zt = s.createElement("defs", null, s.createElement("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
      }, s.createElement("use", {
        xlinkHref: "#image0",
        transform: "scale(0.000753012 0.00135501)"
      })), s.createElement("image", {
        id: "image0",
        width: 1328,
        height: 738,
        xlinkHref: "data:image/png;base64,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"
      }))));
    }

    var Zt = s.forwardRef(SvgBookAMeeting),
        Wt = (t.p, t(260), function BookAMeetingEditorPopup(e) {
      var i = e.onClickOutside,
          a = e.editorSelection,
          n = Da(),
          t = _slicedToArray(Object(s.useState)(""), 2),
          o = t[0],
          g = t[1];

      return r.a.createElement(gi.Div, {
        className: "toolbar-menu-popover"
      }, r.a.createElement(gi.Div, {
        className: "toolbar-menu-popover--container"
      }, r.a.createElement(gi.Div, {
        className: "book-a-meeting-popup-container"
      }, r.a.createElement(gi.Div, {
        className: "book-meeting-toolbar-menu-popover--header"
      }, r.a.createElement(gi.H4, null, "Book a meeting"), r.a.createElement(gi.A, {
        onClick: function onClick() {
          return window.open("https://docs.google.com/document/d/1mqiXt79p6dkCHj_SqsZjAzeKINoDg1gcmCx92_1aK9g/edit?usp=sharing");
        }
      }, "Learn more")), r.a.createElement(gi.Div, {
        className: "driftiwyg-tag-property--editor"
      }, "{{".concat("teammate.upcoming_availability", "}}")), r.a.createElement(gi.P, {
        type: "small"
      }, "We\u2019ll display upcoming availability for the teammate whose calendar was last seen by the recipient."), r.a.createElement(Zt, null), r.a.createElement(gi.Input, {
        label: "Fallback profile link",
        className: en()("wysiwyg-toolbar--default-value-body", "book-a-meeting-fallback-input"),
        placeholder: "Default profile link...",
        description: "If we can\u2019t find a calendar, we\u2019ll display this Drift Profile link instead.",
        onChange: function onChange(e) {
          return g(e.target.value);
        }
      }), r.a.createElement(gi.Button, {
        className: "wysiwyg-toolbar--insert-button",
        type: "primary",
        onClick: function insertToken() {
          Re.insertNodes(n, {
            type: "text-span",
            class: "driftiwyg-tag-property--editor",
            children: [{
              text: o ? "{{".concat("teammate.upcoming_availability", ' or "').concat(o, '"}}') : "{{".concat("teammate.upcoming_availability", "}}")
            }]
          }, {
            at: a.anchor
          }), i();
        }
      }, "Insert"), r.a.createElement(gi.Button, {
        type: "tertiary",
        onClick: i
      }, "Cancel"))));
    });

    function objectSpread2_ownKeys(e, i) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        i && (n = n.filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function _objectSpread2(e) {
      for (var i = 1; i < arguments.length; i++) {
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? objectSpread2_ownKeys(Object(a), !0).forEach(function (i) {
          _defineProperty(e, i, a[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : objectSpread2_ownKeys(Object(a)).forEach(function (i) {
          Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
        });
      }

      return e;
    }

    var Yt = t(111),
        It = (t(262), Object.freeze({
      STRING: "STRING",
      NUMERIC: "NUMERIC",
      BOOLEAN: "BOOLEAN",
      DATETIME: "DATETIME",
      DATE: "DATE"
    })),
        Jt = Object.freeze({
      EQUALS: "==",
      DOES_NOT_EQUAL: "!=",
      GREATER_THAN: ">",
      LESS_THAN: "<",
      GREATER_THAN_OR_EQUAL: ">=",
      LESS_THAN_OR_EQUAL: "<="
    }),
        Ut = Object.freeze({
      DRIFT_INTEL: "drift_intel",
      USER: "user"
    }),
        Gt = [{
      displayName: "Company Name",
      name: "company_name",
      type: It.STRING
    }, {
      displayName: "Employee Count",
      name: "employee_count",
      type: It.NUMERIC
    }, {
      displayName: "Company Domain",
      name: "company_domain",
      type: It.STRING
    }, {
      displayName: "Company Revenue",
      name: "company_revenue",
      type: It.NUMERIC
    }, {
      displayName: "Company Country",
      name: "company_country",
      type: It.STRING
    }, {
      displayName: "Company State",
      name: "company_state",
      type: It.STRING
    }, {
      displayName: "Company Industry",
      name: "company_industry",
      type: It.STRING
    }],
        Vt = [{
      label: "Equals",
      value: Jt.EQUALS
    }, {
      label: "Greater than",
      value: Jt.GREATER_THAN
    }, {
      label: "Less than",
      value: Jt.LESS_THAN
    }, {
      label: "Greater than or equal to",
      value: Jt.GREATER_THAN_OR_EQUAL
    }, {
      label: "Less than or equal to",
      value: Jt.LESS_THAN_OR_EQUAL
    }],
        Kt = [{
      label: "Equals",
      value: Jt.EQUALS
    }, {
      label: "Does not equal",
      value: Jt.DOES_NOT_EQUAL
    }],
        Qt = function formatTagNode(e, i) {
      return {
        type: "division",
        children: [{
          type: "text-span",
          class: i,
          children: [{
            text: e
          }]
        }]
      };
    },
        $t = function VariationBuilder(e) {
      var i = e.onClickOutside,
          a = e.selectedAttribute,
          n = (e.onChange, e.editorSelection),
          t = Da(),
          o = a.type === It.NUMERIC ? Vt : Kt,
          g = {
        operator: o[0].value,
        value: null
      },
          l = _slicedToArray(Object(s.useState)([g]), 2),
          f = l[0],
          h = l[1],
          m = f.filter(function (e) {
        return !!e.operator && !!e.value;
      }).length !== f.length;

      return r.a.createElement(gi.Div, {
        className: "dynamic-content-toolbar-menu-popover--container"
      }, r.a.createElement(gi.Div, {
        className: "dynamic-content-toolbar-menu-popover--variation-builder"
      }, r.a.createElement(gi.Div, {
        className: "dynamic-content-toolbar-menu-popover--subtext"
      }, "Select an operator and value for each variation of this attribute. We\u2019ll insert a template into your email and you can add content for each variation."), f.map(function (e, i) {
        return r.a.createElement(gi.Div, {
          className: "dynamic-content-variation-wrapper",
          key: i
        }, r.a.createElement(gi.Div, {
          className: "dynamic-content-variation"
        }, r.a.createElement(Yt.Select, {
          className: "dynamic-content-variation-operator-select",
          label: "Variation ".concat(i + 1),
          placeholder: "Operator",
          value: Ht(e.operator, o),
          options: o,
          onChange: function onChange(e) {
            return function selectVariationOperator(e, i) {
              var a = Object(tn.clone)(f[i]);
              a.operator = e;
              var n = Object(tn.update)(i, a, f);
              h(n);
            }(e.value, i);
          }
        }), r.a.createElement(gi.Input, {
          className: en()("dynamic-content-variation-value-input", {
            invalid: e.operator && !e.value
          }),
          placeholder: "Value",
          value: e.value,
          onChange: function onChange(e) {
            return function setVariationValue(e, i) {
              var a = Object(tn.clone)(f[i]);
              a.value = e;
              var n = Object(tn.update)(i, a, f);
              h(n);
            }(e.target.value, i);
          }
        }), r.a.createElement(gi.IconButton, {
          className: en()("dynamic-content-variation-delete-button", {
            "dynamic-content-variation-delete-button--hidden": 1 === f.length
          }),
          icon: "cancel-circle",
          onClick: function onClick() {
            return function removeVariation(e) {
              var i = Object(tn.remove)(e, 1, f);
              h(i);
            }(i);
          }
        })), e.operator && !e.value && r.a.createElement(gi.Div, {
          className: "dynamic-content-variation-warning"
        }, "A value must be set"));
      }), r.a.createElement(gi.QuickActionButton, {
        className: "dynamic-content-variation-quick-action-button",
        iconClassName: "tracking-tab--add-partner-mapping-button",
        onClick: function addVariation() {
          var e = Object(tn.append)(g, f);
          h(e);
        },
        text: "Add variation"
      }), r.a.createElement(gi.Button, {
        className: "wysiwyg-toolbar--insert-button",
        type: "primary",
        disabled: m,
        onClick: function insertNode() {
          if (a) {
            var e = a.source,
                o = a.name,
                s = a.type,
                r = [],
                g = "".concat(e, ".").concat(o);
            f.forEach(function (e, i) {
              var a = e.operator,
                  n = e.value;

              if (a && n) {
                var t = "",
                    o = s === It.STRING ? '"'.concat(n, '"') : n;
                t = 0 === i ? "{% if ".concat(g, " ").concat(a, " ").concat(o, " %}") : "{% elif ".concat(g, " ").concat(a, " ").concat(o, " %}"), r.push(Qt(t, "dynamic-content-jinja-code--editor")), r.push(Qt("{# Add content here for the variation above #}", "dynamic-content-placeholder-text--editor"));
              }
            }), r.length > 0 && (r.push(Qt("{% else %}", "dynamic-content-jinja-code--editor")), r.push(Qt("{# Optional: Add generic content to display if the contact doesn't match any of the variables for this attribute. #}", "dynamic-content-placeholder-text--editor")), r.push(Qt("{% endif %}", "dynamic-content-jinja-code--editor")));
            var l = {
              type: "division",
              children: r
            };
            Re.insertNodes(t, l, {
              at: n.anchor
            }), i();
          }
        }
      }, "Insert"), r.a.createElement(gi.Button, {
        type: "tertiary",
        onClick: i
      }, "Cancel")));
    },
        eo = function filterBySearchTerm(e, i) {
      return e.displayName.toLowerCase().includes(i.toLowerCase());
    },
        io = function DynamicContentEditorPopup(e) {
      var i = e.editorSelection,
          a = e.onClickOutside,
          n = e.dynamicContentContactAttributes,
          t = e.driftIntelTagList,
          o = !Object(tn.isEmpty)(t),
          g = _slicedToArray(Object(s.useState)(), 2),
          l = g[0],
          f = g[1],
          h = _slicedToArray(Object(s.useState)(o ? Gt : []), 2),
          m = h[0],
          _ = h[1],
          d = _slicedToArray(Object(s.useState)(n), 2),
          c = d[0],
          F = d[1];

      return r.a.createElement(gi.Div, {
        className: "toolbar-menu-popover"
      }, r.a.createElement(gi.Div, {
        className: "toolbar-menu-popover--container"
      }, r.a.createElement(gi.Div, {
        className: "dynamic-content-toolbar-menu-popover--header"
      }, l && r.a.createElement("span", {
        className: "dynamic-content-toolbar-menu-popover--back-button-container",
        onClick: function onClick() {
          return f(null);
        }
      }, r.a.createElement(Fn.Icon, {
        name: "arrow-1-left",
        className: "dynamic-content-toolbar-menu-popover--back-button",
        width: 14,
        height: 14
      })), r.a.createElement(gi.H4, {
        className: en()({
          "dynamic-content-toolbar-menu-popover--header--offset": !!l
        })
      }, l ? l.displayName : "Dynamic content"), r.a.createElement(gi.A, {
        onClick: function onClick() {
          return window.open("https://drift.force.com/s/article/How-to-use-Dynamic-Content-in-the-Email-Bot-Campaigns");
        }
      }, "Learn more")), l ? r.a.createElement($t, {
        editorSelection: i,
        onClickOutside: a,
        selectedAttribute: l
      }) : r.a.createElement(gi.Div, {
        className: "dynamic-content-toolbar-menu-popover--container"
      }, r.a.createElement(gi.Div, {
        className: "dynamic-content-toolbar-menu-popover--attribute-picker"
      }, "Create multiple variations of content in your email based on any Drift Intel, default, or custom attribute.", r.a.createElement(gi.Input, {
        onChange: function onChange(e) {
          return function filterAttributeList(e) {
            var i = o ? Gt.filter(function (i) {
              return eo(i, e);
            }) : [],
                a = n.filter(function (i) {
              return eo(i, e);
            });
            _(i), F(a);
          }(e.target.value);
        },
        className: "attribute-search-input",
        placeholder: "Search...",
        type: "search"
      })), function renderAttributeList() {
        var e = m.length > 0,
            i = c.length > 0;
        return r.a.createElement(r.a.Fragment, null, e || i ? r.a.createElement(r.a.Fragment, null, e && r.a.createElement(r.a.Fragment, null, r.a.createElement(gi.Div, {
          className: "attribute-list-section-header-wrapper"
        }, r.a.createElement(gi.Div, {
          className: "attribute-list-section-header"
        }, "Drift Intel")), m.map(function (e, i) {
          return r.a.createElement(gi.Div, {
            key: i,
            className: "attribute-list-option",
            onClick: function onClick() {
              return f(_objectSpread2(_objectSpread2({}, e), {}, {
                source: Ut.DRIFT_INTEL
              }));
            }
          }, e.displayName);
        })), i && r.a.createElement(r.a.Fragment, null, r.a.createElement(gi.Div, {
          className: "attribute-list-section-header-wrapper"
        }, r.a.createElement(gi.Div, {
          className: "attribute-list-section-header"
        }, "Default and custom attributes")), c.map(function (e, i) {
          return r.a.createElement(gi.Div, {
            key: i,
            className: "attribute-list-option",
            onClick: function onClick() {
              return f(_objectSpread2(_objectSpread2({}, e), {}, {
                source: Ut.DRIFT_INTEL
              }));
            }
          }, e.displayName);
        }))) : r.a.createElement(gi.Div, {
          className: "empty-state-container"
        }, r.a.createElement(gi.Colorway, {
          type: "2"
        }, r.a.createElement(Fn.Icon, {
          name: "cw-empty-search"
        })), r.a.createElement(gi.Div, null, "There are no attributes", r.a.createElement("br", null), " matching your search.")));
      }())));
    },
        ao = ["link", "emoji", "image", "personalization", "bookAMeeting", "dynamicContent"],
        no = function isMarkActive(e, i) {
      var a = ke.marks(e);
      return !!a && !0 === a[i];
    },
        to = function isBlockActive(e, i) {
      return !!_slicedToArray(ke.nodes(e, {
        match: function match(e) {
          return !ke.isEditor(e) && pe.isElement(e) && e.type === i;
        }
      }), 1)[0];
    },
        oo = function toggleMark(e, i) {
      no(e, i) ? ke.removeMark(e, i) : ke.addMark(e, i, !0);
    },
        so = function ToolbarButton(e) {
      var i = e.editor,
          a = e.format,
          n = cn[a],
          t = "block" === n.type,
          o = t ? to(i, a) : no(i, a);
      return r.a.createElement(gi.ToolTip, {
        component: r.a.createElement("div", null, n.name),
        flow: "up",
        className: en()("wysiwyg-toolbar-button-container", "wysiwyg-toolbar-button-container--".concat(n.type))
      }, r.a.createElement("div", {
        className: en()("wysiwyg-toolbar-button", {
          "wysiwyg-toolbar-button--active": o
        }),
        onMouseDown: function onMouseDown(e) {
          e.preventDefault(), t ? function toggleBlock(e, i) {
            var a = to(e, i),
                n = dn.includes(i);
            Re.unwrapNodes(e, {
              match: function match(e) {
                return dn.includes(!ke.isEditor(e) && pe.isElement(e) && e.type);
              },
              split: !0
            });
            var t = {
              type: a ? "division" : n ? "list-item" : i
            };

            if (Re.setNodes(e, t), !a && n) {
              var o = {
                type: i,
                children: []
              };
              Re.wrapNodes(e, o);
            }
          }(i, a) : oo(i, a);
        },
        "data-active": o
      }, r.a.createElement(Fn.Icon, {
        name: n.icon,
        width: 15,
        height: 15
      })));
    },
        ro = {
      image: nn()(function ImagePlugin(e) {
        var i = e.onClickOutside,
            a = e.handleImageUpload,
            n = e.editorSelection,
            t = e.hideImageControls,
            o = Da();
        o.selection = n;

        var g = _slicedToArray(Object(s.useState)(""), 2),
            l = g[0],
            f = g[1],
            h = _slicedToArray(Object(s.useState)(""), 2),
            m = h[0],
            _ = h[1],
            d = _slicedToArray(Object(s.useState)(""), 2),
            c = d[0],
            F = d[1],
            u = _slicedToArray(Object(s.useState)(""), 2),
            p = u[0],
            b = u[1];

        return r.a.createElement(gi.Div, {
          className: "toolbar-menu-popover toolbar-menu-popover--image"
        }, r.a.createElement(gi.Div, {
          className: "toolbar-menu-popover--container"
        }, r.a.createElement(gi.Div, {
          className: "toolbar-menu-popover--header"
        }, r.a.createElement(gi.H4, null, "Insert an image")), r.a.createElement(gi.Div, {
          className: "toolbar-menu-popover--image-container"
        }, r.a.createElement(li.UploadArea, {
          className: "image-uploader",
          handleUploadFile: function handleUploadImage(e) {
            return b(""), (a instanceof Function ? a : ui)(e).then(function (e) {
              return e.data;
            });
          },
          handleSaveFile: function handleSaveImage(e, i) {
            _(e), F(i);
          },
          handleClearFile: function handleClearImage() {
            _(""), F("");
          },
          onReadError: function onReadError() {
            b("Whoops! Something went wrong. Please try again.");
          },
          onTypeError: function onTypeError() {
            b("Whoops! We only support .png, .jpg, .jpeg, and .gif files.");
          },
          onSizeError: function onSizeError() {
            b("Sorry, your image must be smaller than 25 MB.");
          },
          previewUrl: m,
          previewName: c
        }), p && r.a.createElement(gi.Div, {
          className: "wysiwyg-image-upload-error"
        }, p), !t && r.a.createElement(gi.Input, {
          label: "Link",
          className: "image-popover-alt-text-input",
          onChange: function onChange(e) {
            return f(e.target.value);
          },
          type: "text",
          value: l,
          placeholder: "Type or paste a link"
        }), r.a.createElement(gi.Button, {
          className: "wysiwyg-toolbar--insert-button",
          type: "primary",
          disabled: !m,
          onClick: function handleInsertImage() {
            l ? Fo(o, m, l) : co(o, m), i();
          }
        }, "Insert"), r.a.createElement(gi.Button, {
          type: "tertiary",
          onClick: i
        }, "Cancel"))));
      }),
      personalization: nn()(function DriftPropertyPlugin(e) {
        var i = e.editorSelection,
            a = e.onClickOutside,
            n = Da();
        return r.a.createElement(Nt, Object.assign({
          onClick: function addProperty(e, t) {
            var o = "driftiwyg-tag-property--editor";
            e.startsWith("contentVariable") && (o += " drift-content-variable"), Re.insertNodes(n, {
              type: "text-span",
              class: o,
              children: [{
                text: "{{".concat(e, "}}")
              }],
              propertyName: "contentVariable" === t.source ? t.label : null,
              propertySource: t.source
            }, {
              at: null === i || void 0 === i ? void 0 : i.anchor
            }), a();
          }
        }, e));
      }),
      emoji: nn()(function EmojiPlugin(e) {
        var i = e.onClickOutside,
            a = e.editorSelection,
            n = Da();
        return r.a.createElement("div", {
          className: "toolbar-menu-popover toolbar-menu-popover--emoji"
        }, r.a.createElement("div", {
          className: "toolbar-menu-popover--container"
        }, r.a.createElement(Ot, {
          onSelect: function addEmoji(e) {
            Re.insertText(n, e.native, {
              at: a.anchor
            }), i();
          },
          title: "",
          emoji: "",
          style: {
            width: "100%",
            fontFamily: "var(--main-font-family)",
            color: "var(--color-p1-10)"
          }
        })));
      }),
      bookAMeeting: nn()(Wt),
      dynamicContent: nn()(io),
      link: nn()(function LinkPlugin(e) {
        var i = e.editorSelection,
            a = e.onClickOutside,
            n = Da();
        n.selection = i;

        var t = go(n),
            o = _slicedToArray(Object(s.useState)(i ? ke.string(n, i) : ""), 2),
            g = o[0],
            l = o[1],
            f = _slicedToArray(Object(s.useState)(Object(tn.pathOr)("", [0, "url"], t)), 2),
            h = f[0],
            m = f[1];

        return r.a.createElement(gi.Div, {
          className: "toolbar-menu-popover toolbar-menu-popover--link"
        }, r.a.createElement(gi.Div, {
          className: "toolbar-menu-popover--container"
        }, r.a.createElement(gi.Div, {
          className: "toolbar-menu-popover--header"
        }, r.a.createElement(gi.H4, null, "Insert a link")), r.a.createElement(gi.Div, {
          className: "toolbar-menu-popover-container--link"
        }, r.a.createElement(gi.Input, {
          type: "text",
          value: g,
          label: "Text",
          className: "link-popover-text-input",
          autoFocus: !0,
          placeholder: "Enter display text",
          onChange: function onChange(e) {
            return l(e.target.value);
          }
        }), r.a.createElement(gi.Input, {
          type: "text",
          value: h,
          label: "Link",
          className: "link-popover-link-input",
          placeholder: "Paste a link",
          onChange: function onChange(e) {
            return m(e.target.value);
          }
        }), r.a.createElement(gi.Div, null, r.a.createElement(gi.Button, {
          type: "primary",
          className: "wysiwyg-toolbar--insert-button",
          onClick: function onClick() {
            uo(n, function getValidUrl(e) {
              return function startsWithProtocol(e) {
                return ["http", "https", "tel", "tcp", "file", "mailto"].some(function (i) {
                  return e && e.startsWith(i);
                });
              }(e) || function isProtocolRelative(e) {
                return e && e.startsWith("//");
              }(e) ? e : function isPersonalizationTag(e) {
                return e && e.startsWith("{{");
              }(e) ? function getCleanPersonalizationTagLink(e) {
                return e.replace(/"/g, "'");
              }(e) : "http://".concat(e);
            }(h), g), a();
          },
          disabled: !(g && h)
        }, "Insert"), r.a.createElement(gi.Button, {
          type: "tertiary",
          onClick: a
        }, "Cancel")))));
      })
    },
        go = function getSelectedLink(e) {
      return _slicedToArray(ke.nodes(e, {
        match: function match(e) {
          return !ke.isEditor(e) && pe.isElement(e) && "link" === e.type;
        }
      }), 1)[0];
    },
        lo = function ToolbarButtonWithPopup(e) {
      var i = e.format,
          a = e.changePopoverType,
          n = e.popoverType,
          t = e.editor,
          o = e.userTagList,
          g = e.driftIntelTagList,
          l = e.contentVariablesList,
          f = e.demandbaseTagList,
          h = e.dynamicContentContactAttributes,
          m = e.handleImageUpload,
          _ = e.hideImageControls,
          d = cn[i],
          c = "link" === i && !!go(t),
          F = ro[i],
          u = n === i,
          p = _slicedToArray(Object(s.useState)(), 2),
          b = p[0],
          k = p[1];

      return r.a.createElement("span", {
        className: "wysiwyg-toolbar-popover-button-container"
      }, r.a.createElement(gi.ToolTip, {
        component: r.a.createElement("div", null, d.name),
        flow: "up",
        className: "wysiwyg-toolbar-popover-button-container"
      }, r.a.createElement("div", {
        className: en()("wysiwyg-toolbar-button", {
          "wysiwyg-toolbar-button--active": c
        }),
        onMouseDown: function onMouseDown() {
          k(t.selection), a(i);
        }
      }, r.a.createElement(Fn.Icon, {
        name: d.icon,
        width: 15,
        height: 15
      }))), r.a.createElement("div", {
        id: "popover-container-".concat(i),
        className: "popover-position"
      }, u && r.a.createElement(F, {
        editorSelection: b,
        onClickOutside: function dismissPopover() {
          return a("");
        },
        userTagList: o,
        driftIntelTagList: g,
        contentVariablesList: l,
        demandbaseTagList: f,
        dynamicContentContactAttributes: h,
        handleImageUpload: m,
        hideImageControls: _
      })));
    },
        fo = function Toolbar(e) {
      var i = e.toolbarOptions,
          a = e.userTagList,
          n = e.driftIntelTagList,
          t = e.contentVariablesList,
          o = e.demandbaseTagList,
          g = e.dynamicContentContactAttributes,
          l = e.handleImageUpload,
          f = e.hideImageControls,
          h = Da(),
          m = _slicedToArray(Object(s.useState)(), 2),
          _ = m[0],
          d = m[1],
          c = function changePopoverType(e) {
        d(e);
      };

      return r.a.createElement("div", {
        className: "wysiwyg-slate-editor-menu toolbar-menu"
      }, i.map(function (e, i) {
        return r.a.createElement(s.Fragment, {
          key: i
        }, Object(tn.contains)(e, ao) ? r.a.createElement(lo, {
          editor: h,
          changePopoverType: c,
          popoverType: _,
          format: e,
          userTagList: a,
          driftIntelTagList: n,
          contentVariablesList: t,
          demandbaseTagList: o,
          dynamicContentContactAttributes: g,
          handleImageUpload: l,
          hideImageControls: f
        }) : r.a.createElement(so, {
          editor: h,
          format: e
        }));
      }));
    },
        ho = (t(264), [".png", ".jpg", ".jpeg", ".gif"]),
        mo = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"],
        _o = function withImages(e) {
      var i = e.insertData,
          a = e.isVoid;
      return e.isVoid = function (e) {
        return "image" === e.type || a(e);
      }, e.insertData = function (a) {
        var n = a.getData("text/plain"),
            t = a.files;

        if (t && t.length > 0) {
          var o,
              s = _createForOfIteratorHelper(t);

          try {
            var r = function _loop() {
              var i = o.value,
                  a = new FileReader();
              "image" === _slicedToArray(i.type.split("/"), 1)[0] && (a.addEventListener("load", function () {
                var i = a.result;
                co(e, i);
              }), a.readAsDataURL(i));
            };

            for (s.s(); !(o = s.n()).done;) {
              r();
            }
          } catch (g) {
            s.e(g);
          } finally {
            s.f();
          }
        } else !function isImageUrl(e) {
          if (!e) return !1;
          if (!Ue()(e)) return !1;
          var i = new URL(e).pathname.split(".").pop();
          return ho.includes(i);
        }(n) ? i(a) : co(e, n);
      }, e;
    },
        co = function insertImage(e, i) {
      var a = {
        type: "image",
        url: i,
        children: [{
          text: ""
        }]
      };
      Re.insertNodes(e, [a, {
        type: "division",
        children: [{
          text: ""
        }]
      }]), e.selection = null;
    },
        Fo = function insertHyperlinkedImage(e, i, a) {
      var n = {
        type: "image-link",
        target: "_blank",
        url: a,
        children: [{
          type: "image",
          url: i,
          alt: a,
          children: [{
            text: ""
          }]
        }]
      };
      Re.insertNodes(e, [n, {
        type: "division",
        children: [{
          text: ""
        }]
      }]), e.selection = null;
    },
        uo = function wrapLink(e, i, a) {
      var n = null !== a && void 0 !== a ? a : i;
      (function isLinkActive(e) {
        return !!_slicedToArray(ke.nodes(e, {
          match: function match(e) {
            return !ke.isEditor(e) && pe.isElement(e) && "link" === e.type;
          }
        }), 1)[0];
      })(e) && function unwrapLink(e) {
        Re.unwrapNodes(e, {
          match: function match(e) {
            return !ke.isEditor(e) && pe.isElement(e) && "link" === e.type;
          }
        });
      }(e);
      var t = {
        type: "link",
        url: i,
        children: [{
          text: n
        }]
      };
      Re.insertNodes(e, t);
    },
        po = function Leaf(e) {
      var i = e.attributes,
          a = e.children,
          n = e.leaf;
      return n.bold && (a = r.a.createElement("strong", null, a)), n.code && (a = r.a.createElement("code", null, a)), n.italic && (a = r.a.createElement("em", null, a)), n.underline && (a = r.a.createElement("u", null, a)), r.a.createElement("span", i, a);
    },
        bo = function isCurrentNodeContentVar(e, i) {
      if (!e.focus || Object(tn.isEmpty)(i)) return null;

      var a = function getCurrentNode(e, i) {
        return e.focus.path.slice(0, -1).reduce(function (e, i) {
          return e[i] && e[i].children ? Object(tn.isNil)(e[i].propertyName) ? e[i].children : e[i] : e;
        }, i);
      }(e, i);

      return !Object(tn.isNil)(a.propertyName);
    },
        ko = function EmailWysiwyg(e) {
      var i = e.className,
          a = e.html,
          n = e.toolbarOptions,
          t = e.userTagList,
          o = e.driftIntelTagList,
          g = e.contentVariablesList,
          l = e.demandbaseTagList,
          f = e.onChange,
          h = e.dynamicContentContactAttributes,
          m = e.handleImageUpload,
          _ = e.placeholder,
          d = e.hideImageControls,
          c = function deserialize(e) {
        if (3 === e.nodeType) return e.textContent;
        if (1 !== e.nodeType) return null;
        var i = Array.from(e.childNodes).map(deserialize);

        if (0 === i.length && (i = [{
          text: ""
        }]), hn[e.nodeName]) {
          var a = hn[e.nodeName](e);
          return ri("text", a, i);
        }

        switch (e.nodeName) {
          case "A":
            var n = "image" === Object(tn.pathOr)(null, [0, "type"], i);
            return ri("element", {
              type: n ? "image-link" : "link",
              url: e.getAttribute("href"),
              target: e.getAttribute("target")
            }, i);

          case "BODY":
            return ri("fragment", {}, i);

          case "BR":
          case "DIV":
            return ri("element", {
              type: "division"
            }, i);

          case "IMG":
            return ri("element", {
              type: "image",
              url: e.getAttribute("src"),
              alt: e.getAttribute("alt"),
              width: e.getAttribute("width"),
              height: e.getAttribute("height")
            }, i);

          case "P":
            return ri("element", {
              type: "paragraph"
            }, i);

          case "SPAN":
            var t = e.dataset,
                o = t.propertyname,
                s = t.propertysource,
                r = t.originalcontentvarstring;
            return ri("element", {
              type: "text-span",
              class: e.getAttribute("class"),
              propertyName: o,
              propertySource: s,
              originalContentVarString: r
            }, i);

          case "UL":
            return ri("element", {
              type: "bulleted-list"
            }, i);

          case "LI":
            return ri("element", {
              type: "list-item"
            }, i);

          case "OL":
            return ri("element", {
              type: "numbered-list"
            }, i);

          default:
            return e.textContent;
        }
      }(new DOMParser().parseFromString(a, "text/html").body),
          F = _slicedToArray(Object(s.useState)(c), 2),
          u = F[0],
          p = F[1],
          b = Object(s.useMemo)(function () {
        return function withTags(e) {
          var i = e.isInline;
          return e.isInline = function (e) {
            return "text-span" === e.type || i(e);
          }, e;
        }(_o(function withLinks(e) {
          var i = e.insertData,
              a = e.insertText,
              n = e.isInline;
          return e.isInline = function (e) {
            return "link" === e.type || n(e);
          }, e.insertText = function (i) {
            i && Ue()(i) ? uo(e, i) : a(i);
          }, e.insertData = function (a) {
            var n = a.getData("text/plain");
            n && Ue()(n) ? uo(e, n) : i(a);
          }, e;
        }(function withHistory(e) {
          var i = e,
              a = i.apply;
          return i.history = {
            undos: [],
            redos: []
          }, i.redo = function () {
            var e = i.history,
                a = e.redos;

            if (a.length > 0) {
              var n = a[a.length - 1];
              Ne.withoutSaving(i, function () {
                ke.withoutNormalizing(i, function () {
                  var e,
                      a = _createForOfIteratorHelper(n);

                  try {
                    for (a.s(); !(e = a.n()).done;) {
                      var t = e.value;
                      i.apply(t);
                    }
                  } catch (o) {
                    a.e(o);
                  } finally {
                    a.f();
                  }
                });
              }), e.redos.pop(), e.undos.push(n);
            }
          }, i.undo = function () {
            var e = i.history,
                a = e.undos;

            if (a.length > 0) {
              var n = a[a.length - 1];
              Ne.withoutSaving(i, function () {
                ke.withoutNormalizing(i, function () {
                  var e,
                      a = _createForOfIteratorHelper(n.map(we.inverse).reverse());

                  try {
                    for (a.s(); !(e = a.n()).done;) {
                      var t = e.value;
                      i.apply(t);
                    }
                  } catch (o) {
                    a.e(o);
                  } finally {
                    a.f();
                  }
                });
              }), e.redos.push(n), e.undos.pop();
            }
          }, i.apply = function (e) {
            var n = i.operations,
                t = i.history,
                o = t.undos,
                s = o[o.length - 1],
                r = s && s[s.length - 1],
                g = Ye(e, r),
                l = Ne.isSaving(i),
                f = Ne.isMerging(i);

            if (null == l && (l = We(e)), l) {
              if (null == f && (f = null != s && (0 !== n.length || Ze(e, r) || g)), s && f) g && s.pop(), s.push(e);else {
                var h = [e];
                o.push(h);
              }

              for (; o.length > 100;) {
                o.shift();
              }

              Ie(e) && (t.redos = []);
            }

            a(e);
          }, i;
        }(Qa(se())))));
      }, []),
          k = Object(s.useCallback)(function (e) {
        return r.a.createElement(mn, Object.assign({}, e, {
          hideImageControls: d
        }));
      }, [d]),
          A = Object(s.useCallback)(function (e) {
        return r.a.createElement(po, e);
      }, []),
          y = function onChangeEditorState(e) {
        p(e);

        var i = function serialize(e, i) {
          if (Me.isText(e)) {
            var a = ln()(e.text);
            return a = a.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'"), e.bold && a && (a = "<strong>".concat(a, "</strong>")), e.italic && a && (a = "<em>".concat(a, "</em>")), e.underline && a && (a = "<u>".concat(a, "</u>")), a;
          }

          var n = e.children.map(function (e) {
            return serialize(e);
          }).join("");

          switch (e.type) {
            case "link":
            case "image-link":
              if (n) return '<a href="'.concat(ln()(e.url), '" target="_blank">').concat(n, "</a>");
              break;

            case "division":
              return n.replace(/\s*/g, "") ? "<div>".concat(n, "</div>") : "<br/>";

            case "image":
              return '<img src="'.concat(e.url, '"').concat(e.alt ? ' alt="'.concat(e.alt, '"') : "").concat(e.width ? ' width="'.concat(e.width, '"') : "", "/>");

            case "text-span":
              if (n) {
                var t = "<span".concat(e.class ? ' class="'.concat(e.class, '"') : "", " \n          ").concat(e.propertyName ? ' data-propertyName="'.concat(e.propertyName, '"') : "", "\n          ").concat(e.propertySource ? ' data-propertySource="'.concat(e.propertySource, '"') : "", ">").concat(n, "</span>");
                return "contentVariable" === e.propertySource ? " ".concat(t, " ") : t;
              }

              break;

            case "bulleted-list":
              return "<ul>".concat(n, "</ul>");

            case "list-item":
              return "<li>".concat(n, "</li>");

            case "numbered-list":
              return "<ol>".concat(n, "</ol>");

            case "paragraph":
              return "<p>".concat(n, "</p>");

            default:
              return n;
          }
        }({
          children: e
        });

        !Object(tn.equals)(a, i) && f(i);
      };

      return r.a.createElement("div", {
        className: en()(_defineProperty({}, i, !!i))
      }, r.a.createElement(Ga, {
        editor: b,
        value: u,
        onChange: function onChange(e) {
          return y(e);
        }
      }, r.a.createElement(fo, {
        toolbarOptions: n,
        userTagList: t,
        driftIntelTagList: o,
        contentVariablesList: g,
        demandbaseTagList: l,
        dynamicContentContactAttributes: h,
        handleImageUpload: m,
        hideImageControls: d
      }), r.a.createElement("div", {
        className: "wysiwyg-slate-editor"
      }, r.a.createElement(za, {
        renderElement: k,
        renderLeaf: A,
        placeholder: null !== _ && void 0 !== _ ? _ : "Add your email body here",
        spellCheck: !0,
        onKeyDown: function onKeyDown(e) {
          var i = b.selection,
              a = void 0 === i ? {} : i,
              n = b.children,
              t = void 0 === n ? [] : n,
              o = function getCurrentFocusedLine(e) {
            var i = e.focus;
            return !!i && i.path[0];
          }(a);

          for (var s in _n) {
            if (Ei()(s, e)) e.preventDefault(), oo(b, _n[s]);
          }

          if (function childrenContainContentVars(e) {
            return e.children.some(function (e) {
              return !Object(tn.isNil)(e.propertyName);
            });
          }(t[o])) {
            if ("Backspace" === e.key && bo(a, t)) {
              e.preventDefault();

              var r = function getIndexOfContentVar(e, i) {
                return Object(tn.findIndex)(function (e) {
                  return !Object(tn.isNil)(e.propertyName);
                }, e[i].children);
              }(t, o);

              Re.removeNodes(b, {
                at: [o, r]
              });
            }

            if (mo.includes(e.key) && bo(a, t)) {
              var g,
                  l = function getNextNodePath(e) {
                var i,
                    a = e.focus,
                    n = void 0 === a ? {} : a;
                return Ee.next(null === n || void 0 === n ? void 0 : null === (i = n.path) || void 0 === i ? void 0 : i.slice(0, -1));
              }(a),
                  f = function getPrevNodePath(e, i) {
                var a,
                    n = e.focus,
                    t = void 0 === n ? {} : n,
                    o = bo(e, i) ? null === t || void 0 === t ? void 0 : null === (a = t.path) || void 0 === a ? void 0 : a.slice(0, -1) : null === t || void 0 === t ? void 0 : t.path;
                return o.slice(-1) > 0 ? Ee.previous(o) : o;
              }(a, t),
                  h = "ArrowLeft" === e.key ? f : l,
                  m = null === (g = ke.end(b, f)) || void 0 === g ? void 0 : g.offset,
                  _ = "ArrowLeft" === e.key ? m : 0;

              Re.select(b, {
                anchor: {
                  path: h,
                  offset: _
                },
                focus: {
                  path: h,
                  offset: _
                }
              });
            }

            "Enter" === e.key && bo(a, t) && e.preventDefault();
          }
        }
      }))));
    };

    t.d(a, "EmailWysiwyg", function () {
      return ko;
    });
  }]);
});